
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4ff2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4ff2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("21sFD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("etzZw"));

});
parcelRegister("etzZw", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $a89fb14365b8debb$export$ffb0004e005737fa; }, function (v) { return $a89fb14365b8debb$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $a89fb14365b8debb$export$34b9dba7ce09269b; }, function (v) { return $a89fb14365b8debb$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $a89fb14365b8debb$export$25062201e9e25d76; }, function (v) { return $a89fb14365b8debb$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a89fb14365b8debb$export$ffb0004e005737fa;
var $a89fb14365b8debb$export$34b9dba7ce09269b;
var $a89fb14365b8debb$export$25062201e9e25d76;
"use strict";

(function() {
    "use strict";
    var React = (parcelRequire("3RyIS"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = "" + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = "" + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $a89fb14365b8debb$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $a89fb14365b8debb$export$34b9dba7ce09269b = jsx;
    $a89fb14365b8debb$export$25062201e9e25d76 = jsxs;
})();

});
parcelRegister("3RyIS", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ckOf6"));

});
parcelRegister("ckOf6", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = "18.2.0";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ""; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || "";
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== "object" && typeof partialState !== "function" && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = ".";
    var SUBSEPARATOR = ":";
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return "$" + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, "$&/");
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === "object" && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape("" + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case "string":
            case "number":
                invokeCallback = true;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = "";
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
                mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === "object") {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!("default" in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "defaultProps", {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "propTypes", {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
        else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, "type", {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ("require" + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, "timers").setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === "undefined") error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === "object" && typeof result.then === "function") {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== "undefined") // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});




parcelRegister("3qHRY", function(module, exports) {
"use strict";
function $27f5d45ef881361f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error("^_^");
}

module.exports = (parcelRequire("7Sz57"));

});
parcelRegister("7Sz57", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $5bc8ca069241be1c$export$ae55be85d98224ed; }, function (v) { return $5bc8ca069241be1c$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $5bc8ca069241be1c$export$d39a5bbd09211389; }, function (v) { return $5bc8ca069241be1c$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $5bc8ca069241be1c$export$882461b6382ed46c; }, function (v) { return $5bc8ca069241be1c$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $5bc8ca069241be1c$export$466bfc07425424d5; }, function (v) { return $5bc8ca069241be1c$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $5bc8ca069241be1c$export$cd75ccfd720a3cd4; }, function (v) { return $5bc8ca069241be1c$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $5bc8ca069241be1c$export$fa8d919ba61d84db; }, function (v) { return $5bc8ca069241be1c$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $5bc8ca069241be1c$export$757ceba2d55c277e; }, function (v) { return $5bc8ca069241be1c$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $5bc8ca069241be1c$export$b3890eb0ae9dca99; }, function (v) { return $5bc8ca069241be1c$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $5bc8ca069241be1c$export$502457920280e6be; }, function (v) { return $5bc8ca069241be1c$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $5bc8ca069241be1c$export$c78a37762a8d58e1; }, function (v) { return $5bc8ca069241be1c$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $5bc8ca069241be1c$export$dc54d992c10e8a18; }, function (v) { return $5bc8ca069241be1c$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $5bc8ca069241be1c$export$83d89fbfd8236492; }, function (v) { return $5bc8ca069241be1c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5bc8ca069241be1c$export$ae55be85d98224ed;
var $5bc8ca069241be1c$export$d39a5bbd09211389;
var $5bc8ca069241be1c$export$882461b6382ed46c;
var $5bc8ca069241be1c$export$466bfc07425424d5;
var $5bc8ca069241be1c$export$cd75ccfd720a3cd4;
var $5bc8ca069241be1c$export$fa8d919ba61d84db;
var $5bc8ca069241be1c$export$757ceba2d55c277e;
var $5bc8ca069241be1c$export$b3890eb0ae9dca99;
var $5bc8ca069241be1c$export$502457920280e6be;
var $5bc8ca069241be1c$export$c78a37762a8d58e1;
var $5bc8ca069241be1c$export$dc54d992c10e8a18;
var $5bc8ca069241be1c$export$83d89fbfd8236492;
"use strict";


(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("3RyIS"));
    var Scheduler = (parcelRequire("id5Sv"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning("warn", format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning("error", format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = false; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === "onDoubleClick") possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === "undefined") return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL("" + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === "") return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === "" + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === "" + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === "" + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, "" + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : "";
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = "";
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = "" + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    var REACT_CACHE_TYPE = Symbol.for("react.cache");
    var REACT_TRACING_MARKER_TYPE = Symbol.for("react.tracing_marker");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
                return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
                return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "";
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || "Context";
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return "Cache";
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + ".Consumer";
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + ".Provider";
            case DehydratedFragment:
                return "DehydratedFragment";
            case ForwardRef:
                return getWrappedName$1(type, type.render, "ForwardRef");
            case Fragment:
                return "Fragment";
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return "Portal";
            case HostRoot:
                return "Root";
            case HostText:
                return "Text";
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return "StrictMode";
                return "Mode";
            case OffscreenComponent:
                return "Offscreen";
            case Profiler:
                return "Profiler";
            case ScopeComponent:
                return "Scope";
            case SuspenseComponent:
                return "Suspense";
            case SuspenseListComponent:
                return "SuspenseList";
            case TracingMarkerComponent:
                return "TracingMarker";
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === "function") return type.displayName || type.name || null;
                if (typeof type === "string") return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== "undefined") return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return "";
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return "";
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = "";
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? "true" : "false";
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = "" + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== "undefined" ? document : undefined);
        if (typeof doc === "undefined") return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === "checkbox" || props.type === "radio";
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, "checked", checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === "number") {
                if (value === 0 && node.value === "" || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === "submit" || type === "reset") {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute("value");
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty("value")) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty("defaultValue")) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton = type === "submit" || type === "reset"; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== "") node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, "name");
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== "number" || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === "object" && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === "string" || typeof child === "number") return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute("value", toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return "\n\nCheck the render method of `" + ownerName + "`.";
        return "";
    }
    var valuePropNames = [
        "value",
        "defaultValue"
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps("select", props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue["$" + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArray(children)) {
                    if (children.length > 1) throw new Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    var SVG_NAMESPACE = "http://www.w3.org/2000/svg"; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case "svg":
                return SVG_NAMESPACE;
            case "math":
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!("innerHTML" in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement("div");
                reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            "animationDelay",
            "animationDirection",
            "animationDuration",
            "animationFillMode",
            "animationIterationCount",
            "animationName",
            "animationPlayState",
            "animationTimingFunction"
        ],
        background: [
            "backgroundAttachment",
            "backgroundClip",
            "backgroundColor",
            "backgroundImage",
            "backgroundOrigin",
            "backgroundPositionX",
            "backgroundPositionY",
            "backgroundRepeat",
            "backgroundSize"
        ],
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: [
            "fontFamily",
            "fontFeatureSettings",
            "fontKerning",
            "fontLanguageOverride",
            "fontSize",
            "fontSizeAdjust",
            "fontStretch",
            "fontStyle",
            "fontVariant",
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition",
            "fontWeight",
            "lineHeight"
        ],
        fontVariant: [
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition"
        ],
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: [
            "gridAutoColumns",
            "gridAutoFlow",
            "gridAutoRows",
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: [
            "maskClip",
            "maskComposite",
            "maskImage",
            "maskMode",
            "maskOrigin",
            "maskPositionX",
            "maskPositionY",
            "maskRepeat",
            "maskSize"
        ],
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === "boolean" || value === "";
        if (isEmpty) return "";
        if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ("" + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = "";
        var delimiter = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") styleName = "cssFloat";
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === "boolean" || value === "";
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = "__html";
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + "use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof props.dangerouslySetInnerHTML !== "object" || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== "function") throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, "passive", {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
        var fakeNode = document.createElement("react");
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === "undefined" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent("Event");
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === "object") try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : "invokeguardedcallback"); // Attach our event handlers
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, "event", windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener("error", handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || "A component");
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error("React instrumentation encountered an error: %s.", err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === "function") try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === "function") {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === "function") try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === "function") injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === "function") injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === "function") injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === "function") injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === "function") injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === "function") injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === "function") injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === "function") injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === "function") injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === "function") injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === "function") injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === "function") injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === "function") injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === "function") injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === "function") injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === "function") injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return "Sync";
        if (lane & InputContinuousHydrationLane) return "InputContinuousHydration";
        if (lane & InputContinuousLane) return "InputContinuous";
        if (lane & DefaultHydrationLane) return "DefaultHydration";
        if (lane & DefaultLane) return "Default";
        if (lane & TransitionHydrationLane) return "TransitionHydration";
        if (lane & TransitionLanes) return "Transition";
        if (lane & RetryLanes) return "Retry";
        if (lane & SelectiveHydrationLane) return "SelectiveHydration";
        if (lane & IdleHydrationLane) return "IdleHydration";
        if (lane & IdleLane) return "Idle";
        if (lane & OffscreenLane) return "Offscreen";
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case "focusin":
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case "dragenter":
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case "mouseover":
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case "pointerover":
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case "gotpointercapture":
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            // eslint-disable-next-line no-fallthrough
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            // eslint-disable-next-line no-fallthrough
            case "beforeblur":
            case "afterblur":
            // eslint-disable-next-line no-fallthrough
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            // eslint-disable-next-line no-fallthrough
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ("value" in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== "unknown") event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === "mousemove") {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ("movementY" in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        "8": "Backspace",
        "9": "Tab",
        "12": "Clear",
        "13": "Enter",
        "16": "Shift",
        "17": "Control",
        "18": "Alt",
        "19": "Pause",
        "20": "CapsLock",
        "27": "Escape",
        "32": " ",
        "33": "PageUp",
        "34": "PageDown",
        "35": "End",
        "36": "Home",
        "37": "ArrowLeft",
        "38": "ArrowUp",
        "39": "ArrowRight",
        "40": "ArrowDown",
        "45": "Insert",
        "46": "Delete",
        "112": "F1",
        "113": "F2",
        "114": "F3",
        "115": "F4",
        "116": "F5",
        "117": "F6",
        "118": "F7",
        "119": "F8",
        "120": "F9",
        "121": "F10",
        "122": "F11",
        "123": "F12",
        "144": "NumLock",
        "145": "ScrollLock",
        "224": "Meta"
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || "Unidentified";
        return "";
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === "keypress") return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === "keypress") return getEventCharCode(event);
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && "CompositionEvent" in window;
    var documentMode = null;
    if (canUseDOM && "documentMode" in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]);
        registerTwoPhaseEvent("onCompositionEnd", [
            "compositionend",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionStart", [
            "compositionstart",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionUpdate", [
            "compositionupdate",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case "compositionstart":
                return "onCompositionStart";
            case "compositionend":
                return "onCompositionEnd";
            case "compositionupdate":
                return "onCompositionUpdate";
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === "keydown" && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case "keydown":
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === "object" && "data" in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === "ko";
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = "onCompositionStart";
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = "onCompositionEnd";
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === "onCompositionStart") isComposing = initialize(nativeEventTarget);
            else if (eventType === "onCompositionEnd") {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case "textInput":
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === "compositionend" || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case "paste":
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case "keypress":
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, "onBeforeInput");
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === "input") return !!supportedInputTypes[elem.type];
        if (nodeName === "textarea") return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = "on" + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent("onChange", [
            "change",
            "click",
            "focusin",
            "focusout",
            "input",
            "keydown",
            "keyup",
            "selectionchange"
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, "onChange");
        if (listeners.length > 0) {
            var event = new SyntheticEvent("onChange", "change", null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === "select" || nodeName === "input" && elem.type === "file";
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === "change") return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent("onpropertychange", handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent("onpropertychange", handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== "value") return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === "focusin") {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === "focusout") stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === "selectionchange" || domEventName === "keyup" || domEventName === "keydown") // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === "click") return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === "input" || domEventName === "change") return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== "number") return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, "number", node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === "focusout") handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent("onMouseEnter", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onMouseLeave", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onPointerEnter", [
            "pointerout",
            "pointerover"
        ]);
        registerDirectEvent("onPointerLeave", [
            "pointerout",
            "pointerover"
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === "mouseover" || domEventName === "pointerover";
        var isOutEvent = domEventName === "mouseout" || domEventName === "pointerout";
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = "onMouseLeave";
        var enterEventType = "onMouseEnter";
        var eventTypePrefix = "mouse";
        if (domEventName === "pointerout" || domEventName === "pointerover") {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = "onPointerLeave";
            enterEventType = "onPointerEnter";
            eventTypePrefix = "pointer";
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + "leave", from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + "enter", to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ("contains" in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === "string";
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === "function") priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent("onSelect", [
            "focusout",
            "contextmenu",
            "dragend",
            "focusin",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "selectionchange"
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ("selectionStart" in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, "onSelect");
            if (listeners.length > 0) {
                var event = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case "focusin":
                if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case "focusout":
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case "mousedown":
                mouseDown = true;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case "selectionchange":
                if (skipSelectionChangeEvent) break;
            // falls through
            case "keydown":
            case "keyup":
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement("div").style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!("TransitionEvent" in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName("animationend");
    var ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration");
    var ANIMATION_START = getVendorPrefixedEventName("animationstart");
    var TRANSITION_END = getVendorPrefixedEventName("transitionend");
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        "abort",
        "auxClick",
        "cancel",
        "canPlay",
        "canPlayThrough",
        "click",
        "close",
        "contextMenu",
        "copy",
        "cut",
        "drag",
        "dragEnd",
        "dragEnter",
        "dragExit",
        "dragLeave",
        "dragOver",
        "dragStart",
        "drop",
        "durationChange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "gotPointerCapture",
        "input",
        "invalid",
        "keyDown",
        "keyPress",
        "keyUp",
        "load",
        "loadedData",
        "loadedMetadata",
        "loadStart",
        "lostPointerCapture",
        "mouseDown",
        "mouseMove",
        "mouseOut",
        "mouseOver",
        "mouseUp",
        "paste",
        "pause",
        "play",
        "playing",
        "pointerCancel",
        "pointerDown",
        "pointerMove",
        "pointerOut",
        "pointerOver",
        "pointerUp",
        "progress",
        "rateChange",
        "reset",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "submit",
        "suspend",
        "timeUpdate",
        "touchCancel",
        "touchEnd",
        "touchStart",
        "volumeChange",
        "scroll",
        "toggle",
        "touchMove",
        "waiting",
        "wheel"
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case "keypress":
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case "keydown":
            case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "beforeblur":
            case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "click":
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            /* falls through */ case "mouseout":
            case "mouseover":
            case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case "scroll":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case "copy":
            case "cut":
            case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === "scroll";
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        "cancel",
        "close",
        "invalid",
        "load",
        "scroll",
        "toggle"
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || "unknown-event";
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== "selectionchange") {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent("selectionchange", false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === "touchstart" || domEventName === "touchmove" || domEventName === "wheel") isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + "Capture" : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + "Capture";
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? "capture" : "bubble");
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
    var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
    var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
    var AUTOFOCUS = "autoFocus";
    var CHILDREN = "children";
    var STYLE = "style";
    var HTML$1 = "__html";
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error("Extra attributes from the server: %s", names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === "string" ? markup : "" + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string") {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== "textarea" || nextProp !== "";
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === "number") setTextContent(domElement, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === "script") {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement("div");
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === "select") {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                props = rawProps;
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                props = rawProps;
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                props = rawProps;
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "option":
                postMountWrapper$1(domElement, rawProps);
                break;
            case "select":
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case "input":
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "select":
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "textarea":
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = "";
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = "";
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string" || typeof nextProp === "number") (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case "textarea":
                updateWrapper$1(domElement, nextRawProps);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "input":
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                    break;
                case "checked":
                    break;
                case "selected":
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === "string") {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === "number") {
                    if (domElement.textContent !== "" + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            "" + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === "boolean") {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === "value" || propKey === "checked" || propKey === "selected") ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute("style");
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "select":
            case "option":
                break;
            default:
                if (typeof rawProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === "") // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case "input":
                restoreControlledState(domElement, props);
                return;
            case "textarea":
                restoreControlledState$2(domElement, props);
                return;
            case "select":
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "base",
        "basefont",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dir",
        "div",
        "dl",
        "dt",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "iframe",
        "img",
        "input",
        "isindex",
        "li",
        "link",
        "listing",
        "main",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "nav",
        "noembed",
        "noframes",
        "noscript",
        "object",
        "ol",
        "p",
        "param",
        "plaintext",
        "pre",
        "script",
        "section",
        "select",
        "source",
        "style",
        "summary",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul",
        "wbr",
        "xmp"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        "button"
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        "dd",
        "dt",
        "li",
        "option",
        "optgroup",
        "p",
        "rp",
        "rt"
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === "form") ancestorInfo.formTag = info;
        if (tag === "a") ancestorInfo.aTagInScope = info;
        if (tag === "button") ancestorInfo.buttonTagInScope = info;
        if (tag === "nobr") ancestorInfo.nobrTagInScope = info;
        if (tag === "p") ancestorInfo.pTagInButtonScope = info;
        if (tag === "li") ancestorInfo.listItemTagAutoclosing = info;
        if (tag === "dd" || tag === "dt") ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
            case "optgroup":
                return tag === "option" || tag === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
                return tag === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
                return tag === "col" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
            case "frameset":
                return tag === "frame";
            case "#document":
                return tag === "html";
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
            case "rp":
            case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error("validateDOMNesting: when childText is passed, childTag should be null");
            childTag = "#text";
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = "";
        if (childTag === "#text") {
            if (/\S/.test(childText)) tagDisplayName = "Text nodes";
            else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = "<" + childTag + ">";
        if (invalidParent) {
            var info = "";
            if (ancestorTag === "table" && childTag === "tr") info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
    var SUSPENSE_START_DATA = "$";
    var SUSPENSE_END_DATA = "/$";
    var SUSPENSE_PENDING_START_DATA = "$?";
    var SUSPENSE_FALLBACK_START_DATA = "$!";
    var STYLE$1 = "style";
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, "");
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === "string" || typeof props.children === "number") {
            var string = "" + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                return !!props.autoFocus;
            case "img":
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
            var string = "" + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === "textarea" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === "function" ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === "function" ? queueMicrotask : typeof localPromise !== "undefined" ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                if (newProps.autoFocus) domElement.focus();
                return;
            case "img":
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === "function") style.setProperty("display", "none", "important");
        else style.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
        instance.style.display = dangerousStyleValue("display", display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = "";
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === "" || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== "head" && parentType !== "body";
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = "__reactFiber$" + randomKey;
    var internalPropsKey = "__reactProps$" + randomKey;
    var internalContainerInstanceKey = "__reactContainer$" + randomKey;
    var internalEventHandlersKey = "__reactEvents$" + randomKey;
    var internalEventHandlerListenersKey = "__reactListeners$" + randomKey;
    var internalEventHandlesSetKey = "__reactHandles$" + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error("Unexpected pop.");
            return;
        }
        if (fiber !== fiberStack[index]) error("Unexpected Fiber popped.");
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentNameFromFiber(fiber) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentNameFromFiber(fiber) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = "";
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === "function") pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === "function") pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === "function") {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === "function") {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var fakeInternalInstance = {}; // React.Component uses a shared frozen object by default.
    // We'll use it to determine whether we need to initialize legacy refs.
    var emptyRefsObject = new React.Component().refs;
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, "_processChildContext", {
        enumerable: false,
        value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "replaceState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "forceUpdate");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === "function") {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === "function") instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === "function") instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === "function") {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
                if (typeof instance.componentWillMount === "function") instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
                if (typeof instance.componentWillUpdate === "function") instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === "function") instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === "function") workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === "function") workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== "object") return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentNameFromFiber(returnFiber) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                    error('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + "bug in React. Please file an issue.");
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, "ref");
                var stringRef = "" + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === "function" && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = resolvedInst.refs;
                    if (refs === emptyRefsObject) // This is a lazy pooled frozen object, so we need to initialize.
                    refs = resolvedInst.refs = {};
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + " the following reasons:\n" + "1. You may be adding a ref to a function component\n" + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + "3. You have multiple copies of React loaded\n" + "See https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : childString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== "object" || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== "string") break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += " ";
                    row += newHookName + "\n";
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error("The result of getServerSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error("The result of getSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === "function") // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty("current")) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ":" + identifierPrefix + "R" + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += "H" + localId.toString(32);
            id += ":";
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ":" + identifierPrefix + "r" + globalClientId.toString(32) + ":";
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ""; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console["error"](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || "Anonymous";
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console["error"](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== "function") // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ""
            });
            if (typeof getDerivedStateFromError !== "function") // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(type));
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, "prop", getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === "hidden" || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error("Simulated error coming from DevTools");
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component");
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error("Should have a current fiber. This is a bug in React.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = "";
        if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) hint = " Did you wrap a component in React.lazy() more than once?";
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (workInProgress.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
            var warningKey = ownerName || "";
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error(message);
                else error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === "function";
        if (isAnArray || isIterable) {
            var type = isAnArray ? "array" : "iterable";
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case "forwards":
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case "backwards":
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!("value" in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error("Cannot swap the root fiber.");
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error("Expected parent to have a child.");
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error("Expected to find the previous sibling.");
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(current, workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case "hidden":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case "collapsed":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== "string") {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === "function") {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== "function") {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = "useLayoutEffect";
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = "useInsertionEffect";
                        else hookName = "useEffect";
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === "function") addendum = "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. " + "Instead, write the async function inside your effect " + "and call it immediately:\n\n" + hookName + "(() => {\n" + "  async function fetchData() {\n" + "    // You can await here\n" + "    const response = await MyAPI.getData(someId);\n" + "    // ...\n" + "  }\n" + "  fetchData();\n" + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + "Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = " You returned: " + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onPostCommit === "function") onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onRender === "function") onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === "function") onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === "function") safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === "function") {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty("current")) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor("selector.role");
        TEST_NAME_TYPE = symbolFor("selector.test_id");
        TEXT_TYPE = symbolFor("selector.text");
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== "undefined";
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error("useInsertionEffect must not schedule updates.");
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error("Unknown root exit status.");
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error("Root did not complete. This is a bug in React.");
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === "object" && typeof thrownValue.then === "function") {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || "ReactComponent";
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === "object" && replayError !== null && replayError._suppressLogging && typeof originalError === "object" && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown"; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === "function") {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== "function") return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error("Expected to reach root first.");
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === "function") return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === "string") fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === "object" && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = "";
                if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== "string") error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = "DELETED";
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? "hydrate()" : "render()";
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = "18.2.0";
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === "function") throw new Error("Unable to find node on an unmounted component.");
            else {
                var keys = Object.keys(component).join(",");
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown");
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== "function") error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn("copyWithRename() expects paths of the same length");
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === "function" ? // emulating an uncaught JavaScript error.
    reportError : function(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console["error"](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error("Cannot update an unmounted root.");
        if (typeof arguments[1] === "function") error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== "undefined") error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === "function") error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error("createRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.");
            else if (typeof options === "object" && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === "function") {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== "function") error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, "render");
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    function findDOMNode(componentOrElement) {
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || "A component");
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error("Target container is not a DOM element.");
        if (parentComponent == null || !has(parentComponent)) throw new Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    function unmountComponentAtNode(container) {
        if (!isValidContainerLegacy(container)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: "react-dom"
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
        }
    }
    $5bc8ca069241be1c$export$ae55be85d98224ed = Internals;
    $5bc8ca069241be1c$export$d39a5bbd09211389 = createPortal$1;
    $5bc8ca069241be1c$export$882461b6382ed46c = createRoot$1;
    $5bc8ca069241be1c$export$466bfc07425424d5 = findDOMNode;
    $5bc8ca069241be1c$export$cd75ccfd720a3cd4 = flushSync$1;
    $5bc8ca069241be1c$export$fa8d919ba61d84db = hydrate;
    $5bc8ca069241be1c$export$757ceba2d55c277e = hydrateRoot$1;
    $5bc8ca069241be1c$export$b3890eb0ae9dca99 = render;
    $5bc8ca069241be1c$export$502457920280e6be = unmountComponentAtNode;
    $5bc8ca069241be1c$export$c78a37762a8d58e1 = batchedUpdates$1;
    $5bc8ca069241be1c$export$dc54d992c10e8a18 = renderSubtreeIntoContainer;
    $5bc8ca069241be1c$export$83d89fbfd8236492 = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("id5Sv", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7cBLi"));

});
parcelRegister("7cBLi", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $53e6f21d6b4e0e5e$export$c4744153514ff05d; }, function (v) { return $53e6f21d6b4e0e5e$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $53e6f21d6b4e0e5e$export$3e506c1ccc9cc1a7; }, function (v) { return $53e6f21d6b4e0e5e$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $53e6f21d6b4e0e5e$export$e26fe2ed2fa76875; }, function (v) { return $53e6f21d6b4e0e5e$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $53e6f21d6b4e0e5e$export$502329bbf4b505b1; }, function (v) { return $53e6f21d6b4e0e5e$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $53e6f21d6b4e0e5e$export$6e3807111c4874c4; }, function (v) { return $53e6f21d6b4e0e5e$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $53e6f21d6b4e0e5e$export$c27134553091fb3a; }, function (v) { return $53e6f21d6b4e0e5e$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $53e6f21d6b4e0e5e$export$33ee1acdc04fd2a2; }, function (v) { return $53e6f21d6b4e0e5e$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $53e6f21d6b4e0e5e$export$b00a404bbd5edef2; }, function (v) { return $53e6f21d6b4e0e5e$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $53e6f21d6b4e0e5e$export$8352ce38b91d0c62; }, function (v) { return $53e6f21d6b4e0e5e$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $53e6f21d6b4e0e5e$export$d66a1c1c77bd778b; }, function (v) { return $53e6f21d6b4e0e5e$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $53e6f21d6b4e0e5e$export$d3dfb8e4810cb555; }, function (v) { return $53e6f21d6b4e0e5e$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $53e6f21d6b4e0e5e$export$839f9183b0465a69; }, function (v) { return $53e6f21d6b4e0e5e$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $53e6f21d6b4e0e5e$export$72fdf0e06517287b; }, function (v) { return $53e6f21d6b4e0e5e$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $53e6f21d6b4e0e5e$export$4b844e58a3e414b4; }, function (v) { return $53e6f21d6b4e0e5e$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $53e6f21d6b4e0e5e$export$816d2913ae6b83b1; }, function (v) { return $53e6f21d6b4e0e5e$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $53e6f21d6b4e0e5e$export$61bcfe829111a1d0; }, function (v) { return $53e6f21d6b4e0e5e$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $53e6f21d6b4e0e5e$export$7ee8c9beb337bc3f; }, function (v) { return $53e6f21d6b4e0e5e$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $53e6f21d6b4e0e5e$export$b5836b71941fa3ed; }, function (v) { return $53e6f21d6b4e0e5e$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $53e6f21d6b4e0e5e$export$cf845f2c119da08a; }, function (v) { return $53e6f21d6b4e0e5e$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $53e6f21d6b4e0e5e$export$c4744153514ff05d;
var $53e6f21d6b4e0e5e$export$3e506c1ccc9cc1a7;
var $53e6f21d6b4e0e5e$export$e26fe2ed2fa76875;
var $53e6f21d6b4e0e5e$export$502329bbf4b505b1;
var $53e6f21d6b4e0e5e$export$6e3807111c4874c4;
var $53e6f21d6b4e0e5e$export$c27134553091fb3a;
var $53e6f21d6b4e0e5e$export$33ee1acdc04fd2a2;
var $53e6f21d6b4e0e5e$export$b00a404bbd5edef2;
var $53e6f21d6b4e0e5e$export$8352ce38b91d0c62;
var $53e6f21d6b4e0e5e$export$d66a1c1c77bd778b;
var $53e6f21d6b4e0e5e$export$d3dfb8e4810cb555;
var $53e6f21d6b4e0e5e$export$839f9183b0465a69;
var $53e6f21d6b4e0e5e$export$72fdf0e06517287b;
var $53e6f21d6b4e0e5e$export$4b844e58a3e414b4;
var $53e6f21d6b4e0e5e$export$816d2913ae6b83b1;
var $53e6f21d6b4e0e5e$export$61bcfe829111a1d0;
var $53e6f21d6b4e0e5e$export$7ee8c9beb337bc3f;
var $53e6f21d6b4e0e5e$export$b5836b71941fa3ed;
var $53e6f21d6b4e0e5e$export$cf845f2c119da08a;
"use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $53e6f21d6b4e0e5e$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $53e6f21d6b4e0e5e$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === "function" ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === "function" ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== "undefined" ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== "undefined" && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $53e6f21d6b4e0e5e$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === "function") {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $53e6f21d6b4e0e5e$export$c4744153514ff05d();
                if (typeof continuationCallback === "function") currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $53e6f21d6b4e0e5e$export$c4744153514ff05d();
        var startTime;
        if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = $53e6f21d6b4e0e5e$export$c4744153514ff05d() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function() {
        if (scheduledHostCallback !== null) {
            var currentTime = $53e6f21d6b4e0e5e$export$c4744153514ff05d(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === "function") // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== "undefined") {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($53e6f21d6b4e0e5e$export$c4744153514ff05d());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $53e6f21d6b4e0e5e$export$3e506c1ccc9cc1a7 = IdlePriority;
    $53e6f21d6b4e0e5e$export$e26fe2ed2fa76875 = ImmediatePriority;
    $53e6f21d6b4e0e5e$export$502329bbf4b505b1 = LowPriority;
    $53e6f21d6b4e0e5e$export$6e3807111c4874c4 = NormalPriority;
    $53e6f21d6b4e0e5e$export$c27134553091fb3a = unstable_Profiling;
    $53e6f21d6b4e0e5e$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $53e6f21d6b4e0e5e$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $53e6f21d6b4e0e5e$export$8352ce38b91d0c62 = unstable_continueExecution;
    $53e6f21d6b4e0e5e$export$d66a1c1c77bd778b = forceFrameRate;
    $53e6f21d6b4e0e5e$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $53e6f21d6b4e0e5e$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $53e6f21d6b4e0e5e$export$72fdf0e06517287b = unstable_next;
    $53e6f21d6b4e0e5e$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $53e6f21d6b4e0e5e$export$816d2913ae6b83b1 = unstable_requestPaint;
    $53e6f21d6b4e0e5e$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $53e6f21d6b4e0e5e$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $53e6f21d6b4e0e5e$export$b5836b71941fa3ed = shouldYieldToHost;
    $53e6f21d6b4e0e5e$export$cf845f2c119da08a = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});




parcelRegister("ifjYT", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $bBYeY = parcelRequire("bBYeY");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $d489208e65015df6$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("f4o8i"))($bBYeY.isElement, $d489208e65015df6$var$throwOnDirectAccess);

});
parcelRegister("bBYeY", function(module, exports) {
"use strict";

module.exports = (parcelRequire("i0TDl"));

});
parcelRegister("i0TDl", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $d1d361c728109c96$export$2b8d127b894957b9; }, function (v) { return $d1d361c728109c96$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $d1d361c728109c96$export$cea3a54a6425200c; }, function (v) { return $d1d361c728109c96$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $d1d361c728109c96$export$a7c73072b1a182ae; }, function (v) { return $d1d361c728109c96$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $d1d361c728109c96$export$9f27bc3417b4524d; }, function (v) { return $d1d361c728109c96$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $d1d361c728109c96$export$db77ccec0bb4ccac; }, function (v) { return $d1d361c728109c96$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $d1d361c728109c96$export$8392c0c9d3dcbd35; }, function (v) { return $d1d361c728109c96$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d1d361c728109c96$export$ffb0004e005737fa; }, function (v) { return $d1d361c728109c96$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $d1d361c728109c96$export$b624eff549462981; }, function (v) { return $d1d361c728109c96$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $d1d361c728109c96$export$7897aa7841a5380c; }, function (v) { return $d1d361c728109c96$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $d1d361c728109c96$export$602eac185826482c; }, function (v) { return $d1d361c728109c96$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $d1d361c728109c96$export$e2c29f18771995cb; }, function (v) { return $d1d361c728109c96$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d1d361c728109c96$export$5f8d39834fd61797; }, function (v) { return $d1d361c728109c96$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d1d361c728109c96$export$74bf444e3cd11ea5; }, function (v) { return $d1d361c728109c96$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $d1d361c728109c96$export$92387174baf9b227; }, function (v) { return $d1d361c728109c96$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $d1d361c728109c96$export$ec112efeb987d9c6; }, function (v) { return $d1d361c728109c96$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $d1d361c728109c96$export$b706b080d889d2c9; }, function (v) { return $d1d361c728109c96$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $d1d361c728109c96$export$5be5a87408f70ddc; }, function (v) { return $d1d361c728109c96$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $d1d361c728109c96$export$45a5e7f76e0caa8d; }, function (v) { return $d1d361c728109c96$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $d1d361c728109c96$export$455c2e768291efa6; }, function (v) { return $d1d361c728109c96$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $d1d361c728109c96$export$9522e17588c12572; }, function (v) { return $d1d361c728109c96$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $d1d361c728109c96$export$2110ac352bb060b9; }, function (v) { return $d1d361c728109c96$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $d1d361c728109c96$export$56885ab8b9c456ab; }, function (v) { return $d1d361c728109c96$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $d1d361c728109c96$export$d927fcb6adf8f9de; }, function (v) { return $d1d361c728109c96$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $d1d361c728109c96$export$b82d16f27459e05a; }, function (v) { return $d1d361c728109c96$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $d1d361c728109c96$export$522c17b4f5e123e8; }, function (v) { return $d1d361c728109c96$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $d1d361c728109c96$export$1aabd8a0274ecfd6; }, function (v) { return $d1d361c728109c96$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $d1d361c728109c96$export$9b621391a187a31a; }, function (v) { return $d1d361c728109c96$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $d1d361c728109c96$export$f5bbd400c2f4426f; }, function (v) { return $d1d361c728109c96$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d1d361c728109c96$export$2b8d127b894957b9;
var $d1d361c728109c96$export$cea3a54a6425200c;
var $d1d361c728109c96$export$a7c73072b1a182ae;
var $d1d361c728109c96$export$9f27bc3417b4524d;
var $d1d361c728109c96$export$db77ccec0bb4ccac;
var $d1d361c728109c96$export$8392c0c9d3dcbd35;
var $d1d361c728109c96$export$ffb0004e005737fa;
var $d1d361c728109c96$export$b624eff549462981;
var $d1d361c728109c96$export$7897aa7841a5380c;
var $d1d361c728109c96$export$602eac185826482c;
var $d1d361c728109c96$export$e2c29f18771995cb;
var $d1d361c728109c96$export$5f8d39834fd61797;
var $d1d361c728109c96$export$74bf444e3cd11ea5;
var $d1d361c728109c96$export$92387174baf9b227;
var $d1d361c728109c96$export$ec112efeb987d9c6;
var $d1d361c728109c96$export$b706b080d889d2c9;
var $d1d361c728109c96$export$5be5a87408f70ddc;
var $d1d361c728109c96$export$45a5e7f76e0caa8d;
var $d1d361c728109c96$export$455c2e768291efa6;
var $d1d361c728109c96$export$9522e17588c12572;
var $d1d361c728109c96$export$2110ac352bb060b9;
var $d1d361c728109c96$export$56885ab8b9c456ab;
var $d1d361c728109c96$export$d927fcb6adf8f9de;
var $d1d361c728109c96$export$b82d16f27459e05a;
var $d1d361c728109c96$export$522c17b4f5e123e8;
var $d1d361c728109c96$export$1aabd8a0274ecfd6;
var $d1d361c728109c96$export$9b621391a187a31a;
var $d1d361c728109c96$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $d1d361c728109c96$export$2b8d127b894957b9 = AsyncMode;
    $d1d361c728109c96$export$cea3a54a6425200c = ConcurrentMode;
    $d1d361c728109c96$export$a7c73072b1a182ae = ContextConsumer;
    $d1d361c728109c96$export$9f27bc3417b4524d = ContextProvider;
    $d1d361c728109c96$export$db77ccec0bb4ccac = Element;
    $d1d361c728109c96$export$8392c0c9d3dcbd35 = ForwardRef;
    $d1d361c728109c96$export$ffb0004e005737fa = Fragment;
    $d1d361c728109c96$export$b624eff549462981 = Lazy;
    $d1d361c728109c96$export$7897aa7841a5380c = Memo;
    $d1d361c728109c96$export$602eac185826482c = Portal;
    $d1d361c728109c96$export$e2c29f18771995cb = Profiler;
    $d1d361c728109c96$export$5f8d39834fd61797 = StrictMode;
    $d1d361c728109c96$export$74bf444e3cd11ea5 = Suspense;
    $d1d361c728109c96$export$92387174baf9b227 = isAsyncMode;
    $d1d361c728109c96$export$ec112efeb987d9c6 = isConcurrentMode;
    $d1d361c728109c96$export$b706b080d889d2c9 = isContextConsumer;
    $d1d361c728109c96$export$5be5a87408f70ddc = isContextProvider;
    $d1d361c728109c96$export$45a5e7f76e0caa8d = isElement;
    $d1d361c728109c96$export$455c2e768291efa6 = isForwardRef;
    $d1d361c728109c96$export$9522e17588c12572 = isFragment;
    $d1d361c728109c96$export$2110ac352bb060b9 = isLazy;
    $d1d361c728109c96$export$56885ab8b9c456ab = isMemo;
    $d1d361c728109c96$export$d927fcb6adf8f9de = isPortal;
    $d1d361c728109c96$export$b82d16f27459e05a = isProfiler;
    $d1d361c728109c96$export$522c17b4f5e123e8 = isStrictMode;
    $d1d361c728109c96$export$1aabd8a0274ecfd6 = isSuspense;
    $d1d361c728109c96$export$9b621391a187a31a = isValidElementType;
    $d1d361c728109c96$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("f4o8i", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $bBYeY = parcelRequire("bBYeY");

var $mdSVi = parcelRequire("mdSVi");

var $3gbc1 = parcelRequire("3gbc1");

var $eXyx3 = parcelRequire("eXyx3");

var $8N9Mg = parcelRequire("8N9Mg");
var $af89f302e13835d1$var$printWarning = function() {};
$af89f302e13835d1$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $af89f302e13835d1$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $3gbc1) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = "Invariant Violation";
                    throw err;
                } else if (typeof console !== "undefined") {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ":" + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $af89f302e13835d1$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated " + "and will throw in the standalone `prop-types` package. " + "You may be seeing this warning due to a third-party PropTypes " + "library. See https://fb.me/react-warning-dont-call-proptypes " + "for details.");
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($af89f302e13835d1$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", $3gbc1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$bBYeY.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $af89f302e13835d1$var$printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. " + "A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
                else $af89f302e13835d1$var$printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
            return $af89f302e13835d1$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === "symbol") return String(value);
                return value;
            });
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
            for(var key in propValue)if ($eXyx3(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, $3gbc1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $af89f302e13835d1$var$printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
            return $af89f302e13835d1$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== "function") {
                $af89f302e13835d1$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                return $af89f302e13835d1$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $3gbc1);
                if (checkerResult == null) return null;
                if (checkerResult.data && $eXyx3(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $3gbc1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $mdSVi({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($eXyx3(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $3gbc1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case "number":
            case "string":
            case "undefined":
                return true;
            case "boolean":
                return !propValue;
            case "object":
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === "symbol") return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue["@@toStringTag"] === "Symbol") return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return "array";
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
        if (isSymbol(propType, propValue)) return "symbol";
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
        var propType = getPropType(propValue);
        if (propType === "object") {
            if (propValue instanceof Date) return "date";
            else if (propValue instanceof RegExp) return "regexp";
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case "array":
            case "object":
                return "an " + type;
            case "boolean":
            case "date":
            case "regexp":
                return "a " + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $8N9Mg;
    ReactPropTypes.resetWarningCache = $8N9Mg.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("mdSVi", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $042cd36e865c3ede$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $042cd36e865c3ede$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $042cd36e865c3ede$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $042cd36e865c3ede$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $042cd36e865c3ede$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $042cd36e865c3ede$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $042cd36e865c3ede$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($042cd36e865c3ede$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($042cd36e865c3ede$var$getOwnPropertySymbols) {
            symbols = $042cd36e865c3ede$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($042cd36e865c3ede$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("3gbc1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $25fb8c6a4aedd165$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $25fb8c6a4aedd165$var$ReactPropTypesSecret;

});

parcelRegister("eXyx3", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("8N9Mg", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $666a7bf3509d9baf$var$printWarning = function() {};

var $3gbc1 = parcelRequire("3gbc1");
var $666a7bf3509d9baf$var$loggedTypeFailures = {};

var $eXyx3 = parcelRequire("eXyx3");
$666a7bf3509d9baf$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $666a7bf3509d9baf$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($eXyx3(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                err.name = "Invariant Violation";
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $3gbc1);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $666a7bf3509d9baf$var$printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker " + "function must return `null` or an `Error` but returned a " + typeof error + ". " + "You may have forgotten to pass an argument to the type checker " + "creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and " + "shape all require an argument).");
        if (error instanceof Error && !(error.message in $666a7bf3509d9baf$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $666a7bf3509d9baf$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            $666a7bf3509d9baf$var$printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $666a7bf3509d9baf$var$checkPropTypes.resetWarningCache = function() {
    $666a7bf3509d9baf$var$loggedTypeFailures = {};
};
module.exports = $666a7bf3509d9baf$var$checkPropTypes;

});



parcelRegister("idnjL", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $d42b874deed63190$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $d42b874deed63190$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "NavLink", function () { return $d42b874deed63190$export$b0d92dbee9b5b60d; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("6IPSj")).useLocation; });
/**
 * React Router DOM v6.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $3RyIS = parcelRequire("3RyIS");

var $fBtgV = parcelRequire("fBtgV");

var $fBtgV = parcelRequire("fBtgV");
var $6IPSj = parcelRequire("6IPSj");
function $d42b874deed63190$var$_extends() {
    $d42b874deed63190$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d42b874deed63190$var$_extends.apply(this, arguments);
}
function $d42b874deed63190$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $d42b874deed63190$var$_excluded = [
    "onClick",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to"
], $d42b874deed63190$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
];
function $d42b874deed63190$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} ////////////////////////////////////////////////////////////////////////////////
// COMPONENTS
////////////////////////////////////////////////////////////////////////////////
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $d42b874deed63190$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window } = _ref;
    let historyRef = (0, $3RyIS.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $fBtgV.createBrowserHistory)({
        window: window
    });
    let history = historyRef.current;
    let [state, setState] = (0, $3RyIS.useState)({
        action: history.action,
        location: history.location
    });
    (0, $3RyIS.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $3RyIS.createElement)((0, $6IPSj.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $d42b874deed63190$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window } = _ref2;
    let historyRef = (0, $3RyIS.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $fBtgV.createHashHistory)({
        window: window
    });
    let history = historyRef.current;
    let [state, setState] = (0, $3RyIS.useState)({
        action: history.action,
        location: history.location
    });
    (0, $3RyIS.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $3RyIS.createElement)((0, $6IPSj.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $d42b874deed63190$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = (0, $3RyIS.useState)({
        action: history.action,
        location: history.location
    });
    (0, $3RyIS.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $3RyIS.createElement)((0, $6IPSj.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$d42b874deed63190$export$eefb0c834599897e.displayName = "unstable_HistoryRouter";
function $d42b874deed63190$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */ const $d42b874deed63190$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $3RyIS.forwardRef)(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, reloadDocument: reloadDocument, replace: replace = false, state: state, target: target, to: to } = _ref4, rest = $d42b874deed63190$var$_objectWithoutPropertiesLoose(_ref4, $d42b874deed63190$var$_excluded);
    let href = (0, $6IPSj.useHref)(to);
    let internalOnClick = $d42b874deed63190$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented && !reloadDocument) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    (0, $3RyIS.createElement)("a", $d42b874deed63190$var$_extends({}, rest, {
        href: href,
        onClick: handleClick,
        ref: ref,
        target: target
    })));
});
$d42b874deed63190$export$a6c7ac8248d6e38a.displayName = "Link";
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $d42b874deed63190$export$b0d92dbee9b5b60d = /*#__PURE__*/ (0, $3RyIS.forwardRef)(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $d42b874deed63190$var$_objectWithoutPropertiesLoose(_ref5, $d42b874deed63190$var$_excluded2);
    let location = (0, $6IPSj.useLocation)();
    let path = (0, $6IPSj.useResolvedPath)(to);
    let locationPathname = location.pathname;
    let toPathname = path.pathname;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive
    }) : styleProp;
    return /*#__PURE__*/ (0, $3RyIS.createElement)($d42b874deed63190$export$a6c7ac8248d6e38a, $d42b874deed63190$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive
    }) : children);
});
$d42b874deed63190$export$b0d92dbee9b5b60d.displayName = "NavLink";
// HOOKS
////////////////////////////////////////////////////////////////////////////////
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $d42b874deed63190$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $6IPSj.useNavigate)();
    let location = (0, $6IPSj.useLocation)();
    let path = (0, $6IPSj.useResolvedPath)(to);
    return (0, $3RyIS.useCallback)((event)=>{
        if (event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
        !$d42b874deed63190$var$isModifiedEvent(event) // Ignore clicks with modifier keys
        ) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here.
            let replace = !!replaceProp || (0, $fBtgV.createPath)(location) === (0, $fBtgV.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $d42b874deed63190$export$f1a78c17382fe22a(defaultInit) {
    $d42b874deed63190$var$warning(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params\n\nIf you're unsure how to load polyfills, we recommend you check out https://polyfill.io/v3/ which provides some recommendations about how to load polyfills only for users that need them, instead of for every user.");
    let defaultSearchParamsRef = (0, $3RyIS.useRef)($d42b874deed63190$export$a2e4e2dcc7b1f22f(defaultInit));
    let location = (0, $6IPSj.useLocation)();
    let searchParams = (0, $3RyIS.useMemo)(()=>{
        let searchParams = $d42b874deed63190$export$a2e4e2dcc7b1f22f(location.search);
        for (let key of defaultSearchParamsRef.current.keys())if (!searchParams.has(key)) defaultSearchParamsRef.current.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
        return searchParams;
    }, [
        location.search
    ]);
    let navigate = (0, $6IPSj.useNavigate)();
    let setSearchParams = (0, $3RyIS.useCallback)((nextInit, navigateOptions)=>{
        navigate("?" + $d42b874deed63190$export$a2e4e2dcc7b1f22f(nextInit), navigateOptions);
    }, [
        navigate
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $d42b874deed63190$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}

});
parcelRegister("fBtgV", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $b5c10483c4a96bfa$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $b5c10483c4a96bfa$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createPath", function () { return $b5c10483c4a96bfa$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $b5c10483c4a96bfa$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createHashHistory", function () { return $b5c10483c4a96bfa$export$b71fdd3798280242; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $b5c10483c4a96bfa$export$2b76ad033c6e6d08; });

var $8U8w1 = parcelRequire("8U8w1");
/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $b5c10483c4a96bfa$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($b5c10483c4a96bfa$export$e19cd5f9376f8cee || ($b5c10483c4a96bfa$export$e19cd5f9376f8cee = {}));
var $b5c10483c4a96bfa$var$readOnly = function(obj) {
    return Object.freeze(obj);
};
function $b5c10483c4a96bfa$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $b5c10483c4a96bfa$var$BeforeUnloadEventType = "beforeunload";
var $b5c10483c4a96bfa$var$HashChangeEventType = "hashchange";
var $b5c10483c4a96bfa$var$PopStateEventType = "popstate";
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $b5c10483c4a96bfa$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $b5c10483c4a96bfa$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $b5c10483c4a96bfa$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                } else // Trying to POP to a location with no index. We did not create
                // this location, so we can't effectively block the navigation.
                $b5c10483c4a96bfa$var$warning(false, // detail and link to it here so people can understand better what
                // is going on and how to avoid it.
                "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation.");
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($b5c10483c4a96bfa$var$PopStateEventType, handlePop);
    var action = $b5c10483c4a96bfa$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $b5c10483c4a96bfa$var$createEvents();
    var blockers = $b5c10483c4a96bfa$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $8U8w1.default)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function createHref(to) {
        return typeof to === "string" ? to : $b5c10483c4a96bfa$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $b5c10483c4a96bfa$var$readOnly((0, $8U8w1.default)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $b5c10483c4a96bfa$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $b5c10483c4a96bfa$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $b5c10483c4a96bfa$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $b5c10483c4a96bfa$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($b5c10483c4a96bfa$var$BeforeUnloadEventType, $b5c10483c4a96bfa$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($b5c10483c4a96bfa$var$BeforeUnloadEventType, $b5c10483c4a96bfa$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $b5c10483c4a96bfa$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $b5c10483c4a96bfa$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? "/" : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? "" : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? "" : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $b5c10483c4a96bfa$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $b5c10483c4a96bfa$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                } else // Trying to POP to a location with no index. We did not create
                // this location, so we can't effectively block the navigation.
                $b5c10483c4a96bfa$var$warning(false, // detail and link to it here so people can understand better
                // what is going on and how to avoid it.
                "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation.");
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($b5c10483c4a96bfa$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($b5c10483c4a96bfa$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($b5c10483c4a96bfa$export$fe53371bee54353d(nextLocation) !== $b5c10483c4a96bfa$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $b5c10483c4a96bfa$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $b5c10483c4a96bfa$var$createEvents();
    var blockers = $b5c10483c4a96bfa$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $8U8w1.default)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getBaseHref() {
        var base = document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + "#" + (typeof to === "string" ? to : $b5c10483c4a96bfa$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $b5c10483c4a96bfa$var$readOnly((0, $8U8w1.default)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $b5c10483c4a96bfa$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $b5c10483c4a96bfa$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $b5c10483c4a96bfa$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        $b5c10483c4a96bfa$var$warning(nextLocation.pathname.charAt(0) === "/", "Relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $b5c10483c4a96bfa$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        $b5c10483c4a96bfa$var$warning(nextLocation.pathname.charAt(0) === "/", "Relative pathnames are not supported in hash history.replace(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($b5c10483c4a96bfa$var$BeforeUnloadEventType, $b5c10483c4a96bfa$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($b5c10483c4a96bfa$var$BeforeUnloadEventType, $b5c10483c4a96bfa$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $b5c10483c4a96bfa$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        "/"
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $b5c10483c4a96bfa$var$readOnly((0, $8U8w1.default)({
            pathname: "/",
            search: "",
            hash: "",
            state: null,
            key: $b5c10483c4a96bfa$var$createKey()
        }, typeof entry === "string" ? $b5c10483c4a96bfa$export$8ccf933b0513f8d0(entry) : entry));
        $b5c10483c4a96bfa$var$warning(location.pathname.charAt(0) === "/", "Relative pathnames are not supported in createMemoryHistory({ initialEntries }) (invalid entry: " + JSON.stringify(entry) + ")");
        return location;
    });
    var index = $b5c10483c4a96bfa$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $b5c10483c4a96bfa$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $b5c10483c4a96bfa$var$createEvents();
    var blockers = $b5c10483c4a96bfa$var$createEvents();
    function createHref(to) {
        return typeof to === "string" ? to : $b5c10483c4a96bfa$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $b5c10483c4a96bfa$var$readOnly((0, $8U8w1.default)({
            pathname: location.pathname,
            search: "",
            hash: ""
        }, typeof to === "string" ? $b5c10483c4a96bfa$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $b5c10483c4a96bfa$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $b5c10483c4a96bfa$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        $b5c10483c4a96bfa$var$warning(location.pathname.charAt(0) === "/", "Relative pathnames are not supported in memory history.push(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $b5c10483c4a96bfa$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        $b5c10483c4a96bfa$var$warning(location.pathname.charAt(0) === "/", "Relative pathnames are not supported in memory history.replace(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $b5c10483c4a96bfa$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $b5c10483c4a96bfa$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $b5c10483c4a96bfa$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $b5c10483c4a96bfa$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = "";
}
function $b5c10483c4a96bfa$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $b5c10483c4a96bfa$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $b5c10483c4a96bfa$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? "/" : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? "" : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? "" : _ref$hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $b5c10483c4a96bfa$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}

});
parcelRegister("8U8w1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67ba28b1e227c60b$export$2e2bcd8739ae039; });
function $67ba28b1e227c60b$export$2e2bcd8739ae039() {
    $67ba28b1e227c60b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $67ba28b1e227c60b$export$2e2bcd8739ae039.apply(this, arguments);
}

});


parcelRegister("6IPSj", function(module, exports) {

$parcel$export(module.exports, "useHref", function () { return $4e4f176e5be5b855$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $4e4f176e5be5b855$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $4e4f176e5be5b855$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $4e4f176e5be5b855$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $4e4f176e5be5b855$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "Router", function () { return $4e4f176e5be5b855$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $4e4f176e5be5b855$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Outlet", function () { return $4e4f176e5be5b855$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $4e4f176e5be5b855$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $4e4f176e5be5b855$export$3565eb3d00ca5a74; });
/**
 * React Router v6.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $fBtgV = parcelRequire("fBtgV");

var $3RyIS = parcelRequire("3RyIS");
const $4e4f176e5be5b855$export$26749e8557646306 = /*#__PURE__*/ (0, $3RyIS.createContext)(null);
$4e4f176e5be5b855$export$26749e8557646306.displayName = "Navigation";
const $4e4f176e5be5b855$export$c7914228fb69b0f5 = /*#__PURE__*/ (0, $3RyIS.createContext)(null);
$4e4f176e5be5b855$export$c7914228fb69b0f5.displayName = "Location";
const $4e4f176e5be5b855$export$9072aa6dd1f93057 = /*#__PURE__*/ (0, $3RyIS.createContext)({
    outlet: null,
    matches: []
});
$4e4f176e5be5b855$export$9072aa6dd1f93057.displayName = "Route";
function $4e4f176e5be5b855$var$invariant(cond, message) {
    if (!cond) throw new Error(message);
}
function $4e4f176e5be5b855$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
const $4e4f176e5be5b855$var$alreadyWarned = {};
function $4e4f176e5be5b855$var$warningOnce(key, cond, message) {
    if (!cond && !$4e4f176e5be5b855$var$alreadyWarned[key]) {
        $4e4f176e5be5b855$var$alreadyWarned[key] = true;
        $4e4f176e5be5b855$var$warning(false, message);
    }
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/docs/en/v6/api#generatepath
 */ function $4e4f176e5be5b855$export$82476f982757e71e(path, params) {
    if (params === void 0) params = {};
    return path.replace(/:(\w+)/g, (_, key)=>{
        !(params[key] != null) && $4e4f176e5be5b855$var$invariant(false, 'Missing ":' + key + '" param');
        return params[key];
    }).replace(/\/*\*$/, (_)=>params["*"] == null ? "" : params["*"].replace(/^\/*/, "/"));
}
/**
 * A RouteMatch contains info about how a route matched a URL.
 */ /**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchroutes
 */ function $4e4f176e5be5b855$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? (0, $fBtgV.parsePath)(locationArg) : locationArg;
    let pathname = $4e4f176e5be5b855$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $4e4f176e5be5b855$var$flattenRoutes(routes);
    $4e4f176e5be5b855$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $4e4f176e5be5b855$var$matchRouteBranch(branches[i], pathname);
    return matches;
}
function $4e4f176e5be5b855$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    routes.forEach((route, index)=>{
        let meta = {
            relativePath: route.path || "",
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            !meta.relativePath.startsWith(parentPath) && $4e4f176e5be5b855$var$invariant(false, 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $4e4f176e5be5b855$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            !(route.index !== true) && $4e4f176e5be5b855$var$invariant(false, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $4e4f176e5be5b855$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $4e4f176e5be5b855$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $4e4f176e5be5b855$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $4e4f176e5be5b855$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $4e4f176e5be5b855$var$paramRe = /^:\w+$/;
const $4e4f176e5be5b855$var$dynamicSegmentValue = 3;
const $4e4f176e5be5b855$var$indexRouteValue = 2;
const $4e4f176e5be5b855$var$emptySegmentValue = 1;
const $4e4f176e5be5b855$var$staticSegmentValue = 10;
const $4e4f176e5be5b855$var$splatPenalty = -2;
const $4e4f176e5be5b855$var$isSplat = (s)=>s === "*";
function $4e4f176e5be5b855$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($4e4f176e5be5b855$var$isSplat)) initialScore += $4e4f176e5be5b855$var$splatPenalty;
    if (index) initialScore += $4e4f176e5be5b855$var$indexRouteValue;
    return segments.filter((s)=>!$4e4f176e5be5b855$var$isSplat(s)).reduce((score, segment)=>score + ($4e4f176e5be5b855$var$paramRe.test(segment) ? $4e4f176e5be5b855$var$dynamicSegmentValue : segment === "" ? $4e4f176e5be5b855$var$emptySegmentValue : $4e4f176e5be5b855$var$staticSegmentValue), initialScore);
}
function $4e4f176e5be5b855$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $4e4f176e5be5b855$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $4e4f176e5be5b855$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            params: matchedParams,
            pathname: $4e4f176e5be5b855$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $4e4f176e5be5b855$var$normalizePathname($4e4f176e5be5b855$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $4e4f176e5be5b855$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * A PathPattern is used to match on some portion of a URL pathname.
 */ /**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchpath
 */ function $4e4f176e5be5b855$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $4e4f176e5be5b855$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $4e4f176e5be5b855$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $4e4f176e5be5b855$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $4e4f176e5be5b855$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else regexpSource += end ? "\\/*$" // When matching to the end, ignore trailing slashes
     : // parent routes to matching only their own words and nothing more, e.g. parent
    // route "/home" should not match "/home2".
    // Additionally, allow paths starting with `.`, `-`, `~`, and url-encoded entities,
    // but do not consume the character in the matched path so they can match against
    // nested paths.
    "(?:(?=[.~-]|%[0-9A-F]{2})|\\b|\\/|$)";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $4e4f176e5be5b855$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $4e4f176e5be5b855$var$warning(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/docs/en/v6/api#resolvepath
 */ function $4e4f176e5be5b855$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $fBtgV.parsePath)(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $4e4f176e5be5b855$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $4e4f176e5be5b855$var$normalizeSearch(search),
        hash: $4e4f176e5be5b855$var$normalizeHash(hash)
    };
}
function $4e4f176e5be5b855$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $4e4f176e5be5b855$var$resolveTo(toArg, routePathnames, locationPathname) {
    let to = typeof toArg === "string" ? (0, $fBtgV.parsePath)(toArg) : toArg;
    let toPathname = toArg === "" || to.pathname === "" ? "/" : to.pathname; // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $4e4f176e5be5b855$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original to value had one.
    if (toPathname && toPathname !== "/" && toPathname.endsWith("/") && !path.pathname.endsWith("/")) path.pathname += "/";
    return path;
}
function $4e4f176e5be5b855$var$getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? (0, $fBtgV.parsePath)(to).pathname : to.pathname;
}
function $4e4f176e5be5b855$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let nextChar = pathname.charAt(basename.length);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(basename.length) || "/";
}
const $4e4f176e5be5b855$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
const $4e4f176e5be5b855$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
const $4e4f176e5be5b855$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $4e4f176e5be5b855$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usehref
 */ function $4e4f176e5be5b855$export$b66bb29c5006f12f(to) {
    !$4e4f176e5be5b855$export$9c954a9d03d32f4a() && $4e4f176e5be5b855$var$invariant(false, // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component.");
    let { basename: basename, navigator: navigator } = (0, $3RyIS.useContext)($4e4f176e5be5b855$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $4e4f176e5be5b855$export$e75d2a2d1b3c245b(to);
    let joinedPathname = pathname;
    if (basename !== "/") {
        let toPathname = $4e4f176e5be5b855$var$getToPathname(to);
        let endsWithSlash = toPathname != null && toPathname.endsWith("/");
        joinedPathname = pathname === "/" ? basename + (endsWithSlash ? "/" : "") : $4e4f176e5be5b855$var$joinPaths([
            basename,
            pathname
        ]);
    }
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useinroutercontext
 */ function $4e4f176e5be5b855$export$9c954a9d03d32f4a() {
    return (0, $3RyIS.useContext)($4e4f176e5be5b855$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/docs/en/v6/api#uselocation
 */ function $4e4f176e5be5b855$export$45d76561a5302f2b() {
    !$4e4f176e5be5b855$export$9c954a9d03d32f4a() && $4e4f176e5be5b855$var$invariant(false, // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component.");
    return (0, $3RyIS.useContext)($4e4f176e5be5b855$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigationtype
 */ function $4e4f176e5be5b855$export$1b3f31771c5d07c() {
    return (0, $3RyIS.useContext)($4e4f176e5be5b855$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns true if the URL for the given "to" value matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usematch
 */ function $4e4f176e5be5b855$export$6c330e8992e8a295(pattern) {
    !$4e4f176e5be5b855$export$9c954a9d03d32f4a() && $4e4f176e5be5b855$var$invariant(false, // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component.");
    let { pathname: pathname } = $4e4f176e5be5b855$export$45d76561a5302f2b();
    return (0, $3RyIS.useMemo)(()=>$4e4f176e5be5b855$export$81336c211d5ff295(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigate
 */ function $4e4f176e5be5b855$export$9770f232ac06a008() {
    !$4e4f176e5be5b855$export$9c954a9d03d32f4a() && $4e4f176e5be5b855$var$invariant(false, // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component.");
    let { basename: basename, navigator: navigator } = (0, $3RyIS.useContext)($4e4f176e5be5b855$export$26749e8557646306);
    let { matches: matches } = (0, $3RyIS.useContext)($4e4f176e5be5b855$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4e4f176e5be5b855$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    let activeRef = (0, $3RyIS.useRef)(false);
    (0, $3RyIS.useEffect)(()=>{
        activeRef.current = true;
    });
    let navigate = (0, $3RyIS.useCallback)(function(to, options) {
        if (options === void 0) options = {};
        $4e4f176e5be5b855$var$warning(activeRef.current, "You should call navigate() in a React.useEffect(), not when your component is first rendered.");
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $4e4f176e5be5b855$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname);
        if (basename !== "/") path.pathname = $4e4f176e5be5b855$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $4e4f176e5be5b855$var$OutletContext = /*#__PURE__*/ (0, $3RyIS.createContext)(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/docs/en/v6/api#useoutletcontext
 */ function $4e4f176e5be5b855$export$4138103a3ae699cc() {
    return (0, $3RyIS.useContext)($4e4f176e5be5b855$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useoutlet
 */ function $4e4f176e5be5b855$export$a3be3530d8e40d0b(context) {
    let outlet = (0, $3RyIS.useContext)($4e4f176e5be5b855$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ (0, $3RyIS.createElement)($4e4f176e5be5b855$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useparams
 */ function $4e4f176e5be5b855$export$99eaa27ddbbb95ef() {
    let { matches: matches } = (0, $3RyIS.useContext)($4e4f176e5be5b855$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useresolvedpath
 */ function $4e4f176e5be5b855$export$e75d2a2d1b3c245b(to) {
    let { matches: matches } = (0, $3RyIS.useContext)($4e4f176e5be5b855$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4e4f176e5be5b855$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    return (0, $3RyIS.useMemo)(()=>$4e4f176e5be5b855$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname), [
        to,
        routePathnamesJson,
        locationPathname
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useroutes
 */ function $4e4f176e5be5b855$export$5d3fca4a98652595(routes, locationArg) {
    !$4e4f176e5be5b855$export$9c954a9d03d32f4a() && $4e4f176e5be5b855$var$invariant(false, // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component.");
    let { matches: parentMatches } = (0, $3RyIS.useContext)($4e4f176e5be5b855$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    {
        // You won't get a warning about 2 different <Routes> under a <Route>
        // without a trailing *, but this is a best-effort warning anyway since we
        // cannot even give the warning unless they land at the parent route.
        //
        // Example:
        //
        // <Routes>
        //   {/* This route path MUST end with /* because otherwise
        //       it will never match /blog/post/123 */}
        //   <Route path="blog" element={<Blog />} />
        //   <Route path="blog/feed" element={<BlogFeed />} />
        // </Routes>
        //
        // function Blog() {
        //   return (
        //     <Routes>
        //       <Route path="post/:id" element={<Post />} />
        //     </Routes>
        //   );
        // }
        let parentPath = parentRoute && parentRoute.path || "";
        $4e4f176e5be5b855$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + parentPathname + '" (under <Route path="' + parentPath + '">) but the ') + 'parent route path has no trailing "*". This means if you navigate ' + "deeper, the parent won't match anymore and therefore the child " + "routes will never render.\n\n" + ('Please change the parent <Route path="' + parentPath + '"> to <Route ') + ('path="' + (parentPath === "/" ? "*" : parentPath + "/*") + '">.'));
    }
    let locationFromContext = $4e4f176e5be5b855$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $fBtgV.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && $4e4f176e5be5b855$var$invariant(false, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ('matched by all parent routes. The current pathname base is "' + parentPathnameBase + '" ') + ('but pathname "' + parsedLocationArg.pathname + '" was given in the `location` prop.'));
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = $4e4f176e5be5b855$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    $4e4f176e5be5b855$var$warning(parentRoute || matches != null, 'No routes matched location "' + location.pathname + location.search + location.hash + '" ');
    $4e4f176e5be5b855$var$warning(matches == null || matches[matches.length - 1].route.element !== undefined, 'Matched leaf route at location "' + location.pathname + location.search + location.hash + '" does not have an element. ' + 'This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.');
    return $4e4f176e5be5b855$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $4e4f176e5be5b855$var$joinPaths([
                parentPathnameBase,
                match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $4e4f176e5be5b855$var$joinPaths([
                parentPathnameBase,
                match.pathnameBase
            ])
        })), parentMatches);
}
function $4e4f176e5be5b855$var$_renderMatches(matches, parentMatches) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) return null;
    return matches.reduceRight((outlet, match, index)=>{
        return /*#__PURE__*/ (0, $3RyIS.createElement)($4e4f176e5be5b855$export$9072aa6dd1f93057.Provider, {
            children: match.route.element !== undefined ? match.route.element : outlet,
            value: {
                outlet: outlet,
                matches: parentMatches.concat(matches.slice(0, index + 1))
            }
        });
    }, null);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/docs/en/v6/api#memoryrouter
 */ function $4e4f176e5be5b855$export$ae46f04cfaffe093(_ref) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref;
    let historyRef = (0, $3RyIS.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $fBtgV.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex
    });
    let history = historyRef.current;
    let [state, setState] = (0, $3RyIS.useState)({
        action: history.action,
        location: history.location
    });
    (0, $3RyIS.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $3RyIS.createElement)($4e4f176e5be5b855$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/docs/en/v6/api#navigate
 */ function $4e4f176e5be5b855$export$444b3ab0cb9aec40(_ref2) {
    let { to: to, replace: replace, state: state } = _ref2;
    !$4e4f176e5be5b855$export$9c954a9d03d32f4a() && $4e4f176e5be5b855$var$invariant(false, // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component.");
    $4e4f176e5be5b855$var$warning(!(0, $3RyIS.useContext)($4e4f176e5be5b855$export$26749e8557646306).static, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let navigate = $4e4f176e5be5b855$export$9770f232ac06a008();
    (0, $3RyIS.useEffect)(()=>{
        navigate(to, {
            replace: replace,
            state: state
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/docs/en/v6/api#outlet
 */ function $4e4f176e5be5b855$export$910ae8079b2c2852(props) {
    return $4e4f176e5be5b855$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#route
 */ function $4e4f176e5be5b855$export$e7b0ac011bb776c6(_props) {
    $4e4f176e5be5b855$var$invariant(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/docs/en/v6/api#router
 */ function $4e4f176e5be5b855$export$55185c17a0fcbe46(_ref3) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $fBtgV.Action).Pop, navigator: navigator, static: staticProp = false } = _ref3;
    !!$4e4f176e5be5b855$export$9c954a9d03d32f4a() && $4e4f176e5be5b855$var$invariant(false, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    let basename = $4e4f176e5be5b855$var$normalizePathname(basenameProp);
    let navigationContext = (0, $3RyIS.useMemo)(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $fBtgV.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let location = (0, $3RyIS.useMemo)(()=>{
        let trailingPathname = $4e4f176e5be5b855$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search: search,
            hash: hash,
            state: state,
            key: key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    $4e4f176e5be5b855$var$warning(location != null, '<Router basename="' + basename + '"> is not able to match the URL ' + ('"' + pathname + search + hash + '" because it does not start with the ') + "basename, so the <Router> won't render anything.");
    if (location == null) return null;
    return /*#__PURE__*/ (0, $3RyIS.createElement)($4e4f176e5be5b855$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ (0, $3RyIS.createElement)($4e4f176e5be5b855$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: {
            location: location,
            navigationType: navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#routes
 */ function $4e4f176e5be5b855$export$3565eb3d00ca5a74(_ref4) {
    let { children: children, location: location } = _ref4;
    return $4e4f176e5be5b855$export$5d3fca4a98652595($4e4f176e5be5b855$export$16da398f5434bdec(children), location);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/docs/en/v6/api#createroutesfromchildren
 */ function $4e4f176e5be5b855$export$16da398f5434bdec(children) {
    let routes = [];
    (0, $3RyIS.Children).forEach(children, (element)=>{
        if (!/*#__PURE__*/ (0, $3RyIS.isValidElement)(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === (0, $3RyIS.Fragment)) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $4e4f176e5be5b855$export$16da398f5434bdec(element.props.children));
            return;
        }
        !(element.type === $4e4f176e5be5b855$export$e7b0ac011bb776c6) && $4e4f176e5be5b855$var$invariant(false, "[" + (typeof element.type === "string" ? element.type : element.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>");
        let route = {
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path
        };
        if (element.props.children) route.children = $4e4f176e5be5b855$export$16da398f5434bdec(element.props.children);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $4e4f176e5be5b855$export$daf73786167a7f72(matches) {
    return $4e4f176e5be5b855$var$_renderMatches(matches);
}

});


parcelRegister("l7Vlc", function(module, exports) {

$parcel$export(module.exports, "theme", function () { return $03f81bcaf0c10c12$export$bca14c5b3b88a9c9; });
$parcel$export(module.exports, "getOverride", function () { return $03f81bcaf0c10c12$export$72427a1521dd0069; });
$parcel$export(module.exports, "userPages", function () { return $03f81bcaf0c10c12$export$dce756e42e46fb8d; });
$parcel$export(module.exports, "getString", function () { return $03f81bcaf0c10c12$export$f8963f3214707ee4; });
$parcel$export(module.exports, "getBannerFromVedaConfig", function () { return $03f81bcaf0c10c12$export$13d093fb7ee5439c; });
$parcel$export(module.exports, "getSiteAlertFromVedaConfig", function () { return $03f81bcaf0c10c12$export$d9cb1ed813b8c22a; });
$parcel$export(module.exports, "getNavItemsFromVedaConfig", function () { return $03f81bcaf0c10c12$export$82c8c4fe4976ca54; });
$parcel$export(module.exports, "getCookieConsentFromVedaConfig", function () { return $03f81bcaf0c10c12$export$5bcbf72a6bf6fd08; });
$parcel$export(module.exports, "getFooterSettingsFromVedaConfig", function () { return $03f81bcaf0c10c12$export$65b37974ae70f0ea; });
$parcel$export(module.exports, "datasets", function () { return $03f81bcaf0c10c12$export$98351ca05c1b59e4; });
$parcel$export(module.exports, "stories", function () { return $03f81bcaf0c10c12$export$417f05a13bd2667c; });









const $03f81bcaf0c10c12$var$config = {
    pageOverrides: {
        "aboutContent": {
            data: {
                "title": "The U.S. Greenhouse Gas Center",
                "description": " "
            },
            content: ()=>(parcelRequire("gzxNJ"))
        },
        "homeContent": {
            data: {
                "title": "U.S. Greenhouse Gas Center",
                "description": " "
            },
            content: ()=>(parcelRequire("3nv1n"))
        },
        "developmentContent": {
            data: {
                "title": "We are Continuously Improving!",
                "description": "Please expect updates and provide feedback."
            },
            content: ()=>(parcelRequire("hFyFZ"))
        },
        "homeHero": {
            data: {},
            content: ()=>(parcelRequire("ddP5G"))
        },
        "headerBrand": {
            data: {},
            content: ()=>(parcelRequire("a9c8h"))
        },
        "pageFooter": {
            data: {},
            content: ()=>(parcelRequire("dF6Qr"))
        },
        "/news-and-events": {
            data: {
                "mainNavItem": {
                    "navTitle": "News & Events"
                },
                "title": "News & Events",
                "description": " US GHG Center News, Events, and Training Opportunities. "
            },
            content: ()=>(parcelRequire("dcrHe"))
        },
        "/data-toolkit": {
            data: {
                "mainNavItem": {
                    "navTitle": "Data Toolkit"
                },
                "title": "Accessing and Exploring Data",
                "description": " Everything needed to better understand and use the U.S. Greenhouse Gas Center datasets, including data descriptions, data visualization and open source tools for those interested in utilizing the data for research. "
            },
            content: ()=>(parcelRequire("8TcNs"))
        },
        "/topics": {
            data: {
                "mainNavItem": {
                    "navTitle": "Topics"
                },
                "title": "Topics",
                "description": " Explore thematic content collections and core science focus areas. "
            },
            content: ()=>(parcelRequire("4NX4Q"))
        }
    },
    strings: {
        "stories": {
            "one": "Story",
            "other": "Stories"
        },
        "storiesBanner": {
            "one": "Explore the guided narratives below to learn more about greenhouse gas measurement, changes over time, events and human-related causes and contributions.",
            "other": "Explore the guided narratives below to learn more about greenhouse gas measurement, changes over time, events and human-related causes and contributions."
        },
        "dataCatalogBanner": {
            "one": "This dashboard is for exploring key datasets that provide insight into greenhouse gas sources, sinks, emissions, fluxes, and events.",
            "other": "This dashboard is for exploring key datasets that provide insight into greenhouse gas sources, sinks, emissions, fluxes, and events."
        },
        "tempBanner": {
            "one": "Read the new story on using EMIT and AVIRIS-3 for monitoring large methane emission events.",
            "other": "Read the new story on using EMIT and AVIRIS-3 for monitoring large methane emission events."
        },
        "tempBannerUrl": {
            "one": "stories/emit-and-aviris-3",
            "other": "stories/emit-and-aviris-3"
        },
        "tempBannerExpires": {
            "one": "2024-07-03T12:00:00-04:00",
            "other": "2024-07-03T12:00:00-04:00"
        }
    },
    booleans: {
        "externalLinksInNewTab": true,
        "stories": {
            "one": "Story",
            "other": "Stories"
        },
        "storiesBanner": {
            "one": "Explore the guided narratives below to discover how NASA satellites and other Earth observing resources reveal a changing planet.",
            "other": "Explore the guided narratives below to discover how NASA satellites and other Earth observing resources reveal a changing planet."
        },
        "dataCatalogBanner": {
            "one": "This dashboard explores key indicators to track and compare changes over time.",
            "other": "This dashboard explores key indicators to track and compare changes over time."
        }
    },
    banner: {
        "headerActionText": "Here's how you know",
        "flagImgSrc": "/ghgcenter/img/us_flag_small.png",
        "flagImgAlt": "US flag",
        "leftGuidance": {
            "title": "Official websites use .gov",
            "text": "<p>A <strong>.gov</strong> website belongs to an official government organization in the United States.</p>",
            "iconAlt": "Dot gov icon",
            "icon": "/ghgcenter/img/icon-dot-gov.svg"
        },
        "rightGuidance": {
            "title": "Secure .gov websites use HTTPS",
            "text": "<p>A <strong>lock icon</strong> or <strong>https://</strong> means you've safely connected to the .gov website. Share sensitive information only on official, secure websites.</p>",
            "iconAlt": "HTTPS icon",
            "icon": "/ghgcenter/img/icon-https.svg"
        },
        "className": "",
        "defaultIsOpen": false,
        "contentId": "gov-banner-content"
    },
    siteAlert: undefined,
    navItems: {
        "headerNavItems": [
            {
                "title": "Stories",
                "to": "/stories",
                "type": "internalLink"
            },
            {
                "title": "Topics",
                "to": "/topics",
                "type": "internalLink"
            },
            {
                "title": "Data Toolkit",
                "to": "/data-toolkit",
                "type": "internalLink"
            }
        ],
        "subNavItems": [
            {
                "title": "News & Events",
                "to": "/news-and-events",
                "type": "internalLink"
            },
            {
                "title": "About",
                "to": "/about",
                "type": "internalLink"
            },
            {
                "title": "Contact us",
                "src": "https://docs.google.com/forms/d/e/1FAIpQLSeVWCrnca08Gt_qoWYjTo6gnj1BEGL4NCUC9VEiQnXA02gzVQ/viewform",
                "type": "action"
            }
        ]
    },
    cookieConsentForm: {
        "title": "Cookie Consent",
        "copy": '<p>We use cookies to enhance your browsing experience and to help us understand how our website is used. These cookies allow us to collect data on site usage and improve our services based on your interactions. To learn more about it, see our <a href="https://www.nasa.gov/privacy/#cookies">Privacy Policy</a>.</p>',
        "theme": {
            "card": {
                "sideBarColor": "#082a64",
                "textColor": "#1B2631",
                "linkColor": "#175074"
            },
            "acceptButton": {
                "default": {
                    "backgroundColor": "#082a64",
                    "textColor": "white"
                },
                "hover": {
                    "backgroundColor": "#061A3A",
                    "textColor": "#white"
                }
            },
            "declineButton": {
                "default": {
                    "borderColor": "#082a64",
                    "textColor": "#082a64"
                },
                "hover": {
                    "borderColor": "#061A3A",
                    "textColor": "#2c3e50"
                }
            },
            "iconColor": {
                "default": "#082a64",
                "hover": "#061A3A"
            }
        }
    },
    footerSettings: undefined
};
const $03f81bcaf0c10c12$export$bca14c5b3b88a9c9 = {
    "color": {
        "primary": "#082a64",
        "link": "#1565EF"
    },
    "type": {
        "base": {
            "color": "#1B2631",
            "family": '"Inter", sans-serif !important'
        }
    },
    "button": {
        "type": {
            "case": "uppercase",
            "weight": 500
        }
    }
};
const $03f81bcaf0c10c12$export$73105a133948e25f = [
    {
        "name": "Topics",
        "values": [
            {
                "id": "anthropogenic-emissions",
                "name": "Anthropogenic Emissions"
            },
            {
                "id": "large-emission-events",
                "name": "Large Emission Events"
            },
            {
                "id": "methane",
                "name": "Methane"
            },
            {
                "id": "natural-emissions-and-sinks",
                "name": "Natural Emissions and Sinks"
            },
            {
                "id": "urban",
                "name": "Urban"
            }
        ]
    },
    {
        "name": "Gas",
        "values": [
            {
                "id": "ch\u2084",
                "name": "CH\u2084"
            },
            {
                "id": "co",
                "name": "CO"
            },
            {
                "id": "co\u2082",
                "name": "CO\u2082"
            },
            {
                "id": "no\u2093",
                "name": "NO\u2093"
            },
            {
                "id": "pm-2-5",
                "name": "PM2.5"
            },
            {
                "id": "so\u2082",
                "name": "SO\u2082"
            }
        ]
    }
];
const $03f81bcaf0c10c12$export$72427a1521dd0069 = (key)=>$03f81bcaf0c10c12$var$config.pageOverrides[key];
const $03f81bcaf0c10c12$export$dce756e42e46fb8d = Object.keys($03f81bcaf0c10c12$var$config.pageOverrides).filter((k)=>k.startsWith("/"));
const $03f81bcaf0c10c12$export$f8963f3214707ee4 = (variable)=>$03f81bcaf0c10c12$var$config.strings[variable];
const $03f81bcaf0c10c12$export$11811c4d2c6a473d = (variable)=>$03f81bcaf0c10c12$var$config.booleans[variable];
const $03f81bcaf0c10c12$export$44487a86467333c3 = ()=>$03f81bcaf0c10c12$var$config;
const $03f81bcaf0c10c12$export$13d093fb7ee5439c = ()=>$03f81bcaf0c10c12$var$config.banner;
const $03f81bcaf0c10c12$export$d9cb1ed813b8c22a = ()=>$03f81bcaf0c10c12$var$config.siteAlert;
const $03f81bcaf0c10c12$export$82c8c4fe4976ca54 = ()=>$03f81bcaf0c10c12$var$config.navItems;
const $03f81bcaf0c10c12$export$5bcbf72a6bf6fd08 = ()=>$03f81bcaf0c10c12$var$config.cookieConsentForm;
const $03f81bcaf0c10c12$export$65b37974ae70f0ea = ()=>$03f81bcaf0c10c12$var$config.footerSettings;



















































































































const $03f81bcaf0c10c12$export$98351ca05c1b59e4 = {
    "ct-ch4-monthgrid-v2025": {
        data: {
            "id": "ct-ch4-monthgrid-v2025",
            "name": "CarbonTracker-CH\u2084 Isotopic Methane Inverse Fluxes",
            "description": "Global, monthly 1 degree resolution methane emission estimates from microbial, fossil and pyrogenic sources derived using inverse modeling, version 2025",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/ct-ch4-monthgrid-v2025.html",
                    "label": "Notebook showing data transformation to COG for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Fct-ch4-monthgrid-v2025_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://data.ghg.center/browseui/index.html#ct-ch4-monthgrid-v2025/",
                    "label": "Browse and download the data",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("95TOc")),
                "alt": "Landfill",
                "author": {
                    "name": "Matt Ziminski and Youmi Oh",
                    "url": "https://gml.noaa.gov/ccgg/carbontracker-ch4/"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "anthropogenic-emissions",
                            "name": "Anthropogenic Emissions"
                        },
                        {
                            "id": "natural-emissions-and-sinks",
                            "name": "Natural Emissions and Sinks"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nasa",
                            "name": "NASA"
                        },
                        {
                            "id": "noaa",
                            "name": "NOAA"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "ground-measurements",
                            "name": "Ground Measurements"
                        },
                        {
                            "id": "model-output",
                            "name": "Model Output"
                        }
                    ]
                }
            ],
            "infoDescription": "<ul><li>Temporal Extent: January 1998 - December 2023</li><li>Temporal Resolution: Monthly</li><li>Spatial Extent: Global</li><li>Spatial Resolution: 1\xb0 x 1\xb0</li><li>Data Units: Grams of methane per square meter per year (g CH\u2084/m\xb2/year)</li><li>Data Type: Research</li><li>Data Latency: Updated annually</li></ul>",
            "layers": [
                {
                    "id": "total-ch4",
                    "stacCol": "ct-ch4-monthgrid-v2025",
                    "name": "Total CH\u2084 Emission",
                    "type": "raster",
                    "description": "Total methane emission from microbial, fossil and pyrogenic sources.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        0
                    ],
                    "sourceParams": {
                        "assets": "total",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            50
                        ]
                    },
                    "compare": {
                        "datasetId": "ct-ch4-monthgrid-v2025",
                        "layerId": "total-ch4",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CH\u2084/m\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 50,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "g CH\u2084/m\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("lyJUi")),
                        "alt": "TM5-4DVar Isotopic CH\u2084 Inverse Fluxes - Total CH\u2084 Emission"
                    },
                    "parentDataset": {
                        "id": "ct-ch4-monthgrid-v2025"
                    }
                },
                {
                    "id": "microbial-ch4",
                    "stacCol": "ct-ch4-monthgrid-v2025",
                    "name": "Microbial CH\u2084 Emission",
                    "type": "raster",
                    "description": "Emission of methane from all microbial sources, such as wetlands, ruminants, agriculture and termites.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "microbial",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            30
                        ]
                    },
                    "compare": {
                        "datasetId": "ct-ch4-monthgrid-v2025",
                        "layerId": "microbial-ch4",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CH\u2084/m\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 30,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "g CH\u2084/m\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("43gPa")),
                        "alt": "TM5-4DVar Isotopic CH\u2084 Inverse Fluxes - Microbial CH\u2084 Emission"
                    },
                    "parentDataset": {
                        "id": "ct-ch4-monthgrid-v2025"
                    }
                },
                {
                    "id": "fossil-ch4",
                    "stacCol": "ct-ch4-monthgrid-v2025",
                    "name": "Fossil CH\u2084 Emission",
                    "type": "raster",
                    "description": "Emission of methane from all fossil sources, such as oil and gas activities and coal mining.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "fossil",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            50
                        ]
                    },
                    "compare": {
                        "datasetId": "ct-ch4-monthgrid-v2025",
                        "layerId": "fossil-ch4",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CH\u2084/m\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 50,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "g CH\u2084/m\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("dC64Y")),
                        "alt": "TM5-4DVar Isotopic CH\u2084 Inverse Fluxes - Fossil CH\u2084 Emission"
                    },
                    "parentDataset": {
                        "id": "ct-ch4-monthgrid-v2025"
                    }
                },
                {
                    "id": "pyrogenic-ch4",
                    "stacCol": "ct-ch4-monthgrid-v2025",
                    "name": "Pyrogenic CH\u2084 Emission",
                    "type": "raster",
                    "description": "Emission of methane from all sources of biomass burning, such as wildfires and crop residue burning.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "pyrogenic",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            8
                        ]
                    },
                    "compare": {
                        "datasetId": "ct-ch4-monthgrid-v2025",
                        "layerId": "pyrogenic-ch4",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CH\u2084/m\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 8,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "g CH\u2084/m\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("gEXZk")),
                        "alt": "TM5-4DVar Isotopic CH\u2084 Inverse Fluxes - Pyrogenic CH\u2084 Emission"
                    },
                    "parentDataset": {
                        "id": "ct-ch4-monthgrid-v2025"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("b1MYl"))
    },
    "eccodarwin-co2flux-monthgrid-v5": {
        data: {
            "id": "eccodarwin-co2flux-monthgrid-v5",
            "name": "Air-Sea CO\u2082 Flux, ECCO-Darwin Model v5",
            "description": "Global, monthly average air-sea CO\u2082 flux at ~1/3\xb0 resolution from 2020 to 2022",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/eccodarwin-co2flux-monthgrid-v5.html",
                    "label": "Notebook showing data transformation to COG for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Feccodarwin-co2flux-monthgrid-v5_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://data.ghg.center/browseui/index.html#eccodarwin-co2flux-monthgrid-v5/",
                    "label": "Browse and download the data",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("2MfQD")),
                "alt": "Static rendering of oceanic currents with arrow indicators for cycle direction and strength",
                "author": {
                    "name": "NASA's Science Visualization Studio (SVS)",
                    "url": "https://svs.gsfc.nasa.gov/12629/"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "natural-emissions-and-sinks",
                            "name": "Natural Emissions and Sinks"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nasa",
                            "name": "NASA"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "model-output",
                            "name": "Model Output"
                        }
                    ]
                }
            ],
            "infoDescription": "<ul><li>Temporal Extent: January 2020 - December 2022</li><li>Temporal Resolution: Monthly</li><li>Spatial Extent: Global</li><li>Spatial Resolution: Approximately 1/3\xb0 x  1/3\xb0 (at the equator)</li><li>Data Units: Millimoles of CO\u2082 per meter squared per second (mmol m\xb2/s)</li><li>Data Type: Research</li><li>Data Latency: Updated annually</li></ul>",
            "layers": [
                {
                    "id": "air-sea-co2",
                    "stacCol": "eccodarwin-co2flux-monthgrid-v5",
                    "name": "Air-Sea CO\u2082 Flux",
                    "type": "raster",
                    "description": "Monthly mean air-sea CO\u2082 Flux (negative into ocean)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "co2",
                        "colormap_name": "bwr",
                        "rescale": [
                            -0.0007,
                            0.0002
                        ]
                    },
                    "compare": {
                        "datasetId": "eccodarwin-co2flux-monthgrid-v5",
                        "layerId": "air-sea-co2",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "mmol m\xb2/s"
                        },
                        "type": "gradient",
                        "min": -0.0007,
                        "max": 0.0007,
                        "stops": [
                            "#0000FF",
                            "#3399FF",
                            "#66CCFF",
                            "#FFFFFF",
                            "#FF66CC",
                            "#FF3399",
                            "#FF0000"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "mmol m\xb2/s"
                    },
                    "media": {
                        "src": (parcelRequire("6PoHs")),
                        "alt": "Rendered Air-Sea CO\u2082 Flux"
                    },
                    "parentDataset": {
                        "id": "eccodarwin-co2flux-monthgrid-v5"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("2qN7t"))
    },
    "emit-ch4plume-v2": {
        data: {
            "id": "emit-ch4plume-v2",
            "name": "EMIT Methane Point Source Plume Complexes",
            "description": "Methane point source plume complexes measured by the EMIT imaging spectrometer on the International Space Station (ISS)",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/emit-ch4plume-v2.html",
                    "label": "Notebook showing data transformation to COG for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/user_data_notebooks/emit-ch4plume-v2_User_Notebook.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Femit-ch4plume-v2_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://search.earthdata.nasa.gov/search/granules?p=C3242707413-LPCLOUD&pg[0][v]=f&pg[0][gsk]=-start_date&q=emit%20plume&tl=1694622854.77!3!!",
                    "label": "Download data from NASA Distributed Active Archive Center",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("5uaOo")),
                "alt": "emission from industry",
                "author": {
                    "name": "Chris Leboutillier"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "large-emission-events",
                            "name": "Large Emission Events"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nasa",
                            "name": "NASA"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "satellite-observations",
                            "name": "Satellite Observations"
                        }
                    ]
                }
            ],
            "disableExplore": true,
            "layers": [
                {
                    "id": "ch4-plume-emissions",
                    "stacCol": "emit-ch4plume-v2",
                    "name": "CH\u2084 Point Source Plume Complexes",
                    "type": "raster",
                    "description": "Methane point source plume complex extents with methane enhancements",
                    "initialDatetime": "newest",
                    "analysis": {
                        "exclude": true
                    },
                    "zoomExtent": [
                        8,
                        20
                    ],
                    "sourceParams": {
                        "resampling": "bilinear",
                        "bidx": 1,
                        "assets": "ch4-plume-emissions",
                        "colormap_name": "plasma",
                        "rescale": [
                            1,
                            1500
                        ],
                        "nodata": -9999
                    },
                    "compare": {
                        "datasetId": "emit-ch4plume-v2",
                        "layerId": "ch4-plume-emissions",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "ppm-m"
                        },
                        "type": "gradient",
                        "min": 1,
                        "max": 1500,
                        "stops": [
                            "#310597",
                            "#4c02a1",
                            "#6600a7",
                            "#7e03a8",
                            "#9511a1",
                            "#aa2395",
                            "#bc3587",
                            "#cc4778",
                            "#da5a6a",
                            "#e66c5c",
                            "#f0804e",
                            "#f89540",
                            "#fdac33",
                            "#fdc527",
                            "#f8df25"
                        ]
                    },
                    "parentDataset": {
                        "id": "emit-ch4plume-v2"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("jgdrW"))
    },
    "epa-ch4emission-yeargrid-v2express": {
        data: {
            "id": "epa-ch4emission-yeargrid-v2express",
            "name": "U.S. Gridded Anthropogenic Methane Emissions Inventory",
            "description": "Spatially disaggregated 0.1\xb0x 0.1\xb0 maps of annual U.S. anthropogenic methane emissions from over 25 emission sources, consistent with the U.S. Inventory of Greenhouse Gas Emissions and Sinks",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/epa-ch4emission-grid-v2express.html",
                    "label": "Notebook showing data transformation to COG for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Fepa-ch4emission-grid-v2express_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://data.ghg.center/browseui/index.html#epa-ch4emission-yeargrid-v2express/",
                    "label": "Browse and download the data",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("4bbT8")),
                "alt": "Total Gridded Methane Emissions from the U.S. Inventory of Greenhouse Gas Emissions and Sinks",
                "author": {
                    "name": "EPA"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "anthropogenic-emissions",
                            "name": "Anthropogenic Emissions"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "epa",
                            "name": "EPA"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "gridded-inventory",
                            "name": "Gridded Inventory"
                        }
                    ]
                }
            ],
            "sourceExclusive": "EPA",
            "infoDescription": "<ul><li>Temporal Extent: 2012 - 2020</li><li>Temporal Resolution: Annual</li><li>Spatial Extent: Contiguous United States</li><li>Spatial Resolution: 0.1\xb0 x 0.1\xb0</li><li>Data Units: Megagrams of methane per square kilometer per year (Mg CH\u2084/km\xb2/yr)</li><li>Data type: Research (v2 express extension)</li><li>Data Latency: N/A</li></ul>",
            "layers": [
                {
                    "id": "total-methane",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Total Methane (annual)",
                    "type": "raster",
                    "description": "Total annual methane emission fluxes from all Agriculture, Energy, Waste, and \u2018Other\u2019 sources included in this dataset.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "total-methane",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "total-methane",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("dNmk1")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Total Methane (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "total-agriculture",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Total Agriculture (annual)",
                    "type": "raster",
                    "description": "Total annual methane emission fluxes from Agriculture sources (sum of inventory categories 3A, 3B, 3C, 3F)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "total-agriculture",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "total-agriculture",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("9nNZ8")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Total Agriculture (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "enteric-fermentation",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Agriculture - Enteric Fermentation (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from livestock Enteric Fermentation (inventory Agriculture category 3A)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "enteric-fermentation",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "enteric-fermentation",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("js4uk")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Agriculture - Enteric Fermentation (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "manure-management",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Agriculture - Manure Management (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Manure Management (inventory Agriculture category 3B)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "manure-management",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "manure-management",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("4RK6K")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Agriculture - Manure Management (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "rice-cultivation-l",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Agriculture - Rice Cultivation (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Rice Cultivation (inventory Agriculture category 3C)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "rice-cultivation",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "rice-cultivation-l",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("sCgE2")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Agriculture - Rice Cultivation (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "field-burning-l",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Agriculture - Field Burning (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Field Burning of Agriculture Residues (inventory Agriculture category 3F)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "field-burning",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "field-burning-l",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("2tTRC")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Agriculture - Field Burning (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "total-natural-gas",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Total Natural Gas Systems (annual)",
                    "type": "raster",
                    "description": "Total annual methane emission fluxes from Natural Gas Systems (sum of inventory Energy 1B2b sub-categories)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "total-natural-gas-systems",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "total-natural-gas",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("gfbhF")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Total Natural Gas Systems (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "exploration-ngs-l",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Natural Gas - Exploration (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Natural Gas Exploration (inventory Energy 1B2b sub-category)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "exploration-ngs",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "exploration-ngs-l",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("cqBuF")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Natural Gas - Exploration (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "production-ngs-l",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Natural Gas - Production (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Natural Gas Production (inventory Energy 1B2b sub-category)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "production-ngs",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "production-ngs-l",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("5ep1x")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Natural Gas - Production (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1B2b-transmission-storage-ngs",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Natural Gas - Transmission and Storage (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Natural Gas Transmission and Storage (inventory Energy 1B2b sub-category)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "transmission-storage-ngs",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1B2b-transmission-storage-ngs",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("cfLkt")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Natural Gas - Transmission and Storage (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1B2b-processing-ngs",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Natural Gas - Processing (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Natural Gas Processing (inventory Energy 1B2b sub-category)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "processing-ngs",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1B2b-processing-ngs",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("aCviQ")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Natural Gas - Processing (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1B2b-distribution-ngs",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Natural Gas - Distribution (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Natural Gas Distribution (inventory Energy 1B2b sub-category).",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "distribution-ngs",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1B2b-distribution-ngs",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("lAp22")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Natural Gas - Distribution (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "post-meter-ng",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Natural Gas - Post-Meter (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Natural Gas Post-Meter sources (inventory Energy 1B2b sub-category)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "post-meter",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "post-meter-ng",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("9U7G1")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Natural Gas - Post-Meter (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "total-petroleum",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Total Petroleum Systems (annual)",
                    "type": "raster",
                    "description": "Total annual methane emission fluxes from Petroleum Systems (sum of inventory Energy 1B2a sub-categories)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "total-petroleum-systems",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "total-petroleum",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("lmcnE")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Total Petroleum Systems (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1B2a-exploration-ps",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Petroleum - Exploration (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Petroleum Exploration (inventory Energy 1B2a sub-category).",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "exploration-ps",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1B2a-exploration-ps",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("elwWD")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Petroleum - Exploration (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1B2a-production-ps",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Petroleum - Production (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Petroleum Production (inventory Energy 1B2a sub-category).",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "production-ps",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1B2a-production-ps",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("3gUV3")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Petroleum - Production (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1B2a-transport-ps",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Petroleum - Transportation (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Petroleum Transportation (inventory Energy 1B2a sub-category).",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "transport-ps",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1B2a-transport-ps",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("ls2Ar")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Petroleum - Transportation (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1B2a-refining-ps",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Petroleum - Refining (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Petroleum Refining (inventory Energy 1B2a sub-category).",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "refining-ps",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1B2a-refining-ps",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("fJDCc")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Petroleum - Refining (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "total-waste",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Total Waste (annual)",
                    "type": "raster",
                    "description": "Total annual methane emission fluxes from Waste (sum of inventory Waste categories 5A1, 5B1, 5D)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "total-waste",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "total-waste",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("hYQXi")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Total Waste (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "5A1-msw-landfill-waste",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Waste - Municipal Solid Waste (MSW) Landfills (annual)",
                    "type": "raster",
                    "description": "Annual methane emissions fluxes from Municipal Solid Waste Landfills (inventory Waste 5A1 sub-category).",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "msw-landfill-waste",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "5A1-msw-landfill-waste",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("3AHCb")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Waste - Municipal Solid Waste (MSW) Landfills (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "5A1-industrial-landfill-waste",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Waste - Industrial Landfills (annual)",
                    "type": "raster",
                    "description": "Annual methane emissions fluxes from Industrial Landfills (inventory Waste 5A1 sub-category).",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "industrial-landfill-waste",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "5A1-industrial-landfill-waste",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("fUdcY")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Waste - Industrial Landfills (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "5A1-dwtd-waste",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Waste - Domestic Wastewater Treatment & Discharge (annual)",
                    "type": "raster",
                    "description": "Annual methane emissions fluxes from Domestic Wastewater Treatment and Discharge (inventory Waste 5D sub-category).",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "dwtd-waste",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "5A1-dwtd-waste",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("72eUO")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Waste - Domestic Wastewater Treatment & Discharge (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "5A1-iwtd-waste",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Waste - Industrial Wastewater Treatment & Discharge (annual)",
                    "type": "raster",
                    "description": "Annual methane emissions fluxes from Industrial Wastewater Treatment and Discharge (inventory Waste 5D sub-category).",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "iwtd-waste",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "5A1-iwtd-waste",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("9b2nz")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Waste - Industrial Wastewater Treatment & Discharge (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "5A1-composting-waste",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Waste - Composting (annual)",
                    "type": "raster",
                    "description": "Annual methane emissions fluxes from Composting (inventory Waste category 5B1).",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "composting-waste",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "5A1-composting-waste",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("lpQJO")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Waste - Composting (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "total-coal-mines",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Total Coal Mines (annual)",
                    "type": "raster",
                    "description": "Total annual methane emission fluxes from Coal Mines (sum of inventory 1B1a sub-categories)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "total-coal-mines",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "total-coal-mines",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("1qgVP")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Total Coal Mines (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1B1a-underground-coal",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Coal Mining - Underground Mining (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from active Underground Coal Mining (inventory Energy 1B1a sub-category)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "underground-coal",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1B1a-underground-coal",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("ekSnQ")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Coal Mining - Underground Mining (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1B1a-abn-underground-coal",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Coal Mining - Abandoned Underground Mines (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Abandoned Underground Coal Mines (inventory Energy 1B1a sub-category)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "abn-underground-coal",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1B1a-abn-underground-coal",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("4uNr7")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Coal Mining - Abandoned Underground Mines (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1B1a-surface-coal",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Coal Mining - Surface Mining (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from active Surface Coal Mining (inventory Energy 1B1a sub-category)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "surface-coal",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1B1a-surface-coal",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("ipPXW")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Coal Mining - Surface Mining (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "total-other",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Total Other (annual)",
                    "type": "raster",
                    "description": "Total annual methane emission fluxes from \u2018other\u2019 remaining sources (sum of inventory categories 1A (energy combustion), 2B8 & 2C2 (petrochemical & ferroalloy production) and 1B2a & 1B2b (abandoned O&G well emissions))",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "total-other",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "total-other",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("hiy8Q")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Total Other (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1A-stationary-combustion-other",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Other - Stationary Combustion (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Stationary Combustion (inventory Energy 1A sub-category)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "stationary-combustion-other",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1A-stationary-combustion-other",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("fyxTE")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Other - Stationary combustion (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1A-mobile-combustion-othe",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Other - Mobile Combustion (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Mobile Combustion (inventory Energy 1A sub-category)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "mobile-combustion-other",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1A-mobile-combustion-othe",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("7hxHa")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Other - Mobile combustion (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1A-abn-ong-other",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Other - Abandoned Oil and Gas Wells (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Abandoned Oil and Gas Wells (inventory Energy 1B2a and 1B2b sub-categories)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "abn-ong-other",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1A-abn-ong-other",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("jSZhx")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Other - Abandoned Oil and Gas Wells (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1A-petro-production-other",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Other - Petrochemical Production (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Petrochemical Production (inventory Industrial Processes and Product Use category 2B8)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "petro-production-other",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ],
                        "minzoom": 0,
                        "maxzoom": 5
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1A-petro-production-other",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("jAHyQ")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Other - Petrochemical Production (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                },
                {
                    "id": "1A-ferroalloy-production-other",
                    "stacCol": "epa-ch4emission-yeargrid-v2express",
                    "name": "Other - Ferroalloy Production (annual)",
                    "type": "raster",
                    "description": "Annual methane emission fluxes from Ferroalloy Production (inventory Industrial Processes and Product Use category 2C2)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "ferroalloy-production-other",
                        "colormap_name": "epa-ghgi-ch4",
                        "rescale": [
                            0,
                            20
                        ]
                    },
                    "compare": {
                        "datasetId": "epa-ch4emission-yeargrid-v2express",
                        "layerId": "1A-ferroalloy-production-other",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "yyyy")} VS ${dateFns.format(compareDatetime, "yyyy")}`;
                        }
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "EPA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Annual",
                        "unit": "Mg CH\u2084/km\xb2/yr"
                    },
                    "legend": {
                        "unit": {
                            "label": "Mg CH\u2084/km\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 20,
                        "stops": [
                            "#FFFFFF",
                            "#6F4C9B",
                            "#6059A9",
                            "#5568B8",
                            "#4E79C5",
                            "#4D8AC6",
                            "#4E96BC",
                            "#549EB3",
                            "#59A5A9",
                            "#60AB9E",
                            "#69B190",
                            "#77B77D",
                            "#8CBC68",
                            "#A6BE54",
                            "#BEBC48",
                            "#D1B541",
                            "#DDAA3C",
                            "#E49C39",
                            "#E78C35",
                            "#E67932",
                            "#E4632D",
                            "#DF4828",
                            "#DA2222",
                            "#B8221E",
                            "#95211B",
                            "#721E17",
                            "#521A13"
                        ]
                    },
                    "media": {
                        "src": (parcelRequire("k7kwe")),
                        "alt": "U.S. Gridded Anthropogenic Methane Emissions Inventory - Other - Ferroalloy Production (annual)"
                    },
                    "parentDataset": {
                        "id": "epa-ch4emission-yeargrid-v2express"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("41HVK"))
    },
    "goes-ch4plume-v1": {
        data: {
            "id": "goes-ch4plume-v1",
            "name": "Geostationary Satellite Observations of Extreme and Transient Methane Emissions from Oil and Gas Infrastructure",
            "description": "A sample of methane plumes from point sources observed since 2019 by the U.S. Geostationary Operational Environmental Satellites (GOES) over North and South America",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/goes-ch4plume-v1.html",
                    "label": "Notebook showing data transformation to COG for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/user_data_notebooks/goes-ch4plume-v1_User_Notebook.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Fgoes-ch4plume-v1_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://data.ghg.center/browseui/#goes-ch4plume-v1/",
                    "label": "Browse and download the data",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("kB86A")),
                "alt": "colorful area expands over time showing increase in size of methane plume",
                "author": {
                    "name": "Daniel J. Varon",
                    "url": "https://www.star.nesdis.noaa.gov/star/news_20240207_methane.php"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "large-emission-events",
                            "name": "Large Emission Events"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "noaa",
                            "name": "NOAA"
                        },
                        {
                            "id": "harvard-university",
                            "name": "Harvard University"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "satellite-observations",
                            "name": "Satellite Observations"
                        }
                    ]
                }
            ],
            "disableExplore": true,
            "layers": [
                {
                    "id": "ch4-plume-emissions",
                    "stacCol": "goes-ch4plume-v1",
                    "name": "CH\u2084 Point Source Plume Complexes",
                    "type": "raster",
                    "description": "Methane point source plume complex extents with methane enhancements",
                    "initialDatetime": "newest",
                    "analysis": {
                        "exclude": true
                    },
                    "zoomExtent": [
                        8,
                        20
                    ],
                    "sourceParams": {
                        "resampling": "bilinear",
                        "bidx": 1,
                        "assets": "ch4-plume-emissions",
                        "colormap_name": "plasma",
                        "rescale": [
                            0,
                            0.4
                        ],
                        "nodata": -9999
                    },
                    "compare": {
                        "datasetId": "goes-ch4plume-v1",
                        "layerId": "ch4-plume-emissions",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "ppm-m"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 0.4,
                        "stops": [
                            "#310597",
                            "#4c02a1",
                            "#6600a7",
                            "#7e03a8",
                            "#9511a1",
                            "#aa2395",
                            "#bc3587",
                            "#cc4778",
                            "#da5a6a",
                            "#e66c5c",
                            "#f0804e",
                            "#f89540",
                            "#fdac33",
                            "#fdc527",
                            "#f8df25"
                        ]
                    },
                    "parentDataset": {
                        "id": "goes-ch4plume-v1"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("k0LI2"))
    },
    "gosat-based-ch4budget-yeargrid-v1": {
        data: {
            "id": "gosat-based-ch4budget-yeargrid-v1",
            "name": "GOSAT-based Top-down Total and Natural Methane Emissions",
            "description": "Total and wetland yearly methane emissions derived using the GEOS-Chem global chemistry transport model with inclusion of GOSAT data for 2010 to 2022 on a 4 x 5 degree (lat/lon) grid",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/gosat-based-ch4budget-yeargrid-v1.html",
                    "label": "Notebook showing data transformation to COG for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Fgosat-based-ch4budget-yeargrid-v1_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://data.ghg.center/browseui/index.html#gosat-based-ch4budget-yeargrid-v1/",
                    "label": "Browse and download the data",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("4g2c4")),
                "alt": "Dried/Burned trees",
                "author": {
                    "name": "Mark Landman",
                    "url": "https://unsplash.com/photos/S5xbizGotY0"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "natural-emissions-and-sinks",
                            "name": "Natural Emissions and Sinks"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nasa",
                            "name": "NASA"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "model-output",
                            "name": "Model Output"
                        }
                    ]
                }
            ],
            "infoDescription": "<ul><li>Temporal Extent: 2010 - 2022</li><li>Temporal Resolution: Annual</li><li>Spatial Extent: Global</li><li>Spatial Resolution: 4\xb0(latitude) x 5\xb0(longitude)</li><li>Data Units: Teragrams of methane per year (Tg CH\u2084/year)</li><li>Data Type: Research</li><li>Data Latency: Updated yearly</li></ul>",
            "layers": [
                {
                    "id": "post-total",
                    "stacCol": "gosat-based-ch4budget-yeargrid-v1",
                    "name": "Satellite-Corrected Total Methane Emissions",
                    "type": "raster",
                    "description": "Total methane emissions per grid cell derived using GOSAT data in the GEOS-Chem global chemistry transport model (posterior).",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "post-total",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            3
                        ]
                    },
                    "compare": {
                        "datasetId": "gosat-based-ch4budget-yeargrid-v1",
                        "layerId": "post-total",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "Tg CH\u2084/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 3,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "Tg CH\u2084/yr"
                    },
                    "media": {
                        "src": (parcelRequire("cPIQu")),
                        "alt": "GOSAT-based Top-down Total and Natural Methane Emissions - Posterior Total"
                    },
                    "parentDataset": {
                        "id": "gosat-based-ch4budget-yeargrid-v1"
                    }
                },
                {
                    "id": "post-wetland",
                    "stacCol": "gosat-based-ch4budget-yeargrid-v1",
                    "name": "Satellite-Corrected Wetland Methane Emissions",
                    "type": "raster",
                    "description": "Total wetland methane emissions per grid cell derived using GOSAT data in the GEOS-Chem global chemistry transport model (posterior).",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "post-wetland",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            1
                        ]
                    },
                    "compare": {
                        "datasetId": "gosat-based-ch4budget-yeargrid-v1",
                        "layerId": "post-wetland",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "Tg CH\u2084/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "Tg CH\u2084/yr"
                    },
                    "media": {
                        "src": (parcelRequire("tG87e")),
                        "alt": "GOSAT-based Top-down Total and Natural Methane Emissions - Posterior Wetlands"
                    },
                    "parentDataset": {
                        "id": "gosat-based-ch4budget-yeargrid-v1"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("eRWuO"))
    },
    "gra2pes-ghg-monthgrid-v1": {
        data: {
            "id": "gra2pes-ghg-monthgrid-v1",
            "name": "GRA\xb2PES Greenhouse Gas and Air Quality Species",
            "description": "Monthly, 0.036 degree resolution emissions of carbon dioxide (CO\u2082), carbon monoxide (CO), nitrogen oxide (NO\u2093), sulfur dioxide (SO\u2082), and particulate matter (PM2.5) emissions for the year 2021 over the Contiguous United States from the Greenhouse gas And Air Pollutants Emissions System (GRA\xb2PES)",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/gra2pes-ghg-monthgrid-v1.html",
                    "label": "Notebook showing data transformation to COG for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Fgra2pes-ghg-monthgrid-v1_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://data.ghg.center/browseui/index.html#gra2pes-ghg-monthgrid-v1/",
                    "label": "Browse and download the data",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("78tHT")),
                "alt": "Emissions from industrial area",
                "author": {
                    "name": "U.S. Greenhouse Gas Center",
                    "url": "https://drive.google.com/file/d/1J3gDUaxWD4HiKAeoLEXGsK66CwL9jN8I/view?usp=share_link"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "anthropogenic-emissions",
                            "name": "Anthropogenic Emissions"
                        },
                        {
                            "id": "urban",
                            "name": "Urban"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nist",
                            "name": "NIST"
                        },
                        {
                            "id": "noaa",
                            "name": "NOAA"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        },
                        {
                            "id": "co",
                            "name": "CO"
                        },
                        {
                            "id": "no\u2093",
                            "name": "NO\u2093"
                        },
                        {
                            "id": "so\u2082",
                            "name": "SO\u2082"
                        },
                        {
                            "id": "pm-2-5",
                            "name": "PM2.5"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "gridded-inventory",
                            "name": "Gridded Inventory"
                        }
                    ]
                }
            ],
            "sourceExclusive": "NIST",
            "infoDescription": "<ul><li>Temporal Extent: January 2021 - December 2021</li><li>Temporal Resolution: Monthly</li><li>Spatial Extent: Contiguous United States</li><li>Spatial Resolution: 0.036 x 0.036 degrees</li><li>Data Units: Metric tons per kilometer squared per month (tonne/km\xb2/month) for carbon dioxide (ffCO\u2082), carbon monoxide (CO), nitrogen oxides (NO\u2093), sulfur dioxide (SO\u2082), and particulate matter (PM2.5)</li><li>Data Type: Research</li><li>Data Latency: Updated ~annually</li></ul>",
            "layers": [
                {
                    "id": "co2",
                    "stacCol": "gra2pes-ghg-monthgrid-v1",
                    "name": "CO\u2082 Emissions",
                    "type": "raster",
                    "description": "Estimated monthly total CO\u2082 emissions across all sectors.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "co2",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            2000
                        ]
                    },
                    "compare": {
                        "datasetId": "gra2pes-ghg-monthgrid-v1",
                        "layerId": "nox",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne CO\u2082/km\xb2/month"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 2000,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Monthly",
                        "unit": "tonne CO\u2082/km\xb2/month"
                    },
                    "media": {
                        "src": (parcelRequire("7wLZR")),
                        "alt": "Rendered CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "gra2pes-ghg-monthgrid-v1"
                    }
                },
                {
                    "id": "co",
                    "stacCol": "gra2pes-ghg-monthgrid-v1",
                    "name": "CO Emissions",
                    "type": "raster",
                    "description": "Estimated monthly total carbon monoxide (CO) emissions across all sectors.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "co",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            2
                        ]
                    },
                    "compare": {
                        "datasetId": "gra2pes-ghg-monthgrid-v1",
                        "layerId": "co",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne CO/km\xb2/month"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 2,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Monthly",
                        "unit": "tonne CO/km\xb2/month"
                    },
                    "media": {
                        "src": (parcelRequire("34IAF")),
                        "alt": "Rendered CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "gra2pes-ghg-monthgrid-v1"
                    }
                },
                {
                    "id": "nox",
                    "stacCol": "gra2pes-ghg-monthgrid-v1",
                    "name": "NO\u2093 Emissions",
                    "type": "raster",
                    "description": "Estimated monthly total nitrogen oxide (NO\u2093) emissions across all sectors.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "nox",
                        "colormap_name": "greens",
                        "rescale": [
                            0,
                            2
                        ]
                    },
                    "compare": {
                        "datasetId": "gra2pes-ghg-monthgrid-v1",
                        "layerId": "nox",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne NO\u2093/km\xb2/month"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 2,
                        "stops": [
                            "#f7fcf5",
                            "#c7e9c0",
                            "#74c476",
                            "#31a354",
                            "#006d2c"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Monthly",
                        "unit": "tonne NO\u2093/km\xb2/month"
                    },
                    "media": {
                        "src": (parcelRequire("j1FVx")),
                        "alt": "Rendered CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "gra2pes-ghg-monthgrid-v1"
                    }
                },
                {
                    "id": "so2",
                    "stacCol": "gra2pes-ghg-monthgrid-v1",
                    "name": "SO\u2082 Emissions",
                    "type": "raster",
                    "description": "Estimated monthly total sulfur dioxide (SO\u2082) emissions across all sectors.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "so2",
                        "colormap_name": "blues",
                        "rescale": [
                            0,
                            0.5
                        ]
                    },
                    "compare": {
                        "datasetId": "gra2pes-ghg-monthgrid-v1",
                        "layerId": "so2",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne SO\u2082/km\xb2/month"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 0.5,
                        "stops": [
                            "#f7fbff",
                            "#c6dbef",
                            "#6baed6",
                            "#3182bd",
                            "#08519c"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Monthly",
                        "unit": "tonne SO\u2082/km\xb2/month"
                    },
                    "media": {
                        "src": (parcelRequire("csLWv")),
                        "alt": "Rendered CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "gra2pes-ghg-monthgrid-v1"
                    }
                },
                {
                    "id": "pm25",
                    "stacCol": "gra2pes-ghg-monthgrid-v1",
                    "name": "Particulate Matter (PM2.5)",
                    "type": "raster",
                    "description": "Estimated monthly total emissions of fine particulate matter (PM2.5) across all sectors.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "pm25",
                        "colormap_name": "purples",
                        "rescale": [
                            0,
                            0.2
                        ]
                    },
                    "compare": {
                        "datasetId": "gra2pes-ghg-monthgrid-v1",
                        "layerId": "pm25",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "PM2.5/km\xb2/month"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 0.2,
                        "stops": [
                            "#fcfbfd",
                            "#dadaeb",
                            "#bcbddc",
                            "#756bb1",
                            "#54278f"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Contiguous United States",
                        "temporalResolution": "Monthly",
                        "unit": "PM2.5/km\xb2/month"
                    },
                    "media": {
                        "src": (parcelRequire("2N4PA")),
                        "alt": "Rendered CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "gra2pes-ghg-monthgrid-v1"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("aLnTs"))
    },
    "influx-testbed-ghg-concentrations": {
        data: {
            "id": "influx-testbed-ghg-concentrations",
            "name": "Carbon Dioxide and Methane Concentrations from the Indianapolis Flux Experiment (INFLUX)",
            "description": "Atmospheric concentrations of carbon dioxide (CO\u2082) and methane (CH\u2084) collected at Indianapolis Flux Experiment (INFLUX) tower sites",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/influx-testbed-ghg-concentrations.html",
                    "label": "Notebook showing data transformation for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Finflux-testbed-ghg-concentrations_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://www.datacommons.psu.edu/download/meteorology/influx/influx-tower-data/wmo-x2019-scale/",
                    "label": "Browse and download data from Penn State",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("kSuvA")),
                "alt": "Roadways in Indianapolis, Indiana near a tower station estimating local greenhouse gas emissions",
                "author": {
                    "name": "Pennsylvania State University",
                    "url": "https://bpb-us-e1.wpmucdn.com/sites.psu.edu/dist/9/4276/files/2023/09/US_INC.png"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "ghg-concentrations",
                            "name": "GHG Concentrations"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        },
                        {
                            "id": "urban",
                            "name": "Urban"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "penn-state",
                            "name": "Penn State"
                        },
                        {
                            "id": "nist",
                            "name": "NIST"
                        },
                        {
                            "id": "aem-earth-networks",
                            "name": "AEM/Earth Networks"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "ground-measurements",
                            "name": "Ground Measurements"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        },
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                }
            ],
            "infoDescription": "<ul><li>Temporal Extent: January 1, 2011 - May 2, 2025</li><li>Temporal Resolution: Hourly averages</li><li>Spatial Extent: Indianapolis, Indiana, United States</li><li>Spatial Resolution: Point location samples</li><li>Data Units: Micromoles per mole of dry air (Parts CO\u2082 per million (ppm)); Nanomoles per mole of dry air (Parts CH\u2084 per billion (ppb))</li><li>Data Type: Research</li><li>Data Latency: Updated ~annually</li></ul>",
            "disableExplore": true,
            "layers": [
                {
                    "id": "influx-testbed-ghg-concentrations",
                    "stacCol": "influx-testbed-ghg-concentrations",
                    "name": "Methane Concentration (Air Sample)",
                    "type": "vector",
                    "description": "Discrete air sample measurements of methane (CH\u2084)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "influx-testbed-ghg-concentrations",
                        "colormap_name": "plasma",
                        "rescale": [
                            0,
                            1000
                        ],
                        "nodata": 0
                    },
                    "compare": {
                        "datasetId": "influx-testbed-ghg-concentrations",
                        "layerId": "influx-testbed-ghg-concentrations",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "ppb"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1000,
                        "stops": [
                            "#310597",
                            "#4c02a1",
                            "#6600a7",
                            "#7e03a8",
                            "#9511a1",
                            "#aa2395",
                            "#bc3587",
                            "#cc4778",
                            "#da5a6a",
                            "#e66c5c",
                            "#f0804e",
                            "#f89540",
                            "#fdac33",
                            "#fdc527",
                            "#f8df25"
                        ]
                    },
                    "parentDataset": {
                        "id": "influx-testbed-ghg-concentrations"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("fmeX0"))
    },
    "lam-testbed-ghg-concentrations": {
        data: {
            "id": "lam-testbed-ghg-concentrations",
            "name": "Carbon Dioxide and Methane Concentrations from the Los Angeles Megacity Carbon Project",
            "description": "Atmospheric concentrations of carbon dioxide (CO\u2082) and methane (CH\u2084) collected at NIST Urban Test Bed tower and rooftop sites in California\u2019s South Coast Air Basin",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/lam-testbed-ghg-concentrations.html",
                    "label": "Notebook showing data transformation for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Flam-testbed-ghg-concentrations_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://doi.org/10.18434/mds2-3814",
                    "label": "Browse and download data from NIST",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("a8UfC")),
                "alt": "Ground-based sensors, a satellite, and an aircraft collecting measurements of greenhouse gas emissions in the Los Angeles area",
                "author": {
                    "name": "NASA/JPL-Caltech",
                    "url": "https://www.jpl.nasa.gov"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "ghg-concentrations",
                            "name": "GHG Concentrations"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        },
                        {
                            "id": "urban",
                            "name": "Urban"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nist",
                            "name": "NIST"
                        },
                        {
                            "id": "sio",
                            "name": "SIO"
                        },
                        {
                            "id": "nasa",
                            "name": "NASA"
                        },
                        {
                            "id": "aem-earth-networks",
                            "name": "AEM/Earth Networks"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "ground-measurements",
                            "name": "Ground Measurements"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        },
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                }
            ],
            "infoDescription": "<ul><li>Temporal Extent: January 1, 2015 - January 31, 2025</li><li>Temporal Resolution: Hourly averages</li><li>Spatial Extent:California\u2019s South Coast Air Basin (includes urbanized portions of Los Angeles, Orange, Riverside, and San Bernardino counties)</li><li>Spatial Resolution: Point location samples</li><li>Data Units: Micromoles per mole of dry air (Parts CO\u2082 per million (ppm)); Nanomoles per mole of dry air (Parts CH\u2084 per billion (ppb))</li><li>Data Type: Research</li><li>Data Latency: Updated ~annually</li></ul>",
            "disableExplore": true,
            "layers": [
                {
                    "id": "lam-testbed-ghg-concentrations",
                    "stacCol": "lam-testbed-ghg-concentrations",
                    "name": "Methane Concentration (Air Sample)",
                    "type": "vector",
                    "description": "Discrete air sample measurements of methane (CH\u2084)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "lam-testbed-ghg-concentrations",
                        "colormap_name": "plasma",
                        "rescale": [
                            0,
                            1000
                        ],
                        "nodata": 0
                    },
                    "compare": {
                        "datasetId": "lam-testbed-ghg-concentrations",
                        "layerId": "lam-testbed-ghg-concentrations",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "ppb"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1000,
                        "stops": [
                            "#310597",
                            "#4c02a1",
                            "#6600a7",
                            "#7e03a8",
                            "#9511a1",
                            "#aa2395",
                            "#bc3587",
                            "#cc4778",
                            "#da5a6a",
                            "#e66c5c",
                            "#f0804e",
                            "#f89540",
                            "#fdac33",
                            "#fdc527",
                            "#f8df25"
                        ]
                    },
                    "parentDataset": {
                        "id": "lam-testbed-ghg-concentrations"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("nayFZ"))
    },
    "lpjeosim-wetlandch4-grid-v1": {
        data: {
            "id": "lpjeosim-wetlandch4-grid-v1",
            "name": "Wetland Methane Emissions, LPJ-EOSIM Model",
            "description": "Global monthly and daily 0.5 degree resolution estimates of wetland methane emissions from the LPJ-EOSIM model, version 1",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Flpjeosim-wetlandch4-grid-v1_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://search.earthdata.nasa.gov/search?q=LPJ-EOSIM",
                    "label": "Download data from NASA Distributed Active Archive Center",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("e95SA")),
                "alt": "svs visualiztion",
                "author": {
                    "name": "Mark SubbaRao (NASA/GSFC)",
                    "url": "https://svs.gsfc.nasa.gov/5054"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "natural-emissions-and-sinks",
                            "name": "Natural Emissions and Sinks"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nasa",
                            "name": "NASA"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "model-output",
                            "name": "Model Output"
                        }
                    ]
                }
            ],
            "infoDescription": "<ul><li>Temporal Extent: January 1, 1990 - ongoing</li><li>Temporal Resolution: Daily and Monthly</li><li>Spatial Extent: Global</li><li>Spatial Resolution: 0.5\xb0 x 0.5\xb0</li><li>Data Units: Kilograms of methane per meter squared per second (kg CH\u2084/m\xb2/s)</li><li>Data Type: Research</li><li>Data Latency: Updated once every two months</li></ul>",
            "layers": [
                {
                    "id": "ch4-wetlands-emissions-m-ens",
                    "stacCol": "lpjeosim-wetlandch4-monthgrid-v1",
                    "name": "(Monthly) Ensemble Mean Wetland CH\u2084 Emissions LPJ-EOSIM Model",
                    "type": "raster",
                    "description": "Monthly CH\u2084 emissions from wetlands constructed using an ensemble of climate forcing data sources input to the LPJ-EOSIM model (mean of ERA5 and MERRA-2 layers)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "ensemble-mean-ch4-wetlands-emissions",
                        "colormap_name": "magma",
                        "rescale": [
                            0,
                            3e-9
                        ]
                    },
                    "compare": {
                        "datasetId": "lpjeosim-wetlandch4-grid-v1",
                        "layerId": "ch4-wetlands-emissions-m-ens",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "kg CH\u2084/m\xb2/s"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 3e-9,
                        "stops": [
                            "#2c115f",
                            "#721f81",
                            "#b73779",
                            "#f1605d",
                            "#feb078"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "kg CH\u2084/m\xb2/s"
                    },
                    "parentDataset": {
                        "id": "lpjeosim-wetlandch4-grid-v1"
                    }
                },
                {
                    "id": "ch4-wetlands-emissions-d-ens",
                    "stacCol": "lpjeosim-wetlandch4-daygrid-v1",
                    "name": "(Daily) Ensemble Mean Wetland CH\u2084 Emissions LPJ-EOSIM Model",
                    "type": "raster",
                    "description": "Daily CH\u2084 emissions from wetlands constructed using an ensemble of climate forcing data sources input to the LPJ-EOSIM model (mean of ERA5 and MERRA-2 layers)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "ensemble-mean-ch4-wetlands-emissions",
                        "colormap_name": "magma",
                        "rescale": [
                            0,
                            3e-9
                        ]
                    },
                    "compare": {
                        "datasetId": "lpjeosim-wetlandch4-grid-v1",
                        "layerId": "ch4-wetlands-emissions-d-ens",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "kg CH\u2084/m\xb2/s"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 3e-9,
                        "stops": [
                            "#2c115f",
                            "#721f81",
                            "#b73779",
                            "#f1605d",
                            "#feb078"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Daily",
                        "unit": "kg CH\u2084/m\xb2/s"
                    },
                    "parentDataset": {
                        "id": "lpjeosim-wetlandch4-grid-v1"
                    }
                },
                {
                    "id": "ch4-wetlands-emissions-m-era",
                    "stacCol": "lpjeosim-wetlandch4-monthgrid-v1",
                    "name": "(Monthly) (ERA5) Wetland CH\u2084 Emissions LPJ-EOSIM Model",
                    "type": "raster",
                    "description": "Monthly CH\u2084 from wetlands constructed using ERA5 climate forcing data input to the LPJ-EOSIM model",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "era5-ch4-wetlands-emissions",
                        "colormap_name": "magma",
                        "rescale": [
                            0,
                            3e-9
                        ]
                    },
                    "compare": {
                        "datasetId": "lpjeosim-wetlandch4-grid-v1",
                        "layerId": "ch4-wetlands-emissions-m-era",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "kg CH\u2084/m\xb2/s"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 3e-9,
                        "stops": [
                            "#2c115f",
                            "#721f81",
                            "#b73779",
                            "#f1605d",
                            "#feb078"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "kg CH\u2084/m\xb2/s"
                    },
                    "parentDataset": {
                        "id": "lpjeosim-wetlandch4-grid-v1"
                    }
                },
                {
                    "id": "ch4-wetlands-emissions-d-era",
                    "stacCol": "lpjeosim-wetlandch4-daygrid-v1",
                    "name": "(Daily) (ERA5) Wetland CH\u2084 Emissions LPJ-EOSIM Model",
                    "type": "raster",
                    "description": "Daily CH\u2084 from wetlands constructed using ERA5 climate forcing data input to the LPJ-EOSIM model",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "era5-ch4-wetlands-emissions",
                        "colormap_name": "magma",
                        "rescale": [
                            0,
                            3e-9
                        ]
                    },
                    "compare": {
                        "datasetId": "lpjeosim-wetlandch4-grid-v1",
                        "layerId": "ch4-wetlands-emissions-d-era",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "kg CH\u2084/m\xb2/s"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 3e-9,
                        "stops": [
                            "#2c115f",
                            "#721f81",
                            "#b73779",
                            "#f1605d",
                            "#feb078"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Daily",
                        "unit": "kg CH\u2084/m\xb2/s"
                    },
                    "parentDataset": {
                        "id": "lpjeosim-wetlandch4-grid-v1"
                    }
                },
                {
                    "id": "ch4-wetlands-emissions-m-merra",
                    "stacCol": "lpjeosim-wetlandch4-monthgrid-v1",
                    "name": "(Monthly) (MERRA-2) Wetland CH\u2084 Emissions LPJ-EOSIM Model",
                    "type": "raster",
                    "description": "Monthly CH\u2084 emissions from wetlands constructed using MERRA-2 climate forcing data input to the LPJ-EOSIM model",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "merra2-ch4-wetlands-emissions",
                        "colormap_name": "magma",
                        "rescale": [
                            0,
                            3e-9
                        ]
                    },
                    "compare": {
                        "datasetId": "lpjeosim-wetlandch4-grid-v1",
                        "layerId": "ch4-wetlands-emissions-m-merra",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "kg CH\u2084/m\xb2/s"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 3e-9,
                        "stops": [
                            "#2c115f",
                            "#721f81",
                            "#b73779",
                            "#f1605d",
                            "#feb078"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "kg CH\u2084/m\xb2/s"
                    },
                    "parentDataset": {
                        "id": "lpjeosim-wetlandch4-grid-v1"
                    }
                },
                {
                    "id": "ch4-wetlands-emissions-d-merra",
                    "stacCol": "lpjeosim-wetlandch4-daygrid-v1",
                    "name": "(Daily) (MERRA-2) Wetland CH\u2084 Emissions LPJ-EOSIM Model",
                    "type": "raster",
                    "description": "Daily CH\u2084 emissions from wetlands constructed using MERRA-2 climate forcing data input to the LPJ-EOSIM model",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "merra2-ch4-wetlands-emissions",
                        "colormap_name": "magma",
                        "rescale": [
                            0,
                            3e-9
                        ]
                    },
                    "compare": {
                        "datasetId": "lpjeosim-wetlandch4-grid-v1",
                        "layerId": "ch4-wetlands-emissions-d-merra",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "kg CH\u2084/m\xb2/s"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 3e-9,
                        "stops": [
                            "#2c115f",
                            "#721f81",
                            "#b73779",
                            "#f1605d",
                            "#feb078"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Daily",
                        "unit": "kg CH\u2084/m\xb2/s"
                    },
                    "parentDataset": {
                        "id": "lpjeosim-wetlandch4-grid-v1"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("28eVC"))
    },
    "micasa-carbonflux-grid-v1": {
        data: {
            "id": "micasa-carbonflux-grid-v1",
            "name": "MiCASA Land Carbon Flux",
            "description": "Global, daily and monthly mean 0.1 degree resolution carbon fluxes from net primary production (NPP), heterotrophic respiration (Rh), wildfire emissions (FIRE), fuel wood burning emissions (FUEL), net ecosystem exchange (NEE), and net biosphere exchange (NBE) derived from the MiCASA model, version 1",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Fmicasa-carbonflux-daygrid-v1_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://data.ghg.center/browseui/index.html#micasa-carbonflux-daygrid-v1/",
                    "label": "Browse and download the data",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("5p4Mz")),
                "alt": "wildfire",
                "author": {
                    "name": "Marcus Kauffman"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "natural-emissions-and-sinks",
                            "name": "Natural Emissions and Sinks"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nasa",
                            "name": "NASA"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "model-output",
                            "name": "Model Output"
                        }
                    ]
                }
            ],
            "infoDescription": "<ul><li>Temporal Extent: January 1, 2001 - Ongoing</li><li>Temporal Resolution: Daily and Monthly Averages</li><li>Spatial Extent: Global</li><li>Spatial Resolution: 0.1\xb0 x 0.1\xb0</li><li>Data Units: Grams of Carbon per square meter per day (g Carbon/m\xb2/day)</li><li>Data Type: Research</li><li>Data Latency: Less than a year, typically 6 months</li></ul>",
            "layers": [
                {
                    "id": "micasa-co2-flux-npp-m",
                    "stacCol": "micasa-carbonflux-monthgrid-v1",
                    "name": "(Monthly Mean) Net Primary Production (NPP)",
                    "type": "raster",
                    "description": "Model-estimated net primary production (NPP), which is the rate at which plants produce and store carbon that is available to the ecosystem (biomass increase)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "npp",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            8
                        ],
                        "tile_scale": 3
                    },
                    "compare": {
                        "datasetId": "micasa-carbonflux-grid-v1",
                        "layerId": "micasa-co2-flux-npp-m",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g Carbon/m\xb2/day"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 8,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "g Carbon/m\xb2/day"
                    },
                    "parentDataset": {
                        "id": "micasa-carbonflux-grid-v1"
                    }
                },
                {
                    "id": "micasa-co2-flux-npp",
                    "stacCol": "micasa-carbonflux-daygrid-v1",
                    "name": "(Daily) Net Primary Production (NPP)",
                    "type": "raster",
                    "description": "Model-estimated net primary production (NPP), which is the rate at which plants produce and store carbon that is available to the ecosystem (biomass increase)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "npp",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            8
                        ],
                        "tile_scale": 3
                    },
                    "compare": {
                        "datasetId": "micasa-carbonflux-grid-v1",
                        "layerId": "micasa-co2-flux-npp",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g Carbon/m\xb2/day"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 8,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Daily",
                        "unit": "g Carbon/m\xb2/day"
                    },
                    "parentDataset": {
                        "id": "micasa-carbonflux-grid-v1"
                    }
                },
                {
                    "id": "micasa-co2-flux-hr-m",
                    "stacCol": "micasa-carbonflux-monthgrid-v1",
                    "name": "(Monthly Mean) Heterotrophic Respiration (Rh)",
                    "type": "raster",
                    "description": "Model-estimated heterotrophic respiration (Rh), which is the flux of carbon from the soil to the atmosphere",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "rh",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            8
                        ],
                        "tile_scale": 3
                    },
                    "compare": {
                        "datasetId": "micasa-carbonflux-grid-v1",
                        "layerId": "micasa-co2-flux-hr-m",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g Carbon/m\xb2/day"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 8,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "g Carbon/m\xb2/day"
                    },
                    "parentDataset": {
                        "id": "micasa-carbonflux-grid-v1"
                    }
                },
                {
                    "id": "micasa-co2-flux-hr",
                    "stacCol": "micasa-carbonflux-daygrid-v1",
                    "name": "(Daily) Heterotrophic Respiration (Rh)",
                    "type": "raster",
                    "description": "Model-estimated heterotrophic respiration (Rh), which is the flux of carbon from the soil to the atmosphere",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "rh",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            8
                        ],
                        "tile_scale": 3
                    },
                    "compare": {
                        "datasetId": "micasa-carbonflux-grid-v1",
                        "layerId": "micasa-co2-flux-hr",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g Carbon/m\xb2/day"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 8,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Daily",
                        "unit": "g Carbon/m\xb2/day"
                    },
                    "parentDataset": {
                        "id": "micasa-carbonflux-grid-v1"
                    }
                },
                {
                    "id": "micasa-co2-flux-nee-m",
                    "stacCol": "micasa-carbonflux-monthgrid-v1",
                    "name": "(Monthly Mean) Net Ecosystem Exchange (NEE)",
                    "type": "raster",
                    "description": "Model-estimated net ecosystem exchange (NEE), which is the net carbon flux to the atmosphere from the ecosystem (Rh - NPP)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "nee",
                        "colormap_name": "coolwarm",
                        "rescale": [
                            -4,
                            4
                        ],
                        "tile_scale": 3
                    },
                    "compare": {
                        "datasetId": "micasa-carbonflux-grid-v1",
                        "layerId": "micasa-co2-flux-nee-m",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g Carbon/m\xb2/day"
                        },
                        "type": "gradient",
                        "min": -4,
                        "max": 4,
                        "stops": [
                            "#3B4CC0",
                            "#6788EE",
                            "#9ABBFF",
                            "#C9D7F0",
                            "#EDD1C2",
                            "#F7A889",
                            "#E26952",
                            "#B40426"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "g Carbon/m\xb2/day"
                    },
                    "parentDataset": {
                        "id": "micasa-carbonflux-grid-v1"
                    }
                },
                {
                    "id": "micasa-co2-flux-nee",
                    "stacCol": "micasa-carbonflux-daygrid-v1",
                    "name": "(Daily) Net Ecosystem Exchange (NEE)",
                    "type": "raster",
                    "description": "Model-estimated net ecosystem exchange (NEE), which is the net carbon flux to the atmosphere from the ecosystem (Rh - NPP)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "nee",
                        "colormap_name": "coolwarm",
                        "rescale": [
                            -4,
                            4
                        ],
                        "tile_scale": 3
                    },
                    "compare": {
                        "datasetId": "micasa-carbonflux-grid-v1",
                        "layerId": "micasa-co2-flux-nee",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g Carbon/m\xb2/day"
                        },
                        "type": "gradient",
                        "min": -4,
                        "max": 4,
                        "stops": [
                            "#3B4CC0",
                            "#6788EE",
                            "#9ABBFF",
                            "#C9D7F0",
                            "#EDD1C2",
                            "#F7A889",
                            "#E26952",
                            "#B40426"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Daily",
                        "unit": "g Carbon/m\xb2/day"
                    },
                    "parentDataset": {
                        "id": "micasa-carbonflux-grid-v1"
                    }
                },
                {
                    "id": "micasa-co2-flux-nbe-m",
                    "stacCol": "micasa-carbonflux-monthgrid-v1",
                    "name": "(Monthly Mean) Net Biosphere Exchange (NBE)",
                    "type": "raster",
                    "description": "Model-estimated net biosphere exchange (NBE), which is the net carbon flux to the atmosphere from the ecosystem, taking into account wildfire and wood fuel burning sources of carbon (Rh + FIRE + FUEL - NPP)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "nbe",
                        "colormap_name": "coolwarm",
                        "rescale": [
                            -4,
                            4
                        ],
                        "tile_scale": 3
                    },
                    "compare": {
                        "datasetId": "micasa-carbonflux-grid-v1",
                        "layerId": "micasa-co2-flux-nbe-m",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g Carbon/m\xb2/day"
                        },
                        "type": "gradient",
                        "min": -4,
                        "max": 4,
                        "stops": [
                            "#3B4CC0",
                            "#6788EE",
                            "#9ABBFF",
                            "#C9D7F0",
                            "#EDD1C2",
                            "#F7A889",
                            "#E26952",
                            "#B40426"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "g Carbon/m\xb2/day"
                    },
                    "parentDataset": {
                        "id": "micasa-carbonflux-grid-v1"
                    }
                },
                {
                    "id": "micasa-co2-flux-nbe",
                    "stacCol": "micasa-carbonflux-daygrid-v1",
                    "name": "(Daily) Net Biosphere Exchange (NBE)",
                    "type": "raster",
                    "description": "Model-estimated net biosphere exchange (NBE), which is the net carbon flux to the atmosphere from the ecosystem, taking into account wildfire and wood fuel burning sources of carbon (Rh + FIRE + FUEL - NPP)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "nee",
                        "colormap_name": "coolwarm",
                        "rescale": [
                            -4,
                            4
                        ],
                        "tile_scale": 3
                    },
                    "compare": {
                        "datasetId": "micasa-carbonflux-grid-v1",
                        "layerId": "micasa-co2-flux-nbe",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g Carbon/m\xb2/day"
                        },
                        "type": "gradient",
                        "min": -4,
                        "max": 4,
                        "stops": [
                            "#3B4CC0",
                            "#6788EE",
                            "#9ABBFF",
                            "#C9D7F0",
                            "#EDD1C2",
                            "#F7A889",
                            "#E26952",
                            "#B40426"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Daily",
                        "unit": "g Carbon/m\xb2/day"
                    },
                    "parentDataset": {
                        "id": "micasa-carbonflux-grid-v1"
                    }
                },
                {
                    "id": "micasa-co2-flux-fe-m",
                    "stacCol": "micasa-carbonflux-monthgrid-v1",
                    "name": "(Monthly Mean) Fire Emissions (FIRE)",
                    "type": "raster",
                    "description": "Model-estimated flux of carbon to the atmosphere from wildfires",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "fire",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            8
                        ],
                        "tile_scale": 3
                    },
                    "compare": {
                        "datasetId": "micasa-carbonflux-grid-v1",
                        "layerId": "micasa-co2-flux-fe-m",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g Carbon/m\xb2/day"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 8,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "g Carbon/m\xb2/day"
                    },
                    "parentDataset": {
                        "id": "micasa-carbonflux-grid-v1"
                    }
                },
                {
                    "id": "micasa-co2-flux-fe",
                    "stacCol": "micasa-carbonflux-daygrid-v1",
                    "name": "(Daily) Fire Emissions (FIRE)",
                    "type": "raster",
                    "description": "Model-estimated flux of carbon to the atmosphere from wildfires",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "fire",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            8
                        ],
                        "tile_scale": 3
                    },
                    "compare": {
                        "datasetId": "micasa-carbonflux-grid-v1",
                        "layerId": "micasa-co2-flux-fe",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g Carbon/m\xb2/day"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 8,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Daily",
                        "unit": "g Carbon/m\xb2/day"
                    },
                    "parentDataset": {
                        "id": "micasa-carbonflux-grid-v1"
                    }
                },
                {
                    "id": "micasa-co2-flux-fuel-m",
                    "stacCol": "micasa-carbonflux-monthgrid-v1",
                    "name": "(Monthly Mean) Wood Fuel Emissions (FUEL)",
                    "type": "raster",
                    "description": "Model-estimated flux of carbon to the atmosphere from wood burned for fuel",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "fuel",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            0.5
                        ],
                        "tile_scale": 3
                    },
                    "compare": {
                        "datasetId": "micasa-carbonflux-grid-v1",
                        "layerId": "micasa-co2-flux-fuel-m",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g Carbon/m\xb2/day"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 0.5,
                        "stops": [
                            "#F7FCFD",
                            "#DCE9F2",
                            "#B5CCE3",
                            "#96ACD2",
                            "#8C7DBA",
                            "#894DA3",
                            "#821580",
                            "#4D004B"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "g Carbon/m\xb2/day"
                    },
                    "parentDataset": {
                        "id": "micasa-carbonflux-grid-v1"
                    }
                },
                {
                    "id": "micasa-co2-flux-fuel",
                    "stacCol": "micasa-carbonflux-daygrid-v1",
                    "name": "(Daily) Wood Fuel Emissions (FUEL)",
                    "type": "raster",
                    "description": "Model-estimated flux of carbon to the atmosphere from wood burned for fuel",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "fuel",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            0.5
                        ],
                        "tile_scale": 3
                    },
                    "compare": {
                        "datasetId": "micasa-carbonflux-grid-v1",
                        "layerId": "micasa-co2-flux-fuel",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g Carbon/m\xb2/day"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 0.5,
                        "stops": [
                            "#F7FCFD",
                            "#DCE9F2",
                            "#B5CCE3",
                            "#96ACD2",
                            "#8C7DBA",
                            "#894DA3",
                            "#821580",
                            "#4D004B"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Daily",
                        "unit": "g Carbon/m\xb2/day"
                    },
                    "parentDataset": {
                        "id": "micasa-carbonflux-grid-v1"
                    }
                },
                {
                    "id": "micasa-co2-atmc-m",
                    "stacCol": "micasa-carbonflux-monthgrid-v1",
                    "name": "(Monthly Mean) Atmospheric Correction (ATMC)",
                    "type": "raster",
                    "description": "A correction to account for long-term historical changes in the uptake of CO\u2082 from the atmosphere to the biosphere",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "atmc",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            8
                        ],
                        "tile_scale": 3
                    },
                    "compare": {
                        "datasetId": "micasa-carbonflux-grid-v1",
                        "layerId": "micasa-co2-atmc-m",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g Carbon/m\xb2/day"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 8,
                        "stops": [
                            "#F7FCFD",
                            "#DCE9F2",
                            "#B5CCE3",
                            "#96ACD2",
                            "#8C7DBA",
                            "#894DA3",
                            "#821580",
                            "#4D004B"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "g Carbon/m\xb2/day"
                    },
                    "parentDataset": {
                        "id": "micasa-carbonflux-grid-v1"
                    }
                },
                {
                    "id": "micasa-co2-atmc",
                    "stacCol": "micasa-carbonflux-daygrid-v1",
                    "name": "(Daily) Atmospheric Correction (ATMC)",
                    "type": "raster",
                    "description": "A correction to account for long-term historical changes in the uptake of CO\u2082 from the atmosphere to the biosphere",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "atmc",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            8
                        ],
                        "tile_scale": 3
                    },
                    "compare": {
                        "datasetId": "micasa-carbonflux-grid-v1",
                        "layerId": "micasa-co2-atmc",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g Carbon/m\xb2/day"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 8,
                        "stops": [
                            "#F7FCFD",
                            "#DCE9F2",
                            "#B5CCE3",
                            "#96ACD2",
                            "#8C7DBA",
                            "#894DA3",
                            "#821580",
                            "#4D004B"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Daily",
                        "unit": "g Carbon/m\xb2/day"
                    },
                    "parentDataset": {
                        "id": "micasa-carbonflux-grid-v1"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("dcKo5"))
    },
    "nec-testbed-ghg-concentrations": {
        data: {
            "id": "nec-testbed-ghg-concentrations",
            "name": "Carbon Dioxide and Methane Concentrations from the Northeast Corridor (NEC) Urban Test Bed",
            "description": "Atmospheric concentrations of carbon dioxide (CO\u2082) and methane (CH\u2084) collected at NIST Urban Test Bed tower sites in the Northeastern U.S.",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/nec-testbed-ghg-concentrations.html",
                    "label": "Notebook showing data transformation for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Fnec-testbed-ghg-concentrations_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://doi.org/10.18434/mds2-3765 ",
                    "label": "Browse and download data from NIST",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("dUXEf")),
                "alt": "Smoke",
                "author": {
                    "name": "Chris Leboutillier",
                    "url": "https://unsplash.com/photos/a-large-plume-of-smoke-coming-out-of-a-pipe-NmT8Nk8OJMg"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "ghg-concentrations",
                            "name": "GHG Concentrations"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        },
                        {
                            "id": "urban",
                            "name": "Urban"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nist",
                            "name": "NIST"
                        },
                        {
                            "id": "aem-earth-networks",
                            "name": "AEM/Earth Networks"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "ground-measurements",
                            "name": "Ground Measurements"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        },
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                }
            ],
            "infoDescription": "<ul><li>Temporal Extent: January 1, 2015 - January 31, 2025</li><li>Temporal Resolution: Hourly averages</li><li>Spatial Extent: Northeastern United States (86.20 W, 70.49 W, 43.71 N, 35.20 N)</li><li>Spatial Resolution: Point location samples</li><li>Data Units: Micromoles per mole of dry air (Parts CO\u2082 per million (ppm)); Nanomoles per mole of dry air (Parts CH\u2084 per billion (ppb))</li><li>Data Type: Research</li><li>Data Latency: Updated ~annually</li></ul>",
            "disableExplore": true,
            "layers": [
                {
                    "id": "nec-testbed-ghg-concentrations",
                    "stacCol": "nec-testbed-ghg-concentrations",
                    "name": "Methane Concentration (Air Sample)",
                    "type": "vector",
                    "description": "Discrete air sample measurements of methane (CH\u2084)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "nec-testbed-ghg-concentrations",
                        "colormap_name": "plasma",
                        "rescale": [
                            0,
                            1000
                        ],
                        "nodata": 0
                    },
                    "compare": {
                        "datasetId": "nec-testbed-ghg-concentrations",
                        "layerId": "nec-testbed-ghg-concentrations",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "ppb"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1000,
                        "stops": [
                            "#310597",
                            "#4c02a1",
                            "#6600a7",
                            "#7e03a8",
                            "#9511a1",
                            "#aa2395",
                            "#bc3587",
                            "#cc4778",
                            "#da5a6a",
                            "#e66c5c",
                            "#f0804e",
                            "#f89540",
                            "#fdac33",
                            "#fdc527",
                            "#f8df25"
                        ]
                    },
                    "parentDataset": {
                        "id": "nec-testbed-ghg-concentrations"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("lCNdd"))
    },
    "noaa-gggrn-ch4-concentrations": {
        data: {
            "id": "noaa-gggrn-ch4-concentrations",
            "name": "Atmospheric Methane Concentrations from the NOAA Global Monitoring Laboratory",
            "description": "Atmospheric concentrations of methane (CH\u2084) collected since 1976 at globally distributed surface sites",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/noaa-gggrn-concentrations.html",
                    "label": "Notebook showing data transformation for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://gml.noaa.gov/dv/data/index.php?category=Greenhouse%252BGases&parameter_name=Methane",
                    "label": "Download data from NOAA",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("jF1yB")),
                "alt": "aa",
                "author": {
                    "name": "Columbia University"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "ghg-concentrations",
                            "name": "GHG Concentrations"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "noaa",
                            "name": "NOAA"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "ground-measurements",
                            "name": "Ground Measurements"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                }
            ],
            "infoDescription": "<ul><li>Temporal Extent: 1976 - 2024, varies by station</li><li>Temporal Resolution:  Irregular, varies by station</li><li>Spatial Extent: United States</li><li>Spatial Resolution: Point location samples</li><li>Data Units: Parts CH\u2084 per billion (ppb)</li><li>Data Type: Operational</li><li>Data Latency: Updated annually</li></ul>",
            "disableExplore": true,
            "layers": [
                {
                    "id": "noaa-gggrn-ch4-concentrations",
                    "stacCol": "noaa-gggrn-ch4-concentrations",
                    "name": "Methane Concentration (Air Sample)",
                    "type": "vector",
                    "description": "Discrete air sample measurements of methane (CH\u2084)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "noaa-gggrn-ch4-concentrations",
                        "colormap_name": "plasma",
                        "rescale": [
                            0,
                            1000
                        ],
                        "nodata": 0
                    },
                    "compare": {
                        "datasetId": "noaa-gggrn-ch4-concentrations",
                        "layerId": "noaa-gggrn-ch4-concentrations",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "ppb"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1000,
                        "stops": [
                            "#310597",
                            "#4c02a1",
                            "#6600a7",
                            "#7e03a8",
                            "#9511a1",
                            "#aa2395",
                            "#bc3587",
                            "#cc4778",
                            "#da5a6a",
                            "#e66c5c",
                            "#f0804e",
                            "#f89540",
                            "#fdac33",
                            "#fdc527",
                            "#f8df25"
                        ]
                    },
                    "parentDataset": {
                        "id": "noaa-gggrn-ch4-concentrations"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("4oleC"))
    },
    "noaa-gggrn-co2-concentrations": {
        data: {
            "id": "noaa-gggrn-co2-concentrations",
            "name": "Atmospheric Carbon Dioxide Concentrations from the NOAA Global Monitoring Laboratory",
            "description": "Atmospheric concentrations of carbon dioxide (CO\u2082) collected since 1968 at globally distributed surface sites",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/noaa-gggrn-concentrations.html",
                    "label": "Notebook showing data transformation for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://gml.noaa.gov/dv/data/index.php?parameter_name=Carbon%2BDioxide",
                    "label": "Download data from NOAA",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("jF1yB")),
                "alt": "aa",
                "author": {
                    "name": "Columbia University"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "ghg-concentrations",
                            "name": "GHG Concentrations"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "noaa",
                            "name": "NOAA"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "ground-measurements",
                            "name": "Ground Measurements"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        }
                    ]
                }
            ],
            "infoDescription": "<ul><li>Temporal Extent: 1967 - ongoing, varies by station</li><li>Temporal Resolution:  Varies by station, can be daily up to weekly</li><li>Spatial Extent: United States</li><li>Spatial Resolution: Point location samples</li><li>Data Units: parts CO\u2082 per million (ppm)</li><li>Data Type: Operational</li><li>Data Latency: Quality-controlled data updated annually</li></ul>",
            "disableExplore": true,
            "layers": [
                {
                    "id": "noaa-gggrn-co2-concentrations",
                    "stacCol": "noaa-gggrn-co2-concentrations",
                    "name": "Carbon Dioxide (Air Sample)",
                    "type": "vector",
                    "description": "Atmospheric concentrations of carbon dioxide (CO\u2082) from discrete air samples collected since 1968 at globally distributed surface sites",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "noaa-gggrn-co2-concentrations",
                        "colormap_name": "plasma",
                        "rescale": [
                            0,
                            1000
                        ],
                        "nodata": 0
                    },
                    "compare": {
                        "datasetId": "noaa-gggrn-co2-concentrations",
                        "layerId": "noaa-gggrn-co2-concentrations",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "ppm"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1000,
                        "stops": [
                            "#310597",
                            "#4c02a1",
                            "#6600a7",
                            "#7e03a8",
                            "#9511a1",
                            "#aa2395",
                            "#bc3587",
                            "#cc4778",
                            "#da5a6a",
                            "#e66c5c",
                            "#f0804e",
                            "#f89540",
                            "#fdac33",
                            "#fdc527",
                            "#f8df25"
                        ]
                    },
                    "parentDataset": {
                        "id": "noaa-gggrn-co2-concentrations"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("4yB3w"))
    },
    "oco2-mip-co2budget-yeargrid-v1": {
        data: {
            "id": "oco2-mip-co2budget-yeargrid-v1",
            "name": "OCO-2 MIP Top-down CO\u2082 Budgets",
            "description": "Annual carbon dioxide emissions and removals on a 1\xb0 resolution global grid from 2015-2020, version 1",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/oco2-mip-co2budget-yeargrid-v1.html",
                    "label": "Notebook showing data transformation to COG for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Foco2-mip-co2budget-yeargrid-v1_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://data.ghg.center/browseui/index.html#oco2-mip-co2budget-yeargrid-v1/",
                    "label": "Browse and download the data",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("cuaQM")),
                "alt": "mean net emissions and removals of carbon dioxide",
                "author": {
                    "name": "NASA/JPL",
                    "url": "https://www.jpl.nasa.gov/news/nasa-space-mission-takes-stock-of-carbon-dioxide-emissions-by-countries"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "anthropogenic-emissions",
                            "name": "Anthropogenic Emissions"
                        },
                        {
                            "id": "natural-emissions-and-sinks",
                            "name": "Natural Emissions and Sinks"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nasa",
                            "name": "NASA"
                        },
                        {
                            "id": "noaa",
                            "name": "NOAA"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "model-output",
                            "name": "Model Output"
                        }
                    ]
                }
            ],
            "infoDescription": "<ul><li>Temporal Extent: 2015 \u2013 2020</li><li>Temporal Resolution: Annual</li><li>Spatial Extent: Global</li><li>Spatial Resolution:  1\xb0 x 1\xb0</li><li>Data Units: Grams of carbon dioxide per square meter per year (g CO\u2082/m\xb2/yr)</li><li>Data Type: Research</li><li>Data Latency: N/A</li></ul>",
            "layers": [
                {
                    "id": "co2-emissions-lnlgis-nbe",
                    "stacCol": "oco2-mip-co2budget-yeargrid-v1",
                    "name": "LNLGIS Net Biosphere Exchange (LNLGIS_NBE)",
                    "type": "raster",
                    "description": "CO\u2082 emissions from net flux of carbon from terrestrial biosphere to atmosphere (net biosphere exchange) estimated from the OCO-2 v10 MIP LNLGIS ensemble",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "lnlgis-nbe",
                        "colormap_name": "coolwarm",
                        "rescale": [
                            -1200,
                            1200
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2-mip-co2budget-yeargrid-v1",
                        "layerId": "co2-emissions-lnlgis-nbe",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CO\u2082/m\xb2/yr"
                        },
                        "type": "gradient",
                        "min": -1200,
                        "max": 1200,
                        "stops": [
                            "#3B4CC0",
                            "#5D7CE6",
                            "#82A6FB",
                            "#AAC7FD",
                            "#CDD9EC",
                            "#EAD4C8",
                            "#F7B89C",
                            "#F18D6F",
                            "#D95847",
                            "#B40426"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "g CO\u2082/m\xb2/yr"
                    },
                    "media": {
                        "src": (parcelRequire("g2WoW")),
                        "alt": "OCO-2 MIP Top-down CO\u2082 Budgets - LNLGIS Net Biosphere Exchange (LNLGIS_NBE)"
                    },
                    "parentDataset": {
                        "id": "oco2-mip-co2budget-yeargrid-v1"
                    }
                },
                {
                    "id": "co2-emissions-lnlgis-nbe-std",
                    "stacCol": "oco2-mip-co2budget-yeargrid-v1",
                    "name": "Uncertainty - LNLGIS Net Biosphere Exchange (LNLGIS_NBE_std)",
                    "type": "raster",
                    "description": "Uncertainty in CO\u2082 emissions from net flux of carbon from terrestrial biosphere to atmosphere (net biosphere exchange) estimated from the OCO-2 v10 MIP LNLGIS ensemble",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "lnlgis-nbe-std",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            1000
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2-mip-co2budget-yeargrid-v1",
                        "layerId": "co2-emissions-lnlgis-nbe-std",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CO\u2082/m\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 300,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "g CO\u2082/m\xb2/yr"
                    },
                    "media": {
                        "src": (parcelRequire("4IQQB")),
                        "alt": "OCO-2 MIP Top-down CO\u2082 Budgets - Uncertainty - LNLGIS Net Biosphere Exchange (LNLGIS_NBE_std)"
                    },
                    "parentDataset": {
                        "id": "oco2-mip-co2budget-yeargrid-v1"
                    }
                },
                {
                    "id": "co2-emissions-lnlgis-nce",
                    "stacCol": "oco2-mip-co2budget-yeargrid-v1",
                    "name": "LNLGIS Net Carbon Exchange (LNLGIS_NCE)",
                    "type": "raster",
                    "description": "CO\u2082 emissions from net flux of carbon from surface to atmosphere (net carbon exchange) estimated from the OCO-2 v10 MIP LNLGIS ensemble",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "lnlgis-nce",
                        "colormap_name": "coolwarm",
                        "rescale": [
                            -1200,
                            1200
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2-mip-co2budget-yeargrid-v1",
                        "layerId": "co2-emissions-lnlgis-nce",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CO\u2082/m\xb2/yr"
                        },
                        "type": "gradient",
                        "min": -1200,
                        "max": 1200,
                        "stops": [
                            "#3B4CC0",
                            "#5D7CE6",
                            "#82A6FB",
                            "#AAC7FD",
                            "#CDD9EC",
                            "#EAD4C8",
                            "#F7B89C",
                            "#F18D6F",
                            "#D95847",
                            "#B40426"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "g CO\u2082/m\xb2/yr"
                    },
                    "media": {
                        "src": (parcelRequire("dDPrK")),
                        "alt": "OCO-2 MIP Top-down CO\u2082 Budgets - LNLGIS Net Carbon Exchange (LNLGIS_NCE)"
                    },
                    "parentDataset": {
                        "id": "oco2-mip-co2budget-yeargrid-v1"
                    }
                },
                {
                    "id": "co2-emissions-lnlgis-nce-std",
                    "stacCol": "oco2-mip-co2budget-yeargrid-v1",
                    "name": "Uncertainty - LNLGIS Net Carbon Exchange (LNLGIS_NCE_std)",
                    "type": "raster",
                    "description": "Uncertainty in CO\u2082 emissions from net flux of carbon from surface to atmosphere (net carbon exchange) estimated from the OCO-2 v10 MIP LNLGIS ensemble",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "lnlgis-nce-std",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            1200
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2-mip-co2budget-yeargrid-v1",
                        "layerId": "co2-emissions-lnlgis-nce-std",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CO\u2082/m\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1200,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "g CO\u2082/m\xb2/yr"
                    },
                    "media": {
                        "src": (parcelRequire("dsYZX")),
                        "alt": "OCO-2 MIP Top-down CO\u2082 Budgets - Uncertainty - LNLGIS Net Carbon Exchange (LNLGIS_NCE_std)"
                    },
                    "parentDataset": {
                        "id": "oco2-mip-co2budget-yeargrid-v1"
                    }
                },
                {
                    "id": "co2-emissions-lnlgis-dc-loss",
                    "stacCol": "oco2-mip-co2budget-yeargrid-v1",
                    "name": "LNLGIS Net Land Carbon Stock Loss (LNLGIS_dC_loss)",
                    "type": "raster",
                    "description": "CO\u2082 emissions from net land carbon stock loss (decrease in land carbon) estimated from the OCO-2 v10 MIP LNLGIS ensemble",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "lnlgis-dc-loss",
                        "colormap_name": "coolwarm",
                        "rescale": [
                            -600,
                            600
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2-mip-co2budget-yeargrid-v1",
                        "layerId": "co2-emissions-lnlgis-dc-loss",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CO\u2082/m\xb2/yr"
                        },
                        "type": "gradient",
                        "min": -600,
                        "max": 600,
                        "stops": [
                            "#3B4CC0",
                            "#5D7CE6",
                            "#82A6FB",
                            "#AAC7FD",
                            "#CDD9EC",
                            "#EAD4C8",
                            "#F7B89C",
                            "#F18D6F",
                            "#D95847",
                            "#B40426"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "g CO\u2082/m\xb2/yr"
                    },
                    "media": {
                        "src": (parcelRequire("ciDZa")),
                        "alt": "OCO-2 MIP Top-down CO\u2082 Budgets - LNLGIS Net Land Carbon Stock Loss (LNLGIS_dC_loss)"
                    },
                    "parentDataset": {
                        "id": "oco2-mip-co2budget-yeargrid-v1"
                    }
                },
                {
                    "id": "co2-emissions-lnlgis-dc-loss-std",
                    "stacCol": "oco2-mip-co2budget-yeargrid-v1",
                    "name": "Uncertainty - LNLGIS Net Land Carbon Stock Loss (LNLGIS_dC_loss_std)",
                    "type": "raster",
                    "description": "Uncertainty in CO\u2082 emissions from net land carbon stock loss (decrease in land carbon) estimated from the OCO-2 v10 MIP LNLGIS  ensemble",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "lnlgis-dc-loss-std",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            800
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2-mip-co2budget-yeargrid-v1",
                        "layerId": "co2-emissions-lnlgis-dc-loss-std",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CO\u2082/m\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 800,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "g CO\u2082/m\xb2/yr"
                    },
                    "media": {
                        "src": (parcelRequire("h3M0X")),
                        "alt": "OCO-2 MIP Top-down CO\u2082 Budgets - Uncertainty LNLGIS Net Land Carbon Stock Loss (LNLGIS_dC_loss_std)"
                    },
                    "parentDataset": {
                        "id": "oco2-mip-co2budget-yeargrid-v1"
                    }
                },
                {
                    "id": "co2-emissions-crop",
                    "stacCol": "oco2-mip-co2budget-yeargrid-v1",
                    "name": "Lateral Crop CO\u2082 Flux (Crop)",
                    "type": "raster",
                    "description": "CO\u2082 emissions from lateral flux of carbon in (positive) or out (negative) from crops",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "crop",
                        "colormap_name": "coolwarm",
                        "rescale": [
                            -100,
                            100
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2-mip-co2budget-yeargrid-v1",
                        "layerId": "co2-emissions-crop",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CO\u2082/m\xb2/yr"
                        },
                        "type": "gradient",
                        "min": -100,
                        "max": 100,
                        "stops": [
                            "#3B4CC0",
                            "#5D7CE6",
                            "#82A6FB",
                            "#AAC7FD",
                            "#CDD9EC",
                            "#EAD4C8",
                            "#F7B89C",
                            "#F18D6F",
                            "#D95847",
                            "#B40426"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "g CO\u2082/m\xb2/yr"
                    },
                    "media": {
                        "src": (parcelRequire("cjtgx")),
                        "alt": "OCO-2 MIP Top-down CO\u2082 Budgets - Lateral Crop CO\u2082 Flux (Crop)"
                    },
                    "parentDataset": {
                        "id": "oco2-mip-co2budget-yeargrid-v1"
                    }
                },
                {
                    "id": "co2-emissions-crop-std",
                    "stacCol": "oco2-mip-co2budget-yeargrid-v1",
                    "name": "Uncertainty - Lateral Crop CO\u2082 Flux (Crop_std)",
                    "type": "raster",
                    "description": "Uncertainty in CO\u2082 emissions from lateral flux of carbon from crop",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "crop-std",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            50
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2-mip-co2budget-yeargrid-v1",
                        "layerId": "co2-emissions-crop-std",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CO\u2082/m\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 50,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "g CO\u2082/m\xb2/yr"
                    },
                    "media": {
                        "src": (parcelRequire("ax69L")),
                        "alt": "OCO-2 MIP Top-down CO\u2082 Budgets - Uncertainty - Lateral Crop CO\u2082 Flux (Crop_std)"
                    },
                    "parentDataset": {
                        "id": "oco2-mip-co2budget-yeargrid-v1"
                    }
                },
                {
                    "id": "co2-emissions-ff",
                    "stacCol": "oco2-mip-co2budget-yeargrid-v1",
                    "name": "Fossil Fuel and Cement CO\u2082 Emissions (FF)",
                    "type": "raster",
                    "description": "CO\u2082 emissions from the burning of fossil fuels and release of carbon due to cement production (positive flux from land surface to the atmosphere)",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "ff",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            450
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2-mip-co2budget-yeargrid-v1",
                        "layerId": "co2-emissions-ff",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CO\u2082/m\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 450,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "g CO\u2082/m\xb2/yr"
                    },
                    "media": {
                        "src": (parcelRequire("bGtQp")),
                        "alt": "OCO-2 MIP Top-down CO\u2082 Budgets - Fossil Fuel and Cement CO\u2082 Emissions (FF)"
                    },
                    "parentDataset": {
                        "id": "oco2-mip-co2budget-yeargrid-v1"
                    }
                },
                {
                    "id": "co2-emissions-ff-std",
                    "stacCol": "oco2-mip-co2budget-yeargrid-v1",
                    "name": "Uncertainty - Fossil Fuel and Cement CO\u2082 Emissions (FF_std)",
                    "type": "raster",
                    "description": "Uncertainty in CO\u2082 emissions from the burning of fossil fuels and release of carbon due to cement production",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "ff-std",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            100
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2-mip-co2budget-yeargrid-v1",
                        "layerId": "co2-emissions-ff-std",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CO\u2082/m\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 100,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "g CO\u2082/m\xb2/yr"
                    },
                    "media": {
                        "src": (parcelRequire("gzyTP")),
                        "alt": "OCO-2 MIP Top-down CO\u2082 Budgets - Uncertainty - Fossil Fuel and Cement CO\u2082 Emissions (FF_std)"
                    },
                    "parentDataset": {
                        "id": "oco2-mip-co2budget-yeargrid-v1"
                    }
                },
                {
                    "id": "co2-emissions-river",
                    "stacCol": "oco2-mip-co2budget-yeargrid-v1",
                    "name": "Lateral River CO\u2082 Flux (River)",
                    "type": "raster",
                    "description": "CO\u2082 emissions from lateral flux of carbon in (positive) or out (negative) from rivers",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "river",
                        "colormap_name": "coolwarm",
                        "rescale": [
                            -50,
                            50
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2-mip-co2budget-yeargrid-v1",
                        "layerId": "co2-emissions-river",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CO\u2082/m\xb2/yr"
                        },
                        "type": "gradient",
                        "min": -50,
                        "max": 50,
                        "stops": [
                            "#3B4CC0",
                            "#5D7CE6",
                            "#82A6FB",
                            "#AAC7FD",
                            "#CDD9EC",
                            "#EAD4C8",
                            "#F7B89C",
                            "#F18D6F",
                            "#D95847",
                            "#B40426"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "g CO\u2082/m\xb2/yr"
                    },
                    "media": {
                        "src": (parcelRequire("1FQ71")),
                        "alt": "OCO-2 MIP Top-down CO\u2082 Budgets - Lateral River CO\u2082 Flux (River)"
                    },
                    "parentDataset": {
                        "id": "oco2-mip-co2budget-yeargrid-v1"
                    }
                },
                {
                    "id": "co2-emissions-river-std",
                    "stacCol": "oco2-mip-co2budget-yeargrid-v1",
                    "name": "Uncertainty - Lateral River CO\u2082 Flux (River_std)",
                    "type": "raster",
                    "description": "Uncertainty in CO\u2082 emissions from lateral flux of carbon from rivers",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "river-std",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            60
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2-mip-co2budget-yeargrid-v1",
                        "layerId": "co2-emissions-river-std",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CO\u2082/m\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 60,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "g CO\u2082/m\xb2/yr"
                    },
                    "media": {
                        "src": (parcelRequire("5CFV6")),
                        "alt": "OCO-2 MIP Top-down CO\u2082 Budgets - Uncertainty - Lateral River CO\u2082 Flux (River_std)"
                    },
                    "parentDataset": {
                        "id": "oco2-mip-co2budget-yeargrid-v1"
                    }
                },
                {
                    "id": "co2-emissions-wood",
                    "stacCol": "oco2-mip-co2budget-yeargrid-v1",
                    "name": "Lateral Wood CO\u2082 Flux (Wood)",
                    "type": "raster",
                    "description": "CO\u2082 emissions from lateral flux of carbon due to wood product harvesting and usage",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "wood",
                        "colormap_name": "coolwarm",
                        "rescale": [
                            -100,
                            100
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2-mip-co2budget-yeargrid-v1",
                        "layerId": "co2-emissions-wood",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CO\u2082/m\xb2/yr"
                        },
                        "type": "gradient",
                        "min": -100,
                        "max": 100,
                        "stops": [
                            "#3B4CC0",
                            "#5D7CE6",
                            "#82A6FB",
                            "#AAC7FD",
                            "#CDD9EC",
                            "#EAD4C8",
                            "#F7B89C",
                            "#F18D6F",
                            "#D95847",
                            "#B40426"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "g CO\u2082/m\xb2/yr"
                    },
                    "media": {
                        "src": (parcelRequire("rbSdt")),
                        "alt": "OCO-2 MIP Top-down CO\u2082 Budgets - Lateral Wood CO\u2082 Flux (Wood)"
                    },
                    "parentDataset": {
                        "id": "oco2-mip-co2budget-yeargrid-v1"
                    }
                },
                {
                    "id": "co2-emissions-wood-std",
                    "stacCol": "oco2-mip-co2budget-yeargrid-v1",
                    "name": "Uncertainty - Lateral Wood CO\u2082 Flux (Wood_std)",
                    "type": "raster",
                    "description": "Uncertainty in CO\u2082 emissions from lateral flux of carbon due to wood product harvesting and usage",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "wood-std",
                        "colormap_name": "purd",
                        "rescale": [
                            0,
                            50
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2-mip-co2budget-yeargrid-v1",
                        "layerId": "co2-emissions-wood-std",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "g CO\u2082/m\xb2/yr"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 600,
                        "stops": [
                            "#F7F4F9",
                            "#E9E3F0",
                            "#D9C3DF",
                            "#CDA0CD",
                            "#D57ABA",
                            "#E34A9F",
                            "#DF2179",
                            "#C10E51",
                            "#92003F",
                            "#67001F"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NOAA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "g CO\u2082/m\xb2/yr"
                    },
                    "media": {
                        "src": (parcelRequire("1HNkE")),
                        "alt": "OCO-2 MIP Top-down CO\u2082 Budgets - Uncertainty - Lateral Wood CO\u2082 Flux (Wood_std)"
                    },
                    "parentDataset": {
                        "id": "oco2-mip-co2budget-yeargrid-v1"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("dPFv4"))
    },
    "oco2geos-co2-daygrid-v10r": {
        data: {
            "id": "oco2geos-co2-daygrid-v10r",
            "name": "OCO-2 GEOS Column CO\u2082 Concentrations",
            "description": "Daily, global 0.5 x 0.625 degree assimilated CO\u2082 concentrations derived from OCO-2 satellite data, version 10r",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/oco2geos-co2-daygrid-v10r.html",
                    "label": "Notebook showing data transformation to COG for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Foco2geos-co2-daygrid-v10r_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://data.ghg.center/browseui/index.html#oco2geos-co2-daygrid-v10r/",
                    "label": "Browse and download the data",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("32Jge")),
                "alt": "Smoking Factory",
                "author": {
                    "name": "Johannes Plenio",
                    "url": "https://unsplash.com/photos/5_9inhy4NSE"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "ghg-concentrations",
                            "name": "GHG Concentrations"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nasa",
                            "name": "NASA"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "satellite-observations",
                            "name": "Satellite Observations"
                        },
                        {
                            "id": "model-output",
                            "name": "Model Output"
                        }
                    ]
                }
            ],
            "infoDescription": "<ul><li>Temporal Extent: January 1, 2015 - February 28, 2022</li><li>Temporal Resolution: Daily</li><li>Spatial extent: Global</li><li>Spatial resolution: 0.5\xb0 x 0.625\xb0</li><li>Data units: Parts per million (ppm)</li><li>Data type: Research</li><li>Data Latency: 2-3 months</li></ul>",
            "layers": [
                {
                    "id": "oco2-dryair-column",
                    "stacCol": "oco2geos-co2-daygrid-v10r",
                    "name": "Average Dry-Air Column CO\u2082 (XCO\u2082)",
                    "type": "raster",
                    "description": "Daily dry air column-averaged mole fractions of carbon dioxide created from data assimilations of OCO-2 satellite retrievals.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "xco2",
                        "colormap_name": "magma",
                        "rescale": [
                            412,
                            422
                        ]
                    },
                    "compare": {
                        "datasetId": "oco2geos-co2-daygrid-v10r",
                        "layerId": "oco2-dryair-column",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "ppm"
                        },
                        "type": "gradient",
                        "min": 412,
                        "max": 422,
                        "stops": [
                            "#2c115f",
                            "#721f81",
                            "#b73779",
                            "#f1605d",
                            "#feb078"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Daily",
                        "unit": "ppm"
                    },
                    "media": {
                        "src": (parcelRequire("2OPnE")),
                        "alt": "OCO-2 GEOS Column CO\u2082 Concentrations - Average Dry-Air Column CO\u2082 (XCO\u2082)"
                    },
                    "parentDataset": {
                        "id": "oco2geos-co2-daygrid-v10r"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("dxulp"))
    },
    "odiac-ffco2-monthgrid-v2024": {
        data: {
            "id": "odiac-ffco2-monthgrid-v2024",
            "name": "ODIAC Fossil Fuel CO\u2082 Emissions",
            "description": "Global, monthly 1 km resolution dataset of fossil fuel carbon dioxide emissions, version 2024",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/odiac-ffco2-monthgrid-v2024.html",
                    "label": "Notebook showing data transformation to COG for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Fodiac-ffco2-monthgrid-v2024_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://data.ghg.center/browseui/index.html#odiac-ffco2-monthgrid-v2024/",
                    "label": "Browse and download the data",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("hxIiB")),
                "alt": "White smoke coming from building",
                "author": {
                    "name": "Marcin Jozwiak",
                    "url": "https://unsplash.com/photos/T-eDxGcn-Ok"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "anthropogenic-emissions",
                            "name": "Anthropogenic Emissions"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nasa",
                            "name": "NASA"
                        },
                        {
                            "id": "nies",
                            "name": "NIES"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "model-output",
                            "name": "Model Output"
                        }
                    ]
                }
            ],
            "infoDescription": '<ul><li>Temporal Extent: January 2000 - December 2023</li><li>Temporal Resolution: Monthly</li><li>Spatial Extent: Global</li><li>Spatial Resolution: 1 km x 1 km</li><li>Data Units: Metric tonnes of carbon per 1 km x 1 km cell per month (tonne C/km\xb2/month)</li><li>Data Type: Research</li><li>Data Latency: Updated annually, following the release of an updated <a href="https://www.bp.com/en/global/corporate/energy-economics/statistical-review-of-world-energy.html">BP Statistical Review of World Energy report</a></li></ul>',
            "layers": [
                {
                    "id": "co2-emissions",
                    "stacCol": "odiac-ffco2-monthgrid-v2024",
                    "name": "Fossil Fuel CO\u2082 Emissions",
                    "type": "raster",
                    "description": "Model-estimated monthly, 1 km CO\u2082 emissions created using space-based nighttime light data and individual power plant emission/location profiles.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "co2-emissions",
                        "colormap_name": "jet",
                        "rescale": [
                            -10,
                            60
                        ]
                    },
                    "compare": {
                        "datasetId": "odiac-ffco2-monthgrid-v2024",
                        "layerId": "co2-emissions",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne C/km\xb2/month"
                        },
                        "type": "gradient",
                        "min": -10,
                        "max": 60,
                        "stops": [
                            "#000080",
                            "#0000BB",
                            "#0000F6",
                            "#0020FF",
                            "#0054FF",
                            "#008CFF",
                            "#00C0FF",
                            "#0FF8E7",
                            "#39FFBE",
                            "#66FF90",
                            "#90FF66",
                            "#BEFF39",
                            "#E7FF0F",
                            "#FFD300",
                            "#FFA300",
                            "#FF6F00",
                            "#FF3F00",
                            "#F60B00",
                            "#BB0000",
                            "#800000"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA / NIES",
                        "spatialExtent": "Global",
                        "temporalResolution": "Monthly",
                        "unit": "tonne C/km\xb2/month"
                    },
                    "media": {
                        "src": (parcelRequire("dzjhK")),
                        "alt": "ODIAC Fossil Fuel CO\u2082 Emissions - Fossil Fuel CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "odiac-ffco2-monthgrid-v2024"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("d6NP7"))
    },
    "sedac-popdensity-yeargrid5yr-v4.11": {
        data: {
            "id": "sedac-popdensity-yeargrid5yr-v4.11",
            "name": "SEDAC Gridded World Population Density",
            "description": "Global, 30 arc-seconds (~1km) resolution human population density estimates from the Gridded Population of the World (GPW), version 4, revision 11 dataset based on national censuses and population registers",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/sedac-popdensity-yeargrid5yr-v4.11.html",
                    "label": "Notebook showing data transformation to COG for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Fsedac-popdensity-yeargrid5yr-v4.11_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://data.ghg.center/browseui/index.html#sedac-popdensity-yeargrid5yr-v4.11/",
                    "label": "Browse and download the data",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("bVgGj")),
                "alt": "aa",
                "author": {
                    "name": "Columbia University"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "socioeconomic",
                            "name": "Socioeconomic"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nasa",
                            "name": "NASA"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "model-output",
                            "name": "Model Output"
                        }
                    ]
                }
            ],
            "infoDescription": "<ul><li>Temporal Extent: 2000 - 2020</li><li>Temporal Resolution: Annual, every 5 years</li><li>Spatial Extent: Global</li><li>Spatial Resolution: 30 arc-seconds (~1 km at equator)</li><li>Data Units: Number of persons per square kilometer (persons/km\xb2)</li><li>Data Type: Research</li><li>Data Latency: 5 years</li></ul>",
            "layers": [
                {
                    "id": "nasa-sedac-population",
                    "stacCol": "sedac-popdensity-yeargrid5yr-v4.11",
                    "name": "Population Density",
                    "type": "raster",
                    "description": "Gridded population density estimates for the years 2000, 2005, 2010, 2015, and 2020 from Gridded Population of the World (GPW) version 4, revision 11",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "basemapId": "light",
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "population-density",
                        "colormap_name": "ylorrd",
                        "rescale": [
                            0,
                            1000
                        ]
                    },
                    "compare": {
                        "datasetId": "sedac-popdensity-yeargrid5yr-v4.11",
                        "layerId": "nasa-sedac-population",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "persons/km\xb2"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1000,
                        "stops": [
                            "#FFFFB2",
                            "#FFDDA0",
                            "#FFC381",
                            "#FFA354",
                            "#FF8524",
                            "#FF6715",
                            "#FF0000"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "persons/km\xb2"
                    },
                    "media": {
                        "src": (parcelRequire("cLmTZ")),
                        "alt": "SEDAC Gridded World Population Density - Population Density"
                    },
                    "parentDataset": {
                        "id": "sedac-popdensity-yeargrid5yr-v4.11"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("gY0my"))
    },
    "vulcan-ffco2-yeargrid-v4": {
        data: {
            "id": "vulcan-ffco2-yeargrid-v4",
            "name": "Vulcan Fossil Fuel CO\u2082 Emissions",
            "description": "Annual (2010 - 2021), 1 km resolution estimates of carbon dioxide emissions from fossil fuel combustion over the contiguous United States, version 4.0",
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/vulcan-ffco2-yeargrid-v4.html",
                    "label": "Notebook showing data transformation to COG for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Fvulcan-ffco2-yeargrid-v4_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://data.ghg.center/browseui/index.html#vulcan-ffco2-yeargrid-v4/",
                    "label": "Browse and download the data",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("4RGos")),
                "alt": "FFCO2 emissions for the year 2010-2015 for the contiguous United States",
                "author": {
                    "name": "Dr. Kevin Gurney/NAU",
                    "url": "https://vulcan.rc.nau.edu/Data.html"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "anthropogenic-emissions",
                            "name": "Anthropogenic Emissions"
                        },
                        {
                            "id": "urban",
                            "name": "Urban"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nau",
                            "name": "NAU"
                        },
                        {
                            "id": "nasa",
                            "name": "NASA"
                        },
                        {
                            "id": "noaa",
                            "name": "NOAA"
                        },
                        {
                            "id": "nsf",
                            "name": "NSF"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "hybrid-product",
                            "name": "Hybrid Product"
                        }
                    ]
                }
            ],
            "sourceExclusive": "NSF",
            "infoDescription": "<ul><li>Temporal Extent: 2010 - 2021</li><li>Temporal Resolution: Annual</li><li>Spatial Extent: Contiguous United States</li><li>Spatial Resolution: 1km x 1km</li><li>Data Units: Metric tons of carbon dioxide per 1 km x 1 km grid cell per year (tonne CO\u2082/km\xb2/year)</li><li>Data Type: Research</li><li>Data Latency: Updated annually</li></ul>",
            "layers": [
                {
                    "id": "vulcan-total-co2",
                    "stacCol": "vulcan-ffco2-yeargrid-v4",
                    "name": "Total Fossil Fuel CO\u2082 Emissions",
                    "type": "raster",
                    "description": "Estimated total annual CO\u2082 emissions from fossil fuel combustion (ffCO\u2082) across all sectors.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "total-co2",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            1400
                        ]
                    },
                    "compare": {
                        "datasetId": "vulcan-ffco2-yeargrid-v4",
                        "layerId": "vulcan-total-co2",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne CO\u2082/km\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1400,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "tonne CO\u2082/km\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("evGrO")),
                        "alt": "Rendered Fossil Fuel CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "vulcan-ffco2-yeargrid-v4"
                    }
                },
                {
                    "id": "vulcan-air-co2",
                    "stacCol": "vulcan-ffco2-yeargrid-v4",
                    "name": "Airport Fossil Fuel CO\u2082 Emissions",
                    "type": "raster",
                    "description": "Estimated total annual ffCO\u2082 emissions from taxi, take-off, and landing up to 3000 ft.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "air-co2",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            1400
                        ]
                    },
                    "compare": {
                        "datasetId": "vulcan-ffco2-yeargrid-v4",
                        "layerId": "vulcan-air-co2",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne CO\u2082/km\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1400,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "tonne CO\u2082/km\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("evGrO")),
                        "alt": "Rendered Fossil Fuel CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "vulcan-ffco2-yeargrid-v4"
                    }
                },
                {
                    "id": "vulcan-cmt-co2",
                    "stacCol": "vulcan-ffco2-yeargrid-v4",
                    "name": "Cement Fossil Fuel CO\u2082 Emissions",
                    "type": "raster",
                    "description": "Estimated total annual ffCO\u2082 emissions from cement production.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "cmt-co2",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            1400
                        ]
                    },
                    "compare": {
                        "datasetId": "vulcan-ffco2-yeargrid-v4",
                        "layerId": "vulcan-cmt-co2",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne CO\u2082/km\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1400,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "tonne CO\u2082/km\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("evGrO")),
                        "alt": "Rendered Fossil Fuel CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "vulcan-ffco2-yeargrid-v4"
                    }
                },
                {
                    "id": "vulcan-cmv-co2",
                    "stacCol": "vulcan-ffco2-yeargrid-v4",
                    "name": "Commercial Marine Vessel Fossil Fuel CO\u2082 Emissions",
                    "type": "raster",
                    "description": "Estimated total annual ffCO\u2082 emissions from commercial marine vessels while maneuvering, hoteling, cruising and traveling within reduced speed zones at ports and shipping lanes. Includes only activity within 12 nautical miles (~22km) from the U.S. shoreline.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "cmv-co2",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            1400
                        ]
                    },
                    "compare": {
                        "datasetId": "vulcan-ffco2-yeargrid-v4",
                        "layerId": "vulcan-cmv-co2",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne CO\u2082/km\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1400,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "tonne CO\u2082/km\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("evGrO")),
                        "alt": "Rendered Fossil Fuel CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "vulcan-ffco2-yeargrid-v4"
                    }
                },
                {
                    "id": "vulcan-com-co2",
                    "stacCol": "vulcan-ffco2-yeargrid-v4",
                    "name": "Commercial Fossil Fuel CO\u2082 Emissions",
                    "type": "raster",
                    "description": "Estimated total annual ffCO\u2082 emissions from Commercial buildings.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "com-co2",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            1400
                        ]
                    },
                    "compare": {
                        "datasetId": "vulcan-ffco2-yeargrid-v4",
                        "layerId": "vulcan-com-co2",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne CO\u2082/km\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1400,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "tonne CO\u2082/km\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("evGrO")),
                        "alt": "Rendered Fossil Fuel CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "vulcan-ffco2-yeargrid-v4"
                    }
                },
                {
                    "id": "vulcan-elc-co2",
                    "stacCol": "vulcan-ffco2-yeargrid-v4",
                    "name": "Power Plant Fossil Fuel CO\u2082 Emissions",
                    "type": "raster",
                    "description": "Estimated total annual ffCO\u2082 emissions from power plants.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "elc-co2",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            1400
                        ]
                    },
                    "compare": {
                        "datasetId": "vulcan-ffco2-yeargrid-v4",
                        "layerId": "vulcan-elc-co2",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne CO\u2082/km\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1400,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "tonne CO\u2082/km\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("evGrO")),
                        "alt": "Rendered Fossil Fuel CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "vulcan-ffco2-yeargrid-v4"
                    }
                },
                {
                    "id": "vulcan-ind-co2",
                    "stacCol": "vulcan-ffco2-yeargrid-v4",
                    "name": "Industrial Fossil Fuel CO\u2082 Emissions",
                    "type": "raster",
                    "description": "Estimated total annual ffCO\u2082 emissions from Industrial buildings.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "ind-co2",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            1400
                        ]
                    },
                    "compare": {
                        "datasetId": "vulcan-ffco2-yeargrid-v4",
                        "layerId": "vulcan-ind-co2",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne CO\u2082/km\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1400,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "tonne CO\u2082/km\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("evGrO")),
                        "alt": "Rendered Fossil Fuel CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "vulcan-ffco2-yeargrid-v4"
                    }
                },
                {
                    "id": "vulcan-nrd-co2",
                    "stacCol": "vulcan-ffco2-yeargrid-v4",
                    "name": "Nonroad Fossil Fuel CO\u2082 Emissions",
                    "type": "raster",
                    "description": "Estimated total annual ffCO\u2082 emissions from off-road engines, equipment and vehicles including waterborne pleasure craft.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "nrd-co2",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            1400
                        ]
                    },
                    "compare": {
                        "datasetId": "vulcan-ffco2-yeargrid-v4",
                        "layerId": "vulcan-nrd-co2",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne CO\u2082/km\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1400,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "tonne CO\u2082/km\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("evGrO")),
                        "alt": "Rendered Fossil Fuel CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "vulcan-ffco2-yeargrid-v4"
                    }
                },
                {
                    "id": "vulcan-onr-co2",
                    "stacCol": "vulcan-ffco2-yeargrid-v4",
                    "name": "Onroad Fossil Fuel CO\u2082 Emissions",
                    "type": "raster",
                    "description": "Estimated total annual ffCO\u2082 emissions from mobile vehicles on roads.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "onr-co2",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            1400
                        ]
                    },
                    "compare": {
                        "datasetId": "vulcan-ffco2-yeargrid-v4",
                        "layerId": "vulcan-onr-co2",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne CO\u2082/km\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1400,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "tonne CO\u2082/km\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("evGrO")),
                        "alt": "Rendered Fossil Fuel CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "vulcan-ffco2-yeargrid-v4"
                    }
                },
                {
                    "id": "vulcan-res-co2",
                    "stacCol": "vulcan-ffco2-yeargrid-v4",
                    "name": "Residential Fossil Fuel CO\u2082 Emissions",
                    "type": "raster",
                    "description": "Estimated total annual ffCO\u2082 emissions from Residential buildings.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "res-co2",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            1400
                        ]
                    },
                    "compare": {
                        "datasetId": "vulcan-ffco2-elc-res-yeargrid-v4",
                        "layerId": "vulcan-elc-res-co2",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne CO\u2082/km\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1400,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "tonne CO\u2082/km\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("evGrO")),
                        "alt": "Rendered Fossil Fuel CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "vulcan-ffco2-yeargrid-v4"
                    }
                },
                {
                    "id": "vulcan-rrd-co2",
                    "stacCol": "vulcan-ffco2-yeargrid-v4",
                    "name": "Railroad Fossil Fuel CO\u2082 Emissions",
                    "type": "raster",
                    "description": "Estimated total annual ffCO\u2082 emissions coming from railroads.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "rrd-co2",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            1400
                        ]
                    },
                    "compare": {
                        "datasetId": "vulcan-ffco2-yeargrid-v4",
                        "layerId": "vulcan-rrd-co2",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne CO\u2082/km\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 1400,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "tonne CO\u2082/km\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("evGrO")),
                        "alt": "Rendered Fossil Fuel CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "vulcan-ffco2-yeargrid-v4"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("3DwOc"))
    },
    "vulcan-ffco2-elc-res-yeargrid-v4": {
        data: {
            "id": "vulcan-ffco2-elc-res-yeargrid-v4",
            "name": "Vulcan Fossil Fuel CO\u2082 Emissions, Version 4",
            "description": "Annual (2010 - 2021), 1 km resolution estimates of carbon dioxide emissions from fossil fuels and cement production over the contiguous United States, version 4.0",
            "isHidden": true,
            "usage": [
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/cog_transformation/vulcan-ffco2-yeargrid-v4.html",
                    "label": "Notebook showing data transformation to COG for ingest to the US GHG Center",
                    "title": "Data Transformation Notebook"
                },
                {
                    "url": "https://us-ghg-center.github.io/ghgc-docs/datausage.html",
                    "label": "Notebooks to read, visualize, and explore data statistics",
                    "title": "Data Usage Notebooks"
                },
                {
                    "url": "https://hub.ghg.center/hub/user-redirect/git-pull?repo=https%3A%2F%2Fgithub.com%2FUS-GHG-Center%2Fghgc-docs&urlpath=lab%2Ftree%2Fghgc-docs%2Fuser_data_notebooks%2Fvulcan-ffco2-yeargrid-v4_User_Notebook.ipynb&branch=main",
                    "label": "Run example notebook",
                    "title": "Interactive Session in the US GHG Center JupyterHub (requires account)"
                },
                {
                    "url": "https://data.ghg.center/browseui/index.html#vulcan-ffco2-yeargrid-v4/",
                    "label": "Browse and download the data",
                    "title": "Data Browser"
                }
            ],
            "media": {
                "src": (parcelRequire("95TOc")),
                "alt": "Static rendering of oceanic currents with arrow indicators for cycle direction and strength",
                "author": {
                    "name": "NASA's Science Visualization Studio (SVS)",
                    "url": "https://svs.gsfc.nasa.gov/12629/"
                }
            },
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "anthropogenic-emissions",
                            "name": "Anthropogenic Emissions"
                        }
                    ]
                },
                {
                    "name": "Source",
                    "values": [
                        {
                            "id": "nau",
                            "name": "NAU"
                        },
                        {
                            "id": "nasa",
                            "name": "NASA"
                        },
                        {
                            "id": "noaa",
                            "name": "NOAA"
                        },
                        {
                            "id": "nsf",
                            "name": "NSF"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        }
                    ]
                },
                {
                    "name": "Product Type",
                    "values": [
                        {
                            "id": "model-output",
                            "name": "Model Output"
                        }
                    ]
                }
            ],
            "infoDescription": "<ul><li>Temporal Extent: 2010 - 2021</li><li>Temporal Resolution: Annual</li><li>Spatial Extent: Contiguous United States</li><li>Spatial Resolution: 1km x 1km</li><li>Data Units: Units are metric tonnes of CO\u2082 per 1 km x 1 km cell per year (tC/km\xb2/year)</li><li>Data Type: Research</li><li>Data Latency: Updated annually</li></ul>",
            "layers": [
                {
                    "id": "vulcan-elc-res-co2",
                    "stacCol": "vulcan-ffco2-elc-res-yeargrid-v4",
                    "name": "Scope 2 Residential Fossil Fuel CO\u2082 Emissions",
                    "type": "raster",
                    "description": "Estimated total annual CO\u2082 emissions from fossil fuel combustion (ffCO\u2082) across all sectors.",
                    "initialDatetime": "newest",
                    "projection": {
                        "id": "equirectangular"
                    },
                    "zoomExtent": [
                        0,
                        20
                    ],
                    "sourceParams": {
                        "assets": "elc-res-co2",
                        "colormap_name": "spectral_r",
                        "rescale": [
                            0,
                            500
                        ]
                    },
                    "compare": {
                        "datasetId": "vulcan-ffco2-yeargrid-v4",
                        "layerId": "vulcan-total-co2",
                        "mapLabel": ({ dateFns: dateFns, datetime: datetime, compareDatetime: compareDatetime })=>{
                            if (dateFns && datetime && compareDatetime) return `${dateFns.format(datetime, "LLL yyyy")} VS ${dateFns.format(compareDatetime, "LLL yyyy")}`;
                        }
                    },
                    "legend": {
                        "unit": {
                            "label": "tonne CO\u2082/km\xb2/year"
                        },
                        "type": "gradient",
                        "min": 0,
                        "max": 500,
                        "stops": [
                            "#5e4fa2",
                            "#388eba",
                            "#75c8a5",
                            "#bfe5a0",
                            "#f1f9a9",
                            "#feeea2",
                            "#fdbf6f",
                            "#f67b4a",
                            "#d8434e",
                            "#9e0142"
                        ]
                    },
                    "analysis": {
                        "metrics": [
                            "mean"
                        ],
                        "sourceParams": {
                            "dst_crs": "+proj=cea"
                        }
                    },
                    "info": {
                        "source": "NASA",
                        "spatialExtent": "Global",
                        "temporalResolution": "Annual",
                        "unit": "tonne CO\u2082/km\xb2/year"
                    },
                    "media": {
                        "src": (parcelRequire("lyJUi")),
                        "alt": "Rendered Fossil Fuel CO\u2082 Emissions"
                    },
                    "parentDataset": {
                        "id": "vulcan-ffco2-elc-res-yeargrid-v4"
                    }
                }
            ]
        },
        content: ()=>(parcelRequire("fXYOD"))
    }
};


































const $03f81bcaf0c10c12$export$417f05a13bd2667c = {
    "baltimore": {
        data: {
            "id": "baltimore",
            "name": "Baltimore, a Nexus for Government and Academic Emissions Research",
            "description": "Scientists from U.S. government agencies and regional universities have come together for cooperative research projects, helping to expand environmental monitoring capabilities and improve resident wellbeing across the Baltimore metropolitan region.",
            "isHidden": false,
            "media": {
                "src": (parcelRequire("kbblz")),
                "alt": "City of Baltimore",
                "author": {
                    "name": "f11photo/Adobe Stock",
                    "url": "https://stock.adobe.com/images/downtown-baltimore-city-skyline-cityscape-in-maryland-usa/466075004?asset_id=466075004"
                }
            },
            "pubDate": "2024-09-20T00:00:00.000Z",
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "methane",
                            "name": "Methane"
                        },
                        {
                            "id": "urban",
                            "name": "Urban"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        },
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("jaG4Z"))
    },
    "discovering-large-methane-emissions": {
        data: {
            "id": "discovering-large-methane-emissions",
            "name": "Discovering Large Methane Emission Events with Remote Measurement",
            "description": "A new generation of satellite and airborne instruments can now detect methane emissions from the energy, waste, and agriculture sectors.",
            "media": {
                "src": (parcelRequire("eNAiY")),
                "alt": "An image of the Earth from space with a rendering of the international space station in the foreground. There is a lighter area imposed on the Earth\u2019s surface to suggest the observation swath of EMIT with a rendered plume observation (these components are not to scale).",
                "author": {
                    "name": "NASA/JPL-Caltech"
                }
            },
            "pubDate": "2023-08-24T00:00:00.000Z",
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "large-emission-events",
                            "name": "Large Emission Events"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("a00QF"))
    },
    "emit-and-aviris-3": {
        data: {
            "id": "emit-and-aviris-3",
            "name": "Tracking Methane Plumes from Space and Sky",
            "description": "Methane plumes can now be detected using the airborne AVIRIS-3 spectrometer in addition to EMIT on the International Space Station. Learn more about the similarities and differences and how scientists validate and understand the data from each.",
            "media": {
                "src": (parcelRequire("ktpQy")),
                "alt": "Image of plume from EMIT and AVIRIS-3 showing image swath width for each.",
                "author": {
                    "name": "NASA/JPL-Caltech. Example methane plumes as observed with EMIT and AVIRIS-3. EMIT perched on the International Space Station provides an 80 km wide image swath at 60 m spatial resolution, and AVIRIS-3 provides a narrower 3 km swath at 2 m spatial resolution when flying at 13,000 ft (figure is not to scale)."
                }
            },
            "pubDate": "2024-06-24T00:00:00.000Z",
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "large-emission-events",
                            "name": "Large Emission Events"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("knavZ"))
    },
    "emit-extension-aviris-flights": {
        data: {
            "id": "emit-extension-aviris-flights",
            "name": "NASA Expands Capabilities in Methane Detection from Air and Space",
            "description": "To meet needs for methane measurement, two key NASA technologies have made recent steps. The Earth Surface Mineral Dust Source Investigation (EMIT) project is expanding its methane detection from space, and Airborne Visible/Infrared Imaging Spectrometer (AVIRIS) test flights are helping to improve scientific understanding of sources of methane. ",
            "media": {
                "src": (parcelRequire("57WOn")),
                "alt": "instrument in space on a satellite with earth view in the background",
                "author": {
                    "name": "NASA"
                }
            },
            "pubDate": "2024-12-05T00:00:00.000Z",
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "large-emission-events",
                            "name": "Large Emission Events"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("2AwoR"))
    },
    "epa-super-emitter": {
        data: {
            "id": "epa-super-emitter",
            "name": "Advanced Technology to Detect Methane \u201CSuper Emitters\u201D from Oil and Natural Gas Operations",
            "description": "Under the U.S. EPA\u2019s recent rule for oil and natural gas operations, EPA-certified third parties may use EPA-approved remote-sensing technology to identify large methane releases known as \u201Csuper emitters.\u201D The third parties will share data with the EPA. If the data are credible, the EPA will notify owners/operators, who must investigate.",
            "media": {
                "src": (parcelRequire("jfIyV")),
                "alt": "a cluster of white oil tanks"
            },
            "isHidden": false,
            "pubDate": "2024-12-05T00:00:00.000Z",
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "large-emission-events",
                            "name": "Large Emission Events"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("fAt2m"))
    },
    "goes-validation": {
        data: {
            "id": "goes-validation",
            "name": "NOAA's GOES Satellites Can Provide Quicker Detection of Methane Gas Leaks",
            "description": "Results of a new experiment show technology aboard NOAA\u2019s GOES satellites can help scientists better detect emissions of methane \u2013 a potent greenhouse gas \u2013 as often as every seven seconds. This will provide faster, more complete data on the location and amount of methane emissions to enable more rapid and successful mitigation efforts.",
            "isHidden": false,
            "asLink": {
                "url": "https://www.nesdis.noaa.gov/news/noaas-goes-satellites-can-provide-quicker-detection-of-large-methane-emissions"
            },
            "media": {
                "src": (parcelRequire("bFltN")),
                "alt": "colorful regions representing methane plumes over brown surface as observed by GOES satellite",
                "author": {
                    "name": "Environmental Protection Agency",
                    "url": "https://www.epa.gov"
                }
            },
            "pubDate": "2024-12-05T00:00:00.000Z",
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "large-emission-events",
                            "name": "Large Emission Events"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("6rl5G"))
    },
    "gra2pes": {
        data: {
            "id": "gra2pes",
            "name": "Nationwide Dataset Connects Greenhouse Gases and Air Quality",
            "description": "The GReenhouse gas And Air Pollutants Emissions System (GRA\xb2PES), from NOAA and NIST, combines information on greenhouse gas and air quality pollutant sources into a single national database, offering innovative geospatial detail and new benefits for both climate and public health solutions.",
            "media": {
                "src": (parcelRequire("hH7Lz")),
                "alt": "Comparison of CO\u2082 and NO\u2093 emissions values from GRA\xb2PES dataset",
                "author": {
                    "name": "US GHG Center",
                    "url": "https://earth.gov/ghgcenter"
                }
            },
            "pubDate": "2024-09-20T00:00:00.000Z",
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "anthropogenic-emissions",
                            "name": "Anthropogenic Emissions"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        },
                        {
                            "id": "urban",
                            "name": "Urban"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co",
                            "name": "CO"
                        },
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        },
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        },
                        {
                            "id": "no\u2093",
                            "name": "NO\u2093"
                        },
                        {
                            "id": "pm-2-5",
                            "name": "PM2.5"
                        },
                        {
                            "id": "so\u2082",
                            "name": "SO\u2082"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("1Cchp"))
    },
    "intro-us-ghg-center": {
        data: {
            "id": "intro-us-ghg-center",
            "name": "Introduction to the US GHG Center",
            "description": "The U.S. Greenhouse Gas Center (US GHG Center) is a multi-agency effort to compile greenhouse gas data from observations and models into a collection of trusted greenhouse gas emissions and flux products.",
            "media": {
                "src": (parcelRequire("i5lKg")),
                "alt": "Global carbon dioxide visualization",
                "author": {
                    "name": "US GHG Center",
                    "url": "https://earth.gov/ghgcenter"
                }
            },
            "pubDate": "2023-08-23T00:00:00.000Z",
            "taxonomy": []
        },
        content: ()=>(parcelRequire("ldstH"))
    },
    "losangeles": {
        data: {
            "id": "losangeles",
            "name": "Satellite Data to Help Measure Impact of Los Angeles Climate Solutions",
            "description": "From its vantage point on the International Space Station, NASA\u2019s Orbiting Carbon Observatory-3 provides measurements of carbon dioxide concentrations over many of the world's cities. Scientists are using the data to examine the impact of efforts to reduce emissions in Los Angeles.",
            "isHidden": false,
            "media": {
                "src": (parcelRequire("5A7lF")),
                "alt": "Los Angeles",
                "author": {
                    "name": "Justin/Adobe Stock",
                    "url": "https://stock.adobe.com/images/los-angeles-skyline-with-palm-trees-in-the-foreground/123146928?asset_id=123146928"
                }
            },
            "pubDate": "2024-09-20T00:00:00.000Z",
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "urban",
                            "name": "Urban"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("9Sbpp"))
    },
    "methane": {
        data: {
            "id": "methane",
            "name": "Topic: Methane Emissions",
            "isHidden": true,
            "taxonomy": []
        },
        content: ()=>(parcelRequire("lUJs0"))
    },
    "modeling-natural-methane-emissions": {
        data: {
            "id": "modeling-natural-methane-emissions",
            "name": "Models and Observations Combine to Uncover Drivers of Natural Methane Emissions",
            "description": "Major natural sources of methane, like wetlands, create complications in identifying types and quantities of emissions. Researchers from NASA and NOAA are using advanced technology and models to deepen understanding of the role of natural sources and sinks in global atmospheric concentrations and support improved estimates in the global methane budget.",
            "media": {
                "src": (parcelRequire("mQHYI")),
                "alt": "view of wetland and brush/forest area from above",
                "author": {
                    "name": "Piotr Krzeslak",
                    "url": "https://stock.adobe.com/images/aerial-landscape/169488788"
                }
            },
            "featured": true,
            "pubDate": "2024-12-05T00:00:00.000Z",
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "methane",
                            "name": "Methane"
                        },
                        {
                            "id": "natural-emissions-and-sinks",
                            "name": "Natural Emissions and Sinks"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("dEVBl"))
    },
    "newyork": {
        data: {
            "id": "newyork",
            "name": "New York City Researchers Take to the Street to Investigate Emissions",
            "description": "Researchers are working with the New York State Energy Research & Development Authority to improve emissions estimates by combining measurements from a network of sensors across NYC with data collected by satellites and aircraft, pinpoint unidentified or incorrectly cataloged sources of GHGs and study interactions with other air pollutants.",
            "isHidden": false,
            "media": {
                "src": (parcelRequire("e9Cdj")),
                "alt": "New York City",
                "author": {
                    "name": "Tierney/Adobe Stock",
                    "url": "https://stock.adobe.com/images/aerial-view-of-lower-manhattan-new-york-city/168804068"
                }
            },
            "pubDate": "2024-09-20T00:00:00.000Z",
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "methane",
                            "name": "Methane"
                        },
                        {
                            "id": "urban",
                            "name": "Urban"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        },
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        },
                        {
                            "id": "no\u2093",
                            "name": "NO\u2093"
                        },
                        {
                            "id": "pm-2-5",
                            "name": "PM2.5"
                        },
                        {
                            "id": "so\u2082",
                            "name": "SO\u2082"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("5CUsW"))
    },
    "nist-methane-intercomparisons": {
        data: {
            "id": "nist-methane-intercomparisons",
            "name": "NIST Developing Consensus Standards for Growing Volume of Methane Plume Satellite Data",
            "description": "Methane measurements have seen a boom in data volume within the last decade as remote sensing technologies have advanced and new space-based instruments have taken flight. To support greater transparency and interoperability, NIST is leading an effort to standardize protocols for methane plume data reporting, processing, and comparison.",
            "media": {
                "src": (parcelRequire("9th2q")),
                "alt": "Image of plume from EMIT and AVIRIS-3 showing image swath width for each.",
                "author": {
                    "name": "NASA/JPL-Caltech. Example methane plumes as observed with EMIT and AVIRIS-3. EMIT perched on the International Space Station provides an 80 km wide image swath at 60 m spatial resolution, and AVIRIS-3 provides a narrower 3 km swath at 2 m spatial resolution when flying at 13,000 ft (figure is not to scale)."
                }
            },
            "isHidden": false,
            "pubDate": "2024-12-05T00:00:00.000Z",
            "featured": true,
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "large-emission-events",
                            "name": "Large Emission Events"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("gRrbW"))
    },
    "urban-testbed": {
        data: {
            "id": "urban-testbed",
            "name": "Innovative Urban Testbeds to Advance Emissions Estimates",
            "description": "NIST\u2019s Urban GHG Measurements Testbed System uses ground-based observing networks in Los Angeles, Indianapolis, and the Baltimore/Washington, D.C. region, together with aircraft and satellite data, to diagnose accuracy of local emissions estimates and advance transformative monitoring and measurement methods for the future.",
            "isHidden": false,
            "media": {
                "src": (parcelRequire("d2KHa")),
                "alt": "street view of a city with tower in distance showing image of instruments on tower",
                "author": {
                    "name": "INFLUX project / NIST",
                    "url": "https://bpb-us-e1.wpmucdn.com/sites.psu.edu/dist/9/4276/files/2023/09/US_INC.png"
                }
            },
            "pubDate": "2024-09-20T00:00:00.000Z",
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "anthropogenic-emissions",
                            "name": "Anthropogenic Emissions"
                        },
                        {
                            "id": "methane",
                            "name": "Methane"
                        },
                        {
                            "id": "urban",
                            "name": "Urban"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co",
                            "name": "CO"
                        },
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        },
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("fK0SA"))
    },
    "sanfrancisco": {
        data: {
            "id": "sanfrancisco",
            "name": "Scientists Use Low-Cost Sensor Network to Track San Francisco Area Emissions",
            "description": "Cities have implemented a variety of measures to meet greenhouse gas emissions goals, including expanding renewable energy use and incentivizing residents to drive electric cars. But a challenge for city leaders is measuring if policies are working. One solution is a network of low-cost sensors, scientists say.",
            "isHidden": false,
            "media": {
                "src": (parcelRequire("9Qf3p")),
                "alt": "view of the golden gate bridge",
                "author": {
                    "name": "Luciano Mortula-LGM/Adobe Stock",
                    "url": "https://stock.adobe.com/images/golden-gate-bridge-san-francisco/139531109"
                }
            },
            "pubDate": "2024-09-20T00:00:00.000Z",
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "urban",
                            "name": "Urban"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("bSDGI"))
    },
    "tracking-greenhouse-gas-cycles": {
        data: {
            "id": "tracking-greenhouse-gas-cycles",
            "name": "Tracking Greenhouse Gas Cycles",
            "description": "Understanding carbon transfers between land, ocean, and atmosphere.",
            "media": {
                "src": (parcelRequire("i0o2O")),
                "alt": "Satellite view of wetland area",
                "author": {
                    "name": "NASA Earth Observatory/Michael Taylor and Adam Voiland",
                    "url": "https://climate.nasa.gov/news/3230/satellites-help-scientists-track-dramatic-wetlands-loss-in-louisiana/"
                }
            },
            "pubDate": "2023-08-30T00:00:00.000Z",
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "methane",
                            "name": "Methane"
                        },
                        {
                            "id": "natural-emissions-and-sinks",
                            "name": "Natural Emissions and Sinks"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "ch\u2084",
                            "name": "CH\u2084"
                        },
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("cGALg"))
    },
    "urban": {
        data: {
            "id": "urban",
            "name": "Topic: Urban Emissions",
            "isHidden": true,
            "taxonomy": []
        },
        content: ()=>(parcelRequire("gHdYo"))
    },
    "vulcan": {
        data: {
            "id": "vulcan",
            "name": "Carbon Dioxide Emissions Estimates Available at Neighborhood Scale",
            "description": "Carbon dioxide emissions data are now available at a granular level, from city blocks to entire counties across the contiguous U.S. The latest dataset from the Vulcan Project, called Vulcan 4.0, helps researchers to analyze annual CO\u2082 emissions at fine scales and helps decision makers to develop localized carbon management strategies.",
            "media": {
                "src": (parcelRequire("kMyc3")),
                "alt": "magnifying glass with CO\u2082 written in text with background of smoke coming out of factories.",
                "author": {
                    "name": "TensorSpark/Adobe Stock",
                    "url": "https://stock.adobe.com/search?k=carbon+dioxide+emissions&search_type=usertyped&asset_id=794854919"
                }
            },
            "pubDate": "2024-09-20T00:00:00.000Z",
            "featured": false,
            "isHidden": false,
            "taxonomy": [
                {
                    "name": "Topics",
                    "values": [
                        {
                            "id": "anthropogenic-emissions",
                            "name": "Anthropogenic Emissions"
                        },
                        {
                            "id": "urban",
                            "name": "Urban"
                        }
                    ]
                },
                {
                    "name": "Gas",
                    "values": [
                        {
                            "id": "co\u2082",
                            "name": "CO\u2082"
                        }
                    ]
                }
            ]
        },
        content: ()=>(parcelRequire("dJ9lL"))
    }
};

});
parcelRegister("gzxNJ", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("9Qddj").then(()=>parcelRequire("3hqKl"));

});
parcelRegister("9viiU", function(module, exports) {
"use strict";

function $6eb53517e1f4c378$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("6FL5Y")).resolve(id));
}
module.exports = $6eb53517e1f4c378$var$load;

});


parcelRegister("3nv1n", function(module, exports) {

var $9viiU = parcelRequire("9viiU");


module.exports = Promise.all([
    $9viiU("2l5tY"),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("dMFvb")),
    $9viiU("eOxiP")
]).then(()=>parcelRequire("eNdO0"));

});
parcelRegister("5BfFi", function(module, exports) {
"use strict";

var $f0LRY = parcelRequire("f0LRY");
module.exports = $f0LRY(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("f0LRY", function(module, exports) {
"use strict";
var $aedbfd00e19a0cea$var$cachedBundles = {};
var $aedbfd00e19a0cea$var$cachedPreloads = {};
var $aedbfd00e19a0cea$var$cachedPrefetches = {};
function $aedbfd00e19a0cea$var$getCache(type) {
    switch(type){
        case "preload":
            return $aedbfd00e19a0cea$var$cachedPreloads;
        case "prefetch":
            return $aedbfd00e19a0cea$var$cachedPrefetches;
        default:
            return $aedbfd00e19a0cea$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $aedbfd00e19a0cea$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("hFyFZ", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("fPh7P").then(()=>parcelRequire("fSx6x"));

});

parcelRegister("ddP5G", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("gbBun").then(()=>parcelRequire("exWZz"));

});

parcelRegister("a9c8h", function(module, exports) {

var $9viiU = parcelRequire("9viiU");


module.exports = Promise.all([
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("digOB")),
    $9viiU("GDOPu")
]).then(()=>parcelRequire("gMUYy"));

});

parcelRegister("dF6Qr", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = Promise.all([
    $9viiU("6AxUY"),
    $9viiU("bQEhR")
]).then(()=>parcelRequire("1WltR"));

});

parcelRegister("dcrHe", function(module, exports) {

var $9viiU = parcelRequire("9viiU");


module.exports = Promise.all([
    $9viiU("9MCwV"),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("gBFRY")),
    $9viiU("9azGc"),
    $9viiU("2hQAJ"),
    $9viiU("hTTTm")
]).then(()=>parcelRequire("7ycvr"));

});

parcelRegister("8TcNs", function(module, exports) {

var $9viiU = parcelRequire("9viiU");




module.exports = Promise.all([
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("8Tods")),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("gBFRY")),
    $9viiU("9azGc"),
    $9viiU("kA2Lk")
]).then(()=>parcelRequire("89rWd"));

});

parcelRegister("4NX4Q", function(module, exports) {

var $9viiU = parcelRequire("9viiU");


module.exports = Promise.all([
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("lTA9A")),
    $9viiU("kv55c")
]).then(()=>parcelRequire("87xyo"));

});

parcelRegister("95TOc", function(module, exports) {
module.exports = new URL("ct-ch4-monthgrid-v2023-cover.4d4eeddd.webp", import.meta.url).toString();

});

parcelRegister("lyJUi", function(module, exports) {
module.exports = new URL("tm54dvar-ch4flux-monthgrid-v1.thumbnails.total.85db5e58.webp", import.meta.url).toString();

});

parcelRegister("43gPa", function(module, exports) {
module.exports = new URL("tm54dvar-ch4flux-monthgrid-v1.thumbnails.microbial.f3cee267.webp", import.meta.url).toString();

});

parcelRegister("dC64Y", function(module, exports) {
module.exports = new URL("tm54dvar-ch4flux-monthgrid-v1.thumbnails.fossil.10170ccf.webp", import.meta.url).toString();

});

parcelRegister("gEXZk", function(module, exports) {
module.exports = new URL("tm54dvar-ch4flux-monthgrid-v1.thumbnails.pyrogenic.20c4f8dc.webp", import.meta.url).toString();

});

parcelRegister("b1MYl", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("fWeq5").then(()=>parcelRequire("jgxXC"));

});

parcelRegister("2MfQD", function(module, exports) {
module.exports = new URL("eccodarwin--dataset-cover.f1b8b848.webp", import.meta.url).toString();

});

parcelRegister("6PoHs", function(module, exports) {
module.exports = new URL("eccodarwin-co2flux-monthgrid-v5.thumbnail.co2.fbeee762.webp", import.meta.url).toString();

});

parcelRegister("2qN7t", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("bvewZ").then(()=>parcelRequire("dLe0H"));

});

parcelRegister("5uaOo", function(module, exports) {
module.exports = new URL("emit-plume--cover.c894c9e8.webp", import.meta.url).toString();

});

parcelRegister("jgdrW", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("chylB").then(()=>parcelRequire("dxJWL"));

});

parcelRegister("4bbT8", function(module, exports) {
module.exports = new URL("epa-annual--cover.6246182c.webp", import.meta.url).toString();

});

parcelRegister("dNmk1", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.total.methane.annual.f690954e.webp", import.meta.url).toString();

});

parcelRegister("9nNZ8", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.total.agriculture.annual.b91d8ff1.webp", import.meta.url).toString();

});

parcelRegister("js4uk", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.enteric.fermentation.annual.a6431e35.webp", import.meta.url).toString();

});

parcelRegister("4RK6K", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.agriculture.manure.management.anual.07850204.webp", import.meta.url).toString();

});

parcelRegister("sCgE2", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.agriculture.rice.cultivation.annual.48ee504f.webp", import.meta.url).toString();

});

parcelRegister("2tTRC", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.agriculture.field.burning.annual.91e9059c.webp", import.meta.url).toString();

});

parcelRegister("gfbhF", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.total.natural.gas.systems.annual.58997318.webp", import.meta.url).toString();

});

parcelRegister("cqBuF", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.natural.gas.exploration.annual.da644f24.webp", import.meta.url).toString();

});

parcelRegister("5ep1x", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.natural.gas.production.annual.ac672d45.webp", import.meta.url).toString();

});

parcelRegister("cfLkt", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.natural.gas.transmission.and.storage.annual.f7b4b9d3.webp", import.meta.url).toString();

});

parcelRegister("aCviQ", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.natural.gas.processing.annual.39083168.webp", import.meta.url).toString();

});

parcelRegister("lAp22", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.natural.gas.distribution.annual.0b9d6d56.webp", import.meta.url).toString();

});

parcelRegister("9U7G1", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.natural.gas.post-meter.annual.d8172ac5.webp", import.meta.url).toString();

});

parcelRegister("lmcnE", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.total.petroleum.systems.annual.d40aee29.webp", import.meta.url).toString();

});

parcelRegister("elwWD", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.petroleum.exploration.annual.0de8b8e1.webp", import.meta.url).toString();

});

parcelRegister("3gUV3", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.petroleum.production.annual.bc2204fe.webp", import.meta.url).toString();

});

parcelRegister("ls2Ar", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.petroleum.transportation.annual.aa1a2c6c.webp", import.meta.url).toString();

});

parcelRegister("fJDCc", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.petroleum.refining.annual.8af64570.webp", import.meta.url).toString();

});

parcelRegister("hYQXi", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.total.waste.annual.ce1fce46.webp", import.meta.url).toString();

});

parcelRegister("3AHCb", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.waste.municipal.landfills.annual.68849fd9.webp", import.meta.url).toString();

});

parcelRegister("fUdcY", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.waste.industrial.landfills.annual.29a36f80.webp", import.meta.url).toString();

});

parcelRegister("72eUO", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.waste.domestic.wastewater.annual.b845dc94.webp", import.meta.url).toString();

});

parcelRegister("9b2nz", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.waste.industrial.wastewater.annual.404c056e.webp", import.meta.url).toString();

});

parcelRegister("lpQJO", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.composting.annual.635d9e5e.webp", import.meta.url).toString();

});

parcelRegister("1qgVP", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.total.coal.mines.annual.61fdaeea.webp", import.meta.url).toString();

});

parcelRegister("ekSnQ", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.coal.mining.underground.annual.0ffdd1bf.webp", import.meta.url).toString();

});

parcelRegister("4uNr7", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.coal.mining.abandoned.annual.1b286ddb.webp", import.meta.url).toString();

});

parcelRegister("ipPXW", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.coal.mining.surface.annual.e843d28a.webp", import.meta.url).toString();

});

parcelRegister("hiy8Q", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.total.other.annual.3efa6740.webp", import.meta.url).toString();

});

parcelRegister("fyxTE", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.other.stationary.combustion.annual.2db88a63.webp", import.meta.url).toString();

});

parcelRegister("7hxHa", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.other.mobile.combustion.annual.7a1f1c36.webp", import.meta.url).toString();

});

parcelRegister("jSZhx", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.other.abandoned.oil.gas.annual.b286f012.webp", import.meta.url).toString();

});

parcelRegister("jAHyQ", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.other.petrochemical.production.annual.7ae92d1a.webp", import.meta.url).toString();

});

parcelRegister("k7kwe", function(module, exports) {
module.exports = new URL("epa-ch4emission-yeargrid-v2express.thumbnails.other.ferroalloy.production.annual.20acd208.webp", import.meta.url).toString();

});

parcelRegister("41HVK", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("6ex6U").then(()=>parcelRequire("5Znz5"));

});

parcelRegister("kB86A", function(module, exports) {
module.exports = new URL("goes-ch4plume--cover.650d0c64.webp", import.meta.url).toString();

});

parcelRegister("k0LI2", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("2gM5l").then(()=>parcelRequire("dO0gd"));

});

parcelRegister("4g2c4", function(module, exports) {
module.exports = new URL("oco2-mip-ch4budget-yeargrid-v1--cover.7f4ba8b7.jpg", import.meta.url).toString();

});

parcelRegister("cPIQu", function(module, exports) {
module.exports = new URL("gosat-based-ch4budget-yeargrid-v1.thumbnails.posterior.total.6e0961a9.webp", import.meta.url).toString();

});

parcelRegister("tG87e", function(module, exports) {
module.exports = new URL("gosat-based-ch4budget-yeargrid-v1.thumbnails.posterior.wetlands.667622a2.webp", import.meta.url).toString();

});

parcelRegister("eRWuO", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("afqCa").then(()=>parcelRequire("dT36a"));

});

parcelRegister("78tHT", function(module, exports) {
module.exports = new URL("gra2pes--dataset-cover.6a968f81.webp", import.meta.url).toString();

});

parcelRegister("7wLZR", function(module, exports) {
module.exports = new URL("gra2pes-ghg-monthgrid-v1.thumbnails.total.ba5dfc76.webp", import.meta.url).toString();

});

parcelRegister("34IAF", function(module, exports) {
module.exports = new URL("gra2pes-ghg-co-monthgrid-v1.thumbnails.total.3ca0d0b2.webp", import.meta.url).toString();

});

parcelRegister("j1FVx", function(module, exports) {
module.exports = new URL("gra2pes-ghg-nox-monthgrid-v1.thumbnails.total.f3747779.webp", import.meta.url).toString();

});

parcelRegister("csLWv", function(module, exports) {
module.exports = new URL("gra2pes-ghg-sox-monthgrid-v1.thumbnails.total.93e7c00e.webp", import.meta.url).toString();

});

parcelRegister("2N4PA", function(module, exports) {
module.exports = new URL("gra2pes-ghg-pm25-monthgrid-v1.thumbnails.total.1fb88898.webp", import.meta.url).toString();

});

parcelRegister("aLnTs", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("hs408").then(()=>parcelRequire("oFeGD"));

});

parcelRegister("kSuvA", function(module, exports) {
module.exports = new URL("nist-influx--dataset-cover.0752031a.webp", import.meta.url).toString();

});

parcelRegister("fmeX0", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("fgMen").then(()=>parcelRequire("8G9aR"));

});

parcelRegister("a8UfC", function(module, exports) {
module.exports = new URL("nist-lam--dataset-cover.4342cfbe.webp", import.meta.url).toString();

});

parcelRegister("nayFZ", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("EbqYG").then(()=>parcelRequire("kIszB"));

});

parcelRegister("e95SA", function(module, exports) {
module.exports = new URL("ch4-wetland--cover.87313235.webp", import.meta.url).toString();

});

parcelRegister("28eVC", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("5CXQ8").then(()=>parcelRequire("5HUN5"));

});

parcelRegister("5p4Mz", function(module, exports) {
module.exports = new URL("geos-casa-gfed-cover.85410fe9.jpg", import.meta.url).toString();

});

parcelRegister("dcKo5", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("1JgMx").then(()=>parcelRequire("loKld"));

});

parcelRegister("dUXEf", function(module, exports) {
module.exports = new URL("nist-nec--dataset-cover.f0f31f0a.webp", import.meta.url).toString();

});

parcelRegister("lCNdd", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("5zTox").then(()=>parcelRequire("7ajox"));

});

parcelRegister("jF1yB", function(module, exports) {
module.exports = new URL("noaa-air-samples--cover.c72777b9.webp", import.meta.url).toString();

});

parcelRegister("4oleC", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("bYOkc").then(()=>parcelRequire("kPOQw"));

});

parcelRegister("4yB3w", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("H8c4I").then(()=>parcelRequire("g9kFF"));

});

parcelRegister("cuaQM", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1--cover.7f660c98.webp", import.meta.url).toString();

});

parcelRegister("g2WoW", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1.thumbnails.biosphere.exchange.8b8df2b9.webp", import.meta.url).toString();

});

parcelRegister("4IQQB", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1.thumbnails.biosphere.exchange.uncertainty.e5afde45.webp", import.meta.url).toString();

});

parcelRegister("dDPrK", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1.thumbnails.net.carbon.exchange.2be03f63.webp", import.meta.url).toString();

});

parcelRegister("dsYZX", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1.thumbnails.net.carbon.exchange.uncertainty.d6bc4130.webp", import.meta.url).toString();

});

parcelRegister("ciDZa", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1.thumbnails.net.land.carbon.stock.loss.647620ea.webp", import.meta.url).toString();

});

parcelRegister("h3M0X", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1.thumbnails.net.land.carbon.stock.loss.uncertainty.cfa7f44a.webp", import.meta.url).toString();

});

parcelRegister("cjtgx", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1.thumbnails.lateral.crop.co2.flux.c7178868.webp", import.meta.url).toString();

});

parcelRegister("ax69L", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1.thumbnails.lateral.crop.co2.flux.uncertainty.d888b214.webp", import.meta.url).toString();

});

parcelRegister("bGtQp", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1.thumbnails.fossil.fuel.cement.co2.emissions.1a40cf19.webp", import.meta.url).toString();

});

parcelRegister("gzyTP", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1.thumbnails.fossil.fuel.cement.co2.emissions.uncertainty.fd8e2ed0.webp", import.meta.url).toString();

});

parcelRegister("1FQ71", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1.thumbnails.lateral.river.co2.flux.0008ca6f.webp", import.meta.url).toString();

});

parcelRegister("5CFV6", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1.thumbnails.lateral.river.co2.flux.uncertainty.f63ccbf5.webp", import.meta.url).toString();

});

parcelRegister("rbSdt", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1.thumbnails.lateral.wood.co2.flux.e82e0a40.webp", import.meta.url).toString();

});

parcelRegister("1HNkE", function(module, exports) {
module.exports = new URL("oco2-mip-co2budget-yeargrid-v1.thumbnails.lateral.wood.co2.flux.uncertainty.31333acf.webp", import.meta.url).toString();

});

parcelRegister("dPFv4", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("2iGPd").then(()=>parcelRequire("1PUB9"));

});

parcelRegister("32Jge", function(module, exports) {
module.exports = new URL("oco--dataset-cover.f964f42b.jpg", import.meta.url).toString();

});

parcelRegister("2OPnE", function(module, exports) {
module.exports = new URL("oco2geos-co2-daygrid-v10r.thumbnails.daily.c5c8cc4f.webp", import.meta.url).toString();

});

parcelRegister("dxulp", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("gf2Qk").then(()=>parcelRequire("iHVoF"));

});

parcelRegister("hxIiB", function(module, exports) {
module.exports = new URL("odiac--dataset-cover.63bc8865.jpg", import.meta.url).toString();

});

parcelRegister("dzjhK", function(module, exports) {
module.exports = new URL("odiac-ffco2-monthgrid-v2022.thumbnails.co2.2428b8ef.webp", import.meta.url).toString();

});

parcelRegister("d6NP7", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("4hjum").then(()=>parcelRequire("k5Nt8"));

});

parcelRegister("bVgGj", function(module, exports) {
module.exports = new URL("gpw-yearly--cover.2deb0b71.webp", import.meta.url).toString();

});

parcelRegister("cLmTZ", function(module, exports) {
module.exports = new URL("sedac-popdensity-yeargrid5yr-v4.11.thumbnails.population.density.d980c795.webp", import.meta.url).toString();

});

parcelRegister("gY0my", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("95coX").then(()=>parcelRequire("i4KxO"));

});

parcelRegister("4RGos", function(module, exports) {
module.exports = new URL("vulcan--dataset-cover.99eada4c.webp", import.meta.url).toString();

});

parcelRegister("evGrO", function(module, exports) {
module.exports = new URL("vulcan-co2-yeargrid-v4.thumbnails.total.51e1841a.webp", import.meta.url).toString();

});

parcelRegister("3DwOc", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("kqU7q").then(()=>parcelRequire("gXBOQ"));

});

parcelRegister("fXYOD", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("Ss0Ua").then(()=>parcelRequire("7CwxW"));

});

parcelRegister("kbblz", function(module, exports) {
module.exports = new URL("baltimore_banner.452148e8.webp", import.meta.url).toString();

});

parcelRegister("jaG4Z", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("7trW0").then(()=>parcelRequire("297gv"));

});

parcelRegister("eNAiY", function(module, exports) {
module.exports = new URL("emit_above_planet_v4-1.05c2e6ad.webp", import.meta.url).toString();

});

parcelRegister("a00QF", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("6g98U").then(()=>parcelRequire("b9pms"));

});

parcelRegister("ktpQy", function(module, exports) {
module.exports = new URL("EMIT_AVIRIS3_Data_Insight_Banner_v2.02290e65.webp", import.meta.url).toString();

});

parcelRegister("knavZ", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("ipPEf").then(()=>parcelRequire("eqZud"));

});

parcelRegister("57WOn", function(module, exports) {
module.exports = new URL("EMIT_story_card.7dbd6fb0.webp", import.meta.url).toString();

});

parcelRegister("2AwoR", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("jxA9U").then(()=>parcelRequire("EqS2r"));

});

parcelRegister("jfIyV", function(module, exports) {
module.exports = new URL("EPA_Super_Emitters_card.c3d59a95.webp", import.meta.url).toString();

});

parcelRegister("fAt2m", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("aABTj").then(()=>parcelRequire("c1LQ8"));

});

parcelRegister("bFltN", function(module, exports) {
module.exports = new URL("GOES_story_card_image.e53db582.webp", import.meta.url).toString();

});

parcelRegister("6rl5G", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("6zLRb").then(()=>parcelRequire("9vxfG"));

});

parcelRegister("hH7Lz", function(module, exports) {
module.exports = new URL("gra2pes.bee28672.webp", import.meta.url).toString();

});

parcelRegister("1Cchp", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("4BumT").then(()=>parcelRequire("5TzJh"));

});

parcelRegister("i5lKg", function(module, exports) {
module.exports = new URL("intro-to-ghg-center--cover.137322ee.webp", import.meta.url).toString();

});

parcelRegister("ldstH", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("3yrl5").then(()=>parcelRequire("fUpyc"));

});

parcelRegister("5A7lF", function(module, exports) {
module.exports = new URL("losangeles_banner.e88d58ca.webp", import.meta.url).toString();

});

parcelRegister("9Sbpp", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("4X6H6").then(()=>parcelRequire("h0vHV"));

});

parcelRegister("lUJs0", function(module, exports) {

var $9viiU = parcelRequire("9viiU");




module.exports = Promise.all([
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("bPQAy")),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("gBFRY")),
    $9viiU("9azGc"),
    $9viiU("luOHc")
]).then(()=>parcelRequire("cDGMU"));

});

parcelRegister("mQHYI", function(module, exports) {
module.exports = new URL("Wetlands_image_v2_rs.1c437f53.webp", import.meta.url).toString();

});

parcelRegister("dEVBl", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("boIDd").then(()=>parcelRequire("dE8ku"));

});

parcelRegister("e9Cdj", function(module, exports) {
module.exports = new URL("newyork_banner.f5c75d4e.webp", import.meta.url).toString();

});

parcelRegister("5CUsW", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("9RcMP").then(()=>parcelRequire("4jPj4"));

});

parcelRegister("9th2q", function(module, exports) {
module.exports = new URL("NIST_Methane_Intercomparisons_card.81baa328.webp", import.meta.url).toString();

});

parcelRegister("gRrbW", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("AWDC9").then(()=>parcelRequire("6gLtB"));

});

parcelRegister("d2KHa", function(module, exports) {
module.exports = new URL("US_INC_banner.4b1367a8.webp", import.meta.url).toString();

});

parcelRegister("fK0SA", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("kTieu").then(()=>parcelRequire("agWvS"));

});

parcelRegister("9Qf3p", function(module, exports) {
module.exports = new URL("sanfran_banner.e1731b3f.webp", import.meta.url).toString();

});

parcelRegister("bSDGI", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("3Q4XM").then(()=>parcelRequire("1LcOD"));

});

parcelRegister("i0o2O", function(module, exports) {
module.exports = new URL("tracking-ghg-cycles--cover.fa0968e8.webp", import.meta.url).toString();

});

parcelRegister("cGALg", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("gokci").then(()=>parcelRequire("4jbaG"));

});

parcelRegister("gHdYo", function(module, exports) {

var $9viiU = parcelRequire("9viiU");




module.exports = Promise.all([
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("hM8FP")),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("gBFRY")),
    $9viiU("9azGc"),
    $9viiU("kNYF7")
]).then(()=>parcelRequire("cq99v"));

});

parcelRegister("kMyc3", function(module, exports) {
module.exports = new URL("urban-1.4d6eed7c.webp", import.meta.url).toString();

});

parcelRegister("dJ9lL", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("4yFWq").then(()=>parcelRequire("jUmU8"));

});


parcelRegister("gcFVa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c35ae149058e8ca$export$2e2bcd8739ae039; });

var $atWKR = parcelRequire("atWKR");
const $7c35ae149058e8ca$export$d1755b7eec6664dc = (0, $atWKR.DevseedUiThemeProvider);
var $7c35ae149058e8ca$export$2e2bcd8739ae039 = $7c35ae149058e8ca$export$d1755b7eec6664dc;

});
parcelRegister("atWKR", function(module, exports) {

$parcel$export(module.exports, "add", function () { return $7a1a3049c92d39e5$export$e16d8520af44a096; });
$parcel$export(module.exports, "multiply", function () { return $7a1a3049c92d39e5$export$2060d2db72cce88f; });
$parcel$export(module.exports, "rem", function () { return $7a1a3049c92d39e5$export$fb1897a40d146f7f; });
$parcel$export(module.exports, "themeVal", function () { return $7a1a3049c92d39e5$export$8a7c8beb2538684a; });
$parcel$export(module.exports, "stylizeFunction", function () { return $7a1a3049c92d39e5$export$7838347c282eedba; });
$parcel$export(module.exports, "glsp", function () { return $7a1a3049c92d39e5$export$f3573ed657dcfc0a; });
$parcel$export(module.exports, "rgba", function () { return $7a1a3049c92d39e5$export$4e46ac54fc82cf3b; });
$parcel$export(module.exports, "createUITheme", function () { return $7a1a3049c92d39e5$export$ae3a66f046b9c189; });
$parcel$export(module.exports, "visuallyHidden", function () { return $7a1a3049c92d39e5$export$a1b3edb637fb4f35; });
$parcel$export(module.exports, "listReset", function () { return $7a1a3049c92d39e5$export$8c7c8a1d7156f6c7; });
$parcel$export(module.exports, "truncated", function () { return $7a1a3049c92d39e5$export$23ef198012fb7186; });
$parcel$export(module.exports, "visuallyDisabled", function () { return $7a1a3049c92d39e5$export$7cb898f9e8dbaa44; });
$parcel$export(module.exports, "disabled", function () { return $7a1a3049c92d39e5$export$683472f6198a076e; });
$parcel$export(module.exports, "DevseedUiThemeProvider", function () { return $7a1a3049c92d39e5$export$d1755b7eec6664dc; });
$parcel$export(module.exports, "media", function () { return $7a1a3049c92d39e5$export$987d49ffe1b0900f; });

var $3RyIS = parcelRequire("3RyIS");

var $6fhRl = parcelRequire("6fhRl");
function $7a1a3049c92d39e5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7a1a3049c92d39e5$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7a1a3049c92d39e5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7a1a3049c92d39e5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7a1a3049c92d39e5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7a1a3049c92d39e5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7a1a3049c92d39e5$var$_extends$1() {
    $7a1a3049c92d39e5$var$_extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7a1a3049c92d39e5$var$_extends$1.apply(this, arguments);
}
function $7a1a3049c92d39e5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7a1a3049c92d39e5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7a1a3049c92d39e5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7a1a3049c92d39e5$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function $7a1a3049c92d39e5$var$_slicedToArray(arr, i) {
    return $7a1a3049c92d39e5$var$_arrayWithHoles(arr) || $7a1a3049c92d39e5$var$_iterableToArrayLimit(arr, i) || $7a1a3049c92d39e5$var$_unsupportedIterableToArray(arr, i) || $7a1a3049c92d39e5$var$_nonIterableRest();
}
function $7a1a3049c92d39e5$var$_toConsumableArray(arr) {
    return $7a1a3049c92d39e5$var$_arrayWithoutHoles(arr) || $7a1a3049c92d39e5$var$_iterableToArray(arr) || $7a1a3049c92d39e5$var$_unsupportedIterableToArray(arr) || $7a1a3049c92d39e5$var$_nonIterableSpread();
}
function $7a1a3049c92d39e5$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $7a1a3049c92d39e5$var$_arrayLikeToArray(arr);
}
function $7a1a3049c92d39e5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7a1a3049c92d39e5$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $7a1a3049c92d39e5$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $7a1a3049c92d39e5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7a1a3049c92d39e5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7a1a3049c92d39e5$var$_arrayLikeToArray(o, minLen);
}
function $7a1a3049c92d39e5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7a1a3049c92d39e5$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7a1a3049c92d39e5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $7a1a3049c92d39e5$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $7a1a3049c92d39e5$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var $7a1a3049c92d39e5$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used as references for various `Number` constants. */ var $7a1a3049c92d39e5$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $7a1a3049c92d39e5$var$funcTag = "[object Function]", $7a1a3049c92d39e5$var$genTag = "[object GeneratorFunction]", $7a1a3049c92d39e5$var$symbolTag = "[object Symbol]";
/** Used to match property names within property paths. */ var $7a1a3049c92d39e5$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $7a1a3049c92d39e5$var$reIsPlainProp = /^\w*$/, $7a1a3049c92d39e5$var$reLeadingDot = /^\./, $7a1a3049c92d39e5$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $7a1a3049c92d39e5$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var $7a1a3049c92d39e5$var$reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var $7a1a3049c92d39e5$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $7a1a3049c92d39e5$var$freeGlobal = typeof $7a1a3049c92d39e5$var$commonjsGlobal == "object" && $7a1a3049c92d39e5$var$commonjsGlobal && $7a1a3049c92d39e5$var$commonjsGlobal.Object === Object && $7a1a3049c92d39e5$var$commonjsGlobal;
/** Detect free variable `self`. */ var $7a1a3049c92d39e5$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $7a1a3049c92d39e5$var$root = $7a1a3049c92d39e5$var$freeGlobal || $7a1a3049c92d39e5$var$freeSelf || Function("return this")();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $7a1a3049c92d39e5$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $7a1a3049c92d39e5$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $7a1a3049c92d39e5$var$arrayProto = Array.prototype, $7a1a3049c92d39e5$var$funcProto = Function.prototype, $7a1a3049c92d39e5$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $7a1a3049c92d39e5$var$coreJsData = $7a1a3049c92d39e5$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $7a1a3049c92d39e5$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($7a1a3049c92d39e5$var$coreJsData && $7a1a3049c92d39e5$var$coreJsData.keys && $7a1a3049c92d39e5$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $7a1a3049c92d39e5$var$funcToString = $7a1a3049c92d39e5$var$funcProto.toString;
/** Used to check objects for own properties. */ var $7a1a3049c92d39e5$var$hasOwnProperty = $7a1a3049c92d39e5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7a1a3049c92d39e5$var$objectToString = $7a1a3049c92d39e5$var$objectProto.toString;
/** Used to detect if a method is native. */ var $7a1a3049c92d39e5$var$reIsNative = RegExp("^" + $7a1a3049c92d39e5$var$funcToString.call($7a1a3049c92d39e5$var$hasOwnProperty).replace($7a1a3049c92d39e5$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $7a1a3049c92d39e5$var$Symbol$1 = $7a1a3049c92d39e5$var$root.Symbol, $7a1a3049c92d39e5$var$splice = $7a1a3049c92d39e5$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $7a1a3049c92d39e5$var$Map$1 = $7a1a3049c92d39e5$var$getNative($7a1a3049c92d39e5$var$root, "Map"), $7a1a3049c92d39e5$var$nativeCreate = $7a1a3049c92d39e5$var$getNative(Object, "create");
/** Used to convert symbols to primitives and strings. */ var $7a1a3049c92d39e5$var$symbolProto = $7a1a3049c92d39e5$var$Symbol$1 ? $7a1a3049c92d39e5$var$Symbol$1.prototype : undefined, $7a1a3049c92d39e5$var$symbolToString = $7a1a3049c92d39e5$var$symbolProto ? $7a1a3049c92d39e5$var$symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7a1a3049c92d39e5$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $7a1a3049c92d39e5$var$hashClear() {
    this.__data__ = $7a1a3049c92d39e5$var$nativeCreate ? $7a1a3049c92d39e5$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7a1a3049c92d39e5$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7a1a3049c92d39e5$var$hashGet(key) {
    var data = this.__data__;
    if ($7a1a3049c92d39e5$var$nativeCreate) {
        var result = data[key];
        return result === $7a1a3049c92d39e5$var$HASH_UNDEFINED ? undefined : result;
    }
    return $7a1a3049c92d39e5$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7a1a3049c92d39e5$var$hashHas(key) {
    var data = this.__data__;
    return $7a1a3049c92d39e5$var$nativeCreate ? data[key] !== undefined : $7a1a3049c92d39e5$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7a1a3049c92d39e5$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $7a1a3049c92d39e5$var$nativeCreate && value === undefined ? $7a1a3049c92d39e5$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$7a1a3049c92d39e5$var$Hash.prototype.clear = $7a1a3049c92d39e5$var$hashClear;
$7a1a3049c92d39e5$var$Hash.prototype["delete"] = $7a1a3049c92d39e5$var$hashDelete;
$7a1a3049c92d39e5$var$Hash.prototype.get = $7a1a3049c92d39e5$var$hashGet;
$7a1a3049c92d39e5$var$Hash.prototype.has = $7a1a3049c92d39e5$var$hashHas;
$7a1a3049c92d39e5$var$Hash.prototype.set = $7a1a3049c92d39e5$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7a1a3049c92d39e5$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $7a1a3049c92d39e5$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7a1a3049c92d39e5$var$listCacheDelete(key) {
    var data = this.__data__, index = $7a1a3049c92d39e5$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $7a1a3049c92d39e5$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7a1a3049c92d39e5$var$listCacheGet(key) {
    var data = this.__data__, index = $7a1a3049c92d39e5$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7a1a3049c92d39e5$var$listCacheHas(key) {
    return $7a1a3049c92d39e5$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $7a1a3049c92d39e5$var$listCacheSet(key, value) {
    var data = this.__data__, index = $7a1a3049c92d39e5$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$7a1a3049c92d39e5$var$ListCache.prototype.clear = $7a1a3049c92d39e5$var$listCacheClear;
$7a1a3049c92d39e5$var$ListCache.prototype["delete"] = $7a1a3049c92d39e5$var$listCacheDelete;
$7a1a3049c92d39e5$var$ListCache.prototype.get = $7a1a3049c92d39e5$var$listCacheGet;
$7a1a3049c92d39e5$var$ListCache.prototype.has = $7a1a3049c92d39e5$var$listCacheHas;
$7a1a3049c92d39e5$var$ListCache.prototype.set = $7a1a3049c92d39e5$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7a1a3049c92d39e5$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $7a1a3049c92d39e5$var$mapCacheClear() {
    this.__data__ = {
        "hash": new $7a1a3049c92d39e5$var$Hash,
        "map": new ($7a1a3049c92d39e5$var$Map$1 || $7a1a3049c92d39e5$var$ListCache),
        "string": new $7a1a3049c92d39e5$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7a1a3049c92d39e5$var$mapCacheDelete(key) {
    return $7a1a3049c92d39e5$var$getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7a1a3049c92d39e5$var$mapCacheGet(key) {
    return $7a1a3049c92d39e5$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7a1a3049c92d39e5$var$mapCacheHas(key) {
    return $7a1a3049c92d39e5$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $7a1a3049c92d39e5$var$mapCacheSet(key, value) {
    $7a1a3049c92d39e5$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$7a1a3049c92d39e5$var$MapCache.prototype.clear = $7a1a3049c92d39e5$var$mapCacheClear;
$7a1a3049c92d39e5$var$MapCache.prototype["delete"] = $7a1a3049c92d39e5$var$mapCacheDelete;
$7a1a3049c92d39e5$var$MapCache.prototype.get = $7a1a3049c92d39e5$var$mapCacheGet;
$7a1a3049c92d39e5$var$MapCache.prototype.has = $7a1a3049c92d39e5$var$mapCacheHas;
$7a1a3049c92d39e5$var$MapCache.prototype.set = $7a1a3049c92d39e5$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $7a1a3049c92d39e5$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($7a1a3049c92d39e5$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $7a1a3049c92d39e5$var$baseGet(object, path) {
    path = $7a1a3049c92d39e5$var$isKey(path, object) ? [
        path
    ] : $7a1a3049c92d39e5$var$castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$7a1a3049c92d39e5$var$toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $7a1a3049c92d39e5$var$baseIsNative(value) {
    if (!$7a1a3049c92d39e5$var$isObject(value) || $7a1a3049c92d39e5$var$isMasked(value)) return false;
    var pattern = $7a1a3049c92d39e5$var$isFunction(value) || $7a1a3049c92d39e5$var$isHostObject(value) ? $7a1a3049c92d39e5$var$reIsNative : $7a1a3049c92d39e5$var$reIsHostCtor;
    return pattern.test($7a1a3049c92d39e5$var$toSource(value));
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $7a1a3049c92d39e5$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($7a1a3049c92d39e5$var$isSymbol(value)) return $7a1a3049c92d39e5$var$symbolToString ? $7a1a3049c92d39e5$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$7a1a3049c92d39e5$var$INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function $7a1a3049c92d39e5$var$castPath(value) {
    return $7a1a3049c92d39e5$var$isArray(value) ? value : $7a1a3049c92d39e5$var$stringToPath(value);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $7a1a3049c92d39e5$var$getMapData(map, key) {
    var data = map.__data__;
    return $7a1a3049c92d39e5$var$isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $7a1a3049c92d39e5$var$getNative(object, key) {
    var value = $7a1a3049c92d39e5$var$getValue(object, key);
    return $7a1a3049c92d39e5$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $7a1a3049c92d39e5$var$isKey(value, object) {
    if ($7a1a3049c92d39e5$var$isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $7a1a3049c92d39e5$var$isSymbol(value)) return true;
    return $7a1a3049c92d39e5$var$reIsPlainProp.test(value) || !$7a1a3049c92d39e5$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $7a1a3049c92d39e5$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $7a1a3049c92d39e5$var$isMasked(func) {
    return !!$7a1a3049c92d39e5$var$maskSrcKey && $7a1a3049c92d39e5$var$maskSrcKey in func;
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $7a1a3049c92d39e5$var$stringToPath = $7a1a3049c92d39e5$var$memoize(function(string) {
    string = $7a1a3049c92d39e5$var$toString(string);
    var result = [];
    if ($7a1a3049c92d39e5$var$reLeadingDot.test(string)) result.push("");
    string.replace($7a1a3049c92d39e5$var$rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace($7a1a3049c92d39e5$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $7a1a3049c92d39e5$var$toKey(value) {
    if (typeof value == "string" || $7a1a3049c92d39e5$var$isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$7a1a3049c92d39e5$var$INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $7a1a3049c92d39e5$var$toSource(func) {
    if (func != null) {
        try {
            return $7a1a3049c92d39e5$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $7a1a3049c92d39e5$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError($7a1a3049c92d39e5$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($7a1a3049c92d39e5$var$memoize.Cache || $7a1a3049c92d39e5$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$7a1a3049c92d39e5$var$memoize.Cache = $7a1a3049c92d39e5$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $7a1a3049c92d39e5$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $7a1a3049c92d39e5$var$isArray = Array.isArray;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $7a1a3049c92d39e5$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $7a1a3049c92d39e5$var$isObject(value) ? $7a1a3049c92d39e5$var$objectToString.call(value) : "";
    return tag == $7a1a3049c92d39e5$var$funcTag || tag == $7a1a3049c92d39e5$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $7a1a3049c92d39e5$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $7a1a3049c92d39e5$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $7a1a3049c92d39e5$var$isSymbol(value) {
    return typeof value == "symbol" || $7a1a3049c92d39e5$var$isObjectLike(value) && $7a1a3049c92d39e5$var$objectToString.call(value) == $7a1a3049c92d39e5$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $7a1a3049c92d39e5$var$toString(value) {
    return value == null ? "" : $7a1a3049c92d39e5$var$baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $7a1a3049c92d39e5$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $7a1a3049c92d39e5$var$baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
var $7a1a3049c92d39e5$var$lodash_get = $7a1a3049c92d39e5$var$get;
var $7a1a3049c92d39e5$var$get$1 = $7a1a3049c92d39e5$var$lodash_get;
function $7a1a3049c92d39e5$var$_extends() {
    $7a1a3049c92d39e5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7a1a3049c92d39e5$var$_extends.apply(this, arguments);
}
function $7a1a3049c92d39e5$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $7a1a3049c92d39e5$var$_setPrototypeOf(o, p) {
    $7a1a3049c92d39e5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7a1a3049c92d39e5$var$_setPrototypeOf(o, p);
}
function $7a1a3049c92d39e5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $7a1a3049c92d39e5$var$_setPrototypeOf(subClass, superClass);
}
function $7a1a3049c92d39e5$var$_getPrototypeOf(o) {
    $7a1a3049c92d39e5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7a1a3049c92d39e5$var$_getPrototypeOf(o);
}
function $7a1a3049c92d39e5$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $7a1a3049c92d39e5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7a1a3049c92d39e5$var$_construct(Parent, args, Class) {
    if ($7a1a3049c92d39e5$var$_isNativeReflectConstruct()) $7a1a3049c92d39e5$var$_construct = Reflect.construct;
    else $7a1a3049c92d39e5$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $7a1a3049c92d39e5$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $7a1a3049c92d39e5$var$_construct.apply(null, arguments);
}
function $7a1a3049c92d39e5$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $7a1a3049c92d39e5$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$7a1a3049c92d39e5$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $7a1a3049c92d39e5$var$_construct(Class, arguments, $7a1a3049c92d39e5$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $7a1a3049c92d39e5$var$_setPrototypeOf(Wrapper, Class);
    };
    return $7a1a3049c92d39e5$var$_wrapNativeSuper(Class);
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */ var $7a1a3049c92d39e5$var$PolishedError = /*#__PURE__*/ function(_Error) {
    $7a1a3049c92d39e5$var$_inheritsLoose(PolishedError, _Error);
    function PolishedError(code) {
        var _this;
        _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
        return $7a1a3049c92d39e5$var$_assertThisInitialized(_this);
    }
    return PolishedError;
}(/*#__PURE__*/ $7a1a3049c92d39e5$var$_wrapNativeSuper(Error));
function $7a1a3049c92d39e5$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $7a1a3049c92d39e5$var$convertToInt(red, green, blue) {
    return $7a1a3049c92d39e5$var$colorToInt(red) + "," + $7a1a3049c92d39e5$var$colorToInt(green) + "," + $7a1a3049c92d39e5$var$colorToInt(blue);
}
function $7a1a3049c92d39e5$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $7a1a3049c92d39e5$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
     // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = (hue % 360 + 360) % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $7a1a3049c92d39e5$var$namedColorMap = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "00ffff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "0000ff",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "00ffff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "ff00ff",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "639",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */ function $7a1a3049c92d39e5$var$nameToHex(color) {
    if (typeof color !== "string") return color;
    var normalizedColorName = color.toLowerCase();
    return $7a1a3049c92d39e5$var$namedColorMap[normalizedColorName] ? "#" + $7a1a3049c92d39e5$var$namedColorMap[normalizedColorName] : color;
}
var $7a1a3049c92d39e5$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $7a1a3049c92d39e5$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $7a1a3049c92d39e5$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $7a1a3049c92d39e5$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $7a1a3049c92d39e5$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
var $7a1a3049c92d39e5$var$rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
var $7a1a3049c92d39e5$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var $7a1a3049c92d39e5$var$hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $7a1a3049c92d39e5$var$parseToRgb(color) {
    if (typeof color !== "string") throw new $7a1a3049c92d39e5$var$PolishedError(3);
    var normalizedColor = $7a1a3049c92d39e5$var$nameToHex(color);
    if (normalizedColor.match($7a1a3049c92d39e5$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($7a1a3049c92d39e5$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($7a1a3049c92d39e5$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($7a1a3049c92d39e5$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $7a1a3049c92d39e5$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $7a1a3049c92d39e5$var$rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $7a1a3049c92d39e5$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $7a1a3049c92d39e5$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $7a1a3049c92d39e5$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new $7a1a3049c92d39e5$var$PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $7a1a3049c92d39e5$var$hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $7a1a3049c92d39e5$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $7a1a3049c92d39e5$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new $7a1a3049c92d39e5$var$PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4])
        };
    }
    throw new $7a1a3049c92d39e5$var$PolishedError(5);
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $7a1a3049c92d39e5$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
function $7a1a3049c92d39e5$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $7a1a3049c92d39e5$var$rgb(value, green, blue) {
    if (typeof value === "number" && typeof green === "number" && typeof blue === "number") return $7a1a3049c92d39e5$var$reduceHexValue("#" + $7a1a3049c92d39e5$var$numberToHex(value) + $7a1a3049c92d39e5$var$numberToHex(green) + $7a1a3049c92d39e5$var$numberToHex(blue));
    else if (typeof value === "object" && green === undefined && blue === undefined) return $7a1a3049c92d39e5$var$reduceHexValue("#" + $7a1a3049c92d39e5$var$numberToHex(value.red) + $7a1a3049c92d39e5$var$numberToHex(value.green) + $7a1a3049c92d39e5$var$numberToHex(value.blue));
    throw new $7a1a3049c92d39e5$var$PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $7a1a3049c92d39e5$var$rgba$1(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === "string" && typeof secondValue === "number") {
        var rgbValue = $7a1a3049c92d39e5$var$parseToRgb(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === "number" && typeof secondValue === "number" && typeof thirdValue === "number" && typeof fourthValue === "number") return fourthValue >= 1 ? $7a1a3049c92d39e5$var$rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === "object" && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $7a1a3049c92d39e5$var$rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new $7a1a3049c92d39e5$var$PolishedError(7);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $7a1a3049c92d39e5$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $7a1a3049c92d39e5$var$curried(f, length, combined);
    };
} // eslint-disable-next-line no-redeclare
function $7a1a3049c92d39e5$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $7a1a3049c92d39e5$var$curried(f, f.length, []);
}
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $7a1a3049c92d39e5$var$mix(weight, color, otherColor) {
    if (color === "transparent") return otherColor;
    if (otherColor === "transparent") return color;
    if (weight === 0) return otherColor;
    var parsedColor1 = $7a1a3049c92d39e5$var$parseToRgb(color);
    var color1 = $7a1a3049c92d39e5$var$_extends({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === "number" ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $7a1a3049c92d39e5$var$parseToRgb(otherColor);
    var color2 = $7a1a3049c92d39e5$var$_extends({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === "number" ? parsedColor2.alpha : 1
    }); // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha * (parseFloat(weight) / 1.0) + color2.alpha * (1 - parseFloat(weight) / 1.0)
    };
    return $7a1a3049c92d39e5$var$rgba$1(mixedColor);
} // prettier-ignore
var $7a1a3049c92d39e5$var$curriedMix = /*#__PURE__*/ $7a1a3049c92d39e5$var$curry($7a1a3049c92d39e5$var$mix);
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $7a1a3049c92d39e5$var$shade(percentage, color) {
    if (color === "transparent") return color;
    return $7a1a3049c92d39e5$var$curriedMix(parseFloat(percentage), "rgb(0, 0, 0)", color);
} // prettier-ignore
var $7a1a3049c92d39e5$var$curriedShade = /*#__PURE__*/ $7a1a3049c92d39e5$var$curry($7a1a3049c92d39e5$var$shade);
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $7a1a3049c92d39e5$var$tint(percentage, color) {
    if (color === "transparent") return color;
    return $7a1a3049c92d39e5$var$curriedMix(parseFloat(percentage), "rgb(255, 255, 255)", color);
} // prettier-ignore
var $7a1a3049c92d39e5$var$curriedTint = /*#__PURE__*/ $7a1a3049c92d39e5$var$curry($7a1a3049c92d39e5$var$tint);
/**
 * Creates a math function that performs the given operation taking into account
 * only the unit of the first value. Eg: 2rem * 2 = 4rem | 2 * 2rem = 4
 * The resulting function accepts 2 arguments to which the given operation
 * will be applied.
 * This function is ready to work with styled-components so that any function
 * passed as an argument will receive the component props.
 *
 * @example Simple function
 * const add = createMathOperation('+');
 * add(2, 2) // -> 4
 *
 * @example Using with themeVal()
 * const multiply = createMathOperation('*');
 * multiply(themeVal('globalSpacing'), 2) // -> 2rem
 *
 * @param {string} op Math operation to perform. Can be + - * /
 */ var $7a1a3049c92d39e5$var$createMathOperation = function createMathOperation(op) {
    return function(a, b) {
        return function() {
            a = typeof a === "function" ? a.apply(void 0, arguments) : a;
            b = typeof b === "function" ? b.apply(void 0, arguments) : b; // The final unit is driven by the `a` value.
            var unit = (a + "").match(/[0-9]*(?:.[0-9]+)?(.*)/)[1];
            var aVal = parseFloat(a);
            var bVal = parseFloat(b);
            if (op === "+") return "".concat(aVal + bVal).concat(unit);
            else if (op === "-") return "".concat(aVal - bVal).concat(unit);
            else if (op === "/") return "".concat(aVal / bVal).concat(unit);
            else if (op === "*") return "".concat(aVal * bVal).concat(unit);
        };
    };
};
/**
 * Creates a math function to add values. It takes into account
 * only the unit of the first value. Eg: 2rem + 2 = 4rem | 2 + 2rem = 4
 * This function is ready to work with styled-components so that any function
 * passed as an argument will receive the component props.
 *
 * @param {string} a First value
 * @param {string} b Second value
 */ var $7a1a3049c92d39e5$export$e16d8520af44a096 = $7a1a3049c92d39e5$var$createMathOperation("+");
/**
 * Creates a math function to subtract values. It takes into account
 * only the unit of the first value. Eg: 4rem - 2 = 2rem | 4 - 2rem = 2
 * This function is ready to work with styled-components so that any function
 * passed as an argument will receive the component props.
 *
 * @param {string} a First value
 * @param {string} b Second value
 */ var $7a1a3049c92d39e5$export$4e2d2ead65e5f7e3 = $7a1a3049c92d39e5$var$createMathOperation("-");
/**
 * Creates a math function to divide values. It takes into account
 * only the unit of the first value. Eg: 4rem / 2 = 2rem | 4 / 2rem = 2
 * This function is ready to work with styled-components so that any function
 * passed as an argument will receive the component props.
 *
 * @param {string} a First value
 * @param {string} b Second value
 */ var $7a1a3049c92d39e5$export$cd007d971a5a2143 = $7a1a3049c92d39e5$var$createMathOperation("/");
/**
 * Creates a math function to multiply values. It takes into account
 * only the unit of the first value. Eg: 2rem * 2 = 4rem | 2 * 2rem = 4
 * This function is ready to work with styled-components so that any function
 * passed as an argument will receive the component props.
 *
 * @param {string} a First value
 * @param {string} b Second value
 */ var $7a1a3049c92d39e5$export$2060d2db72cce88f = $7a1a3049c92d39e5$var$createMathOperation("*");
var $7a1a3049c92d39e5$var$createMinMaxOp = function createMinMaxOp(op) {
    return function(a, b) {
        return function() {
            a = typeof a === "function" ? a.apply(void 0, arguments) : a;
            b = typeof b === "function" ? b.apply(void 0, arguments) : b;
            var unitRx = /[0-9]*(?:.[0-9]+)?(.*)/;
            var aUnit = (a + "").match(unitRx)[1];
            var bUnit = (b + "").match(unitRx)[1];
            var aVal = parseFloat(a);
            var bVal = parseFloat(b); // If the values are different but set, return no unit, otherwise return the
            // unit of the value that has it. this is useful when comparing for example
            // 10px with 16.
            var unit = "";
            if (aUnit === bUnit) unit = aUnit;
            else if (aUnit && !bUnit) unit = aUnit;
            else if (!aUnit && bUnit) unit = bUnit;
            if (op === "min") return "".concat(Math.min(aVal, bVal)).concat(unit);
            else if (op === "max") return "".concat(Math.max(aVal, bVal)).concat(unit);
        };
    };
};
/**
 * Creates a math function that returns the minimum of two values. Units are
 * discarded when doing the comparison, but the value is returned with a unit
 * if both arguments has the same one or if only one has it.
 * Eg: 10px, 3px => 3px
 * Eg: 10px, 3 => 3px
 * Eg: 1rem, 3px => 1
 *
 * This function is ready to work with styled-components
 * so that any function passed as an argument will receive the component props.
 *
 * @param {string} a First value
 * @param {string} b Second value
 */ var $7a1a3049c92d39e5$export$96ec731ed4dcb222 = $7a1a3049c92d39e5$var$createMinMaxOp("min");
/**
 * Creates a math function that returns the maximum of two values. Units are
 * discarded when doing the comparison, but the value is returned with a unit
 * if both arguments has the same one or if only one has it.
 * Eg: 10px, 3px => 10px
 * Eg: 10px, 3 => 10px
 * Eg: 1rem, 3px => 3
 *
 * This function is ready to work with styled-components
 * so that any function passed as an argument will receive the component props.
 *
 * @param {string} a First value
 * @param {string} b Second value
 */ var $7a1a3049c92d39e5$export$8960430cfd85939f = $7a1a3049c92d39e5$var$createMinMaxOp("max");
/**
 * Return a function that when executed appends the `unit` to the value.
 *
 * @example
 * const percent = unitify('%');
 * percent(10) // -> 10%
 *
 * @param {string} unit The unit to use
 */ var $7a1a3049c92d39e5$export$9f0cc6ad59c1e4f9 = function unitify(unit) {
    return function(v) {
        return typeof v === "function" ? function() {
            return "".concat(v.apply(void 0, arguments)).concat(unit);
        } : "".concat(v).concat(unit);
    };
};
/**
 * Return the given value with `rem` appended.
 * If value is a function will execute it. This allows to use directly in
 * styled-components with themeVal
 *
 * @see themeVal()
 *
 * @example
 * rem(themeVal('shape.rounded'))
 *
 * @param {mixed} val The value
 */ var $7a1a3049c92d39e5$export$fb1897a40d146f7f = $7a1a3049c92d39e5$export$9f0cc6ad59c1e4f9("rem");
/**
 * Return the given value with `px` appended.
 * If value is a function will execute it. This allows to use directly in
 * styled-components with themeVal
 *
 * @see themeVal()
 *
 * @example
 * px(themeVal('shape.rounded'))
 *
 * @param {mixed} val The value
 */ var $7a1a3049c92d39e5$export$91c0eda1d06bf008 = $7a1a3049c92d39e5$export$9f0cc6ad59c1e4f9("px");
/**
 * Convert the given value to the given unit using the base size defined in the
 * theme. (theme.type.base.root) If value is a function will execute it. This
 * allows to use directly in styled-components with themeVal.
 * Only conversion between rem and px is allowed. Any other destination unit
 * will be ignored and the value returned as is.
 *
 * @example
 * rp2rp(themeVal('layout.max'), 'px')
 *
 * @param {mixed} v The value
 * @param {mixed} unit The destination unit
 *
 * @throws Error if the root type pixel value is not defined.
 */ var $7a1a3049c92d39e5$var$rp2rp = function rp2rp(v, unit) {
    return function() {
        v = typeof v === "function" ? v.apply(void 0, arguments) : v;
        unit = typeof unit === "function" ? unit.apply(void 0, arguments) : unit;
        var rootV = $7a1a3049c92d39e5$var$get$1(arguments.length <= 0 ? undefined : arguments[0], "theme.type.base.root", null);
        if (rootV === null) throw new Error("Root type pixel value not found in theme.type.base.root");
        var srcUnit = (v + "").match(/[0-9]*(?:.[0-9]+)?(.*)/)[1];
        var srcVal = parseFloat(v);
        if (unit === "px") return $7a1a3049c92d39e5$export$91c0eda1d06bf008(srcUnit === "rem" ? srcVal * parseFloat(rootV) : srcVal);
        if (unit === "rem") return $7a1a3049c92d39e5$export$fb1897a40d146f7f(srcUnit === "px" ? srcVal / parseFloat(rootV) : srcVal);
         // Invalid unit - return as is.
        return v;
    };
};
/**
 * Convert the given value to pixels using the base size defined in the theme.
 * (theme.type.base.root)
 * If value is a function will execute it. This allows to use directly in
 * styled-components with themeVal
 *
 * @see rp2rp()
 *
 * @example
 * val2px(themeVal('layout.max'))
 *
 * @param {mixed} val The value
 *
 * @throws Error if the root type pixel value is not defined.
 */ var $7a1a3049c92d39e5$export$63eccb437cf41820 = function val2px(val) {
    return $7a1a3049c92d39e5$var$rp2rp(val, "px");
};
/**
 * Convert the given value to rem using the base size defined in the theme.
 * (theme.type.base.root)
 * If value is a function will execute it. This allows to use directly in
 * styled-components with themeVal
 *
 * @see rp2rp()
 *
 * @example
 * val2rem(themeVal('layout.max'))
 *
 * @param {mixed} val The value
 *
 * @throws Error if the root type pixel value is not defined.
 */ var $7a1a3049c92d39e5$export$a82d5a4f867e20f6 = function val2rem(val) {
    return $7a1a3049c92d39e5$var$rp2rp(val, "rem");
};
/**
 * Returns a function to be used with styled-components and gets a value from
 * the theme property.
 *
 * @param {string} path The path to get from theme
 */ var $7a1a3049c92d39e5$export$8a7c8beb2538684a = function themeVal(path) {
    return function(_ref) {
        var theme = _ref.theme;
        var v = $7a1a3049c92d39e5$var$get$1(theme, path, undefined);
        if (v === undefined) console.error("Theme Value Error: path [".concat(path, "] not found in theme."), theme);
        return v;
    };
};
/**
 * Allows a function to be used with style-components interpolation, passing the
 * component props to each one of the functions arguments if those arguments are
 * functions.
 *
 * Useful in conjunction with themeVal. Instead of:
 * ${(props) => rgba(props.theme.colors.primaryColor, 0.16)}
 * you can do
 * ${rgbaFn(themeVal('colors.primaryColor'), 0.16)}
 *
 * @param {function} fn The function to wrap.
 *
 * @returns {function} Curried function
 */ var $7a1a3049c92d39e5$export$7838347c282eedba = function stylizeFunction(fn) {
    return function() {
        for(var _len = arguments.length, fnArgs = new Array(_len), _key = 0; _key < _len; _key++)fnArgs[_key] = arguments[_key];
        return function() {
            for(var _len2 = arguments.length, props = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)props[_key2] = arguments[_key2];
            var mappedArgs = fnArgs.map(function(arg) {
                return typeof arg === "function" ? arg.apply(void 0, props) : arg;
            });
            return fn.apply(void 0, $7a1a3049c92d39e5$var$_toConsumableArray(mappedArgs));
        };
    };
};
/**
 * Returns the layout.space value form the theme multiplied by the
 * given multiplier.
 *
 * @param {number} m multiplier
 */ var $7a1a3049c92d39e5$export$f3573ed657dcfc0a = function glsp() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    args = args.length ? args : [
        1
    ];
    var fns = args.map(function(m) {
        return $7a1a3049c92d39e5$export$2060d2db72cce88f($7a1a3049c92d39e5$export$8a7c8beb2538684a("layout.space"), m);
    }); // If the there's only one argument return in value format to be used by
    // other methods that need this to resolve to a number.
    if (fns.length === 1) return fns[0];
    var spaces = Array(args.length - 1).fill(" ");
    return (0, $6fhRl.css).apply(void 0, [
        [
            ""
        ].concat($7a1a3049c92d39e5$var$_toConsumableArray(spaces), [
            ""
        ])
    ].concat($7a1a3049c92d39e5$var$_toConsumableArray(fns)));
};
/**
 * Polished rgba function but stylized.
 */ var $7a1a3049c92d39e5$export$4e46ac54fc82cf3b = $7a1a3049c92d39e5$export$7838347c282eedba($7a1a3049c92d39e5$var$rgba$1);
/**
 * Curry the polished rgba function to allow switching the parameters.
 */ var $7a1a3049c92d39e5$var$_rgba = function _rgba(alpha) {
    return function(color) {
        return $7a1a3049c92d39e5$var$rgba$1(color, alpha);
    };
};
var $7a1a3049c92d39e5$var$colorPaletteSettings = [
    {
        code: "50",
        colorFn: $7a1a3049c92d39e5$var$curriedTint(0.96)
    },
    {
        code: "50a",
        colorFn: $7a1a3049c92d39e5$var$_rgba(0.04)
    },
    {
        code: "100",
        colorFn: $7a1a3049c92d39e5$var$curriedTint(0.92)
    },
    {
        code: "100a",
        colorFn: $7a1a3049c92d39e5$var$_rgba(0.08)
    },
    {
        code: "200",
        colorFn: $7a1a3049c92d39e5$var$curriedTint(0.84)
    },
    {
        code: "200a",
        colorFn: $7a1a3049c92d39e5$var$_rgba(0.16)
    },
    {
        code: "300",
        colorFn: $7a1a3049c92d39e5$var$curriedTint(0.68)
    },
    {
        code: "300a",
        colorFn: $7a1a3049c92d39e5$var$_rgba(0.32)
    },
    {
        code: "400",
        colorFn: $7a1a3049c92d39e5$var$curriedTint(0.36)
    },
    {
        code: "400a",
        colorFn: $7a1a3049c92d39e5$var$_rgba(0.64)
    },
    {
        code: "500",
        colorFn: function colorFn(v) {
            return v;
        }
    },
    {
        code: "600",
        colorFn: $7a1a3049c92d39e5$var$curriedShade(0.16)
    },
    {
        code: "700",
        colorFn: $7a1a3049c92d39e5$var$curriedShade(0.32)
    },
    {
        code: "800",
        colorFn: $7a1a3049c92d39e5$var$curriedShade(0.48)
    },
    {
        code: "900",
        colorFn: $7a1a3049c92d39e5$var$curriedShade(0.64)
    }
];
/**
 * Creates a color palette base off of the provided base color including
 * lightened/darkened/transparent versions of that color.
 *
 * Uses a scale from 50 - 900 to indicate the color value. Values lower than 500
 * are lightened, above 500 are darkened and values ending with `a` have a alpha
 * channel.
 *
 * List of returned colors:
 * name-50      Lightened 96%
 * name-50a     Opacity 4%
 * name-100     Lightened 92%
 * name-100a    Opacity 8%
 * name-200     Lightened 84%
 * name-200a    Opacity 16%
 * name-300     Lightened 68%
 * name-300a    Opacity 32%
 * name-400     Lightened 36%
 * name-400a    Opacity 64%
 * name-500     Same as base color
 * name-600     Darkened 16%
 * name-700     Darkened 32%
 * name-800     Darkened 48%
 * name-900     Darkened 64%
 *
 * @param {string} name Name of the color variable
 * @param {string} baseColor Base color for the palette. Used as middle color
 * with value 500.
 *
 * @returns object
 */ function $7a1a3049c92d39e5$export$e48ea82efb9e52cb(name, baseColor) {
    return $7a1a3049c92d39e5$var$colorPaletteSettings.reduce(function(acc, c) {
        return $7a1a3049c92d39e5$var$_objectSpread2($7a1a3049c92d39e5$var$_objectSpread2({}, acc), {}, $7a1a3049c92d39e5$var$_defineProperty({}, "".concat(name, "-").concat(c.code), c.colorFn(baseColor)));
    }, {});
}
var $7a1a3049c92d39e5$var$_excluded$1 = [
    "color",
    "type",
    "shape",
    "layout",
    "button",
    "boxShadow",
    "mediaRanges"
], $7a1a3049c92d39e5$var$_excluded2 = [
    "surface",
    "base",
    "primary",
    "secondary",
    "danger",
    "warning",
    "success",
    "info",
    "background",
    "link"
], $7a1a3049c92d39e5$var$_excluded3 = [
    "base",
    "heading",
    "overline"
], $7a1a3049c92d39e5$var$_excluded4 = [
    "size",
    "line",
    "color",
    "family",
    "style",
    "settings",
    "case",
    "light",
    "regular",
    "medium",
    "bold",
    "weight",
    "antialiasing"
], $7a1a3049c92d39e5$var$_excluded5 = [
    "family",
    "style",
    "settings",
    "case",
    "light",
    "regular",
    "medium",
    "bold",
    "weight",
    "textTransform"
], $7a1a3049c92d39e5$var$_excluded6 = [
    "family",
    "style",
    "settings",
    "case",
    "light",
    "regular",
    "medium",
    "bold",
    "weight",
    "textTransform"
], $7a1a3049c92d39e5$var$_excluded7 = [
    "rounded",
    "ellipsoid"
], $7a1a3049c92d39e5$var$_excluded8 = [
    "space",
    "border",
    "min",
    "max"
], $7a1a3049c92d39e5$var$_excluded9 = [
    "type",
    "shape"
], $7a1a3049c92d39e5$var$_excluded10 = [
    "family",
    "style",
    "settings",
    "case",
    "weight"
], $7a1a3049c92d39e5$var$_excluded11 = [
    "border",
    "rounded"
], $7a1a3049c92d39e5$var$_excluded12 = [
    "inset",
    "input",
    "elevationA",
    "elevationB",
    "elevationC",
    "elevationD"
];
/**
 * Creates a UI theme by combining the provided options with the default ones.
 * When an override for a value is provided, it gets propagated to all the
 * variables that use that value. For example: The primary color will be used
 * for links unless a color for "link" is provided.
 *
 * @param {DevseedUITheme} definition The theme definition
 *
 * @returns DevseedUITheme
 */ function $7a1a3049c92d39e5$export$ae3a66f046b9c189() {
    var definition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _definition$color = definition.color, color = _definition$color === void 0 ? {} : _definition$color, _definition$type = definition.type, type = _definition$type === void 0 ? {} : _definition$type, _definition$shape = definition.shape, shape = _definition$shape === void 0 ? {} : _definition$shape, _definition$layout = definition.layout, layout = _definition$layout === void 0 ? {} : _definition$layout, _definition$button = definition.button, button = _definition$button === void 0 ? {} : _definition$button, _definition$boxShadow = definition.boxShadow, boxShadow = _definition$boxShadow === void 0 ? {} : _definition$boxShadow, _definition$mediaRang = definition.mediaRanges, mediaRanges = _definition$mediaRang === void 0 ? {} : _definition$mediaRang, customDefinition = $7a1a3049c92d39e5$var$_objectWithoutProperties(definition, $7a1a3049c92d39e5$var$_excluded$1);
    var _color$surface = color.surface, surface = _color$surface === void 0 ? "#FFFFFF" : _color$surface, _color$base = color.base, base = _color$base === void 0 ? "#443F3F" : _color$base, _color$primary = color.primary, primary = _color$primary === void 0 ? "#CF3F02" : _color$primary, _color$secondary = color.secondary, secondary = _color$secondary === void 0 ? "#E2C044" : _color$secondary, _color$danger = color.danger, danger = _color$danger === void 0 ? "#A71D31" : _color$danger, _color$warning = color.warning, warning = _color$warning === void 0 ? "#E2C044" : _color$warning, _color$success = color.success, success = _color$success === void 0 ? "#4DA167" : _color$success, _color$info = color.info, info = _color$info === void 0 ? "#2E86AB" : _color$info, background = color.background, link = color.link, customColors = $7a1a3049c92d39e5$var$_objectWithoutProperties(color, $7a1a3049c92d39e5$var$_excluded2);
    var colorScales = $7a1a3049c92d39e5$var$_objectSpread2($7a1a3049c92d39e5$var$_objectSpread2($7a1a3049c92d39e5$var$_objectSpread2($7a1a3049c92d39e5$var$_objectSpread2($7a1a3049c92d39e5$var$_objectSpread2($7a1a3049c92d39e5$var$_objectSpread2($7a1a3049c92d39e5$var$_objectSpread2($7a1a3049c92d39e5$var$_objectSpread2({}, $7a1a3049c92d39e5$export$e48ea82efb9e52cb("base", base)), $7a1a3049c92d39e5$export$e48ea82efb9e52cb("surface", surface)), $7a1a3049c92d39e5$export$e48ea82efb9e52cb("primary", primary)), $7a1a3049c92d39e5$export$e48ea82efb9e52cb("secondary", secondary)), $7a1a3049c92d39e5$export$e48ea82efb9e52cb("danger", danger)), $7a1a3049c92d39e5$export$e48ea82efb9e52cb("warning", warning)), $7a1a3049c92d39e5$export$e48ea82efb9e52cb("success", success)), $7a1a3049c92d39e5$export$e48ea82efb9e52cb("info", info));
    var _type$base = type.base, typeBase = _type$base === void 0 ? {} : _type$base, _type$heading = type.heading, typeHeading = _type$heading === void 0 ? {} : _type$heading, _type$overline = type.overline, typeOverline = _type$overline === void 0 ? {} : _type$overline, customType = $7a1a3049c92d39e5$var$_objectWithoutProperties(type, $7a1a3049c92d39e5$var$_excluded3);
    var _typeBase$size = typeBase.size, typeBaseSize = _typeBase$size === void 0 ? "1rem" : _typeBase$size, _typeBase$line = typeBase.line, typeBaseLine = _typeBase$line === void 0 ? "calc(0.5rem + 1em)" : _typeBase$line, _typeBase$color = typeBase.color, typeBaseColor = _typeBase$color === void 0 ? base : _typeBase$color, _typeBase$family = typeBase.family, typeBaseFamily = _typeBase$family === void 0 ? '"Open Sans", sans-serif' : _typeBase$family, _typeBase$style = typeBase.style, typeBaseStyle = _typeBase$style === void 0 ? "normal" : _typeBase$style, _typeBase$settings = typeBase.settings, typeBaseSettings = _typeBase$settings === void 0 ? "'pnum' 0" : _typeBase$settings, _typeBase$case = typeBase.case, typeBaseCase = _typeBase$case === void 0 ? "none" : _typeBase$case, _typeBase$light = typeBase.light, typeBaseLight = _typeBase$light === void 0 ? 300 : _typeBase$light, _typeBase$regular = typeBase.regular, typeBaseRegular = _typeBase$regular === void 0 ? 400 : _typeBase$regular, _typeBase$medium = typeBase.medium, typeBaseMedium = _typeBase$medium === void 0 ? 600 : _typeBase$medium, _typeBase$bold = typeBase.bold, typeBaseBold = _typeBase$bold === void 0 ? 700 : _typeBase$bold, _typeBase$weight = typeBase.weight, typeBaseWeight = _typeBase$weight === void 0 ? 300 : _typeBase$weight, _typeBase$antialiasin = typeBase.antialiasing, typeBaseAntialiasing = _typeBase$antialiasin === void 0 ? true : _typeBase$antialiasin, customTypeBase = $7a1a3049c92d39e5$var$_objectWithoutProperties(typeBase, $7a1a3049c92d39e5$var$_excluded4);
    var _typeBase$leadSize = typeBase.leadSize, typeLeadSize = _typeBase$leadSize === void 0 ? "calc(".concat(typeBaseSize, " * 1.5)") : _typeBase$leadSize;
    var _typeHeading$family = typeHeading.family, typeHeadingFamily = _typeHeading$family === void 0 ? typeBaseFamily : _typeHeading$family, _typeHeading$style = typeHeading.style, typeHeadingStyle = _typeHeading$style === void 0 ? typeBaseStyle : _typeHeading$style, _typeHeading$settings = typeHeading.settings, typeHeadingSettings = _typeHeading$settings === void 0 ? '"wdth" 80, "wght" 780' : _typeHeading$settings, _typeHeading$case = typeHeading.case, typeHeadingCase = _typeHeading$case === void 0 ? typeBaseCase : _typeHeading$case, _typeHeading$light = typeHeading.light, typeHeadingLight = _typeHeading$light === void 0 ? typeBaseLight : _typeHeading$light, _typeHeading$regular = typeHeading.regular, typeHeadingRegular = _typeHeading$regular === void 0 ? typeBaseRegular : _typeHeading$regular, _typeHeading$medium = typeHeading.medium, typeHeadingMedium = _typeHeading$medium === void 0 ? typeBaseMedium : _typeHeading$medium, _typeHeading$bold = typeHeading.bold, typeHeadingBold = _typeHeading$bold === void 0 ? typeBaseBold : _typeHeading$bold, _typeHeading$weight = typeHeading.weight, typeHeadingWeight = _typeHeading$weight === void 0 ? typeBaseBold : _typeHeading$weight, _typeHeading$textTran = typeHeading.textTransform, typeHeadingTextTransform = _typeHeading$textTran === void 0 ? "none" : _typeHeading$textTran, customTypeHeading = $7a1a3049c92d39e5$var$_objectWithoutProperties(typeHeading, $7a1a3049c92d39e5$var$_excluded5);
    var _typeOverline$family = typeOverline.family, typeOverlineFamily = _typeOverline$family === void 0 ? typeBaseFamily : _typeOverline$family, _typeOverline$style = typeOverline.style, typeOverlineStyle = _typeOverline$style === void 0 ? typeBaseStyle : _typeOverline$style, _typeOverline$setting = typeOverline.settings, typeOverlineSettings = _typeOverline$setting === void 0 ? typeBaseSettings : _typeOverline$setting, _typeOverline$case = typeOverline.case, typeOverlineCase = _typeOverline$case === void 0 ? typeBaseCase : _typeOverline$case, _typeOverline$light = typeOverline.light, typeOverlineLight = _typeOverline$light === void 0 ? typeBaseLight : _typeOverline$light, _typeOverline$regular = typeOverline.regular, typeOverlineRegular = _typeOverline$regular === void 0 ? typeBaseRegular : _typeOverline$regular, _typeOverline$medium = typeOverline.medium, typeOverlineMedium = _typeOverline$medium === void 0 ? typeBaseMedium : _typeOverline$medium, _typeOverline$bold = typeOverline.bold, typeOverlineBold = _typeOverline$bold === void 0 ? typeBaseBold : _typeOverline$bold, _typeOverline$weight = typeOverline.weight, typeOverlineWeight = _typeOverline$weight === void 0 ? typeBaseBold : _typeOverline$weight, _typeOverline$textTra = typeOverline.textTransform, typeOverlineTextTransform = _typeOverline$textTra === void 0 ? "uppercase" : _typeOverline$textTra, customTypeOverline = $7a1a3049c92d39e5$var$_objectWithoutProperties(typeOverline, $7a1a3049c92d39e5$var$_excluded6);
    var _shape$rounded = shape.rounded, rounded = _shape$rounded === void 0 ? "0.25rem" : _shape$rounded, _shape$ellipsoid = shape.ellipsoid, ellipsoid = _shape$ellipsoid === void 0 ? "320rem" : _shape$ellipsoid, customShape = $7a1a3049c92d39e5$var$_objectWithoutProperties(shape, $7a1a3049c92d39e5$var$_excluded7);
    var _layout$space = layout.space, space = _layout$space === void 0 ? "1rem" : _layout$space, _layout$border = layout.border, border = _layout$border === void 0 ? "1px" : _layout$border, _layout$min = layout.min, min = _layout$min === void 0 ? "320px" : _layout$min, _layout$max = layout.max, max = _layout$max === void 0 ? "1280px" : _layout$max, customLayout = $7a1a3049c92d39e5$var$_objectWithoutProperties(layout, $7a1a3049c92d39e5$var$_excluded8);
    var _button$type = button.type, buttonType = _button$type === void 0 ? {} : _button$type, _button$shape = button.shape, buttonShape = _button$shape === void 0 ? {} : _button$shape, customButton = $7a1a3049c92d39e5$var$_objectWithoutProperties(button, $7a1a3049c92d39e5$var$_excluded9);
    var _buttonType$family = buttonType.family, buttonTypeFamily = _buttonType$family === void 0 ? typeBaseFamily : _buttonType$family, _buttonType$style = buttonType.style, buttonTypeStyle = _buttonType$style === void 0 ? typeBaseStyle : _buttonType$style, _buttonType$settings = buttonType.settings, buttonTypeSettings = _buttonType$settings === void 0 ? typeBaseSettings : _buttonType$settings, _buttonType$case = buttonType.case, buttonTypeCase = _buttonType$case === void 0 ? typeBaseCase : _buttonType$case, _buttonType$weight = buttonType.weight, buttonTypeWeight = _buttonType$weight === void 0 ? typeBaseBold : _buttonType$weight, customButtonType = $7a1a3049c92d39e5$var$_objectWithoutProperties(buttonType, $7a1a3049c92d39e5$var$_excluded10);
    var _buttonShape$border = buttonShape.border, buttonShapeBorder = _buttonShape$border === void 0 ? border : _buttonShape$border, _buttonShape$rounded = buttonShape.rounded, buttonShapeRounded = _buttonShape$rounded === void 0 ? rounded : _buttonShape$rounded, customButtonShape = $7a1a3049c92d39e5$var$_objectWithoutProperties(buttonShape, $7a1a3049c92d39e5$var$_excluded11);
    var _boxShadow$inset = boxShadow.inset, inset = _boxShadow$inset === void 0 ? "inset 0px 0px 3px 0px ".concat(colorScales["base-50a"], ";") : _boxShadow$inset, _boxShadow$input = boxShadow.input, input = _boxShadow$input === void 0 ? "0 -1px 1px 0 ".concat(colorScales["base-100a"], ", 0 2px 6px 0 ").concat(colorScales["base-200a"], ";") : _boxShadow$input, _boxShadow$elevationA = boxShadow.elevationA, elevationA = _boxShadow$elevationA === void 0 ? "0 0 4px 0 ".concat(colorScales["base-100a"], ", 0 2px 2px 0 ").concat(colorScales["base-100a"], ";") : _boxShadow$elevationA, _boxShadow$elevationB = boxShadow.elevationB, elevationB = _boxShadow$elevationB === void 0 ? "0 0 4px 0 ".concat(colorScales["base-100a"], ", 0 4px 4px 0 ").concat(colorScales["base-100a"], ";") : _boxShadow$elevationB, _boxShadow$elevationC = boxShadow.elevationC, elevationC = _boxShadow$elevationC === void 0 ? "0 0 4px 0 ".concat(colorScales["base-100a"], ", 0 8px 12px 0 ").concat(colorScales["base-100a"], ";") : _boxShadow$elevationC, _boxShadow$elevationD = boxShadow.elevationD, elevationD = _boxShadow$elevationD === void 0 ? "0 0 4px 0 ".concat(colorScales["base-100a"], ", 0 12px 24px 0 ").concat(colorScales["base-100a"], ";") : _boxShadow$elevationD, customBoxShadow = $7a1a3049c92d39e5$var$_objectWithoutProperties(boxShadow, $7a1a3049c92d39e5$var$_excluded12);
    var _mediaRanges$xsmall = mediaRanges.xsmall, xsmall = _mediaRanges$xsmall === void 0 ? [
        null,
        543
    ] : _mediaRanges$xsmall, _mediaRanges$small = mediaRanges.small, small = _mediaRanges$small === void 0 ? [
        544,
        767
    ] : _mediaRanges$small, _mediaRanges$medium = mediaRanges.medium, medium = _mediaRanges$medium === void 0 ? [
        768,
        991
    ] : _mediaRanges$medium, _mediaRanges$large = mediaRanges.large, large = _mediaRanges$large === void 0 ? [
        992,
        1215
    ] : _mediaRanges$large, _mediaRanges$xlarge = mediaRanges.xlarge, xlarge = _mediaRanges$xlarge === void 0 ? [
        1216,
        null
    ] : _mediaRanges$xlarge; //
    // Theme object definition
    return $7a1a3049c92d39e5$var$_objectSpread2($7a1a3049c92d39e5$var$_objectSpread2({}, customDefinition), {}, {
        color: $7a1a3049c92d39e5$var$_objectSpread2($7a1a3049c92d39e5$var$_objectSpread2({
            // base color for the site. Text and all elements that are not colored.
            // required
            base: base,
            // Background color for filled elements that sit on top of the body.
            // (cards, panel, modal...)
            // required
            surface: surface,
            // required
            primary: primary,
            // required
            secondary: secondary,
            // States colors
            // required
            danger: danger,
            // required
            warning: warning,
            // required
            success: success,
            // required
            info: info,
            // Only used for body color. Uses surface if not provided.
            background: background || surface,
            // Color for links. Uses primary if not defined
            link: link || primary
        }, customColors), colorScales),
        type: $7a1a3049c92d39e5$var$_objectSpread2({
            base: $7a1a3049c92d39e5$var$_objectSpread2({
                size: typeBaseSize,
                leadSize: typeLeadSize,
                line: typeBaseLine,
                color: typeBaseColor,
                family: typeBaseFamily,
                style: typeBaseStyle,
                settings: typeBaseSettings,
                case: typeBaseCase,
                light: typeBaseLight,
                regular: typeBaseRegular,
                medium: typeBaseMedium,
                bold: typeBaseBold,
                weight: typeBaseWeight,
                antialiasing: typeBaseAntialiasing
            }, customTypeBase),
            heading: $7a1a3049c92d39e5$var$_objectSpread2({
                family: typeHeadingFamily,
                style: typeHeadingStyle,
                settings: typeHeadingSettings,
                case: typeHeadingCase,
                light: typeHeadingLight,
                regular: typeHeadingRegular,
                medium: typeHeadingMedium,
                bold: typeHeadingBold,
                weight: typeHeadingWeight,
                textTransform: typeHeadingTextTransform
            }, customTypeHeading),
            overline: $7a1a3049c92d39e5$var$_objectSpread2({
                family: typeOverlineFamily,
                style: typeOverlineStyle,
                settings: typeOverlineSettings,
                case: typeOverlineCase,
                light: typeOverlineLight,
                regular: typeOverlineRegular,
                medium: typeOverlineMedium,
                bold: typeOverlineBold,
                weight: typeOverlineWeight,
                textTransform: typeOverlineTextTransform
            }, customTypeOverline)
        }, customType),
        shape: $7a1a3049c92d39e5$var$_objectSpread2({
            rounded: rounded,
            ellipsoid: ellipsoid
        }, customShape),
        layout: $7a1a3049c92d39e5$var$_objectSpread2({
            space: space,
            border: border,
            min: min,
            max: max
        }, customLayout),
        button: $7a1a3049c92d39e5$var$_objectSpread2({
            type: $7a1a3049c92d39e5$var$_objectSpread2({
                family: buttonTypeFamily,
                style: buttonTypeStyle,
                settings: buttonTypeSettings,
                case: buttonTypeCase,
                weight: buttonTypeWeight
            }, customButtonType),
            shape: $7a1a3049c92d39e5$var$_objectSpread2({
                border: buttonShapeBorder,
                rounded: buttonShapeRounded
            }, customButtonShape)
        }, customButton),
        boxShadow: $7a1a3049c92d39e5$var$_objectSpread2({
            inset: inset,
            input: input,
            elevationA: elevationA,
            elevationB: elevationB,
            elevationC: elevationC,
            elevationD: elevationD
        }, customBoxShadow),
        mediaRanges: {
            xsmall: xsmall,
            small: small,
            medium: medium,
            large: large,
            xlarge: xlarge
        }
    });
}
var $7a1a3049c92d39e5$export$bca14c5b3b88a9c9 = {
    main: $7a1a3049c92d39e5$export$ae3a66f046b9c189()
};
var $7a1a3049c92d39e5$var$_templateObject$2, $7a1a3049c92d39e5$var$_templateObject2$1, $7a1a3049c92d39e5$var$_templateObject3$1, $7a1a3049c92d39e5$var$_templateObject4, $7a1a3049c92d39e5$var$_templateObject5, $7a1a3049c92d39e5$var$_templateObject6, $7a1a3049c92d39e5$var$_templateObject7, $7a1a3049c92d39e5$var$_templateObject8;
var $7a1a3049c92d39e5$export$8ecd7e63f0374d6b = function antialiased() {
    return (0, $6fhRl.css)($7a1a3049c92d39e5$var$_templateObject$2 || ($7a1a3049c92d39e5$var$_templateObject$2 = $7a1a3049c92d39e5$var$_taggedTemplateLiteral([
        "\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n"
    ])));
}; // Hide only visually, but have it available for screen readers.
var $7a1a3049c92d39e5$export$a1b3edb637fb4f35 = function visuallyHidden() {
    return (0, $6fhRl.css)($7a1a3049c92d39e5$var$_templateObject2$1 || ($7a1a3049c92d39e5$var$_templateObject2$1 = $7a1a3049c92d39e5$var$_taggedTemplateLiteral([
        "\n  border: 0 none;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n"
    ])));
};
var $7a1a3049c92d39e5$export$8c7c8a1d7156f6c7 = function listReset() {
    return (0, $6fhRl.css)($7a1a3049c92d39e5$var$_templateObject3$1 || ($7a1a3049c92d39e5$var$_templateObject3$1 = $7a1a3049c92d39e5$var$_taggedTemplateLiteral([
        "\n  margin: 0;\n  padding: 0;\n  list-style: none;\n"
    ])));
};
var $7a1a3049c92d39e5$export$23ef198012fb7186 = function truncated() {
    return (0, $6fhRl.css)($7a1a3049c92d39e5$var$_templateObject4 || ($7a1a3049c92d39e5$var$_templateObject4 = $7a1a3049c92d39e5$var$_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ])));
};
var $7a1a3049c92d39e5$export$7cb898f9e8dbaa44 = function visuallyDisabled() {
    return (0, $6fhRl.css)($7a1a3049c92d39e5$var$_templateObject5 || ($7a1a3049c92d39e5$var$_templateObject5 = $7a1a3049c92d39e5$var$_taggedTemplateLiteral([
        "\n  opacity: 0.48;\n  cursor: not-allowed;\n"
    ])));
};
var $7a1a3049c92d39e5$export$683472f6198a076e = function disabled() {
    return (0, $6fhRl.css)($7a1a3049c92d39e5$var$_templateObject6 || ($7a1a3049c92d39e5$var$_templateObject6 = $7a1a3049c92d39e5$var$_taggedTemplateLiteral([
        "\n  opacity: 0.48;\n  pointer-events: none;\n"
    ])));
};
var $7a1a3049c92d39e5$export$1b93d9625e5bc3ec = function unscrollableY() {
    return (0, $6fhRl.css)($7a1a3049c92d39e5$var$_templateObject7 || ($7a1a3049c92d39e5$var$_templateObject7 = $7a1a3049c92d39e5$var$_taggedTemplateLiteral([
        "\n  overflow-y: hidden;\n"
    ])));
};
var $7a1a3049c92d39e5$export$6ecdca8b3ca86b66 = function unscrollableX() {
    return (0, $6fhRl.css)($7a1a3049c92d39e5$var$_templateObject8 || ($7a1a3049c92d39e5$var$_templateObject8 = $7a1a3049c92d39e5$var$_taggedTemplateLiteral([
        "\n  overflow-x: hidden;\n"
    ])));
};
var $7a1a3049c92d39e5$var$_excluded = [
    "children",
    "theme"
];
var $7a1a3049c92d39e5$var$_templateObject$1, $7a1a3049c92d39e5$var$_templateObject2, $7a1a3049c92d39e5$var$_templateObject3;
// This way they're only rendered when absolutely needed.
var $7a1a3049c92d39e5$var$baseStyles = (0, $6fhRl.css)($7a1a3049c92d39e5$var$_templateObject$1 || ($7a1a3049c92d39e5$var$_templateObject$1 = $7a1a3049c92d39e5$var$_taggedTemplateLiteral([
    "\n  /**\n   * Based on\n   * https://hankchizljaw.com/wrote/a-modern-css-reset/\n   */\n\n  /* Box sizing rules */\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n\n  /* Set core root defaults */\n  html:focus-within {\n    scroll-behavior: smooth;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  }\n\n  /* Set default line-height */\n  * {\n    line-height: ",
    ";\n  }\n\n  /* Remove default margin */\n  body,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  ul,\n  ol,\n  li,\n  figure,\n  blockquote,\n  dl,\n  dd {\n    margin: 0;\n  }\n\n  /* Remove list styles on ul, ol elements with a list role, which suggests\n  default styling will be removed */\n  ul[role='list'],\n  ol[role='list'] {\n    list-style: none;\n    padding: 0;\n  }\n\n  /* Set core <body> defaults */\n  body {\n    background-color: ",
    ";\n    color: ",
    ";\n    font-size: ",
    ";\n    /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */\n    font-family: ",
    ";\n    text-transform: ",
    ";\n    font-weight: ",
    ";\n    font-style: ",
    ";\n    font-variation-settings: ",
    ";\n    min-width: ",
    ";\n    min-height: 100vh;\n    text-rendering: optimizeSpeed;\n\n    ",
    "\n  }\n\n  /* Apply some default styles to <a> elements without a class */\n  a:not([class]) {\n    cursor: pointer;\n    color: ",
    ";\n    text-decoration: none;\n    transition: opacity 0.24s ease 0s;\n\n    &:visited {\n      color: ",
    ";\n    }\n\n    &:hover {\n      opacity: 0.64;\n    }\n\n    &:active {\n      transform: translate(0, 1px);\n    }\n  }\n\n  /* Make images easier to work with */\n  img,\n  picture {\n    max-width: 100%;\n    display: block;\n  }\n\n  /* Inherit fonts for <input> and <button> */\n  input,\n  button,\n  textarea,\n  select {\n    font: inherit;\n  }\n\n  /* Text-level semantics */\n  b,\n  strong {\n    font-weight: ",
    ";\n  }\n\n  /* Remove all animations and transitions for people that prefer not to see them */\n  @media (prefers-reduced-motion: reduce) {\n    html:focus-within {\n      scroll-behavior: auto;\n    }\n\n    *,\n    *::before,\n    *::after {\n      animation-duration: 0.01ms !important;\n      animation-iteration-count: 1 !important;\n      transition-duration: 0.01ms !important;\n      scroll-behavior: auto !important;\n    }\n  }\n\n  /* Misc */\n  ::selection {\n    background-color: ",
    ";\n    color: ",
    ";\n  }\n\n  .tether-element {\n    z-index: 1000;\n  }\n\n  .unscrollable-y {\n    ",
    "\n  }\n\n  .unscrollable-x {\n    ",
    "\n  }\n"
])), $7a1a3049c92d39e5$export$8a7c8beb2538684a("type.base.line"), $7a1a3049c92d39e5$export$8a7c8beb2538684a("color.background"), $7a1a3049c92d39e5$export$8a7c8beb2538684a("type.base.color"), $7a1a3049c92d39e5$export$8a7c8beb2538684a("type.base.size"), $7a1a3049c92d39e5$export$8a7c8beb2538684a("type.base.family"), $7a1a3049c92d39e5$export$8a7c8beb2538684a("type.base.case"), $7a1a3049c92d39e5$export$8a7c8beb2538684a("type.base.weight"), $7a1a3049c92d39e5$export$8a7c8beb2538684a("type.base.style"), $7a1a3049c92d39e5$export$8a7c8beb2538684a("type.base.settings"), $7a1a3049c92d39e5$export$8a7c8beb2538684a("layout.min"), function(_ref) {
    var theme = _ref.theme;
    return theme.type.base.antialiasing && (0, $6fhRl.css)($7a1a3049c92d39e5$var$_templateObject2 || ($7a1a3049c92d39e5$var$_templateObject2 = $7a1a3049c92d39e5$var$_taggedTemplateLiteral([
        "\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n      "
    ])));
}, $7a1a3049c92d39e5$export$8a7c8beb2538684a("color.link"), $7a1a3049c92d39e5$export$8a7c8beb2538684a("color.link"), $7a1a3049c92d39e5$export$8a7c8beb2538684a("type.base.bold"), $7a1a3049c92d39e5$export$8a7c8beb2538684a("color.base-400a"), $7a1a3049c92d39e5$export$8a7c8beb2538684a("color.surface"), $7a1a3049c92d39e5$export$1b93d9625e5bc3ec(), $7a1a3049c92d39e5$export$6ecdca8b3ca86b66());
var $7a1a3049c92d39e5$export$c507fb1c2e1ac13a = (0, $6fhRl.createGlobalStyle)($7a1a3049c92d39e5$var$_templateObject3 || ($7a1a3049c92d39e5$var$_templateObject3 = $7a1a3049c92d39e5$var$_taggedTemplateLiteral([
    "\n  ",
    "\n"
])), $7a1a3049c92d39e5$var$baseStyles);
/* eslint-disable react/prop-types */ var $7a1a3049c92d39e5$export$d1755b7eec6664dc = function DevseedUiThemeProvider(_ref2) {
    var children = _ref2.children, providedTheme = _ref2.theme, rest = $7a1a3049c92d39e5$var$_objectWithoutProperties(_ref2, $7a1a3049c92d39e5$var$_excluded);
    // If the user provided a function, pass the ui library theme to allow
    // overrides. The resulting theme will be the used one.
    var newTheme = typeof providedTheme === "function" ? providedTheme($7a1a3049c92d39e5$export$bca14c5b3b88a9c9.main) : // defaulting to the ui-library.
    providedTheme || $7a1a3049c92d39e5$export$bca14c5b3b88a9c9.main;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement((0, $6fhRl.ThemeProvider), $7a1a3049c92d39e5$var$_extends$1({
        theme: newTheme
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($7a1a3049c92d39e5$export$c507fb1c2e1ac13a, null), children);
};
var $7a1a3049c92d39e5$var$_templateObject;
var $7a1a3049c92d39e5$var$availableRanges = [
    "xsmall",
    "small",
    "medium",
    "large",
    "xlarge"
];
var $7a1a3049c92d39e5$var$availableBounds = [
    "Up",
    "Only",
    "Down"
];
/**
 * Create the 'Up', 'Only', and 'Down' options for the given media label.
 * Logs a warning to the console when the use media query makes no sense,
 * switching to the best alternative possible.
 *
 * @param {string} label Media query range label
 */ /**
 * Create the css media query expression, validating the input range and the
 * desired media query bound type (Up, Down, Only)
 * Logs a warning to the console when the use media query makes no sense,
 * switching to the best alternative possible.
 *
 * @param {array} range The media query range [upper, lower] bounds.
 * @param {string} label The media query range label
 * @param {string} type The media query bound type. One of (Up, Down, Only).
 */ function $7a1a3049c92d39e5$var$buildMediaExp(range, label, type) {
    var getExpr = function getExpr(_ref, type) {
        var _ref2 = $7a1a3049c92d39e5$var$_slicedToArray(_ref, 2), lower = _ref2[0], upper = _ref2[1];
        switch(type){
            case "Up":
                // It makes no sense to have a media query "Up" from nothing.
                // There's no need for a media query in that case.
                if (lower === null) return null;
                return "only screen and (min-width: ".concat(lower, "px)");
            case "Only":
                // This only makes sense when there are both bounds.
                // Otherwise the "Up" or "Down" can be used with the same result.
                if (lower === null || upper === null) return null;
                return "only screen and (min-width: ".concat(lower, "px and max-width: ").concat(upper, "px)");
            case "Down":
                // It makes no sense to have a media query "Down" from infinity.
                // There's no need for a media query in that case.
                if (upper === null) return null;
                return "only screen and (max-width: ".concat(upper, "px)");
        }
    };
    var missingRange = range[0] === null ? "lower" : range[1] === null ? "upper" : null;
    var expr = getExpr(range, type);
    if (expr === null && (type === "Up" || type === "Down")) {
        // eslint-disable-next-line
        console.warn("Media query warning: The specified media query (".concat(label).concat(type, ") has no ").concat(missingRange, " bound.\nThere's no need for a media query in this case;"));
        return null;
    } else if (expr === null) {
        // eslint-disable-next-line
        console.warn("Media query warning: The specified media query (".concat(label).concat(type, ") has no ").concat(missingRange, " bound.\nYou can use (").concat(label).concat(range[0] === null ? "Down" : "Up", ") instead."));
        return getExpr(range, range[0] === null ? "Down" : "Up");
    }
    return expr;
}
/**
 * Create the 'Up', 'Only', and 'Down' options for the given media label.
 *
 * @param {string} label Media query range label
 */ function $7a1a3049c92d39e5$var$createMediaRangeBounds(label) {
    return $7a1a3049c92d39e5$var$availableBounds.reduce(function(acc, type) {
        return $7a1a3049c92d39e5$var$_objectSpread2($7a1a3049c92d39e5$var$_objectSpread2({}, acc), {}, $7a1a3049c92d39e5$var$_defineProperty({}, "".concat(label).concat(type), function _() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return function(props) {
                var range = $7a1a3049c92d39e5$var$get$1(props.theme, [
                    "mediaRanges",
                    label
                ]);
                if (!range) console.warn("Media query warning: Missing bounds for (".concat(label, ") range.\nAdd them to the theme under (mediaRanges: { ").concat(label, ": [upper, lower] })"));
                var expr = range ? $7a1a3049c92d39e5$var$buildMediaExp(range, label, type) : null;
                return expr ? (0, $6fhRl.css)($7a1a3049c92d39e5$var$_templateObject || ($7a1a3049c92d39e5$var$_templateObject = $7a1a3049c92d39e5$var$_taggedTemplateLiteral([
                    "\n                @media ",
                    " {\n                  ",
                    "\n                }\n              "
                ])), expr, (0, $6fhRl.css).apply(void 0, args)) : (0, $6fhRl.css).apply(void 0, args);
            };
        }));
    }, {});
}
/**
 * Build the media query utility where for each range there is the 'Up', 'Only',
 * and 'Down' options.
 *
 * Available media queries:
 * xsmallDown
 * smallUp, smallOnly, smallDown
 * mediumUp, mediumOnly, mediumDown
 * largeUp, largeOnly, largeDown
 * xlargeUp
 *
 * To use with style components as:
 *
 * @example
 * media.smallOnly`
 *   color: red;
 * `
 */ var $7a1a3049c92d39e5$var$media = $7a1a3049c92d39e5$var$availableRanges.reduce(function(acc, label) {
    return $7a1a3049c92d39e5$var$_objectSpread2($7a1a3049c92d39e5$var$_objectSpread2({}, acc), $7a1a3049c92d39e5$var$createMediaRangeBounds(label));
}, {});
var $7a1a3049c92d39e5$export$987d49ffe1b0900f = $7a1a3049c92d39e5$var$media;

});
parcelRegister("6fhRl", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $48c1ff4a00492e84$export$dbf350e5966cf602; });
$parcel$export(module.exports, "ThemeProvider", function () { return $48c1ff4a00492e84$export$d8964aec282183a3; });
$parcel$export(module.exports, "createGlobalStyle", function () { return $48c1ff4a00492e84$export$f0f03736edb61697; });
$parcel$export(module.exports, "keyframes", function () { return $48c1ff4a00492e84$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "useTheme", function () { return $48c1ff4a00492e84$export$93d4e7f90805808f; });
$parcel$export(module.exports, "default", function () { return $48c1ff4a00492e84$export$2e2bcd8739ae039; });

var $bBYeY = parcelRequire("bBYeY");

var $3RyIS = parcelRequire("3RyIS");

var $oEgvS = parcelRequire("oEgvS");

var $2vTmS = parcelRequire("2vTmS");

var $71GfQ = parcelRequire("71GfQ");

var $bsrmw = parcelRequire("bsrmw");

var $5ASLf = parcelRequire("5ASLf");

var $dpptK = parcelRequire("dpptK");
function $48c1ff4a00492e84$var$v() {
    return ($48c1ff4a00492e84$var$v = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $48c1ff4a00492e84$var$g = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $48c1ff4a00492e84$var$S = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $bBYeY.typeOf)(t);
}, $48c1ff4a00492e84$var$w = Object.freeze([]), $48c1ff4a00492e84$var$E = Object.freeze({});
function $48c1ff4a00492e84$var$b(e) {
    return "function" == typeof e;
}
function $48c1ff4a00492e84$var$_(e) {
    return "string" == typeof e && e || e.displayName || e.name || "Component";
}
function $48c1ff4a00492e84$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $48c1ff4a00492e84$var$A = ("undefined" != typeof $dpptK && undefined, "data-styled"), $48c1ff4a00492e84$export$83d89fbfd8236492 = "5.3.5", $48c1ff4a00492e84$var$I = "undefined" != typeof window && "HTMLElement" in window, $48c1ff4a00492e84$var$P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : (typeof $dpptK, typeof $dpptK, true)), $48c1ff4a00492e84$var$O = {}, $48c1ff4a00492e84$var$R = {
    1: "Cannot create styled-component for component: %s.\n\n",
    2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
    3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
    4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
    5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
    6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
    7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
    8: 'ThemeProvider: Please make your "theme" prop an object.\n\n',
    9: "Missing document `<head>`\n\n",
    10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
    11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
    12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
    13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
    14: 'ThemeProvider: "theme" prop is required.\n\n',
    15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
    16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
    17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"
};
function $48c1ff4a00492e84$var$D() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $48c1ff4a00492e84$var$j(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error($48c1ff4a00492e84$var$D.apply(void 0, [
        $48c1ff4a00492e84$var$R[e]
    ].concat(n)).trim());
}
var $48c1ff4a00492e84$var$T = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $48c1ff4a00492e84$var$j(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $48c1ff4a00492e84$var$x = new Map, $48c1ff4a00492e84$var$k = new Map, $48c1ff4a00492e84$var$V = 1, $48c1ff4a00492e84$var$B = function(e) {
    if ($48c1ff4a00492e84$var$x.has(e)) return $48c1ff4a00492e84$var$x.get(e);
    for(; $48c1ff4a00492e84$var$k.has($48c1ff4a00492e84$var$V);)$48c1ff4a00492e84$var$V++;
    var t = $48c1ff4a00492e84$var$V++;
    return ((0 | t) < 0 || t > 1073741824) && $48c1ff4a00492e84$var$j(16, "" + t), $48c1ff4a00492e84$var$x.set(e, t), $48c1ff4a00492e84$var$k.set(t, e), t;
}, $48c1ff4a00492e84$var$z = function(e) {
    return $48c1ff4a00492e84$var$k.get(e);
}, $48c1ff4a00492e84$var$M = function(e, t) {
    t >= $48c1ff4a00492e84$var$V && ($48c1ff4a00492e84$var$V = t + 1), $48c1ff4a00492e84$var$x.set(e, t), $48c1ff4a00492e84$var$k.set(t, e);
}, $48c1ff4a00492e84$var$G = "style[" + $48c1ff4a00492e84$var$A + '][data-styled-version="5.3.5"]', $48c1ff4a00492e84$var$L = new RegExp("^" + $48c1ff4a00492e84$var$A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $48c1ff4a00492e84$var$F = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $48c1ff4a00492e84$var$Y = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($48c1ff4a00492e84$var$L);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($48c1ff4a00492e84$var$M(u, c), $48c1ff4a00492e84$var$F(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $48c1ff4a00492e84$var$q = function() {
    return "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
}, $48c1ff4a00492e84$var$H = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($48c1ff4a00492e84$var$A)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($48c1ff4a00492e84$var$A, "active"), r.setAttribute("data-styled-version", "5.3.5");
    var i = $48c1ff4a00492e84$var$q();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $48c1ff4a00492e84$var$$ = function() {
    function e(e) {
        var t = this.element = $48c1ff4a00492e84$var$H(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $48c1ff4a00492e84$var$j(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $48c1ff4a00492e84$var$W = function() {
    function e(e) {
        var t = this.element = $48c1ff4a00492e84$var$H(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $48c1ff4a00492e84$var$U = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $48c1ff4a00492e84$var$J = $48c1ff4a00492e84$var$I, $48c1ff4a00492e84$var$X = {
    isServer: !$48c1ff4a00492e84$var$I,
    useCSSOMInjection: !$48c1ff4a00492e84$var$P
}, $48c1ff4a00492e84$var$Z = function() {
    function e(e, t, n) {
        void 0 === e && (e = $48c1ff4a00492e84$var$E), void 0 === t && (t = {}), this.options = $48c1ff4a00492e84$var$v({}, $48c1ff4a00492e84$var$X, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $48c1ff4a00492e84$var$I && $48c1ff4a00492e84$var$J && ($48c1ff4a00492e84$var$J = !1, function(e) {
            for(var t = document.querySelectorAll($48c1ff4a00492e84$var$G), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($48c1ff4a00492e84$var$A) && ($48c1ff4a00492e84$var$Y(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $48c1ff4a00492e84$var$B(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($48c1ff4a00492e84$var$v({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $48c1ff4a00492e84$var$U(o) : r ? new $48c1ff4a00492e84$var$$(o) : new $48c1ff4a00492e84$var$W(o), new $48c1ff4a00492e84$var$T(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($48c1ff4a00492e84$var$B(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($48c1ff4a00492e84$var$B(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($48c1ff4a00492e84$var$B(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $48c1ff4a00492e84$var$z(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $48c1ff4a00492e84$var$A + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $48c1ff4a00492e84$var$K = /(a)(d)/gi, $48c1ff4a00492e84$var$Q = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $48c1ff4a00492e84$var$ee(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $48c1ff4a00492e84$var$Q(t % 52) + n;
    return ($48c1ff4a00492e84$var$Q(t % 52) + n).replace($48c1ff4a00492e84$var$K, "$1-$2");
}
var $48c1ff4a00492e84$var$te = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $48c1ff4a00492e84$var$ne = function(e) {
    return $48c1ff4a00492e84$var$te(5381, e);
};
function $48c1ff4a00492e84$var$re(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($48c1ff4a00492e84$var$b(n) && !$48c1ff4a00492e84$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $48c1ff4a00492e84$var$oe = $48c1ff4a00492e84$var$ne("5.3.5"), $48c1ff4a00492e84$var$se = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = false, this.componentId = t, this.baseHash = $48c1ff4a00492e84$var$te($48c1ff4a00492e84$var$oe, t), this.baseStyle = n, $48c1ff4a00492e84$var$Z.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $48c1ff4a00492e84$var$Ne(this.rules, e, t, n).join(""), i = $48c1ff4a00492e84$var$ee($48c1ff4a00492e84$var$te(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $48c1ff4a00492e84$var$te(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h, u = $48c1ff4a00492e84$var$te(u, h + d);
                else if (h) {
                    var p = $48c1ff4a00492e84$var$Ne(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $48c1ff4a00492e84$var$te(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $48c1ff4a00492e84$var$ee(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $48c1ff4a00492e84$var$ie = /^\s*\/\/.*$/gm, $48c1ff4a00492e84$var$ae = [
    ":",
    "[",
    ".",
    "#"
];
function $48c1ff4a00492e84$var$ce(e) {
    var t, n, r, o, s = void 0 === e ? $48c1ff4a00492e84$var$E : e, i = s.options, a = void 0 === i ? $48c1ff4a00492e84$var$E : i, c = s.plugins, u = void 0 === c ? $48c1ff4a00492e84$var$w : c, l = new (0, $2vTmS.default)(a), d = [], h = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $48c1ff4a00492e84$var$ae.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($48c1ff4a00492e84$var$ie, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        h,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $48c1ff4a00492e84$var$j(15), $48c1ff4a00492e84$var$te(e, t.name);
    }, 5381).toString() : "", m;
}
var $48c1ff4a00492e84$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createContext(), $48c1ff4a00492e84$export$91317688fc694efa = $48c1ff4a00492e84$export$8c190ef828af4c86.Consumer, $48c1ff4a00492e84$var$de = (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createContext(), $48c1ff4a00492e84$var$he = ($48c1ff4a00492e84$var$de.Consumer, new $48c1ff4a00492e84$var$Z), $48c1ff4a00492e84$var$pe = $48c1ff4a00492e84$var$ce();
function $48c1ff4a00492e84$var$fe() {
    return (0, $3RyIS.useContext)($48c1ff4a00492e84$export$8c190ef828af4c86) || $48c1ff4a00492e84$var$he;
}
function $48c1ff4a00492e84$var$me() {
    return (0, $3RyIS.useContext)($48c1ff4a00492e84$var$de) || $48c1ff4a00492e84$var$pe;
}
function $48c1ff4a00492e84$export$a473771da2f0ff7c(e) {
    var t = (0, $3RyIS.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $48c1ff4a00492e84$var$fe(), u = (0, $3RyIS.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $3RyIS.useMemo)(function() {
        return $48c1ff4a00492e84$var$ce({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $3RyIS.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($oEgvS)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($48c1ff4a00492e84$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($48c1ff4a00492e84$var$de.Provider, {
        value: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).Children.only(e.children)));
}
var $48c1ff4a00492e84$var$ve = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $48c1ff4a00492e84$var$pe);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $48c1ff4a00492e84$var$j(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $48c1ff4a00492e84$var$pe), this.name + e.hash;
    }, e;
}(), $48c1ff4a00492e84$var$ge = /([A-Z])/, $48c1ff4a00492e84$var$Se = /([A-Z])/g, $48c1ff4a00492e84$var$we = /^ms-/, $48c1ff4a00492e84$var$Ee = function(e) {
    return "-" + e.toLowerCase();
};
function $48c1ff4a00492e84$var$be(e) {
    return $48c1ff4a00492e84$var$ge.test(e) ? e.replace($48c1ff4a00492e84$var$Se, $48c1ff4a00492e84$var$Ee).replace($48c1ff4a00492e84$var$we, "-ms-") : e;
}
var $48c1ff4a00492e84$var$_e = function(e) {
    return null == e || !1 === e || "" === e;
};
function $48c1ff4a00492e84$var$Ne(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $48c1ff4a00492e84$var$Ne(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($48c1ff4a00492e84$var$_e(e)) return "";
    if ($48c1ff4a00492e84$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($48c1ff4a00492e84$var$b(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return (0, $bBYeY.isElement)(u) && console.warn($48c1ff4a00492e84$var$_(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), $48c1ff4a00492e84$var$Ne(u, n, r, o);
    }
    var l;
    return e instanceof $48c1ff4a00492e84$var$ve ? r ? (e.inject(r, o), e.getName(o)) : e : $48c1ff4a00492e84$var$S(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$48c1ff4a00492e84$var$_e(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $48c1ff4a00492e84$var$b(t[i]) ? s.push($48c1ff4a00492e84$var$be(i) + ":", t[i], ";") : $48c1ff4a00492e84$var$S(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($48c1ff4a00492e84$var$be(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $71GfQ.default) ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $48c1ff4a00492e84$var$Ae = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $48c1ff4a00492e84$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $48c1ff4a00492e84$var$b(e) || $48c1ff4a00492e84$var$S(e) ? $48c1ff4a00492e84$var$Ae($48c1ff4a00492e84$var$Ne($48c1ff4a00492e84$var$g($48c1ff4a00492e84$var$w, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $48c1ff4a00492e84$var$Ae($48c1ff4a00492e84$var$Ne($48c1ff4a00492e84$var$g(e, n)));
}
var $48c1ff4a00492e84$var$Ie = /invalid hook call/i, $48c1ff4a00492e84$var$Pe = new Set, $48c1ff4a00492e84$var$Oe = function(e, t) {
    var n = "The component " + e + (t ? ' with the id of "' + t + '"' : "") + " has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.", r = console.error;
    try {
        var o = !0;
        console.error = function(e) {
            if ($48c1ff4a00492e84$var$Ie.test(e)) o = !1, $48c1ff4a00492e84$var$Pe.delete(n);
            else {
                for(var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)s[i - 1] = arguments[i];
                r.apply(void 0, [
                    e
                ].concat(s));
            }
        }, (0, $3RyIS.useRef)(), o && !$48c1ff4a00492e84$var$Pe.has(n) && (console.warn(n), $48c1ff4a00492e84$var$Pe.add(n));
    } catch (e) {
        $48c1ff4a00492e84$var$Ie.test(e.message) && $48c1ff4a00492e84$var$Pe.delete(n);
    } finally{
        console.error = r;
    }
}, $48c1ff4a00492e84$var$Re = function(e, t, n) {
    return void 0 === n && (n = $48c1ff4a00492e84$var$E), e.theme !== n.theme && e.theme || t || n.theme;
}, $48c1ff4a00492e84$var$De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $48c1ff4a00492e84$var$je = /(^-|-$)/g;
function $48c1ff4a00492e84$var$Te(e) {
    return e.replace($48c1ff4a00492e84$var$De, "-").replace($48c1ff4a00492e84$var$je, "");
}
var $48c1ff4a00492e84$var$xe = function(e) {
    return $48c1ff4a00492e84$var$ee($48c1ff4a00492e84$var$ne(e) >>> 0);
};
function $48c1ff4a00492e84$var$ke(e) {
    return "string" == typeof e && e.charAt(0) === e.charAt(0).toLowerCase();
}
var $48c1ff4a00492e84$var$Ve = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $48c1ff4a00492e84$var$Be = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $48c1ff4a00492e84$var$ze(e, t, n) {
    var r = e[n];
    $48c1ff4a00492e84$var$Ve(t) && $48c1ff4a00492e84$var$Ve(r) ? $48c1ff4a00492e84$var$Me(r, t) : e[n] = t;
}
function $48c1ff4a00492e84$var$Me(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($48c1ff4a00492e84$var$Ve(i)) for(var a in i)$48c1ff4a00492e84$var$Be(a) && $48c1ff4a00492e84$var$ze(e, i[a], a);
    }
    return e;
}
var $48c1ff4a00492e84$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createContext(), $48c1ff4a00492e84$export$b631efc24e9d5e2f = $48c1ff4a00492e84$export$2c657da244d00bd6.Consumer;
function $48c1ff4a00492e84$export$d8964aec282183a3(e) {
    var t = (0, $3RyIS.useContext)($48c1ff4a00492e84$export$2c657da244d00bd6), n = (0, $3RyIS.useMemo)(function() {
        return function(e, t) {
            if (!e) return $48c1ff4a00492e84$var$j(14);
            if ($48c1ff4a00492e84$var$b(e)) {
                var n = e(t);
                return null !== n && !Array.isArray(n) && "object" == typeof n ? n : $48c1ff4a00492e84$var$j(7);
            }
            return Array.isArray(e) || "object" != typeof e ? $48c1ff4a00492e84$var$j(8) : t ? $48c1ff4a00492e84$var$v({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($48c1ff4a00492e84$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $48c1ff4a00492e84$var$Ye = {};
function $48c1ff4a00492e84$var$qe(e, t, n) {
    var o = $48c1ff4a00492e84$export$7ba318d8d2f06c76(e), i = !$48c1ff4a00492e84$var$ke(e), a = t.attrs, c = void 0 === a ? $48c1ff4a00492e84$var$w : a, d = t.componentId, h = void 0 === d ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $48c1ff4a00492e84$var$Te(e);
        $48c1ff4a00492e84$var$Ye[n] = ($48c1ff4a00492e84$var$Ye[n] || 0) + 1;
        var r = n + "-" + $48c1ff4a00492e84$var$xe("5.3.5" + n + $48c1ff4a00492e84$var$Ye[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : d, p = t.displayName, f = void 0 === p ? function(e) {
        return $48c1ff4a00492e84$var$ke(e) ? "styled." + e : "Styled(" + $48c1ff4a00492e84$var$_(e) + ")";
    }(e) : p, g = t.displayName && t.componentId ? $48c1ff4a00492e84$var$Te(t.displayName) + "-" + t.componentId : t.componentId || h, S = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, A = t.shouldForwardProp;
    o && e.shouldForwardProp && (A = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var C, I = new $48c1ff4a00492e84$var$se(n, g, o ? e.componentStyle : void 0), P = I.isStatic && 0 === c.length, O = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, d = e.shouldForwardProp, h = e.styledComponentId, p = e.target;
            (0, $3RyIS.useDebugValue)(h);
            var f = function(e, t, n) {
                void 0 === e && (e = $48c1ff4a00492e84$var$E);
                var r = $48c1ff4a00492e84$var$v({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $48c1ff4a00492e84$var$b(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($48c1ff4a00492e84$var$Re(t, (0, $3RyIS.useContext)($48c1ff4a00492e84$export$2c657da244d00bd6), a) || $48c1ff4a00492e84$var$E, t, o), y = f[0], g = f[1], S = function(e, t, n, r) {
                var o = $48c1ff4a00492e84$var$fe(), s = $48c1ff4a00492e84$var$me(), i = t ? e.generateAndInjectStyles($48c1ff4a00492e84$var$E, o, s) : e.generateAndInjectStyles(n, o, s);
                return (0, $3RyIS.useDebugValue)(i), !t && r && r(i), i;
            }(i, r, y, (0, e.warnTooManyClasses)), w = n, _ = g.$as || t.$as || g.as || t.as || p, N = $48c1ff4a00492e84$var$ke(_), A = g !== t ? $48c1ff4a00492e84$var$v({}, t, {}, g) : t, C = {};
            for(var I in A)"$" !== I[0] && "as" !== I && ("forwardedAs" === I ? C.as = A[I] : (d ? d(I, (0, $bsrmw.default), _) : !N || (0, $bsrmw.default)(I)) && (C[I] = A[I]));
            return t.style && g.style !== t.style && (C.style = $48c1ff4a00492e84$var$v({}, t.style, {}, g.style)), C.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), C.ref = w, (0, $3RyIS.createElement)(_, C);
        }(C, e, t, P);
    };
    return O.displayName = f, (C = (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).forwardRef(O)).attrs = S, C.componentStyle = I, C.displayName = f, C.shouldForwardProp = A, C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $48c1ff4a00492e84$var$w, C.styledComponentId = g, C.target = o ? e.target : e, C.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($48c1ff4a00492e84$var$ke(e) ? e : $48c1ff4a00492e84$var$Te($48c1ff4a00492e84$var$_(e)));
        return $48c1ff4a00492e84$var$qe(e, $48c1ff4a00492e84$var$v({}, o, {
            attrs: S,
            componentId: s
        }), n);
    }, Object.defineProperty(C, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $48c1ff4a00492e84$var$Me({}, e.defaultProps, t) : t;
        }
    }), $48c1ff4a00492e84$var$Oe(f, g), C.warnTooManyClasses = function(e, t) {
        var n = {}, r = !1;
        return function(o) {
            if (!r && (n[o] = !0, Object.keys(n).length >= 200)) {
                var s = t ? ' with the id of "' + t + '"' : "";
                console.warn("Over 200 classes were generated for component " + e + s + ".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), r = !0, n = {};
            }
        };
    }(f, g), C.toString = function() {
        return "." + C.styledComponentId;
    }, i && (0, (/*@__PURE__*/$parcel$interopDefault($5ASLf)))(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), C;
}
var $48c1ff4a00492e84$var$He = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $48c1ff4a00492e84$var$E), !(0, $bBYeY.isValidElementType)(r)) return $48c1ff4a00492e84$var$j(1, String(r));
        var s = function() {
            return t(r, o, $48c1ff4a00492e84$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $48c1ff4a00492e84$var$v({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $48c1ff4a00492e84$var$v({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($48c1ff4a00492e84$var$qe, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $48c1ff4a00492e84$var$He[e] = $48c1ff4a00492e84$var$He(e);
});
var $48c1ff4a00492e84$var$$e = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $48c1ff4a00492e84$var$re(e), $48c1ff4a00492e84$var$Z.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($48c1ff4a00492e84$var$Ne(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $48c1ff4a00492e84$var$Z.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $48c1ff4a00492e84$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $48c1ff4a00492e84$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $48c1ff4a00492e84$var$xe(JSON.stringify(i)), u = new $48c1ff4a00492e84$var$$e(i, a);
    function l(e) {
        var t = $48c1ff4a00492e84$var$fe(), n = $48c1ff4a00492e84$var$me(), o = (0, $3RyIS.useContext)($48c1ff4a00492e84$export$2c657da244d00bd6), l = (0, $3RyIS.useRef)(t.allocateGSInstance(a)).current;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).Children.count(e.children) && console.warn("The global style component " + a + " was given child JSX. createGlobalStyle does not render children."), i.some(function(e) {
            return "string" == typeof e && -1 !== e.indexOf("@import");
        }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), t.server && h(l, e, t, o, n), (0, $3RyIS.useLayoutEffect)(function() {
            if (!t.server) return h(l, e, t, o, n), function() {
                return u.removeStyles(l, t);
            };
        }, [
            l,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $48c1ff4a00492e84$var$O, n, o);
        else {
            var s = $48c1ff4a00492e84$var$v({}, t, {
                theme: $48c1ff4a00492e84$var$Re(t, r, l.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return $48c1ff4a00492e84$var$Oe(a), (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).memo(l);
}
function $48c1ff4a00492e84$export$d25ddfdf17c3ad3e(e) {
    "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $48c1ff4a00492e84$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $48c1ff4a00492e84$var$xe(o);
    return new $48c1ff4a00492e84$var$ve(s, o);
}
var $48c1ff4a00492e84$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $48c1ff4a00492e84$var$q();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $48c1ff4a00492e84$var$A + '="true"',
                'data-styled-version="5.3.5"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $48c1ff4a00492e84$var$j(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $48c1ff4a00492e84$var$j(2);
            var n = ((t = {})[$48c1ff4a00492e84$var$A] = "", t["data-styled-version"] = "5.3.5", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $48c1ff4a00492e84$var$q();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("style", $48c1ff4a00492e84$var$v({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $48c1ff4a00492e84$var$Z({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $48c1ff4a00492e84$var$j(2) : (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($48c1ff4a00492e84$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $48c1ff4a00492e84$var$j(3);
    }, e;
}(), $48c1ff4a00492e84$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).forwardRef(function(t, n) {
        var o = (0, $3RyIS.useContext)($48c1ff4a00492e84$export$2c657da244d00bd6), i = e.defaultProps, a = $48c1ff4a00492e84$var$Re(t, o, i);
        return void 0 === a && console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + $48c1ff4a00492e84$var$_(e) + '"'), (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement(e, $48c1ff4a00492e84$var$v({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5ASLf)))(t, e), t.displayName = "WithTheme(" + $48c1ff4a00492e84$var$_(e) + ")", t;
}, $48c1ff4a00492e84$export$93d4e7f90805808f = function() {
    return (0, $3RyIS.useContext)($48c1ff4a00492e84$export$2c657da244d00bd6);
}, $48c1ff4a00492e84$export$5c87cfe6c475f500 = {
    StyleSheet: $48c1ff4a00492e84$var$Z,
    masterSheet: $48c1ff4a00492e84$var$he
};
"undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"), "undefined" != typeof window && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, 1 === window["__styled-components-init__"] && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window["__styled-components-init__"] += 1);
var $48c1ff4a00492e84$export$2e2bcd8739ae039 = $48c1ff4a00492e84$var$He;

});
parcelRegister("oEgvS", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRegister("2vTmS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d496cf2a276e54f$export$2e2bcd8739ae039; });
function $1d496cf2a276e54f$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $1d496cf2a276e54f$export$2e2bcd8739ae039 = $1d496cf2a276e54f$var$stylis_min;

});

parcelRegister("71GfQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51d96741aa78ff89$export$2e2bcd8739ae039; });
var $51d96741aa78ff89$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $51d96741aa78ff89$export$2e2bcd8739ae039 = $51d96741aa78ff89$var$unitlessKeys;

});

parcelRegister("bsrmw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $857788d53dbfec2f$export$2e2bcd8739ae039; });

var $fBLqa = parcelRequire("fBLqa");
var $857788d53dbfec2f$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $857788d53dbfec2f$var$isPropValid = /* #__PURE__ */ (0, $fBLqa.default)(function(prop) {
    return $857788d53dbfec2f$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $857788d53dbfec2f$export$2e2bcd8739ae039 = $857788d53dbfec2f$var$isPropValid;

});
parcelRegister("fBLqa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5cf188ef465ace7$export$2e2bcd8739ae039; });
function $b5cf188ef465ace7$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $b5cf188ef465ace7$export$2e2bcd8739ae039 = $b5cf188ef465ace7$var$memoize;

});


parcelRegister("5ASLf", function(module, exports) {
"use strict";

var $bBYeY = parcelRequire("bBYeY");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $412acaf2829a7ba4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $412acaf2829a7ba4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $412acaf2829a7ba4$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $412acaf2829a7ba4$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $412acaf2829a7ba4$var$TYPE_STATICS = {};
$412acaf2829a7ba4$var$TYPE_STATICS[$bBYeY.ForwardRef] = $412acaf2829a7ba4$var$FORWARD_REF_STATICS;
$412acaf2829a7ba4$var$TYPE_STATICS[$bBYeY.Memo] = $412acaf2829a7ba4$var$MEMO_STATICS;
function $412acaf2829a7ba4$var$getStatics(component) {
    // React v16.11 and below
    if ($bBYeY.isMemo(component)) return $412acaf2829a7ba4$var$MEMO_STATICS;
     // React v16.12 and above
    return $412acaf2829a7ba4$var$TYPE_STATICS[component["$$typeof"]] || $412acaf2829a7ba4$var$REACT_STATICS;
}
var $412acaf2829a7ba4$var$defineProperty = Object.defineProperty;
var $412acaf2829a7ba4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $412acaf2829a7ba4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $412acaf2829a7ba4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $412acaf2829a7ba4$var$getPrototypeOf = Object.getPrototypeOf;
var $412acaf2829a7ba4$var$objectPrototype = Object.prototype;
function $412acaf2829a7ba4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($412acaf2829a7ba4$var$objectPrototype) {
            var inheritedComponent = $412acaf2829a7ba4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $412acaf2829a7ba4$var$objectPrototype) $412acaf2829a7ba4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $412acaf2829a7ba4$var$getOwnPropertyNames(sourceComponent);
        if ($412acaf2829a7ba4$var$getOwnPropertySymbols) keys = keys.concat($412acaf2829a7ba4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $412acaf2829a7ba4$var$getStatics(targetComponent);
        var sourceStatics = $412acaf2829a7ba4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$412acaf2829a7ba4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $412acaf2829a7ba4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $412acaf2829a7ba4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $412acaf2829a7ba4$var$hoistNonReactStatics;

});

parcelRegister("dpptK", function(module, exports) {
// shim for using process in browser
var $9c315fbaaef5ea72$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $9c315fbaaef5ea72$var$cachedSetTimeout;
var $9c315fbaaef5ea72$var$cachedClearTimeout;
function $9c315fbaaef5ea72$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $9c315fbaaef5ea72$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $9c315fbaaef5ea72$var$cachedSetTimeout = setTimeout;
        else $9c315fbaaef5ea72$var$cachedSetTimeout = $9c315fbaaef5ea72$var$defaultSetTimout;
    } catch (e) {
        $9c315fbaaef5ea72$var$cachedSetTimeout = $9c315fbaaef5ea72$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $9c315fbaaef5ea72$var$cachedClearTimeout = clearTimeout;
        else $9c315fbaaef5ea72$var$cachedClearTimeout = $9c315fbaaef5ea72$var$defaultClearTimeout;
    } catch (e) {
        $9c315fbaaef5ea72$var$cachedClearTimeout = $9c315fbaaef5ea72$var$defaultClearTimeout;
    }
})();
function $9c315fbaaef5ea72$var$runTimeout(fun) {
    if ($9c315fbaaef5ea72$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($9c315fbaaef5ea72$var$cachedSetTimeout === $9c315fbaaef5ea72$var$defaultSetTimout || !$9c315fbaaef5ea72$var$cachedSetTimeout) && setTimeout) {
        $9c315fbaaef5ea72$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $9c315fbaaef5ea72$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $9c315fbaaef5ea72$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $9c315fbaaef5ea72$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $9c315fbaaef5ea72$var$runClearTimeout(marker) {
    if ($9c315fbaaef5ea72$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($9c315fbaaef5ea72$var$cachedClearTimeout === $9c315fbaaef5ea72$var$defaultClearTimeout || !$9c315fbaaef5ea72$var$cachedClearTimeout) && clearTimeout) {
        $9c315fbaaef5ea72$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $9c315fbaaef5ea72$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $9c315fbaaef5ea72$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $9c315fbaaef5ea72$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $9c315fbaaef5ea72$var$queue = [];
var $9c315fbaaef5ea72$var$draining = false;
var $9c315fbaaef5ea72$var$currentQueue;
var $9c315fbaaef5ea72$var$queueIndex = -1;
function $9c315fbaaef5ea72$var$cleanUpNextTick() {
    if (!$9c315fbaaef5ea72$var$draining || !$9c315fbaaef5ea72$var$currentQueue) return;
    $9c315fbaaef5ea72$var$draining = false;
    if ($9c315fbaaef5ea72$var$currentQueue.length) $9c315fbaaef5ea72$var$queue = $9c315fbaaef5ea72$var$currentQueue.concat($9c315fbaaef5ea72$var$queue);
    else $9c315fbaaef5ea72$var$queueIndex = -1;
    if ($9c315fbaaef5ea72$var$queue.length) $9c315fbaaef5ea72$var$drainQueue();
}
function $9c315fbaaef5ea72$var$drainQueue() {
    if ($9c315fbaaef5ea72$var$draining) return;
    var timeout = $9c315fbaaef5ea72$var$runTimeout($9c315fbaaef5ea72$var$cleanUpNextTick);
    $9c315fbaaef5ea72$var$draining = true;
    var len = $9c315fbaaef5ea72$var$queue.length;
    while(len){
        $9c315fbaaef5ea72$var$currentQueue = $9c315fbaaef5ea72$var$queue;
        $9c315fbaaef5ea72$var$queue = [];
        while(++$9c315fbaaef5ea72$var$queueIndex < len)if ($9c315fbaaef5ea72$var$currentQueue) $9c315fbaaef5ea72$var$currentQueue[$9c315fbaaef5ea72$var$queueIndex].run();
        $9c315fbaaef5ea72$var$queueIndex = -1;
        len = $9c315fbaaef5ea72$var$queue.length;
    }
    $9c315fbaaef5ea72$var$currentQueue = null;
    $9c315fbaaef5ea72$var$draining = false;
    $9c315fbaaef5ea72$var$runClearTimeout(timeout);
}
$9c315fbaaef5ea72$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $9c315fbaaef5ea72$var$queue.push(new $9c315fbaaef5ea72$var$Item(fun, args));
    if ($9c315fbaaef5ea72$var$queue.length === 1 && !$9c315fbaaef5ea72$var$draining) $9c315fbaaef5ea72$var$runTimeout($9c315fbaaef5ea72$var$drainQueue);
};
// v8 likes predictible objects
function $9c315fbaaef5ea72$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$9c315fbaaef5ea72$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$9c315fbaaef5ea72$var$process.title = "browser";
$9c315fbaaef5ea72$var$process.browser = true;
$9c315fbaaef5ea72$var$process.env = {};
$9c315fbaaef5ea72$var$process.argv = [];
$9c315fbaaef5ea72$var$process.version = ""; // empty string to avoid regexp issues
$9c315fbaaef5ea72$var$process.versions = {};
function $9c315fbaaef5ea72$var$noop() {}
$9c315fbaaef5ea72$var$process.on = $9c315fbaaef5ea72$var$noop;
$9c315fbaaef5ea72$var$process.addListener = $9c315fbaaef5ea72$var$noop;
$9c315fbaaef5ea72$var$process.once = $9c315fbaaef5ea72$var$noop;
$9c315fbaaef5ea72$var$process.off = $9c315fbaaef5ea72$var$noop;
$9c315fbaaef5ea72$var$process.removeListener = $9c315fbaaef5ea72$var$noop;
$9c315fbaaef5ea72$var$process.removeAllListeners = $9c315fbaaef5ea72$var$noop;
$9c315fbaaef5ea72$var$process.emit = $9c315fbaaef5ea72$var$noop;
$9c315fbaaef5ea72$var$process.prependListener = $9c315fbaaef5ea72$var$noop;
$9c315fbaaef5ea72$var$process.prependOnceListener = $9c315fbaaef5ea72$var$noop;
$9c315fbaaef5ea72$var$process.listeners = function(name) {
    return [];
};
$9c315fbaaef5ea72$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$9c315fbaaef5ea72$var$process.cwd = function() {
    return "/";
};
$9c315fbaaef5ea72$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$9c315fbaaef5ea72$var$process.umask = function() {
    return 0;
};

});




parcelRegister("bvGDc", function(module, exports) {

$parcel$export(module.exports, "ABOUT_PATH", function () { return $c270dc10a5405940$export$a9d707845a74e7f7; });
$parcel$export(module.exports, "STORIES_PATH", function () { return $c270dc10a5405940$export$5b5d95bbf9e564e2; });
$parcel$export(module.exports, "DATASETS_PATH", function () { return $c270dc10a5405940$export$e08818004a56cd24; });
$parcel$export(module.exports, "EXPLORATION_PATH", function () { return $c270dc10a5405940$export$f71537b6bf0df664; });
$parcel$export(module.exports, "getStoryPath", function () { return $c270dc10a5405940$export$26aedbbd667bd78b; });
$parcel$export(module.exports, "getDatasetPath", function () { return $c270dc10a5405940$export$a995bc6de1f28ece; });
$parcel$export(module.exports, "getDatasetExplorePath", function () { return $c270dc10a5405940$export$7d452796c80bafa8; });
const $c270dc10a5405940$export$a9d707845a74e7f7 = "/about";
const $c270dc10a5405940$export$5b5d95bbf9e564e2 = "/stories";
const $c270dc10a5405940$export$e08818004a56cd24 = "/data-catalog";
const $c270dc10a5405940$export$f71537b6bf0df664 = "/exploration";
const $c270dc10a5405940$export$d952fbb7ee3525f2 = "/analysis";
const $c270dc10a5405940$export$c5349a07710ccfb7 = "/analysis/results";
const $c270dc10a5405940$export$26aedbbd667bd78b = (d)=>`${$c270dc10a5405940$export$5b5d95bbf9e564e2}/${typeof d === "string" ? d : d.id}`;
const $c270dc10a5405940$export$a995bc6de1f28ece = (d, path = $c270dc10a5405940$export$e08818004a56cd24)=>`${path}/${typeof d === "string" ? d : d.id}`;
const $c270dc10a5405940$export$7d452796c80bafa8 = (d)=>{
    const id = typeof d === "string" ? d : d.id;
    return `${$c270dc10a5405940$export$f71537b6bf0df664}?search=${id}`;
};

});

parcelRegister("5lvjo", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("hAJzY", function(module, exports) {

$parcel$export(module.exports, "GlobalStyles", function () { return $cce927899ce36ecd$export$c507fb1c2e1ac13a; });
$parcel$export(module.exports, "legacyGlobalStyleCSSBlock", function () { return $cce927899ce36ecd$export$b427be1880cc7333; });

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $johEW = parcelRequire("johEW");
const $cce927899ce36ecd$export$c507fb1c2e1ac13a = (0, $6fhRl.createGlobalStyle)`
  /* stylelint-disable-next-line selector-type-no-unknown */
  ${(0, $johEW.reactTippyStyles)()}

  .tether-element.tether-element {
    z-index: ${(0, $atWKR.themeVal)("zIndices.dropdown")};
  }

  :root {
    --base-space-multiplier: ${(0, $atWKR.themeVal)("layout.glspMultiplier.xsmall")};
    --base-font-family: ${(0, $atWKR.themeVal)("type.base.family")};
    --veda-color-primary: ${(0, $atWKR.themeVal)("color.primary")};
    --veda-color-secondary: ${(0, $atWKR.themeVal)("color.secondary")};
    --veda-color-link: ${(0, $atWKR.themeVal)("color.link")};
    --veda-color-base: ${(0, $atWKR.themeVal)("color.base")};
  }

  ${(0, $atWKR.media).smallUp`
    :root {
      --base-text-increment: ${(0, $atWKR.themeVal)("type.base.sizeIncrement.small")};
      --base-space-multiplier: ${(0, $atWKR.themeVal)("layout.glspMultiplier.small")};
    }
  `}

  ${(0, $atWKR.media).mediumUp`
    :root {
      --base-text-increment: ${(0, $atWKR.themeVal)("type.base.sizeIncrement.medium")};
      --base-space-multiplier: ${(0, $atWKR.themeVal)("layout.glspMultiplier.medium")};
    }
  `}

  ${(0, $atWKR.media).largeUp`
    :root {
      --base-text-increment: ${(0, $atWKR.themeVal)("type.base.sizeIncrement.large")};
      --base-space-multiplier: ${(0, $atWKR.themeVal)("layout.glspMultiplier.large")};
    }
  `}

  ${(0, $atWKR.media).xlargeUp`
    :root {
      --base-text-increment: ${(0, $atWKR.themeVal)("type.base.sizeIncrement.xlarge")};
      --base-space-multiplier: ${(0, $atWKR.themeVal)("layout.glspMultiplier.xlarge")};
    }
  `}
`;
const $cce927899ce36ecd$export$b427be1880cc7333 = (0, $6fhRl.css)`
  font-family: ${(0, $atWKR.themeVal)("type.base.family")};
  line-height: calc(0.5rem + 1em);
`;

});
parcelRegister("johEW", function(module, exports) {

$parcel$export(module.exports, "Tip", function () { return $d4fbbe49564f973d$export$c92c6401b52a9298; });
$parcel$export(module.exports, "reactTippyStyles", function () { return $d4fbbe49564f973d$export$27afe0e50870a053; });

var $iuYxf = parcelRequire("iuYxf");


var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");
const $d4fbbe49564f973d$export$c92c6401b52a9298 = (0, $iuYxf.default);
const $d4fbbe49564f973d$export$27afe0e50870a053 = ()=>(0, $6fhRl.css)`
  body {
    [data-tippy-root] {
      z-index: ${(0, $atWKR.themeVal)("zIndices.tooltip")} !important;
    }

    .tippy-box {
      background-color: ${(0, $atWKR.themeVal)("color.base")};
      border-radius: ${(0, $atWKR.themeVal)("shape.rounded")};
    }

    .tippy-arrow {
      color: ${(0, $atWKR.themeVal)("color.base")};
    }

    .tippy-content {
      padding: ${(0, $atWKR.glsp)(0.25, 0.5)};
    }
  }
`;

});
parcelRegister("iuYxf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d779fc5b0c72da4e$export$2e2bcd8739ae039; });

var $9N4xl = parcelRequire("9N4xl");

var $3RyIS = parcelRequire("3RyIS");

var $3qHRY = parcelRequire("3qHRY");
function $d779fc5b0c72da4e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d779fc5b0c72da4e$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
function $d779fc5b0c72da4e$var$preserveRef(ref, node) {
    if (ref) {
        if (typeof ref === "function") ref(node);
        if (({}).hasOwnProperty.call(ref, "current")) ref.current = node;
    }
}
function $d779fc5b0c72da4e$var$ssrSafeCreateDiv() {
    return $d779fc5b0c72da4e$var$isBrowser && document.createElement("div");
}
function $d779fc5b0c72da4e$var$toDataAttributes(attrs) {
    var dataAttrs = {
        "data-placement": attrs.placement
    };
    if (attrs.referenceHidden) dataAttrs["data-reference-hidden"] = "";
    if (attrs.escaped) dataAttrs["data-escaped"] = "";
    return dataAttrs;
}
function $d779fc5b0c72da4e$var$deepEqual(x, y) {
    if (x === y) return true;
    else if (typeof x === "object" && x != null && typeof y === "object" && y != null) {
        if (Object.keys(x).length !== Object.keys(y).length) return false;
        for(var prop in x){
            if (y.hasOwnProperty(prop)) {
                if (!$d779fc5b0c72da4e$var$deepEqual(x[prop], y[prop])) return false;
            } else return false;
        }
        return true;
    } else return false;
}
function $d779fc5b0c72da4e$var$uniqueByShape(arr) {
    var output = [];
    arr.forEach(function(item) {
        if (!output.find(function(outputItem) {
            return $d779fc5b0c72da4e$var$deepEqual(item, outputItem);
        })) output.push(item);
    });
    return output;
}
function $d779fc5b0c72da4e$var$deepPreserveProps(instanceProps, componentProps) {
    var _instanceProps$popper, _componentProps$poppe;
    return Object.assign({}, componentProps, {
        popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
            modifiers: $d779fc5b0c72da4e$var$uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
        })
    });
}
var $d779fc5b0c72da4e$var$useIsomorphicLayoutEffect = $d779fc5b0c72da4e$var$isBrowser ? (0, $3RyIS.useLayoutEffect) : (0, $3RyIS.useEffect);
function $d779fc5b0c72da4e$var$useMutableBox(initialValue) {
    // Using refs instead of state as it's recommended to not store imperative
    // values in state due to memory problems in React(?)
    var ref = (0, $3RyIS.useRef)();
    if (!ref.current) ref.current = typeof initialValue === "function" ? initialValue() : initialValue;
    return ref.current;
}
function $d779fc5b0c72da4e$var$updateClassName(box, action, classNames) {
    classNames.split(/\s+/).forEach(function(name) {
        if (name) box.classList[action](name);
    });
}
var $d779fc5b0c72da4e$var$classNamePlugin = {
    name: "className",
    defaultValue: "",
    fn: function fn(instance) {
        var box = instance.popper.firstElementChild;
        var isDefaultRenderFn = function isDefaultRenderFn() {
            var _instance$props$rende;
            return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
        };
        function add() {
            if (instance.props.className && !isDefaultRenderFn()) {
                console.warn([
                    "@tippyjs/react: Cannot use `className` prop in conjunction with",
                    "`render` prop. Place the className on the element you are",
                    "rendering."
                ].join(" "));
                return;
            }
            $d779fc5b0c72da4e$var$updateClassName(box, "add", instance.props.className);
        }
        function remove() {
            if (isDefaultRenderFn()) $d779fc5b0c72da4e$var$updateClassName(box, "remove", instance.props.className);
        }
        return {
            onCreate: add,
            onBeforeUpdate: remove,
            onAfterUpdate: add
        };
    }
};
function $d779fc5b0c72da4e$var$TippyGenerator(tippy) {
    function Tippy(_ref) {
        var children = _ref.children, content = _ref.content, visible = _ref.visible, singleton = _ref.singleton, render = _ref.render, reference = _ref.reference, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$ignoreAttributes = _ref.ignoreAttributes, ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes, __source = _ref.__source, __self = _ref.__self, restOfNativeProps = $d779fc5b0c72da4e$var$_objectWithoutPropertiesLoose(_ref, [
            "children",
            "content",
            "visible",
            "singleton",
            "render",
            "reference",
            "disabled",
            "ignoreAttributes",
            "__source",
            "__self"
        ]);
        var isControlledMode = visible !== undefined;
        var isSingletonMode = singleton !== undefined;
        var _useState = (0, $3RyIS.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var _useState2 = (0, $3RyIS.useState)({}), attrs = _useState2[0], setAttrs = _useState2[1];
        var _useState3 = (0, $3RyIS.useState)(), singletonContent = _useState3[0], setSingletonContent = _useState3[1];
        var mutableBox = $d779fc5b0c72da4e$var$useMutableBox(function() {
            return {
                container: $d779fc5b0c72da4e$var$ssrSafeCreateDiv(),
                renders: 1
            };
        });
        var props = Object.assign({
            ignoreAttributes: ignoreAttributes
        }, restOfNativeProps, {
            content: mutableBox.container
        });
        if (isControlledMode) {
            [
                "trigger",
                "hideOnClick",
                "showOnCreate"
            ].forEach(function(nativeStateProp) {
                if (props[nativeStateProp] !== undefined) console.warn([
                    "@tippyjs/react: Cannot specify `" + nativeStateProp + "` prop in",
                    "controlled mode (`visible` prop)"
                ].join(" "));
            });
            props.trigger = "manual";
            props.hideOnClick = false;
        }
        if (isSingletonMode) disabled = true;
        var computedProps = props;
        var plugins = props.plugins || [];
        if (render) computedProps = Object.assign({}, props, {
            plugins: isSingletonMode && singleton.data != null ? [].concat(plugins, [
                {
                    fn: function fn() {
                        return {
                            onTrigger: function onTrigger(instance, event) {
                                var node = singleton.data.children.find(function(_ref2) {
                                    var instance = _ref2.instance;
                                    return instance.reference === event.currentTarget;
                                });
                                instance.state.$$activeSingletonInstance = node.instance;
                                setSingletonContent(node.content);
                            }
                        };
                    }
                }
            ]) : plugins,
            render: function render() {
                return {
                    popper: mutableBox.container
                };
            }
        });
        var deps = [
            reference
        ].concat(children ? [
            children.type
        ] : []); // CREATE
        $d779fc5b0c72da4e$var$useIsomorphicLayoutEffect(function() {
            var element = reference;
            if (reference && reference.hasOwnProperty("current")) element = reference.current;
            var instance = tippy(element || mutableBox.ref || $d779fc5b0c72da4e$var$ssrSafeCreateDiv(), Object.assign({}, computedProps, {
                plugins: [
                    $d779fc5b0c72da4e$var$classNamePlugin
                ].concat(props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            if (visible) instance.show();
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps,
                setSingletonContent: setSingletonContent
            });
            setMounted(true);
            return function() {
                instance.destroy();
                singleton == null || singleton.cleanup(instance);
            };
        }, deps); // UPDATE
        $d779fc5b0c72da4e$var$useIsomorphicLayoutEffect(function() {
            var _instance$popperInsta;
            // Prevent this effect from running on 1st render
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var instance = mutableBox.instance;
            instance.setProps($d779fc5b0c72da4e$var$deepPreserveProps(instance.props, computedProps)); // Fixes #264
            (_instance$popperInsta = instance.popperInstance) == null || _instance$popperInsta.forceUpdate();
            if (disabled) instance.disable();
            else instance.enable();
            if (isControlledMode) {
                if (visible) instance.show();
                else instance.hide();
            }
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps,
                setSingletonContent: setSingletonContent
            });
        });
        $d779fc5b0c72da4e$var$useIsomorphicLayoutEffect(function() {
            var _instance$props$poppe;
            if (!render) return;
            var instance = mutableBox.instance;
            instance.setProps({
                popperOptions: Object.assign({}, instance.props.popperOptions, {
                    modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function(_ref3) {
                        var name = _ref3.name;
                        return name !== "$$tippyReact";
                    }), [
                        {
                            name: "$$tippyReact",
                            enabled: true,
                            phase: "beforeWrite",
                            requires: [
                                "computeStyles"
                            ],
                            fn: function fn(_ref4) {
                                var _state$modifiersData;
                                var state = _ref4.state;
                                var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
                                // loop. This expression _must_ evaluate to false when required
                                if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) setAttrs({
                                    placement: state.placement,
                                    referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                                    escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                                });
                                state.attributes.popper = {};
                            }
                        }
                    ])
                })
            });
        }, [
            attrs.placement,
            attrs.referenceHidden,
            attrs.escaped
        ].concat(deps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).Fragment, null, children ? /*#__PURE__*/ (0, $3RyIS.cloneElement)(children, {
            ref: function ref(node) {
                mutableBox.ref = node;
                $d779fc5b0c72da4e$var$preserveRef(children.ref, node);
            }
        }) : null, mounted && /*#__PURE__*/ (0, $3qHRY.createPortal)(render ? render($d779fc5b0c72da4e$var$toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container));
    }
    return Tippy;
}
function $d779fc5b0c72da4e$var$useSingletonGenerator(createSingleton) {
    return function useSingleton(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$overrides = _ref.overrides, overrides = _ref$overrides === void 0 ? [] : _ref$overrides;
        var _useState = (0, $3RyIS.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var mutableBox = $d779fc5b0c72da4e$var$useMutableBox({
            children: [],
            renders: 1
        });
        $d779fc5b0c72da4e$var$useIsomorphicLayoutEffect(function() {
            if (!mounted) {
                setMounted(true);
                return;
            }
            var children = mutableBox.children, sourceData = mutableBox.sourceData;
            if (!sourceData) {
                console.error([
                    "@tippyjs/react: The `source` variable from `useSingleton()` has",
                    "not been passed to a <Tippy /> component."
                ].join(" "));
                return;
            }
            var instance = createSingleton(children.map(function(child) {
                return child.instance;
            }), Object.assign({}, sourceData.props, {
                popperOptions: sourceData.instance.props.popperOptions,
                overrides: overrides,
                plugins: [
                    $d779fc5b0c72da4e$var$classNamePlugin
                ].concat(sourceData.props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            return function() {
                instance.destroy();
                mutableBox.children = children.filter(function(_ref2) {
                    var instance = _ref2.instance;
                    return !instance.state.isDestroyed;
                });
            };
        }, [
            mounted
        ]);
        $d779fc5b0c72da4e$var$useIsomorphicLayoutEffect(function() {
            if (!mounted) return;
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var children = mutableBox.children, instance = mutableBox.instance, sourceData = mutableBox.sourceData;
            if (!(instance && sourceData)) return;
            var _sourceData$props = sourceData.props, content = _sourceData$props.content, props = $d779fc5b0c72da4e$var$_objectWithoutPropertiesLoose(_sourceData$props, [
                "content"
            ]);
            instance.setProps($d779fc5b0c72da4e$var$deepPreserveProps(instance.props, Object.assign({}, props, {
                overrides: overrides
            })));
            instance.setInstances(children.map(function(child) {
                return child.instance;
            }));
            if (disabled) instance.disable();
            else instance.enable();
        });
        return (0, $3RyIS.useMemo)(function() {
            var source = {
                data: mutableBox,
                hook: function hook(data) {
                    mutableBox.sourceData = data;
                    mutableBox.setSingletonContent = data.setSingletonContent;
                },
                cleanup: function cleanup() {
                    mutableBox.sourceData = null;
                }
            };
            var target = {
                hook: function hook(data) {
                    var _mutableBox$instance, _mutableBox$instance2;
                    mutableBox.children = mutableBox.children.filter(function(_ref3) {
                        var instance = _ref3.instance;
                        return data.instance !== instance;
                    });
                    mutableBox.children.push(data);
                    if (((_mutableBox$instance = mutableBox.instance) == null ? void 0 : _mutableBox$instance.state.isMounted) && ((_mutableBox$instance2 = mutableBox.instance) == null ? void 0 : _mutableBox$instance2.state.$$activeSingletonInstance) === data.instance) mutableBox.setSingletonContent == null || mutableBox.setSingletonContent(data.content);
                    if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                        return child.instance;
                    }));
                },
                cleanup: function cleanup(instance) {
                    mutableBox.children = mutableBox.children.filter(function(data) {
                        return data.instance !== instance;
                    });
                    if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                        return child.instance;
                    }));
                }
            };
            return [
                source,
                target
            ];
        }, []);
    };
}
var $d779fc5b0c72da4e$var$forwardRef = function(Tippy, defaultProps) {
    return /*#__PURE__*/ (0, $3RyIS.forwardRef)(function TippyWrapper(_ref, _ref2) {
        var children = _ref.children, props = $d779fc5b0c72da4e$var$_objectWithoutPropertiesLoose(_ref, [
            "children"
        ]);
        return(/*#__PURE__*/ // If I spread them separately here, Babel adds the _extends ponyfill for
        // some reason
        (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/ (0, $3RyIS.cloneElement)(children, {
            ref: function ref(node) {
                $d779fc5b0c72da4e$var$preserveRef(_ref2, node);
                $d779fc5b0c72da4e$var$preserveRef(children.ref, node);
            }
        }) : null));
    });
};
var $d779fc5b0c72da4e$export$abf4268d2dd55708 = /*#__PURE__*/ $d779fc5b0c72da4e$var$useSingletonGenerator((0, $9N4xl.createSingleton));
var $d779fc5b0c72da4e$var$index = /*#__PURE__*/ $d779fc5b0c72da4e$var$forwardRef(/*#__PURE__*/ $d779fc5b0c72da4e$var$TippyGenerator((0, $9N4xl.default)));
var $d779fc5b0c72da4e$export$2e2bcd8739ae039 = $d779fc5b0c72da4e$var$index;

});
parcelRegister("9N4xl", function(module, exports) {

$parcel$export(module.exports, "createSingleton", function () { return $720c3592c323b2f6$export$374c483667c1ea9b; });
$parcel$export(module.exports, "followCursor", function () { return $720c3592c323b2f6$export$ac81526b64504ab6; });
$parcel$export(module.exports, "default", function () { return $720c3592c323b2f6$export$2e2bcd8739ae039; });
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ 
var $aKq0V = parcelRequire("aKq0V");
var $l8mzF = parcelRequire("l8mzF");
var $720c3592c323b2f6$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $720c3592c323b2f6$var$BOX_CLASS = "tippy-box";
var $720c3592c323b2f6$var$CONTENT_CLASS = "tippy-content";
var $720c3592c323b2f6$var$BACKDROP_CLASS = "tippy-backdrop";
var $720c3592c323b2f6$var$ARROW_CLASS = "tippy-arrow";
var $720c3592c323b2f6$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $720c3592c323b2f6$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $720c3592c323b2f6$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $720c3592c323b2f6$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $720c3592c323b2f6$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $720c3592c323b2f6$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
}
function $720c3592c323b2f6$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === "function" ? value.apply(void 0, args) : value;
}
function $720c3592c323b2f6$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $720c3592c323b2f6$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $720c3592c323b2f6$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $720c3592c323b2f6$var$normalizeToArray(value) {
    return [].concat(value);
}
function $720c3592c323b2f6$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $720c3592c323b2f6$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $720c3592c323b2f6$var$getBasePlacement(placement) {
    return placement.split("-")[0];
}
function $720c3592c323b2f6$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $720c3592c323b2f6$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $720c3592c323b2f6$var$div() {
    return document.createElement("div");
}
function $720c3592c323b2f6$var$isElement(value) {
    return [
        "Element",
        "Fragment"
    ].some(function(type) {
        return $720c3592c323b2f6$var$isType(value, type);
    });
}
function $720c3592c323b2f6$var$isNodeList(value) {
    return $720c3592c323b2f6$var$isType(value, "NodeList");
}
function $720c3592c323b2f6$var$isMouseEvent(value) {
    return $720c3592c323b2f6$var$isType(value, "MouseEvent");
}
function $720c3592c323b2f6$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $720c3592c323b2f6$var$getArrayOfElements(value) {
    if ($720c3592c323b2f6$var$isElement(value)) return [
        value
    ];
    if ($720c3592c323b2f6$var$isNodeList(value)) return $720c3592c323b2f6$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $720c3592c323b2f6$var$arrayFrom(document.querySelectorAll(value));
}
function $720c3592c323b2f6$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $720c3592c323b2f6$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute("data-state", state);
    });
}
function $720c3592c323b2f6$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $720c3592c323b2f6$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $720c3592c323b2f6$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $720c3592c323b2f6$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
        var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $720c3592c323b2f6$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        "transitionend",
        "webkitTransitionEnd"
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $720c3592c323b2f6$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $720c3592c323b2f6$var$currentInput = {
    isTouch: false
};
var $720c3592c323b2f6$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $720c3592c323b2f6$var$onDocumentTouchStart() {
    if ($720c3592c323b2f6$var$currentInput.isTouch) return;
    $720c3592c323b2f6$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener("mousemove", $720c3592c323b2f6$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $720c3592c323b2f6$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $720c3592c323b2f6$var$lastMouseMoveTime < 20) {
        $720c3592c323b2f6$var$currentInput.isTouch = false;
        document.removeEventListener("mousemove", $720c3592c323b2f6$var$onDocumentMouseMove);
    }
    $720c3592c323b2f6$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $720c3592c323b2f6$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($720c3592c323b2f6$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $720c3592c323b2f6$var$bindGlobalEventListeners() {
    document.addEventListener("touchstart", $720c3592c323b2f6$var$onDocumentTouchStart, $720c3592c323b2f6$var$TOUCH_OPTIONS);
    window.addEventListener("blur", $720c3592c323b2f6$var$onWindowBlur);
}
var $720c3592c323b2f6$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var $720c3592c323b2f6$var$isIE11 = $720c3592c323b2f6$var$isBrowser ? !!window.msCrypto : false;
function $720c3592c323b2f6$var$createMemoryLeakWarning(method) {
    var txt = method === "destroy" ? "n already-" : " ";
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        "indicates a potential memory leak."
    ].join(" ");
}
function $720c3592c323b2f6$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
}
function $720c3592c323b2f6$var$getDevMessage(message) {
    return $720c3592c323b2f6$var$clean("\n  %ctippy.js\n\n  %c" + $720c3592c323b2f6$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $720c3592c323b2f6$var$getFormattedMessage(message) {
    return [
        $720c3592c323b2f6$var$getDevMessage(message),
        "color: #00C584; font-size: 1.3em; font-weight: bold;",
        "line-height: 1.5",
        "color: #a6a095;"
    ];
} // Assume warnings and errors never have the same message
var $720c3592c323b2f6$var$visitedMessages;
$720c3592c323b2f6$var$resetVisitedMessages();
function $720c3592c323b2f6$var$resetVisitedMessages() {
    $720c3592c323b2f6$var$visitedMessages = new Set();
}
function $720c3592c323b2f6$var$warnWhen(condition, message) {
    if (condition && !$720c3592c323b2f6$var$visitedMessages.has(message)) {
        var _console;
        $720c3592c323b2f6$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $720c3592c323b2f6$var$getFormattedMessage(message));
    }
}
function $720c3592c323b2f6$var$errorWhen(condition, message) {
    if (condition && !$720c3592c323b2f6$var$visitedMessages.has(message)) {
        var _console2;
        $720c3592c323b2f6$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $720c3592c323b2f6$var$getFormattedMessage(message));
    }
}
function $720c3592c323b2f6$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === "[object Object]" && !targets.addEventListener;
    $720c3592c323b2f6$var$errorWhen(didPassFalsyValue, [
        "tippy() was passed",
        "`" + String(targets) + "`",
        "as its targets (first) argument. Valid types are: String, Element,",
        "Element[], or NodeList."
    ].join(" "));
    $720c3592c323b2f6$var$errorWhen(didPassPlainObject, [
        "tippy() was passed a plain object which is not supported as an argument",
        "for virtual positioning. Use props.getReferenceClientRect instead."
    ].join(" "));
}
var $720c3592c323b2f6$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $720c3592c323b2f6$var$renderProps = {
    allowHTML: false,
    animation: "fade",
    arrow: true,
    content: "",
    inertia: false,
    maxWidth: 350,
    role: "tooltip",
    theme: "",
    zIndex: 9999
};
var $720c3592c323b2f6$var$defaultProps = Object.assign({
    appendTo: $720c3592c323b2f6$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: "auto",
        expanded: "auto"
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: "",
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: "top",
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: "mouseenter focus",
    triggerTarget: null
}, $720c3592c323b2f6$var$pluginProps, $720c3592c323b2f6$var$renderProps);
var $720c3592c323b2f6$var$defaultKeys = Object.keys($720c3592c323b2f6$var$defaultProps);
var $720c3592c323b2f6$var$setDefaultProps = function setDefaultProps(partialProps) {
    $720c3592c323b2f6$var$validateProps(partialProps, []);
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $720c3592c323b2f6$var$defaultProps[key] = partialProps[key];
    });
};
function $720c3592c323b2f6$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $720c3592c323b2f6$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $720c3592c323b2f6$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($720c3592c323b2f6$var$getExtendedPassedProps(Object.assign({}, $720c3592c323b2f6$var$defaultProps, {
        plugins: plugins
    }))) : $720c3592c323b2f6$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || "").trim();
        if (!valueAsString) return acc;
        if (key === "content") acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $720c3592c323b2f6$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $720c3592c323b2f6$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $720c3592c323b2f6$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $720c3592c323b2f6$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
        content: out.aria.content === "auto" ? props.interactive ? null : "describedby" : out.aria.content
    };
    return out;
}
function $720c3592c323b2f6$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $720c3592c323b2f6$var$removeProperties($720c3592c323b2f6$var$defaultProps, Object.keys($720c3592c323b2f6$var$pluginProps));
        var didPassUnknownProp = !$720c3592c323b2f6$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $720c3592c323b2f6$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            "a plugin, forgot to pass it in an array as props.plugins.",
            "\n\n",
            "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
            "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"
        ].join(" "));
    });
}
var $720c3592c323b2f6$var$innerHTML = function innerHTML() {
    return "innerHTML";
};
function $720c3592c323b2f6$var$dangerouslySetInnerHTML(element, html) {
    element[$720c3592c323b2f6$var$innerHTML()] = html;
}
function $720c3592c323b2f6$var$createArrowElement(value) {
    var arrow = $720c3592c323b2f6$var$div();
    if (value === true) arrow.className = $720c3592c323b2f6$var$ARROW_CLASS;
    else {
        arrow.className = $720c3592c323b2f6$var$SVG_ARROW_CLASS;
        if ($720c3592c323b2f6$var$isElement(value)) arrow.appendChild(value);
        else $720c3592c323b2f6$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $720c3592c323b2f6$var$setContent(content, props) {
    if ($720c3592c323b2f6$var$isElement(props.content)) {
        $720c3592c323b2f6$var$dangerouslySetInnerHTML(content, "");
        content.appendChild(props.content);
    } else if (typeof props.content !== "function") {
        if (props.allowHTML) $720c3592c323b2f6$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $720c3592c323b2f6$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $720c3592c323b2f6$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($720c3592c323b2f6$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($720c3592c323b2f6$var$ARROW_CLASS) || node.classList.contains($720c3592c323b2f6$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($720c3592c323b2f6$var$BACKDROP_CLASS);
        })
    };
}
function $720c3592c323b2f6$var$render(instance) {
    var popper = $720c3592c323b2f6$var$div();
    var box = $720c3592c323b2f6$var$div();
    box.className = $720c3592c323b2f6$var$BOX_CLASS;
    box.setAttribute("data-state", "hidden");
    box.setAttribute("tabindex", "-1");
    var content = $720c3592c323b2f6$var$div();
    content.className = $720c3592c323b2f6$var$CONTENT_CLASS;
    content.setAttribute("data-state", "hidden");
    $720c3592c323b2f6$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $720c3592c323b2f6$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute("data-theme", nextProps.theme);
        else box.removeAttribute("data-theme");
        if (typeof nextProps.animation === "string") box.setAttribute("data-animation", nextProps.animation);
        else box.removeAttribute("data-animation");
        if (nextProps.inertia) box.setAttribute("data-inertia", "");
        else box.removeAttribute("data-inertia");
        box.style.maxWidth = typeof nextProps.maxWidth === "number" ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute("role", nextProps.role);
        else box.removeAttribute("role");
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $720c3592c323b2f6$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($720c3592c323b2f6$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($720c3592c323b2f6$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$720c3592c323b2f6$var$render.$$tippy = true;
var $720c3592c323b2f6$var$idCounter = 1;
var $720c3592c323b2f6$var$mouseMoveListeners = []; // Used by `hideAll()`
var $720c3592c323b2f6$var$mountedInstances = [];
function $720c3592c323b2f6$var$createTippy(reference, passedProps) {
    var props = $720c3592c323b2f6$var$evaluateProps(reference, Object.assign({}, $720c3592c323b2f6$var$defaultProps, $720c3592c323b2f6$var$getExtendedPassedProps($720c3592c323b2f6$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $720c3592c323b2f6$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $720c3592c323b2f6$var$idCounter++;
    var popperInstance = null;
    var plugins = $720c3592c323b2f6$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $720c3592c323b2f6$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) {
        $720c3592c323b2f6$var$errorWhen(true, "render() function has not been supplied.");
        return instance;
    } // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute("data-tippy-root", "");
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute("aria-expanded");
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook("onCreate", [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener("mouseenter", function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener("mouseleave", function() {
        if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === "hold";
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $720c3592c323b2f6$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $720c3592c323b2f6$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $720c3592c323b2f6$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") return 0;
        return $720c3592c323b2f6$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $720c3592c323b2f6$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $720c3592c323b2f6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, "").trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $720c3592c323b2f6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
            else node.removeAttribute("aria-expanded");
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
        $720c3592c323b2f6$var$mouseMoveListeners = $720c3592c323b2f6$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($720c3592c323b2f6$var$currentInput.isTouch) {
            if (didTouchMove || event.type === "mousedown") return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $720c3592c323b2f6$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($720c3592c323b2f6$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $720c3592c323b2f6$var$actualContains(el, actualTarget);
        })) {
            if ($720c3592c323b2f6$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) return;
        } else invokeHook("onClickOutside", [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener("mousedown", onDocumentPress, true);
        doc.addEventListener("touchend", onDocumentPress, $720c3592c323b2f6$var$TOUCH_OPTIONS);
        doc.addEventListener("touchstart", onTouchStart, $720c3592c323b2f6$var$TOUCH_OPTIONS);
        doc.addEventListener("touchmove", onTouchMove, $720c3592c323b2f6$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener("mousedown", onDocumentPress, true);
        doc.removeEventListener("touchend", onDocumentPress, $720c3592c323b2f6$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchstart", onTouchStart, $720c3592c323b2f6$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchmove", onTouchMove, $720c3592c323b2f6$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $720c3592c323b2f6$var$updateTransitionEndListener(box, "remove", listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $720c3592c323b2f6$var$updateTransitionEndListener(box, "remove", currentTransitionEndListener);
        $720c3592c323b2f6$var$updateTransitionEndListener(box, "add", listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $720c3592c323b2f6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on("touchstart", onTrigger, {
                passive: true
            });
            on("touchend", onMouseLeave, {
                passive: true
            });
        }
        $720c3592c323b2f6$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === "manual") return;
            on(eventType, onTrigger);
            switch(eventType){
                case "mouseenter":
                    on("mouseleave", onMouseLeave);
                    break;
                case "focus":
                    on($720c3592c323b2f6$var$isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
                    break;
                case "focusin":
                    on("focusout", onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $720c3592c323b2f6$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $720c3592c323b2f6$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === "click") isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === "mousemove" && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($720c3592c323b2f6$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $720c3592c323b2f6$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $720c3592c323b2f6$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: "$$tippy",
            enabled: true,
            phase: "beforeWrite",
            requires: [
                "computeStyles"
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        "placement",
                        "reference-hidden",
                        "escaped"
                    ].forEach(function(attr) {
                        if (attr === "placement") box.setAttribute("data-placement", state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, "");
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: "flip",
                options: {
                    padding: 5
                }
            },
            {
                name: "computeStyles",
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: "arrow",
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $l8mzF.createPopper)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $720c3592c323b2f6$var$TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") parentNode = node.parentNode;
        else parentNode = $720c3592c323b2f6$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
        // Accessibility check
        $720c3592c323b2f6$var$warnWhen(instance.props.interactive && appendTo === $720c3592c323b2f6$var$defaultProps.appendTo && node.nextElementSibling !== popper, [
            "Interactive tippy element may not be accessible via keyboard",
            "navigation because it is not directly after the reference element",
            "in the DOM source order.",
            "\n\n",
            "Using a wrapper <div> or <span> tag around the reference element",
            "solves this by creating a new parentNode context.",
            "\n\n",
            "Specifying `appendTo: document.body` silences this warning, but it",
            "assumes you are using a focus management solution to handle",
            "keyboard navigation.",
            "\n\n",
            "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"
        ].join(" "));
    }
    function getNestedPopperTree() {
        return $720c3592c323b2f6$var$arrayFrom(popper.querySelectorAll("[data-tippy-root]"));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook("onTrigger", [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($720c3592c323b2f6$var$currentInput.isTouch && touchValue === "hold" && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook("onUntrigger", [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && [
            "mouseleave",
            "mousemove"
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        $720c3592c323b2f6$var$warnWhen(instance.state.isDestroyed, $720c3592c323b2f6$var$createMemoryLeakWarning("setProps"));
        if (instance.state.isDestroyed) return;
        invokeHook("onBeforeUpdate", [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $720c3592c323b2f6$var$evaluateProps(reference, Object.assign({}, prevProps, $720c3592c323b2f6$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $720c3592c323b2f6$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $720c3592c323b2f6$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute("aria-expanded");
        });
        else if (nextProps.triggerTarget) reference.removeAttribute("aria-expanded");
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook("onAfterUpdate", [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        $720c3592c323b2f6$var$warnWhen(instance.state.isDestroyed, $720c3592c323b2f6$var$createMemoryLeakWarning("show"));
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $720c3592c323b2f6$var$currentInput.isTouch && !instance.props.touch;
        var duration = $720c3592c323b2f6$var$getValueAtIndexOrReturn(instance.props.duration, 0, $720c3592c323b2f6$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute("disabled")) return;
        invokeHook("onShow", [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = "visible";
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = "none";
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $720c3592c323b2f6$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $720c3592c323b2f6$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $720c3592c323b2f6$var$setVisibilityState([
                    _box,
                    _content
                ], "visible");
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $720c3592c323b2f6$var$pushIfUnique($720c3592c323b2f6$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook("onMount", [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook("onShown", [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        $720c3592c323b2f6$var$warnWhen(instance.state.isDestroyed, $720c3592c323b2f6$var$createMemoryLeakWarning("hide"));
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $720c3592c323b2f6$var$getValueAtIndexOrReturn(instance.props.duration, 1, $720c3592c323b2f6$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook("onHide", [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = "hidden";
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $720c3592c323b2f6$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $720c3592c323b2f6$var$setVisibilityState([
                    box,
                    content
                ], "hidden");
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        $720c3592c323b2f6$var$warnWhen(instance.state.isDestroyed, $720c3592c323b2f6$var$createMemoryLeakWarning("hideWithInteractivity"));
        getDocument().addEventListener("mousemove", debouncedOnMouseMove);
        $720c3592c323b2f6$var$pushIfUnique($720c3592c323b2f6$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        $720c3592c323b2f6$var$warnWhen(instance.state.isDestroyed, $720c3592c323b2f6$var$createMemoryLeakWarning("unmount"));
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $720c3592c323b2f6$var$mountedInstances = $720c3592c323b2f6$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook("onHidden", [
            instance
        ]);
    }
    function destroy() {
        $720c3592c323b2f6$var$warnWhen(instance.state.isDestroyed, $720c3592c323b2f6$var$createMemoryLeakWarning("destroy"));
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook("onDestroy", [
            instance
        ]);
    }
}
function $720c3592c323b2f6$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $720c3592c323b2f6$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $720c3592c323b2f6$var$validateTargets(targets);
    $720c3592c323b2f6$var$validateProps(optionalProps, plugins);
    $720c3592c323b2f6$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $720c3592c323b2f6$var$getArrayOfElements(targets);
    var isSingleContentElement = $720c3592c323b2f6$var$isElement(passedProps.content);
    var isMoreThanOneReferenceElement = elements.length > 1;
    $720c3592c323b2f6$var$warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, [
        "tippy() was passed an Element as the `content` prop, but more than",
        "one tippy instance was created by this invocation. This means the",
        "content element will only be appended to the last tippy instance.",
        "\n\n",
        "Instead, pass the .innerHTML of the element, or use a function that",
        "returns a cloned version of the element instead.",
        "\n\n",
        "1) content: element.innerHTML\n",
        "2) content: () => element.cloneNode(true)"
    ].join(" "));
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $720c3592c323b2f6$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $720c3592c323b2f6$var$isElement(targets) ? instances[0] : instances;
}
$720c3592c323b2f6$var$tippy.defaultProps = $720c3592c323b2f6$var$defaultProps;
$720c3592c323b2f6$var$tippy.setDefaultProps = $720c3592c323b2f6$var$setDefaultProps;
$720c3592c323b2f6$var$tippy.currentInput = $720c3592c323b2f6$var$currentInput;
var $720c3592c323b2f6$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $720c3592c323b2f6$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $720c3592c323b2f6$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $720c3592c323b2f6$var$applyStylesModifier = Object.assign({}, (0, $aKq0V.default), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: "0",
                top: "0",
                margin: "0"
            },
            arrow: {
                position: "absolute"
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $720c3592c323b2f6$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    $720c3592c323b2f6$var$errorWhen(!Array.isArray(tippyInstances), [
        "The first argument passed to createSingleton() must be an array of",
        "tippy instances. The passed value was",
        String(tippyInstances)
    ].join(" "));
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $720c3592c323b2f6$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat("content").reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === "function" ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $720c3592c323b2f6$var$tippy($720c3592c323b2f6$var$div(), Object.assign({}, $720c3592c323b2f6$var$removeProperties(optionalProps, [
        "overrides"
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $720c3592c323b2f6$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === "number") return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $720c3592c323b2f6$var$BUBBLING_EVENTS_MAP = {
    mouseover: "mouseenter",
    focusin: "focus",
    click: "click"
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $720c3592c323b2f6$export$10b1921597150314(targets, props) {
    $720c3592c323b2f6$var$errorWhen(!(props && props.target), [
        "You must specity a `target` prop indicating a CSS selector string matching",
        "the target elements that should receive a tippy."
    ].join(" "));
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $720c3592c323b2f6$var$removeProperties(props, [
        "target"
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: "manual",
        touch: false
    });
    var childProps = Object.assign({
        touch: $720c3592c323b2f6$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $720c3592c323b2f6$var$tippy(targets, parentProps);
    var normalizedReturnValue = $720c3592c323b2f6$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute("data-tippy-trigger") || props.trigger || $720c3592c323b2f6$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === "touchstart" && typeof childProps.touch === "boolean") return;
        if (event.type !== "touchstart" && trigger.indexOf($720c3592c323b2f6$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $720c3592c323b2f6$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, "touchstart", onTrigger, $720c3592c323b2f6$var$TOUCH_OPTIONS);
        on(reference, "mouseover", onTrigger);
        on(reference, "focusin", onTrigger);
        on(reference, "click", onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $720c3592c323b2f6$export$dd8ded329c01db79 = {
    name: "animateFill",
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) {
            $720c3592c323b2f6$var$errorWhen(instance.props.animateFill, "The `animateFill` plugin requires the default render function.");
            return {};
        }
        var _getChildren = $720c3592c323b2f6$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $720c3592c323b2f6$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute("data-animatefill", "");
                    box.style.overflow = "hidden";
                    instance.setProps({
                        arrow: false,
                        animation: "shift-away"
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace("ms", "")); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $720c3592c323b2f6$var$setVisibilityState([
                        backdrop
                    ], "visible");
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = "0ms";
            },
            onHide: function onHide() {
                if (backdrop) $720c3592c323b2f6$var$setVisibilityState([
                    backdrop
                ], "hidden");
            }
        };
    }
};
function $720c3592c323b2f6$var$createBackdropElement() {
    var backdrop = $720c3592c323b2f6$var$div();
    backdrop.className = $720c3592c323b2f6$var$BACKDROP_CLASS;
    $720c3592c323b2f6$var$setVisibilityState([
        backdrop
    ], "hidden");
    return backdrop;
}
var $720c3592c323b2f6$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $720c3592c323b2f6$var$activeInstances = [];
function $720c3592c323b2f6$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $720c3592c323b2f6$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $720c3592c323b2f6$var$addMouseCoordsListener(doc) {
    doc.addEventListener("mousemove", $720c3592c323b2f6$var$storeMouseCoords);
}
function $720c3592c323b2f6$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener("mousemove", $720c3592c323b2f6$var$storeMouseCoords);
}
var $720c3592c323b2f6$export$ac81526b64504ab6 = {
    name: "followCursor",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $720c3592c323b2f6$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === "initial" && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener("mousemove", onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener("mousemove", onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === "initial") {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === "horizontal" ? rect.top : y;
                    var right = followCursor === "vertical" ? rect.right : x;
                    var bottom = followCursor === "horizontal" ? rect.bottom : y;
                    var left = followCursor === "vertical" ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $720c3592c323b2f6$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $720c3592c323b2f6$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $720c3592c323b2f6$var$activeInstances = $720c3592c323b2f6$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($720c3592c323b2f6$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $720c3592c323b2f6$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($720c3592c323b2f6$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($720c3592c323b2f6$var$isMouseEvent(event)) $720c3592c323b2f6$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === "focus";
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $720c3592c323b2f6$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $720c3592c323b2f6$export$e2b668424a9c728 = {
    name: "inlinePositioning",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: "tippyInlinePositioning",
            enabled: true,
            phase: "afterWrite",
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $720c3592c323b2f6$var$getInlineBoundingClientRect($720c3592c323b2f6$var$getBasePlacement(placement), reference.getBoundingClientRect(), $720c3592c323b2f6$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($720c3592c323b2f6$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($720c3592c323b2f6$var$isMouseEvent(event)) {
                    var rects = $720c3592c323b2f6$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $720c3592c323b2f6$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case "top":
        case "bottom":
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === "top";
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case "left":
        case "right":
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === "left" ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $720c3592c323b2f6$export$4bd4b47501432316 = {
    name: "sticky",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck("reference") ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck("popper") ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $720c3592c323b2f6$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $720c3592c323b2f6$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $720c3592c323b2f6$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$720c3592c323b2f6$var$tippy.setDefaultProps({
    render: $720c3592c323b2f6$var$render
});
var $720c3592c323b2f6$export$2e2bcd8739ae039 = $720c3592c323b2f6$var$tippy;

});
parcelRegister("aKq0V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d326113857788b1$export$2e2bcd8739ae039; });

var $dlw4S = parcelRequire("dlw4S");

var $3YhAU = parcelRequire("3YhAU");
// and applies them to the HTMLElements such as popper and arrow
function $7d326113857788b1$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $3YhAU.isHTMLElement)(element) || !(0, $dlw4S.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7d326113857788b1$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $3YhAU.isHTMLElement)(element) || !(0, $dlw4S.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7d326113857788b1$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7d326113857788b1$var$applyStyles,
    effect: $7d326113857788b1$var$effect,
    requires: [
        "computeStyles"
    ]
};

});
parcelRegister("dlw4S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b761e7869d1b32a$export$2e2bcd8739ae039; });
function $9b761e7869d1b32a$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("3YhAU", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $2e449f8bb0dd6bdb$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $2e449f8bb0dd6bdb$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $2e449f8bb0dd6bdb$export$af51f0f06c0f328a; });

var $dlBK6 = parcelRequire("dlBK6");
function $2e449f8bb0dd6bdb$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $dlBK6.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $2e449f8bb0dd6bdb$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $dlBK6.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $2e449f8bb0dd6bdb$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $dlBK6.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("dlBK6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b7a83704799f639$export$2e2bcd8739ae039; });
function $9b7a83704799f639$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("l8mzF", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $f62bdb19a70aebbe$export$8f7491d57c8f97a9; });

var $hDvce = parcelRequire("hDvce");

var $2MO3e = parcelRequire("2MO3e");

var $405KJ = parcelRequire("405KJ");

var $cv113 = parcelRequire("cv113");

var $aKq0V = parcelRequire("aKq0V");

var $crUTM = parcelRequire("crUTM");

var $jHXL8 = parcelRequire("jHXL8");

var $ayGIo = parcelRequire("ayGIo");

var $3jVTd = parcelRequire("3jVTd");

var $4n602 = parcelRequire("4n602");


var $f62bdb19a70aebbe$export$d34966752335dd47 = [
    (0, $2MO3e.default),
    (0, $405KJ.default),
    (0, $cv113.default),
    (0, $aKq0V.default),
    (0, $crUTM.default),
    (0, $jHXL8.default),
    (0, $ayGIo.default),
    (0, $3jVTd.default),
    (0, $4n602.default)
];
var $f62bdb19a70aebbe$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $hDvce.popperGenerator)({
    defaultModifiers: $f62bdb19a70aebbe$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("hDvce", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $cd6e471e5735de99$export$ed5e13716264f202; });

var $a6rwf = parcelRequire("a6rwf");

var $4k5Qq = parcelRequire("4k5Qq");

var $1uvId = parcelRequire("1uvId");

var $fVS9z = parcelRequire("fVS9z");

var $7iyDP = parcelRequire("7iyDP");

var $iLPIP = parcelRequire("iLPIP");

var $b2KU7 = parcelRequire("b2KU7");

var $ft4mC = parcelRequire("ft4mC");

var $ePg1I = parcelRequire("ePg1I");

var $hH1fq = parcelRequire("hH1fq");

var $ghCmx = parcelRequire("ghCmx");


var $3YhAU = parcelRequire("3YhAU");

var $h94gw = parcelRequire("h94gw");
var $cd6e471e5735de99$var$INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var $cd6e471e5735de99$var$INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var $cd6e471e5735de99$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $cd6e471e5735de99$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $cd6e471e5735de99$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $cd6e471e5735de99$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $cd6e471e5735de99$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $3YhAU.isElement)(reference) ? (0, $1uvId.default)(reference) : reference.contextElement ? (0, $1uvId.default)(reference.contextElement) : [],
                    popper: (0, $1uvId.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $iLPIP.default)((0, $ghCmx.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers = (0, $ePg1I.default)([].concat(orderedModifiers, state.options.modifiers), function(_ref) {
                    var name = _ref.name;
                    return name;
                });
                (0, $ft4mC.default)(modifiers);
                if ((0, $hH1fq.default)(state.options.placement) === (0, $h94gw.auto)) {
                    var flipModifier = state.orderedModifiers.find(function(_ref2) {
                        var name = _ref2.name;
                        return name === "flip";
                    });
                    if (!flipModifier) console.error([
                        'Popper: "auto" placements require the "flip" modifier be',
                        "present and enabled to work."
                    ].join(" "));
                }
                var _getComputedStyle = (0, $7iyDP.default)(popper), marginTop = _getComputedStyle.marginTop, marginRight = _getComputedStyle.marginRight, marginBottom = _getComputedStyle.marginBottom, marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
                // cause bugs with positioning, so we'll warn the consumer
                if ([
                    marginTop,
                    marginRight,
                    marginBottom,
                    marginLeft
                ].some(function(margin) {
                    return parseFloat(margin);
                })) console.warn([
                    'Popper: CSS "margin" styles cannot be used to apply padding',
                    "between the popper and its reference element or boundary.",
                    "To replicate margin, use the `offset` modifier, as well as",
                    "the `padding` option in the `preventOverflow` and `flip`",
                    "modifiers."
                ].join(" "));
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$cd6e471e5735de99$var$areValidElements(reference, popper)) {
                    console.error($cd6e471e5735de99$var$INVALID_ELEMENT_ERROR);
                    return;
                } // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $a6rwf.default)(reference, (0, $fVS9z.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $4k5Qq.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    __debug_loops__ += 1;
                    if (__debug_loops__ > 100) {
                        console.error($cd6e471e5735de99$var$INFINITE_LOOP_ERROR);
                        break;
                    }
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $b2KU7.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$cd6e471e5735de99$var$areValidElements(reference, popper)) {
            console.error($cd6e471e5735de99$var$INVALID_ELEMENT_ERROR);
            return instance;
        }
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $cd6e471e5735de99$export$8f7491d57c8f97a9 = /*#__PURE__*/ $cd6e471e5735de99$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("a6rwf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75afcfaa2ca10f46$export$2e2bcd8739ae039; });

var $62ABL = parcelRequire("62ABL");

var $8loCq = parcelRequire("8loCq");

var $dlw4S = parcelRequire("dlw4S");

var $3YhAU = parcelRequire("3YhAU");

var $4a3iy = parcelRequire("4a3iy");

var $54mI3 = parcelRequire("54mI3");

var $2GAR5 = parcelRequire("2GAR5");

var $uHBV8 = parcelRequire("uHBV8");
function $75afcfaa2ca10f46$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $uHBV8.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $uHBV8.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $75afcfaa2ca10f46$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $3YhAU.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $3YhAU.isHTMLElement)(offsetParent) && $75afcfaa2ca10f46$var$isElementScaled(offsetParent);
    var documentElement = (0, $54mI3.default)(offsetParent);
    var rect = (0, $62ABL.default)(elementOrVirtualElement, offsetParentIsScaled);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $dlw4S.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $2GAR5.default)(documentElement)) scroll = (0, $8loCq.default)(offsetParent);
        if ((0, $3YhAU.isHTMLElement)(offsetParent)) {
            offsets = (0, $62ABL.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $4a3iy.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("62ABL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $465f5397cfe89d20$export$2e2bcd8739ae039; });

var $3YhAU = parcelRequire("3YhAU");

var $uHBV8 = parcelRequire("uHBV8");
function $465f5397cfe89d20$export$2e2bcd8739ae039(element, includeScale) {
    if (includeScale === void 0) includeScale = false;
    var rect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if ((0, $3YhAU.isHTMLElement)(element) && includeScale) {
        var offsetHeight = element.offsetHeight;
        var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
        // Fallback to 1 in case both values are `0`
        if (offsetWidth > 0) scaleX = (0, $uHBV8.round)(rect.width) / offsetWidth || 1;
        if (offsetHeight > 0) scaleY = (0, $uHBV8.round)(rect.height) / offsetHeight || 1;
    }
    return {
        width: rect.width / scaleX,
        height: rect.height / scaleY,
        top: rect.top / scaleY,
        right: rect.right / scaleX,
        bottom: rect.bottom / scaleY,
        left: rect.left / scaleX,
        x: rect.left / scaleX,
        y: rect.top / scaleY
    };
}

});
parcelRegister("uHBV8", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $05c4a19e1cbbd18b$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $05c4a19e1cbbd18b$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $05c4a19e1cbbd18b$export$2077e0241d6afd3c; });
var $05c4a19e1cbbd18b$export$8960430cfd85939f = Math.max;
var $05c4a19e1cbbd18b$export$96ec731ed4dcb222 = Math.min;
var $05c4a19e1cbbd18b$export$2077e0241d6afd3c = Math.round;

});


parcelRegister("8loCq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $613361ac9ac38ec3$export$2e2bcd8739ae039; });

var $lBfJd = parcelRequire("lBfJd");

var $dlBK6 = parcelRequire("dlBK6");

var $3YhAU = parcelRequire("3YhAU");

var $e10Rj = parcelRequire("e10Rj");
function $613361ac9ac38ec3$export$2e2bcd8739ae039(node) {
    if (node === (0, $dlBK6.default)(node) || !(0, $3YhAU.isHTMLElement)(node)) return (0, $lBfJd.default)(node);
    else return (0, $e10Rj.default)(node);
}

});
parcelRegister("lBfJd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb9940f714d4ac74$export$2e2bcd8739ae039; });

var $dlBK6 = parcelRequire("dlBK6");
function $fb9940f714d4ac74$export$2e2bcd8739ae039(node) {
    var win = (0, $dlBK6.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("e10Rj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a341d33d6f717364$export$2e2bcd8739ae039; });
function $a341d33d6f717364$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("4a3iy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $307aa78ddcd32e15$export$2e2bcd8739ae039; });

var $62ABL = parcelRequire("62ABL");

var $54mI3 = parcelRequire("54mI3");

var $lBfJd = parcelRequire("lBfJd");
function $307aa78ddcd32e15$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $62ABL.default)((0, $54mI3.default)(element)).left + (0, $lBfJd.default)(element).scrollLeft;
}

});
parcelRegister("54mI3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b0ef11d8f5149c1$export$2e2bcd8739ae039; });

var $3YhAU = parcelRequire("3YhAU");
function $3b0ef11d8f5149c1$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $3YhAU.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("2GAR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f4c17b182c7a8db$export$2e2bcd8739ae039; });

var $7iyDP = parcelRequire("7iyDP");
function $1f4c17b182c7a8db$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $7iyDP.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("7iyDP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $550515e91b1904ef$export$2e2bcd8739ae039; });

var $dlBK6 = parcelRequire("dlBK6");
function $550515e91b1904ef$export$2e2bcd8739ae039(element) {
    return (0, $dlBK6.default)(element).getComputedStyle(element);
}

});



parcelRegister("4k5Qq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $325d904f5c0b3afa$export$2e2bcd8739ae039; });

var $62ABL = parcelRequire("62ABL");
function $325d904f5c0b3afa$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $62ABL.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("1uvId", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11613128d3382058$export$2e2bcd8739ae039; });

var $hIFav = parcelRequire("hIFav");

var $hIfFN = parcelRequire("hIfFN");

var $dlBK6 = parcelRequire("dlBK6");

var $2GAR5 = parcelRequire("2GAR5");
function $11613128d3382058$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $hIFav.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $dlBK6.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $2GAR5.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($11613128d3382058$export$2e2bcd8739ae039((0, $hIfFN.default)(target)));
}

});
parcelRegister("hIFav", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce667aeacbfcb987$export$2e2bcd8739ae039; });

var $hIfFN = parcelRequire("hIfFN");

var $2GAR5 = parcelRequire("2GAR5");

var $dlw4S = parcelRequire("dlw4S");

var $3YhAU = parcelRequire("3YhAU");
function $ce667aeacbfcb987$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $dlw4S.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $3YhAU.isHTMLElement)(node) && (0, $2GAR5.default)(node)) return node;
    return $ce667aeacbfcb987$export$2e2bcd8739ae039((0, $hIfFN.default)(node));
}

});
parcelRegister("hIfFN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce52b41c943701dd$export$2e2bcd8739ae039; });

var $dlw4S = parcelRequire("dlw4S");

var $54mI3 = parcelRequire("54mI3");

var $3YhAU = parcelRequire("3YhAU");
function $ce52b41c943701dd$export$2e2bcd8739ae039(element) {
    if ((0, $dlw4S.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $3YhAU.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $54mI3.default)(element) // fallback
    );
}

});



parcelRegister("fVS9z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9962f97dbfef606$export$2e2bcd8739ae039; });

var $dlBK6 = parcelRequire("dlBK6");

var $dlw4S = parcelRequire("dlw4S");

var $7iyDP = parcelRequire("7iyDP");

var $3YhAU = parcelRequire("3YhAU");

var $7hixx = parcelRequire("7hixx");

var $hIfFN = parcelRequire("hIfFN");
function $b9962f97dbfef606$var$getTrueOffsetParent(element) {
    if (!(0, $3YhAU.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $7iyDP.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $b9962f97dbfef606$var$getContainingBlock(element) {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1;
    var isIE = navigator.userAgent.indexOf("Trident") !== -1;
    if (isIE && (0, $3YhAU.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $7iyDP.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $hIfFN.default)(element);
    if ((0, $3YhAU.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $3YhAU.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $dlw4S.default)(currentNode)) < 0){
        var css = (0, $7iyDP.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $b9962f97dbfef606$export$2e2bcd8739ae039(element) {
    var window = (0, $dlBK6.default)(element);
    var offsetParent = $b9962f97dbfef606$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $7hixx.default)(offsetParent) && (0, $7iyDP.default)(offsetParent).position === "static")offsetParent = $b9962f97dbfef606$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $dlw4S.default)(offsetParent) === "html" || (0, $dlw4S.default)(offsetParent) === "body" && (0, $7iyDP.default)(offsetParent).position === "static")) return window;
    return offsetParent || $b9962f97dbfef606$var$getContainingBlock(element) || window;
}

});
parcelRegister("7hixx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54c8809869211918$export$2e2bcd8739ae039; });

var $dlw4S = parcelRequire("dlw4S");
function $54c8809869211918$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $dlw4S.default)(element)) >= 0;
}

});


parcelRegister("iLPIP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $daa4bcb78b946b3a$export$2e2bcd8739ae039; });

var $h94gw = parcelRequire("h94gw");
function $daa4bcb78b946b3a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $daa4bcb78b946b3a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $daa4bcb78b946b3a$var$order(modifiers); // order based on phase
    return (0, $h94gw.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("h94gw", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $c7b695fb9d478847$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $c7b695fb9d478847$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $c7b695fb9d478847$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $c7b695fb9d478847$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $c7b695fb9d478847$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $c7b695fb9d478847$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $c7b695fb9d478847$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $c7b695fb9d478847$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $c7b695fb9d478847$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $c7b695fb9d478847$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $c7b695fb9d478847$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $c7b695fb9d478847$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $c7b695fb9d478847$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $c7b695fb9d478847$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $c7b695fb9d478847$export$d087d3878fdf71d5; });
var $c7b695fb9d478847$export$1e95b668f3b82d = "top";
var $c7b695fb9d478847$export$40e543e69a8b3fbb = "bottom";
var $c7b695fb9d478847$export$79ffe56a765070d2 = "right";
var $c7b695fb9d478847$export$eabcd2c8791e7bf4 = "left";
var $c7b695fb9d478847$export$dfb5619354ba860 = "auto";
var $c7b695fb9d478847$export$aec2ce47c367b8c3 = [
    $c7b695fb9d478847$export$1e95b668f3b82d,
    $c7b695fb9d478847$export$40e543e69a8b3fbb,
    $c7b695fb9d478847$export$79ffe56a765070d2,
    $c7b695fb9d478847$export$eabcd2c8791e7bf4
];
var $c7b695fb9d478847$export$b3571188c770cc5a = "start";
var $c7b695fb9d478847$export$bd5df0f255a350f8 = "end";
var $c7b695fb9d478847$export$390fd549c5303b4d = "clippingParents";
var $c7b695fb9d478847$export$d7b7311ec04a3e8f = "viewport";
var $c7b695fb9d478847$export$ae5ab1c730825774 = "popper";
var $c7b695fb9d478847$export$ca50aac9f3ba507f = "reference";
var $c7b695fb9d478847$export$368f9a87e87fa4e1 = /*#__PURE__*/ $c7b695fb9d478847$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $c7b695fb9d478847$export$b3571188c770cc5a,
        placement + "-" + $c7b695fb9d478847$export$bd5df0f255a350f8
    ]);
}, []);
var $c7b695fb9d478847$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($c7b695fb9d478847$export$aec2ce47c367b8c3, [
    $c7b695fb9d478847$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $c7b695fb9d478847$export$b3571188c770cc5a,
        placement + "-" + $c7b695fb9d478847$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $c7b695fb9d478847$export$421679a7c3d56e = "beforeRead";
var $c7b695fb9d478847$export$aafa59e2e03f2942 = "read";
var $c7b695fb9d478847$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $c7b695fb9d478847$export$c65e99957a05207c = "beforeMain";
var $c7b695fb9d478847$export$f22da7240b7add18 = "main";
var $c7b695fb9d478847$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $c7b695fb9d478847$export$8d4d2d70e7d46032 = "beforeWrite";
var $c7b695fb9d478847$export$68d8715fc104d294 = "write";
var $c7b695fb9d478847$export$70a6e5159acce2e6 = "afterWrite";
var $c7b695fb9d478847$export$d087d3878fdf71d5 = [
    $c7b695fb9d478847$export$421679a7c3d56e,
    $c7b695fb9d478847$export$aafa59e2e03f2942,
    $c7b695fb9d478847$export$6964f6c886723980,
    $c7b695fb9d478847$export$c65e99957a05207c,
    $c7b695fb9d478847$export$f22da7240b7add18,
    $c7b695fb9d478847$export$bab79516f2d662fe,
    $c7b695fb9d478847$export$8d4d2d70e7d46032,
    $c7b695fb9d478847$export$68d8715fc104d294,
    $c7b695fb9d478847$export$70a6e5159acce2e6
];

});


parcelRegister("b2KU7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80a443c8882e995a$export$2e2bcd8739ae039; });
function $80a443c8882e995a$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("ft4mC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b42cf308842ea96d$export$2e2bcd8739ae039; });

var $cMLGM = parcelRequire("cMLGM");

var $h94gw = parcelRequire("h94gw");
var $b42cf308842ea96d$var$INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var $b42cf308842ea96d$var$MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var $b42cf308842ea96d$var$VALID_PROPERTIES = [
    "name",
    "enabled",
    "phase",
    "fn",
    "effect",
    "requires",
    "options"
];
function $b42cf308842ea96d$export$2e2bcd8739ae039(modifiers) {
    modifiers.forEach(function(modifier) {
        [].concat(Object.keys(modifier), $b42cf308842ea96d$var$VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
        .filter(function(value, index, self) {
            return self.indexOf(value) === index;
        }).forEach(function(key) {
            switch(key){
                case "name":
                    if (typeof modifier.name !== "string") console.error((0, $cMLGM.default)($b42cf308842ea96d$var$INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', '"' + String(modifier.name) + '"'));
                    break;
                case "enabled":
                    if (typeof modifier.enabled !== "boolean") console.error((0, $cMLGM.default)($b42cf308842ea96d$var$INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', '"' + String(modifier.enabled) + '"'));
                    break;
                case "phase":
                    if ((0, $h94gw.modifierPhases).indexOf(modifier.phase) < 0) console.error((0, $cMLGM.default)($b42cf308842ea96d$var$INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + (0, $h94gw.modifierPhases).join(", "), '"' + String(modifier.phase) + '"'));
                    break;
                case "fn":
                    if (typeof modifier.fn !== "function") console.error((0, $cMLGM.default)($b42cf308842ea96d$var$INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', '"' + String(modifier.fn) + '"'));
                    break;
                case "effect":
                    if (modifier.effect != null && typeof modifier.effect !== "function") console.error((0, $cMLGM.default)($b42cf308842ea96d$var$INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', '"' + String(modifier.fn) + '"'));
                    break;
                case "requires":
                    if (modifier.requires != null && !Array.isArray(modifier.requires)) console.error((0, $cMLGM.default)($b42cf308842ea96d$var$INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', '"' + String(modifier.requires) + '"'));
                    break;
                case "requiresIfExists":
                    if (!Array.isArray(modifier.requiresIfExists)) console.error((0, $cMLGM.default)($b42cf308842ea96d$var$INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', '"' + String(modifier.requiresIfExists) + '"'));
                    break;
                case "options":
                case "data":
                    break;
                default:
                    console.error('PopperJS: an invalid property has been provided to the "' + modifier.name + '" modifier, valid properties are ' + $b42cf308842ea96d$var$VALID_PROPERTIES.map(function(s) {
                        return '"' + s + '"';
                    }).join(", ") + '; but "' + key + '" was provided.');
            }
            modifier.requires && modifier.requires.forEach(function(requirement) {
                if (modifiers.find(function(mod) {
                    return mod.name === requirement;
                }) == null) console.error((0, $cMLGM.default)($b42cf308842ea96d$var$MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
            });
        });
    });
}

});
parcelRegister("cMLGM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94eef5c2e5ca6f64$export$2e2bcd8739ae039; });
function $94eef5c2e5ca6f64$export$2e2bcd8739ae039(str) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return [].concat(args).reduce(function(p, c) {
        return p.replace(/%s/, c);
    }, str);
}

});


parcelRegister("ePg1I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acb242a8fb4d8740$export$2e2bcd8739ae039; });
function $acb242a8fb4d8740$export$2e2bcd8739ae039(arr, fn) {
    var identifiers = new Set();
    return arr.filter(function(item) {
        var identifier = fn(item);
        if (!identifiers.has(identifier)) {
            identifiers.add(identifier);
            return true;
        }
    });
}

});

parcelRegister("hH1fq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce176ba0991b36f2$export$2e2bcd8739ae039; });

function $ce176ba0991b36f2$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("ghCmx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdabfde1384ced6c$export$2e2bcd8739ae039; });
function $bdabfde1384ced6c$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("2MO3e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2076e38fd6542b4e$export$2e2bcd8739ae039; });

var $dlBK6 = parcelRequire("dlBK6");
var $2076e38fd6542b4e$var$passive = {
    passive: true
};
function $2076e38fd6542b4e$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $dlBK6.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $2076e38fd6542b4e$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $2076e38fd6542b4e$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $2076e38fd6542b4e$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $2076e38fd6542b4e$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $2076e38fd6542b4e$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $2076e38fd6542b4e$var$effect,
    data: {}
};

});

parcelRegister("405KJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e9b9fe5e8390439$export$2e2bcd8739ae039; });

var $jSh61 = parcelRequire("jSh61");
function $2e9b9fe5e8390439$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $jSh61.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $2e9b9fe5e8390439$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $2e9b9fe5e8390439$var$popperOffsets,
    data: {}
};

});
parcelRegister("jSh61", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7805268e80361b4$export$2e2bcd8739ae039; });

var $hH1fq = parcelRequire("hH1fq");

var $hHWXJ = parcelRequire("hHWXJ");

var $kNArq = parcelRequire("kNArq");

var $h94gw = parcelRequire("h94gw");
function $e7805268e80361b4$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $hH1fq.default)(placement) : null;
    var variation = placement ? (0, $hHWXJ.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $h94gw.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $h94gw.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $h94gw.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $h94gw.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $kNArq.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $h94gw.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $h94gw.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("hHWXJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce4430811525cfb4$export$2e2bcd8739ae039; });
function $ce4430811525cfb4$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("kNArq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f244a6c12d1dbb74$export$2e2bcd8739ae039; });
function $f244a6c12d1dbb74$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("cv113", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91992b0c09373bad$export$2e2bcd8739ae039; });

var $h94gw = parcelRequire("h94gw");

var $fVS9z = parcelRequire("fVS9z");

var $dlBK6 = parcelRequire("dlBK6");

var $54mI3 = parcelRequire("54mI3");

var $7iyDP = parcelRequire("7iyDP");

var $hH1fq = parcelRequire("hH1fq");

var $hHWXJ = parcelRequire("hHWXJ");

var $uHBV8 = parcelRequire("uHBV8");
var $91992b0c09373bad$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $91992b0c09373bad$var$roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $uHBV8.round)(x * dpr) / dpr || 0,
        y: (0, $uHBV8.round)(y * dpr) / dpr || 0
    };
}
function $91992b0c09373bad$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $h94gw.left);
    var sideY = (0, $h94gw.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $fVS9z.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $dlBK6.default)(popper)) {
            offsetParent = (0, $54mI3.default)(popper);
            if ((0, $7iyDP.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $h94gw.top) || (placement === (0, $h94gw.left) || placement === (0, $h94gw.right)) && variation === (0, $h94gw.end)) {
            sideY = (0, $h94gw.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $h94gw.left) || (placement === (0, $h94gw.top) || placement === (0, $h94gw.bottom)) && variation === (0, $h94gw.end)) {
            sideX = (0, $h94gw.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $91992b0c09373bad$var$unsetSides);
    var _ref4 = roundOffsets === true ? $91992b0c09373bad$var$roundOffsetsByDPR({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $91992b0c09373bad$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty = (0, $7iyDP.default)(state.elements.popper).transitionProperty || "";
    if (adaptive && [
        "transform",
        "top",
        "right",
        "bottom",
        "left"
    ].some(function(property) {
        return transitionProperty.indexOf(property) >= 0;
    })) console.warn([
        "Popper: Detected CSS transitions on at least one of the following",
        'CSS properties: "transform", "top", "right", "bottom", "left".',
        "\n\n",
        'Disable the "computeStyles" modifier\'s `adaptive` option to allow',
        "for smooth transitions, or remove these properties from the CSS",
        "transition declaration on the popper element if only transitioning",
        "opacity or background-color for example.",
        "\n\n",
        "We recommend using the popper element as a wrapper around an inner",
        "element that can have any CSS property transitioned for animations."
    ].join(" "));
    var commonStyles = {
        placement: (0, $hH1fq.default)(state.placement),
        variation: (0, $hHWXJ.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $91992b0c09373bad$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $91992b0c09373bad$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $91992b0c09373bad$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $91992b0c09373bad$var$computeStyles,
    data: {}
};

});

parcelRegister("crUTM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9104248e632c0c03$export$2e2bcd8739ae039; });

var $hH1fq = parcelRequire("hH1fq");

var $h94gw = parcelRequire("h94gw");
function $9104248e632c0c03$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $hH1fq.default)(placement);
    var invertDistance = [
        (0, $h94gw.left),
        (0, $h94gw.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $h94gw.left),
        (0, $h94gw.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $9104248e632c0c03$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $h94gw.placements).reduce(function(acc, placement) {
        acc[placement] = $9104248e632c0c03$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9104248e632c0c03$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $9104248e632c0c03$var$offset
};

});

parcelRegister("jHXL8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e59063671f631605$export$2e2bcd8739ae039; });

var $gDWFo = parcelRequire("gDWFo");

var $hH1fq = parcelRequire("hH1fq");

var $a7JNJ = parcelRequire("a7JNJ");

var $fp3j1 = parcelRequire("fp3j1");

var $2fjhO = parcelRequire("2fjhO");

var $h94gw = parcelRequire("h94gw");

var $hHWXJ = parcelRequire("hHWXJ");
function $e59063671f631605$var$getExpandedFallbackPlacements(placement) {
    if ((0, $hH1fq.default)(placement) === (0, $h94gw.auto)) return [];
    var oppositePlacement = (0, $gDWFo.default)(placement);
    return [
        (0, $a7JNJ.default)(placement),
        oppositePlacement,
        (0, $a7JNJ.default)(oppositePlacement)
    ];
}
function $e59063671f631605$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $hH1fq.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $gDWFo.default)(preferredPlacement)
    ] : $e59063671f631605$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $hH1fq.default)(placement) === (0, $h94gw.auto) ? (0, $2fjhO.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $hH1fq.default)(placement);
        var isStartVariation = (0, $hHWXJ.default)(placement) === (0, $h94gw.start);
        var isVertical = [
            (0, $h94gw.top),
            (0, $h94gw.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $fp3j1.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $h94gw.right) : (0, $h94gw.left) : isStartVariation ? (0, $h94gw.bottom) : (0, $h94gw.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $gDWFo.default)(mainVariationSide);
        var altVariationSide = (0, $gDWFo.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $e59063671f631605$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $e59063671f631605$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("gDWFo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1ddcbcee49cc3bd$export$2e2bcd8739ae039; });
var $c1ddcbcee49cc3bd$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $c1ddcbcee49cc3bd$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $c1ddcbcee49cc3bd$var$hash[matched];
    });
}

});

parcelRegister("a7JNJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75ee15fc046133ca$export$2e2bcd8739ae039; });
var $75ee15fc046133ca$var$hash = {
    start: "end",
    end: "start"
};
function $75ee15fc046133ca$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $75ee15fc046133ca$var$hash[matched];
    });
}

});

parcelRegister("fp3j1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b36bc146a035670a$export$2e2bcd8739ae039; });

var $1EhTM = parcelRequire("1EhTM");

var $54mI3 = parcelRequire("54mI3");

var $62ABL = parcelRequire("62ABL");

var $jSh61 = parcelRequire("jSh61");

var $ks2eW = parcelRequire("ks2eW");

var $h94gw = parcelRequire("h94gw");

var $3YhAU = parcelRequire("3YhAU");

var $fTc6w = parcelRequire("fTc6w");

var $6WSXK = parcelRequire("6WSXK");
function $b36bc146a035670a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $h94gw.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $h94gw.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $h94gw.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $fTc6w.default)(typeof padding !== "number" ? padding : (0, $6WSXK.default)(padding, (0, $h94gw.basePlacements)));
    var altContext = elementContext === (0, $h94gw.popper) ? (0, $h94gw.reference) : (0, $h94gw.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $1EhTM.default)((0, $3YhAU.isElement)(element) ? element : element.contextElement || (0, $54mI3.default)(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = (0, $62ABL.default)(state.elements.reference);
    var popperOffsets = (0, $jSh61.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $ks2eW.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $h94gw.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $h94gw.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $h94gw.right),
                (0, $h94gw.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $h94gw.top),
                (0, $h94gw.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("1EhTM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13376932bffe4eff$export$2e2bcd8739ae039; });

var $h94gw = parcelRequire("h94gw");

var $kY2wX = parcelRequire("kY2wX");

var $fh5FM = parcelRequire("fh5FM");

var $1uvId = parcelRequire("1uvId");

var $fVS9z = parcelRequire("fVS9z");

var $54mI3 = parcelRequire("54mI3");

var $7iyDP = parcelRequire("7iyDP");

var $3YhAU = parcelRequire("3YhAU");

var $62ABL = parcelRequire("62ABL");

var $hIfFN = parcelRequire("hIfFN");

var $iG8TS = parcelRequire("iG8TS");

var $dlw4S = parcelRequire("dlw4S");

var $ks2eW = parcelRequire("ks2eW");

var $uHBV8 = parcelRequire("uHBV8");
function $13376932bffe4eff$var$getInnerBoundingClientRect(element) {
    var rect = (0, $62ABL.default)(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $13376932bffe4eff$var$getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === (0, $h94gw.viewport) ? (0, $ks2eW.default)((0, $kY2wX.default)(element)) : (0, $3YhAU.isElement)(clippingParent) ? $13376932bffe4eff$var$getInnerBoundingClientRect(clippingParent) : (0, $ks2eW.default)((0, $fh5FM.default)((0, $54mI3.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $13376932bffe4eff$var$getClippingParents(element) {
    var clippingParents = (0, $1uvId.default)((0, $hIfFN.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $7iyDP.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $3YhAU.isHTMLElement)(element) ? (0, $fVS9z.default)(element) : element;
    if (!(0, $3YhAU.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $3YhAU.isElement)(clippingParent) && (0, $iG8TS.default)(clippingParent, clipperElement) && (0, $dlw4S.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $13376932bffe4eff$export$2e2bcd8739ae039(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === "clippingParents" ? $13376932bffe4eff$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $13376932bffe4eff$var$getClientRectFromMixedType(element, clippingParent);
        accRect.top = (0, $uHBV8.max)(rect.top, accRect.top);
        accRect.right = (0, $uHBV8.min)(rect.right, accRect.right);
        accRect.bottom = (0, $uHBV8.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $uHBV8.max)(rect.left, accRect.left);
        return accRect;
    }, $13376932bffe4eff$var$getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("kY2wX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43b5fc218187728$export$2e2bcd8739ae039; });

var $dlBK6 = parcelRequire("dlBK6");

var $54mI3 = parcelRequire("54mI3");

var $4a3iy = parcelRequire("4a3iy");
function $f43b5fc218187728$export$2e2bcd8739ae039(element) {
    var win = (0, $dlBK6.default)(element);
    var html = (0, $54mI3.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
        // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
        // errors due to floating point numbers, so we need to check precision.
        // Safari returns a number <= 0, usually < -1 when pinch-zoomed
        // Feature detection fails in mobile emulation mode in Chrome.
        // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
        // 0.001
        // Fallback here: "Not Safari" userAgent
        if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $4a3iy.default)(element),
        y: y
    };
}

});

parcelRegister("fh5FM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1ecd815de37b207$export$2e2bcd8739ae039; });

var $54mI3 = parcelRequire("54mI3");

var $7iyDP = parcelRequire("7iyDP");

var $4a3iy = parcelRequire("4a3iy");

var $lBfJd = parcelRequire("lBfJd");

var $uHBV8 = parcelRequire("uHBV8");
function $b1ecd815de37b207$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $54mI3.default)(element);
    var winScroll = (0, $lBfJd.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $uHBV8.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $uHBV8.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $4a3iy.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $7iyDP.default)(body || html).direction === "rtl") x += (0, $uHBV8.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("iG8TS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9930da757336997$export$2e2bcd8739ae039; });

var $3YhAU = parcelRequire("3YhAU");
function $d9930da757336997$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $3YhAU.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ks2eW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee3828fcacb4570c$export$2e2bcd8739ae039; });
function $ee3828fcacb4570c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("fTc6w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b91561bb19739729$export$2e2bcd8739ae039; });

var $fHDbj = parcelRequire("fHDbj");
function $b91561bb19739729$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $fHDbj.default)(), paddingObject);
}

});
parcelRegister("fHDbj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6e943c95044015d$export$2e2bcd8739ae039; });
function $b6e943c95044015d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("6WSXK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50f2cb4ad494d7b3$export$2e2bcd8739ae039; });
function $50f2cb4ad494d7b3$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("2fjhO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a2bf15d1f63b732$export$2e2bcd8739ae039; });

var $hHWXJ = parcelRequire("hHWXJ");

var $h94gw = parcelRequire("h94gw");

var $fp3j1 = parcelRequire("fp3j1");

var $hH1fq = parcelRequire("hH1fq");
function $1a2bf15d1f63b732$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $h94gw.placements) : _options$allowedAutoP;
    var variation = (0, $hHWXJ.default)(placement);
    var placements = variation ? flipVariations ? (0, $h94gw.variationPlacements) : (0, $h94gw.variationPlacements).filter(function(placement) {
        return (0, $hHWXJ.default)(placement) === variation;
    }) : (0, $h94gw.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) {
        allowedPlacements = placements;
        console.error([
            "Popper: The `allowedAutoPlacements` option did not allow any",
            "placements. Ensure the `placement` option matches the variation",
            "of the allowed placements.",
            'For example, "auto" cannot be used to allow "bottom-start".',
            'Use "auto-start" instead.'
        ].join(" "));
    } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $fp3j1.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $hH1fq.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("ayGIo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7afe36a9fc4e8482$export$2e2bcd8739ae039; });

var $h94gw = parcelRequire("h94gw");

var $hH1fq = parcelRequire("hH1fq");

var $kNArq = parcelRequire("kNArq");

var $ewmyF = parcelRequire("ewmyF");

var $3h2oT = parcelRequire("3h2oT");

var $4k5Qq = parcelRequire("4k5Qq");

var $fVS9z = parcelRequire("fVS9z");

var $fp3j1 = parcelRequire("fp3j1");

var $hHWXJ = parcelRequire("hHWXJ");

var $fHDbj = parcelRequire("fHDbj");

var $uHBV8 = parcelRequire("uHBV8");
function $7afe36a9fc4e8482$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $fp3j1.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $hH1fq.default)(state.placement);
    var variation = (0, $hHWXJ.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $kNArq.default)(basePlacement);
    var altAxis = (0, $ewmyF.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $h94gw.top) : (0, $h94gw.left);
        var altSide = mainAxis === "y" ? (0, $h94gw.bottom) : (0, $h94gw.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $h94gw.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $h94gw.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $4k5Qq.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $fHDbj.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $3h2oT.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $fVS9z.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $3h2oT.within)(tether ? (0, $uHBV8.min)(min, tetherMin) : min, offset, tether ? (0, $uHBV8.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $h94gw.top) : (0, $h94gw.left);
        var _altSide = mainAxis === "x" ? (0, $h94gw.bottom) : (0, $h94gw.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $h94gw.top),
            (0, $h94gw.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $3h2oT.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $3h2oT.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7afe36a9fc4e8482$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $7afe36a9fc4e8482$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("ewmyF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9258d735bb9dcad$export$2e2bcd8739ae039; });
function $a9258d735bb9dcad$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("3h2oT", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $2624d2556a49feec$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $2624d2556a49feec$export$86c8af6d3ef0b4a; });

var $uHBV8 = parcelRequire("uHBV8");
function $2624d2556a49feec$export$f28d906d67a997f3(min, value, max) {
    return (0, $uHBV8.max)(min, (0, $uHBV8.min)(value, max));
}
function $2624d2556a49feec$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $2624d2556a49feec$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("3jVTd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26b00d1a0b30de04$export$2e2bcd8739ae039; });

var $hH1fq = parcelRequire("hH1fq");

var $4k5Qq = parcelRequire("4k5Qq");

var $iG8TS = parcelRequire("iG8TS");

var $fVS9z = parcelRequire("fVS9z");

var $kNArq = parcelRequire("kNArq");

var $3h2oT = parcelRequire("3h2oT");

var $fTc6w = parcelRequire("fTc6w");

var $6WSXK = parcelRequire("6WSXK");

var $h94gw = parcelRequire("h94gw");

var $3YhAU = parcelRequire("3YhAU");
var $26b00d1a0b30de04$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $fTc6w.default)(typeof padding !== "number" ? padding : (0, $6WSXK.default)(padding, (0, $h94gw.basePlacements)));
};
function $26b00d1a0b30de04$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $hH1fq.default)(state.placement);
    var axis = (0, $kNArq.default)(basePlacement);
    var isVertical = [
        (0, $h94gw.left),
        (0, $h94gw.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $26b00d1a0b30de04$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $4k5Qq.default)(arrowElement);
    var minProp = axis === "y" ? (0, $h94gw.top) : (0, $h94gw.left);
    var maxProp = axis === "y" ? (0, $h94gw.bottom) : (0, $h94gw.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $fVS9z.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $3h2oT.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $26b00d1a0b30de04$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $3YhAU.isHTMLElement)(arrowElement)) console.error([
        'Popper: "arrow" element must be an HTMLElement (not an SVGElement).',
        "To use an SVG arrow, wrap it in an HTMLElement that will be used as",
        "the arrow."
    ].join(" "));
    if (!(0, $iG8TS.default)(state.elements.popper, arrowElement)) {
        console.error([
            'Popper: "arrow" modifier\'s `element` must be a child of the popper',
            "element."
        ].join(" "));
        return;
    }
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $26b00d1a0b30de04$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $26b00d1a0b30de04$var$arrow,
    effect: $26b00d1a0b30de04$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("4n602", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32edf6d1b9b76378$export$2e2bcd8739ae039; });

var $h94gw = parcelRequire("h94gw");

var $fp3j1 = parcelRequire("fp3j1");
function $32edf6d1b9b76378$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $32edf6d1b9b76378$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $h94gw.top),
        (0, $h94gw.right),
        (0, $h94gw.bottom),
        (0, $h94gw.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $32edf6d1b9b76378$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $fp3j1.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $fp3j1.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $32edf6d1b9b76378$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $32edf6d1b9b76378$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $32edf6d1b9b76378$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $32edf6d1b9b76378$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $32edf6d1b9b76378$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $32edf6d1b9b76378$var$hide
};

});






parcelRegister("hNqhF", function(module, exports) {

$parcel$export(module.exports, "PAGE_BODY_ID", function () { return $5b91943ffd5d8a79$export$d6ec024df97d592e; });
$parcel$export(module.exports, "default", function () { return $5b91943ffd5d8a79$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "LayoutProps", function () { return $5b91943ffd5d8a79$export$35b29076f8ca0f7c; });
$parcel$export(module.exports, "useFeedbackModal", function () { return $5b91943ffd5d8a79$export$4fa3f5a70f38c462; });

var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");

var $idnjL = parcelRequire("idnjL");
var $6IPSj = parcelRequire("6IPSj");

var $b5GLB = parcelRequire("b5GLB");

var $6fhRl = parcelRequire("6fhRl");

var $6IPSj = parcelRequire("6IPSj");

var $8KsRR = parcelRequire("8KsRR");

var $l7Vlc = parcelRequire("l7Vlc");

var $2bHS7 = parcelRequire("2bHS7");

var $9oXNB = parcelRequire("9oXNB");

var $4bQfl = parcelRequire("4bQfl");

var $jFp0l = parcelRequire("jFp0l");

var $akyNT = parcelRequire("akyNT");

var $iCOkj = parcelRequire("iCOkj");

var $lhcdM = parcelRequire("lhcdM");

var $5l1xF = parcelRequire("5l1xF");

var $6fOze = parcelRequire("6fOze");

var $av1AG = parcelRequire("av1AG");

var $2bHS7 = parcelRequire("2bHS7");

var $39y1u = parcelRequire("39y1u");

const $5b91943ffd5d8a79$var$Banner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).lazy(()=>(parcelRequire("2V0YG")));

const $5b91943ffd5d8a79$var$SiteAlert = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).lazy(()=>(parcelRequire("92mPg")));

const $5b91943ffd5d8a79$var$CookieConsent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).lazy(()=>(parcelRequire("2hNh9")));
const $5b91943ffd5d8a79$var$appTitle = "U.S. Greenhouse Gas Center";
const $5b91943ffd5d8a79$var$appDescription = "Exploring Greenhouse Gas Data; Driving Sustainable Strategies through Powerful Analysis";
const $5b91943ffd5d8a79$var$isUswdsFooterEnabled = (0, $39y1u.checkEnvFlag)("FALSE");
const $5b91943ffd5d8a79$var$isCookieConsentEnabled = (0, $39y1u.checkEnvFlag)("TRUE");
const $5b91943ffd5d8a79$export$d6ec024df97d592e = "pagebody";
const $5b91943ffd5d8a79$var$Page = (0, $6fhRl.default).div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-anchor: none;
`;
const $5b91943ffd5d8a79$var$PageBody = (0, $6fhRl.default).div`
  flex-grow: 1;
  animation: ${(0, $8KsRR.reveal)} 0.48s ease 0s 1;
  display: flex;
  flex-direction: column;
  overflow-anchor: auto;
`;
function $5b91943ffd5d8a79$var$LayoutRoot(props) {
    const cookieConsentContent = (0, $l7Vlc.getCookieConsentFromVedaConfig)();
    const bannerContent = (0, $l7Vlc.getBannerFromVedaConfig)();
    const siteAlertContent = (0, $l7Vlc.getSiteAlertFromVedaConfig)();
    const { children: children } = props;
    const [displayCookieConsentForm, setDisplayCookieConsentForm] = (0, $3RyIS.useState)(true);
    const { pathname: pathname } = (0, $6IPSj.useLocation)();
    (0, $3RyIS.useEffect)(()=>{
        // When there is no cookie consent form set up
        !cookieConsentContent && (0, $lhcdM.setGoogleTagManager)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { title: title, thumbnail: thumbnail, description: description, hideFooter: hideFooter, hideNav: hideNav } = (0, $3RyIS.useContext)((0, $iCOkj.LayoutRootContext));
    const truncatedTitle = title?.length > 32 ? `${title.slice(0, 32)}...` : title;
    const fullTitle = truncatedTitle ? `${truncatedTitle} \u{2014} ` : "";
    return /*#__PURE__*/ (0, $21sFD.jsxs)($5b91943ffd5d8a79$var$Page, {
        children: [
            /*#__PURE__*/ (0, $21sFD.jsx)((0, $9oXNB.default), {
                title: `${fullTitle}${$5b91943ffd5d8a79$var$appTitle}`,
                description: description || $5b91943ffd5d8a79$var$appDescription,
                thumbnail: thumbnail
            }),
            bannerContent && /*#__PURE__*/ (0, $21sFD.jsx)($5b91943ffd5d8a79$var$Banner, {
                ...bannerContent
            }),
            siteAlertContent && /*#__PURE__*/ (0, $21sFD.jsx)($5b91943ffd5d8a79$var$SiteAlert, {
                appTitle: siteAlertContent.title,
                ...siteAlertContent
            }),
            !hideNav && /*#__PURE__*/ (0, $21sFD.jsx)((0, $5l1xF.default), {
                mainNavItems: (0, $av1AG.mainNavItems),
                subNavItems: (0, $av1AG.subNavItems),
                logo: /*#__PURE__*/ (0, $21sFD.jsx)((0, $6fOze.default), {
                    linkProperties: {
                        LinkElement: (0, $idnjL.Link),
                        pathAttributeKeyName: "to"
                    }
                })
            }),
            /*#__PURE__*/ (0, $21sFD.jsxs)($5b91943ffd5d8a79$var$PageBody, {
                id: $5b91943ffd5d8a79$export$d6ec024df97d592e,
                tabIndex: -1,
                children: [
                    /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Outlet), {}),
                    children,
                    $5b91943ffd5d8a79$var$isCookieConsentEnabled && displayCookieConsentForm && /*#__PURE__*/ (0, $21sFD.jsx)($5b91943ffd5d8a79$var$CookieConsent, {
                        ...cookieConsentContent,
                        setDisplayCookieConsentForm: setDisplayCookieConsentForm,
                        setGoogleTagManager: (0, $lhcdM.setGoogleTagManager),
                        pathname: pathname
                    })
                ]
            }),
            $5b91943ffd5d8a79$var$isUswdsFooterEnabled ? /*#__PURE__*/ (0, $21sFD.jsx)((0, $4bQfl.default), {
                mainNavItems: (0, $2bHS7.footerNavItems),
                subNavItems: (0, $2bHS7.footerSubNavItems),
                hideFooter: hideFooter,
                logoSvg: /*#__PURE__*/ (0, $21sFD.jsx)((0, $akyNT.default), {}),
                footerSettings: (0, $2bHS7.footerSettings)
            }) : /*#__PURE__*/ (0, $21sFD.jsx)((0, $jFp0l.default), {
                hideFooter: hideFooter
            })
        ]
    });
}
var $5b91943ffd5d8a79$export$2e2bcd8739ae039 = $5b91943ffd5d8a79$var$LayoutRoot;
function $5b91943ffd5d8a79$export$35b29076f8ca0f7c(props) {
    const { setLayoutProps: setLayoutProps } = (0, $3RyIS.useContext)((0, $iCOkj.LayoutRootContext));
    (0, $b5GLB.useDeepCompareEffect)(()=>{
        setLayoutProps(props);
    }, [
        setLayoutProps,
        props
    ]);
    return null;
}
function $5b91943ffd5d8a79$export$4fa3f5a70f38c462() {
    const { feedbackModalRevealed: feedbackModalRevealed, setFeedbackModalRevealed: setFeedbackModalRevealed } = (0, $3RyIS.useContext)((0, $iCOkj.LayoutRootContext));
    return {
        isRevealed: feedbackModalRevealed,
        show: (0, $3RyIS.useCallback)(()=>setFeedbackModalRevealed(true), [
            setFeedbackModalRevealed
        ]),
        hide: (0, $3RyIS.useCallback)(()=>setFeedbackModalRevealed(false), [
            setFeedbackModalRevealed
        ])
    };
}

});
parcelRegister("b5GLB", function(module, exports) {

$parcel$export(module.exports, "useDeepCompareEffect", function () { return $813155e9bfa468d9$export$db77f469fe79526e; });

var $3RyIS = parcelRequire("3RyIS");

var $6lm7n = parcelRequire("6lm7n");
function $813155e9bfa468d9$var$checkDeps(deps, name) {
    const reactHookName = `React.${name.replace(/DeepCompare/, "")}`;
    if (!deps || deps.length === 0) throw new Error(`${name} should not be used with no dependencies. Use ${reactHookName} instead.`);
}
function $813155e9bfa468d9$var$useDeepCompareMemoize(value) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).useRef([]);
    if (!(0, $6lm7n.default)(value, ref.current)) ref.current = value;
    return ref.current;
}
/**
 * `useDeepCompareEffect` will return a memoized version of the callback that
 * only changes if one of the `deps` has changed.
 *
 * Usage note: only use this if `deps` are objects or arrays that contain
 * objects. Otherwise you should just use React.useEffect.
 *
 */ function $813155e9bfa468d9$export$dde1cbb23f203832(callback, dependencies) {
    $813155e9bfa468d9$var$checkDeps(dependencies, "useDeepCompareCallback");
    return (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).useCallback(callback, $813155e9bfa468d9$var$useDeepCompareMemoize(dependencies));
}
/**
 * `useDeepCompareEffect` Accepts a function that contains imperative, possibly
 * effectful code.
 *
 * @param effect Imperative function that can return a cleanup function
 * @param deps If present, effect will only activate if the values in the list
 * change.
 *
 * Usage note: only use this if `deps` are objects or arrays that contain
 * objects. Otherwise you should just use React.useEffect.
 *
 */ function $813155e9bfa468d9$export$db77f469fe79526e(effect, dependencies) {
    $813155e9bfa468d9$var$checkDeps(dependencies, "useDeepCompareEffect");
    (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).useEffect(effect, $813155e9bfa468d9$var$useDeepCompareMemoize(dependencies));
}
/**
 * `useDeepCompareMemo` will only recompute the memoized value when one of the
 * `deps` has changed.
 *
 * Usage note: only use this if `deps` are objects or arrays that contain
 * objects. Otherwise you should just use React.useMemo.
 *
 */ function $813155e9bfa468d9$export$dbaf05b475729581(factory, dependencies) {
    $813155e9bfa468d9$var$checkDeps(dependencies, "useDeepCompareMemo");
    return (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).useMemo(factory, $813155e9bfa468d9$var$useDeepCompareMemoize(dependencies));
}

});
parcelRegister("6lm7n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de36530c997e95a2$export$2e2bcd8739ae039; });
function $de36530c997e95a2$export$2e2bcd8739ae039(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array && (len = foo.length) === bar.length) {
            while(len-- && $de36530c997e95a2$export$2e2bcd8739ae039(foo[len], bar[len]));
            return len === -1;
        }
        if (ctor === Object) {
            if (Object.keys(foo).length !== Object.keys(bar).length) return false;
            for(len in foo)if (!(len in bar) || !$de36530c997e95a2$export$2e2bcd8739ae039(foo[len], bar[len])) return false;
            return true;
        }
    }
    return foo !== foo && bar !== bar;
}

});


parcelRegister("8KsRR", function(module, exports) {

$parcel$export(module.exports, "shake", function () { return $65e90325489f1b76$export$267b06a7460aa7d3; });
$parcel$export(module.exports, "reveal", function () { return $65e90325489f1b76$export$4a0db9aa4d24dc0c; });

var $6fhRl = parcelRequire("6fhRl");
function $65e90325489f1b76$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var $65e90325489f1b76$var$_templateObject, $65e90325489f1b76$var$_templateObject2, $65e90325489f1b76$var$_templateObject3, $65e90325489f1b76$var$_templateObject4, $65e90325489f1b76$var$_templateObject5;
var $65e90325489f1b76$export$267b06a7460aa7d3 = (0, $6fhRl.keyframes)($65e90325489f1b76$var$_templateObject || ($65e90325489f1b76$var$_templateObject = $65e90325489f1b76$var$_taggedTemplateLiteral([
    "\n  8%, 41% {\n    transform: translateX(-0.5rem);\n  }\n\n  25%, 58% {\n    transform: translateX(0.5rem);\n  }\n\n  75% {\n    transform: translateX(-0.25rem);\n  }\n\n  92% {\n    transform: translateX(0.25rem);\n  }\n\n  0%, 100% {\n    transform: translateX(0);\n  }\n"
])));
var $65e90325489f1b76$export$d6feddd6ae888657 = (0, $6fhRl.keyframes)($65e90325489f1b76$var$_templateObject2 || ($65e90325489f1b76$var$_templateObject2 = $65e90325489f1b76$var$_taggedTemplateLiteral([
    "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
])));
var $65e90325489f1b76$export$c156984459eedb8a = (0, $6fhRl.keyframes)($65e90325489f1b76$var$_templateObject3 || ($65e90325489f1b76$var$_templateObject3 = $65e90325489f1b76$var$_taggedTemplateLiteral([
    "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(-360deg);\n  }\n"
])));
var $65e90325489f1b76$export$4a0db9aa4d24dc0c = (0, $6fhRl.keyframes)($65e90325489f1b76$var$_templateObject4 || ($65e90325489f1b76$var$_templateObject4 = $65e90325489f1b76$var$_taggedTemplateLiteral([
    "\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n"
])));
var $65e90325489f1b76$export$fe8985bb6374093c = (0, $6fhRl.keyframes)($65e90325489f1b76$var$_templateObject5 || ($65e90325489f1b76$var$_templateObject5 = $65e90325489f1b76$var$_taggedTemplateLiteral([
    "\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"
])));

});

parcelRegister("2bHS7", function(module, exports) {

$parcel$export(module.exports, "footerSettings", function () { return $f49cf99ee8c52fb4$export$445646fa93c98398; });
$parcel$export(module.exports, "footerNavItems", function () { return $f49cf99ee8c52fb4$export$6a1da13d1725d148; });
$parcel$export(module.exports, "footerSubNavItems", function () { return $f49cf99ee8c52fb4$export$a8809d68cdad5679; });

var $l7Vlc = parcelRequire("l7Vlc");

var $av1AG = parcelRequire("av1AG");
const $f49cf99ee8c52fb4$var$defaultFooterSettings = {
    secondarySection: {
        division: "NASA EarthData 2024",
        version: "BETA VERSION",
        title: "NASA Official",
        name: "Manil Maskey",
        to: "test@example.com",
        type: "email"
    },
    returnToTop: true
};
const $f49cf99ee8c52fb4$export$6db9516455537ced = [
    {
        ...(0, $av1AG.dataCatalogNavItem),
        customClassNames: "usa-footer__primary-link tablet:padding-0 padding-x-0 padding-y-4"
    },
    {
        ...(0, $av1AG.explorationNavItem),
        customClassNames: "usa-footer__primary-link tablet:padding-0 padding-x-0 padding-y-4"
    },
    {
        ...(0, $av1AG.storiesNavItem),
        customClassNames: "usa-footer__primary-link tablet:padding-0 padding-x-0 padding-y-4"
    }
];
let $f49cf99ee8c52fb4$export$3172295e4309abab = [
    {
        ...(0, $av1AG.aboutNavItem),
        customClassNames: "usa-link text-base-dark text-underline"
    }
];
$f49cf99ee8c52fb4$export$3172295e4309abab = [
    ...$f49cf99ee8c52fb4$export$3172295e4309abab,
    {
        ...(0, $av1AG.contactUsNavItem),
        customClassNames: "usa-link text-base-dark text-underline"
    }
];
const $f49cf99ee8c52fb4$export$445646fa93c98398 = (0, $l7Vlc.getFooterSettingsFromVedaConfig)() ?? $f49cf99ee8c52fb4$var$defaultFooterSettings;
const $f49cf99ee8c52fb4$export$6a1da13d1725d148 = (0, $l7Vlc.getNavItemsFromVedaConfig)()?.footerNavItems ?? $f49cf99ee8c52fb4$export$6db9516455537ced;
const $f49cf99ee8c52fb4$export$a8809d68cdad5679 = (0, $l7Vlc.getNavItemsFromVedaConfig)()?.footerSubNavItems ?? $f49cf99ee8c52fb4$export$3172295e4309abab;

});
parcelRegister("av1AG", function(module, exports) {

$parcel$export(module.exports, "dataCatalogNavItem", function () { return $3e8bed88113ecae4$export$cc5a793eb211db0d; });
$parcel$export(module.exports, "explorationNavItem", function () { return $3e8bed88113ecae4$export$a9237f223fa5a221; });
$parcel$export(module.exports, "storiesNavItem", function () { return $3e8bed88113ecae4$export$99c28e949732d6a3; });
$parcel$export(module.exports, "aboutNavItem", function () { return $3e8bed88113ecae4$export$41caebcd3fea7129; });
$parcel$export(module.exports, "contactUsNavItem", function () { return $3e8bed88113ecae4$export$95c45dbb686a59f8; });
$parcel$export(module.exports, "mainNavItems", function () { return $3e8bed88113ecae4$export$3e78cb61a8b0eacc; });
$parcel$export(module.exports, "subNavItems", function () { return $3e8bed88113ecae4$export$454c9943c839b46e; });

var $l7Vlc = parcelRequire("l7Vlc");

var $aUAzJ = parcelRequire("aUAzJ");

var $bvGDc = parcelRequire("bvGDc");
const $3e8bed88113ecae4$export$cc5a793eb211db0d = {
    id: "data-catalog",
    title: "Data Catalog",
    to: (0, $bvGDc.DATASETS_PATH),
    type: (0, $aUAzJ.NavItemType).INTERNAL_LINK
};
const $3e8bed88113ecae4$export$a9237f223fa5a221 = {
    id: "exploration",
    title: "Exploration",
    to: (0, $bvGDc.EXPLORATION_PATH),
    type: (0, $aUAzJ.NavItemType).INTERNAL_LINK
};
const $3e8bed88113ecae4$export$99c28e949732d6a3 = {
    id: "stories",
    title: (0, $l7Vlc.getString)("stories").other,
    to: (0, $bvGDc.STORIES_PATH),
    type: (0, $aUAzJ.NavItemType).INTERNAL_LINK
};
const $3e8bed88113ecae4$export$41caebcd3fea7129 = {
    id: "about",
    title: "About",
    to: (0, $bvGDc.ABOUT_PATH),
    type: (0, $aUAzJ.NavItemType).INTERNAL_LINK
};
const $3e8bed88113ecae4$export$95c45dbb686a59f8 = {
    id: "contact-us",
    title: "Contact us",
    actionId: "open-google-form",
    type: (0, $aUAzJ.NavItemType).ACTION
};
let $3e8bed88113ecae4$export$6db9516455537ced = [
    $3e8bed88113ecae4$export$cc5a793eb211db0d,
    $3e8bed88113ecae4$export$a9237f223fa5a221,
    $3e8bed88113ecae4$export$99c28e949732d6a3
];
$3e8bed88113ecae4$export$6db9516455537ced = [
    ...$3e8bed88113ecae4$export$6db9516455537ced,
    {
        title: "Hub",
        href: "https://hub.ghg.center/",
        type: (0, $aUAzJ.NavItemType).EXTERNAL_LINK
    }
];
let $3e8bed88113ecae4$export$3172295e4309abab = [
    $3e8bed88113ecae4$export$41caebcd3fea7129
];
$3e8bed88113ecae4$export$3172295e4309abab = [
    ...$3e8bed88113ecae4$export$3172295e4309abab,
    $3e8bed88113ecae4$export$95c45dbb686a59f8
];
const $3e8bed88113ecae4$export$3e78cb61a8b0eacc = (0, $l7Vlc.getNavItemsFromVedaConfig)()?.headerNavItems ?? $3e8bed88113ecae4$export$6db9516455537ced;
const $3e8bed88113ecae4$export$454c9943c839b46e = (0, $l7Vlc.getNavItemsFromVedaConfig)()?.subNavItems ?? $3e8bed88113ecae4$export$3172295e4309abab;

});
parcelRegister("aUAzJ", function(module, exports) {

$parcel$export(module.exports, "NavItemType", function () { return $c79b543900d903d2$export$3efdafa91d88d7f2; });
var $c79b543900d903d2$export$3efdafa91d88d7f2;
(function(NavItemType) {
    NavItemType["INTERNAL_LINK"] = "internalLink";
    NavItemType["EXTERNAL_LINK"] = "externalLink";
    NavItemType["DROPDOWN"] = "dropdown";
    NavItemType["ACTION"] = "action"; // styled as the link but performs some type of action instead of re-routing
})($c79b543900d903d2$export$3efdafa91d88d7f2 || ($c79b543900d903d2$export$3efdafa91d88d7f2 = {}));

});



parcelRegister("9oXNB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d84bdc52acb5b26$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $ifjYT = parcelRequire("ifjYT");

var $5JnQ0 = parcelRequire("5JnQ0");

var $6fhRl = parcelRequire("6fhRl");
parcelRequire("idnjL");
var $6IPSj = parcelRequire("6IPSj");
const $6d84bdc52acb5b26$var$appTitle = "U.S. Greenhouse Gas Center";
const $6d84bdc52acb5b26$var$baseUrl = window.location.origin;
const $6d84bdc52acb5b26$var$defaultMetaImage = `${undefined ?? ""}/meta/meta-image.png`;
function $6d84bdc52acb5b26$var$MetaTags({ title: title, description: description, thumbnail: thumbnail, children: children }) {
    const theme = (0, $6fhRl.useTheme)();
    const location = (0, $6IPSj.useLocation)();
    return /*#__PURE__*/ (0, $21sFD.jsxs)((0, $5JnQ0.Helmet), {
        children: [
            /*#__PURE__*/ (0, $21sFD.jsx)("title", {
                children: title
            }),
            description ? /*#__PURE__*/ (0, $21sFD.jsx)("meta", {
                name: "description",
                content: description
            }) : null,
            /*#__PURE__*/ (0, $21sFD.jsx)("meta", {
                name: "theme-color",
                content: theme?.color.primary
            }),
            /*#__PURE__*/ (0, $21sFD.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0, $21sFD.jsx)("meta", {
                name: "twitter:creator",
                content: "author"
            }),
            /*#__PURE__*/ (0, $21sFD.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            description ? /*#__PURE__*/ (0, $21sFD.jsx)("meta", {
                name: "twitter:description",
                content: description
            }) : null,
            /*#__PURE__*/ (0, $21sFD.jsx)("meta", {
                name: "twitter:image",
                content: thumbnail || $6d84bdc52acb5b26$var$defaultMetaImage
            }),
            /*#__PURE__*/ (0, $21sFD.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0, $21sFD.jsx)("meta", {
                property: "og:url",
                content: `${$6d84bdc52acb5b26$var$baseUrl}${location.pathname}` || $6d84bdc52acb5b26$var$baseUrl
            }),
            /*#__PURE__*/ (0, $21sFD.jsx)("meta", {
                property: "og:site_name",
                content: $6d84bdc52acb5b26$var$appTitle
            }),
            /*#__PURE__*/ (0, $21sFD.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0, $21sFD.jsx)("meta", {
                property: "og:image",
                content: thumbnail || $6d84bdc52acb5b26$var$defaultMetaImage
            }),
            description ? /*#__PURE__*/ (0, $21sFD.jsx)("meta", {
                property: "og:description",
                content: description
            }) : null,
            children,
            /*#__PURE__*/ (0, $21sFD.jsx)("script", {
                async: true,
                type: "text/javascript",
                src: "https://dap.digitalgov.gov/Universal-Federated-Analytics-Min.js?agency=NASA&subagency=HQ",
                id: "_fed_an_ua_tag"
            })
        ]
    });
}
$6d84bdc52acb5b26$var$MetaTags.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).node
};
var $6d84bdc52acb5b26$export$2e2bcd8739ae039 = $6d84bdc52acb5b26$var$MetaTags;

});
parcelRegister("5JnQ0", function(module, exports) {

$parcel$export(module.exports, "Helmet", function () { return $42c3a56ee255d1b3$export$dcef8f9bb9a41431; });

var $ifjYT = parcelRequire("ifjYT");

var $f5nSS = parcelRequire("f5nSS");

var $gBH9h = parcelRequire("gBH9h");

var $3RyIS = parcelRequire("3RyIS");

var $mdSVi = parcelRequire("mdSVi");
var $42c3a56ee255d1b3$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $42c3a56ee255d1b3$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $42c3a56ee255d1b3$var$VALID_TAG_NAMES = Object.keys($42c3a56ee255d1b3$var$TAG_NAMES).map(function(name) {
    return $42c3a56ee255d1b3$var$TAG_NAMES[name];
});
var $42c3a56ee255d1b3$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $42c3a56ee255d1b3$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $42c3a56ee255d1b3$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $42c3a56ee255d1b3$var$HTML_TAG_MAP = Object.keys($42c3a56ee255d1b3$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$42c3a56ee255d1b3$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $42c3a56ee255d1b3$var$SELF_CLOSING_TAGS = [
    $42c3a56ee255d1b3$var$TAG_NAMES.NOSCRIPT,
    $42c3a56ee255d1b3$var$TAG_NAMES.SCRIPT,
    $42c3a56ee255d1b3$var$TAG_NAMES.STYLE
];
var $42c3a56ee255d1b3$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $42c3a56ee255d1b3$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $42c3a56ee255d1b3$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $42c3a56ee255d1b3$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $42c3a56ee255d1b3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $42c3a56ee255d1b3$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $42c3a56ee255d1b3$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $42c3a56ee255d1b3$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $42c3a56ee255d1b3$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $42c3a56ee255d1b3$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $42c3a56ee255d1b3$var$getInnermostProperty(propsList, $42c3a56ee255d1b3$var$TAG_NAMES.TITLE);
    var innermostTemplate = $42c3a56ee255d1b3$var$getInnermostProperty(propsList, $42c3a56ee255d1b3$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $42c3a56ee255d1b3$var$getInnermostProperty(propsList, $42c3a56ee255d1b3$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $42c3a56ee255d1b3$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $42c3a56ee255d1b3$var$getInnermostProperty(propsList, $42c3a56ee255d1b3$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $42c3a56ee255d1b3$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $42c3a56ee255d1b3$var$_extends({}, tagAttrs, current);
    }, {});
};
var $42c3a56ee255d1b3$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$42c3a56ee255d1b3$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$42c3a56ee255d1b3$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $42c3a56ee255d1b3$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $42c3a56ee255d1b3$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $42c3a56ee255d1b3$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $42c3a56ee255d1b3$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $42c3a56ee255d1b3$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $42c3a56ee255d1b3$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $42c3a56ee255d1b3$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $42c3a56ee255d1b3$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($mdSVi)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $42c3a56ee255d1b3$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $42c3a56ee255d1b3$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $42c3a56ee255d1b3$var$getBaseTagFromPropsList([
            $42c3a56ee255d1b3$var$TAG_PROPERTIES.HREF,
            $42c3a56ee255d1b3$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $42c3a56ee255d1b3$var$getAttributesFromPropsList($42c3a56ee255d1b3$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $42c3a56ee255d1b3$var$getInnermostProperty(propsList, $42c3a56ee255d1b3$var$HELMET_PROPS.DEFER),
        encode: $42c3a56ee255d1b3$var$getInnermostProperty(propsList, $42c3a56ee255d1b3$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $42c3a56ee255d1b3$var$getAttributesFromPropsList($42c3a56ee255d1b3$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $42c3a56ee255d1b3$var$getTagsFromPropsList($42c3a56ee255d1b3$var$TAG_NAMES.LINK, [
            $42c3a56ee255d1b3$var$TAG_PROPERTIES.REL,
            $42c3a56ee255d1b3$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $42c3a56ee255d1b3$var$getTagsFromPropsList($42c3a56ee255d1b3$var$TAG_NAMES.META, [
            $42c3a56ee255d1b3$var$TAG_PROPERTIES.NAME,
            $42c3a56ee255d1b3$var$TAG_PROPERTIES.CHARSET,
            $42c3a56ee255d1b3$var$TAG_PROPERTIES.HTTPEQUIV,
            $42c3a56ee255d1b3$var$TAG_PROPERTIES.PROPERTY,
            $42c3a56ee255d1b3$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $42c3a56ee255d1b3$var$getTagsFromPropsList($42c3a56ee255d1b3$var$TAG_NAMES.NOSCRIPT, [
            $42c3a56ee255d1b3$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $42c3a56ee255d1b3$var$getOnChangeClientState(propsList),
        scriptTags: $42c3a56ee255d1b3$var$getTagsFromPropsList($42c3a56ee255d1b3$var$TAG_NAMES.SCRIPT, [
            $42c3a56ee255d1b3$var$TAG_PROPERTIES.SRC,
            $42c3a56ee255d1b3$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $42c3a56ee255d1b3$var$getTagsFromPropsList($42c3a56ee255d1b3$var$TAG_NAMES.STYLE, [
            $42c3a56ee255d1b3$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $42c3a56ee255d1b3$var$getTitleFromPropsList(propsList),
        titleAttributes: $42c3a56ee255d1b3$var$getAttributesFromPropsList($42c3a56ee255d1b3$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $42c3a56ee255d1b3$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $42c3a56ee255d1b3$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $42c3a56ee255d1b3$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $42c3a56ee255d1b3$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $42c3a56ee255d1b3$var$rafPolyfill : $parcel$global.requestAnimationFrame || $42c3a56ee255d1b3$var$rafPolyfill;
var $42c3a56ee255d1b3$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $42c3a56ee255d1b3$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $42c3a56ee255d1b3$var$cafPolyfill;
var $42c3a56ee255d1b3$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $42c3a56ee255d1b3$var$_helmetCallback = null;
var $42c3a56ee255d1b3$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($42c3a56ee255d1b3$var$_helmetCallback) $42c3a56ee255d1b3$var$cancelAnimationFrame($42c3a56ee255d1b3$var$_helmetCallback);
    if (newState.defer) $42c3a56ee255d1b3$var$_helmetCallback = $42c3a56ee255d1b3$var$requestAnimationFrame(function() {
        $42c3a56ee255d1b3$var$commitTagChanges(newState, function() {
            $42c3a56ee255d1b3$var$_helmetCallback = null;
        });
    });
    else {
        $42c3a56ee255d1b3$var$commitTagChanges(newState);
        $42c3a56ee255d1b3$var$_helmetCallback = null;
    }
};
var $42c3a56ee255d1b3$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $42c3a56ee255d1b3$var$updateAttributes($42c3a56ee255d1b3$var$TAG_NAMES.BODY, bodyAttributes);
    $42c3a56ee255d1b3$var$updateAttributes($42c3a56ee255d1b3$var$TAG_NAMES.HTML, htmlAttributes);
    $42c3a56ee255d1b3$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $42c3a56ee255d1b3$var$updateTags($42c3a56ee255d1b3$var$TAG_NAMES.BASE, baseTag),
        linkTags: $42c3a56ee255d1b3$var$updateTags($42c3a56ee255d1b3$var$TAG_NAMES.LINK, linkTags),
        metaTags: $42c3a56ee255d1b3$var$updateTags($42c3a56ee255d1b3$var$TAG_NAMES.META, metaTags),
        noscriptTags: $42c3a56ee255d1b3$var$updateTags($42c3a56ee255d1b3$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $42c3a56ee255d1b3$var$updateTags($42c3a56ee255d1b3$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $42c3a56ee255d1b3$var$updateTags($42c3a56ee255d1b3$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $42c3a56ee255d1b3$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $42c3a56ee255d1b3$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $42c3a56ee255d1b3$var$flattenArray(title);
    $42c3a56ee255d1b3$var$updateAttributes($42c3a56ee255d1b3$var$TAG_NAMES.TITLE, attributes);
};
var $42c3a56ee255d1b3$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($42c3a56ee255d1b3$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($42c3a56ee255d1b3$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($42c3a56ee255d1b3$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($42c3a56ee255d1b3$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $42c3a56ee255d1b3$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($42c3a56ee255d1b3$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $42c3a56ee255d1b3$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $42c3a56ee255d1b3$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $42c3a56ee255d1b3$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($42c3a56ee255d1b3$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $42c3a56ee255d1b3$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $42c3a56ee255d1b3$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $42c3a56ee255d1b3$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $42c3a56ee255d1b3$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $42c3a56ee255d1b3$var$HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $42c3a56ee255d1b3$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $42c3a56ee255d1b3$var$HELMET_ATTRIBUTE + '="true">' + $42c3a56ee255d1b3$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $42c3a56ee255d1b3$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $42c3a56ee255d1b3$var$TAG_PROPERTIES.INNER_HTML || attribute === $42c3a56ee255d1b3$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $42c3a56ee255d1b3$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $42c3a56ee255d1b3$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $42c3a56ee255d1b3$var$HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $42c3a56ee255d1b3$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$42c3a56ee255d1b3$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $42c3a56ee255d1b3$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$42c3a56ee255d1b3$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $42c3a56ee255d1b3$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$42c3a56ee255d1b3$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $42c3a56ee255d1b3$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($42c3a56ee255d1b3$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $42c3a56ee255d1b3$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$42c3a56ee255d1b3$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $42c3a56ee255d1b3$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $42c3a56ee255d1b3$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $42c3a56ee255d1b3$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement(type, mappedTag);
    });
};
var $42c3a56ee255d1b3$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $42c3a56ee255d1b3$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $42c3a56ee255d1b3$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $42c3a56ee255d1b3$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $42c3a56ee255d1b3$var$ATTRIBUTE_NAMES.BODY:
        case $42c3a56ee255d1b3$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $42c3a56ee255d1b3$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $42c3a56ee255d1b3$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $42c3a56ee255d1b3$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $42c3a56ee255d1b3$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $42c3a56ee255d1b3$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $42c3a56ee255d1b3$var$getMethodsForTag($42c3a56ee255d1b3$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $42c3a56ee255d1b3$var$getMethodsForTag($42c3a56ee255d1b3$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $42c3a56ee255d1b3$var$getMethodsForTag($42c3a56ee255d1b3$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $42c3a56ee255d1b3$var$getMethodsForTag($42c3a56ee255d1b3$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $42c3a56ee255d1b3$var$getMethodsForTag($42c3a56ee255d1b3$var$TAG_NAMES.META, metaTags, encode),
        noscript: $42c3a56ee255d1b3$var$getMethodsForTag($42c3a56ee255d1b3$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $42c3a56ee255d1b3$var$getMethodsForTag($42c3a56ee255d1b3$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $42c3a56ee255d1b3$var$getMethodsForTag($42c3a56ee255d1b3$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $42c3a56ee255d1b3$var$getMethodsForTag($42c3a56ee255d1b3$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $42c3a56ee255d1b3$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $42c3a56ee255d1b3$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $42c3a56ee255d1b3$var$classCallCheck(this, HelmetWrapper);
            return $42c3a56ee255d1b3$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($gBH9h)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $42c3a56ee255d1b3$var$TAG_NAMES.SCRIPT:
                case $42c3a56ee255d1b3$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $42c3a56ee255d1b3$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $42c3a56ee255d1b3$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $42c3a56ee255d1b3$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $42c3a56ee255d1b3$var$TAG_NAMES.TITLE:
                    return $42c3a56ee255d1b3$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $42c3a56ee255d1b3$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $42c3a56ee255d1b3$var$TAG_NAMES.BODY:
                    return $42c3a56ee255d1b3$var$_extends({}, newProps, {
                        bodyAttributes: $42c3a56ee255d1b3$var$_extends({}, newChildProps)
                    });
                case $42c3a56ee255d1b3$var$TAG_NAMES.HTML:
                    return $42c3a56ee255d1b3$var$_extends({}, newProps, {
                        htmlAttributes: $42c3a56ee255d1b3$var$_extends({}, newChildProps)
                    });
            }
            return $42c3a56ee255d1b3$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $42c3a56ee255d1b3$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $42c3a56ee255d1b3$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $42c3a56ee255d1b3$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (!$42c3a56ee255d1b3$var$VALID_TAG_NAMES.some(function(name) {
                return child.type === name;
            })) {
                if (typeof child.type === "function") return $42c3a56ee255d1b3$var$warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                return $42c3a56ee255d1b3$var$warn("Only elements types " + $42c3a56ee255d1b3$var$VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
            }
            if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function(nestedChild) {
                return typeof nestedChild !== "string";
            }))) throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $42c3a56ee255d1b3$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $42c3a56ee255d1b3$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $42c3a56ee255d1b3$var$TAG_NAMES.LINK:
                    case $42c3a56ee255d1b3$var$TAG_NAMES.META:
                    case $42c3a56ee255d1b3$var$TAG_NAMES.NOSCRIPT:
                    case $42c3a56ee255d1b3$var$TAG_NAMES.SCRIPT:
                    case $42c3a56ee255d1b3$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $42c3a56ee255d1b3$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $42c3a56ee255d1b3$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement(Component, newProps);
        };
        $42c3a56ee255d1b3$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $42c3a56ee255d1b3$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $42c3a56ee255d1b3$var$NullComponent = function NullComponent() {
    return null;
};
var $42c3a56ee255d1b3$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($f5nSS)))($42c3a56ee255d1b3$var$reducePropsToState, $42c3a56ee255d1b3$var$handleClientStateChange, $42c3a56ee255d1b3$var$mapStateOnServer)($42c3a56ee255d1b3$var$NullComponent);
var $42c3a56ee255d1b3$export$dcef8f9bb9a41431 = $42c3a56ee255d1b3$var$Helmet($42c3a56ee255d1b3$var$HelmetSideEffects);
$42c3a56ee255d1b3$export$dcef8f9bb9a41431.renderStatic = $42c3a56ee255d1b3$export$dcef8f9bb9a41431.rewind;
var $42c3a56ee255d1b3$export$2e2bcd8739ae039 = $42c3a56ee255d1b3$export$dcef8f9bb9a41431;

});
parcelRegister("f5nSS", function(module, exports) {
"use strict";
function $afb9d985eeca136b$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $3RyIS = parcelRequire("3RyIS");
var $afb9d985eeca136b$var$React__default = $afb9d985eeca136b$var$_interopDefault($3RyIS);
function $afb9d985eeca136b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $afb9d985eeca136b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $afb9d985eeca136b$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $afb9d985eeca136b$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $afb9d985eeca136b$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $afb9d985eeca136b$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($3RyIS.PureComponent);
        $afb9d985eeca136b$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $afb9d985eeca136b$var$_defineProperty(SideEffect, "canUseDOM", $afb9d985eeca136b$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $afb9d985eeca136b$var$withSideEffect;

});

parcelRegister("gBH9h", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $c171927ad09663ed$var$hasElementType = typeof Element !== "undefined";
var $c171927ad09663ed$var$hasMap = typeof Map === "function";
var $c171927ad09663ed$var$hasSet = typeof Set === "function";
var $c171927ad09663ed$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $c171927ad09663ed$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$c171927ad09663ed$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($c171927ad09663ed$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$c171927ad09663ed$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($c171927ad09663ed$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($c171927ad09663ed$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($c171927ad09663ed$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$c171927ad09663ed$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $c171927ad09663ed$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("4bQfl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47395840b5e682f1$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");

var $fQhPJ = parcelRequire("fQhPJ");

var $3pC4o = parcelRequire("3pC4o");
parcelRequire("hiK0Y");
var $3Rq2a = parcelRequire("3Rq2a");
function $47395840b5e682f1$export$2e2bcd8739ae039({ mainNavItems: mainNavItems, subNavItems: subNavItems, hideFooter: hideFooter, logoSvg: logoSvg, footerSettings: footerSettings }) {
    const { returnToTop: returnToTop, secondarySection: secondarySection } = footerSettings;
    const primaryItems = (0, $3RyIS.useMemo)(()=>(0, $fQhPJ.createDynamicNavMenuList)({
            navItems: mainNavItems
        }), [
        mainNavItems
    ]);
    const secondaryItems = (0, $3RyIS.useMemo)(()=>(0, $fQhPJ.createDynamicNavMenuList)({
            navItems: subNavItems
        }), [
        subNavItems
    ]);
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $3Rq2a.USWDSFooter), {
        size: "slim",
        returnToTop: returnToTop && /*#__PURE__*/ (0, $21sFD.jsx)((0, $3pC4o.default), {}),
        className: hideFooter && "display-none",
        primary: /*#__PURE__*/ (0, $21sFD.jsxs)("div", {
            className: "grid-row usa-footer__primary-container footer_primary_container ",
            children: [
                /*#__PURE__*/ (0, $21sFD.jsx)("div", {
                    className: "mobile-lg:grid-col-8 mobile-lg:padding-x-0 flex-align-self-center",
                    children: /*#__PURE__*/ (0, $21sFD.jsx)((0, $3Rq2a.USWDSFooterNav), {
                        "aria-label": "Footer navigation",
                        size: "slim",
                        links: primaryItems,
                        className: "padding-x-0 width-auto"
                    })
                }),
                /*#__PURE__*/ (0, $21sFD.jsx)("div", {
                    className: "tablet:grid-col-4 mobile-lg:grid-col-8",
                    children: /*#__PURE__*/ (0, $21sFD.jsx)((0, $3Rq2a.USWDSAddress), {
                        size: "slim",
                        items: secondaryItems
                    })
                })
            ]
        }),
        secondary: /*#__PURE__*/ (0, $21sFD.jsxs)("div", {
            id: "footer_secondary_container",
            className: "grid-row",
            children: [
                /*#__PURE__*/ (0, $21sFD.jsx)("div", {
                    id: "logo-container",
                    className: "margin-bottom-2 tablet:margin-bottom-0",
                    children: /*#__PURE__*/ (0, $21sFD.jsxs)("a", {
                        id: "logo-container-link",
                        href: "#",
                        children: [
                            logoSvg,
                            /*#__PURE__*/ (0, $21sFD.jsxs)("span", {
                                className: "footer-text",
                                children: [
                                    secondarySection.division,
                                    " \u2022 ",
                                    secondarySection.version
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $21sFD.jsxs)("div", {
                    className: " mobile-lg:grid-col-4 footer-text  mobile-lg:grid-gap-6 tablet:flex-justify-end mobile-lg:width-auto width-full flex-align-center",
                    children: [
                        /*#__PURE__*/ (0, $21sFD.jsxs)("span", {
                            children: [
                                secondarySection.title,
                                ": "
                            ]
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsxs)("a", {
                            href: `mailto:${secondarySection.to}`,
                            className: "text-primary-light display-flex flex-align-center",
                            children: [
                                /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Icon).Mail, {
                                    className: "margin-right-1 width-205 height-auto position-relative"
                                }),
                                secondarySection.name
                            ]
                        }, secondarySection.type)
                    ]
                })
            ]
        })
    });
}

});
parcelRegister("2JIVh", function(module, exports) {

$parcel$export(module.exports, "Alert", function () { return $1fe2a1803f0c20d4$export$caec2af78bcc877f; });
$parcel$export(module.exports, "Accordion", function () { return $1fe2a1803f0c20d4$export$a766cd26d0d69044; });
$parcel$export(module.exports, "Button", function () { return $1fe2a1803f0c20d4$export$353f5b6fc5456de1; });
$parcel$export(module.exports, "ButtonGroup", function () { return $1fe2a1803f0c20d4$export$69b1032f2ecdf404; });
$parcel$export(module.exports, "Link", function () { return $1fe2a1803f0c20d4$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "MediaBlockBody", function () { return $1fe2a1803f0c20d4$export$e727c80ad1303051; });
$parcel$export(module.exports, "Tag", function () { return $1fe2a1803f0c20d4$export$3288d34c523a1192; });
$parcel$export(module.exports, "Icon", function () { return $1fe2a1803f0c20d4$export$f04a61298a47a40f; });
$parcel$export(module.exports, "Pagination", function () { return $1fe2a1803f0c20d4$export$68f5e1453c188a82; });
$parcel$export(module.exports, "Banner", function () { return $1fe2a1803f0c20d4$export$3b4e64e77073e307; });
$parcel$export(module.exports, "BannerButton", function () { return $1fe2a1803f0c20d4$export$fa7e947fd004b381; });
$parcel$export(module.exports, "BannerContent", function () { return $1fe2a1803f0c20d4$export$1c91e5dc5ea848c6; });
$parcel$export(module.exports, "BannerFlag", function () { return $1fe2a1803f0c20d4$export$23a1ecb99a79c2b0; });
$parcel$export(module.exports, "BannerGuidance", function () { return $1fe2a1803f0c20d4$export$da58138b7f8a73ff; });
$parcel$export(module.exports, "BannerHeader", function () { return $1fe2a1803f0c20d4$export$72e85ab5dabbfb7c; });
$parcel$export(module.exports, "BannerIcon", function () { return $1fe2a1803f0c20d4$export$9217ca52f16e0cac; });
$parcel$export(module.exports, "GridContainer", function () { return $1fe2a1803f0c20d4$export$cc55614734af2d87; });
$parcel$export(module.exports, "Grid", function () { return $1fe2a1803f0c20d4$export$ef2184bd89960b14; });
$parcel$export(module.exports, "TextInput", function () { return $1fe2a1803f0c20d4$export$c86715117507e8e5; });
$parcel$export(module.exports, "Checkbox", function () { return $1fe2a1803f0c20d4$export$48513f6b9f8ce62d; });
$parcel$export(module.exports, "InputGroup", function () { return $1fe2a1803f0c20d4$export$6e5a9cd40e0c9b97; });
$parcel$export(module.exports, "InputSuffix", function () { return $1fe2a1803f0c20d4$export$73766b5928142d6e; });
$parcel$export(module.exports, "Menu", function () { return $1fe2a1803f0c20d4$export$d9b273488cd8ce6f; });
$parcel$export(module.exports, "Select", function () { return $1fe2a1803f0c20d4$export$ef9b1a59e592288f; });
$parcel$export(module.exports, "TextInputMask", function () { return $1fe2a1803f0c20d4$export$c2fcfdf13c04ed4d; });
$parcel$export(module.exports, "ExtendedNav", function () { return $1fe2a1803f0c20d4$export$a4c45cb7e5079cd; });
$parcel$export(module.exports, "Header", function () { return $1fe2a1803f0c20d4$export$8b251419efc915eb; });
$parcel$export(module.exports, "NavMenuButton", function () { return $1fe2a1803f0c20d4$export$16a8a20e3cbcd702; });
$parcel$export(module.exports, "NavDropDownButton", function () { return $1fe2a1803f0c20d4$export$4fc25bfa0f22e533; });
$parcel$export(module.exports, "Title", function () { return $1fe2a1803f0c20d4$export$f99233281efd08a0; });
$parcel$export(module.exports, "Address", function () { return $1fe2a1803f0c20d4$export$73974d1f547d9d48; });
$parcel$export(module.exports, "Footer", function () { return $1fe2a1803f0c20d4$export$a06f1c675e846f6f; });
$parcel$export(module.exports, "FooterExtendedNavList", function () { return $1fe2a1803f0c20d4$export$b005084e04de8f45; });
$parcel$export(module.exports, "FooterNav", function () { return $1fe2a1803f0c20d4$export$3210cca7a959581e; });
$parcel$export(module.exports, "Logo", function () { return $1fe2a1803f0c20d4$export$e6ff31bff12b7ff4; });
$parcel$export(module.exports, "SocialLink", function () { return $1fe2a1803f0c20d4$export$cc8afd413c65875b; });
$parcel$export(module.exports, "CardGroup", function () { return $1fe2a1803f0c20d4$export$9acc0474485b44b2; });
$parcel$export(module.exports, "Card", function () { return $1fe2a1803f0c20d4$export$60332b2344f7fe41; });
$parcel$export(module.exports, "CardHeader", function () { return $1fe2a1803f0c20d4$export$5665775b26e26c5d; });
$parcel$export(module.exports, "CardMedia", function () { return $1fe2a1803f0c20d4$export$4aa095286866240f; });
$parcel$export(module.exports, "CardBody", function () { return $1fe2a1803f0c20d4$export$851de33184ecdac4; });
$parcel$export(module.exports, "CardFooter", function () { return $1fe2a1803f0c20d4$export$e9897d434e0741ee; });
$parcel$export(module.exports, "Search", function () { return $1fe2a1803f0c20d4$export$4b85d3515bd863a5; });
$parcel$export(module.exports, "SiteAlert", function () { return $1fe2a1803f0c20d4$export$8a6ca22c8941eb13; });

var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");

var $dzGKu = parcelRequire("dzGKu");

var $3qHRY = parcelRequire("3qHRY");
"use client";
function $1fe2a1803f0c20d4$var$Ft(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $1fe2a1803f0c20d4$var$bt = {
    exports: {}
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ (function(e) {
    (function() {
        var s = {}.hasOwnProperty;
        function a() {
            for(var r = "", o = 0; o < arguments.length; o++){
                var v = arguments[o];
                v && (r = i(r, n(v)));
            }
            return r;
        }
        function n(r) {
            if (typeof r == "string" || typeof r == "number") return r;
            if (typeof r != "object") return "";
            if (Array.isArray(r)) return a.apply(null, r);
            if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]")) return r.toString();
            var o = "";
            for(var v in r)s.call(r, v) && r[v] && (o = i(o, v));
            return o;
        }
        function i(r, o) {
            return o ? r ? r + " " + o : r + o : r;
        }
        e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
    })();
})($1fe2a1803f0c20d4$var$bt);
var $1fe2a1803f0c20d4$var$Pt = $1fe2a1803f0c20d4$var$bt.exports;
const $1fe2a1803f0c20d4$var$g = /* @__PURE__ */ $1fe2a1803f0c20d4$var$Ft($1fe2a1803f0c20d4$var$Pt), $1fe2a1803f0c20d4$var$Rt = "_alertWithCTA_16hlx_1", $1fe2a1803f0c20d4$var$Ut = {
    alertWithCTA: $1fe2a1803f0c20d4$var$Rt
}, $1fe2a1803f0c20d4$export$caec2af78bcc877f = ({ type: e, heading: s, headingLevel: a, cta: n, children: i, slim: r, noIcon: o, className: v, validation: d, ...u })=>{
    const w = $1fe2a1803f0c20d4$var$g("usa-alert", {
        "usa-alert--success": e === "success",
        "usa-alert--warning": e === "warning",
        "usa-alert--error": e === "error",
        "usa-alert--info": e === "info",
        "usa-alert--slim": r,
        "usa-alert--no-icon": o,
        "usa-alert--validation": d,
        [$1fe2a1803f0c20d4$var$Ut.alertWithCTA]: !!n
    }, v);
    return /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
        className: w,
        "data-testid": "alert",
        ...u,
        children: [
            /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
                className: "usa-alert__body",
                children: [
                    s && /* @__PURE__ */ (0, $21sFD.jsx)(a, {
                        className: "usa-alert__heading",
                        children: s
                    }),
                    i && (d ? i : /* @__PURE__ */ (0, $21sFD.jsx)("p", {
                        className: "usa-alert__text",
                        children: i
                    }))
                ]
            }),
            n && /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                children: n
            })
        ]
    });
}, $1fe2a1803f0c20d4$var$Yt = ({ title: e, id: s, content: a, expanded: n, className: i, headingLevel: r, handleToggle: o })=>{
    const v = $1fe2a1803f0c20d4$var$g("usa-accordion__heading", i), d = $1fe2a1803f0c20d4$var$g("usa-accordion__content", "usa-prose", i);
    return /* @__PURE__ */ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)(r, {
                className: v,
                children: /* @__PURE__ */ (0, $21sFD.jsx)("button", {
                    type: "button",
                    className: "usa-accordion__button",
                    "aria-expanded": n,
                    "aria-controls": s,
                    "data-testid": `accordionButton_${s}`,
                    onClick: o,
                    children: e
                })
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                id: s,
                "data-testid": `accordionItem_${s}`,
                className: d,
                hidden: !n,
                children: a
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$a766cd26d0d69044 = ({ bordered: e, items: s, className: a, multiselectable: n = !1 })=>{
    const [i, r] = (0, $3RyIS.useState)(s.filter((d)=>!!d.expanded).map((d)=>d.id)), o = $1fe2a1803f0c20d4$var$g("usa-accordion", {
        "usa-accordion--bordered": e
    }, a), v = (d)=>{
        const u = [
            ...i
        ], w = i.indexOf(d), f = n;
        w > -1 ? u.splice(w, 1) : (f || u.splice(0, u.length), u.push(d)), r(u);
    };
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: o,
        "data-testid": "accordion",
        "data-allow-multiple": n || void 0,
        children: s.map((d, u)=>/* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$Yt, {
                ...d,
                expanded: i.indexOf(d.id) > -1,
                handleToggle: (w)=>{
                    d.handleToggle && d.handleToggle(w), v(d.id);
                }
            }, `accordionItem_${u}`))
    });
}, $1fe2a1803f0c20d4$export$353f5b6fc5456de1 = ({ type: e, children: s, secondary: a, base: n, accentStyle: i, outline: r, inverse: o, size: v, unstyled: d, onClick: u, className: w, ...f })=>{
    const _ = $1fe2a1803f0c20d4$var$g("usa-button", {
        "usa-button--secondary": a,
        "usa-button--base": n,
        "usa-button--accent-cool": i === "cool",
        "usa-button--accent-warm": i === "warm",
        "usa-button--outline": r,
        "usa-button--inverse": o,
        "usa-button--big": v === "big",
        "usa-button--unstyled": d
    }, w);
    return /* @__PURE__ */ (0, $21sFD.jsx)("button", {
        type: e,
        className: _,
        onClick: u,
        "data-testid": "button",
        ...f,
        children: s
    });
}, $1fe2a1803f0c20d4$export$69b1032f2ecdf404 = ({ className: e, children: s, type: a = "default", ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-button-group", {
        "usa-button-group--segmented": a == "segmented"
    }, e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("ul", {
        className: i,
        ...n,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).Children.map(s, (r)=>/* @__PURE__ */ (0, $21sFD.jsx)("li", {
                className: "usa-button-group__item",
                children: r
            }))
    });
};
function $1fe2a1803f0c20d4$var$Ye(e) {
    return "asCustom" in e;
}
const $1fe2a1803f0c20d4$var$Wt = (e)=>{
    e.key === " " && e.target && (e.preventDefault(), e.target.click());
};
function $1fe2a1803f0c20d4$var$ot(e, s) {
    return e === "unstyled" ? s : $1fe2a1803f0c20d4$var$g("usa-link", {
        "usa-link--external": e === "external",
        "usa-nav__link": e === "nav"
    }, s);
}
function $1fe2a1803f0c20d4$export$a6c7ac8248d6e38a(e) {
    if ($1fe2a1803f0c20d4$var$Ye(e)) {
        const { variant: s, className: a, asCustom: n, children: i, ...r } = e, o = r, v = $1fe2a1803f0c20d4$var$ot(s, a);
        return (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement(n, {
            className: v,
            ...o
        }, i);
    } else {
        const { children: s, className: a, variant: n, allowSpacebarActivation: i = !1, ...r } = e, o = $1fe2a1803f0c20d4$var$ot(n, a);
        return /* @__PURE__ */ (0, $21sFD.jsx)("a", {
            className: o,
            ...i && {
                onKeyDown: $1fe2a1803f0c20d4$var$Wt
            },
            ...r,
            children: s
        });
    }
}
const $1fe2a1803f0c20d4$var$Ie = {
    "smooth-scroll": "_smooth-scroll_zpzmq_2"
}, $1fe2a1803f0c20d4$export$81bfd91751d81555 = ({ className: e, content: s, headingLevel: a = "h4", mainProps: n, navProps: i, rootMargin: r = "0px 0px 0px 0px", scrollOffset: o, threshold: v = 1, title: d = "On this page", ...u })=>{
    const w = $1fe2a1803f0c20d4$var$g("usa-in-page-nav", $1fe2a1803f0c20d4$var$Ie.target, e), { className: f, ..._ } = i || {}, k = $1fe2a1803f0c20d4$var$g("usa-in-page-nav__nav", f), { className: b, ...M } = n || {}, B = $1fe2a1803f0c20d4$var$g("main-content", b), x = a, $ = {
        "--margin-offset": o
    }, [p, N] = (0, $3RyIS.useState)(""), A = s.props.children.filter((L)=>L.type === "h2" || L.type === "h3"), V = (L)=>{
        L.forEach((y)=>{
            y.isIntersecting && N(y.target.id);
        });
    }, E = {
        root: null,
        rootMargin: r,
        threshold: [
            v
        ]
    }, S = new IntersectionObserver(V, E);
    return (0, $3RyIS.useEffect)(()=>{
        var L;
        return document.querySelectorAll("h2,h3").forEach((y)=>S.observe(y)), (L = document.querySelector("html")) == null || L.classList.add($1fe2a1803f0c20d4$var$Ie["smooth-scroll"]), ()=>{
            var y;
            (y = document.querySelector("html")) == null || y.classList.remove($1fe2a1803f0c20d4$var$Ie["smooth-scroll"]);
        };
    }), /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
        className: "usa-in-page-nav-container",
        ...u,
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)("aside", {
                className: w,
                "aria-label": d,
                "data-testid": "InPageNavigation",
                children: /* @__PURE__ */ (0, $21sFD.jsxs)("nav", {
                    className: k,
                    ..._,
                    children: [
                        /* @__PURE__ */ (0, $21sFD.jsx)(x, {
                            className: "usa-in-page-nav__heading",
                            tabIndex: 0,
                            children: d
                        }),
                        /* @__PURE__ */ (0, $21sFD.jsx)("ul", {
                            className: "usa-in-page-nav__list",
                            children: A.map((L)=>{
                                const y = L.props.children, O = L.props.id, D = $1fe2a1803f0c20d4$var$g("usa-in-page-nav__item", {
                                    "usa-in-page-nav__item--sub-item": L.type === "h3"
                                }), H = $1fe2a1803f0c20d4$var$g("usa-in-page-nav__link", {
                                    "usa-current": O === p
                                });
                                return /* @__PURE__ */ (0, $21sFD.jsx)("li", {
                                    className: D,
                                    children: /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$a6c7ac8248d6e38a, {
                                        href: `#${O}`,
                                        className: H,
                                        children: y
                                    })
                                }, `usa-in-page-nav__item_${y}`);
                            })
                        })
                    ]
                })
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)("main", {
                id: "main-content",
                className: B,
                ...M,
                style: o ? $ : void 0,
                children: s
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$e727c80ad1303051 = ({ children: e, className: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-media-block__body", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: n,
        ...a,
        children: e
    });
}, $1fe2a1803f0c20d4$var$Kt = "_fixed_1khz6_1", $1fe2a1803f0c20d4$var$It = {
    fixed: $1fe2a1803f0c20d4$var$Kt
}, $1fe2a1803f0c20d4$export$54ec01a60f47d33d = ({ bordered: e, caption: s, children: a, className: n, fullWidth: i, fixed: r, scrollable: o, striped: v, compact: d, stackedStyle: u = "none" })=>{
    const w = $1fe2a1803f0c20d4$var$g("usa-table", {
        "usa-table--borderless": !e,
        "width-full": i,
        [`${$1fe2a1803f0c20d4$var$It.fixed}`]: r,
        "usa-table--striped": v,
        "usa-table--compact": d,
        "usa-table--stacked": u === "default",
        "usa-table--stacked-header": u === "headers"
    }, n);
    d && u !== "none" && console.warn("USWDS states that compact styling is not suitable for use with stacked variants. See USWDS Table component, Table variants for more information: https://designsystem.digital.gov/components/table");
    const f = /* @__PURE__ */ (0, $21sFD.jsxs)("table", {
        className: w,
        "data-testid": "table",
        children: [
            s && /* @__PURE__ */ (0, $21sFD.jsx)("caption", {
                children: s
            }),
            a
        ]
    });
    return /* @__PURE__ */ (0, $21sFD.jsx)((0, $21sFD.Fragment), {
        children: o ? /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            "data-testid": "scrollable-table-container",
            className: "usa-table-container--scrollable",
            tabIndex: 0,
            children: f
        }) : f
    });
}, $1fe2a1803f0c20d4$export$3288d34c523a1192 = ({ children: e, background: s, className: a, ...n })=>{
    const i = {};
    s && (i.background = s);
    const r = $1fe2a1803f0c20d4$var$g("usa-tag", a);
    return /* @__PURE__ */ (0, $21sFD.jsx)("span", {
        "data-testid": "tag",
        className: r,
        style: {
            ...i
        },
        ...n,
        children: e
    });
}, $1fe2a1803f0c20d4$var$Zt = (e, s = window, a = document.documentElement)=>{
    const n = e.getBoundingClientRect();
    return n.top >= 0 && n.left >= 0 && n.bottom <= (s.innerHeight || a.clientHeight) && n.right <= (s.innerWidth || a.clientWidth);
}, $1fe2a1803f0c20d4$var$lt = (e, s)=>parseInt(window.getComputedStyle(e).getPropertyValue(s), 10), $1fe2a1803f0c20d4$var$Ne = (e, s, a)=>$1fe2a1803f0c20d4$var$lt(a, `margin-${e}`) > 0 ? s - $1fe2a1803f0c20d4$var$lt(a, `margin-${e}`) : s;
function $1fe2a1803f0c20d4$var$Gt(e) {
    return "asCustom" in e;
}
const $1fe2a1803f0c20d4$var$Te = 5, $1fe2a1803f0c20d4$var$jt = "top";
function $1fe2a1803f0c20d4$export$28c660c63b792dea({ position: e = $1fe2a1803f0c20d4$var$jt, wrapperclasses: s, className: a, ...n }) {
    const i = (0, $3RyIS.useRef)(null), r = (0, $3RyIS.useRef)(null), o = (0, $3RyIS.useRef)(`tooltip-${Math.floor(Math.random() * 9e5) + 1e5}`), [v, d] = (0, $3RyIS.useState)(!1), [u, w] = (0, $3RyIS.useState)(!1), [f, _] = (0, $3RyIS.useState)(void 0), [k, b] = (0, $3RyIS.useState)(0), [M, B] = (0, $3RyIS.useState)(!1), [x, $] = (0, $3RyIS.useState)({}), p = (H, P)=>{
        const j = $1fe2a1803f0c20d4$var$Ne("top", H.offsetHeight, P), G = $1fe2a1803f0c20d4$var$Ne("left", H.offsetWidth, P);
        _("top"), $({
            left: "50%",
            top: `-${$1fe2a1803f0c20d4$var$Te}px`,
            margin: `-${j}px 0 0 -${G / 2}px`
        });
    }, N = (H, P)=>{
        const j = $1fe2a1803f0c20d4$var$Ne("left", H.offsetWidth, P);
        _("bottom"), $({
            left: "50%",
            margin: `${$1fe2a1803f0c20d4$var$Te}px 0 0 -${j / 2}px`
        });
    }, A = (H, P)=>{
        const j = $1fe2a1803f0c20d4$var$Ne("top", H.offsetHeight, P);
        _("right"), $({
            top: "50%",
            left: `${P.offsetLeft + P.offsetWidth + $1fe2a1803f0c20d4$var$Te}px`,
            margin: `-${j / 2}px 0 0 0`
        });
    }, V = (H, P)=>{
        const j = $1fe2a1803f0c20d4$var$Ne("top", H.offsetHeight, P), G = $1fe2a1803f0c20d4$var$Ne("left", P.offsetLeft > H.offsetWidth ? P.offsetLeft - H.offsetWidth : H.offsetWidth, P);
        _("left"), $({
            top: "50%",
            left: `-${$1fe2a1803f0c20d4$var$Te}px`,
            margin: `-${j / 2}px 0 0 ${P.offsetLeft > H.offsetWidth ? G : -G}px`
        });
    }, E = [
        p,
        N,
        A,
        V
    ], S = E.length;
    (0, $3RyIS.useEffect)(()=>{
        if (v && i.current && r.current) {
            const H = i.current, P = r.current;
            if ($1fe2a1803f0c20d4$var$Zt(P)) w(!0);
            else {
                const G = k;
                if (G < S || M === !1) {
                    if (b((ee)=>ee + 1), G < S) {
                        const ee = E[parseInt(`${G}`)];
                        ee(P, H);
                    } else B(!0), b(0);
                } else console.warn("No visible position found - this may mean your tooltip contents is too long!");
            }
        }
    }, [
        f,
        x,
        M
    ]), (0, $3RyIS.useEffect)(()=>{
        if (!v) w(!1), B(!1), b(0);
        else if (i.current && r.current) {
            const H = i.current, P = r.current;
            switch(e){
                case "top":
                    p(P, H);
                    break;
                case "bottom":
                    N(P, H);
                    break;
                case "right":
                    A(P, H);
                    break;
                case "left":
                    V(P, H);
                    break;
            }
        }
    }, [
        v
    ]);
    const L = ()=>{
        d(!0);
    }, y = ()=>{
        d(!1);
    }, O = $1fe2a1803f0c20d4$var$g("usa-tooltip", s), D = $1fe2a1803f0c20d4$var$g("usa-tooltip__body", {
        "is-set": v,
        "usa-tooltip__body--top": f === "top",
        "usa-tooltip__body--bottom": f === "bottom",
        "usa-tooltip__body--right": f === "right",
        "usa-tooltip__body--left": f === "left",
        "is-visible": u,
        // isShown is set after positioning updated, to prevent jitter when position changes
        "usa-tooltip__body--wrap": v && M
    });
    if ($1fe2a1803f0c20d4$var$Gt(n)) {
        const { label: H, title: P, asCustom: j, children: G, ...ee } = n, ie = ee, U = $1fe2a1803f0c20d4$var$g("usa-tooltip__trigger", a), X = (0, $3RyIS.createElement)(j, {
            ...ie,
            ref: i,
            "data-testid": "triggerElement",
            "aria-describedby": o.current,
            tabIndex: 0,
            title: "",
            onMouseEnter: L,
            onMouseOver: L,
            onFocus: L,
            onMouseLeave: y,
            onBlur: y,
            onKeyDown: y,
            className: U
        }, G);
        return /* @__PURE__ */ (0, $21sFD.jsxs)("span", {
            "data-testid": "tooltipWrapper",
            className: O,
            children: [
                X,
                /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                    "data-testid": "tooltipBody",
                    title: P ?? (typeof H == "string" ? H : void 0),
                    id: o.current,
                    ref: r,
                    className: D,
                    role: "tooltip",
                    "aria-hidden": !v,
                    style: x,
                    children: H
                })
            ]
        });
    } else {
        const { label: H, title: P, children: j, ...G } = n, ee = $1fe2a1803f0c20d4$var$g("usa-button", "usa-tooltip__trigger", a);
        return /* @__PURE__ */ (0, $21sFD.jsxs)("span", {
            "data-testid": "tooltipWrapper",
            className: O,
            children: [
                /* @__PURE__ */ (0, $21sFD.jsx)("button", {
                    ...G,
                    "data-testid": "triggerElement",
                    ref: i,
                    "aria-describedby": o.current,
                    tabIndex: 0,
                    type: "button",
                    className: ee,
                    title: "",
                    onMouseEnter: L,
                    onMouseOver: L,
                    onFocus: L,
                    onMouseLeave: y,
                    onBlur: y,
                    onKeyDown: y,
                    children: j
                }),
                /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                    "data-testid": "tooltipBody",
                    title: P ?? (typeof H == "string" ? H : void 0),
                    id: o.current,
                    ref: r,
                    className: D,
                    role: "tooltip",
                    "aria-hidden": !v,
                    style: x,
                    children: H
                })
            ]
        });
    }
}
const $1fe2a1803f0c20d4$export$1a35787d6353cf6a = ({ items: e, isSubnav: s = !1 })=>{
    const a = $1fe2a1803f0c20d4$var$g({
        "usa-sidenav": !s,
        "usa-sidenav__sublist": s
    });
    return /* @__PURE__ */ (0, $21sFD.jsx)("ul", {
        className: a,
        "data-testid": "sidenav",
        children: e.map((n, i)=>/* @__PURE__ */ (0, $21sFD.jsx)("li", {
                className: "usa-sidenav__item",
                children: n
            }, `sidenav_item_${i}`))
    });
}, $1fe2a1803f0c20d4$var$qt = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
    })), $1fe2a1803f0c20d4$var$Qt = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$qt), $1fe2a1803f0c20d4$var$Jt = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 17,
        cy: 4.54,
        r: 2
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M14 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm3-3.5h-1.86l1.67-3.67C17.42 8.5 16.44 7 14.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L7.22 10l1.92.53L9.79 9H12l-1.83 4.1c-.6 1.33.39 2.9 1.85 2.9H17v5h2v-5.5c0-1.1-.9-2-2-2z"
    })), $1fe2a1803f0c20d4$var$Xt = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Jt), $1fe2a1803f0c20d4$var$e1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M4 10h3v7H4zm6.5 0h3v7h-3zM2 19h20v3H2zm15-9h3v7h-3zm-5-9L2 6v2h20V6z"
    })), $1fe2a1803f0c20d4$var$t1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$e1), $1fe2a1803f0c20d4$var$s1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z"
    })), $1fe2a1803f0c20d4$var$a1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$s1), $1fe2a1803f0c20d4$var$n1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0 1 12.28 0C16.43 19.18 14.03 20 12 20z"
    })), $1fe2a1803f0c20d4$var$c1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$n1), $1fe2a1803f0c20d4$var$i1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
    })), $1fe2a1803f0c20d4$var$o1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$i1), $1fe2a1803f0c20d4$var$r1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
    })), $1fe2a1803f0c20d4$var$l1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$r1), $1fe2a1803f0c20d4$var$h1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    })), $1fe2a1803f0c20d4$var$m1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$h1), $1fe2a1803f0c20d4$var$d1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m22 5.72-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39 6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 0 0 0-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
    })), $1fe2a1803f0c20d4$var$v1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$d1), $1fe2a1803f0c20d4$var$g1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57V12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57V12c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
    })), $1fe2a1803f0c20d4$var$u1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$g1), $1fe2a1803f0c20d4$var$w1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z"
    })), $1fe2a1803f0c20d4$var$p1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$w1), $1fe2a1803f0c20d4$var$f1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
    })), $1fe2a1803f0c20d4$var$M1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$f1), $1fe2a1803f0c20d4$var$x1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
    })), $1fe2a1803f0c20d4$var$E1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$x1), $1fe2a1803f0c20d4$var$b1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m7 10 5 5 5-5z"
    })), $1fe2a1803f0c20d4$var$z1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$b1), $1fe2a1803f0c20d4$var$S1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m7 14 5-5 5 5z"
    })), $1fe2a1803f0c20d4$var$_1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$S1), $1fe2a1803f0c20d4$var$C1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
    })), $1fe2a1803f0c20d4$var$N1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$C1), $1fe2a1803f0c20d4$var$y1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
    })), $1fe2a1803f0c20d4$var$L1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$y1), $1fe2a1803f0c20d4$var$k1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m14 12-2 2-2-2 2-2 2 2zm-2-6 2.12 2.12 2.5-2.5L12 1 7.38 5.62l2.5 2.5L12 6zm-6 6 2.12-2.12-2.5-2.5L1 12l4.62 4.62 2.5-2.5L6 12zm12 0-2.12 2.12 2.5 2.5L23 12l-4.62-4.62-2.5 2.5L18 12zm-6 6-2.12-2.12-2.5 2.5L12 23l4.62-4.62-2.5-2.5L12 18z"
    })), $1fe2a1803f0c20d4$var$$1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$k1), $1fe2a1803f0c20d4$var$H1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
    })), $1fe2a1803f0c20d4$var$V1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$H1), $1fe2a1803f0c20d4$var$B1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 5 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
    })), $1fe2a1803f0c20d4$var$O1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$B1), $1fe2a1803f0c20d4$var$A1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
    })), $1fe2a1803f0c20d4$var$D1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$A1), $1fe2a1803f0c20d4$var$T1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.87 5.87 0 0 1 6 12c0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
    })), $1fe2a1803f0c20d4$var$F1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$T1), $1fe2a1803f0c20d4$var$P1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 8v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V8c0-1.86 1.28-3.41 3-3.86V2h3v2h4V2h3v2.14c1.72.45 3 2 3 3.86zM6 12v2h10v2h2v-4H6z"
    })), $1fe2a1803f0c20d4$var$R1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$P1), $1fe2a1803f0c20d4$var$U1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 7,
        cy: 7,
        r: 2
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 13V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08-.4 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08 0-.18-.03-.34-.07-.51l1.25-1.25a.828.828 0 0 1 1.41.59V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5A2.251 2.251 0 0 0 5 12.25V13H2v6c0 1.1.9 2 2 2 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 1.1 0 2-.9 2-2v-6h-2z"
    })), $1fe2a1803f0c20d4$var$Y1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$U1), $1fe2a1803f0c20d4$var$W1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M17 10.13a33.86 33.86 0 0 1-10 0 1.92 1.92 0 0 1-1.51-1.46 10.42 10.42 0 0 1 0-4.84 1.92 1.92 0 0 1 1.57-1.46 33.86 33.86 0 0 1 10 0 1.9 1.9 0 0 1 1.56 1.46 10.16 10.16 0 0 1 0 4.84A1.9 1.9 0 0 1 17 10.13Zm4 12.12H7a5.25 5.25 0 0 1 0-10.5h10a3.25 3.25 0 0 1 0 6.5H7a1.25 1.25 0 0 1 0-2.5h10a.75.75 0 0 0 0-1.5H7a2.75 2.75 0 0 0 0 5.5h14a1.25 1.25 0 0 1 0 2.5Z"
    })), $1fe2a1803f0c20d4$var$K1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$W1), $1fe2a1803f0c20d4$var$I1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
    })), $1fe2a1803f0c20d4$var$Z1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$I1), $1fe2a1803f0c20d4$var$G1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 8h-2.81a5.985 5.985 0 0 0-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"
    })), $1fe2a1803f0c20d4$var$j1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$G1), $1fe2a1803f0c20d4$var$q1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m22.7 19-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
    })), $1fe2a1803f0c20d4$var$Q1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$q1), $1fe2a1803f0c20d4$var$J1 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
    })), $1fe2a1803f0c20d4$var$X1 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$J1), $1fe2a1803f0c20d4$var$es = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M18 11v2h4v-2h-4zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm11.5 3c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z"
    })), $1fe2a1803f0c20d4$var$ts = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$es), $1fe2a1803f0c20d4$var$ss = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        fillRule: "evenodd",
        d: "m12 5 8 13h2v2H2v-2h2l8-13zm.05 8-2.69 5h5.38l-2.69-5zM5.5 3l-.018.024A2.5 2.5 0 0 0 7.498 7 2.5 2.5 0 1 1 5.5 3z"
    })), $1fe2a1803f0c20d4$var$as = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ss), $1fe2a1803f0c20d4$var$ns = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
    })), $1fe2a1803f0c20d4$var$cs = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ns), $1fe2a1803f0c20d4$var$is = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
    })), $1fe2a1803f0c20d4$var$os = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$is), $1fe2a1803f0c20d4$var$rs = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    })), $1fe2a1803f0c20d4$var$ls = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$rs), $1fe2a1803f0c20d4$var$hs = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    })), $1fe2a1803f0c20d4$var$ms = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$hs), $1fe2a1803f0c20d4$var$ds = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    })), $1fe2a1803f0c20d4$var$vs = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ds), $1fe2a1803f0c20d4$var$gs = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    })), $1fe2a1803f0c20d4$var$us = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$gs), $1fe2a1803f0c20d4$var$ws = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M21.6 18.2 13 11.75v-.91a3.496 3.496 0 0 0-.18-6.75A3.51 3.51 0 0 0 8.5 7.5h2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5c0 .84-.69 1.52-1.53 1.5-.54-.01-.97.45-.97.99v1.76L2.4 18.2c-.77.58-.36 1.8.6 1.8h18c.96 0 1.37-1.22.6-1.8zM6 18l6-4.5 6 4.5H6z"
    })), $1fe2a1803f0c20d4$var$ps = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ws), $1fe2a1803f0c20d4$var$fs = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m16.99 5 .63 1.37 1.37.63-1.37.63L16.99 9l-.63-1.37L14.99 7l1.37-.63.63-1.37M11 6.13V4h2c.57 0 1.1.17 1.55.45l1.43-1.43A4.899 4.899 0 0 0 13 2H7.5v2H9v2.14A5.007 5.007 0 0 0 5.26 9.5h3.98L15 11.65v-.62a5 5 0 0 0-4-4.9zM1 22h4V11H1v11zm19-5h-7l-2.09-.73.33-.94L13 16h2.82c.65 0 1.18-.53 1.18-1.18 0-.49-.31-.93-.77-1.11L8.97 11H7v9.02L14 22l8-3c-.01-1.1-.89-2-2-2zm0-3c1.1 0 2-.9 2-2s-2-4-2-4-2 2.9-2 4 .9 2 2 2z"
    })), $1fe2a1803f0c20d4$var$Ms = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$fs), $1fe2a1803f0c20d4$var$xs = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M15.7 2.37 15 2.3V4a3 3 0 0 1-6 0V2.3l-.7.07a7 7 0 0 0-6.3 7V20h3V10h1.5v12h11V10H19v10h3V9.33a7 7 0 0 0-6.3-6.96Z"
    })), $1fe2a1803f0c20d4$var$Es = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$xs), $1fe2a1803f0c20d4$var$bs = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    })), $1fe2a1803f0c20d4$var$zs = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$bs), $1fe2a1803f0c20d4$var$Ss = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z"
    })), $1fe2a1803f0c20d4$var$_s = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ss), $1fe2a1803f0c20d4$var$Cs = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
    })), $1fe2a1803f0c20d4$var$Ns = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Cs), $1fe2a1803f0c20d4$var$ys = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M9.4 16.6 4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0 4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
    })), $1fe2a1803f0c20d4$var$Ls = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ys), $1fe2a1803f0c20d4$var$ks = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
    })), $1fe2a1803f0c20d4$var$$s = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ks), $1fe2a1803f0c20d4$var$Hs = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11 14H9a9 9 0 0 1 9-9v2c-3.87 0-7 3.13-7 7zm7-3V9c-2.76 0-5 2.24-5 5h2c0-1.66 1.34-3 3-3zM7 4c0-1.11-.89-2-2-2s-2 .89-2 2 .89 2 2 2 2-.89 2-2zm4.45.5h-2A2.99 2.99 0 0 1 6.5 7h-3C2.67 7 2 7.67 2 8.5V11h6V8.74a4.97 4.97 0 0 0 3.45-4.24zM19 17c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm1.5 1h-3a2.99 2.99 0 0 1-2.95-2.5h-2A4.97 4.97 0 0 0 16 19.74V22h6v-2.5c0-.83-.67-1.5-1.5-1.5z"
    })), $1fe2a1803f0c20d4$var$Vs = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Hs), $1fe2a1803f0c20d4$var$Bs = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m13.783 15.172 2.121-2.121 5.996 5.996-2.121 2.121zM17.5 10c1.93 0 3.5-1.57 3.5-3.5 0-.58-.16-1.12-.41-1.6l-2.7 2.7-1.49-1.49 2.7-2.7c-.48-.25-1.02-.41-1.6-.41C15.57 3 14 4.57 14 6.5c0 .41.08.8.21 1.16l-1.85 1.85-1.78-1.78.71-.71-1.41-1.41L12 3.49a3 3 0 0 0-4.24 0L4.22 7.03l1.41 1.41H2.81l-.71.71 3.54 3.54.71-.71V9.15l1.41 1.41.71-.71 1.78 1.78-7.41 7.41 2.12 2.12L16.34 9.79c.36.13.75.21 1.16.21z"
    })), $1fe2a1803f0c20d4$var$Os = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Bs), $1fe2a1803f0c20d4$var$As = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 10.5,
        cy: 4.5,
        r: 1.5
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19.59 16h-1.27l-.64.71h-1.27L15.14 21h1.27l.64-.71h1.9l.64.71h1.27l-1.27-5zm-5.21-3.28L14 14.19l-3.8-1.26-.1-.16.52-3.13c.93 1.37 2.15 2.11 4.6 2.11v-1.5c-2.44 0-3.09-.77-3.9-2.39a2.65 2.65 0 0 0-3-1.59L3.75 7.41v3.38l-1.51-.5-.48 1.42 4.35 1.45L5 20.86l2 .28 1-7.34.38.13L10 16.3V21h2v-5.3l-.49-.7 2 .67-.37 1.27 1.91.57 1.24-4.19Zm-9.13-1.43v-2.7l1.57-.4-.49 3.46Z"
    })), $1fe2a1803f0c20d4$var$Ds = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$As), $1fe2a1803f0c20d4$var$Ts = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-2 8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8H8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 0 1 5.56 0A2.01 2.01 0 0 1 16 17.43V18z"
    })), $1fe2a1803f0c20d4$var$Fs = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ts), $1fe2a1803f0c20d4$var$Ps = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
    })), $1fe2a1803f0c20d4$var$Rs = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ps), $1fe2a1803f0c20d4$var$Us = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M21.25 10.5c-.41 0-.75.34-.75.75h-1.54a6.978 6.978 0 0 0-1.52-3.65l1.09-1.09.01.01c.29.29.77.29 1.06 0s.29-.77 0-1.06L18.54 4.4a.754.754 0 0 0-1.06 0c-.29.29-.29.76-.01 1.05l-1.09 1.09a7.015 7.015 0 0 0-3.64-1.51V3.5h.01c.41 0 .75-.34.75-.75S13.16 2 12.75 2h-1.5c-.41 0-.75.34-.75.75s.33.74.74.75v1.55c-1.37.14-2.62.69-3.64 1.51L6.51 5.47l.01-.01c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0L4.4 5.46c-.29.29-.29.77 0 1.06.29.29.76.29 1.05.01l1.09 1.09a6.89 6.89 0 0 0-1.5 3.63H3.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5c0 .41.34.75.75.75s.75-.34.75-.75h1.54c.15 1.37.69 2.61 1.5 3.63l-1.09 1.09a.742.742 0 0 0-1.05.01c-.29.29-.29.77 0 1.06l1.06 1.06c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06l-.01-.01 1.09-1.09c1.02.82 2.26 1.36 3.63 1.51v1.55c-.41.01-.74.34-.74.75s.34.75.75.75h1.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-.01v-1.54c1.37-.14 2.62-.69 3.64-1.51l1.09 1.09c-.29.29-.28.76.01 1.05.29.29.77.29 1.06 0l1.06-1.06c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-.01.01-1.09-1.09a7.025 7.025 0 0 0 1.52-3.65h1.54c0 .41.34.75.75.75s.75-.34.75-.75v-1.5c.01-.4-.33-.74-.74-.74zM13.75 8c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM12 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1.75-5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM8.5 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1.75 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3.5 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm.75-4c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1z"
    })), $1fe2a1803f0c20d4$var$Ys = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Us), $1fe2a1803f0c20d4$var$Ws = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
    })), $1fe2a1803f0c20d4$var$Ks = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ws), $1fe2a1803f0c20d4$var$Is = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M22 9 12 2 2 9h9v13h2V9z"
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m4.14 12-1.96.37.82 4.37V22h2l.02-4H7v4h2v-6H4.9zm14.96 4H15v6h2v-4h1.98l.02 4h2v-5.26l.82-4.37-1.96-.37z"
    })), $1fe2a1803f0c20d4$var$Zs = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Is), $1fe2a1803f0c20d4$var$Gs = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
    })), $1fe2a1803f0c20d4$var$js = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Gs), $1fe2a1803f0c20d4$var$qs = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M15 13V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4zm-4-8c0-.55.45-1 1-1s1 .45 1 1h-1v1h1v2h-1v1h1v2h-2V5z"
    })), $1fe2a1803f0c20d4$var$Qs = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$qs), $1fe2a1803f0c20d4$var$Js = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m21.41 10.59-7.99-8c-.78-.78-2.05-.78-2.83 0l-8.01 8c-.78.78-.78 2.05 0 2.83l8.01 8c.78.78 2.05.78 2.83 0l7.99-8c.79-.79.79-2.05 0-2.83zM13.5 14.5V12H10v3H8v-4c0-.55.45-1 1-1h4.5V7.5L17 11l-3.5 3.5z"
    })), $1fe2a1803f0c20d4$var$Xs = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Js), $1fe2a1803f0c20d4$var$ea = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10 2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
    })), $1fe2a1803f0c20d4$var$ta = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ea), $1fe2a1803f0c20d4$var$sa = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"
    })), $1fe2a1803f0c20d4$var$aa = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$sa), $1fe2a1803f0c20d4$var$na = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
    })), $1fe2a1803f0c20d4$var$ca = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$na), $1fe2a1803f0c20d4$var$ia = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9 7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7"
    })), $1fe2a1803f0c20d4$var$oa = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ia), $1fe2a1803f0c20d4$var$ra = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0 1 12 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0 1 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
    })), $1fe2a1803f0c20d4$var$la = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ra), $1fe2a1803f0c20d4$var$ha = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m13 10.17-2.5-2.5V2.25a1.25 1.25 0 0 1 2.5 0v7.92zm7 2.58v-7.5a1.25 1.25 0 0 0-2.5 0V11h-1V3.25a1.25 1.25 0 0 0-2.5 0v7.92l6 6v-4.42zM9.5 4.25C9.5 3.56 8.94 3 8.25 3c-.67 0-1.2.53-1.24 1.18L9.5 6.67V4.25zm3.5 5.92-2.5-2.5V2.25a1.25 1.25 0 0 1 2.5 0v7.92zm7 2.58v-7.5a1.25 1.25 0 0 0-2.5 0V11h-1V3.25a1.25 1.25 0 0 0-2.5 0v7.92l6 6v-4.42zM9.5 4.25C9.5 3.56 8.94 3 8.25 3c-.67 0-1.2.53-1.24 1.18L9.5 6.67V4.25zm11.69 16.94L2.81 2.81 1.39 4.22l5.63 5.63L7 9.83v4.3c-1.11-.64-2.58-1.47-2.6-1.48-.17-.09-.34-.14-.54-.14-.26 0-.5.09-.7.26-.04.01-1.16 1.11-1.16 1.11l6.8 7.18c.57.6 1.35.94 2.18.94H17c.62 0 1.18-.19 1.65-.52l-.02-.02 1.15 1.15 1.41-1.42z"
    })), $1fe2a1803f0c20d4$var$ma = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ha), $1fe2a1803f0c20d4$var$da = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
    })), $1fe2a1803f0c20d4$var$va = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$da), $1fe2a1803f0c20d4$var$ga = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M6.05 8.05a7.001 7.001 0 0 0-.02 9.88c1.47-3.4 4.09-6.24 7.36-7.93A15.952 15.952 0 0 0 8 19.32c2.6 1.23 5.8.78 7.95-1.37C19.43 14.47 20 4 20 4S9.53 4.57 6.05 8.05z"
    })), $1fe2a1803f0c20d4$var$ua = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ga), $1fe2a1803f0c20d4$var$wa = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
    })), $1fe2a1803f0c20d4$var$pa = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$wa), $1fe2a1803f0c20d4$var$fa = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M21 14c0-.55-.45-1-1-1h-2v2h2c.55 0 1-.45 1-1zm-1 3h-2v2h2c.55 0 1-.45 1-1s-.45-1-1-1zm-8-3h-2v4h2c0 1.1.9 2 2 2h3v-8h-3c-1.1 0-2 .9-2 2z"
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M5 13c0-1.1.9-2 2-2h1.5c1.93 0 3.5-1.57 3.5-3.5S10.43 4 8.5 4H5c-.55 0-1 .45-1 1s.45 1 1 1h3.5c.83 0 1.5.67 1.5 1.5S9.33 9 8.5 9H7c-2.21 0-4 1.79-4 4s1.79 4 4 4h2v-2H7c-1.1 0-2-.9-2-2z"
    })), $1fe2a1803f0c20d4$var$Ma = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$fa), $1fe2a1803f0c20d4$var$xa = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94A5.01 5.01 0 0 0 11 15.9V19H7v2h10v-2h-4v-3.1a5.01 5.01 0 0 0 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"
    })), $1fe2a1803f0c20d4$var$Ea = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$xa), $1fe2a1803f0c20d4$var$ba = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
    })), $1fe2a1803f0c20d4$var$za = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ba), $1fe2a1803f0c20d4$var$Sa = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    })), $1fe2a1803f0c20d4$var$_a = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Sa), $1fe2a1803f0c20d4$var$Ca = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
    })), $1fe2a1803f0c20d4$var$Na = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ca), $1fe2a1803f0c20d4$var$ya = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    })), $1fe2a1803f0c20d4$var$La = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ya), $1fe2a1803f0c20d4$var$ka = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
    })), $1fe2a1803f0c20d4$var$$a = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ka), $1fe2a1803f0c20d4$var$Ha = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z"
    })), $1fe2a1803f0c20d4$var$Va = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ha), $1fe2a1803f0c20d4$var$Ba = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m4 18 8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
    })), $1fe2a1803f0c20d4$var$Oa = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ba), $1fe2a1803f0c20d4$var$Aa = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11 18V6l-8.5 6 8.5 6zm.5-6 8.5 6V6l-8.5 6z"
    })), $1fe2a1803f0c20d4$var$Da = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Aa), $1fe2a1803f0c20d4$var$Ta = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
    })), $1fe2a1803f0c20d4$var$Fa = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ta), $1fe2a1803f0c20d4$var$Pa = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
    })), $1fe2a1803f0c20d4$var$Ra = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Pa), $1fe2a1803f0c20d4$var$Ua = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 9h-1V4H8v16h14v-8c0-1.66-1.34-3-3-3zm-9-3h6v3h-6V6zm4 11h-4v-5h4v5zm2 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM4.5 8A2.5 2.5 0 0 0 2 10.5v8a2.5 2.5 0 0 0 5 0v-8A2.5 2.5 0 0 0 4.5 8z"
    })), $1fe2a1803f0c20d4$var$Ya = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ua), $1fe2a1803f0c20d4$var$Wa = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
    })), $1fe2a1803f0c20d4$var$Ka = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Wa), $1fe2a1803f0c20d4$var$Ia = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M15 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V7l-5-5zM6 20V4h8v4h4v12H6zm10-10v5c0 2.21-1.79 4-4 4s-4-1.79-4-4V8.5a2.5 2.5 0 0 1 2.76-2.49c1.3.13 2.24 1.32 2.24 2.63V15h-2V8.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V15c0 1.1.9 2 2 2s2-.9 2-2v-5h2z"
    })), $1fe2a1803f0c20d4$var$Za = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ia), $1fe2a1803f0c20d4$var$Ga = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"
    })), $1fe2a1803f0c20d4$var$ja = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ga), $1fe2a1803f0c20d4$var$qa = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A.998.998 0 0 0 18.95 4H5.04c-.83 0-1.3.95-.79 1.61z"
    })), $1fe2a1803f0c20d4$var$Qa = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$qa), $1fe2a1803f0c20d4$var$Ja = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
    })), $1fe2a1803f0c20d4$var$Xa = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ja), $1fe2a1803f0c20d4$var$e2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2a.506.506 0 0 1 .2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67a.49.49 0 0 1-.44.28zM3.5 9.72a.499.499 0 0 1-.41-.79c.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25a.5.5 0 0 1-.12.7c-.23.16-.54.11-.7-.12a9.388 9.388 0 0 0-3.39-2.94c-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07a.47.47 0 0 1-.35-.15c-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1a7.297 7.297 0 0 1-2.17-5.22c0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29a11.14 11.14 0 0 1-.73-3.96c0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
    })), $1fe2a1803f0c20d4$var$t2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$e2), $1fe2a1803f0c20d4$var$s2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M18.41 16.59 13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
    })), $1fe2a1803f0c20d4$var$a2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$s2), $1fe2a1803f0c20d4$var$n2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M14.4 6 14 4H5v17h2v-7h5.6l.4 2h7V6z"
    })), $1fe2a1803f0c20d4$var$c2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$n2), $1fe2a1803f0c20d4$var$i2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M6.459 17a4.444 4.444 0 0 1-4.116-2.768 4.541 4.541 0 0 1 .954-4.909 4.405 4.405 0 0 1 4.845-.982 4.5 4.5 0 0 1 2.747 4.159 4.514 4.514 0 0 1-1.292 3.181A4.403 4.403 0 0 1 6.459 17Zm11.111 0a4.444 4.444 0 0 1-4.116-2.768 4.541 4.541 0 0 1 .954-4.909 4.405 4.405 0 0 1 4.845-.982A4.5 4.5 0 0 1 22 12.5a4.514 4.514 0 0 1-1.292 3.181A4.403 4.403 0 0 1 17.57 17Z"
    })), $1fe2a1803f0c20d4$var$o2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$i2), $1fe2a1803f0c20d4$var$r2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
    })), $1fe2a1803f0c20d4$var$l2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$r2), $1fe2a1803f0c20d4$var$h2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M17 18.16a6 6 0 0 0-2.95.8 4.08 4.08 0 0 1-2.05.6 3.81 3.81 0 0 1-2-.56 5.84 5.84 0 0 0-5.9 0 4.05 4.05 0 0 1-2 .6v2a6 6 0 0 0 3-.8 4.05 4.05 0 0 1 1.9-.69 3.87 3.87 0 0 1 2.05.6 5.84 5.84 0 0 0 5.9 0 4.08 4.08 0 0 1 2.05-.6 3.81 3.81 0 0 1 2.05.6 5.9 5.9 0 0 0 2.95.8v-2a3.81 3.81 0 0 1-2-.51 6 6 0 0 0-3-.84Zm3-3.65a6.8 6.8 0 0 0-2-.71V10h3l-9-7-9 7h3v3.8a6.8 6.8 0 0 0-1.95.71 4.15 4.15 0 0 1-2 .6v1.95a6.07 6.07 0 0 0 3-.8 3.8 3.8 0 0 1 4.1 0 5.87 5.87 0 0 0 2.95.8 6 6 0 0 0 2.95-.8 3.8 3.8 0 0 1 4.1 0 5.9 5.9 0 0 0 2.95.8v-1.95a3.81 3.81 0 0 1-2.1-.6Zm-9.95 0V11h4v3.54a4.19 4.19 0 0 1-2 .57 3.8 3.8 0 0 1-2.05-.57Z"
    })), $1fe2a1803f0c20d4$var$m2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$h2), $1fe2a1803f0c20d4$var$d2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
    })), $1fe2a1803f0c20d4$var$v2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$d2), $1fe2a1803f0c20d4$var$g2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
    })), $1fe2a1803f0c20d4$var$u2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$g2), $1fe2a1803f0c20d4$var$w2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"
    })), $1fe2a1803f0c20d4$var$p2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$w2), $1fe2a1803f0c20d4$var$f2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
    })), $1fe2a1803f0c20d4$var$M2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$f2), $1fe2a1803f0c20d4$var$x2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
    })), $1fe2a1803f0c20d4$var$E2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$x2), $1fe2a1803f0c20d4$var$b2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2a10 10 0 0 0-3.16 19.49c.5.09.68-.22.68-.48v-1.7C6.73 19.91 6.14 18 6.14 18A2.69 2.69 0 0 0 5 16.5c-.91-.62.07-.61.07-.61a2.13 2.13 0 0 1 1.53 1 2.14 2.14 0 0 0 2.91.83 2.16 2.16 0 0 1 .63-1.34c-2.14-.21-4.52-1.07-4.52-4.9a3.89 3.89 0 0 1 1-2.69 3.57 3.57 0 0 1 .1-2.64s.84-.27 2.75 1a9.63 9.63 0 0 1 5 0c1.91-1.29 2.75-1 2.75-1a3.57 3.57 0 0 1 .1 2.64 3.89 3.89 0 0 1 1 2.69c0 3.84-2.34 4.68-4.57 4.93a2.39 2.39 0 0 1 .68 1.85v2.75c0 .33.18.58.69.48A10 10 0 0 0 12 2Z",
        fillRule: "evenodd"
    })), $1fe2a1803f0c20d4$var$z2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$b2), $1fe2a1803f0c20d4$var$S2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        fillRule: "evenodd",
        d: "M3 3v8h8V3H3zm6 6H5V5h4v4zm-6 4v8h8v-8H3zm6 6H5v-4h4v4zm4-16v8h8V3h-8zm6 6h-4V5h4v4zm-6 4v8h8v-8h-8zm6 6h-4v-4h4v4z"
    })), $1fe2a1803f0c20d4$var$_2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$S2), $1fe2a1803f0c20d4$var$C2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M22 9V7h-2v2h-2v2h2v2h2v-2h2V9zM8 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 1c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm4.51-8.95C13.43 5.11 14 6.49 14 8s-.57 2.89-1.49 3.95C14.47 11.7 16 10.04 16 8s-1.53-3.7-3.49-3.95zm4.02 9.78C17.42 14.66 18 15.7 18 17v3h2v-3c0-1.45-1.59-2.51-3.47-3.17z"
    })), $1fe2a1803f0c20d4$var$N2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$C2), $1fe2a1803f0c20d4$var$y2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 12.75c1.63 0 3.07.39 4.24.9 1.08.48 1.76 1.56 1.76 2.73V18H6v-1.61c0-1.18.68-2.26 1.76-2.73 1.17-.52 2.61-.91 4.24-.91zM4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58A2.01 2.01 0 0 0 0 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29zM20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85A6.95 6.95 0 0 0 20 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57zM12 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z"
    })), $1fe2a1803f0c20d4$var$L2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$y2), $1fe2a1803f0c20d4$var$k2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55A3.999 3.999 0 0 0 21 18h-2c0 1.1-.9 2-2 2zM7.64 2.64 6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0-5 0z"
    })), $1fe2a1803f0c20d4$var$$2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$k2), $1fe2a1803f0c20d4$var$H2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
    })), $1fe2a1803f0c20d4$var$V2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$H2), $1fe2a1803f0c20d4$var$B2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
    })), $1fe2a1803f0c20d4$var$O2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$B2), $1fe2a1803f0c20d4$var$A2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    })), $1fe2a1803f0c20d4$var$D2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$A2), $1fe2a1803f0c20d4$var$T2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
    })), $1fe2a1803f0c20d4$var$F2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$T2), $1fe2a1803f0c20d4$var$P2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
    })), $1fe2a1803f0c20d4$var$R2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$P2), $1fe2a1803f0c20d4$var$U2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Zm-3 14h-2v-4h-4v4H8V7h2v4h4V7h2Z"
    })), $1fe2a1803f0c20d4$var$Y2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$U2), $1fe2a1803f0c20d4$var$W2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
    })), $1fe2a1803f0c20d4$var$K2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$W2), $1fe2a1803f0c20d4$var$I2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5-4-4V4h8v3.5l-4 4z"
    })), $1fe2a1803f0c20d4$var$Z2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$I2), $1fe2a1803f0c20d4$var$G2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 12a7 7 0 0 0-6.34-7 27.32 27.32 0 0 1 2.21-2.09.44.44 0 0 0-.29-.78 10.62 10.62 0 0 0-9.17 7.5 4.26 4.26 0 0 0-.15.47v.06A7.18 7.18 0 0 0 5 12a7 7 0 0 0 6.35 7 27.71 27.71 0 0 1-2.21 2.1.44.44 0 0 0 .29.78 10.65 10.65 0 0 0 9.23-7.69v-.14c0-.05.05-.13.07-.2A6.76 6.76 0 0 0 19 12Zm-7 3.5a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5Z"
    })), $1fe2a1803f0c20d4$var$j2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$G2), $1fe2a1803f0c20d4$var$q2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11 14.14C11 13.38 9.33 13 8.5 13S6 13.38 6 14.14V15h5Z"
    }), /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 8.5,
        cy: 10.5,
        r: 1.5
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm-7 13H4V7h9Zm7 0h-5v-2h5Zm0-4h-5v-2h5Zm0-4h-5V7h5Z"
    })), $1fe2a1803f0c20d4$var$Q2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$q2), $1fe2a1803f0c20d4$var$J2 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
    })), $1fe2a1803f0c20d4$var$X2 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$J2), $1fe2a1803f0c20d4$var$en = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
    })), $1fe2a1803f0c20d4$var$tn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$en), $1fe2a1803f0c20d4$var$sn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M0 0h24v24H0V0z",
        fill: "none"
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    })), $1fe2a1803f0c20d4$var$an = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$sn), $1fe2a1803f0c20d4$var$nn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M21 8c-1.45 0-2.26 1.44-1.93 2.51l-3.55 3.56c-.3-.09-.74-.09-1.04 0l-2.55-2.55C12.27 10.45 11.46 9 10 9c-1.45 0-2.27 1.44-1.93 2.52l-4.56 4.55C2.44 15.74 1 16.55 1 18c0 1.1.9 2 2 2 1.45 0 2.26-1.44 1.93-2.51l4.55-4.56c.3.09.74.09 1.04 0l2.55 2.55C12.73 16.55 13.54 18 15 18c1.45 0 2.27-1.44 1.93-2.52l3.56-3.55c1.07.33 2.51-.48 2.51-1.93 0-1.1-.9-2-2-2z"
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m15 9 .94-2.07L18 6l-2.06-.93L15 3l-.92 2.07L12 6l2.08.93zM3.5 11 4 9l2-.5L4 8l-.5-2L3 8l-2 .5L3 9z"
    })), $1fe2a1803f0c20d4$var$cn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$nn), $1fe2a1803f0c20d4$var$on = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M8.273 3.063c-.958.045-1.612.198-2.184.423a4.41 4.41 0 0 0-1.592 1.04 4.409 4.409 0 0 0-1.035 1.596c-.222.572-.372 1.227-.414 2.185-.042.958-.052 1.266-.047 3.71.005 2.444.016 2.75.062 3.71.046.958.198 1.612.423 2.184a4.41 4.41 0 0 0 1.04 1.592 4.4 4.4 0 0 0 1.597 1.035c.572.221 1.227.372 2.185.414.958.042 1.266.052 3.71.047 2.443-.005 2.75-.016 3.71-.061.96-.046 1.611-.199 2.183-.423a4.411 4.411 0 0 0 1.592-1.04 4.41 4.41 0 0 0 1.035-1.597c.222-.572.372-1.227.414-2.184.042-.96.052-1.268.047-3.711-.005-2.444-.016-2.75-.061-3.71-.046-.96-.198-1.612-.423-2.184a4.418 4.418 0 0 0-1.04-1.592 4.4 4.4 0 0 0-1.597-1.035c-.572-.221-1.227-.372-2.185-.414-.958-.041-1.266-.052-3.71-.047-2.444.005-2.75.015-3.71.062m.105 16.27c-.878-.038-1.354-.184-1.672-.306a2.802 2.802 0 0 1-1.036-.671 2.772 2.772 0 0 1-.675-1.034c-.124-.317-.272-.793-.313-1.67-.045-.95-.054-1.234-.06-3.637-.004-2.403.005-2.687.046-3.636.038-.877.184-1.354.306-1.671.162-.421.357-.72.672-1.036a2.778 2.778 0 0 1 1.033-.675c.317-.124.793-.272 1.67-.313.95-.045 1.234-.054 3.637-.06 2.402-.005 2.687.004 3.637.046.876.038 1.354.183 1.67.306.421.162.72.357 1.037.671.316.315.511.613.675 1.034.124.317.271.792.313 1.67.045.95.055 1.234.06 3.636.004 2.402-.004 2.688-.046 3.636-.038.878-.184 1.354-.306 1.672a2.79 2.79 0 0 1-.672 1.036 2.78 2.78 0 0 1-1.033.675c-.317.124-.794.271-1.67.313-.95.045-1.234.054-3.637.06-2.403.005-2.687-.005-3.636-.046M15.715 7.19a1.08 1.08 0 1 0 2.16-.004 1.08 1.08 0 0 0-2.16.004m-8.336 4.819a4.62 4.62 0 1 0 9.242-.018 4.62 4.62 0 0 0-9.242.018M9 12.006a3 3 0 1 1 6-.012 3 3 0 0 1-6 .012"
    })), $1fe2a1803f0c20d4$var$rn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$on), $1fe2a1803f0c20d4$var$ln = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"
    })), $1fe2a1803f0c20d4$var$hn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ln), $1fe2a1803f0c20d4$var$mn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"
    })), $1fe2a1803f0c20d4$var$dn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$mn), $1fe2a1803f0c20d4$var$vn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95a15.65 15.65 0 0 0-1.38-3.56A8.03 8.03 0 0 1 18.92 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 0 1 5.08 16zm2.95-8H5.08a7.987 7.987 0 0 1 4.33-3.56A15.65 15.65 0 0 0 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 0 1-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
    })), $1fe2a1803f0c20d4$var$gn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$vn), $1fe2a1803f0c20d4$var$un = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M5.59 7.41 10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
    })), $1fe2a1803f0c20d4$var$wn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$un), $1fe2a1803f0c20d4$var$pn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
    })), $1fe2a1803f0c20d4$var$fn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$pn), $1fe2a1803f0c20d4$var$Mn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M9 21c0 .5.4 1 1 1h4c.6 0 1-.5 1-1v-1H9v1zm3-19C8.1 2 5 5.1 5 9c0 2.4 1.2 4.5 3 5.7V17c0 .5.4 1 1 1h6c.6 0 1-.5 1-1v-2.3c1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7z"
    })), $1fe2a1803f0c20d4$var$xn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Mn), $1fe2a1803f0c20d4$var$En = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2 11.7V16h-4v-2.3C8.48 12.63 7 11.53 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.49-1.51 3.65-3 4.7z"
    })), $1fe2a1803f0c20d4$var$bn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$En), $1fe2a1803f0c20d4$var$zn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19.667 3A1.322 1.322 0 0 1 21 4.298V19.7a1.323 1.323 0 0 1-1.333 1.3H4.328A1.32 1.32 0 0 1 3 19.701V4.3A1.32 1.32 0 0 1 4.328 3h15.339Zm-4.898 6.1a2.834 2.834 0 0 0-2.55 1.403h-.036V9.316H9.6V18h2.692v-4.296c0-1.133.214-2.23 1.616-2.23 1.382 0 1.4 1.296 1.4 2.303V18H18v-4.764c0-2.338-.503-4.136-3.231-4.136Zm-6.86.216H5.213V18h2.694V9.316ZM6.561 5A1.57 1.57 0 0 0 5 6.565a1.57 1.57 0 0 0 1.562 1.564l.142-.006a1.572 1.572 0 0 0 1.42-1.558l-.006-.142A1.572 1.572 0 0 0 6.562 5Z"
    })), $1fe2a1803f0c20d4$var$Sn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$zn), $1fe2a1803f0c20d4$var$_n = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
    })), $1fe2a1803f0c20d4$var$Cn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$_n), $1fe2a1803f0c20d4$var$Nn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H16zM2 4.27l3.11 3.11A4.991 4.991 0 0 0 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74 3.27 3 2 4.27z"
    })), $1fe2a1803f0c20d4$var$yn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Nn), $1fe2a1803f0c20d4$var$Ln = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
    })), $1fe2a1803f0c20d4$var$kn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ln), $1fe2a1803f0c20d4$var$$n = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 0 0 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z"
    })), $1fe2a1803f0c20d4$var$Hn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$$n), $1fe2a1803f0c20d4$var$Vn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m12 12.9-2.13 2.09c-.56.56-.87 1.29-.87 2.07C9 18.68 10.35 20 12 20s3-1.32 3-2.94c0-.78-.31-1.52-.87-2.07L12 12.9z"
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m16 6-.44.55C14.38 8.02 12 7.19 12 5.3V2S4 6 4 13c0 2.92 1.56 5.47 3.89 6.86-.56-.79-.89-1.76-.89-2.8 0-1.32.52-2.56 1.47-3.5L12 10.1l3.53 3.47c.95.93 1.47 2.17 1.47 3.5 0 1.02-.31 1.96-.85 2.75 1.89-1.15 3.29-3.06 3.71-5.3.66-3.55-1.07-6.9-3.86-8.52z"
    })), $1fe2a1803f0c20d4$var$Bn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Vn), $1fe2a1803f0c20d4$var$On = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m19.77 7.23.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 0 0 2.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 0 0 5 0V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
    })), $1fe2a1803f0c20d4$var$An = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$On), $1fe2a1803f0c20d4$var$Dn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
    })), $1fe2a1803f0c20d4$var$Tn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Dn), $1fe2a1803f0c20d4$var$Fn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"
    })), $1fe2a1803f0c20d4$var$Pn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Fn), $1fe2a1803f0c20d4$var$Rn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M9.17 16.83a4.008 4.008 0 0 0 5.66 0 4.008 4.008 0 0 0 0-5.66l-5.66 5.66zM18 2.01 6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
    })), $1fe2a1803f0c20d4$var$Un = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Rn), $1fe2a1803f0c20d4$var$Yn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
    })), $1fe2a1803f0c20d4$var$Wn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Yn), $1fe2a1803f0c20d4$var$Kn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m21.41 11.58-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
    })), $1fe2a1803f0c20d4$var$In = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Kn), $1fe2a1803f0c20d4$var$Zn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
    })), $1fe2a1803f0c20d4$var$Gn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Zn), $1fe2a1803f0c20d4$var$jn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z"
    })), $1fe2a1803f0c20d4$var$qn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$jn), $1fe2a1803f0c20d4$var$Qn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm2.5 11.59.9 3.88-3.4-2.05-3.4 2.05.9-3.87-3-2.59 3.96-.34L12 6.02l1.54 3.64 3.96.34-3 2.59z"
    })), $1fe2a1803f0c20d4$var$Jn = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Qn), $1fe2a1803f0c20d4$var$Xn = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
    })), $1fe2a1803f0c20d4$var$ec = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Xn), $1fe2a1803f0c20d4$var$tc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
    })), $1fe2a1803f0c20d4$var$sc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$tc), $1fe2a1803f0c20d4$var$ac = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z"
    })), $1fe2a1803f0c20d4$var$nc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ac), $1fe2a1803f0c20d4$var$cc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
    })), $1fe2a1803f0c20d4$var$ic = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$cc), $1fe2a1803f0c20d4$var$oc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"
    })), $1fe2a1803f0c20d4$var$rc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$oc), $1fe2a1803f0c20d4$var$lc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z"
    })), $1fe2a1803f0c20d4$var$hc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$lc), $1fe2a1803f0c20d4$var$mc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11 7 9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z"
    })), $1fe2a1803f0c20d4$var$dc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$mc), $1fe2a1803f0c20d4$var$vc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
    })), $1fe2a1803f0c20d4$var$gc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$vc), $1fe2a1803f0c20d4$var$uc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 0 0 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
    })), $1fe2a1803f0c20d4$var$wc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$uc), $1fe2a1803f0c20d4$var$pc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
    })), $1fe2a1803f0c20d4$var$fc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$pc), $1fe2a1803f0c20d4$var$Mc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
    })), $1fe2a1803f0c20d4$var$xc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Mc), $1fe2a1803f0c20d4$var$Ec = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m20.5 3-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"
    })), $1fe2a1803f0c20d4$var$bc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ec), $1fe2a1803f0c20d4$var$zc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19.5 6c-1.31 0-2.37 1.01-2.48 2.3-1.88-.5-2.84-1.8-5.02-1.8-2.19 0-3.14 1.3-5.02 1.8C6.87 7.02 5.81 6 4.5 6A2.5 2.5 0 0 0 2 8.5V9c0 6 3.6 7.81 6.52 7.98C9.53 17.62 10.72 18 12 18s2.47-.38 3.48-1.02C18.4 16.81 22 15 22 9v-.5A2.5 2.5 0 0 0 19.5 6zm-16 3v-.5c0-.55.45-1 1-1s1 .45 1 1v3c0 1.28.38 2.47 1.01 3.48C4.99 14.27 3.5 12.65 3.5 9zm17 0c0 3.65-1.49 5.27-3.01 5.98.64-1.01 1.01-2.2 1.01-3.48v-3c0-.55.45-1 1-1s1 .45 1 1V9zm-9.81 1.48c-.44.26-.96.56-1.69.76V10.2c.48-.17.84-.38 1.18-.58C10.72 9.3 11.23 9 12 9s1.27.3 1.8.62c.34.2.71.42 1.2.59v1.04c-.75-.21-1.26-.51-1.71-.78-.46-.27-.8-.47-1.29-.47s-.84.2-1.31.48z"
    })), $1fe2a1803f0c20d4$var$Sc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$zc), $1fe2a1803f0c20d4$var$_c = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 6h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM10 4h4v2h-4V4zm6 11h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z"
    })), $1fe2a1803f0c20d4$var$Cc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$_c), $1fe2a1803f0c20d4$var$Nc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
    })), $1fe2a1803f0c20d4$var$yc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Nc), $1fe2a1803f0c20d4$var$Lc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M17 10.43V2H7v8.43c0 .35.18.68.49.86l4.18 2.51-.99 2.34-3.41.29 2.59 2.24L9.07 22 12 20.23 14.93 22l-.78-3.33 2.59-2.24-3.41-.29-.99-2.34 4.18-2.51c.3-.18.48-.5.48-.86zm-4 1.8-1 .6-1-.6V3h2v9.23z"
    })), $1fe2a1803f0c20d4$var$kc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Lc), $1fe2a1803f0c20d4$var$$c = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    })), $1fe2a1803f0c20d4$var$Hc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$$c), $1fe2a1803f0c20d4$var$Vc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    })), $1fe2a1803f0c20d4$var$Bc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Vc), $1fe2a1803f0c20d4$var$Oc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
    })), $1fe2a1803f0c20d4$var$Ac = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Oc), $1fe2a1803f0c20d4$var$Dc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    })), $1fe2a1803f0c20d4$var$Tc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Dc), $1fe2a1803f0c20d4$var$Fc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    })), $1fe2a1803f0c20d4$var$Pc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Fc), $1fe2a1803f0c20d4$var$Rc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11.41 7.41 10 6l-6 6 6 6 1.41-1.41L6.83 12zm8 0L18 6l-6 6 6 6 1.41-1.41L14.83 12z"
    })), $1fe2a1803f0c20d4$var$Uc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Rc), $1fe2a1803f0c20d4$var$Yc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m14 6-1.41 1.41L17.17 12l-4.58 4.59L14 18l6-6zM6 6 4.59 7.41 9.17 12l-4.58 4.59L6 18l6-6z"
    })), $1fe2a1803f0c20d4$var$Wc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Yc), $1fe2a1803f0c20d4$var$Kc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M21 3 3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"
    })), $1fe2a1803f0c20d4$var$Ic = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Kc), $1fe2a1803f0c20d4$var$Zc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
    })), $1fe2a1803f0c20d4$var$Gc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Zc), $1fe2a1803f0c20d4$var$jc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M7.58 4.08 6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2a8.445 8.445 0 0 1 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43a8.495 8.495 0 0 1 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"
    })), $1fe2a1803f0c20d4$var$qc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$jc), $1fe2a1803f0c20d4$var$Qc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
    })), $1fe2a1803f0c20d4$var$Jc = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Qc), $1fe2a1803f0c20d4$var$Xc = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 18.69 7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z"
    })), $1fe2a1803f0c20d4$var$ei = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Xc), $1fe2a1803f0c20d4$var$ti = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M17 12h2L12 2 5.05 12H7l-3.9 6h6.92v4h3.96v-4H21z"
    })), $1fe2a1803f0c20d4$var$si = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ti), $1fe2a1803f0c20d4$var$ai = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
    })), $1fe2a1803f0c20d4$var$ni = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ai), $1fe2a1803f0c20d4$var$ci = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
    })), $1fe2a1803f0c20d4$var$ii = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ci), $1fe2a1803f0c20d4$var$oi = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 4.5,
        cy: 9.5,
        r: 2.5
    }), /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 9,
        cy: 5.5,
        r: 2.5
    }), /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 15,
        cy: 5.5,
        r: 2.5
    }), /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 19.5,
        cy: 9.5,
        r: 2.5
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
    })), $1fe2a1803f0c20d4$var$ri = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$oi), $1fe2a1803f0c20d4$var$li = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
    })), $1fe2a1803f0c20d4$var$hi = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$li), $1fe2a1803f0c20d4$var$mi = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 12,
        cy: 12,
        r: 3.2
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M9 2 7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
    })), $1fe2a1803f0c20d4$var$di = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$mi), $1fe2a1803f0c20d4$var$vi = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
    })), $1fe2a1803f0c20d4$var$gi = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$vi), $1fe2a1803f0c20d4$var$ui = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 12,
        cy: 19,
        r: 2
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M10 3h4v12h-4z"
    })), $1fe2a1803f0c20d4$var$wi = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ui), $1fe2a1803f0c20d4$var$pi = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
    })), $1fe2a1803f0c20d4$var$fi = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$pi), $1fe2a1803f0c20d4$var$Mi = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        fillRule: "evenodd",
        d: "M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z"
    })), $1fe2a1803f0c20d4$var$xi = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Mi), $1fe2a1803f0c20d4$var$Ei = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    })), $1fe2a1803f0c20d4$var$bi = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ei), $1fe2a1803f0c20d4$var$zi = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M17.51 7A5.62 5.62 0 0 0 7 5.51a4.5 4.5 0 0 0 .49 9h9.75A3.74 3.74 0 0 0 17.51 7ZM4.076 20.774 6.08 15.77l1.857.743-2.003 5.004zm4.998-.002 2.003-5.004 1.856.743-2.002 5.004zm4.998.008 2.002-5.004 1.857.743-2.002 5.004z"
    })), $1fe2a1803f0c20d4$var$Si = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$zi), $1fe2a1803f0c20d4$var$_i = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M16 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4.78 3.58A6.95 6.95 0 0 0 18 7c-.67 0-1.31.1-1.92.28.58.55.92 1.32.92 2.15V10h5v-.57c0-.81-.48-1.53-1.22-1.85zM6 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.92 1.28C7.31 7.1 6.67 7 6 7c-.99 0-1.93.21-2.78.58A2.01 2.01 0 0 0 2 9.43V10h5v-.57c0-.83.34-1.6.92-2.15zM10 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6H8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 0 1 5.56 0A2.01 2.01 0 0 1 16 9.43V10zm-1 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6h-8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 0 1 5.56 0A2.01 2.01 0 0 1 21 21.43V22zM5 16c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6H3v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 0 1 5.56 0A2.01 2.01 0 0 1 11 21.43V22zm1.75-9v-2h-1.5v2H9l3 3 3-3h-2.25z"
    })), $1fe2a1803f0c20d4$var$Ci = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$_i), $1fe2a1803f0c20d4$var$Ni = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
    })), $1fe2a1803f0c20d4$var$yi = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ni), $1fe2a1803f0c20d4$var$Li = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 13H5v-2h14v2z"
    })), $1fe2a1803f0c20d4$var$ki = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Li), $1fe2a1803f0c20d4$var$$i = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"
    })), $1fe2a1803f0c20d4$var$Hi = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$$i), $1fe2a1803f0c20d4$var$Vi = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"
    })), $1fe2a1803f0c20d4$var$Bi = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Vi), $1fe2a1803f0c20d4$var$Oi = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 6.18,
        cy: 17.82,
        r: 2.18
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"
    })), $1fe2a1803f0c20d4$var$Ai = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Oi), $1fe2a1803f0c20d4$var$Di = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11 5h2v14h-2V5zm-6 7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 0 0-5.56 0A2.01 2.01 0 0 0 1 15.43V16h8v-.57c0-.81-.48-1.53-1.22-1.85zM19 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 0 0-5.56 0A2.01 2.01 0 0 0 15 15.43V16h8v-.57c0-.81-.48-1.53-1.22-1.85z"
    })), $1fe2a1803f0c20d4$var$Ti = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Di), $1fe2a1803f0c20d4$var$Fi = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M15.5 6.5C15.5 5.66 17 4 17 4s1.5 1.66 1.5 2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5zm4 8.5a2.5 2.5 0 0 0 2.5-2.5c0-1.67-2.5-4.5-2.5-4.5S17 10.83 17 12.5a2.5 2.5 0 0 0 2.5 2.5zM13 14h-2v-2H9v2H7v2h2v2h2v-2h2v-2zm3-2v10H4V12c0-2.97 2.16-5.43 5-5.91V4H7V2h6c1.13 0 2.15.39 2.99 1.01l-1.43 1.43C14.1 4.17 13.57 4 13 4h-2v2.09c2.84.48 5 2.94 5 5.91z"
    })), $1fe2a1803f0c20d4$var$Pi = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Fi), $1fe2a1803f0c20d4$var$Ri = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67 2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
    })), $1fe2a1803f0c20d4$var$Ui = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ri), $1fe2a1803f0c20d4$var$Yi = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("g", {
        "data-name": "Severe Weather"
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M4.05 17.73 12 4l8 13.85A5 5 0 0 0 19.2 8a7.49 7.49 0 0 0-14-2 6 6 0 0 0-1.15 11.73Z"
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 7 3.34 22h17.32Zm0 13.4a1 1 0 1 1 1-1 1 1 0 0 1-1 1ZM11 17v-4.6h2V17Z"
    }))), $1fe2a1803f0c20d4$var$Wi = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Yi), $1fe2a1803f0c20d4$var$Ki = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    })), $1fe2a1803f0c20d4$var$Ii = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ki), $1fe2a1803f0c20d4$var$Zi = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3 1 9l11 6 9-4.91V17h2V9L12 3z"
    })), $1fe2a1803f0c20d4$var$Gi = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Zi), $1fe2a1803f0c20d4$var$ji = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19.8 18.4 14 10.67V6.5l1.35-1.69c.26-.33.03-.81-.39-.81H9.04c-.42 0-.65.48-.39.81L10 6.5v4.17L4.2 18.4c-.49.66-.02 1.6.8 1.6h14c.82 0 1.29-.94.8-1.6z"
    })), $1fe2a1803f0c20d4$var$qi = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ji), $1fe2a1803f0c20d4$var$Qi = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    })), $1fe2a1803f0c20d4$var$Ji = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Qi), $1fe2a1803f0c20d4$var$Xi = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
    })), $1fe2a1803f0c20d4$var$eo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Xi), $1fe2a1803f0c20d4$var$to = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"
    })), $1fe2a1803f0c20d4$var$so = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$to), $1fe2a1803f0c20d4$var$ao = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 15.5,
        cy: 9.5,
        r: 1.5
    }), /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 8.5,
        cy: 9.5,
        r: 1.5
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-3.5c.73 0 1.39.19 1.97.53.12-.14.86-.98 1.01-1.14A5.39 5.39 0 0 0 12 15c-1.11 0-2.13.33-2.99.88.97 1.09.01.02 1.01 1.14.59-.33 1.25-.52 1.98-.52z"
    })), $1fe2a1803f0c20d4$var$no = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ao), $1fe2a1803f0c20d4$var$co = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M9 15.5h6v1H9v-1z"
    }), /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 15.5,
        cy: 9.5,
        r: 1.5
    }), /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 8.5,
        cy: 9.5,
        r: 1.5
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    })), $1fe2a1803f0c20d4$var$io = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$co), $1fe2a1803f0c20d4$var$oo = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 15.5,
        cy: 9.5,
        r: 1.5
    }), /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 8.5,
        cy: 9.5,
        r: 1.5
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-.73 0-1.38-.18-1.96-.52-.12.14-.86.98-1.01 1.15a5.49 5.49 0 0 0 5.95-.01c-.97-1.09-.01-.02-1.01-1.15-.59.35-1.24.53-1.97.53z"
    })), $1fe2a1803f0c20d4$var$ro = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$oo), $1fe2a1803f0c20d4$var$lo = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 15.5,
        cy: 9.5,
        r: 1.5
    }), /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 8.5,
        cy: 9.5,
        r: 1.5
    }), /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 15.5,
        cy: 9.5,
        r: 1.5
    }), /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 8.5,
        cy: 9.5,
        r: 1.5
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-2.5c2.33 0 4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2s-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5z"
    })), $1fe2a1803f0c20d4$var$ho = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$lo), $1fe2a1803f0c20d4$var$mo = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 15.5,
        cy: 9.5,
        r: 1.5
    }), /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 8.5,
        cy: 9.5,
        r: 1.5
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z"
    })), $1fe2a1803f0c20d4$var$vo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$mo), $1fe2a1803f0c20d4$var$go = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.488.488 0 0 0-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 0 0-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
    })), $1fe2a1803f0c20d4$var$uo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$go), $1fe2a1803f0c20d4$var$wo = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
    })), $1fe2a1803f0c20d4$var$po = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$wo), $1fe2a1803f0c20d4$var$fo = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"
    })), $1fe2a1803f0c20d4$var$Mo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$fo), $1fe2a1803f0c20d4$var$xo = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m17.21 9-4.38-6.56a.993.993 0 0 0-.83-.42c-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    })), $1fe2a1803f0c20d4$var$Eo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$xo), $1fe2a1803f0c20d4$var$bo = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m20.76 14.07-.66-1.34-2.88 1.42L13.5 12l3.72-2.15 2.88 1.42.66-1.34-1.97-.98 2.25-1.3-.75-1.3-2.25 1.3.14-2.2-1.5-.1-.21 3.2-3.72 2.15V6.4l2.67-1.78-.84-1.24-1.83 1.22V2h-1.5v2.6L9.42 3.38l-.84 1.24 2.67 1.78v4.3L7.53 8.55l-.21-3.2-1.5.1.14 2.2-2.25-1.3-.75 1.3 2.25 1.3-1.97.98.66 1.34 2.88-1.42L10.5 12l-3.72 2.15-2.88-1.42-.66 1.34 1.97.98-2.25 1.3.75 1.3 2.25-1.3-.14 2.2 1.5.1.21-3.2 3.72-2.15v4.3l-2.67 1.78.84 1.24 1.83-1.22V22h1.5v-2.6l1.83 1.22.84-1.24-2.67-1.78v-4.3l3.72 2.15.21 3.2 1.5-.1-.14-2.2 2.25 1.3.75-1.3-2.25-1.3 1.97-.98z"
    })), $1fe2a1803f0c20d4$var$zo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$bo), $1fe2a1803f0c20d4$var$So = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m9.12 5-7.18 6.79c-.6.56-.94 1.35-.94 2.18V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 0 0 0-2.5H12v-1h7.75a1.25 1.25 0 0 0 0-2.5H12v-1h8.75a1.25 1.25 0 0 0 0-2.5H12v-1h6.75a1.25 1.25 0 0 0 0-2.5H8.86c.64-1.11 1.48-2.58 1.49-2.61a1.065 1.065 0 0 0-.12-1.23C10.22 6.12 9.12 5 9.12 5zM14 6.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75m0-1.5c-1.24 0-2.25 1.01-2.25 2.25S12.76 9.25 14 9.25 16.25 8.24 16.25 7 15.24 4.75 14 4.75zm5.75.75c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5m0-1.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM16.5 1c-.83 0-1.5.67-1.5 1.5S15.67 4 16.5 4 18 3.33 18 2.5 17.33 1 16.5 1z"
    })), $1fe2a1803f0c20d4$var$_o = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$So), $1fe2a1803f0c20d4$var$Co = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M4 5c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4.78 3.58a6.95 6.95 0 0 0-5.56 0A2.01 2.01 0 0 0 2 10.43V11h8v-.57c0-.81-.48-1.53-1.22-1.85zM18 7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 0 0-5.56 0A2.01 2.01 0 0 0 14 10.43V11h8v-.57c0-.81-.48-1.53-1.22-1.85zM22 17l-4-4v3H6v-3l-4 4 4 4v-3h12v3l4-4z"
    })), $1fe2a1803f0c20d4$var$No = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Co), $1fe2a1803f0c20d4$var$yo = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M15.17 15 13 17.17V6.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 11 6.83v10.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15z"
    })), $1fe2a1803f0c20d4$var$Lo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$yo), $1fe2a1803f0c20d4$var$ko = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"
    })), $1fe2a1803f0c20d4$var$$o = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$ko), $1fe2a1803f0c20d4$var$Ho = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
    })), $1fe2a1803f0c20d4$var$Vo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ho), $1fe2a1803f0c20d4$var$Bo = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
    })), $1fe2a1803f0c20d4$var$Oo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Bo), $1fe2a1803f0c20d4$var$Ao = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
    })), $1fe2a1803f0c20d4$var$Do = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Ao), $1fe2a1803f0c20d4$var$To = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
    })), $1fe2a1803f0c20d4$var$Fo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$To), $1fe2a1803f0c20d4$var$Po = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.46 7.12-2.78 1.15a4.982 4.982 0 0 0-2.95-2.94l1.15-2.78c2.1.8 3.77 2.47 4.58 4.57zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zM9.13 4.54l1.17 2.78a5 5 0 0 0-2.98 2.97L4.54 9.13a7.984 7.984 0 0 1 4.59-4.59zM4.54 14.87l2.78-1.15a4.968 4.968 0 0 0 2.97 2.96l-1.17 2.78a7.996 7.996 0 0 1-4.58-4.59zm10.34 4.59-1.15-2.78a4.978 4.978 0 0 0 2.95-2.97l2.78 1.17a8.007 8.007 0 0 1-4.58 4.58z"
    })), $1fe2a1803f0c20d4$var$Ro = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Po), $1fe2a1803f0c20d4$var$Uo = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M21 12.22C21 6.73 16.74 3 12 3c-4.69 0-9 3.65-9 9.28-.6.34-1 .98-1 1.72v2c0 1.1.9 2 2 2h1v-6.1c0-3.87 3.13-7 7-7s7 3.13 7 7V19h-8v2h8c1.1 0 2-.9 2-2v-1.22c.59-.31 1-.92 1-1.64v-2.3c0-.7-.41-1.31-1-1.62z"
    }), /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 9,
        cy: 13,
        r: 1
    }), /* @__PURE__ */ $3RyIS.createElement("circle", {
        cx: 15,
        cy: 13,
        r: 1
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M18 11.03A6.04 6.04 0 0 0 12.05 6c-3.03 0-6.29 2.51-6.03 6.45a8.075 8.075 0 0 0 4.86-5.89c1.31 2.63 4 4.44 7.12 4.47z"
    })), $1fe2a1803f0c20d4$var$Yo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Uo), $1fe2a1803f0c20d4$var$Wo = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
    })), $1fe2a1803f0c20d4$var$Ko = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Wo), $1fe2a1803f0c20d4$var$Io = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M22 4h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h2V4zM2.17 11.12c-.11.25-.17.52-.17.8V13c0 1.1.9 2 2 2h5.5l-.92 4.65c-.05.22-.02.46.08.66.23.45.52.86.88 1.22L10 22l6.41-6.41c.38-.38.59-.89.59-1.42V6.34C17 5.05 15.95 4 14.66 4h-8.1c-.71 0-1.36.37-1.72.97l-2.67 6.15z"
    })), $1fe2a1803f0c20d4$var$Zo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Io), $1fe2a1803f0c20d4$var$Go = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M2 20h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1H2v11zm19.83-7.12c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66a4.8 4.8 0 0 0-.88-1.22L14 2 7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.84A2.34 2.34 0 0 0 9.34 20h8.11c.7 0 1.36-.37 1.72-.97l2.66-6.15z"
    })), $1fe2a1803f0c20d4$var$jo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Go), $1fe2a1803f0c20d4$var$qo = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M9 1h6v2H9zm10.03 6.39 1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0 0 12 4a9 9 0 0 0-9 9c0 4.97 4.02 9 9 9a8.994 8.994 0 0 0 7.03-14.61zM13 14h-2V8h2v6z"
    })), $1fe2a1803f0c20d4$var$Qo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$qo), $1fe2a1803f0c20d4$var$Jo = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zM7 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
    })), $1fe2a1803f0c20d4$var$Xo = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$Jo), $1fe2a1803f0c20d4$var$e0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
    })), $1fe2a1803f0c20d4$var$t0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$e0), $1fe2a1803f0c20d4$var$s0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6 10H6v-2h8v2zm4-4H6v-2h12v2z"
    })), $1fe2a1803f0c20d4$var$a0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$s0), $1fe2a1803f0c20d4$var$n0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "1em",
        viewBox: "0 0 24 24",
        width: "1em",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M13 16v-2h2.77c.08-.32.16-.65.23-1 1.19-5.95 4-6 4-10H4a10.35 10.35 0 0 0 .48 3H8v2H5.26c.32.69.68 1.36 1 2H10v2H7.51A13.86 13.86 0 0 1 9 15a6.24 6.24 0 0 1-1 6l1 1c2.82-1.54 4.85-3.09 6.1-6Z"
    })), $1fe2a1803f0c20d4$var$c0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$n0), $1fe2a1803f0c20d4$var$i0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m12.87 15.07-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7 1.62-4.33L19.12 17h-3.24z"
    })), $1fe2a1803f0c20d4$var$o0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$i0), $1fe2a1803f0c20d4$var$r0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m16 18 2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"
    })), $1fe2a1803f0c20d4$var$l0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$r0), $1fe2a1803f0c20d4$var$h0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m16 6 2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
    })), $1fe2a1803f0c20d4$var$m0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$h0), $1fe2a1803f0c20d4$var$d0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19.912 7.925v.527A11.562 11.562 0 0 1 8.265 20.098 11.443 11.443 0 0 1 2 18.265c.328.017.657.017.985 0a8.132 8.132 0 0 0 5.093-1.698 4.092 4.092 0 0 1-3.786-2.852c.255.062.518.091.781.085.36-.002.72-.047 1.07-.136a4.109 4.109 0 0 1-3.21-4.024c.566.32 1.202.494 1.851.51a4.126 4.126 0 0 1-1.34-5.518 11.613 11.613 0 0 0 8.488 4.295 4.397 4.397 0 0 1-.119-.934 4.092 4.092 0 0 1 4.092-4.092 4.04 4.04 0 0 1 3.005 1.29 7.929 7.929 0 0 0 2.53-1c-.3.953-.94 1.763-1.8 2.274A7.725 7.725 0 0 0 22 5.803a8.489 8.489 0 0 1-2.088 2.122Z",
        fillRule: "evenodd"
    })), $1fe2a1803f0c20d4$var$v0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$d0), $1fe2a1803f0c20d4$var$g0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
    })), $1fe2a1803f0c20d4$var$u0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$g0), $1fe2a1803f0c20d4$var$w0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M7.41 18.59 8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
    })), $1fe2a1803f0c20d4$var$p0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$w0), $1fe2a1803f0c20d4$var$f0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 5.83 15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
    })), $1fe2a1803f0c20d4$var$M0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$f0), $1fe2a1803f0c20d4$var$x0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79s7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58s9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"
    })), $1fe2a1803f0c20d4$var$E0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$x0), $1fe2a1803f0c20d4$var$b0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
    })), $1fe2a1803f0c20d4$var$z0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$b0), $1fe2a1803f0c20d4$var$S0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m23 12-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82L8.6 22.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69L23 12zm-12.91 4.72-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z"
    })), $1fe2a1803f0c20d4$var$_0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$S0), $1fe2a1803f0c20d4$var$C0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
    })), $1fe2a1803f0c20d4$var$N0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$C0), $1fe2a1803f0c20d4$var$y0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
    })), $1fe2a1803f0c20d4$var$L0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$y0), $1fe2a1803f0c20d4$var$k0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46A11.804 11.804 0 0 0 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
    })), $1fe2a1803f0c20d4$var$$0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$k0), $1fe2a1803f0c20d4$var$H0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M16.5 12A4.5 4.5 0 0 0 14 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 0 0 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4 9.91 6.09 12 8.18V4z"
    })), $1fe2a1803f0c20d4$var$V0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$H0), $1fe2a1803f0c20d4$var$B0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
    })), $1fe2a1803f0c20d4$var$O0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$B0), $1fe2a1803f0c20d4$var$A0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M18.5 8A2.5 2.5 0 0 0 21 5.5C21 3.83 18.5 1 18.5 1S16 3.83 16 5.5A2.5 2.5 0 0 0 18.5 8zm-5 1c.83 0 1.5-.67 1.5-1.5 0-.84-1.5-2.5-1.5-2.5S12 6.66 12 7.5c0 .83.67 1.5 1.5 1.5zM9.12 5l-7.18 6.79c-.6.56-.94 1.35-.94 2.18V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 0 0 0-2.5H12v-1h7.75a1.25 1.25 0 0 0 0-2.5H12v-1h8.75a1.25 1.25 0 0 0 0-2.5H12v-1h6.75a1.25 1.25 0 0 0 0-2.5H8.86c.64-1.11 1.48-2.58 1.49-2.61a1.065 1.065 0 0 0-.12-1.23C10.22 6.12 9.12 5 9.12 5z"
    })), $1fe2a1803f0c20d4$var$D0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$A0), $1fe2a1803f0c20d4$var$T0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m1 9 2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8 3 3 3-3a4.237 4.237 0 0 0-6 0zm-4-4 2 2a7.074 7.074 0 0 1 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"
    })), $1fe2a1803f0c20d4$var$F0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$T0), $1fe2a1803f0c20d4$var$P0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
    })), $1fe2a1803f0c20d4$var$R0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$P0), $1fe2a1803f0c20d4$var$U0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M13.522 10.775 19.48 4h-1.412l-5.172 5.883L8.765 4H4l6.247 8.895L4 20h1.412l5.461-6.212L15.236 20H20l-6.478-9.225Zm-1.933 2.199-.633-.886L5.92 5.04h2.168l4.064 5.688.633.886 5.283 7.394H15.9l-4.311-6.034Z"
    })), $1fe2a1803f0c20d4$var$Y0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$U0), $1fe2a1803f0c20d4$var$W0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M19.816 5.389a2.469 2.469 0 0 1 1.766 1.746c.291 1.598.43 3.22.417 4.843a25.867 25.867 0 0 1-.417 4.794 2.468 2.468 0 0 1-1.766 1.795c-2.593.318-5.204.46-7.816.429a58.411 58.411 0 0 1-7.816-.429 2.469 2.469 0 0 1-1.766-1.746 25.879 25.879 0 0 1-.417-4.843 25.85 25.85 0 0 1 .417-4.793 2.468 2.468 0 0 1 1.766-1.796c2.594-.3 5.205-.427 7.816-.379a58.413 58.413 0 0 1 7.816.379ZM9.95 9.046v5.864l5.233-2.932L9.95 9.046Z"
    })), $1fe2a1803f0c20d4$var$K0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$W0), $1fe2a1803f0c20d4$var$I0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }), /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
    })), $1fe2a1803f0c20d4$var$Z0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$I0), $1fe2a1803f0c20d4$var$G0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "m15 3 2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3h-6zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3v6zm6 12-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6h6zm12-6-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6v-6z"
    })), $1fe2a1803f0c20d4$var$j0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$G0), $1fe2a1803f0c20d4$var$q0 = (e)=>/* @__PURE__ */ $3RyIS.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        ...e
    }, /* @__PURE__ */ $3RyIS.createElement("path", {
        d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
    })), $1fe2a1803f0c20d4$var$Q0 = (0, $3RyIS.memo)($1fe2a1803f0c20d4$var$q0), $1fe2a1803f0c20d4$var$h = (e)=>{
    const s = (a)=>{
        const { size: n, className: i, focusable: r = !1, role: o = "img", ...v } = a, u = {
            className: $1fe2a1803f0c20d4$var$g("usa-icon", {
                [`usa-icon--size-${n}`]: n !== void 0
            }, i),
            focusable: r,
            role: o,
            ...v
        };
        return o === "img" && !v["aria-hidden"] && !v["aria-label"] && !v["aria-labelledby"] && console.warn("Icon with img role is missing an accessible label. https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Img_role#associated_wai-aria_roles_states_and_properties"), /* @__PURE__ */ (0, $21sFD.jsx)(e, {
            ...u
        });
    };
    return s.displayName = e.displayName, s;
}, $1fe2a1803f0c20d4$var$l = class l {
};
$1fe2a1803f0c20d4$var$l.AccessibilityNew = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Qt), $1fe2a1803f0c20d4$var$l.AccessibleForward = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Xt), $1fe2a1803f0c20d4$var$l.AccountBalance = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$t1), $1fe2a1803f0c20d4$var$l.AccountBox = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$a1), $1fe2a1803f0c20d4$var$l.AccountCircle = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$c1), $1fe2a1803f0c20d4$var$l.Add = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$o1), $1fe2a1803f0c20d4$var$l.AddCircle = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$l1), $1fe2a1803f0c20d4$var$l.AddCircleOutline = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$m1), $1fe2a1803f0c20d4$var$l.Alarm = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$v1), $1fe2a1803f0c20d4$var$l.AlternateEmail = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$u1), $1fe2a1803f0c20d4$var$l.Announcement = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$p1), $1fe2a1803f0c20d4$var$l.ArrowBack = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$M1), $1fe2a1803f0c20d4$var$l.ArrowDownward = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$E1), $1fe2a1803f0c20d4$var$l.ArrowDropDown = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$z1), $1fe2a1803f0c20d4$var$l.ArrowDropUp = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$_1), $1fe2a1803f0c20d4$var$l.ArrowForward = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$N1), $1fe2a1803f0c20d4$var$l.ArrowUpward = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$L1), $1fe2a1803f0c20d4$var$l.Api = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$$1), $1fe2a1803f0c20d4$var$l.Assessment = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$V1), $1fe2a1803f0c20d4$var$l.AttachFile = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$O1), $1fe2a1803f0c20d4$var$l.AttachMoney = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$D1), $1fe2a1803f0c20d4$var$l.Autorenew = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$F1), $1fe2a1803f0c20d4$var$l.Backpack = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$R1), $1fe2a1803f0c20d4$var$l.Bathtub = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Y1), $1fe2a1803f0c20d4$var$l.Bedding = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$K1), $1fe2a1803f0c20d4$var$l.Bookmark = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Z1), $1fe2a1803f0c20d4$var$l.BugReport = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$j1), $1fe2a1803f0c20d4$var$l.Build = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Q1), $1fe2a1803f0c20d4$var$l.CalendarToday = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$X1), $1fe2a1803f0c20d4$var$l.Campaign = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ts), $1fe2a1803f0c20d4$var$l.Camping = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$as), $1fe2a1803f0c20d4$var$l.Cancel = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$cs), $1fe2a1803f0c20d4$var$l.Chat = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$os), $1fe2a1803f0c20d4$var$l.Check = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ls), $1fe2a1803f0c20d4$var$l.CheckBoxOutlineBlank = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ms), $1fe2a1803f0c20d4$var$l.CheckCircle = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$vs), $1fe2a1803f0c20d4$var$l.CheckCircleOutline = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$us), $1fe2a1803f0c20d4$var$l.Checkroom = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ps), $1fe2a1803f0c20d4$var$l.CleanHands = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ms), $1fe2a1803f0c20d4$var$l.Clothes = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Es), $1fe2a1803f0c20d4$var$l.Close = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$zs), $1fe2a1803f0c20d4$var$l.ClosedCaption = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$_s), $1fe2a1803f0c20d4$var$l.Cloud = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ns), $1fe2a1803f0c20d4$var$l.Code = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ls), $1fe2a1803f0c20d4$var$l.Comment = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$$s), $1fe2a1803f0c20d4$var$l.ConnectWithoutContact = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Vs), $1fe2a1803f0c20d4$var$l.Construction = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Os), $1fe2a1803f0c20d4$var$l.ConstructionWorker = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ds), $1fe2a1803f0c20d4$var$l.ContactPage = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Fs), $1fe2a1803f0c20d4$var$l.ContentCopy = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Rs), $1fe2a1803f0c20d4$var$l.Coronavirus = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ys), $1fe2a1803f0c20d4$var$l.CreditCard = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ks), $1fe2a1803f0c20d4$var$l.Deck = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Zs), $1fe2a1803f0c20d4$var$l.Delete = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$js), $1fe2a1803f0c20d4$var$l.DeviceThermostat = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Qs), $1fe2a1803f0c20d4$var$l.Directions = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Xs), $1fe2a1803f0c20d4$var$l.DirectionsBike = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ta), $1fe2a1803f0c20d4$var$l.DirectionsBus = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$aa), $1fe2a1803f0c20d4$var$l.DirectionsCar = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ca), $1fe2a1803f0c20d4$var$l.DirectionsWalk = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$oa), $1fe2a1803f0c20d4$var$l.DoNotDisturb = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$la), $1fe2a1803f0c20d4$var$l.DoNotTouch = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ma), $1fe2a1803f0c20d4$var$l.DragHandle = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$va), $1fe2a1803f0c20d4$var$l.Eco = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ua), $1fe2a1803f0c20d4$var$l.Edit = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$pa), $1fe2a1803f0c20d4$var$l.ElectricalServices = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ma), $1fe2a1803f0c20d4$var$l.EmojiEvents = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ea), $1fe2a1803f0c20d4$var$l.Error = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$za), $1fe2a1803f0c20d4$var$l.ErrorOutline = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$_a), $1fe2a1803f0c20d4$var$l.Event = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Na), $1fe2a1803f0c20d4$var$l.ExpandLess = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$La), $1fe2a1803f0c20d4$var$l.ExpandMore = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$$a), $1fe2a1803f0c20d4$var$l.Facebook = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Va), $1fe2a1803f0c20d4$var$l.FastForward = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Oa), $1fe2a1803f0c20d4$var$l.FastRewind = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Da), $1fe2a1803f0c20d4$var$l.Favorite = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Fa), $1fe2a1803f0c20d4$var$l.FavoriteBorder = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ra), $1fe2a1803f0c20d4$var$l.Fax = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ya), $1fe2a1803f0c20d4$var$l.FileDownload = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ka), $1fe2a1803f0c20d4$var$l.FilePresent = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Za), $1fe2a1803f0c20d4$var$l.FileUpload = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ja), $1fe2a1803f0c20d4$var$l.FilterAlt = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Qa), $1fe2a1803f0c20d4$var$l.FilterList = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Xa), $1fe2a1803f0c20d4$var$l.Fingerprint = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$t2), $1fe2a1803f0c20d4$var$l.FirstPage = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$a2), $1fe2a1803f0c20d4$var$l.Flag = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$c2), $1fe2a1803f0c20d4$var$l.Flickr = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$o2), $1fe2a1803f0c20d4$var$l.Flight = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$l2), $1fe2a1803f0c20d4$var$l.Flooding = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$m2), $1fe2a1803f0c20d4$var$l.Folder = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$v2), $1fe2a1803f0c20d4$var$l.FolderOpen = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$u2), $1fe2a1803f0c20d4$var$l.FormatQuote = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$p2), $1fe2a1803f0c20d4$var$l.FormatSize = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$M2), $1fe2a1803f0c20d4$var$l.Forum = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$E2), $1fe2a1803f0c20d4$var$l.Github = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$z2), $1fe2a1803f0c20d4$var$l.GridView = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$_2), $1fe2a1803f0c20d4$var$l.GroupAdd = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$N2), $1fe2a1803f0c20d4$var$l.Groups = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$L2), $1fe2a1803f0c20d4$var$l.Hearing = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$$2), $1fe2a1803f0c20d4$var$l.Help = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$V2), $1fe2a1803f0c20d4$var$l.HelpOutline = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$O2), $1fe2a1803f0c20d4$var$l.HighlightOff = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$D2), $1fe2a1803f0c20d4$var$l.History = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$F2), $1fe2a1803f0c20d4$var$l.Home = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$R2), $1fe2a1803f0c20d4$var$l.Hospital = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Y2), $1fe2a1803f0c20d4$var$l.Hotel = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$K2), $1fe2a1803f0c20d4$var$l.HourglassEmpty = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Z2), $1fe2a1803f0c20d4$var$l.Hurricane = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$j2), $1fe2a1803f0c20d4$var$l.Identification = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Q2), $1fe2a1803f0c20d4$var$l.Image = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$X2), $1fe2a1803f0c20d4$var$l.Info = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$tn), $1fe2a1803f0c20d4$var$l.InfoOutline = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$an), $1fe2a1803f0c20d4$var$l.Insights = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$cn), $1fe2a1803f0c20d4$var$l.Instagram = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$rn), $1fe2a1803f0c20d4$var$l.Keyboard = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$hn), $1fe2a1803f0c20d4$var$l.Label = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$dn), $1fe2a1803f0c20d4$var$l.Language = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$gn), $1fe2a1803f0c20d4$var$l.LastPage = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$wn), $1fe2a1803f0c20d4$var$l.Launch = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$fn), $1fe2a1803f0c20d4$var$l.Lightbulb = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$xn), $1fe2a1803f0c20d4$var$l.LightbulbOutline = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$bn), $1fe2a1803f0c20d4$var$l.LinkedIn = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Sn), $1fe2a1803f0c20d4$var$l.Link = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Cn), $1fe2a1803f0c20d4$var$l.LinkOff = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$yn), $1fe2a1803f0c20d4$var$l.List = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$kn), $1fe2a1803f0c20d4$var$l.LocalCafe = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Hn), $1fe2a1803f0c20d4$var$l.LocalFireDepartment = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Bn), $1fe2a1803f0c20d4$var$l.LocalGasStation = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$An), $1fe2a1803f0c20d4$var$l.LocalGroceryStore = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Tn), $1fe2a1803f0c20d4$var$l.LocalHospital = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Pn), $1fe2a1803f0c20d4$var$l.LocalLaundryService = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Un), $1fe2a1803f0c20d4$var$l.LocalLibrary = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Wn), $1fe2a1803f0c20d4$var$l.LocalOffer = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$In), $1fe2a1803f0c20d4$var$l.LocalParking = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Gn), $1fe2a1803f0c20d4$var$l.LocalPharmacy = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$qn), $1fe2a1803f0c20d4$var$l.LocalPolice = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Jn), $1fe2a1803f0c20d4$var$l.LocalTaxi = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ec), $1fe2a1803f0c20d4$var$l.LocationCity = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$sc), $1fe2a1803f0c20d4$var$l.LocationOn = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$nc), $1fe2a1803f0c20d4$var$l.Lock = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ic), $1fe2a1803f0c20d4$var$l.LockOpen = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$rc), $1fe2a1803f0c20d4$var$l.LockOutline = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$hc), $1fe2a1803f0c20d4$var$l.Login = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$dc), $1fe2a1803f0c20d4$var$l.Logout = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$gc), $1fe2a1803f0c20d4$var$l.Loop = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$wc), $1fe2a1803f0c20d4$var$l.Mail = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$fc), $1fe2a1803f0c20d4$var$l.MailOutline = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$xc), $1fe2a1803f0c20d4$var$l.Map = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$bc), $1fe2a1803f0c20d4$var$l.Masks = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Sc), $1fe2a1803f0c20d4$var$l.MedicalServices = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Cc), $1fe2a1803f0c20d4$var$l.Menu = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$yc), $1fe2a1803f0c20d4$var$l.MilitaryTech = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$kc), $1fe2a1803f0c20d4$var$l.MoreHoriz = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Hc), $1fe2a1803f0c20d4$var$l.MoreVert = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Bc), $1fe2a1803f0c20d4$var$l.MyLocation = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ac), $1fe2a1803f0c20d4$var$l.NavigateBefore = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Tc), $1fe2a1803f0c20d4$var$l.NavigateNext = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Pc), $1fe2a1803f0c20d4$var$l.NavigateFarBefore = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Uc), $1fe2a1803f0c20d4$var$l.NavigateFarNext = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Wc), $1fe2a1803f0c20d4$var$l.NearMe = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ic), $1fe2a1803f0c20d4$var$l.Notifications = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Gc), $1fe2a1803f0c20d4$var$l.NotificationsActive = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$qc), $1fe2a1803f0c20d4$var$l.NotificationsNone = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Jc), $1fe2a1803f0c20d4$var$l.NotificationsOff = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ei), $1fe2a1803f0c20d4$var$l.Park = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$si), $1fe2a1803f0c20d4$var$l.People = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ni), $1fe2a1803f0c20d4$var$l.Person = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ii), $1fe2a1803f0c20d4$var$l.Pets = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ri), $1fe2a1803f0c20d4$var$l.Phone = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$hi), $1fe2a1803f0c20d4$var$l.PhotoCamera = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$di), $1fe2a1803f0c20d4$var$l.Print = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$gi), $1fe2a1803f0c20d4$var$l.PriorityHigh = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$wi), $1fe2a1803f0c20d4$var$l.Public = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$fi), $1fe2a1803f0c20d4$var$l.PushPin = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$xi), $1fe2a1803f0c20d4$var$l.RadioButtonUnchecked = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$bi), $1fe2a1803f0c20d4$var$l.Rain = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Si), $1fe2a1803f0c20d4$var$l.ReduceCapacity = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ci), $1fe2a1803f0c20d4$var$l.RemoveCircle = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$yi), $1fe2a1803f0c20d4$var$l.Remove = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ki), $1fe2a1803f0c20d4$var$l.Report = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Hi), $1fe2a1803f0c20d4$var$l.Restaurant = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Bi), $1fe2a1803f0c20d4$var$l.RssFeed = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ai), $1fe2a1803f0c20d4$var$l.SafetyDivider = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ti), $1fe2a1803f0c20d4$var$l.Sanitizer = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Pi), $1fe2a1803f0c20d4$var$l.SaveAlt = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ui), $1fe2a1803f0c20d4$var$l.SevereWeather = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Wi), $1fe2a1803f0c20d4$var$l.Schedule = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ii), $1fe2a1803f0c20d4$var$l.School = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Gi), $1fe2a1803f0c20d4$var$l.Science = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$qi), $1fe2a1803f0c20d4$var$l.Search = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ji), $1fe2a1803f0c20d4$var$l.Security = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$eo), $1fe2a1803f0c20d4$var$l.Send = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$so), $1fe2a1803f0c20d4$var$l.SentimentDissatisfied = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$no), $1fe2a1803f0c20d4$var$l.SentimentNeutral = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$io), $1fe2a1803f0c20d4$var$l.SentimentSatisfied = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ro), $1fe2a1803f0c20d4$var$l.SentimentSatisfiedAlt = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$ho), $1fe2a1803f0c20d4$var$l.SentimentVeryDissatisfied = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$vo), $1fe2a1803f0c20d4$var$l.Settings = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$uo), $1fe2a1803f0c20d4$var$l.Share = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$po), $1fe2a1803f0c20d4$var$l.Shield = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Mo), $1fe2a1803f0c20d4$var$l.ShoppingBasket = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Eo), $1fe2a1803f0c20d4$var$l.Snow = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$zo), $1fe2a1803f0c20d4$var$l.Soap = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$_o), $1fe2a1803f0c20d4$var$l.SocialDistance = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$No), $1fe2a1803f0c20d4$var$l.SortArrow = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Lo), $1fe2a1803f0c20d4$var$l.Spellcheck = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$$o), $1fe2a1803f0c20d4$var$l.Star = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Vo), $1fe2a1803f0c20d4$var$l.StarHalf = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Oo), $1fe2a1803f0c20d4$var$l.StarOutline = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Do), $1fe2a1803f0c20d4$var$l.Store = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Fo), $1fe2a1803f0c20d4$var$l.Support = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ro), $1fe2a1803f0c20d4$var$l.SupportAgent = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Yo), $1fe2a1803f0c20d4$var$l.TextFields = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Ko), $1fe2a1803f0c20d4$var$l.ThumbDownAlt = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Zo), $1fe2a1803f0c20d4$var$l.ThumbUpAlt = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$jo), $1fe2a1803f0c20d4$var$l.Timer = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Qo), $1fe2a1803f0c20d4$var$l.ToggleOff = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Xo), $1fe2a1803f0c20d4$var$l.ToggleOn = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$t0), $1fe2a1803f0c20d4$var$l.Topic = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$a0), $1fe2a1803f0c20d4$var$l.Tornado = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$c0), $1fe2a1803f0c20d4$var$l.Translate = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$o0), $1fe2a1803f0c20d4$var$l.TrendingDown = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$l0), $1fe2a1803f0c20d4$var$l.TrendingUp = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$m0), $1fe2a1803f0c20d4$var$l.Twitter = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$v0), $1fe2a1803f0c20d4$var$l.Undo = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$u0), $1fe2a1803f0c20d4$var$l.UnfoldLess = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$p0), $1fe2a1803f0c20d4$var$l.UnfoldMore = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$M0), $1fe2a1803f0c20d4$var$l.Update = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$E0), $1fe2a1803f0c20d4$var$l.UploadFile = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$z0), $1fe2a1803f0c20d4$var$l.Verified = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$_0), $1fe2a1803f0c20d4$var$l.VerifiedUser = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$N0), $1fe2a1803f0c20d4$var$l.Visibility = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$L0), $1fe2a1803f0c20d4$var$l.VisibilityOff = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$$0), $1fe2a1803f0c20d4$var$l.VolumeOff = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$V0), $1fe2a1803f0c20d4$var$l.Warning = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$O0), $1fe2a1803f0c20d4$var$l.Wash = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$D0), $1fe2a1803f0c20d4$var$l.Wifi = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$F0), $1fe2a1803f0c20d4$var$l.Work = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$R0), $1fe2a1803f0c20d4$var$l.X = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Y0), $1fe2a1803f0c20d4$var$l.Youtube = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$K0), $1fe2a1803f0c20d4$var$l.ZoomIn = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Z0), $1fe2a1803f0c20d4$var$l.ZoomOutMap = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$j0), $1fe2a1803f0c20d4$var$l.ZoomOut = $1fe2a1803f0c20d4$var$h($1fe2a1803f0c20d4$var$Q0);
let $1fe2a1803f0c20d4$export$f04a61298a47a40f = $1fe2a1803f0c20d4$var$l;
const $1fe2a1803f0c20d4$var$J0 = ({ page: e, isCurrent: s, pathname: a, onClickPageNumber: n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-pagination__button", {
        "usa-current": s
    });
    return /* @__PURE__ */ (0, $21sFD.jsx)("li", {
        className: "usa-pagination__item usa-pagination__page-no",
        children: n ? /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$353f5b6fc5456de1, {
            type: "button",
            unstyled: !0,
            "data-testid": "pagination-page-number",
            className: i,
            "aria-label": `Page ${e}`,
            "aria-current": s ? "page" : void 0,
            onClick: (r)=>{
                n(r, e);
            },
            children: e
        }) : /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$a6c7ac8248d6e38a, {
            href: `${a}?page=${e}`,
            className: i,
            "aria-label": `Page ${e}`,
            "aria-current": s ? "page" : void 0,
            children: e
        })
    }, `pagination_page_${e}`);
}, $1fe2a1803f0c20d4$var$X0 = ()=>/* @__PURE__ */ (0, $21sFD.jsx)("li", {
        className: "usa-pagination__item usa-pagination__overflow",
        "aria-label": "ellipsis indicating non-visible pages",
        children: /* @__PURE__ */ (0, $21sFD.jsx)("span", {
            children: "\u2026"
        })
    }), $1fe2a1803f0c20d4$export$68f5e1453c188a82 = ({ pathname: e, totalPages: s, currentPage: a, className: n, maxSlots: i = 7, onClickPrevious: r, onClickNext: o, onClickPageNumber: v, ...d })=>{
    const u = $1fe2a1803f0c20d4$var$g("usa-pagination", n), w = a === 1, f = s ? a === s : !1, _ = s ? s > i : !0, k = Math.round(i / 2), b = !!(s && s - a >= k), M = _ && a > k, B = b || !s, x = _ || !s ? [
        a
    ] : Array.from({
        length: s
    }).map((N, A)=>A + 1);
    if (_) {
        const N = w ? 0 : M ? 2 : 1, A = f ? 0 : B ? 2 : 1, V = i - 1 - (N + A);
        let E = 0, S = 0;
        M && B ? (E = Math.round((V - 1) / 2), S = V - E) : M ? (S = (s || 0) - a - 1, S = S < 0 ? 0 : S, E = V - S) : B && (E = a - 2, E = E < 0 ? 0 : E, S = V - E);
        let L = 1;
        for(; E > 0;)x.unshift(a - L), L++, E--;
        for(L = 1; S > 0;)x.push(a + L), L++, S--;
        M && x.unshift("overflow"), a !== 1 && x.unshift(1), B && x.push("overflow"), s && a !== s && x.push(s);
    }
    const $ = !w && a - 1, p = !f && a + 1;
    return /* @__PURE__ */ (0, $21sFD.jsx)("nav", {
        "aria-label": "Pagination",
        className: u,
        ...d,
        children: /* @__PURE__ */ (0, $21sFD.jsxs)("ul", {
            className: "usa-pagination__list",
            children: [
                $ && /* @__PURE__ */ (0, $21sFD.jsx)("li", {
                    className: "usa-pagination__item usa-pagination__arrow",
                    children: r ? /* @__PURE__ */ (0, $21sFD.jsxs)($1fe2a1803f0c20d4$export$353f5b6fc5456de1, {
                        type: "button",
                        unstyled: !0,
                        className: "usa-pagination__link usa-pagination__previous-page",
                        "aria-label": "Previous page",
                        "data-testid": "pagination-previous",
                        onClick: r,
                        children: [
                            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$f04a61298a47a40f.NavigateBefore, {
                                "aria-hidden": !0
                            }),
                            /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                                className: "usa-pagination__link-text",
                                children: "Previous"
                            })
                        ]
                    }) : /* @__PURE__ */ (0, $21sFD.jsxs)($1fe2a1803f0c20d4$export$a6c7ac8248d6e38a, {
                        href: `${e}?page=${$}`,
                        className: "usa-pagination__link usa-pagination__previous-page",
                        "aria-label": "Previous page",
                        children: [
                            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$f04a61298a47a40f.NavigateBefore, {
                                "aria-hidden": !0
                            }),
                            /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                                className: "usa-pagination__link-text",
                                children: "Previous"
                            })
                        ]
                    })
                }),
                x.map((N, A)=>N === "overflow" ? /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$X0, {}, `pagination_overflow_${A}`) : /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$J0, {
                        page: N,
                        pathname: e,
                        isCurrent: N === a,
                        onClickPageNumber: v
                    }, `pagination_page_${N}`)),
                p && /* @__PURE__ */ (0, $21sFD.jsx)("li", {
                    className: "usa-pagination__item usa-pagination__arrow",
                    children: o ? /* @__PURE__ */ (0, $21sFD.jsxs)($1fe2a1803f0c20d4$export$353f5b6fc5456de1, {
                        type: "button",
                        unstyled: !0,
                        className: "usa-pagination__link usa-pagination__next-page",
                        "aria-label": "Next page",
                        "data-testid": "pagination-next",
                        onClick: o,
                        children: [
                            /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                                className: "usa-pagination__link-text",
                                children: "Next"
                            }),
                            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$f04a61298a47a40f.NavigateNext, {
                                "aria-hidden": !0
                            })
                        ]
                    }) : /* @__PURE__ */ (0, $21sFD.jsxs)($1fe2a1803f0c20d4$export$a6c7ac8248d6e38a, {
                        href: `${e}?page=${p}`,
                        className: "usa-pagination__link usa-pagination__next-page",
                        "aria-label": "Next page",
                        children: [
                            /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                                className: "usa-pagination__link-text",
                                children: "Next"
                            }),
                            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$f04a61298a47a40f.NavigateNext, {
                                "aria-hidden": !0
                            })
                        ]
                    })
                })
            ]
        })
    });
}, $1fe2a1803f0c20d4$export$3b4e64e77073e307 = ({ children: e, divProps: s, className: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-banner", a), { className: r, ...o } = s || {}, v = $1fe2a1803f0c20d4$var$g("usa-accordion", r);
    return /* @__PURE__ */ (0, $21sFD.jsx)("section", {
        className: i,
        ...n,
        children: /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            className: v,
            ...o,
            children: e
        })
    });
}, $1fe2a1803f0c20d4$export$fa7e947fd004b381 = ({ isOpen: e, children: s, className: a, spanProps: n, ...i })=>{
    const r = $1fe2a1803f0c20d4$var$g("usa-accordion__button usa-banner__button", a), { className: o, ...v } = n || {}, d = $1fe2a1803f0c20d4$var$g("usa-banner__button-text", o);
    return /* @__PURE__ */ (0, $21sFD.jsx)("button", {
        type: "button",
        className: r,
        "aria-expanded": e,
        ...i,
        children: /* @__PURE__ */ (0, $21sFD.jsx)("span", {
            className: d,
            ...v,
            children: s
        })
    });
}, $1fe2a1803f0c20d4$export$1c91e5dc5ea848c6 = ({ children: e, isOpen: s, className: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-banner__content usa-accordion__content", a);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: i,
        hidden: !s,
        ...n,
        children: e
    });
}, $1fe2a1803f0c20d4$export$23a1ecb99a79c2b0 = ({ alt: e, className: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-banner__header-flag", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("img", {
        className: n,
        alt: e,
        ...a
    });
}, $1fe2a1803f0c20d4$export$da58138b7f8a73ff = ({ children: e, className: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-banner__guidance", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: n,
        ...a,
        children: e
    });
}, $1fe2a1803f0c20d4$export$72e85ab5dabbfb7c = ({ children: e, isOpen: s, flagImg: a, innerDivProps: n, headerText: i, headerTextProps: r, headerActionText: o, headerActionProps: v, className: d, ...u })=>{
    const w = $1fe2a1803f0c20d4$var$g("usa-banner__header", {
        "usa-banner__header--expanded": s
    }, d), { className: f, ..._ } = n || {}, k = $1fe2a1803f0c20d4$var$g("usa-banner__inner", f), { className: b, ...M } = r || {}, B = $1fe2a1803f0c20d4$var$g("usa-banner__header-text", b), { className: x, ...$ } = v || {}, p = $1fe2a1803f0c20d4$var$g("usa-banner__header-action", x);
    return /* @__PURE__ */ (0, $21sFD.jsx)("header", {
        className: w,
        ...u,
        children: /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
            className: k,
            ..._,
            "data-testid": "banner-header-inner-div",
            children: [
                a && /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                    className: "grid-col-auto",
                    "data-testid": "banner-header-flag-div",
                    children: a
                }),
                /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
                    className: "grid-col-fill tablet:grid-col-auto",
                    "aria-hidden": !0,
                    "data-testid": "banner-header-grid-div",
                    children: [
                        /* @__PURE__ */ (0, $21sFD.jsx)("p", {
                            className: B,
                            ...M,
                            children: i
                        }),
                        /* @__PURE__ */ (0, $21sFD.jsx)("p", {
                            className: p,
                            "aria-hidden": "true",
                            ...$,
                            children: o
                        })
                    ]
                }),
                e
            ]
        })
    });
}, $1fe2a1803f0c20d4$export$9217ca52f16e0cac = ({ src: e, alt: s, className: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-banner__icon usa-media-block__img", a);
    return /* @__PURE__ */ (0, $21sFD.jsx)("img", {
        className: i,
        src: e,
        alt: s,
        "aria-hidden": "true",
        ...n
    });
}, $1fe2a1803f0c20d4$var$cr = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAsBAMAAAAncaPMAAAAAXNSR0IArs4c6QAAABtQTFRF////4EAg2z8g2z8f2z4f2j4fHjSyHjOxHTOxQEYPwgAAAIdJREFUeNrNkUENxDAMBEOhFJaCKZiCKZhCKBj2ebV3rdR71+pIq+Qxj1GyqjJ3U8VlHkc07hFm0awBYe91juq6MSI0yhSAEgkzJ4TMKiXyzFw3pgR9lmIBJlqj2AmBedf+IycExmlKZVzvZEJ4A0oBrjBl/m6PCy95B3fFAN6YuQPxhbcB4QMkEj04wQXD5wAAAABJRU5ErkJggg==", $1fe2a1803f0c20d4$var$ir = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='64'%20height='64'%20viewBox='0%200%2064%2064'%3e%3ctitle%3eicon-dot-gov%3c/title%3e%3cpath%20fill='%232378C3'%20fill-rule='evenodd'%20d='m32%200c17.7%200%2032%2014.3%2032%2032s-14.3%2032-32%2032-32-14.3-32-32%2014.3-32%2032-32zm0%201.2c-17%200-30.8%2013.8-30.8%2030.8s13.8%2030.8%2030.8%2030.8%2030.8-13.8%2030.8-30.8-13.8-30.8-30.8-30.8zm11.4%2038.9c.5%200%20.9.4.9.8v1.6h-24.6v-1.6c0-.5.4-.8.9-.8zm-17.1-12.3v9.8h1.6v-9.8h3.3v9.8h1.6v-9.8h3.3v9.8h1.6v-9.8h3.3v9.8h.8c.5%200%20.9.4.9.8v.8h-21.4v-.8c0-.5.4-.8.9-.8h.8v-9.8zm5.7-8.2%2012.3%204.9v1.6h-1.6c0%20.5-.4.8-.9.8h-19.6c-.5%200-.9-.4-.9-.8h-1.6v-1.6s12.3-4.9%2012.3-4.9z'/%3e%3c/svg%3e", $1fe2a1803f0c20d4$var$or = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='64'%20height='64'%20viewBox='0%200%2064%2064'%3e%3ctitle%3eicon-https%3c/title%3e%3cpath%20fill='%23719F2A'%20fill-rule='evenodd'%20d='M32%200c17.673%200%2032%2014.327%2032%2032%200%2017.673-14.327%2032-32%2032C14.327%2064%200%2049.673%200%2032%200%2014.327%2014.327%200%2032%200zm0%201.208C14.994%201.208%201.208%2014.994%201.208%2032S14.994%2062.792%2032%2062.792%2062.792%2049.006%2062.792%2032%2049.006%201.208%2032%201.208zm0%2018.886a7.245%207.245%200%200%201%207.245%207.245v3.103h.52c.86%200%201.557.698%201.557%201.558v9.322c0%20.86-.697%201.558-1.557%201.558h-15.53c-.86%200-1.557-.697-1.557-1.558V32c0-.86.697-1.558%201.557-1.558h.52V27.34A7.245%207.245%200%200%201%2032%2020.094zm0%203.103a4.142%204.142%200%200%200-4.142%204.142v3.103h8.284V27.34A4.142%204.142%200%200%200%2032%2023.197z'/%3e%3c/svg%3e", $1fe2a1803f0c20d4$var$rr = (e, s)=>{
    switch(e){
        case "english":
            return {
                header: "An official website of the United States government",
                ariaLabel: "Official website of the United States government",
                headerAction: "Here\u2019s how you know",
                tldSectionHeader: `Official websites use ${s}`,
                tldSectionContent: (()=>{
                    switch(s){
                        case ".gov":
                            return /* @__PURE__ */ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
                                children: [
                                    "A ",
                                    /* @__PURE__ */ (0, $21sFD.jsx)("strong", {
                                        children: ".gov"
                                    }),
                                    " website belongs to an official government organization in the United States."
                                ]
                            });
                        case ".mil":
                            return /* @__PURE__ */ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
                                children: [
                                    "A ",
                                    /* @__PURE__ */ (0, $21sFD.jsx)("strong", {
                                        children: ".mil"
                                    }),
                                    " website belongs to an official U.S. Department of Defense organization."
                                ]
                            });
                    }
                })(),
                httpsSectionHeader: `Secure ${s} websites use HTTPS`,
                httpsSectionContent: /* @__PURE__ */ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
                    children: [
                        "A",
                        " ",
                        /* @__PURE__ */ (0, $21sFD.jsxs)("strong", {
                            children: [
                                "lock (",
                                /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$f04a61298a47a40f.Lock, {
                                    "aria-label": "Locked padlock icon"
                                }),
                                ")"
                            ]
                        }),
                        " ",
                        "or ",
                        /* @__PURE__ */ (0, $21sFD.jsx)("strong", {
                            children: "https://"
                        }),
                        " means you\u2019ve safely connected to the",
                        " ",
                        s,
                        " website. Share sensitive information only on official, secure websites."
                    ]
                })
            };
        case "spanish":
            return {
                header: "Un sitio oficial del Gobierno de Estados Unidos",
                ariaLabel: "Un sitio oficial del Gobierno de Estados Unidos",
                headerAction: "As\xed es como usted puede verificarlo",
                tldSectionHeader: `Los sitios web oficiales usan ${s}`,
                tldSectionContent: (()=>{
                    switch(s){
                        case ".gov":
                            return /* @__PURE__ */ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
                                children: [
                                    "Un sitio web ",
                                    /* @__PURE__ */ (0, $21sFD.jsx)("strong", {
                                        children: ".gov"
                                    }),
                                    " pertenece a una organizaci\xf3n oficial del Gobierno de Estados Unidos."
                                ]
                            });
                        case ".mil":
                            return /* @__PURE__ */ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
                                children: [
                                    "Un sitio web ",
                                    /* @__PURE__ */ (0, $21sFD.jsx)("strong", {
                                        children: ".mil"
                                    }),
                                    " pertenece a una organizaci\xf3n oficial del Departamento de Defensa de EE. UU."
                                ]
                            });
                    }
                })(),
                httpsSectionHeader: `Los sitios web seguros ${s} usan HTTPS`,
                httpsSectionContent: /* @__PURE__ */ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
                    children: [
                        "Un",
                        " ",
                        /* @__PURE__ */ (0, $21sFD.jsxs)("strong", {
                            children: [
                                "candado (",
                                /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$f04a61298a47a40f.Lock, {
                                    "aria-label": "Icono de candado cerrado"
                                }),
                                ")"
                            ]
                        }),
                        " ",
                        "o ",
                        /* @__PURE__ */ (0, $21sFD.jsx)("strong", {
                            children: "https://"
                        }),
                        " significa que usted se conect\xf3 de forma segura a un sitio web ",
                        s,
                        ". Comparta informaci\xf3n sensible s\xf3lo en sitios web oficiales y seguros."
                    ]
                })
            };
    }
}, $1fe2a1803f0c20d4$export$a9b20c64d7557a04 = ({ tld: e = ".gov", language: s = "english", className: a, ...n })=>{
    const [i, r] = (0, $3RyIS.useState)(!1), { header: o, ariaLabel: v, headerAction: d, httpsSectionHeader: u, httpsSectionContent: w, tldSectionHeader: f, tldSectionContent: _ } = $1fe2a1803f0c20d4$var$rr(s, e);
    return /* @__PURE__ */ (0, $21sFD.jsxs)($1fe2a1803f0c20d4$export$3b4e64e77073e307, {
        className: a,
        "data-testid": "govBanner",
        "aria-label": v,
        ...n,
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$72e85ab5dabbfb7c, {
                isOpen: i,
                flagImg: /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$23a1ecb99a79c2b0, {
                    src: $1fe2a1803f0c20d4$var$cr,
                    "aria-hidden": !0,
                    alt: ""
                }),
                headerText: o,
                headerActionText: d,
                children: /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$fa7e947fd004b381, {
                    isOpen: i,
                    "aria-controls": "gov-banner",
                    onClick: ()=>{
                        r((k)=>!k);
                    },
                    children: d
                })
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$1c91e5dc5ea848c6, {
                id: "gov-banner",
                isOpen: i,
                children: /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
                    className: "grid-row grid-gap-lg",
                    children: [
                        /* @__PURE__ */ (0, $21sFD.jsxs)($1fe2a1803f0c20d4$export$da58138b7f8a73ff, {
                            className: "tablet:grid-col-6",
                            children: [
                                /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$9217ca52f16e0cac, {
                                    src: $1fe2a1803f0c20d4$var$ir,
                                    alt: ""
                                }),
                                /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$e727c80ad1303051, {
                                    children: /* @__PURE__ */ (0, $21sFD.jsxs)("p", {
                                        children: [
                                            /* @__PURE__ */ (0, $21sFD.jsx)("strong", {
                                                children: f
                                            }),
                                            /* @__PURE__ */ (0, $21sFD.jsx)("br", {}),
                                            _
                                        ]
                                    })
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, $21sFD.jsxs)($1fe2a1803f0c20d4$export$da58138b7f8a73ff, {
                            className: "tablet:grid-col-6",
                            children: [
                                /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$9217ca52f16e0cac, {
                                    src: $1fe2a1803f0c20d4$var$or,
                                    alt: ""
                                }),
                                /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$e727c80ad1303051, {
                                    children: /* @__PURE__ */ (0, $21sFD.jsxs)("p", {
                                        children: [
                                            /* @__PURE__ */ (0, $21sFD.jsx)("strong", {
                                                children: u
                                            }),
                                            /* @__PURE__ */ (0, $21sFD.jsx)("br", {}),
                                            w
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$fb8073518f34e6ec = ({ children: e, className: s, condensed: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-collection", {
        "usa-collection--condensed": a
    }, s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("ul", {
        className: i,
        "data-testid": "collection",
        ...n,
        children: e
    });
}, $1fe2a1803f0c20d4$export$5b7f4051a57920d0 = ({ className: e, children: s, variantComponent: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-collection__item", e);
    return /* @__PURE__ */ (0, $21sFD.jsxs)("li", {
        className: i,
        ...n,
        children: [
            a,
            /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                className: "usa-collection__body",
                children: s
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$8cec3e91a59bdd9 = ({ headingLevel: e, className: s, children: a, ...n })=>{
    const i = e, r = $1fe2a1803f0c20d4$var$g("usa-collection__heading", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)(i, {
        className: r,
        ...n,
        children: a
    });
}, $1fe2a1803f0c20d4$export$972f5c4cb3d20c9e = ({ className: e, children: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-collection__description", e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("p", {
        className: n,
        ...a,
        children: s
    });
}, $1fe2a1803f0c20d4$export$34959f39b8f12aa4 = ({ className: e, children: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-collection__meta", e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("ul", {
        className: n,
        ...a,
        children: s
    });
}, $1fe2a1803f0c20d4$export$df0211e9e10d0c42 = ({ className: e, children: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-collection__meta-item", e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("li", {
        className: n,
        ...a,
        children: s
    });
}, $1fe2a1803f0c20d4$export$ea5d693752907a31 = ({ className: e, children: s, tagStyle: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-collection__meta-item", "usa-tag", {
        "usa-tag--new": a === "new"
    }, e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("li", {
        className: i,
        ...n,
        children: s
    });
}, $1fe2a1803f0c20d4$export$88de89d4660e70f1 = ({ className: e, src: s, alt: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-collection__img", e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("img", {
        className: i,
        src: s,
        alt: a,
        ...n
    });
}, $1fe2a1803f0c20d4$var$lr = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
], $1fe2a1803f0c20d4$export$21c8981c4ab73ced = ({ datetime: e })=>{
    const s = new Date(e);
    return s && s.getTime && isNaN(s.getTime()) ? /* @__PURE__ */ (0, $21sFD.jsx)((0, $21sFD.Fragment), {}) : /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: "usa-collection__calendar-date",
        "data-testid": "collection-calendar-date",
        children: /* @__PURE__ */ (0, $21sFD.jsxs)("time", {
            dateTime: e,
            children: [
                /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                    className: "usa-collection__calendar-date-month",
                    children: $1fe2a1803f0c20d4$var$lr[s.getMonth()]
                }),
                /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                    className: "usa-collection__calendar-date-day",
                    children: s.getDate()
                })
            ]
        })
    });
};
function $1fe2a1803f0c20d4$var$hr(e) {
    return "asCustom" in e;
}
function $1fe2a1803f0c20d4$var$dt(e, s) {
    return $1fe2a1803f0c20d4$var$g({
        "grid-container": !s,
        [`grid-container-${s}`]: !!s
    }, e);
}
function $1fe2a1803f0c20d4$export$cc55614734af2d87(e) {
    if ($1fe2a1803f0c20d4$var$hr(e)) {
        const { className: s, containerSize: a, asCustom: n, children: i, ...r } = e, o = r, v = $1fe2a1803f0c20d4$var$dt(s, a);
        return (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement(n, {
            "data-testid": "gridContainer",
            className: v,
            ...o
        }, i);
    } else {
        const { className: s, containerSize: a, children: n, ...i } = e, r = $1fe2a1803f0c20d4$var$dt(s, a);
        return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            "data-testid": "gridContainer",
            className: r,
            ...i,
            children: n
        });
    }
}
const $1fe2a1803f0c20d4$var$tt = {
    mobile: "mobile",
    mobileLg: "mobile-lg",
    tablet: "tablet",
    tabletLg: "tablet-lg",
    desktop: "desktop",
    desktopLg: "desktop-lg",
    widescreen: "widescreen"
};
function $1fe2a1803f0c20d4$var$mr(e) {
    return "asCustom" in e;
}
const $1fe2a1803f0c20d4$var$Fe = (e = {}, s)=>{
    const a = s ? `${$1fe2a1803f0c20d4$var$tt[s]}:` : "", { row: n, col: i, gap: r, offset: o } = e;
    return $1fe2a1803f0c20d4$var$g({
        [`${a}grid-row`]: n,
        [`${a}grid-gap`]: r === !0,
        [`${a}grid-gap-${r}`]: r !== !0 && !!r,
        [`${a}grid-col`]: i === !0,
        [`${a}grid-col-${i}`]: i !== !0 && !!i,
        [`${a}grid-offset-${o}`]: !!o
    });
}, $1fe2a1803f0c20d4$var$dr = (e)=>{
    let s = $1fe2a1803f0c20d4$var$Fe(e);
    return Object.keys($1fe2a1803f0c20d4$var$tt).forEach((a)=>{
        const n = a;
        if (Object.prototype.hasOwnProperty.call(e, n)) {
            const i = e[n];
            s = $1fe2a1803f0c20d4$var$g(s, $1fe2a1803f0c20d4$var$Fe(i, n));
        }
    }), s;
};
function $1fe2a1803f0c20d4$export$ef2184bd89960b14(e) {
    const { children: s, className: a, row: n, col: i, gap: r, offset: o, mobile: v, mobileLg: d, tablet: u, tabletLg: w, desktop: f, desktopLg: _, widescreen: k, ...b } = e, M = {
        row: n,
        col: i,
        gap: r,
        offset: o
    }, B = {
        mobile: v,
        mobileLg: d,
        tablet: u,
        tabletLg: w,
        desktop: f,
        desktopLg: _,
        widescreen: k
    };
    let x = $1fe2a1803f0c20d4$var$Fe(M);
    if (Object.keys($1fe2a1803f0c20d4$var$tt).forEach(($)=>{
        const p = $;
        if (Object.prototype.hasOwnProperty.call(B, p)) {
            const N = e[p];
            x = $1fe2a1803f0c20d4$var$g(x, $1fe2a1803f0c20d4$var$Fe(N, p));
        }
    }), x = $1fe2a1803f0c20d4$var$g(x, a), $1fe2a1803f0c20d4$var$mr(b)) {
        const { asCustom: $, ...p } = b, N = p;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($, {
            className: x,
            ...N
        }, s);
    } else return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: x,
        "data-testid": "grid",
        ...b,
        children: s
    });
}
const $1fe2a1803f0c20d4$export$c86715117507e8e5 = (0, $3RyIS.forwardRef)((e, s)=>{
    const { id: a, name: n, type: i, className: r, validationStatus: o, inputSize: v, inputRef: d, ...u } = e, b = $1fe2a1803f0c20d4$var$g("usa-input", {
        "usa-input--error": o === "error",
        "usa-input--success": o === "success",
        "usa-input--small": v === "small",
        "usa-input--medium": v === "medium"
    }, r);
    return /* @__PURE__ */ (0, $21sFD.jsx)("input", {
        "data-testid": "textInput",
        className: b,
        id: a,
        name: n,
        type: i,
        ref: d || s,
        ...u
    });
});
$1fe2a1803f0c20d4$export$c86715117507e8e5.displayName = "TextInput";
const $1fe2a1803f0c20d4$export$379139ebc1c2b235 = ({ id: e, name: s, className: a, error: n, success: i, children: r, inputRef: o, ...v })=>{
    const d = $1fe2a1803f0c20d4$var$g("usa-textarea", {
        "usa-input--error": n,
        "usa-input--success": i
    }, a);
    return /* @__PURE__ */ (0, $21sFD.jsx)("textarea", {
        "data-testid": "textarea",
        className: d,
        id: e,
        name: s,
        ref: o,
        ...v,
        children: r
    });
}, $1fe2a1803f0c20d4$var$gr = (e)=>Array.from(e).length, $1fe2a1803f0c20d4$var$ur = (e, s)=>{
    const a = `${s} characters allowed`, n = "$0 characters left", i = "$0 character left", r = "$0 character over limit", o = "$0 characters over limit", v = s - e;
    switch(v){
        case s:
            return a;
        case 1:
            return i.replace("$0", "1");
        case -1:
            return r.replace("$0", "1");
        default:
            return v >= 0 ? n.replace("$0", v.toString()) : o.replace("$0", Math.abs(v).toString());
    }
}, $1fe2a1803f0c20d4$export$5740cdd52697d95d = ({ id: e, name: s, className: a, maxLength: n, value: i = "", defaultValue: r = "", isTextArea: o = !1, getCharacterCount: v = $1fe2a1803f0c20d4$var$gr, getMessage: d = $1fe2a1803f0c20d4$var$ur, ...u })=>{
    const w = v(i || r), [f, _] = (0, $3RyIS.useState)(w), [k, b] = (0, $3RyIS.useState)(d(w, n)), [M, B] = (0, $3RyIS.useState)(w < n), x = (0, $3RyIS.useRef)(null), $ = $1fe2a1803f0c20d4$var$g("usa-character-count__field", a), p = $1fe2a1803f0c20d4$var$g("usa-hint", "usa-character-count__status", {
        "usa-character-count__status--invalid": !M
    });
    (0, $3RyIS.useEffect)(()=>{
        const E = d(f, n);
        b(E), B(f <= n);
        const S = setTimeout(()=>{
            x.current && (x.current.textContent = E);
        }, 1e3);
        return ()=>clearTimeout(S);
    }, [
        f
    ]);
    const N = (E, S)=>{
        const L = M ? "" : "The content is too long.";
        E.target.setCustomValidity(L), S && S(E);
    }, A = (E, S)=>{
        const { target: { value: L = "" } } = E;
        _(v(L)), S && S(E);
    };
    let V;
    if (o) {
        const { onBlur: E, onChange: S, inputRef: L, ...y } = u, O = {
            id: e,
            name: s,
            className: $,
            ...i ? {
                value: i
            } : {
                defaultValue: r
            },
            onBlur: (D)=>N(D, E),
            onChange: (D)=>A(D, S),
            inputRef: L,
            ...y
        };
        V = /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$379139ebc1c2b235, {
            ...O
        });
    } else {
        const { onBlur: E, onChange: S, inputRef: L, type: y = "text", ...O } = u, D = {
            id: e,
            type: y,
            name: s,
            className: $,
            ...i ? {
                value: i
            } : {
                defaultValue: r
            },
            onBlur: (H)=>N(H, E),
            onChange: (H)=>A(H, S),
            inputRef: L,
            ...O
        };
        V = /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$c86715117507e8e5, {
            ...D
        });
    }
    return /* @__PURE__ */ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
        children: [
            V,
            /* @__PURE__ */ (0, $21sFD.jsxs)("span", {
                className: "usa-sr-only",
                id: `${e}-info`,
                children: [
                    "You can enter up to ",
                    n,
                    " characters"
                ]
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                className: p,
                "aria-hidden": "true",
                "data-testid": "characterCountMessage",
                children: k
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                ref: x,
                className: "usa-character-count__sr-status usa-sr-only",
                "aria-live": "polite",
                "data-testid": "characterCountSRMessage"
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$48513f6b9f8ce62d = ({ id: e, name: s, className: a, label: n, inputRef: i, tile: r, labelDescription: o, ...v })=>{
    const d = $1fe2a1803f0c20d4$var$g("usa-checkbox", a), u = $1fe2a1803f0c20d4$var$g("usa-checkbox__input", {
        "usa-checkbox__input--tile": r
    });
    return /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
        "data-testid": "checkbox",
        className: d,
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)("input", {
                className: u,
                id: e,
                type: "checkbox",
                name: s,
                ref: i,
                ...v
            }),
            /* @__PURE__ */ (0, $21sFD.jsxs)("label", {
                className: "usa-checkbox__label",
                htmlFor: e,
                children: [
                    n,
                    o && /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                        className: "usa-checkbox__label-description",
                        children: o
                    })
                ]
            })
        ]
    });
}, $1fe2a1803f0c20d4$var$wr = (e, s = "", a = {})=>{
    const n = (r)=>r.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    let i = e.replace(/{{(.*?)}}/g, (r, o)=>{
        const v = o.trim(), d = a[v];
        if (v !== "query" && d) {
            const u = new RegExp(d, "i"), w = s.match(u);
            return w ? n(w[1]) : "";
        }
        return n(s);
    });
    return i = "^(?:" + i + ")$", new RegExp(i, "i");
};
var $1fe2a1803f0c20d4$var$I = /* @__PURE__ */ ((e)=>(e[e.SELECT_OPTION = 0] = "SELECT_OPTION", e[e.CLEAR = 1] = "CLEAR", e[e.OPEN_LIST = 2] = "OPEN_LIST", e[e.CLOSE_LIST = 3] = "CLOSE_LIST", e[e.FOCUS_OPTION = 4] = "FOCUS_OPTION", e[e.UPDATE_FILTER = 5] = "UPDATE_FILTER", e[e.BLUR = 6] = "BLUR", e[e.CLEAR_SELECTION = 7] = "CLEAR_SELECTION", e[e.FOCUS_INPUT = 8] = "FOCUS_INPUT", e))($1fe2a1803f0c20d4$var$I || {});
const $1fe2a1803f0c20d4$var$pr = (e, s, a, n)=>{
    const i = (o)=>{
        const v = $1fe2a1803f0c20d4$var$wr(n.filter, o, n.extras), d = s.filter((u)=>v.test(u.label.toLowerCase()));
        return a ? {
            closestMatch: d.length > 0 ? d[0] : s[0],
            optionsToDisplay: s
        } : {
            closestMatch: d[0],
            optionsToDisplay: d
        };
    };
    return (0, $3RyIS.useReducer)((o, v)=>{
        switch(v.type){
            case 0:
                return {
                    ...o,
                    isOpen: !1,
                    selectedOption: v.option,
                    focusMode: $1fe2a1803f0c20d4$var$we.Input,
                    inputValue: v.option.label,
                    filteredOptions: s,
                    focusedOption: v.option,
                    statusText: ""
                };
            case 5:
                {
                    const { closestMatch: d, optionsToDisplay: u } = i(v.value), w = {
                        ...o,
                        isOpen: !0,
                        filteredOptions: u,
                        inputValue: v.value,
                        statusText: `${u.length} result${u.length > 1 ? "s" : ""} available.`
                    };
                    return u.length < 1 && (w.statusText = "No results."), a || !o.selectedOption ? w.focusedOption = d : o.selectedOption && (w.filteredOptions.includes(o.selectedOption) ? w.focusedOption = o.selectedOption : w.focusedOption = d), w;
                }
            case 2:
                {
                    const d = o.filteredOptions.length ? `${o.filteredOptions.length} result${o.filteredOptions.length > 1 ? "s" : ""} available.` : "No results.";
                    return {
                        ...o,
                        isOpen: !0,
                        focusMode: $1fe2a1803f0c20d4$var$we.Input,
                        focusedOption: o.selectedOption || o.focusedOption || s[0],
                        statusText: d
                    };
                }
            case 3:
                {
                    const d = {
                        ...o,
                        isOpen: !1,
                        focusMode: $1fe2a1803f0c20d4$var$we.Input,
                        focusedOption: void 0,
                        statusText: ""
                    };
                    return o.filteredOptions.length === 0 && (d.filteredOptions = s, d.inputValue = ""), o.selectedOption && (d.inputValue = o.selectedOption.label), d;
                }
            case 4:
                {
                    const d = o.filteredOptions.length ? `${o.filteredOptions.length} result${o.filteredOptions.length > 1 ? "s" : ""} available.` : "No results.";
                    return {
                        ...o,
                        isOpen: !0,
                        focusedOption: v.option,
                        focusMode: $1fe2a1803f0c20d4$var$we.Item,
                        statusText: d
                    };
                }
            case 1:
                return {
                    ...o,
                    inputValue: "",
                    isOpen: !1,
                    focusMode: $1fe2a1803f0c20d4$var$we.Input,
                    selectedOption: void 0,
                    filteredOptions: s,
                    focusedOption: s[0],
                    statusText: ""
                };
            case 6:
                {
                    const d = {
                        ...o,
                        isOpen: !1,
                        focusMode: $1fe2a1803f0c20d4$var$we.None,
                        filteredOptions: s,
                        statusText: ""
                    };
                    return o.selectedOption ? (d.inputValue = o.selectedOption.label, d.focusedOption = o.selectedOption) : (d.inputValue = "", d.focusedOption = s[0]), d;
                }
            case 7:
                return {
                    ...o,
                    inputValue: "",
                    isOpen: !1,
                    focusMode: $1fe2a1803f0c20d4$var$we.None,
                    selectedOption: void 0,
                    filteredOptions: s,
                    focusedOption: void 0,
                    statusText: ""
                };
            case 8:
                return {
                    ...o,
                    focusMode: $1fe2a1803f0c20d4$var$we.Input
                };
            default:
                throw new Error();
        }
    }, e);
}, $1fe2a1803f0c20d4$var$fr = ".*{{query}}.*";
var $1fe2a1803f0c20d4$var$we = /* @__PURE__ */ ((e)=>(e[e.None = 0] = "None", e[e.Input = 1] = "Input", e[e.Item = 2] = "Item", e))($1fe2a1803f0c20d4$var$we || {});
const $1fe2a1803f0c20d4$var$Mr = ({ focused: e, ...s })=>{
    const a = (0, $3RyIS.useRef)(null);
    return (0, $3RyIS.useEffect)(()=>{
        e && a.current && a.current.focus();
    }), /* @__PURE__ */ (0, $21sFD.jsx)("input", {
        type: "text",
        ...s,
        className: "usa-combo-box__input",
        "data-testid": "combo-box-input",
        autoCapitalize: "off",
        autoComplete: "off",
        ref: a
    });
}, $1fe2a1803f0c20d4$var$xr = ({ id: e, name: s, className: a, options: n, defaultValue: i, disabled: r, onChange: o, assistiveHint: v, noResults: d, selectProps: u, inputProps: w, ulProps: f, customFilter: _, disableFiltering: k = !1 }, b)=>{
    var X;
    const M = !!r;
    let B;
    i && (B = n.find((C)=>C.value === i));
    const x = _ || {
        filter: $1fe2a1803f0c20d4$var$fr
    }, $ = {
        isOpen: !1,
        selectedOption: B || void 0,
        focusedOption: void 0,
        focusMode: 0,
        filteredOptions: n,
        inputValue: B ? B.label : "",
        statusText: ""
    }, [p, N] = $1fe2a1803f0c20d4$var$pr($, n, k, x), A = (0, $3RyIS.useRef)(null), V = (0, $3RyIS.useRef)(null), E = (0, $3RyIS.useRef)(null);
    (0, $3RyIS.useEffect)(()=>{
        p.filteredOptions = n;
    }, [
        n
    ]), (0, $3RyIS.useEffect)(()=>{
        var C;
        o && o(((C = p.selectedOption) == null ? void 0 : C.value) || void 0);
    }, [
        p.selectedOption
    ]), (0, $3RyIS.useEffect)(()=>{
        p.focusMode === 2 && p.focusedOption && E.current && E.current.focus();
    }, [
        p.focusMode,
        p.focusedOption
    ]), (0, $3RyIS.useEffect)(()=>{
        if (p.isOpen && p.focusedOption && E.current && V.current && p.focusMode === 1) {
            const C = E.current.offsetTop + E.current.offsetHeight, R = V.current.scrollTop + V.current.offsetHeight;
            C > R && (V.current.scrollTop = C - V.current.offsetHeight), E.current.offsetTop < V.current.scrollTop && (V.current.scrollTop = E.current.offsetTop);
        }
    }, [
        p.isOpen,
        p.focusedOption
    ]), (0, $3RyIS.useEffect)(()=>{
        var C;
        p.focusMode !== 0 && ((C = A.current) != null && C.contains(window.document.activeElement) || N({
            type: $1fe2a1803f0c20d4$var$I.BLUR
        }));
    }, [
        p.focusMode
    ]), (0, $3RyIS.useImperativeHandle)(b, ()=>({
            focus: ()=>N({
                    type: $1fe2a1803f0c20d4$var$I.FOCUS_INPUT
                }),
            clearSelection: ()=>N({
                    type: $1fe2a1803f0c20d4$var$I.CLEAR_SELECTION
                })
        }), []);
    const S = (C)=>{
        if (C.key === "Escape") N({
            type: $1fe2a1803f0c20d4$var$I.CLOSE_LIST
        });
        else if (C.key === "ArrowDown" || C.key == "Down") C.preventDefault(), N({
            type: $1fe2a1803f0c20d4$var$I.FOCUS_OPTION,
            option: p.selectedOption || p.focusedOption || p.filteredOptions[0]
        });
        else if (C.key === "Tab") {
            if (p.isOpen && !p.selectedOption) {
                const R = k ? p.focusedOption : p.selectedOption || p.focusedOption;
                R ? (C.preventDefault(), N({
                    type: $1fe2a1803f0c20d4$var$I.FOCUS_OPTION,
                    option: R
                })) : N({
                    type: $1fe2a1803f0c20d4$var$I.BLUR
                });
            }
            !p.isOpen && p.selectedOption && N({
                type: $1fe2a1803f0c20d4$var$I.BLUR
            });
        } else if (C.key === "Enter" && p.isOpen) {
            C.preventDefault();
            const R = p.filteredOptions.find((q)=>q.label.toLowerCase() === p.inputValue.toLowerCase());
            R ? N({
                type: $1fe2a1803f0c20d4$var$I.SELECT_OPTION,
                option: R
            }) : p.selectedOption ? N({
                type: $1fe2a1803f0c20d4$var$I.CLOSE_LIST
            }) : N({
                type: $1fe2a1803f0c20d4$var$I.CLEAR
            });
        }
    }, L = (C)=>{
        var Q;
        const { relatedTarget: R } = C;
        (!R || R instanceof Node && !((Q = A.current) != null && Q.contains(R))) && p.focusMode !== 0 && N({
            type: $1fe2a1803f0c20d4$var$I.BLUR
        });
    }, y = (C)=>{
        C.key === "Tab" && p.isOpen && p.selectedOption && (C.preventDefault(), N({
            type: $1fe2a1803f0c20d4$var$I.FOCUS_OPTION,
            option: p.selectedOption
        }));
    }, O = (C, R, q)=>{
        const Q = R.focusedOption ? R.filteredOptions.indexOf(R.focusedOption) : -1, re = R.filteredOptions[0], ve = R.filteredOptions[R.filteredOptions.length - 1];
        if (Q === -1) C({
            type: $1fe2a1803f0c20d4$var$I.FOCUS_OPTION,
            option: re
        });
        else {
            const de = Q + q;
            if (de < 0) C({
                type: $1fe2a1803f0c20d4$var$I.CLOSE_LIST
            });
            else if (de >= R.filteredOptions.length) C({
                type: $1fe2a1803f0c20d4$var$I.FOCUS_OPTION,
                option: ve
            });
            else {
                const fe = R.filteredOptions[de];
                C({
                    type: $1fe2a1803f0c20d4$var$I.FOCUS_OPTION,
                    option: fe
                });
            }
        }
    }, D = (C)=>{
        var q;
        const { relatedTarget: R } = C;
        (!R || R instanceof Node && !((q = A.current) != null && q.contains(R))) && N({
            type: $1fe2a1803f0c20d4$var$I.BLUR
        });
    }, H = (C)=>{
        C.key === "Escape" ? N({
            type: $1fe2a1803f0c20d4$var$I.CLOSE_LIST
        }) : C.key === "Tab" || C.key === "Enter" ? (C.preventDefault(), p.focusedOption && N({
            type: $1fe2a1803f0c20d4$var$I.SELECT_OPTION,
            option: p.focusedOption
        })) : C.key === "ArrowDown" || C.key === "Down" ? (C.preventDefault(), O(N, p, 1)) : (C.key === "ArrowUp" || C.key === "Up") && (C.preventDefault(), O(N, p, -1));
    }, P = p.selectedOption && p.selectedOption.label === p.inputValue, j = $1fe2a1803f0c20d4$var$g("usa-combo-box", a, {
        "usa-combo-box--pristine": P
    }), G = `${e}--list`, ee = `${e}--assistiveHint`, ie = p.focusedOption ? p.filteredOptions.findIndex((C)=>C === p.focusedOption) : -1, U = ie > -1 && `${G}--option-${ie}`;
    return /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
        "data-testid": "combo-box",
        "data-enhanced": "true",
        className: j,
        ref: A,
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)("select", {
                ...u,
                className: "usa-select usa-sr-only usa-combo-box__select",
                name: s,
                "aria-hidden": !0,
                tabIndex: -1,
                defaultValue: (X = p.selectedOption) == null ? void 0 : X.value,
                "data-testid": "combo-box-select",
                children: n.map((C)=>/* @__PURE__ */ (0, $21sFD.jsx)("option", {
                        value: C.value,
                        children: C.label
                    }, C.value))
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$Mr, {
                ...w,
                role: "combobox",
                onChange: (C)=>{
                    w != null && w.onChange && (w == null || w.onChange(C)), N({
                        type: $1fe2a1803f0c20d4$var$I.UPDATE_FILTER,
                        value: C.target.value
                    });
                },
                onClick: ()=>N({
                        type: $1fe2a1803f0c20d4$var$I.OPEN_LIST
                    }),
                onBlur: L,
                onKeyDown: S,
                value: p.inputValue,
                focused: p.focusMode === 1,
                "aria-owns": G,
                "aria-controls": G,
                "aria-autocomplete": "list",
                "aria-describedby": ee,
                "aria-expanded": p.isOpen,
                "aria-activedescendant": p.isOpen && U || "",
                id: e,
                disabled: M
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                className: "usa-combo-box__clear-input__wrapper",
                tabIndex: -1,
                children: /* @__PURE__ */ (0, $21sFD.jsx)("button", {
                    type: "button",
                    className: "usa-combo-box__clear-input",
                    "aria-label": "Clear the select contents",
                    onClick: ()=>N({
                            type: $1fe2a1803f0c20d4$var$I.CLEAR
                        }),
                    "data-testid": "combo-box-clear-button",
                    onKeyDown: y,
                    hidden: !P || M,
                    disabled: M,
                    children: "\xa0"
                })
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                className: "usa-combo-box__input-button-separator",
                children: "\xa0"
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                className: "usa-combo-box__toggle-list__wrapper",
                tabIndex: -1,
                children: /* @__PURE__ */ (0, $21sFD.jsx)("button", {
                    "data-testid": "combo-box-toggle",
                    type: "button",
                    className: "usa-combo-box__toggle-list",
                    tabIndex: -1,
                    "aria-label": "Toggle the dropdown list",
                    onClick: ()=>N({
                            type: p.isOpen ? $1fe2a1803f0c20d4$var$I.CLOSE_LIST : $1fe2a1803f0c20d4$var$I.OPEN_LIST
                        }),
                    disabled: M,
                    children: "\xa0"
                })
            }),
            /* @__PURE__ */ (0, $21sFD.jsxs)("ul", {
                ...f,
                "data-testid": "combo-box-option-list",
                tabIndex: -1,
                id: G,
                className: "usa-combo-box__list",
                role: "listbox",
                ref: V,
                hidden: !p.isOpen,
                children: [
                    p.filteredOptions.map((C, R)=>{
                        const q = C === p.focusedOption, Q = C === p.selectedOption, re = $1fe2a1803f0c20d4$var$g("usa-combo-box__list-option", {
                            "usa-combo-box__list-option--focused": q,
                            "usa-combo-box__list-option--selected": Q
                        });
                        return /* @__PURE__ */ (0, $21sFD.jsx)("li", {
                            ref: q ? E : null,
                            value: C.value,
                            className: re,
                            tabIndex: q ? 0 : -1,
                            role: "option",
                            "aria-selected": Q,
                            "aria-setsize": p.filteredOptions.length,
                            "aria-posinset": R + 1,
                            id: G + `--option-${R}`,
                            onKeyDown: H,
                            onBlur: D,
                            "data-testid": `combo-box-option-${C.value}`,
                            "data-value": C.value,
                            onMouseEnter: ()=>N({
                                    type: $1fe2a1803f0c20d4$var$I.FOCUS_OPTION,
                                    option: C
                                }),
                            onClick: ()=>{
                                N({
                                    type: $1fe2a1803f0c20d4$var$I.SELECT_OPTION,
                                    option: C
                                });
                            },
                            children: C.label
                        }, C.value);
                    }),
                    p.filteredOptions.length === 0 ? /* @__PURE__ */ (0, $21sFD.jsx)("li", {
                        className: "usa-combo-box__list-option--no-results",
                        children: d || "No results found"
                    }) : null
                ]
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                className: "usa-combo-box__status usa-sr-only",
                role: "status",
                children: p.statusText
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                id: ee,
                className: "usa-sr-only",
                "data-testid": "combo-box-assistive-hint",
                children: v || `When autocomplete results are available use up and down arrows to review
           and enter to select. Touch device users, explore by touch or with swipe
           gestures.`
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$72b9695b8216309a = (0, $3RyIS.forwardRef)($1fe2a1803f0c20d4$var$xr), $1fe2a1803f0c20d4$export$162b722f6dd80445 = ()=>/* @__PURE__ */ (0, $21sFD.jsx)("abbr", {
        title: "required",
        className: "usa-hint usa-hint--required",
        children: "*"
    }), $1fe2a1803f0c20d4$export$b04be29aa201d4f5 = ({ children: e, htmlFor: s, className: a, error: n, hint: i, srOnly: r, requiredMarker: o, ...v })=>{
    const d = $1fe2a1803f0c20d4$var$g({
        "usa-label": !r,
        "usa-sr-only": r,
        "usa-label--error": n
    }, a);
    return /* @__PURE__ */ (0, $21sFD.jsxs)("label", {
        ...v,
        "data-testid": "label",
        className: d,
        htmlFor: s,
        children: [
            e,
            i && /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                className: "usa-hint",
                children: i
            }),
            o && /* @__PURE__ */ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
                children: [
                    " ",
                    /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$162b722f6dd80445, {})
                ]
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$2d00230e1e6f7fbc = ({ children: e, className: s, error: a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-form-group", {
        "usa-form-group--error": a
    }, s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        "data-testid": "formGroup",
        className: n,
        children: e
    });
}, $1fe2a1803f0c20d4$export$7edc06cf1783b30f = ({ id: e, name: s, label: a, unit: n, maxLength: i, minLength: r, className: o, ...v })=>{
    const d = $1fe2a1803f0c20d4$var$g({
        "usa-form-group--month": n == "month",
        "usa-form-group--day": n == "day",
        "usa-form-group--year": n == "year"
    }), u = $1fe2a1803f0c20d4$var$g(o);
    return /* @__PURE__ */ (0, $21sFD.jsxs)($1fe2a1803f0c20d4$export$2d00230e1e6f7fbc, {
        className: d,
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$b04be29aa201d4f5, {
                htmlFor: e,
                children: a
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$c86715117507e8e5, {
                ...v,
                className: u,
                id: e,
                name: s,
                type: "text",
                maxLength: i,
                minLength: r,
                pattern: "[0-9]*",
                inputMode: "numeric"
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$28573c025b70075c = ({ children: e, className: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-memorable-date", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: n,
        ...a,
        "data-testid": "dateInputGroup",
        children: e
    });
}, $1fe2a1803f0c20d4$var$vt = "Please enter a valid date", $1fe2a1803f0c20d4$var$br = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
], $1fe2a1803f0c20d4$var$zr = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
], $1fe2a1803f0c20d4$var$Sr = [
    "S",
    "M",
    "T",
    "W",
    "Th",
    "F",
    "S"
], $1fe2a1803f0c20d4$var$ge = 12, $1fe2a1803f0c20d4$var$_r = "0000-01-01", $1fe2a1803f0c20d4$var$ye = "MM/DD/YYYY", $1fe2a1803f0c20d4$var$St = "YYYY-MM-DD", $1fe2a1803f0c20d4$var$We = {
    months: $1fe2a1803f0c20d4$var$br,
    daysOfWeek: $1fe2a1803f0c20d4$var$zr,
    daysOfWeekShort: $1fe2a1803f0c20d4$var$Sr,
    statuses: [
        "You can navigate by day using left and right arrows",
        "Weeks by using up and down arrows",
        "Months by using page up and page down keys",
        "Years by using shift plus page up and shift plus page down",
        "Home and end keys navigate to the beginning and end of a week"
    ],
    selectedDate: "Selected date",
    selectAMonth: "Select a month.",
    toggleCalendar: "Toggle calendar",
    backOneYear: "Navigate back one year",
    backOneMonth: "Navigate back one month",
    forwardOneYear: "Navigate forward one year",
    forwardOneMonth: "Navigate forward one month",
    selectMonth: "Select month",
    selectYear: "Select year"
}, $1fe2a1803f0c20d4$var$st = (e, s)=>(s !== e.getMonth() && e.setDate(0), e), $1fe2a1803f0c20d4$var$Re = (e, s, a)=>{
    const n = /* @__PURE__ */ new Date(0);
    return n.setFullYear(e, s, a), n;
}, $1fe2a1803f0c20d4$var$Ue = ()=>{
    const e = /* @__PURE__ */ new Date(), s = e.getDate(), a = e.getMonth(), n = e.getFullYear();
    return $1fe2a1803f0c20d4$var$Re(n, a, s);
}, $1fe2a1803f0c20d4$var$at = (e)=>{
    const s = /* @__PURE__ */ new Date(0);
    return s.setFullYear(e.getFullYear(), e.getMonth(), 1), s;
}, $1fe2a1803f0c20d4$var$_t = (e)=>{
    const s = /* @__PURE__ */ new Date(0);
    return s.setFullYear(e.getFullYear(), e.getMonth() + 1, 0), s;
}, $1fe2a1803f0c20d4$var$Ee = (e, s)=>{
    const a = new Date(e.getTime());
    return a.setDate(a.getDate() + s), a;
}, $1fe2a1803f0c20d4$var$Qe = (e, s)=>$1fe2a1803f0c20d4$var$Ee(e, -s), $1fe2a1803f0c20d4$var$Ct = (e, s)=>$1fe2a1803f0c20d4$var$Ee(e, s * 7), $1fe2a1803f0c20d4$var$Cr = (e, s)=>$1fe2a1803f0c20d4$var$Ct(e, -s), $1fe2a1803f0c20d4$var$gt = (e)=>{
    const s = e.getDay();
    return $1fe2a1803f0c20d4$var$Qe(e, s);
}, $1fe2a1803f0c20d4$var$Nr = (e)=>{
    const s = e.getDay();
    return $1fe2a1803f0c20d4$var$Ee(e, 6 - s);
}, $1fe2a1803f0c20d4$var$$e = (e, s)=>{
    const a = new Date(e.getTime()), n = (a.getMonth() + 12 + s) % 12;
    return a.setMonth(a.getMonth() + s), $1fe2a1803f0c20d4$var$st(a, n), a;
}, $1fe2a1803f0c20d4$var$Ze = (e, s)=>$1fe2a1803f0c20d4$var$$e(e, -s), $1fe2a1803f0c20d4$var$Je = (e, s)=>$1fe2a1803f0c20d4$var$$e(e, s * 12), $1fe2a1803f0c20d4$var$ut = (e, s)=>$1fe2a1803f0c20d4$var$Je(e, -s), $1fe2a1803f0c20d4$var$Le = (e, s)=>{
    const a = new Date(e.getTime());
    return a.setMonth(s), $1fe2a1803f0c20d4$var$st(a, s), a;
}, $1fe2a1803f0c20d4$var$xe = (e, s)=>{
    const a = new Date(e.getTime()), n = a.getMonth();
    return a.setFullYear(s), $1fe2a1803f0c20d4$var$st(a, n), a;
}, $1fe2a1803f0c20d4$var$yr = (e, s)=>{
    let a = e;
    return s < e && (a = s), new Date(a.getTime());
}, $1fe2a1803f0c20d4$var$Lr = (e, s)=>{
    let a = e;
    return s > e && (a = s), new Date(a.getTime());
}, $1fe2a1803f0c20d4$var$Nt = (e, s)=>e && s && e.getFullYear() === s.getFullYear(), $1fe2a1803f0c20d4$var$be = (e, s)=>$1fe2a1803f0c20d4$var$Nt(e, s) && e.getMonth() === s.getMonth(), $1fe2a1803f0c20d4$var$pe = (e, s)=>$1fe2a1803f0c20d4$var$be(e, s) && e.getDate() === s.getDate(), $1fe2a1803f0c20d4$var$he = (e, s, a)=>{
    let n = e;
    return e < s ? n = s : a && e > a && (n = a), new Date(n.getTime());
}, $1fe2a1803f0c20d4$var$Xe = (e, s, a)=>e >= s && (!a || e <= a), $1fe2a1803f0c20d4$var$kr = (e, s, a)=>$1fe2a1803f0c20d4$var$_t(e) < s || !!a && $1fe2a1803f0c20d4$var$at(e) > a, $1fe2a1803f0c20d4$var$Ge = (e, s, a)=>$1fe2a1803f0c20d4$var$_t($1fe2a1803f0c20d4$var$Le(e, 11)) < s || !!a && $1fe2a1803f0c20d4$var$at($1fe2a1803f0c20d4$var$Le(e, 0)) > a, $1fe2a1803f0c20d4$var$oe = (e, s = $1fe2a1803f0c20d4$var$St, a = !1)=>{
    let n, i, r, o, v;
    if (e) {
        let d, u, w;
        if (s === $1fe2a1803f0c20d4$var$ye ? [d, u, w] = e.split("/") : [w, d, u] = e.split("-"), w && (v = parseInt(w, 10), !Number.isNaN(v) && (o = v, a && (o = Math.max(0, o), w.length < 3)))) {
            const f = $1fe2a1803f0c20d4$var$Ue().getFullYear();
            o = f - f % 10 ** w.length + v;
        }
        if (d && (v = parseInt(d, 10), Number.isNaN(v) || (i = v, a && (i = Math.max(1, i), i = Math.min(12, i)))), i && u && o != null && (v = parseInt(u, 10), !Number.isNaN(v) && (r = v, a))) {
            const f = $1fe2a1803f0c20d4$var$Re(o, i, 0).getDate();
            r = Math.max(1, r), r = Math.min(f, r);
        }
        i && r && o != null && (n = $1fe2a1803f0c20d4$var$Re(o, i - 1, r));
    }
    return n;
}, $1fe2a1803f0c20d4$var$le = (e, s = $1fe2a1803f0c20d4$var$St)=>{
    const a = (o, v)=>`0000${o}`.slice(-v), n = e.getMonth() + 1, i = e.getDate(), r = e.getFullYear();
    return s === $1fe2a1803f0c20d4$var$ye ? [
        a(n, 2),
        a(i, 2),
        a(r, 4)
    ].join("/") : [
        a(r, 4),
        a(n, 2),
        a(i, 2)
    ].join("-");
}, $1fe2a1803f0c20d4$var$wt = (e, s, a)=>{
    let n = !1;
    if (e) {
        n = !0;
        const i = e.split("/"), [r, o, v] = i.map((d)=>{
            let u;
            const w = parseInt(d, 10);
            return Number.isNaN(w) || (u = w), u;
        });
        if (r && o && v != null) {
            const d = $1fe2a1803f0c20d4$var$Re(v, r - 1, o);
            d.getMonth() === r - 1 && d.getDate() === o && d.getFullYear() === v && i[2].length === 4 && $1fe2a1803f0c20d4$var$Xe(d, s, a) && (n = !1);
        }
    }
    return n;
}, $1fe2a1803f0c20d4$var$nt = (e, s)=>{
    const a = [];
    let n = 0;
    for(; n < e.length;){
        const i = [];
        for(; n < e.length && i.length < s;)i.push(e[parseInt(`${n}`)]), n += 1;
        a.push(i);
    }
    return /* @__PURE__ */ (0, $21sFD.jsx)((0, $21sFD.Fragment), {
        children: a.map((i, r)=>/* @__PURE__ */ (0, $21sFD.jsx)("tr", {
                children: i.map((o, v)=>/* @__PURE__ */ (0, $21sFD.jsx)("td", {
                        children: o
                    }, `row_${r}_cell_${v}`))
            }, `row_${r}`))
    });
}, $1fe2a1803f0c20d4$var$ct = (e, s)=>{
    if (e.key === "Tab") {
        const a = s.filter((_)=>_ && !_.disabled), n = document == null ? void 0 : document.activeElement, i = 0, r = a.length - 1, o = a[parseInt(`${i}`)], v = a[parseInt(`${r}`)], d = n instanceof HTMLButtonElement ? a.indexOf(n) : -1, u = d === r, w = d === i, f = d === -1;
        e.shiftKey ? (w || f) && (e.preventDefault(), v == null || v.focus()) : (u || f) && (e.preventDefault(), o == null || o.focus());
    }
}, $1fe2a1803f0c20d4$var$it = ()=>typeof navigator < "u" && (navigator.userAgent.match(/(iPod|iPhone|iPad)/g) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) && !window.MSStream, $1fe2a1803f0c20d4$var$$r = ({ date: e, onClick: s, onKeyDown: a, onMouseMove: n, isDisabled: i = !1, isSelected: r = !1, isFocused: o = !1, isPrevMonth: v = !1, isFocusedMonth: d = !1, isNextMonth: u = !1, isToday: w = !1, isRangeDate: f = !1, isRangeStart: _ = !1, isRangeEnd: k = !1, isWithinRange: b = !1, i18n: M = $1fe2a1803f0c20d4$var$We }, B)=>{
    const x = e.getDate(), $ = e.getMonth(), p = e.getFullYear(), N = e.getDay(), A = $1fe2a1803f0c20d4$var$le(e), V = o ? 0 : -1, E = $1fe2a1803f0c20d4$var$g("usa-date-picker__calendar__date", {
        "usa-date-picker__calendar__date--previous-month": v,
        "usa-date-picker__calendar__date--current-month": d,
        "usa-date-picker__calendar__date--next-month": u,
        "usa-date-picker__calendar__date--selected": r,
        "usa-date-picker__calendar__date--today": w,
        "usa-date-picker__calendar__date--focused": o,
        "usa-date-picker__calendar__date--range-date": f,
        "usa-date-picker__calendar__date--range-date-start": _,
        "usa-date-picker__calendar__date--range-date-end": k,
        "usa-date-picker__calendar__date--within-range": b
    }), S = M.months[parseInt(`${$}`)], L = M.daysOfWeek[parseInt(`${N}`)], y = ()=>{
        s(A);
    }, O = (H)=>{
        a(H);
    }, D = ()=>{
        i || $1fe2a1803f0c20d4$var$it() || n(e);
    };
    return(// Ignoring error: "The attribute aria-selected is not supported by the role button. This role is implicit on the element button."
    // Ignoring because this attribute is present in the USWDS implementation (https://github.com/uswds/uswds/blob/develop/src/js/components/date-picker.js#L1017)
    // eslint-disable-next-line jsx-a11y/role-supports-aria-props
    /* @__PURE__ */ (0, $21sFD.jsx)("button", {
        type: "button",
        "data-testid": "select-date",
        ref: B,
        onClick: y,
        tabIndex: V,
        className: E,
        "data-day": x,
        "data-month": $ + 1,
        "data-year": p,
        "data-value": A,
        "aria-label": `${x} ${S} ${p} ${L}`,
        "aria-selected": !!r,
        disabled: i,
        onKeyDown: O,
        onMouseMove: d ? D : void 0,
        children: x
    }));
}, $1fe2a1803f0c20d4$var$Hr = (0, $3RyIS.forwardRef)($1fe2a1803f0c20d4$var$$r), $1fe2a1803f0c20d4$var$Vr = ({ date: e, minDate: s, maxDate: a, handleSelectMonth: n, i18n: i = $1fe2a1803f0c20d4$var$We })=>{
    const r = e.getMonth(), [o, v] = (0, $3RyIS.useState)(r), d = (0, $3RyIS.useRef)(null), u = (0, $3RyIS.useRef)(null);
    (0, $3RyIS.useEffect)(()=>{
        const b = d.current && d.current.querySelector(`[data-value="${o}"]`);
        b && b.focus();
    }, [
        o
    ]);
    const w = (b)=>{
        $1fe2a1803f0c20d4$var$ct(b, [
            u == null ? void 0 : u.current
        ]);
    }, f = (b)=>{
        var p;
        let M;
        const B = b.target, x = parseInt(((p = B.dataset) == null ? void 0 : p.value) || "", 10), $ = $1fe2a1803f0c20d4$var$Le(e, x);
        switch(b.key){
            case "ArrowUp":
            case "Up":
                M = x - 3;
                break;
            case "ArrowDown":
            case "Down":
                M = x + 3;
                break;
            case "ArrowLeft":
            case "Left":
                M = x - 1;
                break;
            case "ArrowRight":
            case "Right":
                M = x + 1;
                break;
            case "Home":
                M = x - x % 3;
                break;
            case "End":
                M = x + 2 - x % 3;
                break;
            case "PageDown":
                M = 11;
                break;
            case "PageUp":
                M = 0;
                break;
            default:
                return;
        }
        if (M !== void 0) {
            M = Math.max(0, Math.min(11, M));
            const N = $1fe2a1803f0c20d4$var$Le(e, M), A = $1fe2a1803f0c20d4$var$he(N, s, a);
            $1fe2a1803f0c20d4$var$be($, A) || v(A.getMonth());
        }
        b.preventDefault();
    }, k = i.months.map((b, M)=>{
        const B = $1fe2a1803f0c20d4$var$Le(e, M), x = $1fe2a1803f0c20d4$var$kr(B, s, a), $ = M === r, p = M === o, N = p ? 0 : -1, A = $1fe2a1803f0c20d4$var$g("usa-date-picker__calendar__month", {
            "usa-date-picker__calendar__month--selected": $,
            "usa-date-picker__calendar__month--focused": p
        });
        return(// Ignoring error: "The attribute aria-selected is not supported by the role button. This role is implicit on the element button."
        // Ignoring because this attribute is present in the USWDS implementation (https://github.com/uswds/uswds/blob/develop/src/js/components/date-picker.js#L1340)
        // eslint-disable-next-line jsx-a11y/role-supports-aria-props
        /* @__PURE__ */ (0, $21sFD.jsx)("button", {
            type: "button",
            ref: p ? u : null,
            tabIndex: N,
            className: A,
            "data-value": M,
            "data-label": b,
            "aria-selected": $,
            disabled: x,
            onClick: ()=>{
                n(M);
            },
            onKeyDown: f,
            onMouseMove: ()=>{
                x || $1fe2a1803f0c20d4$var$it() || M !== o && v(M);
            },
            children: b
        }, `selectMonth_${b}`));
    });
    return(// Ignoring error: "Static HTML elements with event handlers require a role."
    // Ignoring because this element does not have a role in the USWDS implementation (https://github.com/uswds/uswds/blob/develop/src/js/components/date-picker.js#L1345)
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        tabIndex: -1,
        "data-testid": "calendar-month-picker",
        className: "usa-date-picker__calendar__month-picker",
        ref: d,
        onKeyDown: w,
        children: /* @__PURE__ */ (0, $21sFD.jsx)("table", {
            className: "usa-date-picker__calendar__table",
            role: "presentation",
            children: /* @__PURE__ */ (0, $21sFD.jsx)("tbody", {
                children: $1fe2a1803f0c20d4$var$nt(k, 3)
            })
        })
    }));
}, $1fe2a1803f0c20d4$var$Br = ({ date: e, minDate: s, maxDate: a, handleSelectYear: n, setStatuses: i })=>{
    const r = (0, $3RyIS.useRef)(null), o = (0, $3RyIS.useRef)(null), v = (0, $3RyIS.useRef)(null), d = (0, $3RyIS.useRef)(null), u = e.getFullYear(), [w, f] = (0, $3RyIS.useState)(u), [_, k] = (0, $3RyIS.useState)([
        null,
        null
    ]);
    let b = w;
    b -= b % $1fe2a1803f0c20d4$var$ge, b = Math.max(0, b);
    const M = $1fe2a1803f0c20d4$var$Ge($1fe2a1803f0c20d4$var$xe(e, b - 1), s, a), B = $1fe2a1803f0c20d4$var$Ge($1fe2a1803f0c20d4$var$xe(e, b + $1fe2a1803f0c20d4$var$ge), s, a);
    (0, $3RyIS.useEffect)(()=>{
        const E = `Showing years ${b} to ${b + $1fe2a1803f0c20d4$var$ge - 1}. Select a year.`;
        i([
            E
        ]);
        const [S, L] = _;
        if (S && L) S.disabled ? L.focus() : S.focus(), k([
            null,
            null
        ]);
        else {
            const y = d.current && d.current.querySelector(".usa-date-picker__calendar__year--focused");
            y && y.focus();
        }
    }, [
        w
    ]), (0, $3RyIS.useEffect)(()=>{
        const E = d.current && d.current.querySelector(`[data-value="${w}"]`);
        E && E.focus();
    }, []);
    const x = (E)=>{
        $1fe2a1803f0c20d4$var$ct(E, [
            r == null ? void 0 : r.current,
            v == null ? void 0 : v.current,
            o == null ? void 0 : o.current
        ]);
    }, $ = (E)=>{
        var D;
        let S;
        const L = E.target, y = parseInt(((D = L.dataset) == null ? void 0 : D.value) || "", 10), O = $1fe2a1803f0c20d4$var$xe(e, y);
        switch(E.key){
            case "ArrowUp":
            case "Up":
                S = y - 3;
                break;
            case "ArrowDown":
            case "Down":
                S = y + 3;
                break;
            case "ArrowLeft":
            case "Left":
                S = y - 1;
                break;
            case "ArrowRight":
            case "Right":
                S = y + 1;
                break;
            case "Home":
                S = y - y % 3;
                break;
            case "End":
                S = y + 2 - y % 3;
                break;
            case "PageDown":
                S = y + $1fe2a1803f0c20d4$var$ge;
                break;
            case "PageUp":
                S = y - $1fe2a1803f0c20d4$var$ge;
                break;
            default:
                return;
        }
        if (S !== void 0) {
            S = Math.max(0, S);
            const H = $1fe2a1803f0c20d4$var$xe(e, S), P = $1fe2a1803f0c20d4$var$he(H, s, a);
            $1fe2a1803f0c20d4$var$Nt(O, P) || f(P.getFullYear());
        }
        E.preventDefault();
    }, p = [];
    let N = b;
    for(; p.length < $1fe2a1803f0c20d4$var$ge;){
        const E = N, S = $1fe2a1803f0c20d4$var$Ge($1fe2a1803f0c20d4$var$xe(e, E), s, a), L = E === u, y = E === w, O = y ? 0 : -1, D = $1fe2a1803f0c20d4$var$g("usa-date-picker__calendar__year", {
            "usa-date-picker__calendar__year--selected": L,
            "usa-date-picker__calendar__year--focused": y
        }), H = ()=>{
            n(E);
        }, P = ()=>{
            S || $1fe2a1803f0c20d4$var$it() || E !== w && f(E);
        };
        p.push(// Ignoring error: "The attribute aria-selected is not supported by the role button. This role is implicit on the element button."
        // Ignoring because this attribute is present in the USWDS implementation (https://github.com/uswds/uswds/blob/develop/src/js/components/date-picker.js#L1447)
        // eslint-disable-next-line jsx-a11y/role-supports-aria-props
        /* @__PURE__ */ (0, $21sFD.jsx)("button", {
            type: "button",
            tabIndex: O,
            ref: y ? v : null,
            className: D,
            "data-value": E,
            "aria-selected": L,
            disabled: S,
            onClick: H,
            onKeyDown: $,
            onMouseMove: P,
            children: E
        })), N += 1;
    }
    const A = ()=>{
        let E = w - $1fe2a1803f0c20d4$var$ge;
        E = Math.max(0, E);
        let S = $1fe2a1803f0c20d4$var$xe(e, E);
        S = $1fe2a1803f0c20d4$var$he(S, s, a), k([
            r.current,
            d.current
        ]), f(S.getFullYear());
    }, V = ()=>{
        let E = w + $1fe2a1803f0c20d4$var$ge;
        E = Math.max(0, E);
        let S = $1fe2a1803f0c20d4$var$xe(e, E);
        S = $1fe2a1803f0c20d4$var$he(S, s, a), k([
            o.current,
            d.current
        ]), f(S.getFullYear());
    };
    return(// Ignoring error: "Static HTML elements with event handlers require a role."
    // Ignoring because this element does not have a role in the USWDS implementation (https://github.com/uswds/uswds/blob/develop/src/js/components/date-picker.js#L1457)
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        tabIndex: -1,
        className: "usa-date-picker__calendar__year-picker",
        "data-testid": "calendar-year-picker",
        ref: d,
        onKeyDown: x,
        children: /* @__PURE__ */ (0, $21sFD.jsx)("table", {
            className: "usa-date-picker__calendar__table",
            role: "presentation",
            children: /* @__PURE__ */ (0, $21sFD.jsx)("tbody", {
                children: /* @__PURE__ */ (0, $21sFD.jsxs)("tr", {
                    children: [
                        /* @__PURE__ */ (0, $21sFD.jsx)("td", {
                            children: /* @__PURE__ */ (0, $21sFD.jsx)("button", {
                                type: "button",
                                "data-testid": "previous-year-chunk",
                                className: "usa-date-picker__calendar__previous-year-chunk",
                                "aria-label": `Navigate back ${$1fe2a1803f0c20d4$var$ge} years`,
                                disabled: M,
                                onClick: A,
                                ref: r
                            })
                        }),
                        /* @__PURE__ */ (0, $21sFD.jsx)("td", {
                            colSpan: 3,
                            children: /* @__PURE__ */ (0, $21sFD.jsx)("table", {
                                className: "usa-date-picker__calendar__table",
                                role: "presentation",
                                children: /* @__PURE__ */ (0, $21sFD.jsx)("tbody", {
                                    children: $1fe2a1803f0c20d4$var$nt(p, 3)
                                })
                            })
                        }),
                        /* @__PURE__ */ (0, $21sFD.jsx)("td", {
                            children: /* @__PURE__ */ (0, $21sFD.jsx)("button", {
                                type: "button",
                                "data-testid": "next-year-chunk",
                                className: "usa-date-picker__calendar__next-year-chunk",
                                "aria-label": `Navigate forward ${$1fe2a1803f0c20d4$var$ge} years`,
                                disabled: B,
                                onClick: V,
                                ref: o
                            })
                        })
                    ]
                })
            })
        })
    }));
}, $1fe2a1803f0c20d4$var$Me = {
    DATE_PICKER: "DATE_PICKER",
    MONTH_PICKER: "MONTH_PICKER",
    YEAR_PICKER: "YEAR_PICKER"
}, $1fe2a1803f0c20d4$var$Or = ({ date: e, selectedDate: s, handleSelectDate: a, minDate: n, maxDate: i, rangeDate: r, setStatuses: o, focusMode: v, i18n: d = $1fe2a1803f0c20d4$var$We })=>{
    const u = (0, $3RyIS.useRef)(null), w = (0, $3RyIS.useRef)(null), f = (0, $3RyIS.useRef)(null), _ = (0, $3RyIS.useRef)(null), k = (0, $3RyIS.useRef)(null), b = (0, $3RyIS.useRef)(null), M = (0, $3RyIS.useRef)(null), B = (0, $3RyIS.useRef)(null), [x, $] = (0, $3RyIS.useState)(e || $1fe2a1803f0c20d4$var$Ue()), [p, N] = (0, $3RyIS.useState)($1fe2a1803f0c20d4$var$Me.DATE_PICKER), [A, V] = (0, $3RyIS.useState)([
        null,
        null
    ]);
    let E = !0;
    const S = (T)=>{
        let W = $1fe2a1803f0c20d4$var$Le(x, T);
        W = $1fe2a1803f0c20d4$var$he(W, n, i), $(W), N($1fe2a1803f0c20d4$var$Me.DATE_PICKER);
    }, L = (T)=>{
        let W = $1fe2a1803f0c20d4$var$xe(x, T);
        W = $1fe2a1803f0c20d4$var$he(W, n, i), $(W), N($1fe2a1803f0c20d4$var$Me.DATE_PICKER);
    }, y = $1fe2a1803f0c20d4$var$Ee(x, 0), O = x.getMonth(), D = x.getFullYear(), H = d.months[parseInt(`${O}`)], P = d.daysOfWeekShort, j = d.daysOfWeek, G = d.backOneYear, ee = d.backOneMonth, ie = `${H}. ${d.selectMonth}`, U = `${D}. ${d.selectYear}`, X = d.forwardOneMonth, C = d.forwardOneYear;
    if ((0, $3RyIS.useEffect)(()=>{
        E = !1;
    }, []), (0, $3RyIS.useEffect)(()=>{
        e && p === $1fe2a1803f0c20d4$var$Me.DATE_PICKER && $(e);
    }, [
        e
    ]), (0, $3RyIS.useEffect)(()=>{
        if (v !== $1fe2a1803f0c20d4$var$yt.Input) {
            const [T, W] = A;
            if (T && W) T.disabled ? W.focus() : T.focus(), V([
                null,
                null
            ]);
            else {
                const De = B.current && B.current.querySelector(".usa-date-picker__calendar__date--focused");
                De && De.focus();
            }
        }
        if (E) {
            const T = [
                `${H} ${D}`
            ];
            if (s && $1fe2a1803f0c20d4$var$pe(y, s)) {
                const W = d.selectedDate;
                T.unshift(W);
            }
            o(T);
        }
    }, [
        x
    ]), p === $1fe2a1803f0c20d4$var$Me.MONTH_PICKER) return /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$Vr, {
        date: x,
        minDate: n,
        maxDate: i,
        handleSelectMonth: S,
        i18n: d
    });
    if (p === $1fe2a1803f0c20d4$var$Me.YEAR_PICKER) return /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$Br, {
        date: x,
        minDate: n,
        maxDate: i,
        handleSelectYear: L,
        setStatuses: o
    });
    const R = $1fe2a1803f0c20d4$var$Ze(x, 1), q = $1fe2a1803f0c20d4$var$$e(x, 1), Q = $1fe2a1803f0c20d4$var$at(x), re = $1fe2a1803f0c20d4$var$be(x, n), ve = i && $1fe2a1803f0c20d4$var$be(x, i), de = s || x, fe = r && $1fe2a1803f0c20d4$var$yr(de, r), Ce = r && $1fe2a1803f0c20d4$var$Lr(de, r), Be = fe && $1fe2a1803f0c20d4$var$Ee(fe, 1), Oe = Ce && $1fe2a1803f0c20d4$var$Qe(Ce, 1), Y = (T)=>{
        $1fe2a1803f0c20d4$var$ct(T, [
            u == null ? void 0 : u.current,
            w == null ? void 0 : w.current,
            k == null ? void 0 : k.current,
            b == null ? void 0 : b.current,
            f == null ? void 0 : f.current,
            _ == null ? void 0 : _.current,
            M == null ? void 0 : M.current
        ]);
    }, J = (T)=>{
        let W;
        switch(T.key){
            case "ArrowUp":
            case "Up":
                W = $1fe2a1803f0c20d4$var$Cr(x, 1);
                break;
            case "ArrowDown":
            case "Down":
                W = $1fe2a1803f0c20d4$var$Ct(x, 1);
                break;
            case "ArrowLeft":
            case "Left":
                W = $1fe2a1803f0c20d4$var$Qe(x, 1);
                break;
            case "ArrowRight":
            case "Right":
                W = $1fe2a1803f0c20d4$var$Ee(x, 1);
                break;
            case "Home":
                W = $1fe2a1803f0c20d4$var$gt(x);
                break;
            case "End":
                W = $1fe2a1803f0c20d4$var$Nr(x);
                break;
            case "PageDown":
                T.shiftKey ? W = $1fe2a1803f0c20d4$var$Je(x, 1) : W = $1fe2a1803f0c20d4$var$$e(x, 1);
                break;
            case "PageUp":
                T.shiftKey ? W = $1fe2a1803f0c20d4$var$ut(x, 1) : W = $1fe2a1803f0c20d4$var$Ze(x, 1);
                break;
            default:
                return;
        }
        if (W !== void 0) {
            const De = $1fe2a1803f0c20d4$var$he(W, n, i);
            $1fe2a1803f0c20d4$var$pe(x, De) || $(W);
        }
        T.preventDefault();
    }, te = (T)=>{
        T !== x && $(T);
    }, ne = ()=>{
        let T = $1fe2a1803f0c20d4$var$ut(x, 1);
        T = $1fe2a1803f0c20d4$var$he(T, n, i), $(T), V([
            u.current,
            B.current
        ]);
    }, me = ()=>{
        let T = $1fe2a1803f0c20d4$var$Ze(x, 1);
        T = $1fe2a1803f0c20d4$var$he(T, n, i), $(T), V([
            w.current,
            B.current
        ]);
    }, Ke = ()=>{
        let T = $1fe2a1803f0c20d4$var$$e(x, 1);
        T = $1fe2a1803f0c20d4$var$he(T, n, i), $(T), V([
            f.current,
            B.current
        ]);
    }, $t = ()=>{
        let T = $1fe2a1803f0c20d4$var$Je(x, 1);
        T = $1fe2a1803f0c20d4$var$he(T, n, i), $(T), V([
            _.current,
            B.current
        ]);
    }, Ht = ()=>{
        N($1fe2a1803f0c20d4$var$Me.MONTH_PICKER);
        const T = d.selectAMonth;
        o([
            T
        ]);
    }, Vt = ()=>{
        N($1fe2a1803f0c20d4$var$Me.YEAR_PICKER);
    }, Ae = [];
    let ce = $1fe2a1803f0c20d4$var$gt(Q);
    for(; Ae.length < 28 || ce.getMonth() === O || Ae.length % 7 !== 0;){
        const T = $1fe2a1803f0c20d4$var$pe(ce, y);
        Ae.push(/* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$Hr, {
            date: ce,
            onClick: a,
            onKeyDown: J,
            onMouseMove: te,
            ref: T ? M : null,
            isDisabled: !$1fe2a1803f0c20d4$var$Xe(ce, n, i),
            isSelected: s && $1fe2a1803f0c20d4$var$pe(ce, s),
            isFocused: T,
            isPrevMonth: $1fe2a1803f0c20d4$var$be(ce, R),
            isFocusedMonth: $1fe2a1803f0c20d4$var$be(ce, y),
            isNextMonth: $1fe2a1803f0c20d4$var$be(ce, q),
            isToday: $1fe2a1803f0c20d4$var$pe(ce, $1fe2a1803f0c20d4$var$Ue()),
            isRangeDate: r && $1fe2a1803f0c20d4$var$pe(ce, r),
            isRangeStart: fe && $1fe2a1803f0c20d4$var$pe(ce, fe),
            isRangeEnd: Ce && $1fe2a1803f0c20d4$var$pe(ce, Ce),
            isWithinRange: Be && Oe && $1fe2a1803f0c20d4$var$Xe(ce, Be, Oe),
            i18n: d
        })), ce = $1fe2a1803f0c20d4$var$Ee(ce, 1);
    }
    return(// Ignoring error: "Static HTML elements with event handlers require a role."
    // Ignoring because this element does not have a role in the USWDS implementation (https://github.com/uswds/uswds/blob/develop/src/js/components/date-picker.js#L1042)
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
        tabIndex: -1,
        className: "usa-date-picker__calendar__date-picker",
        "data-testid": "calendar-date-picker",
        ref: B,
        onKeyDown: Y,
        children: [
            /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
                className: "usa-date-picker__calendar__row",
                children: [
                    /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                        className: "usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items",
                        children: /* @__PURE__ */ (0, $21sFD.jsx)("button", {
                            type: "button",
                            "data-testid": "previous-year",
                            onClick: ne,
                            ref: u,
                            className: "usa-date-picker__calendar__previous-year",
                            "aria-label": G,
                            disabled: re
                        })
                    }),
                    /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                        className: "usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items",
                        children: /* @__PURE__ */ (0, $21sFD.jsx)("button", {
                            type: "button",
                            "data-testid": "previous-month",
                            onClick: me,
                            ref: w,
                            className: "usa-date-picker__calendar__previous-month",
                            "aria-label": ee,
                            disabled: re
                        })
                    }),
                    /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
                        className: "usa-date-picker__calendar__cell usa-date-picker__calendar__month-label",
                        children: [
                            /* @__PURE__ */ (0, $21sFD.jsx)("button", {
                                type: "button",
                                "data-testid": "select-month",
                                onClick: Ht,
                                ref: k,
                                className: "usa-date-picker__calendar__month-selection",
                                "aria-label": ie,
                                children: H
                            }),
                            /* @__PURE__ */ (0, $21sFD.jsx)("button", {
                                type: "button",
                                "data-testid": "select-year",
                                onClick: Vt,
                                ref: b,
                                className: "usa-date-picker__calendar__year-selection",
                                "aria-label": U,
                                children: D
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                        className: "usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items",
                        children: /* @__PURE__ */ (0, $21sFD.jsx)("button", {
                            type: "button",
                            "data-testid": "next-month",
                            onClick: Ke,
                            ref: f,
                            className: "usa-date-picker__calendar__next-month",
                            "aria-label": X,
                            disabled: ve
                        })
                    }),
                    /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                        className: "usa-date-picker__calendar__cell usa-date-picker__calendar__cell--center-items",
                        children: /* @__PURE__ */ (0, $21sFD.jsx)("button", {
                            type: "button",
                            "data-testid": "next-year",
                            onClick: $t,
                            ref: _,
                            className: "usa-date-picker__calendar__next-year",
                            "aria-label": C,
                            disabled: ve
                        })
                    })
                ]
            }),
            /* @__PURE__ */ (0, $21sFD.jsxs)("table", {
                className: "usa-date-picker__calendar__table",
                children: [
                    /* @__PURE__ */ (0, $21sFD.jsx)("thead", {
                        children: /* @__PURE__ */ (0, $21sFD.jsx)("tr", {
                            children: P.map((T, W)=>/* @__PURE__ */ (0, $21sFD.jsx)("th", {
                                    className: "usa-date-picker__calendar__day-of-week",
                                    scope: "col",
                                    "aria-label": j[parseInt(`${W}`)],
                                    children: T
                                }, `day-of-week-${T}-${W}`))
                        })
                    }),
                    /* @__PURE__ */ (0, $21sFD.jsx)("tbody", {
                        children: $1fe2a1803f0c20d4$var$nt(Ae, 7)
                    })
                ]
            })
        ]
    }));
};
var $1fe2a1803f0c20d4$var$yt = /* @__PURE__ */ ((e)=>(e[e.None = 0] = "None", e[e.Input = 1] = "Input", e))($1fe2a1803f0c20d4$var$yt || {});
const $1fe2a1803f0c20d4$export$5109c6dd95d8fb00 = ({ id: e, name: s, className: a, validationStatus: n, defaultValue: i, disabled: r, required: o, minDate: v = $1fe2a1803f0c20d4$var$_r, maxDate: d, rangeDate: u, onChange: w, onBlur: f, i18n: _ = $1fe2a1803f0c20d4$var$We, ...k })=>{
    const b = (0, $3RyIS.useRef)(null), M = (0, $3RyIS.useRef)(null), B = n === "error", x = n === "success", [$, p] = (0, $3RyIS.useState)(""), [N, A] = (0, $3RyIS.useState)(""), [V, E] = (0, $3RyIS.useState)(!1), [S, L] = (0, $3RyIS.useState)(void 0), [y, O] = (0, $3RyIS.useState)(0), [D, H] = (0, $3RyIS.useState)([]), [P, j] = (0, $3RyIS.useState)(0), [G, ee] = (0, $3RyIS.useState)(void 0), ie = $1fe2a1803f0c20d4$var$oe(v), U = d ? $1fe2a1803f0c20d4$var$oe(d) : void 0, X = u ? $1fe2a1803f0c20d4$var$oe(u) : void 0, C = ()=>{
        var J, te, ne, me;
        const Y = $1fe2a1803f0c20d4$var$wt(N, ie, U);
        Y && !((J = M == null ? void 0 : M.current) != null && J.validationMessage) && ((te = M == null ? void 0 : M.current) == null || te.setCustomValidity($1fe2a1803f0c20d4$var$vt)), !Y && ((ne = M == null ? void 0 : M.current) == null ? void 0 : ne.validationMessage) === $1fe2a1803f0c20d4$var$vt && ((me = M == null ? void 0 : M.current) == null || me.setCustomValidity(""));
    }, R = (Y, J = !0)=>{
        var me;
        const te = $1fe2a1803f0c20d4$var$oe(Y), ne = te && $1fe2a1803f0c20d4$var$le(te, $1fe2a1803f0c20d4$var$ye);
        te && p(Y), ne && A(ne), w && w(ne), J && (E(!1), H([]), (me = M == null ? void 0 : M.current) == null || me.focus());
    }, q = (Y)=>{
        const J = Y.target.value;
        A(J), w && w(J);
        const te = $1fe2a1803f0c20d4$var$oe(J, $1fe2a1803f0c20d4$var$ye, !0);
        let ne = "";
        if (te && !$1fe2a1803f0c20d4$var$wt(J, ie, U) && (ne = $1fe2a1803f0c20d4$var$le(te)), $ !== ne && p(ne), te && V) {
            const me = $1fe2a1803f0c20d4$var$he(te, ie, U);
            L(me);
        }
    };
    (0, $3RyIS.useEffect)(()=>{
        i && R(i, !1);
    }, []), (0, $3RyIS.useEffect)(()=>{
        if (V) {
            const Y = b.current && b.current.querySelector(".usa-date-picker__calendar__date--focused");
            Y && Y.focus();
        }
    }, [
        V
    ]), (0, $3RyIS.useEffect)(()=>{
        C();
    }, [
        N,
        v,
        d
    ]);
    const Q = ()=>{
        var Y;
        if (V) H([]);
        else {
            const J = $1fe2a1803f0c20d4$var$oe(N, $1fe2a1803f0c20d4$var$ye, !0), te = $1fe2a1803f0c20d4$var$he(J || i && $1fe2a1803f0c20d4$var$oe(i) || $1fe2a1803f0c20d4$var$Ue(), ie, U);
            L(te), O((Y = b == null ? void 0 : b.current) == null ? void 0 : Y.offsetHeight);
            const ne = _.statuses, me = $1fe2a1803f0c20d4$var$oe($);
            if (me && $1fe2a1803f0c20d4$var$pe(me, $1fe2a1803f0c20d4$var$Ee(te, 0))) {
                const Ke = _.selectedDate;
                ne.unshift(Ke);
            }
            H(ne);
        }
        E(!V);
    }, re = (Y)=>{
        var J;
        (J = b.current) != null && J.contains(Y == null ? void 0 : Y.relatedTarget) || (V && (E(!1), H([])), f && f(Y));
    }, ve = (Y)=>{
        var J;
        Y.key === "Escape" && (V && (E(!1), H([]), (J = M == null ? void 0 : M.current) == null || J.focus()), Y.preventDefault());
    }, de = (Y)=>{
        ee(Y.keyCode);
    }, fe = (Y)=>{
        Y.keyCode !== G && Y.preventDefault();
    }, Ce = $1fe2a1803f0c20d4$var$g("usa-date-picker", "usa-date-picker--initialized", {
        "usa-date-picker--active": V
    }, a), Be = $1fe2a1803f0c20d4$var$g("usa-input", "usa-date-picker__external-input", {
        "usa-input--error": B,
        "usa-input--success": x
    }), Oe = _.toggleCalendar;
    return(// Ignoring error: "Static HTML elements with event handlers require a role."
    // Ignoring because this element does not have a role in the USWDS implementation (https://github.com/uswds/uswds/blob/develop/src/js/components/date-picker.js#L828)
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
        "data-testid": "date-picker",
        className: Ce,
        ref: b,
        onBlur: re,
        onKeyDown: ve,
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)("input", {
                ...k,
                name: s,
                "data-testid": "date-picker-internal-input",
                className: "usa-input usa-sr-only usa-date-picker__internal-input",
                type: "text",
                "aria-hidden": !0,
                tabIndex: -1,
                required: !1,
                disabled: !1,
                value: $,
                readOnly: !0
            }),
            /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
                className: "usa-date-picker__wrapper",
                tabIndex: -1,
                children: [
                    /* @__PURE__ */ (0, $21sFD.jsx)("input", {
                        ...k,
                        id: e,
                        "data-testid": "date-picker-external-input",
                        className: Be,
                        type: "text",
                        disabled: r,
                        required: o,
                        value: N,
                        ref: M,
                        onInput: q,
                        onFocus: ()=>{
                            j(1);
                        },
                        onBlur: (Y)=>{
                            j(0), f && f(Y);
                        }
                    }),
                    /* @__PURE__ */ (0, $21sFD.jsx)("button", {
                        "data-testid": "date-picker-button",
                        type: "button",
                        className: "usa-date-picker__button",
                        "aria-haspopup": !0,
                        "aria-label": Oe,
                        disabled: r,
                        onClick: Q
                    }),
                    /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                        "data-testid": "date-picker-calendar",
                        className: "usa-date-picker__calendar",
                        role: "application",
                        hidden: !V,
                        "data-value": S && $1fe2a1803f0c20d4$var$le(S),
                        style: {
                            top: `${y}px`
                        },
                        onKeyDown: de,
                        onKeyUp: fe,
                        children: V && /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$Or, {
                            date: S,
                            handleSelectDate: R,
                            minDate: ie,
                            maxDate: U,
                            rangeDate: X,
                            selectedDate: $1fe2a1803f0c20d4$var$oe($),
                            setStatuses: H,
                            focusMode: P,
                            i18n: _
                        })
                    }),
                    /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                        "data-testid": "date-picker-status",
                        className: "usa-sr-only usa-date-picker__status",
                        role: "status",
                        "aria-live": "polite",
                        children: D.join(". ")
                    })
                ]
            })
        ]
    }));
}, $1fe2a1803f0c20d4$export$17334619f3ac2224 = (e)=>{
    const { startDateLabel: s, startDateHint: a, startDatePickerProps: n, endDateLabel: i, endDateHint: r, endDatePickerProps: o, className: v } = e, [d, u] = (0, $3RyIS.useState)(n.defaultValue), [w, f] = (0, $3RyIS.useState)(o.defaultValue), _ = ()=>{
        const { maxDate: S } = n, L = S && $1fe2a1803f0c20d4$var$oe(S), y = w && $1fe2a1803f0c20d4$var$oe(w);
        return y && L ? y.getTime() < L.getTime() ? $1fe2a1803f0c20d4$var$le(y) : $1fe2a1803f0c20d4$var$le(L) : y && $1fe2a1803f0c20d4$var$le(y) || L && $1fe2a1803f0c20d4$var$le(L) || void 0;
    }, k = ()=>{
        const { minDate: S } = o, L = S && $1fe2a1803f0c20d4$var$oe(S), y = d && $1fe2a1803f0c20d4$var$oe(d);
        return y && L ? y.getTime() > L.getTime() ? $1fe2a1803f0c20d4$var$le(y) : $1fe2a1803f0c20d4$var$le(L) : y && $1fe2a1803f0c20d4$var$le(y) || L && $1fe2a1803f0c20d4$var$le(L) || void 0;
    }, b = (S, L)=>(y)=>{
            const O = y && $1fe2a1803f0c20d4$var$oe(y, $1fe2a1803f0c20d4$var$ye);
            if (O) {
                const D = $1fe2a1803f0c20d4$var$le(O);
                L(D);
            } else L(y);
            S && S(y);
        }, M = b(n.onChange, u), B = b(o.onChange, f), x = $1fe2a1803f0c20d4$var$g(v, "usa-date-range-picker"), $ = $1fe2a1803f0c20d4$var$g(n.className, "usa-date-range-picker__range-start"), p = $1fe2a1803f0c20d4$var$g(o.className, "usa-date-range-picker__range-end"), N = `${n.id}-label`, A = `${n.id}-hint`, V = `${o.id}-label`, E = `${o.id}-hint`;
    return /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
        className: x,
        "data-testid": "date-range-picker",
        children: [
            /* @__PURE__ */ (0, $21sFD.jsxs)($1fe2a1803f0c20d4$export$2d00230e1e6f7fbc, {
                children: [
                    s && /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$b04be29aa201d4f5, {
                        id: N,
                        htmlFor: n.id,
                        children: s
                    }),
                    a && /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                        className: "usa-hint",
                        id: A,
                        children: a
                    }),
                    /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$5109c6dd95d8fb00, {
                        className: $,
                        rangeDate: w,
                        ...n,
                        "aria-labelledby": s && N,
                        "aria-describedby": a && A,
                        onChange: M,
                        maxDate: _()
                    })
                ]
            }),
            /* @__PURE__ */ (0, $21sFD.jsxs)($1fe2a1803f0c20d4$export$2d00230e1e6f7fbc, {
                children: [
                    i && /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$b04be29aa201d4f5, {
                        id: V,
                        htmlFor: o.id,
                        children: i
                    }),
                    r && /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                        className: "usa-hint",
                        id: E,
                        children: r
                    }),
                    /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$5109c6dd95d8fb00, {
                        className: p,
                        rangeDate: d,
                        ...o,
                        "aria-labelledby": i && V,
                        "aria-describedby": r && E,
                        onChange: B,
                        minDate: k()
                    })
                ]
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$915e9e7bd4f0f96d = ({ children: e, className: s, id: a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-error-message", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("span", {
        "data-testid": "errorMessage",
        className: n,
        id: a,
        role: "alert",
        children: e
    });
}, $1fe2a1803f0c20d4$export$e154be390aa0e14 = ({ children: e, legend: s, className: a, legendStyle: n = "default", requiredMarker: i, ...r })=>{
    const o = $1fe2a1803f0c20d4$var$g("usa-fieldset", a), v = $1fe2a1803f0c20d4$var$g({
        "usa-legend": n === "default",
        "usa-legend--large": n === "large",
        "usa-sr-only": n === "srOnly"
    });
    return /* @__PURE__ */ (0, $21sFD.jsxs)("fieldset", {
        "data-testid": "fieldset",
        className: o,
        ...r,
        children: [
            s && /* @__PURE__ */ (0, $21sFD.jsxs)("legend", {
                className: v,
                children: [
                    s,
                    i && /* @__PURE__ */ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
                        children: [
                            " ",
                            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$162b722f6dd80445, {})
                        ]
                    })
                ]
            }),
            e
        ]
    });
}, $1fe2a1803f0c20d4$var$ft = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", $1fe2a1803f0c20d4$var$Ar = ({ imageId: e, file: s })=>{
    const a = (0, $3RyIS.useRef)(new FileReader()), [n, i] = (0, $3RyIS.useState)(!0), [r, o] = (0, $3RyIS.useState)($1fe2a1803f0c20d4$var$ft), [v, d] = (0, $3RyIS.useState)(!1);
    (0, $3RyIS.useEffect)(()=>(a.current.onloadend = ()=>{
            i(!1), o(a.current.result);
        }, a.current.readAsDataURL(s), ()=>{
            a.current.onloadend = null;
        }), []);
    const { name: u } = s, w = ()=>{
        o($1fe2a1803f0c20d4$var$ft), d(!0);
    }, f = u.indexOf(".pdf") > 0, _ = u.indexOf(".doc") > 0 || u.indexOf(".pages") > 0, k = u.indexOf(".mov") > 0 || u.indexOf(".mp4") > 0, b = u.indexOf(".xls") > 0 || u.indexOf(".numbers") > 0, B = $1fe2a1803f0c20d4$var$g("usa-file-input__preview-image", {
        "is-loading": n,
        "usa-file-input__preview-image--pdf": v && f,
        "usa-file-input__preview-image--word": v && _,
        "usa-file-input__preview-image--video": v && k,
        "usa-file-input__preview-image--excel": v && b,
        "usa-file-input__preview-image--generic": v && !f && !_ && !k && !b
    });
    return /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
        "data-testid": "file-input-preview",
        className: "usa-file-input__preview",
        "aria-hidden": "true",
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)("img", {
                id: e,
                "data-testid": "file-input-preview-image",
                src: r,
                alt: "",
                className: B,
                onError: w
            }),
            u
        ]
    });
}, $1fe2a1803f0c20d4$var$Dr = (e)=>e.replace(/[^a-z0-9]/g, function(a) {
        const n = a.charCodeAt(0);
        return n === 32 ? "-" : n >= 65 && n <= 90 ? `img_${a.toLowerCase()}` : `__${n.toString(16).slice(-4)}`;
    }), $1fe2a1803f0c20d4$var$Tr = ({ name: e, id: s, dragText: a, chooseText: n, errorText: i, disabled: r, multiple: o, className: v, accept: d, onChange: u, onDrop: w, ...f }, _)=>{
    const k = (0, $3RyIS.useRef)(null), [b, M] = (0, $3RyIS.useState)(!1), [B, x] = (0, $3RyIS.useState)(!1), [$, p] = (0, $3RyIS.useState)([]), [N, A] = (0, $3RyIS.useState)(!1);
    (0, $3RyIS.useEffect)(()=>{
        if (typeof navigator > "u") return;
        const U = /rv:11.0/i.test(navigator == null ? void 0 : navigator.userAgent) || /Edge\/\d./i.test(navigator == null ? void 0 : navigator.userAgent);
        A(U);
    }, [
        typeof navigator
    ]), (0, $3RyIS.useImperativeHandle)(_, ()=>({
            input: k.current,
            clearFiles: ()=>p([]),
            files: $
        }), [
        $
    ]);
    const V = $1fe2a1803f0c20d4$var$g("usa-file-input", {
        "usa-file-input--disabled": r
    }, v), E = $1fe2a1803f0c20d4$var$g("usa-file-input__target", {
        "usa-file-input--drag": b,
        "has-invalid-file": B
    }), S = o ? "Drag files here or " : "Drag file here or ", L = "choose from folder", y = "This is not a valid file type.", O = [];
    if ($) for(let U = 0; U < ($ == null ? void 0 : $.length); U++){
        const X = $1fe2a1803f0c20d4$var$Dr($[parseInt(`${U}`)].name), C = `filePreview_${X}`;
        O.push(/* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$Ar, {
            imageId: X,
            file: $[parseInt(`${U}`)]
        }, C));
    }
    const D = $1fe2a1803f0c20d4$var$g("usa-file-input__instructions", {
        "display-none": O.length > 0
    }), H = O.length > 1 ? `${O.length} files selected` : "Selected file", P = (U)=>{
        if (x(!1), d) {
            const X = d.split(",");
            let C = !0;
            for(let R = 0; R < U.dataTransfer.files.length; R += 1){
                const q = U.dataTransfer.files[parseInt(`${R}`)];
                if (C) for(let Q = 0; Q < X.length; Q += 1){
                    const re = X[parseInt(`${Q}`)];
                    if (C = q.name.indexOf(re) > 0 || q.type.includes(re.replace(/\*/g, "")), C) break;
                }
                else break;
            }
            C || (p([]), x(!0), U.preventDefault(), U.stopPropagation());
        }
    }, j = ()=>M(!0), G = ()=>M(!1), ee = (U)=>{
        P(U), M(!1), w && w(U);
    }, ie = (U)=>{
        var C, R, q, Q;
        x(!1);
        const X = [];
        if ((R = (C = U.target) == null ? void 0 : C.files) != null && R.length) {
            const re = ((Q = (q = U.target) == null ? void 0 : q.files) == null ? void 0 : Q.length) || 0;
            for(let ve = 0; ve < re; ve++){
                const de = U.target.files.item(ve);
                de && X.push(de);
            }
        }
        p(X), u && u(U);
    };
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        "data-testid": "file-input",
        className: V,
        "aria-disabled": r,
        children: /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
            "data-testid": "file-input-droptarget",
            className: E,
            onDragOver: j,
            onDragLeave: G,
            onDrop: ee,
            children: [
                O.length > 0 && /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
                    "data-testid": "file-input-preview-heading",
                    className: "usa-file-input__preview-heading",
                    children: [
                        H,
                        " ",
                        /* @__PURE__ */ (0, $21sFD.jsxs)("span", {
                            className: "usa-file-input__choose",
                            children: [
                                "Change file",
                                O.length > 1 && "s"
                            ]
                        })
                    ]
                }),
                /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
                    "data-testid": "file-input-instructions",
                    className: D,
                    "aria-hidden": "true",
                    children: [
                        !N && /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                            className: "usa-file-input__drag-text",
                            children: a || S
                        }),
                        /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                            className: "usa-file-input__choose",
                            children: n || L
                        })
                    ]
                }),
                O,
                /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                    "data-testid": "file-input-box",
                    className: "usa-file-input__box"
                }),
                B && /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                    "data-testid": "file-input-error",
                    className: "usa-file-input__accepted-files-message",
                    children: i || y
                }),
                /* @__PURE__ */ (0, $21sFD.jsx)("input", {
                    ...f,
                    ref: k,
                    type: "file",
                    "data-testid": "file-input-input",
                    name: e,
                    id: s,
                    className: "usa-file-input__input",
                    disabled: r,
                    onChange: ie,
                    multiple: o,
                    accept: d
                })
            ]
        })
    });
}, $1fe2a1803f0c20d4$export$b57af79a4ab2a1c6 = (0, $3RyIS.forwardRef)($1fe2a1803f0c20d4$var$Tr), $1fe2a1803f0c20d4$export$a7fed597f4b8afd8 = ({ onSubmit: e, children: s, className: a, large: n, search: i, ...r })=>{
    const o = $1fe2a1803f0c20d4$var$g({
        "usa-form": !i,
        "usa-form--large": n
    }, a);
    return /* @__PURE__ */ (0, $21sFD.jsx)("form", {
        "data-testid": "form",
        className: o,
        onSubmit: e,
        ...r,
        children: s
    });
}, $1fe2a1803f0c20d4$export$6e5a9cd40e0c9b97 = ({ children: e, className: s, error: a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-input-group", {
        "usa-input-group--error": a
    }, s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        "data-testid": "inputGroup",
        className: n,
        children: e
    });
}, $1fe2a1803f0c20d4$export$1da9af5f304341ae = ({ className: e, children: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-input-prefix", e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: n,
        "aria-hidden": "true",
        ...a,
        "data-testid": "InputPrefix",
        children: s
    });
}, $1fe2a1803f0c20d4$export$73766b5928142d6e = ({ className: e, children: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-input-suffix", e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: n,
        "aria-hidden": "true",
        ...a,
        "data-testid": "InputSuffix",
        children: s
    });
}, $1fe2a1803f0c20d4$export$6ed84e2bd23b7cfb = ({ label: e, labelAttr: s, isOpen: a, onToggle: n, className: i, controls: r, ...o })=>{
    const v = $1fe2a1803f0c20d4$var$g("usa-button", "usa-language__link", i);
    return /* @__PURE__ */ (0, $21sFD.jsx)("button", {
        "data-testid": "languageSelectorButton",
        className: v,
        "aria-expanded": a,
        "aria-controls": r,
        onClick: ()=>n(),
        type: "button",
        ...o,
        children: s ? /* @__PURE__ */ (0, $21sFD.jsx)("span", {
            lang: s,
            children: e
        }) : e
    });
}, $1fe2a1803f0c20d4$export$6b43f262d1299a2e = ({ items: e, type: s, className: a, ...n })=>{
    const i = s === "primary", r = s === "secondary", o = s === "subnav", v = s === "megamenu", d = s === "footerSecondary", u = s === "language", w = $1fe2a1803f0c20d4$var$g({
        "usa-nav__primary usa-accordion": i,
        "usa-nav__secondary-links": r,
        "usa-nav__submenu": o,
        "usa-nav__submenu-list": v,
        "usa-list usa-list--unstyled": d,
        "usa-language__submenu": u
    }, a), f = $1fe2a1803f0c20d4$var$g({
        "usa-nav__primary-item": i,
        "usa-nav__secondary-item": r,
        "usa-nav__submenu-item": o || v,
        "usa-footer__secondary-link": d,
        "usa-language__submenu-item": u
    });
    return /* @__PURE__ */ (0, $21sFD.jsx)("ul", {
        className: w,
        ...n,
        children: e.map((_, k)=>/* @__PURE__ */ (0, $21sFD.jsx)("li", {
                className: f,
                children: _
            }, `item_${k}`))
    });
}, $1fe2a1803f0c20d4$export$d9b273488cd8ce6f = ({ className: e, items: s, isOpen: a, type: n, ...i })=>/* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$6b43f262d1299a2e, {
        className: e,
        items: s,
        type: n || "subnav",
        hidden: !a,
        ...i
    }), $1fe2a1803f0c20d4$var$Rr = (e)=>e.map((s, a)=>{
        const n = /* @__PURE__ */ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
            children: [
                /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                    lang: s.attr,
                    children: /* @__PURE__ */ (0, $21sFD.jsx)("strong", {
                        children: s.label
                    })
                }),
                s.label_local && ` (${s.label_local})`
            ]
        });
        return typeof s.on_click == "string" ? /* @__PURE__ */ (0, $21sFD.jsx)("a", {
            href: s.on_click,
            "data-testid": s.attr,
            children: n
        }, a) : /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$353f5b6fc5456de1, {
            onClick: s.on_click,
            "data-testid": s.attr,
            type: "button",
            unstyled: !0,
            children: n
        }, a);
    }), $1fe2a1803f0c20d4$var$Ur = ({ label: e, langs: s, small: a, className: n, displayLang: i, ...r })=>{
    const [o, v] = (0, $3RyIS.useState)(!1), d = $1fe2a1803f0c20d4$var$g("usa-language-container", {
        "usa-language--small": a !== void 0
    }, n), u = s.find((f)=>f.attr === i), w = "language-options";
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: d,
        "data-testid": "languageSelector",
        ...r,
        children: /* @__PURE__ */ (0, $21sFD.jsx)("ul", {
            className: "usa-language__primary usa-accordion",
            children: /* @__PURE__ */ (0, $21sFD.jsxs)("li", {
                className: "usa-language__primary-item",
                children: [
                    /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$6ed84e2bd23b7cfb, {
                        className: d,
                        label: (u == null ? void 0 : u.label) || e || s[0].label,
                        isOpen: o,
                        controls: w,
                        onToggle: ()=>v((f)=>!f)
                    }),
                    /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$d9b273488cd8ce6f, {
                        items: $1fe2a1803f0c20d4$var$Rr(s),
                        isOpen: o,
                        id: w,
                        type: "language"
                    })
                ]
            })
        })
    });
}, $1fe2a1803f0c20d4$export$ddd501dda1f62236 = ({ label: e, langs: s, small: a, className: n, displayLang: i, ...r })=>{
    const o = $1fe2a1803f0c20d4$var$g("usa-language-container", {
        "usa-language--small": a !== void 0
    }, n), [v, d] = (0, $3RyIS.useState)(!1);
    if (s.length > 2) return /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$Ur, {
        label: e,
        langs: s,
        small: a,
        displayLang: i,
        className: n
    });
    {
        e && console.warn("LanguageSelector's label is not used when only two languages are available.");
        const u = s.find((_)=>_.attr === i) || s[Number(v)], w = typeof u.on_click == "string" ? u.on_click : "", f = typeof u.on_click == "string" ? ()=>{
            window.location.assign(w);
        } : u.on_click;
        return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            className: o,
            "data-testid": "languageSelector",
            ...r,
            children: /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$6ed84e2bd23b7cfb, {
                className: o,
                label: u.label,
                labelAttr: u.attr,
                onToggle: ()=>{
                    f(), i || d((_)=>!_);
                }
            })
        });
    }
}, $1fe2a1803f0c20d4$export$d7b12c4107be0d61 = ({ id: e, name: s, className: a, label: n, inputRef: i, tile: r, labelDescription: o, ...v })=>{
    const d = $1fe2a1803f0c20d4$var$g("usa-radio", a), u = $1fe2a1803f0c20d4$var$g("usa-radio__input", {
        "usa-radio__input--tile": r
    });
    return /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
        "data-testid": "radio",
        className: d,
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)("input", {
                className: u,
                id: e,
                type: "radio",
                name: s,
                ref: i,
                ...v
            }),
            /* @__PURE__ */ (0, $21sFD.jsxs)("label", {
                className: "usa-radio__label",
                htmlFor: e,
                children: [
                    n,
                    o && /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                        className: "usa-checkbox__label-description",
                        children: o
                    })
                ]
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$f5603a09670563b9 = ({ className: e, inputRef: s, textPreposition: a, textUnit: n, ...i })=>{
    const r = $1fe2a1803f0c20d4$var$g("usa-range", e), o = 0, v = 100, d = Math.round(v / 2), u = "", w = "of", { min: f, max: _, defaultValue: k, value: b, ...M } = i, B = f || o, x = _ || v, $ = n || u, p = a || w, N = b !== void 0 ? b : k !== void 0 ? k : d, [A, V] = (0, $3RyIS.useState)(N), E = `${A} ${$} ${p} ${x}`;
    return /* @__PURE__ */ (0, $21sFD.jsx)("input", {
        "data-testid": "range",
        "aria-valuetext": E,
        className: r,
        ref: s,
        type: "range",
        ...M,
        min: B,
        max: x,
        value: A,
        onChange: (S)=>V(Number(S.target.value))
    });
}, $1fe2a1803f0c20d4$export$ef9b1a59e592288f = ({ id: e, name: s, className: a, inputRef: n, children: i, validationStatus: r, ...o })=>{
    const u = $1fe2a1803f0c20d4$var$g("usa-select", {
        "usa-input--error": r === "error",
        "usa-input--success": r === "success"
    }, a);
    return /* @__PURE__ */ (0, $21sFD.jsx)("select", {
        "data-testid": "Select",
        className: u,
        id: e,
        name: s,
        ref: n,
        ...o,
        children: i
    });
};
function $1fe2a1803f0c20d4$var$je(e, s, a) {
    const n = a || s, i = a ? e.replace(/\W/g, "") : e.replace(/\D/g, ""), r = (w)=>!Number.isNaN(parseInt(w, 10)), o = (w)=>w ? w.match(/[A-Z]/i) : !1, v = "_#dDmMyY9", d = "A";
    let u = "";
    for(let w = 0, f = 0; w < n.length; w++){
        const _ = r(i[f]), k = o(i[f]), b = v.indexOf(n[w]) >= 0, M = d.indexOf(n[w]) >= 0;
        if (b && _ || a && M && k) u += i[f++];
        else {
            if (i[f] === void 0 || // if no characters left and the pattern is non-special character
            !a && !_ && b || a && (M && !k || b && !k)) break;
            u += n[w];
        }
    }
    return u;
}
const $1fe2a1803f0c20d4$export$c2fcfdf13c04ed4d = ({ id: e, className: s, mask: a, value: n, defaultValue: i, charset: r, onChange: o, ...v })=>{
    const d = $1fe2a1803f0c20d4$var$g({
        "usa-masked": a
    }, s), [u, w] = (0, $3RyIS.useState)(// Ensure that this component preserves the expected behavior when a user sets the defaultValue
    $1fe2a1803f0c20d4$var$je(n ?? i ?? "", a, r));
    (0, $3RyIS.useEffect)(()=>{
        w($1fe2a1803f0c20d4$var$je(n ?? i ?? "", a, r));
    }, [
        n
    ]);
    const [f, _] = (0, $3RyIS.useState)(a.substring(u.length)), k = (b)=>{
        const M = $1fe2a1803f0c20d4$var$je(b.target.value, a, r);
        _(a.substring(M.length)), w(M), b.target.value = M, o == null || o(b);
    };
    return /* @__PURE__ */ (0, $21sFD.jsxs)("span", {
        className: "usa-input-mask",
        children: [
            /* @__PURE__ */ (0, $21sFD.jsxs)("span", {
                className: "usa-input-mask--content",
                "aria-hidden": !0,
                "data-testid": `${e}Mask`,
                children: [
                    /* @__PURE__ */ (0, $21sFD.jsx)("i", {
                        children: u
                    }),
                    f
                ]
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$c86715117507e8e5, {
                "data-testid": "textInput",
                className: d,
                id: e,
                maxLength: a.length,
                onChange: k,
                value: u,
                ...v
            })
        ]
    });
}, $1fe2a1803f0c20d4$var$Mt = (e)=>{
    let s;
    if (e) {
        const [a, n] = e.split(":").map((i)=>{
            let r;
            const o = parseInt(i, 10);
            return Number.isNaN(o) || (r = o), r;
        });
        a != null && n != null && (s = a * 60 + n);
    }
    return s;
}, $1fe2a1803f0c20d4$var$Yr = (e)=>{
    const s = e % 60, a = Math.floor(e / 60), n = a % 12 || 12, i = a < 12 ? "am" : "pm";
    return {
        minute: s,
        hour24: a,
        hour12: n,
        ampm: i
    };
}, $1fe2a1803f0c20d4$var$qe = (e, s)=>`0000${e}`.slice(-s), $1fe2a1803f0c20d4$var$Wr = (e, s, a)=>{
    const n = [];
    for(let i = e; i <= s; i += a){
        const { minute: r, hour24: o, hour12: v, ampm: d } = $1fe2a1803f0c20d4$var$Yr(i);
        n.push({
            value: `${$1fe2a1803f0c20d4$var$qe(o, 2)}:${$1fe2a1803f0c20d4$var$qe(r, 2)}`,
            label: `${v}:${$1fe2a1803f0c20d4$var$qe(r, 2)}${d}`
        });
    }
    return n;
}, $1fe2a1803f0c20d4$var$Kr = "23:59", $1fe2a1803f0c20d4$var$Ir = 1439, $1fe2a1803f0c20d4$var$Zr = "00:00", $1fe2a1803f0c20d4$var$Gr = 0, $1fe2a1803f0c20d4$var$jr = 30, $1fe2a1803f0c20d4$var$xt = 1, $1fe2a1803f0c20d4$var$qr = {
    filter: "0?{{ hourQueryFilter }}:{{minuteQueryFilter}}.*{{ apQueryFilter }}m?",
    extras: {
        apQueryFilter: "([ap])",
        hourQueryFilter: "([1-9][0-2]?)",
        minuteQueryFilter: "[\\d]+:([0-9]{0,2})"
    }
}, $1fe2a1803f0c20d4$export$5f876910ea565cd3 = ({ id: e, name: s, onChange: a, label: n, defaultValue: i, disabled: r, minTime: o = $1fe2a1803f0c20d4$var$Zr, maxTime: v = $1fe2a1803f0c20d4$var$Kr, step: d = $1fe2a1803f0c20d4$var$jr, hint: u, className: w })=>{
    const f = $1fe2a1803f0c20d4$var$g("usa-time-picker", w), _ = $1fe2a1803f0c20d4$var$Mt(o) || $1fe2a1803f0c20d4$var$Gr, k = $1fe2a1803f0c20d4$var$Mt(v) || $1fe2a1803f0c20d4$var$Ir, b = d < $1fe2a1803f0c20d4$var$xt ? $1fe2a1803f0c20d4$var$xt : d, M = (0, $3RyIS.useMemo)(()=>$1fe2a1803f0c20d4$var$Wr(_, k, b), [
        o,
        v,
        d
    ]), B = `${s}-label`, x = `${s}-hint`;
    return /* @__PURE__ */ (0, $21sFD.jsxs)($1fe2a1803f0c20d4$export$2d00230e1e6f7fbc, {
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$b04be29aa201d4f5, {
                className: "usa-label",
                id: B,
                htmlFor: e,
                children: n
            }),
            u && /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                className: "usa-hint",
                id: x,
                children: u
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$72b9695b8216309a, {
                id: e,
                name: s,
                className: f,
                onChange: a,
                defaultValue: i,
                options: M,
                disabled: r,
                customFilter: $1fe2a1803f0c20d4$var$qr,
                disableFiltering: !0
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$cb2516900eaef313 = ({ children: e, className: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g(s, "usa-checklist");
    return /* @__PURE__ */ (0, $21sFD.jsx)("ul", {
        className: n,
        "data-testid": "validationChecklist",
        ...a,
        children: e
    });
}, $1fe2a1803f0c20d4$export$785e6f5643079170 = ({ children: e, className: s, isValid: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-checklist__item", {
        "usa-checklist__item--checked": a
    }, s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("li", {
        className: i,
        ...n,
        children: e
    });
}, $1fe2a1803f0c20d4$export$504945ce5da4b7ea = ({ onClick: e, className: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-nav__close", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("button", {
        className: n,
        onClick: e,
        "data-testid": "navCloseButton",
        "aria-label": "Close Navigation Menu",
        ...a,
        type: "button",
        children: /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$f04a61298a47a40f.Close, {
            size: 3,
            "aria-hidden": "true"
        })
    });
}, $1fe2a1803f0c20d4$export$a4c45cb7e5079cd = ({ primaryItems: e, secondaryItems: s, mobileExpanded: a = !1, children: n, className: i, onToggleMobileNav: r, ...o })=>{
    const v = $1fe2a1803f0c20d4$var$g("usa-nav", {
        "is-visible": a
    }, i);
    return /* @__PURE__ */ (0, $21sFD.jsx)("nav", {
        className: v,
        ...o,
        children: /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
            className: "usa-nav__inner",
            children: [
                /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$504945ce5da4b7ea, {
                    onClick: r
                }),
                /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$6b43f262d1299a2e, {
                    items: e,
                    type: "primary"
                }),
                /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
                    className: "usa-nav__secondary",
                    children: [
                        /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$6b43f262d1299a2e, {
                            items: s,
                            type: "secondary"
                        }),
                        n
                    ]
                })
            ]
        })
    });
}, $1fe2a1803f0c20d4$export$8b251419efc915eb = ({ basic: e, extended: s, basicWithMegaMenu: a, children: n, showMobileOverlay: i, className: r, ...o })=>{
    const v = $1fe2a1803f0c20d4$var$g("usa-header", {
        "usa-header--basic": e,
        "usa-header--megamenu": a,
        "usa-header--extended": s
    }, r), d = $1fe2a1803f0c20d4$var$g("usa-overlay", {
        "is-visible": i
    });
    return /* @__PURE__ */ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
        children: [
            i !== void 0 && /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                className: d,
                "data-testid": "overlay"
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)("header", {
                "data-testid": "header",
                className: v,
                ...o,
                children: n
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$aee42d298194d478 = ({ items: e, isOpen: s, className: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-nav__submenu usa-megamenu", a);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: i,
        hidden: !s,
        "data-testid": "megamenu",
        children: /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            className: "grid-row grid-gap-4",
            children: e.map((r, o)=>/* @__PURE__ */ (0, $21sFD.jsx)("div", {
                    className: "usa-col",
                    children: /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$6b43f262d1299a2e, {
                        items: r,
                        type: "megamenu",
                        ...n
                    })
                }, `subnav_col_${o}`))
        })
    });
}, $1fe2a1803f0c20d4$export$16a8a20e3cbcd702 = ({ label: e, onClick: s, ...a })=>/* @__PURE__ */ (0, $21sFD.jsx)("button", {
        className: "usa-menu-btn",
        onClick: s,
        "data-testid": "navMenuButton",
        ...a,
        type: "button",
        children: e
    }), $1fe2a1803f0c20d4$export$4fc25bfa0f22e533 = ({ label: e, menuId: s, isOpen: a, onToggle: n, isCurrent: i, className: r, ...o })=>{
    const v = $1fe2a1803f0c20d4$var$g("usa-accordion__button", "usa-nav__link", {
        "usa-current": i
    }, r);
    return /* @__PURE__ */ (0, $21sFD.jsx)("button", {
        "data-testid": "navDropDownButton",
        className: v,
        "aria-expanded": a,
        "aria-controls": s,
        onClick: ()=>n(),
        ...o,
        type: "button",
        children: /* @__PURE__ */ (0, $21sFD.jsx)("span", {
            children: e
        })
    });
}, $1fe2a1803f0c20d4$export$4baff8562c6306d7 = ({ items: e, onToggleMobileNav: s, mobileExpanded: a, children: n, className: i, ...r })=>{
    const o = $1fe2a1803f0c20d4$var$g("usa-nav", {
        "is-visible": a
    }, i);
    return /* @__PURE__ */ (0, $21sFD.jsxs)("nav", {
        className: o,
        ...r,
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$504945ce5da4b7ea, {
                onClick: s
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$6b43f262d1299a2e, {
                items: e,
                type: "primary"
            }),
            n
        ]
    });
}, $1fe2a1803f0c20d4$export$f99233281efd08a0 = ({ className: e, children: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-logo", e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: n,
        ...a,
        children: /* @__PURE__ */ (0, $21sFD.jsx)("em", {
            className: "usa-logo__text",
            children: s
        })
    });
}, $1fe2a1803f0c20d4$export$527d32aa1785fdd4 = ({ children: e, className: s })=>{
    const a = $1fe2a1803f0c20d4$var$g(s, "usa-icon-list");
    return /* @__PURE__ */ (0, $21sFD.jsx)("ul", {
        className: a,
        "data-testid": "iconList",
        children: e
    });
}, $1fe2a1803f0c20d4$export$d1c25a7354cbf0c = ({ className: e, children: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g(e, "usa-icon-list__content");
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: n,
        ...a,
        "data-testid": "iconListContent",
        children: s
    });
}, $1fe2a1803f0c20d4$export$f424945adde69ae9 = ({ className: e, children: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g(e, "usa-icon-list__icon");
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: n,
        ...a,
        "data-testid": "iconListIcon",
        children: s
    });
}, $1fe2a1803f0c20d4$export$6a05cf27bd63cbe9 = ({ className: e, children: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g(e, "usa-icon-list__item");
    return /* @__PURE__ */ (0, $21sFD.jsx)("li", {
        className: n,
        ...a,
        "data-testid": "iconListItem",
        children: s
    });
}, $1fe2a1803f0c20d4$export$96c96dfb564e8bfe = ({ type: e, children: s, className: a })=>{
    const n = $1fe2a1803f0c20d4$var$g(a, "usa-icon-list__title");
    return /* @__PURE__ */ (0, $21sFD.jsx)(e, {
        className: n,
        "data-testid": "iconListTitle",
        children: s
    });
}, $1fe2a1803f0c20d4$export$989167234458594d = ({ className: e, children: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-identifier", e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        "data-testid": "identifier",
        className: n,
        ...a,
        children: s
    });
}, $1fe2a1803f0c20d4$export$7f36700136933134 = ({ children: e, className: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-identifier__section usa-identifier__section--usagov", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("section", {
        "data-testid": "identifierGov",
        className: n,
        ...a,
        children: /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            className: "usa-identifier__container",
            children: e
        })
    });
}, $1fe2a1803f0c20d4$export$d9f78b632f8309d4 = ({ children: e, domain: s, className: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-identifier__identity", a);
    return /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
        "data-testid": "identifierIdentity",
        className: i,
        ...n,
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)("p", {
                className: "usa-identifier__identity-domain",
                children: s
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)("p", {
                className: "usa-identifier__identity-disclaimer",
                children: e
            })
        ]
    });
};
function $1fe2a1803f0c20d4$export$9e6c201f5547b27f({ className: e, ...s }) {
    const a = $1fe2a1803f0c20d4$var$g(e, "usa-identifier__required-link"), n = {
        ...s,
        className: a
    };
    return $1fe2a1803f0c20d4$var$Ye(n) ? /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$a6c7ac8248d6e38a, {
        ...n
    }) : /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$a6c7ac8248d6e38a, {
        ...n
    });
}
const $1fe2a1803f0c20d4$export$89ca14efc3cb83f0 = ({ children: e, className: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-identifier__required-links-item", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("li", {
        className: n,
        ...a,
        children: e
    });
}, $1fe2a1803f0c20d4$export$4a4313f82efe3c12 = ({ children: e, className: s, navProps: a, listProps: n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-identifier__section usa-identifier__section--required-links", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("nav", {
        className: i,
        ...a,
        children: /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            className: "usa-identifier__container",
            children: /* @__PURE__ */ (0, $21sFD.jsx)("ul", {
                className: "usa-identifier__required-links-list",
                ...n,
                children: e
            })
        })
    });
}, $1fe2a1803f0c20d4$export$d96f3172140b84e9 = ({ children: e, className: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-identifier__logo", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("a", {
        className: n,
        ...a,
        children: e
    });
}, $1fe2a1803f0c20d4$export$a81647eaadb8d42 = ({ children: e, className: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-identifier__logos", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        "data-testid": "identifierLogos",
        className: n,
        ...a,
        children: e
    });
}, $1fe2a1803f0c20d4$export$3b5a5c2f147d18d8 = ({ className: e, children: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-identifier__section usa-identifier__section--masthead", e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("section", {
        "data-testid": "identifierMasthead",
        className: n,
        ...a,
        children: /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            className: "usa-identifier__container",
            children: s
        })
    });
}, $1fe2a1803f0c20d4$export$73974d1f547d9d48 = ({ size: e, className: s, items: a })=>{
    const n = e === "big", i = e === "medium", r = e === "slim", o = $1fe2a1803f0c20d4$var$g("usa-footer__address", s), v = $1fe2a1803f0c20d4$var$g({
        "grid-col-auto": n || i,
        "grid-col-auto mobile-lg:grid-col-12 desktop:grid-col-auto": r
    });
    return /* @__PURE__ */ (0, $21sFD.jsx)("address", {
        className: o,
        children: r ? /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            className: "grid-row grid-gap",
            children: a.map((d, u)=>/* @__PURE__ */ (0, $21sFD.jsx)("div", {
                    className: v,
                    children: /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                        className: "usa-footer__contact-info",
                        children: d
                    })
                }, `addressItem-${u}`))
        }) : /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            className: "usa-footer__contact-info grid-row grid-gap",
            children: a.map((d, u)=>/* @__PURE__ */ (0, $21sFD.jsx)("div", {
                    className: v,
                    children: d
                }, `addressItem-${u}`))
        })
    });
}, $1fe2a1803f0c20d4$export$a06f1c675e846f6f = ({ size: e, returnToTop: s, primary: a, secondary: n, ...i })=>{
    const r = $1fe2a1803f0c20d4$var$g("usa-footer", {
        "usa-footer--big": e === "big",
        "usa-footer--medium": e === "medium",
        "usa-footer--slim": e === "slim"
    }, i.className);
    return /* @__PURE__ */ (0, $21sFD.jsxs)("footer", {
        ...i,
        className: r,
        children: [
            s && s,
            /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                className: "usa-footer__primary-section",
                children: a
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                className: "usa-footer__secondary-section",
                children: /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                    className: "grid-container",
                    children: n
                })
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$b005084e04de8f45 = ({ className: e, isMobile: s, nestedLinks: a })=>{
    const n = $1fe2a1803f0c20d4$var$g("grid-row grid-gap-4", e), i = window && typeof window == "object", [r, o] = (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).useState(i && window.innerWidth < 480), [v, d] = (0, $3RyIS.useState)(Array(a.length).fill(!1)), u = s || s === void 0 && r;
    (0, $3RyIS.useEffect)(()=>{
        if (s) return;
        function f() {
            const _ = i && window.innerWidth < 480;
            _ !== r && o(_);
        }
        return window.addEventListener("resize", f), ()=>window.removeEventListener("resize", f);
    }, []);
    const w = (f)=>{
        d((_)=>{
            const k = Array(a.length).fill(!1);
            return k[f] = !_[f], k;
        });
    };
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: n,
        children: a.map((f, _)=>/* @__PURE__ */ (0, $21sFD.jsx)("div", {
                className: "mobile-lg:grid-col-6 desktop:grid-col-3",
                children: /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$Jr, {
                    onToggle: u ? ()=>w(_) : void 0,
                    isOpen: u ? v[_] : !0,
                    links: f
                })
            }, `linkSection-${_}`))
    });
}, $1fe2a1803f0c20d4$var$Jr = ({ isOpen: e = !1, links: s, onToggle: a })=>{
    const [n, ...i] = s, r = $1fe2a1803f0c20d4$var$g("usa-footer__primary-content usa-footer__primary-content--collapsible", {
        hidden: !e
    });
    return(// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ (0, $21sFD.jsxs)("section", {
        className: r,
        onClick: a,
        onKeyPress: a,
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)("h4", {
                className: "usa-footer__primary-link",
                children: n
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$6b43f262d1299a2e, {
                type: "footerSecondary",
                items: i
            })
        ]
    }));
};
function $1fe2a1803f0c20d4$var$Et(e) {
    return e[0].constructor === Array;
}
const $1fe2a1803f0c20d4$export$3210cca7a959581e = ({ className: e, size: s, isMobile: a, links: n, ...i })=>{
    const r = s === "big", o = s === "medium", v = s === "slim", d = $1fe2a1803f0c20d4$var$g("usa-footer__nav", e), u = $1fe2a1803f0c20d4$var$g("desktop:grid-col-auto usa-footer__primary-content", {
        "mobile-lg:grid-col-4": r || o,
        "mobile-lg:grid-col-6": v
    });
    return /* @__PURE__ */ (0, $21sFD.jsxs)("nav", {
        className: d,
        ...i,
        children: [
            r && $1fe2a1803f0c20d4$var$Et(n) && /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$b005084e04de8f45, {
                isMobile: a,
                nestedLinks: n
            }),
            !$1fe2a1803f0c20d4$var$Et(n) && /* @__PURE__ */ (0, $21sFD.jsx)("ul", {
                className: "grid-row grid-gap",
                children: n.map((w, f)=>/* @__PURE__ */ (0, $21sFD.jsx)("li", {
                        className: u,
                        children: w
                    }, `navLink-${f}`))
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$e6ff31bff12b7ff4 = ({ size: e, heading: s, image: a, ...n })=>{
    const i = e === "big", r = e === "medium", o = e === "slim", v = $1fe2a1803f0c20d4$var$g("usa-footer__logo grid-row", {
        "mobile-lg:grid-col-6 mobile-lg:grid-gap-2": i || r,
        "grid-gap-2": o
    }, n.className), d = $1fe2a1803f0c20d4$var$g({
        "mobile-lg:grid-col-auto": i || r,
        "grid-col-auto": o
    });
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: v,
        "data-testid": "footerLogo",
        children: /* @__PURE__ */ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
            children: [
                /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                    className: d,
                    children: a
                }),
                s && /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                    className: d,
                    children: s
                })
            ]
        })
    });
}, $1fe2a1803f0c20d4$export$1782e62edd12a1f5 = ({ className: e, links: s })=>{
    const a = $1fe2a1803f0c20d4$var$g("usa-footer__social-links grid-row grid-gap-1", e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: a,
        children: s.map((n, i)=>/* @__PURE__ */ (0, $21sFD.jsx)("div", {
                className: "grid-col-auto",
                children: n
            }, `socialLink${i}`))
    });
}, $1fe2a1803f0c20d4$export$cc8afd413c65875b = ({ name: e, ...s })=>{
    let a;
    switch(e){
        case "Facebook":
            a = $1fe2a1803f0c20d4$export$f04a61298a47a40f.Facebook;
            break;
        case "Twitter":
            a = $1fe2a1803f0c20d4$export$f04a61298a47a40f.Twitter;
            break;
        case "YouTube":
            a = $1fe2a1803f0c20d4$export$f04a61298a47a40f.Youtube;
            break;
        case "Instagram":
            a = $1fe2a1803f0c20d4$export$f04a61298a47a40f.Instagram;
            break;
        case "RSS":
            a = $1fe2a1803f0c20d4$export$f04a61298a47a40f.RssFeed;
            break;
    }
    return /* @__PURE__ */ (0, $21sFD.jsx)("a", {
        className: "usa-social-link",
        ...s,
        title: e,
        children: a && /* @__PURE__ */ (0, $21sFD.jsx)(a, {
            className: "usa-social-link__icon",
            name: e,
            "aria-hidden": "true"
        })
    });
}, $1fe2a1803f0c20d4$var$Xr = (e)=>{
    const [s, a] = (0, $3RyIS.useState)(e || !1), n = (r)=>{
        const o = r.target;
        return r && o && o.closest(".usa-modal") ? o.hasAttribute("[data-close-modal]") || !!o.closest("[data-close-modal]") : !0;
    };
    return {
        isOpen: s,
        toggleModal: (r, o)=>r && !n(r) ? (r.stopPropagation(), !1) : (a(o === !0 ? !0 : o === !1 ? !1 : (v)=>!v), !0)
    };
}, $1fe2a1803f0c20d4$var$el = ()=>{
    var e;
    if (typeof document < "u") {
        const s = document.createElement("div");
        s.setAttribute("style", "visibility: hidden; overflow: scroll; ms-overflow-style: scrollbar"), document.body.appendChild(s);
        const a = document.createElement("div");
        s.appendChild(a);
        const n = `${s.offsetWidth - a.offsetWidth}px`;
        return (e = s.parentNode) == null || e.removeChild(s), n;
    }
    return "";
}, $1fe2a1803f0c20d4$var$tl = ({ handleClose: e, ...s })=>/* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$353f5b6fc5456de1, {
        "aria-label": "Close this window",
        ...s,
        className: "usa-modal__close",
        onClick: e,
        "data-close-modal": !0,
        type: "button",
        children: /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$f04a61298a47a40f.Close, {
            "aria-hidden": "true"
        })
    }), $1fe2a1803f0c20d4$var$sl = ({ modalId: e, className: s, children: a, handleClose: n, isLarge: i = !1, forceAction: r = !1, ...o }, v)=>{
    const d = $1fe2a1803f0c20d4$var$g("usa-modal", {
        "usa-modal--lg": i
    }, s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        ...o,
        "data-testid": "modalWindow",
        className: d,
        ref: v,
        "data-force-action": r,
        children: /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
            className: "usa-modal__content",
            children: [
                /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                    className: "usa-modal__main",
                    children: a
                }),
                !r && /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$tl, {
                    "aria-controls": e,
                    handleClose: n
                })
            ]
        })
    });
}, $1fe2a1803f0c20d4$var$al = (0, $3RyIS.forwardRef)($1fe2a1803f0c20d4$var$sl), $1fe2a1803f0c20d4$var$nl = ({ id: e, children: s, isVisible: a, forceAction: n, className: i, handleClose: r, ...o }, v)=>{
    const d = $1fe2a1803f0c20d4$var$g("usa-modal-wrapper", {
        "is-visible": a,
        "is-hidden": !a
    }, i);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        ...o,
        ref: v,
        id: e,
        className: d,
        role: "dialog",
        children: /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            "data-testid": "modalOverlay",
            className: "usa-modal-overlay",
            onClick: n ? void 0 : r,
            "aria-controls": e,
            children: s
        })
    });
}, $1fe2a1803f0c20d4$var$cl = (0, $3RyIS.forwardRef)($1fe2a1803f0c20d4$var$nl), $1fe2a1803f0c20d4$var$il = ({ id: e, children: s, isLarge: a = !1, forceAction: n = !1, modalRoot: i = ".usa-modal-wrapper", renderToPortal: r = !0, isInitiallyOpen: o, ...v }, d)=>{
    const { isOpen: u, toggleModal: w } = $1fe2a1803f0c20d4$var$Xr(o), [f, _] = (0, $3RyIS.useState)(!1), k = (0, $3RyIS.useRef)(), b = (0, $3RyIS.useRef)(), M = (0, $3RyIS.useRef)(null), x = `body > *:not(${i || ".usa-modal-wrapper"}):not([aria-hidden])`, $ = "[data-modal-hidden]", p = (O)=>{
        w(O, !1);
    };
    (0, $3RyIS.useImperativeHandle)(d, ()=>({
            modalId: e,
            modalIsOpen: u,
            toggleModal: w
        }), [
        e,
        u
    ]);
    const N = ()=>{
        const { body: O } = document;
        O.style.paddingRight = b.current || "", O.classList.add("usa-js-modal--active"), document.querySelectorAll(x).forEach((D)=>{
            D.setAttribute("aria-hidden", "true"), D.setAttribute("data-modal-hidden", "");
        }), n && O.classList.add("usa-js-no-click");
    }, A = ()=>{
        const { body: O } = document;
        O.style.paddingRight = k.current || "", O.classList.remove("usa-js-modal--active"), O.classList.remove("usa-js-no-click"), document.querySelectorAll($).forEach((D)=>{
            D.removeAttribute("aria-hidden"), D.removeAttribute("data-modal-hidden");
        });
    };
    (0, $3RyIS.useEffect)(()=>{
        const O = $1fe2a1803f0c20d4$var$el(), D = window.getComputedStyle(document.body).getPropertyValue("padding-right") || "0px", H = `${parseInt(D.replace(/px/, ""), 10) + parseInt(O.replace(/px/, ""), 10)}px`;
        return k.current = D, b.current = H, _(!0), ()=>{
            A();
        };
    }, []), (0, $3RyIS.useEffect)(()=>{
        f && (u === !0 ? N() : u === !1 && A());
    }, [
        u
    ]);
    const V = v["aria-labelledby"], E = v["aria-describedby"];
    V || console.error(`${e} is missing aria-labelledby attribute`), E || console.error(`${e} is missing aria-describedby attribute`), delete v["aria-labelledby"], delete v["aria-describedby"];
    const y = /* @__PURE__ */ (0, $21sFD.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dzGKu))), {
        active: u,
        focusTrapOptions: {
            initialFocus: ()=>{
                var D;
                const O = (D = M.current) == null ? void 0 : D.querySelector("[data-focus]");
                return O || M.current || !1;
            },
            escapeDeactivates: ()=>n ? !1 : (p(), !0)
        },
        children: /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$cl, {
            role: "dialog",
            id: e,
            "aria-labelledby": V,
            "aria-describedby": E,
            "data-force-action": n,
            isVisible: u,
            handleClose: p,
            forceAction: n,
            children: /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$al, {
                modalId: e,
                ...v,
                ref: M,
                isLarge: a,
                forceAction: n,
                tabIndex: -1,
                handleClose: p,
                children: s
            })
        })
    });
    if (r) {
        const D = document.getElementById("modal-root") || document.body;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3qHRY))).createPortal(y, D);
    } else return y;
}, $1fe2a1803f0c20d4$export$2b77a92f1a5ad772 = (0, $3RyIS.forwardRef)($1fe2a1803f0c20d4$var$il), $1fe2a1803f0c20d4$export$29c3cd616cf888ad = ({ modalRef: e, children: s, opener: a, closer: n, ...i })=>{
    var v;
    const r = (d)=>{
        if (!e || !e.current) return console.error("ModalRef is required"), !1;
        i.onClick && i.onClick(d), a && !n ? e.current.toggleModal(d, !0) : n && !a ? e.current.toggleModal(d, !1) : e.current.toggleModal(d);
    }, o = {
        "data-close-modal": !0,
        "data-open-modal": !0
    };
    return a && !n && delete o["data-close-modal"], n && !a && delete o["data-open-modal"], /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$353f5b6fc5456de1, {
        ...i,
        ...o,
        type: "button",
        "aria-controls": (v = e == null ? void 0 : e.current) == null ? void 0 : v.modalId,
        onClick: r,
        children: s
    });
};
function $1fe2a1803f0c20d4$export$2c683708ecc20550({ modalRef: e, ...s }) {
    var r;
    const a = (o)=>{
        if (!e || !e.current) return console.error("ModalRef is required"), !1;
        o.preventDefault(), e.current.toggleModal(o, !0);
    }, n = {
        ...s,
        role: "button",
        "aria-controls": (r = e == null ? void 0 : e.current) == null ? void 0 : r.modalId,
        "data-open-modal": !0,
        onClick: a
    };
    return $1fe2a1803f0c20d4$var$Ye(n) ? /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$a6c7ac8248d6e38a, {
        ...n
    }) : /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$a6c7ac8248d6e38a, {
        ...n
    });
}
const $1fe2a1803f0c20d4$export$9af27c346834c182 = ({ className: e, children: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-modal__heading", e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("h2", {
        className: n,
        ...a,
        children: s
    });
}, $1fe2a1803f0c20d4$export$519437715052e656 = ({ children: e, className: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-modal__footer", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: n,
        "data-testid": "modalFooter",
        ...a,
        children: e
    });
}, $1fe2a1803f0c20d4$export$9acc0474485b44b2 = ({ children: e, className: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-card-group", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("ul", {
        className: n,
        "data-testid": "CardGroup",
        ...a,
        children: e
    });
}, $1fe2a1803f0c20d4$export$60332b2344f7fe41 = ({ layout: e = "standardDefault", headerFirst: s, children: a, className: n, gridLayout: i, containerProps: r, ...o })=>{
    const { className: v, ...d } = r || {}, u = i && $1fe2a1803f0c20d4$var$dr(i), w = $1fe2a1803f0c20d4$var$g("usa-card", {
        "usa-card--header-first": s,
        "usa-card--flag": e === "flagDefault" || e === "flagMediaRight",
        "usa-card--media-right": e === "flagMediaRight"
    }, u, n), f = $1fe2a1803f0c20d4$var$g("usa-card__container", v);
    return /* @__PURE__ */ (0, $21sFD.jsx)("li", {
        className: w,
        "data-testid": "Card",
        ...o,
        children: /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            className: f,
            ...d,
            children: a
        })
    });
}, $1fe2a1803f0c20d4$export$5665775b26e26c5d = ({ exdent: e, children: s, className: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-card__header", {
        "usa-card__header--exdent": e
    }, a);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: i,
        ...n,
        "data-testid": "CardHeader",
        children: s
    });
}, $1fe2a1803f0c20d4$export$4aa095286866240f = ({ exdent: e, inset: s, imageClass: a, children: n, className: i, ...r })=>{
    const o = $1fe2a1803f0c20d4$var$g("usa-card__media", {
        "usa-card__media--exdent": e,
        "usa-card__media--inset": s
    }, i), v = $1fe2a1803f0c20d4$var$g("usa-card__img", a);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: o,
        ...r,
        "data-testid": "CardMedia",
        children: /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            className: v,
            children: n
        })
    });
}, $1fe2a1803f0c20d4$export$851de33184ecdac4 = ({ exdent: e, children: s, className: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-card__body", {
        "usa-card__body--exdent": e
    }, a);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: i,
        ...n,
        "data-testid": "CardBody",
        children: s
    });
}, $1fe2a1803f0c20d4$export$e9897d434e0741ee = ({ exdent: e, children: s, className: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-card__footer", {
        "usa-card__footer--exdent": e
    }, a);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: i,
        ...n,
        "data-testid": "CardFooter",
        children: s
    });
}, $1fe2a1803f0c20d4$export$9f18a7f63b4119cb = ({ variant: e = "default", children: s, className: a, navProps: n, listProps: i })=>{
    const r = $1fe2a1803f0c20d4$var$g("usa-breadcrumb", {
        "usa-breadcrumb--wrap": e === "wrap"
    }, a);
    return /* @__PURE__ */ (0, $21sFD.jsx)("nav", {
        className: r,
        "aria-label": "Breadcrumbs",
        ...n,
        children: /* @__PURE__ */ (0, $21sFD.jsx)("ol", {
            className: "usa-breadcrumb__list",
            ...i,
            children: s
        })
    });
}, $1fe2a1803f0c20d4$export$dabcc1ec9dd9d1cc = ({ children: e, current: s = !1, className: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-breadcrumb__list-item", {
        "usa-current": s
    }, a);
    return /* @__PURE__ */ (0, $21sFD.jsx)("li", {
        className: i,
        "aria-current": s ? "page" : void 0,
        ...n,
        children: e
    });
};
function $1fe2a1803f0c20d4$export$ca871f5ef145e138({ className: e, ...s }) {
    const a = $1fe2a1803f0c20d4$var$g(e, "usa-breadcrumb__link"), n = {
        ...s,
        className: a
    };
    return $1fe2a1803f0c20d4$var$Ye(n) ? /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$a6c7ac8248d6e38a, {
        ...n,
        variant: "unstyled"
    }) : /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$a6c7ac8248d6e38a, {
        ...n,
        variant: "unstyled"
    });
}
const $1fe2a1803f0c20d4$export$a765b9dee96eca0e = (e)=>{
    const { showLabels: s = !0, counters: a = "none", centered: n = !1, children: i, className: r, divProps: o, listProps: v, headingProps: d, headingLevel: u, stepText: w = "Step", ofText: f = "of", statusText: _ = {
        complete: "completed",
        incomplete: "not completed"
    } } = e, k = u, { className: b, ...M } = o || {}, { className: B, ...x } = v || {}, { className: $, ...p } = d || {}, N = $1fe2a1803f0c20d4$var$g("usa-step-indicator", {
        "usa-step-indicator--no-labels": !s,
        "usa-step-indicator--counters": a === "default",
        "usa-step-indicator--counters-sm": a === "small",
        "usa-step-indicator--center": n
    }, r, b), A = $1fe2a1803f0c20d4$var$g("usa-step-indicator__segments", B), V = $1fe2a1803f0c20d4$var$g("usa-step-indicator__heading", $), S = (()=>{
        const H = i.findIndex((P)=>P.props.status === "current");
        return H === -1 ? 0 : H;
    })(), L = S + 1, y = i[parseInt(`${S}`)].props.label, O = i.length, D = (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).Children.map(i, (H)=>(0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).cloneElement(H, {
            statusText: _
        }));
    return /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
        className: N,
        "data-testid": "step-indicator",
        "aria-label": "progress",
        ...M,
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)("ol", {
                className: A,
                ...x,
                children: D
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)("div", {
                className: "usa-step-indicator__header",
                children: /* @__PURE__ */ (0, $21sFD.jsxs)(k, {
                    className: V,
                    ...p,
                    children: [
                        /* @__PURE__ */ (0, $21sFD.jsxs)("span", {
                            className: "usa-step-indicator__heading-counter",
                            children: [
                                /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                                    className: "usa-sr-only",
                                    "data-testid": "step-text",
                                    children: w
                                }),
                                /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                                    className: "usa-step-indicator__current-step",
                                    children: L
                                }),
                                "\xa0",
                                /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                                    className: "usa-step-indicator__total-steps",
                                    children: `${f} ${O}`
                                }),
                                "\xa0"
                            ]
                        }),
                        /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                            className: "usa-step-indicator__heading-text",
                            children: y
                        })
                    ]
                })
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$43295839114af587 = (e)=>{
    const { label: s, status: a = "incomplete", statusText: n = {
        complete: "completed",
        incomplete: "not completed"
    }, className: i, ...r } = e, o = $1fe2a1803f0c20d4$var$g("usa-step-indicator__segment", {
        "usa-step-indicator__segment--complete": a === "complete",
        "usa-step-indicator__segment--current": a === "current"
    }, i);
    return /* @__PURE__ */ (0, $21sFD.jsx)("li", {
        className: o,
        "aria-current": a === "current" ? "true" : void 0,
        ...r,
        children: /* @__PURE__ */ (0, $21sFD.jsxs)("span", {
            className: "usa-step-indicator__segment-label",
            children: [
                s,
                "\xa0",
                a !== "current" && /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                    "data-testid": "srStatusText",
                    className: "usa-sr-only",
                    children: a === "complete" ? n.complete : n.incomplete
                })
            ]
        })
    });
}, $1fe2a1803f0c20d4$var$ol = ({ isBig: e, className: s, placeholder: a, defaultValue: n, inputName: i = "search", label: r = "Search", inputId: o = "search-field", inputProps: v })=>{
    const d = $1fe2a1803f0c20d4$var$g({
        "usa-search--big": e
    }, s);
    return /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
        className: d,
        "data-testid": "searchField",
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$b04be29aa201d4f5, {
                srOnly: !0,
                htmlFor: o,
                children: r
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$c86715117507e8e5, {
                ...v,
                id: o,
                name: i,
                type: "search",
                placeholder: a,
                defaultValue: n
            })
        ]
    });
}, $1fe2a1803f0c20d4$var$rl = ({ size: e, className: s, i18n: a, buttonAriaLabel: n })=>{
    const i = (a == null ? void 0 : a.buttonText) || "Search", r = e === "small", v = $1fe2a1803f0c20d4$var$g({
        "usa-search--small": r,
        "usa-search--big": e === "big"
    }, s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: v,
        children: /* @__PURE__ */ (0, $21sFD.jsxs)($1fe2a1803f0c20d4$export$353f5b6fc5456de1, {
            "aria-label": n || i,
            type: "submit",
            children: [
                !r && /* @__PURE__ */ (0, $21sFD.jsx)("span", {
                    className: "usa-search__submit-text",
                    children: i
                }),
                /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$export$f04a61298a47a40f.Search, {
                    className: "usa-search__submit-icon",
                    name: i,
                    size: 3,
                    "aria-hidden": !0
                })
            ]
        })
    });
}, $1fe2a1803f0c20d4$export$4b85d3515bd863a5 = ({ onSubmit: e, size: s, className: a, placeholder: n, inputName: i = "search", label: r = "Search", inputId: o = "search-field", i18n: v, buttonAriaLabel: d, inputProps: u, ...w })=>{
    const f = $1fe2a1803f0c20d4$var$g("usa-search", a);
    return /* @__PURE__ */ (0, $21sFD.jsxs)($1fe2a1803f0c20d4$export$a7fed597f4b8afd8, {
        onSubmit: e,
        className: f,
        role: "search",
        search: !0,
        ...w,
        children: [
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$ol, {
                ...u,
                isBig: s == "big",
                inputId: o,
                placeholder: n,
                name: i,
                label: r,
                defaultValue: w.defaultValue
            }),
            /* @__PURE__ */ (0, $21sFD.jsx)($1fe2a1803f0c20d4$var$rl, {
                size: s,
                i18n: v,
                buttonAriaLabel: d
            })
        ]
    });
}, $1fe2a1803f0c20d4$export$2e1a5bb9d2fd5c1e = ({ children: e, className: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-summary-box", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: n,
        "data-testid": "summary-box",
        ...a,
        children: /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            className: "usa-summary-box__body",
            children: e
        })
    });
}, $1fe2a1803f0c20d4$export$ad1a55e8dd3094c9 = ({ children: e, className: s, headingLevel: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-summary-box__heading", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)(a, {
        className: i,
        ...n,
        children: e
    });
}, $1fe2a1803f0c20d4$export$b2ae27d4e5696623 = ({ children: e, className: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-summary-box__text", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)("div", {
        className: n,
        ...a,
        children: e
    });
}, $1fe2a1803f0c20d4$export$afd3bbbb1044354a = ({ className: e, children: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-process-list", e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("ol", {
        className: n,
        ...a,
        children: s
    });
}, $1fe2a1803f0c20d4$export$c121f6427b3ae86f = ({ className: e, children: s, ...a })=>{
    const n = $1fe2a1803f0c20d4$var$g("usa-process-list__item", e);
    return /* @__PURE__ */ (0, $21sFD.jsx)("li", {
        className: n,
        ...a,
        children: s
    });
}, $1fe2a1803f0c20d4$export$1da437d77233d00f = ({ type: e, className: s, children: a, ...n })=>{
    const i = $1fe2a1803f0c20d4$var$g("usa-process-list__heading", s);
    return /* @__PURE__ */ (0, $21sFD.jsx)(e, {
        "data-testid": "processListHeading",
        className: i,
        ...n,
        children: a
    });
}, $1fe2a1803f0c20d4$export$8a6ca22c8941eb13 = ({ variant: e, children: s, heading: a, showIcon: n = !0, slim: i = !1, className: r, ...o })=>{
    const v = $1fe2a1803f0c20d4$var$g("usa-site-alert", {
        "usa-site-alert--info": e === "info",
        "usa-site-alert--emergency": e === "emergency",
        "usa-site-alert--no-heading": a === void 0 && !i,
        "usa-site-alert--no-icon": !n,
        "usa-site-alert--slim": i
    }, r);
    let d = s;
    return typeof s == "string" && (d = /* @__PURE__ */ (0, $21sFD.jsx)("p", {
        className: "usa-alert__text",
        children: s
    })), /* @__PURE__ */ (0, $21sFD.jsx)("section", {
        "data-testid": "siteAlert",
        className: v,
        "aria-label": "Site alert",
        ...o,
        children: /* @__PURE__ */ (0, $21sFD.jsx)("div", {
            className: "usa-alert",
            children: /* @__PURE__ */ (0, $21sFD.jsxs)("div", {
                className: "usa-alert__body",
                children: [
                    a && /* @__PURE__ */ (0, $21sFD.jsx)("h3", {
                        className: "usa-alert__heading",
                        children: a
                    }),
                    d
                ]
            })
        })
    });
};

});
parcelRegister("dzGKu", function(module, exports) {
"use strict";
function $9e1fb441673deefc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9e1fb441673deefc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9e1fb441673deefc$var$_typeof(o);
}
function $9e1fb441673deefc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9e1fb441673deefc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $9e1fb441673deefc$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $9e1fb441673deefc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9e1fb441673deefc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9e1fb441673deefc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9e1fb441673deefc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9e1fb441673deefc$var$_setPrototypeOf(subClass, superClass);
}
function $9e1fb441673deefc$var$_setPrototypeOf(o, p) {
    $9e1fb441673deefc$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9e1fb441673deefc$var$_setPrototypeOf(o, p);
}
function $9e1fb441673deefc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9e1fb441673deefc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $9e1fb441673deefc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9e1fb441673deefc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9e1fb441673deefc$var$_possibleConstructorReturn(this, result);
    };
}
function $9e1fb441673deefc$var$_possibleConstructorReturn(self, call) {
    if (call && ($9e1fb441673deefc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9e1fb441673deefc$var$_assertThisInitialized(self);
}
function $9e1fb441673deefc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9e1fb441673deefc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9e1fb441673deefc$var$_getPrototypeOf(o) {
    $9e1fb441673deefc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9e1fb441673deefc$var$_getPrototypeOf(o);
}
function $9e1fb441673deefc$var$_defineProperty(obj, key, value) {
    key = $9e1fb441673deefc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9e1fb441673deefc$var$_toPropertyKey(arg) {
    var key = $9e1fb441673deefc$var$_toPrimitive(arg, "string");
    return $9e1fb441673deefc$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9e1fb441673deefc$var$_toPrimitive(input, hint) {
    if ($9e1fb441673deefc$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9e1fb441673deefc$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $3RyIS = parcelRequire("3RyIS");

var $ifjYT = parcelRequire("ifjYT");

var $4sttu = parcelRequire("4sttu");
var $9e1fb441673deefc$var$createFocusTrap = $4sttu.createFocusTrap;

var $ivXgI = parcelRequire("ivXgI");
var $9e1fb441673deefc$var$isFocusable = $ivXgI.isFocusable;
var $9e1fb441673deefc$var$FocusTrap = /*#__PURE__*/ function(_React$Component) {
    $9e1fb441673deefc$var$_inherits(FocusTrap, _React$Component);
    var _super = $9e1fb441673deefc$var$_createSuper(FocusTrap);
    function FocusTrap(props) {
        var _this;
        $9e1fb441673deefc$var$_classCallCheck(this, FocusTrap);
        _this = _super.call(this, props);
        /**
     * Gets the node for the given option, which is expected to be an option that
     *  can be either a DOM node, a string that is a selector to get a node, `false`
     *  (if a node is explicitly NOT given), or a function that returns any of these
     *  values.
     * @param {string} optionName
     * @returns {undefined | false | HTMLElement | SVGElement} Returns
     *  `undefined` if the option is not specified; `false` if the option
     *  resolved to `false` (node explicitly not given); otherwise, the resolved
     *  DOM node.
     * @throws {Error} If the option is set, not `false`, and is not, or does not
     *  resolve to a node.
     */ $9e1fb441673deefc$var$_defineProperty($9e1fb441673deefc$var$_assertThisInitialized(_this), "getNodeForOption", function(optionName) {
            var _this$internalOptions;
            // use internal options first, falling back to original options
            var optionValue = (_this$internalOptions = this.internalOptions[optionName]) !== null && _this$internalOptions !== void 0 ? _this$internalOptions : this.originalOptions[optionName];
            if (typeof optionValue === "function") {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
                optionValue = optionValue.apply(void 0, params);
            }
            if (optionValue === true) optionValue = undefined; // use default value
            if (!optionValue) {
                if (optionValue === undefined || optionValue === false) return optionValue;
                // else, empty string (invalid), null (invalid), 0 (invalid)
                throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
            }
            var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
            if (typeof optionValue === "string") {
                var _this$getDocument;
                node = (_this$getDocument = this.getDocument()) === null || _this$getDocument === void 0 ? void 0 : _this$getDocument.querySelector(optionValue); // resolve to node, or null if fails
                if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
            }
            return node;
        });
        _this.handleDeactivate = _this.handleDeactivate.bind($9e1fb441673deefc$var$_assertThisInitialized(_this));
        _this.handlePostDeactivate = _this.handlePostDeactivate.bind($9e1fb441673deefc$var$_assertThisInitialized(_this));
        _this.handleClickOutsideDeactivates = _this.handleClickOutsideDeactivates.bind($9e1fb441673deefc$var$_assertThisInitialized(_this));
        // focus-trap options used internally when creating the trap
        _this.internalOptions = {
            // We need to hijack the returnFocusOnDeactivate option,
            // because React can move focus into the element before we arrived at
            // this lifecycle hook (e.g. with autoFocus inputs). So the component
            // captures the previouslyFocusedElement in componentWillMount,
            // then (optionally) returns focus to it in componentWillUnmount.
            returnFocusOnDeactivate: false,
            // the rest of these are also related to deactivation of the trap, and we
            //  need to use them and control them as well
            checkCanReturnFocus: null,
            onDeactivate: _this.handleDeactivate,
            onPostDeactivate: _this.handlePostDeactivate,
            // we need to special-case this setting as well so that we can know if we should
            //  NOT return focus if the trap gets auto-deactivated as the result of an
            //  outside click (otherwise, we'll always think we should return focus because
            //  of how we manage that flag internally here)
            clickOutsideDeactivates: _this.handleClickOutsideDeactivates
        };
        // original options provided by the consumer
        _this.originalOptions = {
            // because of the above `internalOptions`, we maintain our own flag for
            //  this option, and default it to `true` because that's focus-trap's default
            returnFocusOnDeactivate: true,
            // because of the above `internalOptions`, we keep these separate since
            //  they're part of the deactivation process which we configure (internally) to
            //  be shared between focus-trap and focus-trap-react
            onDeactivate: null,
            onPostDeactivate: null,
            checkCanReturnFocus: null,
            // the user's setting, defaulted to false since focus-trap defaults this to false
            clickOutsideDeactivates: false
        };
        var focusTrapOptions = props.focusTrapOptions;
        for(var optionName in focusTrapOptions){
            if (!Object.prototype.hasOwnProperty.call(focusTrapOptions, optionName)) continue;
            if (optionName === "returnFocusOnDeactivate" || optionName === "onDeactivate" || optionName === "onPostDeactivate" || optionName === "checkCanReturnFocus" || optionName === "clickOutsideDeactivates") {
                _this.originalOptions[optionName] = focusTrapOptions[optionName];
                continue; // exclude from internalOptions
            }
            _this.internalOptions[optionName] = focusTrapOptions[optionName];
        }
        // if set, `{ target: Node, allowDeactivation: boolean }` where `target` is the outside
        //  node that was clicked, and `allowDeactivation` is the result of the consumer's
        //  option (stored in `this.originalOptions.clickOutsideDeactivates`, which may be a
        //  function) whether to allow or deny auto-deactivation on click on this outside node
        _this.outsideClick = null;
        // elements from which to create the focus trap on mount; if a child is used
        //  instead of the `containerElements` prop, we'll get the child's related
        //  element when the trap renders and then is declared 'mounted'
        _this.focusTrapElements = props.containerElements || [];
        // now we remember what the currently focused element is, not relying on focus-trap
        _this.updatePreviousElement();
        return _this;
    }
    /**
   * Gets the configured document.
   * @returns {Document|undefined} Configured document, falling back to the main
   *  document, if it exists. During SSR, `undefined` is returned since the
   *  document doesn't exist.
   */ $9e1fb441673deefc$var$_createClass(FocusTrap, [
        {
            key: "getDocument",
            value: function getDocument() {
                // SSR: careful to check if `document` exists before accessing it as a variable
                return this.props.focusTrapOptions.document || (typeof document !== "undefined" ? document : undefined);
            }
        },
        {
            key: "getReturnFocusNode",
            value: function getReturnFocusNode() {
                var node = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
                return node ? node : node === false ? false : this.previouslyFocusedElement;
            }
        },
        {
            key: "updatePreviousElement",
            value: function updatePreviousElement() {
                var currentDocument = this.getDocument();
                if (currentDocument) this.previouslyFocusedElement = currentDocument.activeElement;
            }
        },
        {
            key: "deactivateTrap",
            value: function deactivateTrap() {
                // NOTE: it's possible the focus trap has already been deactivated without our knowing it,
                //  especially if the user set the `clickOutsideDeactivates: true` option on the trap,
                //  and the mouse was clicked on some element outside the trap; at that point, focus-trap
                //  will initiate its auto-deactivation process, which will call our own
                //  handleDeactivate(), which will call into this method
                if (!this.focusTrap || !this.focusTrap.active) return;
                this.focusTrap.deactivate({
                    // NOTE: we never let the trap return the focus since we do that ourselves
                    returnFocus: false,
                    // we'll call this in our own post deactivate handler so make sure the trap doesn't
                    //  do it prematurely
                    checkCanReturnFocus: null,
                    // let it call the user's original deactivate handler, if any, instead of
                    //  our own which calls back into this function
                    onDeactivate: this.originalOptions.onDeactivate
                });
            }
        },
        {
            key: "handleClickOutsideDeactivates",
            value: function handleClickOutsideDeactivates(event) {
                // use consumer's option (or call their handler) as the permission or denial
                var allowDeactivation = typeof this.originalOptions.clickOutsideDeactivates === "function" ? this.originalOptions.clickOutsideDeactivates.call(null, event) // call out of context
                 : this.originalOptions.clickOutsideDeactivates; // boolean
                if (allowDeactivation) // capture the outside target that was clicked so we can use it in the deactivation
                //  process since the consumer allowed it to cause auto-deactivation
                this.outsideClick = {
                    target: event.target,
                    allowDeactivation: allowDeactivation
                };
                return allowDeactivation;
            }
        },
        {
            key: "handleDeactivate",
            value: function handleDeactivate() {
                if (this.originalOptions.onDeactivate) this.originalOptions.onDeactivate.call(null); // call user's handler out of context
                this.deactivateTrap();
            }
        },
        {
            key: "handlePostDeactivate",
            value: function handlePostDeactivate() {
                var _this2 = this;
                var finishDeactivation = function finishDeactivation() {
                    var returnFocusNode = _this2.getReturnFocusNode();
                    var canReturnFocus = !!// did the consumer allow it?
                    (_this2.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
                    returnFocusNode !== null && returnFocusNode !== void 0 && returnFocusNode.focus && // was there an outside click that allowed deactivation?
                    (!_this2.outsideClick || // did the consumer allow deactivation when the outside node was clicked?
                    _this2.outsideClick.allowDeactivation && // is the outside node NOT focusable (implying that it did NOT receive focus
                    //  as a result of the click-through) -- in which case do NOT restore focus
                    //  to `returnFocusNode` because focus should remain on the outside node
                    !$9e1fb441673deefc$var$isFocusable(_this2.outsideClick.target, _this2.internalOptions.tabbableOptions)));
                    var _this2$internalOption = _this2.internalOptions.preventScroll, preventScroll = _this2$internalOption === void 0 ? false : _this2$internalOption;
                    if (canReturnFocus) // return focus to the element that had focus when the trap was activated
                    returnFocusNode.focus({
                        preventScroll: preventScroll
                    });
                    if (_this2.originalOptions.onPostDeactivate) _this2.originalOptions.onPostDeactivate.call(null); // don't call it in context of "this"
                    _this2.outsideClick = null; // reset: no longer needed
                };
                if (this.originalOptions.checkCanReturnFocus) this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()) // call out of context
                .then(finishDeactivation, finishDeactivation);
                else finishDeactivation();
            }
        },
        {
            key: "setupFocusTrap",
            value: function setupFocusTrap() {
                if (this.focusTrap) // trap already exists: it's possible we're in StrictMode and we're being remounted,
                //  in which case, we will have deactivated the trap when we got unmounted (remember,
                //  StrictMode, in development, purposely unmounts and remounts components after
                //  mounting them the first time to make sure they have reusable state,
                //  @see https://reactjs.org/docs/strict-mode.html#ensuring-reusable-state) so now
                //  we need to restore the state of the trap according to our component state
                // NOTE: Strict mode __violates__ assumptions about the `componentWillUnmount()` API
                //  which clearly states -- even for React 18 -- that, "Once a component instance is
                //  unmounted, __it will never be mounted again.__" (emphasis ours). So when we get
                //  unmounted, we assume we're gone forever and we deactivate the trap. But then
                //  we get remounted and we're supposed to restore state. But if you had paused,
                //  we've now deactivated (we don't know we're amount to get remounted again)
                //  which means we need to reactivate and then pause. Otherwise, do nothing.
                {
                    if (this.props.active && !this.focusTrap.active) {
                        this.focusTrap.activate();
                        if (this.props.paused) this.focusTrap.pause();
                    }
                } else {
                    var nodesExist = this.focusTrapElements.some(Boolean);
                    if (nodesExist) {
                        // eslint-disable-next-line react/prop-types -- _createFocusTrap is an internal prop
                        this.focusTrap = this.props._createFocusTrap(this.focusTrapElements, this.internalOptions);
                        if (this.props.active) this.focusTrap.activate();
                        if (this.props.paused) this.focusTrap.pause();
                    }
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.active) this.setupFocusTrap();
            // else, wait for later activation in case the `focusTrapOptions` will be updated
            //  again before the trap is activated (e.g. if waiting to know what the document
            //  object will be, so the Trap must be rendered, but the consumer is waiting to
            //  activate until they have obtained the document from a ref)
            //  @see https://github.com/focus-trap/focus-trap-react/issues/539
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.focusTrap) {
                    if (prevProps.containerElements !== this.props.containerElements) this.focusTrap.updateContainerElements(this.props.containerElements);
                    var hasActivated = !prevProps.active && this.props.active;
                    var hasDeactivated = prevProps.active && !this.props.active;
                    var hasPaused = !prevProps.paused && this.props.paused;
                    var hasUnpaused = prevProps.paused && !this.props.paused;
                    if (hasActivated) {
                        this.updatePreviousElement();
                        this.focusTrap.activate();
                    }
                    if (hasDeactivated) {
                        this.deactivateTrap();
                        return; // un/pause does nothing on an inactive trap
                    }
                    if (hasPaused) this.focusTrap.pause();
                    if (hasUnpaused) this.focusTrap.unpause();
                } else {
                    // NOTE: if we're in `componentDidUpdate` and we don't have a trap yet,
                    //  it either means it shouldn't be active, or it should be but none of
                    //  of given `containerElements` were present in the DOM the last time
                    //  we tried to create the trap
                    if (prevProps.containerElements !== this.props.containerElements) this.focusTrapElements = this.props.containerElements;
                    // don't create the trap unless it should be active in case the consumer
                    //  is still updating `focusTrapOptions`
                    //  @see https://github.com/focus-trap/focus-trap-react/issues/539
                    if (this.props.active) {
                        this.updatePreviousElement();
                        this.setupFocusTrap();
                    }
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.deactivateTrap();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var child = this.props.children ? $3RyIS.Children.only(this.props.children) : undefined;
                if (child) {
                    if (child.type && child.type === $3RyIS.Fragment) throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
                    var callbackRef = function callbackRef(element) {
                        var containerElements = _this3.props.containerElements;
                        if (child) {
                            if (typeof child.ref === "function") child.ref(element);
                            else if (child.ref) child.ref.current = element;
                        }
                        _this3.focusTrapElements = containerElements ? containerElements : [
                            element
                        ];
                    };
                    var childWithRef = $3RyIS.cloneElement(child, {
                        ref: callbackRef
                    });
                    return childWithRef;
                }
                return null;
            }
        }
    ]);
    return FocusTrap;
}($3RyIS.Component); // support server-side rendering where `Element` will not be defined
var $9e1fb441673deefc$var$ElementType = typeof Element === "undefined" ? Function : Element;
$9e1fb441673deefc$var$FocusTrap.propTypes = {
    active: $ifjYT.bool,
    paused: $ifjYT.bool,
    focusTrapOptions: $ifjYT.shape({
        document: $ifjYT.object,
        onActivate: $ifjYT.func,
        onPostActivate: $ifjYT.func,
        checkCanFocusTrap: $ifjYT.func,
        onPause: $ifjYT.func,
        onPostPause: $ifjYT.func,
        onUnpause: $ifjYT.func,
        onPostUnpause: $ifjYT.func,
        onDeactivate: $ifjYT.func,
        onPostDeactivate: $ifjYT.func,
        checkCanReturnFocus: $ifjYT.func,
        initialFocus: $ifjYT.oneOfType([
            $ifjYT.instanceOf($9e1fb441673deefc$var$ElementType),
            $ifjYT.string,
            $ifjYT.bool,
            $ifjYT.func
        ]),
        fallbackFocus: $ifjYT.oneOfType([
            $ifjYT.instanceOf($9e1fb441673deefc$var$ElementType),
            $ifjYT.string,
            // NOTE: does not support `false` as value (or return value from function)
            $ifjYT.func
        ]),
        escapeDeactivates: $ifjYT.oneOfType([
            $ifjYT.bool,
            $ifjYT.func
        ]),
        clickOutsideDeactivates: $ifjYT.oneOfType([
            $ifjYT.bool,
            $ifjYT.func
        ]),
        returnFocusOnDeactivate: $ifjYT.bool,
        setReturnFocus: $ifjYT.oneOfType([
            $ifjYT.instanceOf($9e1fb441673deefc$var$ElementType),
            $ifjYT.string,
            $ifjYT.bool,
            $ifjYT.func
        ]),
        allowOutsideClick: $ifjYT.oneOfType([
            $ifjYT.bool,
            $ifjYT.func
        ]),
        preventScroll: $ifjYT.bool,
        tabbableOptions: $ifjYT.shape({
            displayCheck: $ifjYT.oneOf([
                "full",
                "legacy-full",
                "non-zero-area",
                "none"
            ]),
            getShadowRoot: $ifjYT.oneOfType([
                $ifjYT.bool,
                $ifjYT.func
            ])
        }),
        trapStack: $ifjYT.array,
        isKeyForward: $ifjYT.func,
        isKeyBackward: $ifjYT.func
    }),
    containerElements: $ifjYT.arrayOf($ifjYT.instanceOf($9e1fb441673deefc$var$ElementType)),
    // DOM element ONLY
    children: $ifjYT.oneOfType([
        $ifjYT.element,
        // React element
        $ifjYT.instanceOf($9e1fb441673deefc$var$ElementType) // DOM element
    ])
};
$9e1fb441673deefc$var$FocusTrap.defaultProps = {
    active: true,
    paused: false,
    focusTrapOptions: {},
    _createFocusTrap: $9e1fb441673deefc$var$createFocusTrap
};
module.exports = $9e1fb441673deefc$var$FocusTrap;

});
parcelRegister("4sttu", function(module, exports) {

$parcel$export(module.exports, "createFocusTrap", function () { return $33f0a403d28ae409$export$360440dfcba94c00; });
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ 
var $ivXgI = parcelRequire("ivXgI");
function $33f0a403d28ae409$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $33f0a403d28ae409$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $33f0a403d28ae409$var$ownKeys(Object(t), !0).forEach(function(r) {
            $33f0a403d28ae409$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $33f0a403d28ae409$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $33f0a403d28ae409$var$_defineProperty(obj, key, value) {
    key = $33f0a403d28ae409$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $33f0a403d28ae409$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $33f0a403d28ae409$var$_toPropertyKey(arg) {
    var key = $33f0a403d28ae409$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
var $33f0a403d28ae409$var$activeFocusTraps = {
    activateTrap: function activateTrap(trapStack, trap) {
        if (trapStack.length > 0) {
            var activeTrap = trapStack[trapStack.length - 1];
            if (activeTrap !== trap) activeTrap.pause();
        }
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            // move this existing trap to the front of the queue
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        if (trapStack.length > 0) trapStack[trapStack.length - 1].unpause();
    }
};
var $33f0a403d28ae409$var$isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var $33f0a403d28ae409$var$isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Escape" || (e === null || e === void 0 ? void 0 : e.key) === "Esc" || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var $33f0a403d28ae409$var$isTabEvent = function isTabEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Tab" || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
// checks for TAB by default
var $33f0a403d28ae409$var$isKeyForward = function isKeyForward(e) {
    return $33f0a403d28ae409$var$isTabEvent(e) && !e.shiftKey;
};
// checks for SHIFT+TAB by default
var $33f0a403d28ae409$var$isKeyBackward = function isKeyBackward(e) {
    return $33f0a403d28ae409$var$isTabEvent(e) && e.shiftKey;
};
var $33f0a403d28ae409$var$delay = function delay(fn) {
    return setTimeout(fn, 0);
};
// Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var $33f0a403d28ae409$var$findIndex = function findIndex(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false; // break
        }
        return true; // next
    });
    return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var $33f0a403d28ae409$var$valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var $33f0a403d28ae409$var$getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var $33f0a403d28ae409$var$internalTrapStack = [];
var $33f0a403d28ae409$export$360440dfcba94c00 = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || $33f0a403d28ae409$var$internalTrapStack;
    var config = $33f0a403d28ae409$var$_objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        isKeyForward: $33f0a403d28ae409$var$isKeyForward,
        isKeyBackward: $33f0a403d28ae409$var$isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   posTabIndexesFound: boolean,
        //   firstTabbableNode: HTMLElement|undefined,
        //   lastTabbableNode: HTMLElement|undefined,
        //   firstDomTabbableNode: HTMLElement|undefined,
        //   lastDomTabbableNode: HTMLElement|undefined,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === "function" ? event.composedPath() : undefined;
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
            // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue); // resolve to node, or null if fails
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption("initialFocus");
        // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined || !(0, $ivXgI.isFocusable)(node, config.tabbableOptions)) {
            // option not specified nor focusable: use fallback options
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = (0, $ivXgI.tabbable)(container, config.tabbableOptions);
            // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
            //  are focusable but not tabbable
            var focusableNodes = (0, $ivXgI.focusable)(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return (0, $ivXgI.isTabbable)(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return (0, $ivXgI.isTabbable)(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return (0, $ivXgI.getTabIndex)(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound: posTabIndexesFound,
                /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode: firstTabbableNode,
                /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode: lastTabbableNode,
                // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode: firstDomTabbableNode,
                /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode: lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
                        //  since `node` should at least have been focusable, we assume that's the case and mimic
                        //  what browsers do, which is set focus to the next node in __document position order__,
                        //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
                        //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
                        //  basic DOM order
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return (0, $ivXgI.isTabbable)(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return (0, $ivXgI.isTabbable)(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus") // returning false not supported for this option
        ) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        // NOTE: Positive tabindexes are only properly supported in single-container traps because
        //  doing it across multiple containers where tabindexes could be all over the place
        //  would require Tabbable to support multiple containers, would require additional
        //  specialized Shadow DOM support, and would require Tabbable's multi-container support
        //  to look at those containers in document position order rather than user-provided
        //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
        //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    /**
   * Gets the current activeElement. If it's a web-component and has open shadow-root
   * it will recursively search inside shadow roots for the "true" activeElement.
   *
   * @param {Document | ShadowRoot} el
   *
   * @returns {HTMLElement} The element that currently has the focus
   **/ var getActiveElement = function getActiveElement(el) {
        var activeElement = el.activeElement;
        if (!activeElement) return;
        if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) return getActiveElement(activeElement.shadowRoot);
        return activeElement;
    };
    var tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === getActiveElement(document)) return;
        if (!node || !node.focus) {
            tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        // NOTE: focus() API does not trigger focusIn event so set MRU node manually
        state.mostRecentlyFocusedNode = node;
        if ($33f0a403d28ae409$var$isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    };
    /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */ var findNextNavNode = function findNextNavNode(_ref2) {
        var target = _ref2.target, event = _ref2.event, _ref2$isBackward = _ref2.isBackward, isBackward = _ref2$isBackward === void 0 ? false : _ref2$isBackward;
        target = target || $33f0a403d28ae409$var$getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back into...
                if (isBackward) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = $33f0a403d28ae409$var$findIndex(state.tabbableGroups, function(_ref3) {
                    var firstTabbableNode = _ref3.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || (0, $ivXgI.isFocusable)(target, config.tabbableOptions) && !(0, $ivXgI.isTabbable)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = (0, $ivXgI.getTabIndex)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!$33f0a403d28ae409$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = $33f0a403d28ae409$var$findIndex(state.tabbableGroups, function(_ref4) {
                    var lastTabbableNode = _ref4.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0, $ivXgI.isFocusable)(target, config.tabbableOptions) && !(0, $ivXgI.isTabbable)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = (0, $ivXgI.getTabIndex)(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!$33f0a403d28ae409$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else // no groups available
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption("fallbackFocus");
        return destinationNode;
    };
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = $33f0a403d28ae409$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) // allow the click since it ocurred inside the trap
        return;
        if ($33f0a403d28ae409$var$valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if ($33f0a403d28ae409$var$valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
        // otherwise, prevent the click
        e.preventDefault();
    };
    // In case focus escapes the trap for some strange reason, pull it back in.
    // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
    //  scrolling if the node that got focused was out of view; there's nothing we can do to
    //  prevent that from happening by the time we discover that focus escaped
    var checkFocusIn = function checkFocusIn(event) {
        var target = $33f0a403d28ae409$var$getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            event.stopImmediatePropagation();
            // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
            //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
            //  toward a node with a positive tab index
            var nextNode; // next node to focus, if we find one
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if ((0, $ivXgI.getTabIndex)(state.mostRecentlyFocusedNode) > 0) {
                    // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    // there MAY not be any tabbable nodes in the container if there are at least 2 containers
                    //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
                    //  with at least one tabbable node in order to function, so this could be the other container
                    //  with nothing tabbable in it)
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        // else, don't find in container order without considering direction too
                        }
                    }
                // else, no tabbable nodes in that container (which means we must have at least one other
                //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
                //  an error the last time updateTabbableNodes() was run): find next node among all known
                //  containers
                } else // check to see if there's at least one tabbable node with a positive tab index inside
                //  the trap because focus seems to escape when navigating backward from a tabbable node
                //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
                //  the greatest positive tab index like it should)
                if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return (0, $ivXgI.getTabIndex)(n) > 0;
                    });
                })) // no containers with tabbable nodes with positive tab indexes which means the focus
                //  escaped for some other reason and we should just execute the fallback to the
                //  MRU node or initial focus node, if any
                navAcrossContainers = false;
            } else // no MRU node means we're likely in some initial condition when the trap has just
            //  been activated and initial focus hasn't been given yet, in which case we should
            //  fall through to trying to focus the initial focus node, which is what should
            //  happen below at this point in the logic
            navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) tryFocus(nextNode);
            else tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = undefined; // clear
    };
    // Hijack key nav events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkKeyNav = function checkKeyNav(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if ($33f0a403d28ae409$var$isTabEvent(event)) // since tab natively moves focus, we wouldn't have a destination node unless we
            //  were on the edge of a container and had to move to the next/previous edge, in
            //  which case we want to prevent default to keep the browser from moving focus
            //  to where it normally would
            event.preventDefault();
            tryFocus(destinationNode);
        }
    // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkKey = function checkKey(event) {
        if ($33f0a403d28ae409$var$isEscapeEvent(event) && $33f0a403d28ae409$var$valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
            return;
        }
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    var checkClick = function checkClick(e) {
        var target = $33f0a403d28ae409$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if ($33f0a403d28ae409$var$valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if ($33f0a403d28ae409$var$valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    //
    // EVENT LISTENERS
    //
    var addListeners = function addListeners() {
        if (!state.active) return;
        // There can be only one listening focus trap at a time
        $33f0a403d28ae409$var$activeFocusTraps.activateTrap(trapStack, trap);
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        state.delayInitialFocusTimer = config.delayInitialFocus ? $33f0a403d28ae409$var$delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    };
    //
    // MUTATION OBSERVER
    //
    var checkDomRemoval = function checkDomRemoval(mutations) {
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === state.mostRecentlyFocusedNode;
            });
        });
        // If the currently focused is removed then browsers will move focus to the
        // <body> element. If this happens, try to move focus back into the trap.
        if (isFocusedNodeRemoved) tryFocus(getInitialFocusNode());
    };
    // Use MutationObserver - if supported - to detect if focused node is removed
    // from the DOM.
    var mutationObserver = typeof window !== "undefined" && "MutationObserver" in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            onActivate === null || onActivate === void 0 || onActivate();
            var finishActivation = function finishActivation() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                updateObservedNodes();
                onPostActivate === null || onPostActivate === void 0 || onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = $33f0a403d28ae409$var$_objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            $33f0a403d28ae409$var$activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            onDeactivate === null || onDeactivate === void 0 || onDeactivate();
            var finishDeactivation = function finishDeactivation() {
                $33f0a403d28ae409$var$delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (state.paused || !state.active) return this;
            var onPause = getOption(pauseOptions, "onPause");
            var onPostPause = getOption(pauseOptions, "onPostPause");
            state.paused = true;
            onPause === null || onPause === void 0 || onPause();
            removeListeners();
            updateObservedNodes();
            onPostPause === null || onPostPause === void 0 || onPostPause();
            return this;
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.paused || !state.active) return this;
            var onUnpause = getOption(unpauseOptions, "onUnpause");
            var onPostUnpause = getOption(unpauseOptions, "onPostUnpause");
            state.paused = false;
            onUnpause === null || onUnpause === void 0 || onUnpause();
            updateTabbableNodes();
            addListeners();
            updateObservedNodes();
            onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            updateObservedNodes();
            return this;
        }
    };
    // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};

});
parcelRegister("ivXgI", function(module, exports) {

$parcel$export(module.exports, "getTabIndex", function () { return $d7a918c0cfa1f02d$export$a4672efddb4181b8; });
$parcel$export(module.exports, "tabbable", function () { return $d7a918c0cfa1f02d$export$17100aea90429aa7; });
$parcel$export(module.exports, "focusable", function () { return $d7a918c0cfa1f02d$export$ecc6d1fcdff4f700; });
$parcel$export(module.exports, "isTabbable", function () { return $d7a918c0cfa1f02d$export$bebd5a1431fec25d; });
$parcel$export(module.exports, "isFocusable", function () { return $d7a918c0cfa1f02d$export$4c063cf1350e6fed; });
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $d7a918c0cfa1f02d$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $d7a918c0cfa1f02d$var$candidateSelector = /* #__PURE__ */ $d7a918c0cfa1f02d$var$candidateSelectors.join(",");
var $d7a918c0cfa1f02d$var$NoElement = typeof Element === "undefined";
var $d7a918c0cfa1f02d$var$matches = $d7a918c0cfa1f02d$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $d7a918c0cfa1f02d$var$getRootNode = !$d7a918c0cfa1f02d$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $d7a918c0cfa1f02d$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $d7a918c0cfa1f02d$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $d7a918c0cfa1f02d$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($d7a918c0cfa1f02d$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($d7a918c0cfa1f02d$var$candidateSelector));
    if (includeContainer && $d7a918c0cfa1f02d$var$matches.call(el, $d7a918c0cfa1f02d$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $d7a918c0cfa1f02d$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($d7a918c0cfa1f02d$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $d7a918c0cfa1f02d$var$matches.call(element, $d7a918c0cfa1f02d$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$d7a918c0cfa1f02d$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $d7a918c0cfa1f02d$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $d7a918c0cfa1f02d$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $d7a918c0cfa1f02d$var$isContentEditable(node)) && !$d7a918c0cfa1f02d$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $d7a918c0cfa1f02d$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $d7a918c0cfa1f02d$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$d7a918c0cfa1f02d$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $d7a918c0cfa1f02d$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $d7a918c0cfa1f02d$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $d7a918c0cfa1f02d$var$isHiddenInput = function isHiddenInput(node) {
    return $d7a918c0cfa1f02d$var$isInput(node) && node.type === "hidden";
};
var $d7a918c0cfa1f02d$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $d7a918c0cfa1f02d$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $d7a918c0cfa1f02d$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $d7a918c0cfa1f02d$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $d7a918c0cfa1f02d$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $d7a918c0cfa1f02d$var$isRadio = function isRadio(node) {
    return $d7a918c0cfa1f02d$var$isInput(node) && node.type === "radio";
};
var $d7a918c0cfa1f02d$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $d7a918c0cfa1f02d$var$isRadio(node) && !$d7a918c0cfa1f02d$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $d7a918c0cfa1f02d$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $d7a918c0cfa1f02d$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $d7a918c0cfa1f02d$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $d7a918c0cfa1f02d$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $d7a918c0cfa1f02d$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $d7a918c0cfa1f02d$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($d7a918c0cfa1f02d$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $d7a918c0cfa1f02d$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $d7a918c0cfa1f02d$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($d7a918c0cfa1f02d$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $d7a918c0cfa1f02d$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $d7a918c0cfa1f02d$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $d7a918c0cfa1f02d$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $d7a918c0cfa1f02d$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $d7a918c0cfa1f02d$var$isInert(node) || $d7a918c0cfa1f02d$var$isHiddenInput(node) || $d7a918c0cfa1f02d$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $d7a918c0cfa1f02d$var$isDetailsWithSummary(node) || $d7a918c0cfa1f02d$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $d7a918c0cfa1f02d$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($d7a918c0cfa1f02d$var$isNonTabbableRadio(node) || $d7a918c0cfa1f02d$export$a4672efddb4181b8(node) < 0 || !$d7a918c0cfa1f02d$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $d7a918c0cfa1f02d$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $d7a918c0cfa1f02d$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $d7a918c0cfa1f02d$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($d7a918c0cfa1f02d$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $d7a918c0cfa1f02d$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $d7a918c0cfa1f02d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $d7a918c0cfa1f02d$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $d7a918c0cfa1f02d$var$isValidShadowRootTabbable
    });
    else candidates = $d7a918c0cfa1f02d$var$getCandidates(container, options.includeContainer, $d7a918c0cfa1f02d$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $d7a918c0cfa1f02d$var$sortByOrder(candidates);
};
var $d7a918c0cfa1f02d$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $d7a918c0cfa1f02d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $d7a918c0cfa1f02d$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $d7a918c0cfa1f02d$var$getCandidates(container, options.includeContainer, $d7a918c0cfa1f02d$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $d7a918c0cfa1f02d$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($d7a918c0cfa1f02d$var$matches.call(node, $d7a918c0cfa1f02d$var$candidateSelector) === false) return false;
    return $d7a918c0cfa1f02d$var$isNodeMatchingSelectorTabbable(options, node);
};
var $d7a918c0cfa1f02d$var$focusableCandidateSelector = /* #__PURE__ */ $d7a918c0cfa1f02d$var$candidateSelectors.concat("iframe").join(",");
var $d7a918c0cfa1f02d$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($d7a918c0cfa1f02d$var$matches.call(node, $d7a918c0cfa1f02d$var$focusableCandidateSelector) === false) return false;
    return $d7a918c0cfa1f02d$var$isNodeMatchingSelectorFocusable(options, node);
};

});




parcelRegister("fQhPJ", function(module, exports) {

$parcel$export(module.exports, "createDynamicNavMenuList", function () { return $517596f59434fb08$export$9dea853b81d44643; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $aUAzJ = parcelRequire("aUAzJ");

var $9Qd4D = parcelRequire("9Qd4D");

var $iteUt = parcelRequire("iteUt");

var $50y3l = parcelRequire("50y3l");
const $517596f59434fb08$export$9dea853b81d44643 = ({ navItems: navItems, dropdownIsOpen: dropdownIsOpen, dropdownSetIsOpen: dropdownSetIsOpen })=>{
    // @TODO:Need to elevate this functionality to outside of the header. Allow this function to take classname as an argument so we can dynamcally create different types of links across multiple compoenents and apply various visual styling.
    return navItems.map((item, index)=>{
        switch(item.type){
            case (0, $aUAzJ.NavItemType).DROPDOWN:
                if (dropdownIsOpen === undefined || dropdownSetIsOpen === undefined) return /*#__PURE__*/ (0, $21sFD.jsx)((0, $21sFD.Fragment), {});
                return /*#__PURE__*/ (0, $21sFD.jsx)((0, $9Qd4D.NavDropDownButton), {
                    item: item,
                    isOpen: dropdownIsOpen,
                    setIsOpen: dropdownSetIsOpen,
                    index: index
                });
            case (0, $aUAzJ.NavItemType).INTERNAL_LINK:
                return /*#__PURE__*/ (0, $21sFD.jsx)((0, $iteUt.NavItemInternalLink), {
                    item: item
                });
            case (0, $aUAzJ.NavItemType).EXTERNAL_LINK:
                return /*#__PURE__*/ (0, $21sFD.jsx)((0, $iteUt.NavItemExternalLink), {
                    item: item
                });
            case (0, $aUAzJ.NavItemType).ACTION:
                return /*#__PURE__*/ (0, $21sFD.jsx)((0, $50y3l.NavItemCTA), {
                    item: item
                });
            default:
                return /*#__PURE__*/ (0, $21sFD.jsx)((0, $21sFD.Fragment), {});
        }
    });
};

});
parcelRegister("9Qd4D", function(module, exports) {

$parcel$export(module.exports, "NavDropDownButton", function () { return $3bcf768f8dc57cde$export$4fc25bfa0f22e533; });

var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");

var $fQhPJ = parcelRequire("fQhPJ");
parcelRequire("hiK0Y");
var $cBges = parcelRequire("cBges");
var $cu2Em = parcelRequire("cu2Em");

var $aPWeF = parcelRequire("aPWeF");
const $3bcf768f8dc57cde$export$4fc25bfa0f22e533 = ({ item: item, isOpen: isOpen, setIsOpen: setIsOpen, index: index })=>{
    const onToggle = (index, setIsOpen)=>{
        setIsOpen((prevIsOpen)=>{
            const newIsOpen = prevIsOpen.map((prev, i)=>i === index ? !prev // toggle the current dropdown
                 : false // close all other dropdowns
            );
            return newIsOpen;
        });
    };
    const handleClickOutside = (0, $3RyIS.useCallback)(()=>{
        if (isOpen[index]) setIsOpen((prevIsOpen)=>{
            const newIsOpen = [
                ...prevIsOpen
            ];
            newIsOpen[index] = false;
            return newIsOpen;
        });
    }, [
        index,
        isOpen,
        setIsOpen
    ]);
    const dropdownRef = (0, $aPWeF.useClickOutside)(handleClickOutside);
    const submenuItems = (0, $fQhPJ.createDynamicNavMenuList)({
        navItems: item.children
    });
    return /*#__PURE__*/ (0, $21sFD.jsxs)("div", {
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0, $21sFD.jsx)((0, $cu2Em.USWDSNavDropDownButton), {
                onToggle: ()=>onToggle(index, setIsOpen),
                menuId: item.title,
                isOpen: isOpen[index],
                label: item.title
            }),
            /*#__PURE__*/ (0, $21sFD.jsx)((0, $cBges.USWDSMenu), {
                items: submenuItems,
                isOpen: isOpen[index],
                id: `${item.id}-dropdown`
            })
        ]
    }, item.id);
};

});
parcelRegister("hiK0Y", function(module, exports) {

$parcel$export(module.exports, "USWDSAccordion", function () { return (parcelRequire("dfF1i")).USWDSAccordion; });
$parcel$export(module.exports, "USWDSAlert", function () { return (parcelRequire("fGphl")).USWDSAlert; });
$parcel$export(module.exports, "USWDSButtonGroup", function () { return (parcelRequire("3xK2A")).USWDSButtonGroup; });
$parcel$export(module.exports, "USWDSButton", function () { return (parcelRequire("3xK2A")).USWDSButton; });
$parcel$export(module.exports, "USWDSBanner", function () { return (parcelRequire("d8SZE")).USWDSBanner; });
$parcel$export(module.exports, "USWDSBannerContent", function () { return (parcelRequire("d8SZE")).USWDSBannerContent; });
$parcel$export(module.exports, "USWDSBannerButton", function () { return (parcelRequire("d8SZE")).USWDSBannerButton; });
$parcel$export(module.exports, "USWDSBannerFlag", function () { return (parcelRequire("d8SZE")).USWDSBannerFlag; });
$parcel$export(module.exports, "USWDSBannerHeader", function () { return (parcelRequire("d8SZE")).USWDSBannerHeader; });
$parcel$export(module.exports, "USWDSBannerIcon", function () { return (parcelRequire("d8SZE")).USWDSBannerIcon; });
$parcel$export(module.exports, "USWDSBannerGuidance", function () { return (parcelRequire("d8SZE")).USWDSBannerGuidance; });
$parcel$export(module.exports, "USWDSMediaBlockBody", function () { return (parcelRequire("d8SZE")).USWDSMediaBlockBody; });
$parcel$export(module.exports, "USWDSCardComponent", function () { return (parcelRequire("kasiS")).USWDSCardComponent; });
$parcel$export(module.exports, "USWDSCardBody", function () { return (parcelRequire("kasiS")).USWDSCardBody; });
$parcel$export(module.exports, "USWDSCardGroup", function () { return (parcelRequire("kasiS")).USWDSCardGroup; });
$parcel$export(module.exports, "USWDSCardHeader", function () { return (parcelRequire("kasiS")).USWDSCardHeader; });
$parcel$export(module.exports, "USWDSCardMedia", function () { return (parcelRequire("kasiS")).USWDSCardMedia; });
$parcel$export(module.exports, "USWDSCardFooter", function () { return (parcelRequire("kasiS")).USWDSCardFooter; });
$parcel$export(module.exports, "USWDSCheckbox", function () { return (parcelRequire("1kIGL")).USWDSCheckbox; });
$parcel$export(module.exports, "USWDSExtendedNav", function () { return (parcelRequire("cpaZD")).USWDSExtendedNav; });
$parcel$export(module.exports, "USWDSFooterNav", function () { return (parcelRequire("3Rq2a")).USWDSFooterNav; });
$parcel$export(module.exports, "USWDSFooter", function () { return (parcelRequire("3Rq2a")).USWDSFooter; });
$parcel$export(module.exports, "USWDSAddress", function () { return (parcelRequire("3Rq2a")).USWDSAddress; });
$parcel$export(module.exports, "USWDSGridContainer", function () { return (parcelRequire("covgo")).USWDSGridContainer; });
$parcel$export(module.exports, "USWDSGrid", function () { return (parcelRequire("covgo")).USWDSGrid; });
$parcel$export(module.exports, "USWDSHeader", function () { return (parcelRequire("4KRzF")).USWDSHeader; });
$parcel$export(module.exports, "USWDSHeaderTitle", function () { return (parcelRequire("4KRzF")).USWDSHeaderTitle; });
$parcel$export(module.exports, "USWDSIcon", function () { return (parcelRequire("3zKGP")).USWDSIcon; });
$parcel$export(module.exports, "USWDSTextInput", function () { return (parcelRequire("cpAtw")).USWDSTextInput; });
$parcel$export(module.exports, "USWDSInputSuffix", function () { return (parcelRequire("cpAtw")).USWDSInputSuffix; });
$parcel$export(module.exports, "USWDSInputGroup", function () { return (parcelRequire("cpAtw")).USWDSInputGroup; });
$parcel$export(module.exports, "USWDSMenu", function () { return (parcelRequire("cBges")).USWDSMenu; });
$parcel$export(module.exports, "USWDSNavMenuButton", function () { return (parcelRequire("jgkOA")).USWDSNavMenuButton; });
$parcel$export(module.exports, "USWDSNavDropDownButton", function () { return (parcelRequire("cu2Em")).USWDSNavDropDownButton; });
$parcel$export(module.exports, "USWDSPagination", function () { return (parcelRequire("8dlCb")).USWDSPagination; });
$parcel$export(module.exports, "USWDSSiteAlert", function () { return (parcelRequire("5RnQo")).USWDSSiteAlert; });
$parcel$export(module.exports, "USWDSSearch", function () { return (parcelRequire("4JGTQ")).USWDSSearch; });
$parcel$export(module.exports, "USWDSTag", function () { return (parcelRequire("7KS4c")).USWDSTag; });
$parcel$export(module.exports, "USWDSSelect", function () { return (parcelRequire("h8K3x")).USWDSSelect; });

var $dfF1i = parcelRequire("dfF1i");

var $fGphl = parcelRequire("fGphl");

var $3xK2A = parcelRequire("3xK2A");

var $d8SZE = parcelRequire("d8SZE");

var $kasiS = parcelRequire("kasiS");

var $1kIGL = parcelRequire("1kIGL");

var $cpaZD = parcelRequire("cpaZD");

var $3Rq2a = parcelRequire("3Rq2a");

var $covgo = parcelRequire("covgo");

var $4KRzF = parcelRequire("4KRzF");

var $3zKGP = parcelRequire("3zKGP");

var $cpAtw = parcelRequire("cpAtw");

var $h6VLb = parcelRequire("h6VLb");

var $cBges = parcelRequire("cBges");

var $jgkOA = parcelRequire("jgkOA");

var $cu2Em = parcelRequire("cu2Em");

var $8dlCb = parcelRequire("8dlCb");

var $5RnQo = parcelRequire("5RnQo");

var $4JGTQ = parcelRequire("4JGTQ");

var $7KS4c = parcelRequire("7KS4c");

var $h8K3x = parcelRequire("h8K3x");

});
parcelRegister("dfF1i", function(module, exports) {

$parcel$export(module.exports, "USWDSAccordion", function () { return $624742895857b6fb$export$35a56daef9f667a7; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $624742895857b6fb$export$35a56daef9f667a7(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Accordion), {
        ...props
    });
}

});

parcelRegister("fGphl", function(module, exports) {

$parcel$export(module.exports, "USWDSAlert", function () { return $3c81f5104003fa97$export$b04b89b5a5312af7; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $3c81f5104003fa97$export$b04b89b5a5312af7(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Alert), {
        ...props
    });
}

});

parcelRegister("3xK2A", function(module, exports) {

$parcel$export(module.exports, "USWDSButton", function () { return $cba32af60fe94cef$export$248fb05c5aa01092; });
$parcel$export(module.exports, "USWDSButtonGroup", function () { return $cba32af60fe94cef$export$e8a99f6267afb335; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $cba32af60fe94cef$export$248fb05c5aa01092(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Button), {
        ...props
    });
}
function $cba32af60fe94cef$export$e8a99f6267afb335(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.ButtonGroup), {
        ...props
    });
}

});

parcelRegister("d8SZE", function(module, exports) {

$parcel$export(module.exports, "USWDSBanner", function () { return $18fb4e4076f0158c$export$b2055fba41f58d27; });
$parcel$export(module.exports, "USWDSBannerContent", function () { return $18fb4e4076f0158c$export$f1f29594be25aba2; });
$parcel$export(module.exports, "USWDSBannerButton", function () { return $18fb4e4076f0158c$export$2fcaf366748300cb; });
$parcel$export(module.exports, "USWDSBannerFlag", function () { return $18fb4e4076f0158c$export$3139edaf36e6c088; });
$parcel$export(module.exports, "USWDSBannerHeader", function () { return $18fb4e4076f0158c$export$11af364306df343e; });
$parcel$export(module.exports, "USWDSBannerIcon", function () { return $18fb4e4076f0158c$export$25d7a6d74885409e; });
$parcel$export(module.exports, "USWDSBannerGuidance", function () { return $18fb4e4076f0158c$export$ec434514efd2b3f4; });
$parcel$export(module.exports, "USWDSMediaBlockBody", function () { return $18fb4e4076f0158c$export$e46598b4f7b219cb; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $18fb4e4076f0158c$export$b2055fba41f58d27(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Banner), {
        ...props
    });
}
function $18fb4e4076f0158c$export$f1f29594be25aba2(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.BannerContent), {
        ...props
    });
}
function $18fb4e4076f0158c$export$2fcaf366748300cb(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.BannerButton), {
        ...props
    });
}
function $18fb4e4076f0158c$export$3139edaf36e6c088(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.BannerFlag), {
        ...props
    });
}
function $18fb4e4076f0158c$export$11af364306df343e(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.BannerHeader), {
        ...props
    });
}
function $18fb4e4076f0158c$export$25d7a6d74885409e(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.BannerIcon), {
        ...props
    });
}
function $18fb4e4076f0158c$export$ec434514efd2b3f4(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.BannerGuidance), {
        ...props
    });
}
function $18fb4e4076f0158c$export$e46598b4f7b219cb(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.MediaBlockBody), {
        ...props
    });
}

});

parcelRegister("kasiS", function(module, exports) {

$parcel$export(module.exports, "USWDSCardComponent", function () { return $e8126f49e80a52d5$export$2c7fc6f2fb3ef5d6; });
$parcel$export(module.exports, "USWDSCardBody", function () { return $e8126f49e80a52d5$export$72b362bbcefa45b7; });
$parcel$export(module.exports, "USWDSCardGroup", function () { return $e8126f49e80a52d5$export$ff854e4c388490e2; });
$parcel$export(module.exports, "USWDSCardHeader", function () { return $e8126f49e80a52d5$export$9760ec5753d39cf4; });
$parcel$export(module.exports, "USWDSCardMedia", function () { return $e8126f49e80a52d5$export$51bdfab8a61a362c; });
$parcel$export(module.exports, "USWDSCardFooter", function () { return $e8126f49e80a52d5$export$714c24d944785ed; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $e8126f49e80a52d5$export$2c7fc6f2fb3ef5d6(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Card), {
        ...props
    });
}
function $e8126f49e80a52d5$export$72b362bbcefa45b7(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.CardBody), {
        ...props
    });
}
function $e8126f49e80a52d5$export$ff854e4c388490e2(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.CardGroup), {
        ...props
    });
}
function $e8126f49e80a52d5$export$9760ec5753d39cf4(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.CardHeader), {
        ...props
    });
}
function $e8126f49e80a52d5$export$51bdfab8a61a362c(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.CardMedia), {
        ...props
    });
}
function $e8126f49e80a52d5$export$714c24d944785ed(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.CardFooter), {
        ...props
    });
}

});

parcelRegister("1kIGL", function(module, exports) {

$parcel$export(module.exports, "USWDSCheckbox", function () { return $568bdcecea0e8f90$export$4e9b1de093901fae; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $568bdcecea0e8f90$export$4e9b1de093901fae(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Checkbox), {
        ...props
    });
}

});

parcelRegister("cpaZD", function(module, exports) {

$parcel$export(module.exports, "USWDSExtendedNav", function () { return $7c215a870486eaeb$export$411efe4e3a82332; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $7c215a870486eaeb$export$411efe4e3a82332(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.ExtendedNav), {
        ...props
    });
}

});

parcelRegister("3Rq2a", function(module, exports) {

$parcel$export(module.exports, "USWDSFooter", function () { return $30c45f6643d5cfdf$export$b3b860d9aa51a4b7; });
$parcel$export(module.exports, "USWDSFooterNav", function () { return $30c45f6643d5cfdf$export$4fd8b481c9d4244a; });
$parcel$export(module.exports, "USWDSAddress", function () { return $30c45f6643d5cfdf$export$6ae575990e4b97ad; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $30c45f6643d5cfdf$export$b3b860d9aa51a4b7(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Footer), {
        ...props
    });
}
function $30c45f6643d5cfdf$export$4fd8b481c9d4244a(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.FooterNav), {
        ...props
    });
}
function $30c45f6643d5cfdf$export$871bdb28c6ff4f22(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.SocialLink), {
        ...props
    });
}
function $30c45f6643d5cfdf$export$8cf6c1110caf6354(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Logo), {
        ...props
    });
}
function $30c45f6643d5cfdf$export$6ae575990e4b97ad(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Address), {
        ...props
    });
}
function $30c45f6643d5cfdf$export$32a09fd8db6c87ab(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.FooterExtendedNavList), {
        ...props
    });
}

});

parcelRegister("covgo", function(module, exports) {

$parcel$export(module.exports, "USWDSGridContainer", function () { return $634b4b08c0d8bbe4$export$d31c4af957bde846; });
$parcel$export(module.exports, "USWDSGrid", function () { return $634b4b08c0d8bbe4$export$1095f78c02c665c7; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $634b4b08c0d8bbe4$export$d31c4af957bde846(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.GridContainer), {
        ...props
    });
}
function $634b4b08c0d8bbe4$export$1095f78c02c665c7(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Grid), {
        ...props
    });
}

});

parcelRegister("4KRzF", function(module, exports) {

$parcel$export(module.exports, "USWDSHeader", function () { return $05f4b0187b992376$export$4f6cc9e3a5d9cc0f; });
$parcel$export(module.exports, "USWDSHeaderTitle", function () { return $05f4b0187b992376$export$5b3ca409b0d8ae0a; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $05f4b0187b992376$export$4f6cc9e3a5d9cc0f(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Header), {
        ...props
    });
}
function $05f4b0187b992376$export$5b3ca409b0d8ae0a(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Title), {
        ...props
    });
}

});

parcelRegister("3zKGP", function(module, exports) {

$parcel$export(module.exports, "USWDSIcon", function () { return $0b1704fd7766c3cb$export$8ce4680a6e350c5d; });

var $2JIVh = parcelRequire("2JIVh");
const $0b1704fd7766c3cb$export$8ce4680a6e350c5d = (0, $2JIVh.Icon);

});

parcelRegister("cpAtw", function(module, exports) {

$parcel$export(module.exports, "USWDSTextInput", function () { return $8596dfd8d5383d1e$export$a2cb780acafd0294; });
$parcel$export(module.exports, "USWDSInputSuffix", function () { return $8596dfd8d5383d1e$export$f2fc8abff0118fb8; });
$parcel$export(module.exports, "USWDSInputGroup", function () { return $8596dfd8d5383d1e$export$fd108164334c0f5e; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $8596dfd8d5383d1e$export$a2cb780acafd0294(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.TextInput), {
        ...props
    });
}
function $8596dfd8d5383d1e$export$112d32f5bfddfd8c(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.TextInputMask), {
        ...props
    });
}
function $8596dfd8d5383d1e$export$f2fc8abff0118fb8(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.InputSuffix), {
        ...props
    });
}
function $8596dfd8d5383d1e$export$fd108164334c0f5e(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.InputGroup), {
        ...props
    });
}

});

parcelRegister("h6VLb", function(module, exports) {

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $93697dcb0a79756c$export$f3ebad3ecb7f0e90(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Link), {
        ...props
    });
}

});

parcelRegister("cBges", function(module, exports) {

$parcel$export(module.exports, "USWDSMenu", function () { return $1747d985c76167bd$export$c44519b42a34ee18; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $1747d985c76167bd$export$c44519b42a34ee18(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Menu), {
        ...props
    });
}

});

parcelRegister("jgkOA", function(module, exports) {

$parcel$export(module.exports, "USWDSNavMenuButton", function () { return $493a4d06216c9df6$export$c0aaf7c172d2d362; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $493a4d06216c9df6$export$c0aaf7c172d2d362(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.NavMenuButton), {
        ...props
    });
}

});

parcelRegister("cu2Em", function(module, exports) {

$parcel$export(module.exports, "USWDSNavDropDownButton", function () { return $fb489df5f58ec057$export$f814cb98d9e6385d; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $fb489df5f58ec057$export$f814cb98d9e6385d(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.NavDropDownButton), {
        ...props
    });
}

});

parcelRegister("8dlCb", function(module, exports) {

$parcel$export(module.exports, "USWDSPagination", function () { return $d0e7a6f0dd904559$export$6477c94b48ba081e; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $d0e7a6f0dd904559$export$6477c94b48ba081e(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Pagination), {
        ...props
    });
}

});

parcelRegister("5RnQo", function(module, exports) {

$parcel$export(module.exports, "USWDSSiteAlert", function () { return $1c5c3d7a95d31c65$export$2b351d3376e573b9; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $1c5c3d7a95d31c65$export$2b351d3376e573b9(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.SiteAlert), {
        ...props
    });
}

});

parcelRegister("4JGTQ", function(module, exports) {

$parcel$export(module.exports, "USWDSSearch", function () { return $2a77a9f379756e52$export$4c65c6a274082669; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $2a77a9f379756e52$export$4c65c6a274082669(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Search), {
        ...props
    });
}

});

parcelRegister("7KS4c", function(module, exports) {

$parcel$export(module.exports, "USWDSTag", function () { return $2025826dde814c16$export$91725b376ecb6458; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $2025826dde814c16$export$91725b376ecb6458(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Tag), {
        ...props
    });
}

});

parcelRegister("h8K3x", function(module, exports) {

$parcel$export(module.exports, "USWDSSelect", function () { return $90b17f74bb3060bd$export$9ce540127e9af702; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $2JIVh = parcelRequire("2JIVh");
function $90b17f74bb3060bd$export$9ce540127e9af702(props) {
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Select), {
        ...props
    });
}

});


parcelRegister("aPWeF", function(module, exports) {

$parcel$export(module.exports, "useClickOutside", function () { return $54c294d9613667cb$export$1896bab46732d207; });

var $3RyIS = parcelRequire("3RyIS");
const $54c294d9613667cb$export$1896bab46732d207 = (onClose)=>{
    const ref = (0, $3RyIS.useRef)(null);
    (0, $3RyIS.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (ref.current && !ref.current.contains(event.target)) onClose();
        };
        document.addEventListener("click", handleClickOutside, true);
        return ()=>document.removeEventListener("click", handleClickOutside, true);
    }, [
        onClose
    ]);
    return ref;
};

});


parcelRegister("iteUt", function(module, exports) {

$parcel$export(module.exports, "NavItemExternalLink", function () { return $2d8dcb3eb03b8110$export$8780c2c1d641687; });
$parcel$export(module.exports, "NavItemInternalLink", function () { return $2d8dcb3eb03b8110$export$1d089b50e6ff26e2; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $6SviU = parcelRequire("6SviU");
const $2d8dcb3eb03b8110$export$8780c2c1d641687 = ({ item: item })=>{
    const defaultClassName = "usa-nav__link";
    return /*#__PURE__*/ (0, $21sFD.jsx)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: item.href,
        className: item.customClassNames || defaultClassName,
        id: item.id,
        children: /*#__PURE__*/ (0, $21sFD.jsx)("span", {
            children: item.title
        })
    }, item.id);
};
const $2d8dcb3eb03b8110$export$1d089b50e6ff26e2 = ({ item: item })=>{
    const { navigation: { LinkComponent: LinkComponent, linkProps: linkProps } } = (0, $6SviU.useVedaUI)();
    const path = {
        [linkProps.pathAttributeKeyName]: item.to
    };
    const defaultClassName = "usa-nav__link";
    return /*#__PURE__*/ (0, $21sFD.jsx)(LinkComponent, {
        ...path,
        className: item.customClassNames || defaultClassName,
        id: item.id,
        children: /*#__PURE__*/ (0, $21sFD.jsx)("span", {
            children: item.title
        })
    }, item.id);
};

});
parcelRegister("6SviU", function(module, exports) {

$parcel$export(module.exports, "useVedaUI", function () { return $2dc69dcc479c43b5$export$625504311771793d; });
$parcel$export(module.exports, "VedaUIProvider", function () { return $2dc69dcc479c43b5$export$842d5d9b4379d2a; });

var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");

var $bvGDc = parcelRequire("bvGDc");

var $39y1u = parcelRequire("39y1u");
const $2dc69dcc479c43b5$var$defaultNavigation = {
    LinkComponent: "a",
    linkProps: {
        pathAttributeKeyName: "href"
    }
};
const $2dc69dcc479c43b5$var$defaultRoutes = {
    dataCatalogPath: (0, $bvGDc.DATASETS_PATH),
    storiesCatalogPath: (0, $bvGDc.STORIES_PATH)
};
const $2dc69dcc479c43b5$var$VedaUIContext = /*#__PURE__*/ (0, $3RyIS.createContext)(null);
$2dc69dcc479c43b5$var$VedaUIContext.displayName = "VedaUIContext";
function $2dc69dcc479c43b5$var$validateConfig(config) {
    const requiredFields = [
        "envMapboxToken",
        "envApiStacEndpoint",
        "envApiRasterEndpoint"
    ];
    requiredFields.forEach((field)=>{
        const value = config[field];
        if (!value.trim()) // eslint-disable-next-line no-console
        console.warn(`VedaUIProvider: ${field} is required and cannot be empty.`);
    });
}
function $2dc69dcc479c43b5$export$625504311771793d() {
    const context = (0, $3RyIS.useContext)($2dc69dcc479c43b5$var$VedaUIContext);
    if (!context) throw new Error("useVedaUI must be used within a VedaUIProvider");
    return context;
}
function $2dc69dcc479c43b5$export$842d5d9b4379d2a({ config: config, children: children }) {
    const navigation = {
        ...$2dc69dcc479c43b5$var$defaultNavigation,
        ...config.navigation
    };
    const routes = {
        ...$2dc69dcc479c43b5$var$defaultRoutes,
        ...config.routes
    };
    const Link = ({ to: to, children: children, ...props })=>{
        const { LinkComponent: LinkComponent, linkProps: linkProps } = navigation;
        const { pathAttributeKeyName: pathAttributeKeyName, ...htmlLinkProps } = linkProps;
        if ($39y1u.isExternalLink(to)) return /*#__PURE__*/ (0, $21sFD.jsx)("a", {
            href: to,
            target: "_blank",
            rel: "noopener noreferrer",
            ...props,
            children: children
        });
        return /*#__PURE__*/ (0, $21sFD.jsx)(LinkComponent, {
            [pathAttributeKeyName]: to,
            ...htmlLinkProps,
            ...props,
            children: children
        });
    };
    const fullConfig = {
        ...config,
        navigation: navigation,
        routes: routes,
        Link: Link
    };
    $2dc69dcc479c43b5$var$validateConfig(fullConfig);
    return /*#__PURE__*/ (0, $21sFD.jsx)($2dc69dcc479c43b5$var$VedaUIContext.Provider, {
        value: fullConfig,
        children: children
    });
}

});
parcelRegister("39y1u", function(module, exports) {

$parcel$export(module.exports, "validateRangeNum", function () { return $99b506f41b04e7d3$export$233456f449dff06c; });
$parcel$export(module.exports, "composeVisuallyDisabled", function () { return $99b506f41b04e7d3$export$6df8b10de86b21f9; });
$parcel$export(module.exports, "checkEnvFlag", function () { return $99b506f41b04e7d3$export$b1ae4add8586f53a; });
$parcel$export(module.exports, "isExternalLink", function () { return $99b506f41b04e7d3$export$b98882f166bb7ce2; });

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");
function $99b506f41b04e7d3$export$842a2cf37af977e1(a, n) {
    return (a % n + n) % n;
}
function $99b506f41b04e7d3$export$233456f449dff06c(min, max) {
    return (raw)=>{
        const value = Number(raw);
        return !isNaN(value) && raw !== "" && value >= min && value <= max;
    };
}
function $99b506f41b04e7d3$export$930856e8dcb3692d(a, b) {
    // Exist early if they're the same.
    if (a === b) return true;
    return JSON.stringify(a) === JSON.stringify(b);
}
function $99b506f41b04e7d3$export$6df8b10de86b21f9(Comp, additionalStyles) {
    return (0, $6fhRl.default)(Comp).attrs((props)=>{
        const onClickOriginal = props.onClick;
        return {
            onClick: (e)=>{
                if (props.visuallyDisabled) {
                    e.preventDefault();
                    return;
                }
                return onClickOriginal?.(e);
            }
        };
    })`
    ${({ visuallyDisabled: vd })=>vd && (0, $6fhRl.css)`
        ${(0, $atWKR.visuallyDisabled)()}

        &&&:hover {
          ${(0, $atWKR.visuallyDisabled)()}
          background: inherit;
        }

        ${additionalStyles}
      `}
  `;
}
function $99b506f41b04e7d3$export$b1ae4add8586f53a(value) {
    return (value ?? "").toLowerCase() === "true";
}
const $99b506f41b04e7d3$export$b98882f166bb7ce2 = (url)=>{
    return /^https?:\/\//.test(url);
};

});



parcelRegister("50y3l", function(module, exports) {

$parcel$export(module.exports, "NavItemCTA", function () { return $c89d6c9335ee6b15$export$f6d16c56689c659a; });

var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");

var $fH1nS = parcelRequire("fH1nS");

var $1wE4d = parcelRequire("1wE4d");
const $c89d6c9335ee6b15$export$f6d16c56689c659a = ({ item: item })=>{
    const { isRevealed: isRevealed, show: show, hide: hide } = (0, $1wE4d.useDisplay)();
    const defaultClassName = "usa-nav__link";
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).Fragment, {
        children: item.actionId === "open-google-form" && /*#__PURE__*/ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
            children: [
                /*#__PURE__*/ (0, $21sFD.jsx)("button", {
                    className: item.customClassNames || defaultClassName,
                    type: "button",
                    tabIndex: 0,
                    id: item.id,
                    onClick: show,
                    style: {
                        background: "none",
                        border: "none",
                        cursor: "pointer"
                    },
                    children: item.title
                }),
                /*#__PURE__*/ (0, $21sFD.jsx)((0, $fH1nS.default), {
                    src: "https://docs.google.com/forms/d/e/1FAIpQLSeVWCrnca08Gt_qoWYjTo6gnj1BEGL4NCUC9VEiQnXA02gzVQ/viewform",
                    isRevealed: isRevealed,
                    hide: hide
                })
            ]
        })
    }, item.id);
};

});
parcelRegister("fH1nS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79b3096cdef9702b$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $6fhRl = parcelRequire("6fhRl");

var $bpZeU = parcelRequire("bpZeU");
const $79b3096cdef9702b$var$StyledGoogleForm = (0, $6fhRl.default).iframe`
  width: 100%;
`;
const $79b3096cdef9702b$var$GoogleForm = (props)=>{
    const { src: src, isRevealed: isRevealed, hide: hide } = props;
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $21sFD.Fragment), {
        children: /*#__PURE__*/ (0, $21sFD.jsx)((0, $bpZeU.Modal), {
            id: "modal",
            size: "large",
            title: "Contact Us",
            revealed: isRevealed,
            onCloseClick: hide,
            onOverlayClick: hide,
            closeButton: true,
            content: /*#__PURE__*/ (0, $21sFD.jsx)($79b3096cdef9702b$var$StyledGoogleForm, {
                src: src,
                height: 504,
                frameBorder: 0,
                marginHeight: 0,
                marginWidth: 0,
                children: "Loading\u2026"
            })
        })
    });
};
var $79b3096cdef9702b$export$2e2bcd8739ae039 = $79b3096cdef9702b$var$GoogleForm;

});
parcelRegister("bpZeU", function(module, exports) {

$parcel$export(module.exports, "ModalHeader", function () { return $85018863a573216b$export$f50a68e3694789ee; });
$parcel$export(module.exports, "ModalHeadline", function () { return $85018863a573216b$export$27d59016d6ad74f5; });
$parcel$export(module.exports, "ModalBody", function () { return $85018863a573216b$export$cb540d8b0ef7906c; });
$parcel$export(module.exports, "ModalFooter", function () { return $85018863a573216b$export$519437715052e656; });
$parcel$export(module.exports, "Modal", function () { return $85018863a573216b$export$2b77a92f1a5ad772; });

var $3RyIS = parcelRequire("3RyIS");

var $3qHRY = parcelRequire("3qHRY");

var $ifjYT = parcelRequire("ifjYT");

var $9HCvT = parcelRequire("9HCvT");

var $bywau = parcelRequire("bywau");

var $egbTY = parcelRequire("egbTY");

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $9mbTf = parcelRequire("9mbTf");
function $85018863a573216b$var$_extends$1() {
    $85018863a573216b$var$_extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $85018863a573216b$var$_extends$1.apply(this, arguments);
}
function $85018863a573216b$var$_objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $85018863a573216b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $85018863a573216b$var$_objectWithoutPropertiesLoose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $85018863a573216b$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function $85018863a573216b$var$_slicedToArray(arr, i) {
    return $85018863a573216b$var$_arrayWithHoles(arr) || $85018863a573216b$var$_iterableToArrayLimit(arr, i) || $85018863a573216b$var$_unsupportedIterableToArray(arr, i) || $85018863a573216b$var$_nonIterableRest();
}
function $85018863a573216b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $85018863a573216b$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $85018863a573216b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $85018863a573216b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $85018863a573216b$var$_arrayLikeToArray(o, minLen);
}
function $85018863a573216b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $85018863a573216b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $85018863a573216b$var$_extends() {
    $85018863a573216b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $85018863a573216b$var$_extends.apply(this, arguments);
}
function $85018863a573216b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $85018863a573216b$var$_setPrototypeOf(o, p) {
    $85018863a573216b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $85018863a573216b$var$_setPrototypeOf(o, p);
}
function $85018863a573216b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $85018863a573216b$var$_setPrototypeOf(subClass, superClass);
}
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $85018863a573216b$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $85018863a573216b$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!$85018863a573216b$var$hasClass(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}
function $85018863a573216b$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $85018863a573216b$var$removeClass$1(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $85018863a573216b$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $85018863a573216b$var$replaceClassName(element.className && element.className.baseVal || "", className));
}
var $85018863a573216b$var$config = {
    disabled: false
};
var $85018863a573216b$var$TransitionGroupContext = (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createContext(null);
var $85018863a573216b$var$UNMOUNTED = "unmounted";
var $85018863a573216b$var$EXITED = "exited";
var $85018863a573216b$var$ENTERING = "entering";
var $85018863a573216b$var$ENTERED = "entered";
var $85018863a573216b$var$EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $85018863a573216b$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $85018863a573216b$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $85018863a573216b$var$EXITED;
                _this.appearStatus = $85018863a573216b$var$ENTERING;
            } else initialStatus = $85018863a573216b$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $85018863a573216b$var$UNMOUNTED;
        else initialStatus = $85018863a573216b$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $85018863a573216b$var$UNMOUNTED) return {
            status: $85018863a573216b$var$EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $85018863a573216b$var$ENTERING && status !== $85018863a573216b$var$ENTERED) nextStatus = $85018863a573216b$var$ENTERING;
            } else if (status === $85018863a573216b$var$ENTERING || status === $85018863a573216b$var$ENTERED) nextStatus = $85018863a573216b$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $85018863a573216b$var$ENTERING) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $85018863a573216b$var$EXITED) this.setState({
            status: $85018863a573216b$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($3qHRY))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || $85018863a573216b$var$config.disabled) {
            this.safeSetState({
                status: $85018863a573216b$var$ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $85018863a573216b$var$ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $85018863a573216b$var$ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($3qHRY))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || $85018863a573216b$var$config.disabled) {
            this.safeSetState({
                status: $85018863a573216b$var$EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $85018863a573216b$var$EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $85018863a573216b$var$EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($3qHRY))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $85018863a573216b$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = $85018863a573216b$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$var$TransitionGroupContext.Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).Component);
$85018863a573216b$var$Transition.contextType = $85018863a573216b$var$TransitionGroupContext;
$85018863a573216b$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $85018863a573216b$var$noop() {}
$85018863a573216b$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $85018863a573216b$var$noop,
    onEntering: $85018863a573216b$var$noop,
    onEntered: $85018863a573216b$var$noop,
    onExit: $85018863a573216b$var$noop,
    onExiting: $85018863a573216b$var$noop,
    onExited: $85018863a573216b$var$noop
};
$85018863a573216b$var$Transition.UNMOUNTED = $85018863a573216b$var$UNMOUNTED;
$85018863a573216b$var$Transition.EXITED = $85018863a573216b$var$EXITED;
$85018863a573216b$var$Transition.ENTERING = $85018863a573216b$var$ENTERING;
$85018863a573216b$var$Transition.ENTERED = $85018863a573216b$var$ENTERED;
$85018863a573216b$var$Transition.EXITING = $85018863a573216b$var$EXITING;
var $85018863a573216b$var$Transition$1 = $85018863a573216b$var$Transition;
var $85018863a573216b$var$_addClass = function addClass$1(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return $85018863a573216b$var$addClass(node, c);
    });
};
var $85018863a573216b$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return $85018863a573216b$var$removeClass$1(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $85018863a573216b$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    $85018863a573216b$var$_inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") /* eslint-disable no-unused-expressions */ node && node.scrollTop;
        if (className) {
            this.appliedClasses[type][phase] = className;
            $85018863a573216b$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $85018863a573216b$var$removeClass(node, baseClassName);
        if (activeClassName) $85018863a573216b$var$removeClass(node, activeClassName);
        if (doneClassName) $85018863a573216b$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props;
        _this$props.classNames;
        var props = $85018863a573216b$var$_objectWithoutPropertiesLoose(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$var$Transition$1, $85018863a573216b$var$_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).Component);
$85018863a573216b$var$CSSTransition.defaultProps = {
    classNames: ""
};
$85018863a573216b$var$CSSTransition.propTypes = {};
var $85018863a573216b$var$CSSTransition$1 = $85018863a573216b$var$CSSTransition;
var $85018863a573216b$var$_templateObject, $85018863a573216b$var$_templateObject2;
var $85018863a573216b$var$sizeMapping = {
    small: "32rem",
    medium: "48rem",
    large: "64rem",
    xlarge: "80rem",
    fullscreen: "100%"
};
var $85018863a573216b$var$renderModalSize = function renderModalSize() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size;
    return (0, $6fhRl.css)($85018863a573216b$var$_templateObject || ($85018863a573216b$var$_templateObject = $85018863a573216b$var$_taggedTemplateLiteral([
        "\n    max-width: ",
        ";\n  "
    ])), $85018863a573216b$var$sizeMapping[size]);
};
var $85018863a573216b$var$ModalContents = /*#__PURE__*/ (0, $6fhRl.default).div.withConfig({
    displayName: "styled__ModalContents",
    componentId: "sc-1f8l41k-0"
})([
    "display:grid;grid-template-columns:100%;grid-template-rows:",
    ";background:",
    ";border-radius:",
    ";width:100%;margin:",
    ";box-shadow:",
    ";",
    " > *:last-child{margin-bottom:0;}"
], function(_ref) {
    var size = _ref.size;
    return size === "fullscreen" ? "3rem auto" : "auto";
}, (0, $atWKR.themeVal)("color.surface"), (0, $atWKR.themeVal)("shape.rounded"), function(_ref2) {
    var size = _ref2.size;
    return size === "fullscreen" ? 0 : "auto";
}, (0, $atWKR.themeVal)("boxShadow.elevationD"), $85018863a573216b$var$renderModalSize);
var $85018863a573216b$var$ModalWrapper = /*#__PURE__*/ (0, $6fhRl.default).section.withConfig({
    displayName: "styled__ModalWrapper",
    componentId: "sc-1f8l41k-1"
})([
    "display:flex;position:fixed;top:0;bottom:0;left:0;right:0;z-index:9990;overflow-y:auto;opacity:1;visibility:visible;background:",
    ";transform:translate3d(0,0,0);padding:",
    ";&.modal-appear,&.modal-enter{opacity:0;visibility:hidden;}&.modal-enter-appear,&.modal-enter-active{transition:opacity 0.32s ease 0.1s,visibility 0.32s linear 0.1s;opacity:1;visibility:visible;}&.modal-exit{opacity:1;visibility:visible;}&.modal-exit-active{transition:opacity 0.32s ease 0.1s,visibility 0.32s linear 0.1s;opacity:0;visibility:hidden;}"
], (0, $atWKR.themeVal)("color.base-400a"), function(_ref3) {
    var size = _ref3.size;
    return size === "fullscreen" ? 0 : (0, $atWKR.glsp)(2);
});
var $85018863a573216b$var$BodyUnscrollable = (0, $6fhRl.createGlobalStyle)($85018863a573216b$var$_templateObject2 || ($85018863a573216b$var$_templateObject2 = $85018863a573216b$var$_taggedTemplateLiteral([
    "\n  ",
    "\n"
])), function(_ref4) {
    var revealed = _ref4.revealed;
    return revealed && "\n    body {\n      overflow-y: hidden;\n    }\n  ";
});
var $85018863a573216b$export$f50a68e3694789ee = /*#__PURE__*/ (0, $6fhRl.default).header.withConfig({
    displayName: "styled__ModalHeader",
    componentId: "sc-1f8l41k-2"
})([
    "display:flex;gap:",
    ";flex-flow:row nowrap;align-items:center;background:",
    ";padding:",
    ";border-radius:",
    " ",
    " 0 0;"
], (0, $atWKR.glsp)(), (0, $atWKR.themeVal)("color.surface"), (0, $atWKR.glsp)(2), (0, $atWKR.themeVal)("shape.rounded"), (0, $atWKR.themeVal)("shape.rounded"));
var $85018863a573216b$export$27d59016d6ad74f5 = /*#__PURE__*/ (0, $6fhRl.default).div.withConfig({
    displayName: "styled__ModalHeadline",
    componentId: "sc-1f8l41k-3"
})([
    "display:flex;flex-flow:column nowrap;"
]);
var $85018863a573216b$export$90659110dcb654b9 = /*#__PURE__*/ (0, $6fhRl.default)((0, $9mbTf.Toolbar)).withConfig({
    displayName: "styled__ModalToolbar",
    componentId: "sc-1f8l41k-4"
})([
    "margin-left:auto;padding:",
    ";"
], (0, $atWKR.glsp)(1 / 8, 0, 1 / 8, 0));
var $85018863a573216b$export$cb540d8b0ef7906c = /*#__PURE__*/ (0, $6fhRl.default).div.withConfig({
    displayName: "styled__ModalBody",
    componentId: "sc-1f8l41k-5"
})([
    "padding:0 ",
    ";&:first-child{padding-top:",
    ";}&:last-child{padding-bottom:",
    ";}"
], (0, $atWKR.glsp)(2), (0, $atWKR.glsp)(2), (0, $atWKR.glsp)(2));
var $85018863a573216b$export$519437715052e656 = /*#__PURE__*/ (0, $6fhRl.default).footer.withConfig({
    displayName: "styled__ModalFooter",
    componentId: "sc-1f8l41k-6"
})([
    "background:",
    ";padding:",
    ";border-radius:0 0 ",
    " ",
    ";"
], (0, $atWKR.themeVal)("color.surface"), (0, $atWKR.glsp)(2), (0, $atWKR.themeVal)("shape.rounded"), (0, $atWKR.themeVal)("shape.rounded"));
var $85018863a573216b$var$_excluded$1 = [
    "fn",
    "children"
];
/**
 * Tries to render the given function falling back to the children if it is not
 * set.
 *
 * @param {function} fn The render function to try to run
 * @param {node} children The fallback if the render function is not set
 * @prop {any} rest Remaining props are passed to the function
 */ function $85018863a573216b$var$Try(props) {
    /* eslint-disable-next-line react/prop-types */ var F = props.fn, children = props.children, rest = $85018863a573216b$var$_objectWithoutProperties(props, $85018863a573216b$var$_excluded$1);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).isValidElement(F)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement(F, props);
    else if (typeof F === "function") return F(rest);
    else return children || null;
}
var $85018863a573216b$var$_excluded = [
    "id",
    "title",
    "content",
    "footerContent",
    "closeButton",
    "size",
    "revealed",
    "className",
    "disableKeyboardClose",
    "onCloseClick",
    "onOverlayClick",
    "renderContents",
    "renderHeader",
    "renderHeadline",
    "renderToolbar",
    "renderBody",
    "renderFooter"
];
/**
 * React modal component.
 * Displays a modal component which is portaled to the body to ensure is appears
 * over all other elements
 *
 * @param {string} id An id for the modal
 * @param {bool} revealed Whether or not the modal is visible.
 * @param {string} size Size of the modal. One of "small", "medium", "large", "xlarge", "full"
 * @param {string} className Classes for the modal wrapper
 * @param {function} onOverlayClick Callback function for overlay click
 * @param {function} onCloseClick Callback function for close button click
 * @param {bool} closeButton Whether or not the modal should render
 *               the default close button. Default `true`.
 * @param {string} title Title for the modal. Required unless the header is
 *                 being overridden.
 * @param {node} content Modal body content, rendered inside `ModalBody`.
 *               Required unless the body is being overridden.
 * @param {bool} disableKeyboardClose Disables the use of keyboard to close the modal.
 * @param {node} footerContent Modal footer content, rendered
 *               inside `ModalFooter`.
 * @param {function} renderContents Overrides the contents of the modal.
 *                   Anything returned by this function is rendered inside
 *                   `ModalContents`.
 *                   Signature: fn(bag). Bag has the following props:
 *                     {function} close Method to close the modal.
 * @param {function} renderHeader Overrides the modal header element.
 *                   Anything returned by this function is rendered instead of
 *                   `ModalHeader`.
 *                   Signature: fn(bag). Bag has the following props:
 *                     {function} close Method to close the modal.
 * @param {function} renderHeadline Overrides the modal headline element.
 *                   Anything returned by this function is rendered instead of
 *                   `ModalHeadline`.
 *                   Signature: fn(bag). Bag has the following props:
 *                     {function} close Method to close the modal.
 * @param {function} renderToolbar Overrides the modal toolbar element.
 *                   Anything returned by this function is rendered instead of
 *                   `ModalToolbar`.
 *                   Signature: fn(bag). Bag has the following props:
 *                     {function} close Method to close the modal.
 * @param {function} renderBody Overrides the modal body element.
 *                   Anything returned by this function is rendered instead of
 *                   `ModalBody`.
 *                   Signature: fn(bag). Bag has the following props:
 *                     {function} close Method to close the modal.
 * @param {function} renderFooter Overrides the modal footer element.
 *                   Anything returned by this function is rendered instead of
 *                   `ModalFooter`.
 *                   Signature: fn(bag). Bag has the following props:
 *                     {function} close Method to close the modal.
 */ function $85018863a573216b$export$2b77a92f1a5ad772(props) {
    var id = props.id, title = props.title, content = props.content, footerContent = props.footerContent, closeButton = props.closeButton, size = props.size, revealed = props.revealed, className = props.className, disableKeyboardClose = props.disableKeyboardClose, onCloseClick = props.onCloseClick, onOverlayClick = props.onOverlayClick, renderContents = props.renderContents, renderHeader = props.renderHeader, renderHeadline = props.renderHeadline, renderToolbar = props.renderToolbar, renderBody = props.renderBody, renderFooter = props.renderFooter, rest = $85018863a573216b$var$_objectWithoutProperties(props, $85018863a573216b$var$_excluded);
    var uuid = (0, $3RyIS.useRef)($85018863a573216b$export$2b77a92f1a5ad772.generateUUID());
    var _useState = (0, $3RyIS.useState)(false), _useState2 = $85018863a573216b$var$_slicedToArray(_useState, 2), hasMounted = _useState2[0], setHasMounted = _useState2[1];
    var _useState3 = (0, $3RyIS.useState)(null), _useState4 = $85018863a573216b$var$_slicedToArray(_useState3, 2), modalElement = _useState4[0], setModalElement = _useState4[1]; // Key listener for esc key.
    (0, $3RyIS.useEffect)(function() {
        if (disableKeyboardClose) return;
        var keyListener = function keyListener(e) {
            // ESC.
            if (revealed && e.keyCode === 27) {
                e.preventDefault();
                onCloseClick(e);
            }
        };
        document.addEventListener("keyup", keyListener);
        return function() {
            document.removeEventListener("keyup", keyListener);
        };
    }, [
        revealed,
        onCloseClick,
        disableKeyboardClose
    ]); // Will be called on initial mount.
    (0, $3RyIS.useEffect)(function() {
        var el = document.createElement("div");
        el.className = "modal-portal-".concat(uuid.current);
        document.body.appendChild(el);
        setModalElement(el);
        setHasMounted(true);
        return function() {
            document.body.removeChild(el);
        };
    }, []); // Note:
    // This check is necessary for this component to work when used with SSR.
    // While react-portal will itself check if window is available, that is not
    // enough to ensure that there aren't discrepancies between what the server
    // renders and what the client renders, as the client *will* have access to
    // the window. Therefore, we should only render the root level portal element
    // once the component has actually mounted, as determined by a state variable.
    if (!hasMounted) return null;
    var _onOverlayClick = function _onOverlayClick(e) {
        // Prevent children from triggering this.
        if (e.target === e.currentTarget && typeof onOverlayClick === "function") onOverlayClick(e);
    };
    var klasses = [
        "modal",
        className
    ];
    var _onCloseClick = function _onCloseClick(e) {
        e.preventDefault();
        onCloseClick(e);
    };
    var fnBag = {
        close: _onCloseClick
    };
    return /*#__PURE__*/ (0, $3qHRY.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$var$CSSTransition$1, {
        in: revealed,
        appear: true,
        unmountOnExit: true,
        classNames: "modal",
        timeout: {
            enter: 400,
            exit: 400
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$var$ModalWrapper, $85018863a573216b$var$_extends$1({
        className: klasses.join(" "),
        key: "modal-".concat(id),
        onClick: _onOverlayClick,
        id: id,
        size: size
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$var$BodyUnscrollable, {
        revealed: revealed
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$var$ModalContents, {
        className: "modal__contents",
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$var$Try, $85018863a573216b$var$_extends$1({
        fn: renderContents
    }, fnBag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$var$Try, $85018863a573216b$var$_extends$1({
        fn: renderHeader
    }, fnBag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$export$f50a68e3694789ee, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$var$Try, $85018863a573216b$var$_extends$1({
        fn: renderHeadline
    }, fnBag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$export$27d59016d6ad74f5, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement((0, $egbTY.Heading), {
        size: "small"
    }, title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$var$Try, $85018863a573216b$var$_extends$1({
        fn: renderToolbar
    }, fnBag), closeButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$export$90659110dcb654b9, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement((0, $9HCvT.Button), {
        size: "small",
        fitting: "skinny",
        onClick: _onCloseClick,
        title: "Close modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement((0, $bywau.CollecticonXmarkSmall), {
        title: "Close modal",
        meaningful: true
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$var$Try, $85018863a573216b$var$_extends$1({
        fn: renderBody
    }, fnBag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$export$cb540d8b0ef7906c, null, content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$var$Try, $85018863a573216b$var$_extends$1({
        fn: renderFooter
    }, fnBag), footerContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($85018863a573216b$export$519437715052e656, null, footerContent) : null))))), modalElement);
} // Use a static method to generate a uuid so it can be mocked during tests.
$85018863a573216b$export$2b77a92f1a5ad772.generateUUID = function() {
    return Math.random().toString(36).substr(2, 5);
};
$85018863a573216b$export$2b77a92f1a5ad772.defaultProps = {
    closeButton: true,
    revealed: false,
    size: "medium",
    onOverlayClick: function onOverlayClick() {},
    onCloseClick: function onCloseClick() {}
};
$85018863a573216b$export$2b77a92f1a5ad772.propTypes = {
    id: (0, $ifjYT.PropTypes).string.isRequired,
    revealed: (0, $ifjYT.PropTypes).bool,
    className: (0, $ifjYT.PropTypes).string,
    size: (0, $ifjYT.PropTypes).oneOf([
        "small",
        "medium",
        "large",
        "xlarge",
        "fullscreen"
    ]),
    onOverlayClick: (0, $ifjYT.PropTypes).func,
    onCloseClick: (0, $ifjYT.PropTypes).func,
    closeButton: (0, $ifjYT.PropTypes).bool,
    disableKeyboardClose: (0, $ifjYT.PropTypes).bool,
    title: (0, $ifjYT.PropTypes).string,
    renderContents: (0, $ifjYT.PropTypes).func,
    renderHeader: (0, $ifjYT.PropTypes).func,
    renderHeadline: (0, $ifjYT.PropTypes).func,
    renderToolbar: (0, $ifjYT.PropTypes).func,
    renderBody: (0, $ifjYT.PropTypes).func,
    content: (0, $ifjYT.PropTypes).node,
    renderFooter: (0, $ifjYT.PropTypes).func,
    footerContent: (0, $ifjYT.PropTypes).node
};

});
parcelRegister("9HCvT", function(module, exports) {

$parcel$export(module.exports, "createButtonStyles", function () { return $7106012d8f305125$export$cc180511040450b0; });
$parcel$export(module.exports, "Button", function () { return $7106012d8f305125$export$353f5b6fc5456de1; });
$parcel$export(module.exports, "createButtonGroupStyles", function () { return $7106012d8f305125$export$601b1256e3377a5d; });

var $ifjYT = parcelRequire("ifjYT");

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $3RyIS = parcelRequire("3RyIS");
function $7106012d8f305125$var$_extends() {
    $7106012d8f305125$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7106012d8f305125$var$_extends.apply(this, arguments);
}
function $7106012d8f305125$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7106012d8f305125$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7106012d8f305125$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7106012d8f305125$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function $7106012d8f305125$var$_slicedToArray(arr, i) {
    return $7106012d8f305125$var$_arrayWithHoles(arr) || $7106012d8f305125$var$_iterableToArrayLimit(arr, i) || $7106012d8f305125$var$_unsupportedIterableToArray(arr, i) || $7106012d8f305125$var$_nonIterableRest();
}
function $7106012d8f305125$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7106012d8f305125$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $7106012d8f305125$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7106012d8f305125$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7106012d8f305125$var$_arrayLikeToArray(o, minLen);
}
function $7106012d8f305125$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7106012d8f305125$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7106012d8f305125$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7106012d8f305125$var$_setPrototypeOf(o, p) {
    $7106012d8f305125$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7106012d8f305125$var$_setPrototypeOf(o, p);
}
function $7106012d8f305125$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $7106012d8f305125$var$_setPrototypeOf(subClass, superClass);
}
function $7106012d8f305125$var$_getPrototypeOf(o) {
    $7106012d8f305125$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7106012d8f305125$var$_getPrototypeOf(o);
}
function $7106012d8f305125$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $7106012d8f305125$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7106012d8f305125$var$_construct(Parent, args, Class) {
    if ($7106012d8f305125$var$_isNativeReflectConstruct()) $7106012d8f305125$var$_construct = Reflect.construct;
    else $7106012d8f305125$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $7106012d8f305125$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $7106012d8f305125$var$_construct.apply(null, arguments);
}
function $7106012d8f305125$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $7106012d8f305125$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$7106012d8f305125$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $7106012d8f305125$var$_construct(Class, arguments, $7106012d8f305125$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $7106012d8f305125$var$_setPrototypeOf(Wrapper, Class);
    };
    return $7106012d8f305125$var$_wrapNativeSuper(Class);
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */ var $7106012d8f305125$var$PolishedError = /*#__PURE__*/ function(_Error) {
    $7106012d8f305125$var$_inheritsLoose(PolishedError, _Error);
    function PolishedError(code) {
        var _this;
        _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
        return $7106012d8f305125$var$_assertThisInitialized(_this);
    }
    return PolishedError;
}(/*#__PURE__*/ $7106012d8f305125$var$_wrapNativeSuper(Error));
function $7106012d8f305125$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $7106012d8f305125$var$convertToInt(red, green, blue) {
    return $7106012d8f305125$var$colorToInt(red) + "," + $7106012d8f305125$var$colorToInt(green) + "," + $7106012d8f305125$var$colorToInt(blue);
}
function $7106012d8f305125$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $7106012d8f305125$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
     // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = (hue % 360 + 360) % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $7106012d8f305125$var$namedColorMap = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "00ffff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "0000ff",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "00ffff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "ff00ff",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "639",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */ function $7106012d8f305125$var$nameToHex(color) {
    if (typeof color !== "string") return color;
    var normalizedColorName = color.toLowerCase();
    return $7106012d8f305125$var$namedColorMap[normalizedColorName] ? "#" + $7106012d8f305125$var$namedColorMap[normalizedColorName] : color;
}
var $7106012d8f305125$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $7106012d8f305125$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $7106012d8f305125$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $7106012d8f305125$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $7106012d8f305125$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
var $7106012d8f305125$var$rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
var $7106012d8f305125$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var $7106012d8f305125$var$hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $7106012d8f305125$var$parseToRgb(color) {
    if (typeof color !== "string") throw new $7106012d8f305125$var$PolishedError(3);
    var normalizedColor = $7106012d8f305125$var$nameToHex(color);
    if (normalizedColor.match($7106012d8f305125$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($7106012d8f305125$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($7106012d8f305125$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($7106012d8f305125$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $7106012d8f305125$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $7106012d8f305125$var$rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $7106012d8f305125$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $7106012d8f305125$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $7106012d8f305125$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new $7106012d8f305125$var$PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $7106012d8f305125$var$hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $7106012d8f305125$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $7106012d8f305125$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new $7106012d8f305125$var$PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4])
        };
    }
    throw new $7106012d8f305125$var$PolishedError(5);
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $7106012d8f305125$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
function $7106012d8f305125$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $7106012d8f305125$var$rgb(value, green, blue) {
    if (typeof value === "number" && typeof green === "number" && typeof blue === "number") return $7106012d8f305125$var$reduceHexValue("#" + $7106012d8f305125$var$numberToHex(value) + $7106012d8f305125$var$numberToHex(green) + $7106012d8f305125$var$numberToHex(blue));
    else if (typeof value === "object" && green === undefined && blue === undefined) return $7106012d8f305125$var$reduceHexValue("#" + $7106012d8f305125$var$numberToHex(value.red) + $7106012d8f305125$var$numberToHex(value.green) + $7106012d8f305125$var$numberToHex(value.blue));
    throw new $7106012d8f305125$var$PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $7106012d8f305125$var$rgba(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === "string" && typeof secondValue === "number") {
        var rgbValue = $7106012d8f305125$var$parseToRgb(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === "number" && typeof secondValue === "number" && typeof thirdValue === "number" && typeof fourthValue === "number") return fourthValue >= 1 ? $7106012d8f305125$var$rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === "object" && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $7106012d8f305125$var$rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new $7106012d8f305125$var$PolishedError(7);
}
// global button group props, like the size.
// Context
var $7106012d8f305125$var$ButtonGroupContext = /*#__PURE__*/ (0, $3RyIS.createContext)({
    inGroup: false
}); // Context provider
var $7106012d8f305125$export$85041a2bb9328e33 = function ButtonGroupProvider(props) {
    var children = props.children, size = props.size, radius = props.radius, _props$variation = props.variation, variation = _props$variation === void 0 ? "base-fill" : _props$variation;
    var contextValue = (0, $3RyIS.useMemo)(function() {
        return {
            inGroup: true,
            size: size,
            radius: radius,
            variation: variation
        };
    }, [
        size,
        radius,
        variation
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($7106012d8f305125$var$ButtonGroupContext.Provider, {
        value: contextValue
    }, children);
};
$7106012d8f305125$export$85041a2bb9328e33.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).node,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    radius: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    variation: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string
}; // Context consumer
var $7106012d8f305125$export$749e21be8b14b968 = function useButtonGroup() {
    // It should be possible to use the hook outside the button group to allow
    // component reusability.
    return (0, $3RyIS.useContext)($7106012d8f305125$var$ButtonGroupContext);
};
var $7106012d8f305125$var$_templateObject$1, $7106012d8f305125$var$_templateObject2$1, $7106012d8f305125$var$_templateObject3$1, $7106012d8f305125$var$_templateObject4, $7106012d8f305125$var$_templateObject5, $7106012d8f305125$var$_templateObject6, $7106012d8f305125$var$_templateObject7, $7106012d8f305125$var$_templateObject8, $7106012d8f305125$var$_templateObject9, $7106012d8f305125$var$_templateObject10, $7106012d8f305125$var$_templateObject11, $7106012d8f305125$var$_templateObject12, $7106012d8f305125$var$_templateObject13, $7106012d8f305125$var$_templateObject14, $7106012d8f305125$var$_templateObject15, $7106012d8f305125$var$_templateObject16, $7106012d8f305125$var$_templateObject17;
var $7106012d8f305125$export$cc180511040450b0 = function createButtonStyles(props) {
    return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject$1 || ($7106012d8f305125$var$_templateObject$1 = $7106012d8f305125$var$_taggedTemplateLiteral([
        "\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: ",
        ";\n    user-select: none;\n    line-height: inherit;\n    border: ",
        " solid transparent;\n    background: transparent;\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    font-style: ",
        ";\n    font-variation-settings: ",
        ";\n    text-transform: ",
        ";\n    outline: 0 solid transparent;\n    text-decoration: none;\n    transition: background-color 0.24s ease-in-out 0s,\n      outline-width 0.16s ease-in-out 0s;\n\n    &:focus-visible {\n      outline-width: 0.25rem;\n    }\n\n    &:focus:not(:focus-visible) {\n      outline: 0;\n    }\n\n    /* Disabled state based on prop. */\n    ",
        "\n\n    &[disabled] {\n      ",
        "\n    }\n\n    /* Size. */\n    ",
        "\n\n    /* Variation. */\n    ",
        "\n\n    /* Content Fit */\n    ",
        "\n\n    /* Radius */\n    &,\n    &::after {\n      ",
        "\n    }\n\n    &::after {\n      position: absolute;\n      z-index: 10;\n      top: -",
        ";\n      right: -",
        ";\n      bottom: -",
        ";\n      left: -",
        ";\n      content: '';\n      background: transparent;\n      pointer-events: none;\n    }\n  "
    ])), (0, $atWKR.glsp)(0.25), (0, $atWKR.themeVal)("button.shape.border"), (0, $atWKR.themeVal)("button.type.family"), (0, $atWKR.themeVal)("button.type.weight"), (0, $atWKR.themeVal)("button.type.style"), (0, $atWKR.themeVal)("button.type.settings"), (0, $atWKR.themeVal)("button.type.case"), $7106012d8f305125$var$renderDisabledState(props), (0, $atWKR.disabled)(), $7106012d8f305125$var$renderButtonSize(props), $7106012d8f305125$var$renderButtonVariation(props), $7106012d8f305125$var$renderButtonFitting(props), $7106012d8f305125$var$renderButtonRadius(props), (0, $atWKR.themeVal)("button.shape.border"), (0, $atWKR.themeVal)("button.shape.border"), (0, $atWKR.themeVal)("button.shape.border"), (0, $atWKR.themeVal)("button.shape.border"));
}; // Styled component of a button
var $7106012d8f305125$var$StyledButton = /*#__PURE__*/ (0, $6fhRl.default).button.attrs(function(props) {
    return {
        "aria-pressed": String(!!props.active),
        type: props.type || (!props.as ? "button" : undefined)
    };
}).withConfig({
    displayName: "Button__StyledButton",
    componentId: "sc-1n019q7-0"
})([
    "",
    ""
], $7106012d8f305125$export$cc180511040450b0);
/* eslint-disable react/display-name, react/prop-types */ // Wrap the styled button in a high order component to pass the context
// provider. This component needs to also become a styled-component to take
// advantage of the styled component functionalities.
// To be sure that this component maintains its structure you MUST use the
// styled-component's `forwardedAs` property when replacing what's being
// rendered, instead of using `as`.
var $7106012d8f305125$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $6fhRl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).forwardRef(function(props, ref) {
    var _useButtonGroup = $7106012d8f305125$export$749e21be8b14b968(), size = _useButtonGroup.size, variation = _useButtonGroup.variation, radius = _useButtonGroup.radius;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($7106012d8f305125$var$StyledButton, $7106012d8f305125$var$_extends({
        size: size,
        variation: variation,
        radius: radius
    }, props, {
        ref: ref
    }));
})).withConfig({
    displayName: "Button",
    componentId: "sc-1n019q7-1"
})([
    ""
]);
/* eslint-enable */ $7106012d8f305125$export$353f5b6fc5456de1.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).node,
    variation: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    radius: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    fitting: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).bool
};
/**
 * Renders the button disabled stated.
 *
 * @param {object} props The element props
 * @param {bool} props.disabled Whether the button should be disabled.
 */ function $7106012d8f305125$var$renderDisabledState(props) {
    return props.disabled ? (0, $atWKR.disabled)() : (0, $6fhRl.css)($7106012d8f305125$var$_templateObject2$1 || ($7106012d8f305125$var$_templateObject2$1 = $7106012d8f305125$var$_taggedTemplateLiteral([
        "\n        cursor: pointer;\n      "
    ])));
}
/**
 * Renders the button size based on the props.
 *
 * @param {object} props The element props
 * @param {string} props.size The value for the box. One of
 *                 "small" | "medium" | "large" | "xlarge"
 */ function $7106012d8f305125$var$renderButtonSize(props) {
    var _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size;
    switch(size){
        case "small":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject3$1 || ($7106012d8f305125$var$_templateObject3$1 = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        min-width: 1.5rem;\n        height: 1.5rem;\n        font-size: 0.875rem;\n        padding: 0 0.5rem;\n      "
            ])));
        case "medium":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject4 || ($7106012d8f305125$var$_templateObject4 = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        min-width: 2rem;\n        height: 2rem;\n        font-size: 1rem;\n        padding: 0 0.75rem;\n      "
            ])));
        case "large":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject5 || ($7106012d8f305125$var$_templateObject5 = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        min-width: 2.5rem;\n        height: 2.5rem;\n        font-size: 1rem;\n        padding: 0 1rem;\n      "
            ])));
        case "xlarge":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject6 || ($7106012d8f305125$var$_templateObject6 = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        min-width: 3rem;\n        height: 3rem;\n        font-size: 1rem;\n        padding: 0 1.25rem;\n      "
            ])));
        default:
            throw new Error("Invalid button size (".concat(size, "). Must be one of [small, medium, large, xlarge]."));
    }
}
function $7106012d8f305125$var$renderButtonVariation(props) {
    var _props$variation;
    var _ref = ((_props$variation = props.variation) === null || _props$variation === void 0 ? void 0 : _props$variation.split("-")) || [
        "base",
        "text"
    ], _ref2 = $7106012d8f305125$var$_slicedToArray(_ref, 2), color = _ref2[0], type = _ref2[1]; // Function to get the color from the theme.
    var tColor = function tColor(c) {
        return (0, $atWKR.themeVal)([
            "color",
            c
        ]);
    };
    if (![
        "text",
        "fill",
        "outline"
    ].includes(type)) throw new Error("Invalid button type (".concat(type, "). Must be one of [text, fill, outline]."));
    if (color === "achromic") {
        if (type === "fill") throw new Error("achromic-fill buttons do not exist.");
        switch(type){
            case "text":
                return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject7 || ($7106012d8f305125$var$_templateObject7 = $7106012d8f305125$var$_taggedTemplateLiteral([
                    "\n          color: #fff;\n\n          &:hover {\n            background-color: ",
                    ";\n          }\n\n          /* Print & when prop is passed */\n          ",
                    "\n          &:active,\n          &.active {\n            background-color: ",
                    ";\n          }\n\n          &:focus-visible {\n            outline-color: ",
                    ";\n          }\n        "
                ])), $7106012d8f305125$var$rgba("#fff", 0.04), function(_ref3) {
                    var active = _ref3.active;
                    return active && "&,";
                }, $7106012d8f305125$var$rgba("#fff", 0.08), $7106012d8f305125$var$rgba("#fff", 0.16));
            case "outline":
                return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject8 || ($7106012d8f305125$var$_templateObject8 = $7106012d8f305125$var$_taggedTemplateLiteral([
                    "\n          border-color: #fff;\n          color: #fff;\n\n          &:hover {\n            background-color: ",
                    ";\n          }\n\n          /* Print & when prop is passed */\n          ",
                    "\n          &:active,\n          &.active {\n            background-color: ",
                    ";\n          }\n\n          &:focus-visible {\n            outline-color: ",
                    ";\n          }\n        "
                ])), $7106012d8f305125$var$rgba("#fff", 0.04), function(_ref4) {
                    var active = _ref4.active;
                    return active && "&,";
                }, $7106012d8f305125$var$rgba("#fff", 0.04), $7106012d8f305125$var$rgba("#fff", 0.16));
        }
    }
    switch(type){
        case "text":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject9 || ($7106012d8f305125$var$_templateObject9 = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        color: ",
                ";\n\n        &:hover {\n          background-color: ",
                ";\n        }\n\n        /* Print & when prop is passed */\n        ",
                "\n        &:active,\n        &.active {\n          background-color: ",
                ";\n        }\n\n        &:focus-visible {\n          outline-color: ",
                ";\n        }\n      "
            ])), tColor(color), tColor("".concat(color, "-50a")), function(_ref5) {
                var active = _ref5.active;
                return active && "&,";
            }, tColor("".concat(color, "-100a")), tColor("".concat(color, "-200a")));
        case "outline":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject10 || ($7106012d8f305125$var$_templateObject10 = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        border-color: ",
                ";\n        color: ",
                ";\n\n        &:hover {\n          background-color: ",
                ";\n        }\n\n        /* Print & when prop is passed */\n        ",
                "\n        &:active,\n        &.active {\n          background-color: ",
                ";\n        }\n\n        &:focus-visible {\n          outline-color: ",
                ";\n        }\n      "
            ])), tColor(color), tColor(color), tColor("".concat(color, "-50a")), function(_ref6) {
                var active = _ref6.active;
                return active && "&,";
            }, tColor("".concat(color, "-100a")), tColor("".concat(color, "-200a")));
        case "fill":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject11 || ($7106012d8f305125$var$_templateObject11 = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        border-color: ",
                ";\n        background-color: ",
                ";\n        color: #fff;\n\n        &:hover {\n          background-color: ",
                ";\n        }\n\n        /* Print & when prop is passed */\n        ",
                "\n        &:active,\n        &.active {\n          background-color: ",
                ";\n        }\n\n        &:focus-visible {\n          outline-color: ",
                ";\n        }\n\n        &::after {\n          box-shadow: ",
                ";\n        }\n      "
            ])), (0, $atWKR.themeVal)("color.base-200a"), tColor(color), tColor("".concat(color, "-600")), function(_ref7) {
                var active = _ref7.active;
                return active && "&,";
            }, tColor("".concat(color, "-700")), tColor("".concat(color, "-200a")), (0, $atWKR.themeVal)("boxShadow.elevationB"));
    }
}
/**
 * Renders the border radius based on the props.
 *
 * @param {object} props The element props
 * @param {string} props.radius The value for the radius. One of
 *                 "ellipsoid" | "square" | "rounded"
 */ function $7106012d8f305125$var$renderButtonRadius(props) {
    var _props$radius = props.radius, radius = _props$radius === void 0 ? "rounded" : _props$radius;
    switch(radius){
        case "rounded":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject12 || ($7106012d8f305125$var$_templateObject12 = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        border-radius: ",
                ";\n      "
            ])), (0, $atWKR.themeVal)("shape.rounded"));
        case "ellipsoid":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject13 || ($7106012d8f305125$var$_templateObject13 = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        border-radius: ",
                ";\n      "
            ])), (0, $atWKR.themeVal)("shape.ellipsoid"));
        case "square":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject14 || ($7106012d8f305125$var$_templateObject14 = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        border-radius: 0;\n      "
            ])));
        default:
            throw new Error("Invalid button radius (".concat(radius, "). Must be one of [rounded, ellipsoid, square]."));
    }
}
/**
 * Renders the content fit based on the props.
 *
 * @param {object} props The element props
 * @param {string} props.fitting The value for the content fit. One of
 *                 "skinny" | "regular" | "relaxed" | "baggy"
 */ function $7106012d8f305125$var$renderButtonFitting(props) {
    var _props$fitting = props.fitting, fitting = _props$fitting === void 0 ? "regular" : _props$fitting;
    switch(fitting){
        case "skinny":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject15 || ($7106012d8f305125$var$_templateObject15 = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        padding-left: 0;\n        padding-right: 0;\n      "
            ])));
        case "regular":
            return "";
        case "relaxed":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject16 || ($7106012d8f305125$var$_templateObject16 = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        min-width: 12rem;\n      "
            ])));
        case "baggy":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject17 || ($7106012d8f305125$var$_templateObject17 = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        width: 100%;\n      "
            ])));
        default:
            throw new Error("Invalid button fitting (".concat(fitting, "). Must be one of [skinny, regular, relaxed, baggy]."));
    }
}
var $7106012d8f305125$var$_excluded = [
    "className",
    "children",
    "size",
    "variation",
    "radius",
    "role"
];
var $7106012d8f305125$var$_templateObject, $7106012d8f305125$var$_templateObject2, $7106012d8f305125$var$_templateObject3;
/**
 * Renders the button group orientation based on the props.
 *
 * @param {object} props The element props
 * @param {string} props.orientation The value for the orientation. One of
 *                 "horizontal" | "vertical"
 */ function $7106012d8f305125$var$renderOrientation(props) {
    var _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation;
    switch(orientation){
        case "horizontal":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject || ($7106012d8f305125$var$_templateObject = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        flex-flow: row nowrap;\n        > ",
                ":first-child:not(:last-child) {\n          &,\n          &::after {\n            border-top-right-radius: 0;\n            border-bottom-right-radius: 0;\n          }\n\n          &::after {\n            clip-path: inset(-100% 0 -100% -100%);\n          }\n        }\n        > ",
                ":last-child:not(:first-child) {\n          &,\n          &::after {\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n          }\n\n          &::after {\n            clip-path: inset(-100% -100% -100% 0);\n          }\n        }\n        > ",
                ":not(:first-child):not(:last-child) {\n          &,\n          &::after {\n            border-radius: 0;\n          }\n\n          &::after {\n            clip-path: inset(-100% 0);\n          }\n        }\n        > ",
                " + ",
                " {\n          margin-left: -",
                ";\n        }\n      "
            ])), $7106012d8f305125$export$353f5b6fc5456de1, $7106012d8f305125$export$353f5b6fc5456de1, $7106012d8f305125$export$353f5b6fc5456de1, $7106012d8f305125$export$353f5b6fc5456de1, $7106012d8f305125$export$353f5b6fc5456de1, (0, $atWKR.themeVal)("button.shape.border"));
        case "vertical":
            return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject2 || ($7106012d8f305125$var$_templateObject2 = $7106012d8f305125$var$_taggedTemplateLiteral([
                "\n        flex-flow: column;\n        > ",
                ":first-child:not(:last-child) {\n          &,\n          &::after {\n            border-bottom-right-radius: 0;\n            border-bottom-left-radius: 0;\n          }\n\n          &::after {\n            clip-path: inset(-100% -100% 0 -100%);\n          }\n        }\n        > ",
                ":last-child:not(:first-child) {\n          &,\n          &::after {\n            border-top-left-radius: 0;\n            border-top-right-radius: 0;\n          }\n\n          &::after {\n            clip-path: inset(0 -100% -100% -100%);\n          }\n        }\n        > ",
                ":not(:first-child):not(:last-child) {\n          &,\n          &::after {\n            border-radius: 0;\n          }\n\n          &::after {\n            clip-path: inset(0 -100%);\n          }\n        }\n        > ",
                " + ",
                " {\n          margin-top: -",
                ";\n        }\n      "
            ])), $7106012d8f305125$export$353f5b6fc5456de1, $7106012d8f305125$export$353f5b6fc5456de1, $7106012d8f305125$export$353f5b6fc5456de1, $7106012d8f305125$export$353f5b6fc5456de1, $7106012d8f305125$export$353f5b6fc5456de1, (0, $atWKR.themeVal)("button.shape.border"));
        default:
            throw new Error("Invalid button group orientation (".concat(orientation, "). Must be one of [horizontal, vertical]."));
    }
}
var $7106012d8f305125$export$601b1256e3377a5d = function createButtonGroupStyles(props) {
    return (0, $6fhRl.css)($7106012d8f305125$var$_templateObject3 || ($7106012d8f305125$var$_templateObject3 = $7106012d8f305125$var$_taggedTemplateLiteral([
        "\n    position: relative;\n    display: inline-flex;\n\n    > ",
        " {\n      position: relative;\n      flex: 1 1 auto;\n\n      &:focus {\n        z-index: 1;\n      }\n    }\n\n    /* Group orientation */\n    ",
        "\n  "
    ])), $7106012d8f305125$export$353f5b6fc5456de1, $7106012d8f305125$var$renderOrientation(props));
}; // Styled component of the button group.
var $7106012d8f305125$var$StyledButtonGroup = /*#__PURE__*/ (0, $6fhRl.default).div.withConfig({
    displayName: "ButtonGroup__StyledButtonGroup",
    componentId: "sc-tfq0db-0"
})([
    "",
    ""
], $7106012d8f305125$export$601b1256e3377a5d);
/* eslint-disable react/display-name, react/prop-types */ // Wrap the styled button in a high order component to pass the context
// provider. This component needs to also become a styled-component to take
// advantage of the styled component functionalities.
// To be sure that this component maintains its structure you MUST use the
// styled-component's `forwardedAs` property when replacing what's being
// rendered, instead of using `as`.
var $7106012d8f305125$export$69b1032f2ecdf404 = /*#__PURE__*/ (0, $6fhRl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).forwardRef(function(props, ref) {
    var className = props.className, children = props.children, size = props.size, variation = props.variation, radius = props.radius, _props$role = props.role, role = _props$role === void 0 ? "group" : _props$role, rest = $7106012d8f305125$var$_objectWithoutProperties(props, $7106012d8f305125$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($7106012d8f305125$export$85041a2bb9328e33, {
        size: size,
        variation: variation,
        radius: radius
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($7106012d8f305125$var$StyledButtonGroup, $7106012d8f305125$var$_extends({
        className: className,
        role: role,
        ref: ref
    }, rest), children));
})).withConfig({
    displayName: "ButtonGroup",
    componentId: "sc-tfq0db-1"
})([
    ""
]);
/* eslint-enable */ $7106012d8f305125$export$69b1032f2ecdf404.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    variation: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    radius: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string
};

});

parcelRegister("bywau", function(module, exports) {

$parcel$export(module.exports, "iconDataURI", function () { return $022bcdb8507c1d1a$export$60da06e7afb307b7; });
$parcel$export(module.exports, "CollecticonArrowRight", function () { return $022bcdb8507c1d1a$export$d30f3c1f95f9e187; });
$parcel$export(module.exports, "CollecticonBrandGithub", function () { return $022bcdb8507c1d1a$export$68cfb6157bb0630; });
$parcel$export(module.exports, "CollecticonChevronDownSmall", function () { return $022bcdb8507c1d1a$export$c99fa69b6fe4cbfa; });
$parcel$export(module.exports, "CollecticonEnvelope", function () { return $022bcdb8507c1d1a$export$8f179830d10593db; });
$parcel$export(module.exports, "CollecticonExpandTopRight", function () { return $022bcdb8507c1d1a$export$10a0ddbd1861a097; });
$parcel$export(module.exports, "CollecticonSpeechBalloon", function () { return $022bcdb8507c1d1a$export$154cb3948df3efa1; });
$parcel$export(module.exports, "CollecticonTextBlock", function () { return $022bcdb8507c1d1a$export$3b8ef319a6c5f131; });
$parcel$export(module.exports, "CollecticonTickSmall", function () { return $022bcdb8507c1d1a$export$7679025d661a5f99; });
$parcel$export(module.exports, "CollecticonXmarkSmall", function () { return $022bcdb8507c1d1a$export$4cca98ab4f54f41d; });

var $3RyIS = parcelRequire("3RyIS");

var $6fhRl = parcelRequire("6fhRl");

var $ifjYT = parcelRequire("ifjYT");

var $lGXdi = parcelRequire("lGXdi");
function $022bcdb8507c1d1a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $022bcdb8507c1d1a$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $022bcdb8507c1d1a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $022bcdb8507c1d1a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $022bcdb8507c1d1a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $022bcdb8507c1d1a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $022bcdb8507c1d1a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $022bcdb8507c1d1a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $022bcdb8507c1d1a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $022bcdb8507c1d1a$var$server_node = {
    exports: {}
};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */ var $022bcdb8507c1d1a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $022bcdb8507c1d1a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $022bcdb8507c1d1a$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $022bcdb8507c1d1a$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $022bcdb8507c1d1a$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
var $022bcdb8507c1d1a$var$objectAssign = $022bcdb8507c1d1a$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $022bcdb8507c1d1a$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($022bcdb8507c1d1a$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($022bcdb8507c1d1a$var$getOwnPropertySymbols) {
            symbols = $022bcdb8507c1d1a$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($022bcdb8507c1d1a$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};
/** @license React v16.14.0
 * react-dom-server.node.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $022bcdb8507c1d1a$var$k = $022bcdb8507c1d1a$var$objectAssign, $022bcdb8507c1d1a$var$m = (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))), $022bcdb8507c1d1a$var$aa = (0, (/*@__PURE__*/$parcel$interopDefault($lGXdi)));
function $022bcdb8507c1d1a$var$r(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $022bcdb8507c1d1a$var$u = "function" === typeof Symbol && Symbol.for, $022bcdb8507c1d1a$var$ba = $022bcdb8507c1d1a$var$u ? Symbol.for("react.portal") : 60106, $022bcdb8507c1d1a$var$v = $022bcdb8507c1d1a$var$u ? Symbol.for("react.fragment") : 60107, $022bcdb8507c1d1a$var$ca = $022bcdb8507c1d1a$var$u ? Symbol.for("react.strict_mode") : 60108, $022bcdb8507c1d1a$var$da = $022bcdb8507c1d1a$var$u ? Symbol.for("react.profiler") : 60114, $022bcdb8507c1d1a$var$w = $022bcdb8507c1d1a$var$u ? Symbol.for("react.provider") : 60109, $022bcdb8507c1d1a$var$ea = $022bcdb8507c1d1a$var$u ? Symbol.for("react.context") : 60110, $022bcdb8507c1d1a$var$fa = $022bcdb8507c1d1a$var$u ? Symbol.for("react.concurrent_mode") : 60111, $022bcdb8507c1d1a$var$ha = $022bcdb8507c1d1a$var$u ? Symbol.for("react.forward_ref") : 60112, $022bcdb8507c1d1a$var$B = $022bcdb8507c1d1a$var$u ? Symbol.for("react.suspense") : 60113, $022bcdb8507c1d1a$var$ia = $022bcdb8507c1d1a$var$u ? Symbol.for("react.suspense_list") : 60120, $022bcdb8507c1d1a$var$ja = $022bcdb8507c1d1a$var$u ? Symbol.for("react.memo") : 60115, $022bcdb8507c1d1a$var$ka = $022bcdb8507c1d1a$var$u ? Symbol.for("react.lazy") : 60116, $022bcdb8507c1d1a$var$la = $022bcdb8507c1d1a$var$u ? Symbol.for("react.block") : 60121, $022bcdb8507c1d1a$var$ma = $022bcdb8507c1d1a$var$u ? Symbol.for("react.fundamental") : 60117, $022bcdb8507c1d1a$var$na = $022bcdb8507c1d1a$var$u ? Symbol.for("react.scope") : 60119;
function $022bcdb8507c1d1a$var$oa(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(c) {
            0 === a._status && (c = c.default, a._status = 1, a._result = c);
        }, function(c) {
            0 === a._status && (a._status = 2, a._result = c);
        });
    }
}
function $022bcdb8507c1d1a$var$C(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $022bcdb8507c1d1a$var$v:
            return "Fragment";
        case $022bcdb8507c1d1a$var$ba:
            return "Portal";
        case $022bcdb8507c1d1a$var$da:
            return "Profiler";
        case $022bcdb8507c1d1a$var$ca:
            return "StrictMode";
        case $022bcdb8507c1d1a$var$B:
            return "Suspense";
        case $022bcdb8507c1d1a$var$ia:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $022bcdb8507c1d1a$var$ea:
            return "Context.Consumer";
        case $022bcdb8507c1d1a$var$w:
            return "Context.Provider";
        case $022bcdb8507c1d1a$var$ha:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $022bcdb8507c1d1a$var$ja:
            return $022bcdb8507c1d1a$var$C(a.type);
        case $022bcdb8507c1d1a$var$la:
            return $022bcdb8507c1d1a$var$C(a.render);
        case $022bcdb8507c1d1a$var$ka:
            if (a = 1 === a._status ? a._result : null) return $022bcdb8507c1d1a$var$C(a);
    }
    return null;
}
var $022bcdb8507c1d1a$var$D = $022bcdb8507c1d1a$var$m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$022bcdb8507c1d1a$var$D.hasOwnProperty("ReactCurrentDispatcher") || ($022bcdb8507c1d1a$var$D.ReactCurrentDispatcher = {
    current: null
});
$022bcdb8507c1d1a$var$D.hasOwnProperty("ReactCurrentBatchConfig") || ($022bcdb8507c1d1a$var$D.ReactCurrentBatchConfig = {
    suspense: null
});
var $022bcdb8507c1d1a$var$pa = {};
function $022bcdb8507c1d1a$var$E(a, b) {
    for(var c = a._threadCount | 0; c <= b; c++)a[c] = a._currentValue2, a._threadCount = c + 1;
}
function $022bcdb8507c1d1a$var$qa(a, b, c, d) {
    if (d && (d = a.contextType, "object" === typeof d && null !== d)) return $022bcdb8507c1d1a$var$E(d, c), d[c];
    if (a = a.contextTypes) {
        c = {};
        for(var f in a)c[f] = b[f];
        b = c;
    } else b = $022bcdb8507c1d1a$var$pa;
    return b;
}
for(var $022bcdb8507c1d1a$var$F = new Uint16Array(16), $022bcdb8507c1d1a$var$H = 0; 15 > $022bcdb8507c1d1a$var$H; $022bcdb8507c1d1a$var$H++)$022bcdb8507c1d1a$var$F[$022bcdb8507c1d1a$var$H] = $022bcdb8507c1d1a$var$H + 1;
$022bcdb8507c1d1a$var$F[15] = 0;
var $022bcdb8507c1d1a$var$ra = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $022bcdb8507c1d1a$var$sa = Object.prototype.hasOwnProperty, $022bcdb8507c1d1a$var$ta = {}, $022bcdb8507c1d1a$var$ua = {};
function $022bcdb8507c1d1a$var$va(a) {
    if ($022bcdb8507c1d1a$var$sa.call($022bcdb8507c1d1a$var$ua, a)) return !0;
    if ($022bcdb8507c1d1a$var$sa.call($022bcdb8507c1d1a$var$ta, a)) return !1;
    if ($022bcdb8507c1d1a$var$ra.test(a)) return $022bcdb8507c1d1a$var$ua[a] = !0;
    $022bcdb8507c1d1a$var$ta[a] = !0;
    return !1;
}
function $022bcdb8507c1d1a$var$wa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $022bcdb8507c1d1a$var$xa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $022bcdb8507c1d1a$var$wa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $022bcdb8507c1d1a$var$J(a, b, c, d, f, h) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = h;
}
var $022bcdb8507c1d1a$var$K = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $022bcdb8507c1d1a$var$K[a] = new $022bcdb8507c1d1a$var$J(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $022bcdb8507c1d1a$var$K[b] = new $022bcdb8507c1d1a$var$J(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $022bcdb8507c1d1a$var$K[a] = new $022bcdb8507c1d1a$var$J(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $022bcdb8507c1d1a$var$K[a] = new $022bcdb8507c1d1a$var$J(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $022bcdb8507c1d1a$var$K[a] = new $022bcdb8507c1d1a$var$J(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $022bcdb8507c1d1a$var$K[a] = new $022bcdb8507c1d1a$var$J(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $022bcdb8507c1d1a$var$K[a] = new $022bcdb8507c1d1a$var$J(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $022bcdb8507c1d1a$var$K[a] = new $022bcdb8507c1d1a$var$J(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $022bcdb8507c1d1a$var$K[a] = new $022bcdb8507c1d1a$var$J(a, 5, !1, a.toLowerCase(), null, !1);
});
var $022bcdb8507c1d1a$var$L = /[\-:]([a-z])/g;
function $022bcdb8507c1d1a$var$M(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($022bcdb8507c1d1a$var$L, $022bcdb8507c1d1a$var$M);
    $022bcdb8507c1d1a$var$K[b] = new $022bcdb8507c1d1a$var$J(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($022bcdb8507c1d1a$var$L, $022bcdb8507c1d1a$var$M);
    $022bcdb8507c1d1a$var$K[b] = new $022bcdb8507c1d1a$var$J(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($022bcdb8507c1d1a$var$L, $022bcdb8507c1d1a$var$M);
    $022bcdb8507c1d1a$var$K[b] = new $022bcdb8507c1d1a$var$J(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $022bcdb8507c1d1a$var$K[a] = new $022bcdb8507c1d1a$var$J(a, 1, !1, a.toLowerCase(), null, !1);
});
$022bcdb8507c1d1a$var$K.xlinkHref = new $022bcdb8507c1d1a$var$J("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $022bcdb8507c1d1a$var$K[a] = new $022bcdb8507c1d1a$var$J(a, 1, !1, a.toLowerCase(), null, !0);
});
var $022bcdb8507c1d1a$var$ya = /["'&<>]/;
function $022bcdb8507c1d1a$var$N(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $022bcdb8507c1d1a$var$ya.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
function $022bcdb8507c1d1a$var$za(a, b) {
    var c = $022bcdb8507c1d1a$var$K.hasOwnProperty(a) ? $022bcdb8507c1d1a$var$K[a] : null;
    var d;
    if (d = "style" !== a) d = null !== c ? 0 === c.type : !(2 < a.length) || "o" !== a[0] && "O" !== a[0] || "n" !== a[1] && "N" !== a[1] ? !1 : !0;
    if (d || $022bcdb8507c1d1a$var$xa(a, b, c, !1)) return "";
    if (null !== c) {
        a = c.attributeName;
        d = c.type;
        if (3 === d || 4 === d && !0 === b) return a + '=""';
        c.sanitizeURL && (b = "" + b);
        return a + '="' + ($022bcdb8507c1d1a$var$N(b) + '"');
    }
    return $022bcdb8507c1d1a$var$va(a) ? a + '="' + ($022bcdb8507c1d1a$var$N(b) + '"') : "";
}
function $022bcdb8507c1d1a$var$Aa(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $022bcdb8507c1d1a$var$Ba = "function" === typeof Object.is ? Object.is : $022bcdb8507c1d1a$var$Aa, $022bcdb8507c1d1a$var$O = null, $022bcdb8507c1d1a$var$P = null, $022bcdb8507c1d1a$var$Q = null, $022bcdb8507c1d1a$var$R = !1, $022bcdb8507c1d1a$var$S = !1, $022bcdb8507c1d1a$var$U = null, $022bcdb8507c1d1a$var$V = 0;
function $022bcdb8507c1d1a$var$W() {
    if (null === $022bcdb8507c1d1a$var$O) throw Error($022bcdb8507c1d1a$var$r(321));
    return $022bcdb8507c1d1a$var$O;
}
function $022bcdb8507c1d1a$var$Ca() {
    if (0 < $022bcdb8507c1d1a$var$V) throw Error($022bcdb8507c1d1a$var$r(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $022bcdb8507c1d1a$var$Da() {
    null === $022bcdb8507c1d1a$var$Q ? null === $022bcdb8507c1d1a$var$P ? ($022bcdb8507c1d1a$var$R = !1, $022bcdb8507c1d1a$var$P = $022bcdb8507c1d1a$var$Q = $022bcdb8507c1d1a$var$Ca()) : ($022bcdb8507c1d1a$var$R = !0, $022bcdb8507c1d1a$var$Q = $022bcdb8507c1d1a$var$P) : null === $022bcdb8507c1d1a$var$Q.next ? ($022bcdb8507c1d1a$var$R = !1, $022bcdb8507c1d1a$var$Q = $022bcdb8507c1d1a$var$Q.next = $022bcdb8507c1d1a$var$Ca()) : ($022bcdb8507c1d1a$var$R = !0, $022bcdb8507c1d1a$var$Q = $022bcdb8507c1d1a$var$Q.next);
    return $022bcdb8507c1d1a$var$Q;
}
function $022bcdb8507c1d1a$var$Ea(a, b, c, d) {
    for(; $022bcdb8507c1d1a$var$S;)$022bcdb8507c1d1a$var$S = !1, $022bcdb8507c1d1a$var$V += 1, $022bcdb8507c1d1a$var$Q = null, c = a(b, d);
    $022bcdb8507c1d1a$var$P = $022bcdb8507c1d1a$var$O = null;
    $022bcdb8507c1d1a$var$V = 0;
    $022bcdb8507c1d1a$var$Q = $022bcdb8507c1d1a$var$U = null;
    return c;
}
function $022bcdb8507c1d1a$var$Fa(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $022bcdb8507c1d1a$var$Ga(a, b, c) {
    $022bcdb8507c1d1a$var$O = $022bcdb8507c1d1a$var$W();
    $022bcdb8507c1d1a$var$Q = $022bcdb8507c1d1a$var$Da();
    if ($022bcdb8507c1d1a$var$R) {
        var d = $022bcdb8507c1d1a$var$Q.queue;
        b = d.dispatch;
        if (null !== $022bcdb8507c1d1a$var$U && (c = $022bcdb8507c1d1a$var$U.get(d), void 0 !== c)) {
            $022bcdb8507c1d1a$var$U.delete(d);
            d = $022bcdb8507c1d1a$var$Q.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $022bcdb8507c1d1a$var$Q.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $022bcdb8507c1d1a$var$Q.memoizedState,
            b
        ];
    }
    a = a === $022bcdb8507c1d1a$var$Fa ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $022bcdb8507c1d1a$var$Q.memoizedState = a;
    a = $022bcdb8507c1d1a$var$Q.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $022bcdb8507c1d1a$var$Ha.bind(null, $022bcdb8507c1d1a$var$O, a);
    return [
        $022bcdb8507c1d1a$var$Q.memoizedState,
        a
    ];
}
function $022bcdb8507c1d1a$var$Ha(a, b, c) {
    if (!(25 > $022bcdb8507c1d1a$var$V)) throw Error($022bcdb8507c1d1a$var$r(301));
    if (a === $022bcdb8507c1d1a$var$O) {
        if ($022bcdb8507c1d1a$var$S = !0, a = {
            action: c,
            next: null
        }, null === $022bcdb8507c1d1a$var$U && ($022bcdb8507c1d1a$var$U = new Map), c = $022bcdb8507c1d1a$var$U.get(b), void 0 === c) $022bcdb8507c1d1a$var$U.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $022bcdb8507c1d1a$var$Ia() {}
var $022bcdb8507c1d1a$var$X = 0, $022bcdb8507c1d1a$var$Ja = {
    readContext: function(a) {
        var b = $022bcdb8507c1d1a$var$X;
        $022bcdb8507c1d1a$var$E(a, b);
        return a[b];
    },
    useContext: function(a) {
        $022bcdb8507c1d1a$var$W();
        var b = $022bcdb8507c1d1a$var$X;
        $022bcdb8507c1d1a$var$E(a, b);
        return a[b];
    },
    useMemo: function(a, b) {
        $022bcdb8507c1d1a$var$O = $022bcdb8507c1d1a$var$W();
        $022bcdb8507c1d1a$var$Q = $022bcdb8507c1d1a$var$Da();
        b = void 0 === b ? null : b;
        if (null !== $022bcdb8507c1d1a$var$Q) {
            var c = $022bcdb8507c1d1a$var$Q.memoizedState;
            if (null !== c && null !== b) {
                a: {
                    var d = c[1];
                    if (null === d) d = !1;
                    else {
                        for(var f = 0; f < d.length && f < b.length; f++)if (!$022bcdb8507c1d1a$var$Ba(b[f], d[f])) {
                            d = !1;
                            break a;
                        }
                        d = !0;
                    }
                }
                if (d) return c[0];
            }
        }
        a = a();
        $022bcdb8507c1d1a$var$Q.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: $022bcdb8507c1d1a$var$Ga,
    useRef: function(a) {
        $022bcdb8507c1d1a$var$O = $022bcdb8507c1d1a$var$W();
        $022bcdb8507c1d1a$var$Q = $022bcdb8507c1d1a$var$Da();
        var b = $022bcdb8507c1d1a$var$Q.memoizedState;
        return null === b ? (a = {
            current: a
        }, $022bcdb8507c1d1a$var$Q.memoizedState = a) : b;
    },
    useState: function(a) {
        return $022bcdb8507c1d1a$var$Ga($022bcdb8507c1d1a$var$Fa, a);
    },
    useLayoutEffect: function() {},
    useCallback: function(a) {
        return a;
    },
    useImperativeHandle: $022bcdb8507c1d1a$var$Ia,
    useEffect: $022bcdb8507c1d1a$var$Ia,
    useDebugValue: $022bcdb8507c1d1a$var$Ia,
    useResponder: function(a, b) {
        return {
            props: b,
            responder: a
        };
    },
    useDeferredValue: function(a) {
        $022bcdb8507c1d1a$var$W();
        return a;
    },
    useTransition: function() {
        $022bcdb8507c1d1a$var$W();
        return [
            function(a) {
                a();
            },
            !1
        ];
    }
}, $022bcdb8507c1d1a$var$Ka = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $022bcdb8507c1d1a$var$La(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
var $022bcdb8507c1d1a$var$Ma = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
}, $022bcdb8507c1d1a$var$Na = $022bcdb8507c1d1a$var$k({
    menuitem: !0
}, $022bcdb8507c1d1a$var$Ma), $022bcdb8507c1d1a$var$Y = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $022bcdb8507c1d1a$var$Oa = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($022bcdb8507c1d1a$var$Y).forEach(function(a) {
    $022bcdb8507c1d1a$var$Oa.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $022bcdb8507c1d1a$var$Y[b] = $022bcdb8507c1d1a$var$Y[a];
    });
});
var $022bcdb8507c1d1a$var$Pa = /([A-Z])/g, $022bcdb8507c1d1a$var$Qa = /^ms-/, $022bcdb8507c1d1a$var$Z = $022bcdb8507c1d1a$var$m.Children.toArray, $022bcdb8507c1d1a$var$Ra = $022bcdb8507c1d1a$var$D.ReactCurrentDispatcher, $022bcdb8507c1d1a$var$Sa = {
    listing: !0,
    pre: !0,
    textarea: !0
}, $022bcdb8507c1d1a$var$Ta = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $022bcdb8507c1d1a$var$Ua = {}, $022bcdb8507c1d1a$var$Va = {};
function $022bcdb8507c1d1a$var$Wa(a) {
    if (void 0 === a || null === a) return a;
    var b = "";
    $022bcdb8507c1d1a$var$m.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $022bcdb8507c1d1a$var$Xa = Object.prototype.hasOwnProperty, $022bcdb8507c1d1a$var$Ya = {
    children: null,
    dangerouslySetInnerHTML: null,
    suppressContentEditableWarning: null,
    suppressHydrationWarning: null
};
function $022bcdb8507c1d1a$var$Za(a, b) {
    if (void 0 === a) throw Error($022bcdb8507c1d1a$var$r(152, $022bcdb8507c1d1a$var$C(b) || "Component"));
}
function $022bcdb8507c1d1a$var$$a(a, b, c) {
    function d(d, h) {
        var e = h.prototype && h.prototype.isReactComponent, f = $022bcdb8507c1d1a$var$qa(h, b, c, e), p = [], g = !1, l = {
            isMounted: function() {
                return !1;
            },
            enqueueForceUpdate: function() {
                if (null === p) return null;
            },
            enqueueReplaceState: function(a, c) {
                g = !0;
                p = [
                    c
                ];
            },
            enqueueSetState: function(a, c) {
                if (null === p) return null;
                p.push(c);
            }
        };
        if (e) {
            if (e = new h(d.props, f, l), "function" === typeof h.getDerivedStateFromProps) {
                var x = h.getDerivedStateFromProps.call(null, d.props, e.state);
                null != x && (e.state = $022bcdb8507c1d1a$var$k({}, e.state, x));
            }
        } else if ($022bcdb8507c1d1a$var$O = {}, e = h(d.props, f, l), e = $022bcdb8507c1d1a$var$Ea(h, d.props, e, f), null == e || null == e.render) {
            a = e;
            $022bcdb8507c1d1a$var$Za(a, h);
            return;
        }
        e.props = d.props;
        e.context = f;
        e.updater = l;
        l = e.state;
        void 0 === l && (e.state = l = null);
        if ("function" === typeof e.UNSAFE_componentWillMount || "function" === typeof e.componentWillMount) {
            if ("function" === typeof e.componentWillMount && "function" !== typeof h.getDerivedStateFromProps && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && "function" !== typeof h.getDerivedStateFromProps && e.UNSAFE_componentWillMount(), p.length) {
                l = p;
                var t = g;
                p = null;
                g = !1;
                if (t && 1 === l.length) e.state = l[0];
                else {
                    x = t ? l[0] : e.state;
                    var y = !0;
                    for(t = t ? 1 : 0; t < l.length; t++){
                        var q = l[t];
                        q = "function" === typeof q ? q.call(e, x, d.props, f) : q;
                        null != q && (y ? (y = !1, x = $022bcdb8507c1d1a$var$k({}, x, q)) : $022bcdb8507c1d1a$var$k(x, q));
                    }
                    e.state = x;
                }
            } else p = null;
        }
        a = e.render();
        $022bcdb8507c1d1a$var$Za(a, h);
        if ("function" === typeof e.getChildContext && (d = h.childContextTypes, "object" === typeof d)) {
            var A = e.getChildContext();
            for(var T in A)if (!(T in d)) throw Error($022bcdb8507c1d1a$var$r(108, $022bcdb8507c1d1a$var$C(h) || "Unknown", T));
        }
        A && (b = $022bcdb8507c1d1a$var$k({}, b, A));
    }
    for(; $022bcdb8507c1d1a$var$m.isValidElement(a);){
        var f = a, h = f.type;
        if ("function" !== typeof h) break;
        d(f, h);
    }
    return {
        child: a,
        context: b
    };
}
var $022bcdb8507c1d1a$var$ab = function() {
    function a(a, b) {
        $022bcdb8507c1d1a$var$m.isValidElement(a) ? a.type !== $022bcdb8507c1d1a$var$v ? a = [
            a
        ] : (a = a.props.children, a = $022bcdb8507c1d1a$var$m.isValidElement(a) ? [
            a
        ] : $022bcdb8507c1d1a$var$Z(a)) : a = $022bcdb8507c1d1a$var$Z(a);
        a = {
            type: null,
            domNamespace: $022bcdb8507c1d1a$var$Ka.html,
            children: a,
            childIndex: 0,
            context: $022bcdb8507c1d1a$var$pa,
            footer: ""
        };
        var c = $022bcdb8507c1d1a$var$F[0];
        if (0 === c) {
            var d = $022bcdb8507c1d1a$var$F;
            c = d.length;
            var p = 2 * c;
            if (!(65536 >= p)) throw Error($022bcdb8507c1d1a$var$r(304));
            var g = new Uint16Array(p);
            g.set(d);
            $022bcdb8507c1d1a$var$F = g;
            $022bcdb8507c1d1a$var$F[0] = c + 1;
            for(d = c; d < p - 1; d++)$022bcdb8507c1d1a$var$F[d] = d + 1;
            $022bcdb8507c1d1a$var$F[p - 1] = 0;
        } else $022bcdb8507c1d1a$var$F[0] = $022bcdb8507c1d1a$var$F[c];
        this.threadID = c;
        this.stack = [
            a
        ];
        this.exhausted = !1;
        this.currentSelectValue = null;
        this.previousWasTextNode = !1;
        this.makeStaticMarkup = b;
        this.suspenseDepth = 0;
        this.contextIndex = -1;
        this.contextStack = [];
        this.contextValueStack = [];
    }
    var b = a.prototype;
    b.destroy = function() {
        if (!this.exhausted) {
            this.exhausted = !0;
            this.clearProviders();
            var a = this.threadID;
            $022bcdb8507c1d1a$var$F[a] = $022bcdb8507c1d1a$var$F[0];
            $022bcdb8507c1d1a$var$F[0] = a;
        }
    };
    b.pushProvider = function(a) {
        var b = ++this.contextIndex, c = a.type._context, h = this.threadID;
        $022bcdb8507c1d1a$var$E(c, h);
        var p = c[h];
        this.contextStack[b] = c;
        this.contextValueStack[b] = p;
        c[h] = a.props.value;
    };
    b.popProvider = function() {
        var a = this.contextIndex, b = this.contextStack[a], f = this.contextValueStack[a];
        this.contextStack[a] = null;
        this.contextValueStack[a] = null;
        this.contextIndex--;
        b[this.threadID] = f;
    };
    b.clearProviders = function() {
        for(var a = this.contextIndex; 0 <= a; a--)this.contextStack[a][this.threadID] = this.contextValueStack[a];
    };
    b.read = function(a) {
        if (this.exhausted) return null;
        var b = $022bcdb8507c1d1a$var$X;
        $022bcdb8507c1d1a$var$X = this.threadID;
        var c = $022bcdb8507c1d1a$var$Ra.current;
        $022bcdb8507c1d1a$var$Ra.current = $022bcdb8507c1d1a$var$Ja;
        try {
            for(var h = [
                ""
            ], p = !1; h[0].length < a;){
                if (0 === this.stack.length) {
                    this.exhausted = !0;
                    var g = this.threadID;
                    $022bcdb8507c1d1a$var$F[g] = $022bcdb8507c1d1a$var$F[0];
                    $022bcdb8507c1d1a$var$F[0] = g;
                    break;
                }
                var e = this.stack[this.stack.length - 1];
                if (p || e.childIndex >= e.children.length) {
                    var I = e.footer;
                    "" !== I && (this.previousWasTextNode = !1);
                    this.stack.pop();
                    if ("select" === e.type) this.currentSelectValue = null;
                    else if (null != e.type && null != e.type.type && e.type.type.$$typeof === $022bcdb8507c1d1a$var$w) this.popProvider(e.type);
                    else if (e.type === $022bcdb8507c1d1a$var$B) {
                        this.suspenseDepth--;
                        var G = h.pop();
                        if (p) {
                            p = !1;
                            var n = e.fallbackFrame;
                            if (!n) throw Error($022bcdb8507c1d1a$var$r(303));
                            this.stack.push(n);
                            h[this.suspenseDepth] += "<!--$!-->";
                            continue;
                        } else h[this.suspenseDepth] += G;
                    }
                    h[this.suspenseDepth] += I;
                } else {
                    var l = e.children[e.childIndex++], x = "";
                    try {
                        x += this.render(l, e.context, e.domNamespace);
                    } catch (t) {
                        if (null != t && "function" === typeof t.then) throw Error($022bcdb8507c1d1a$var$r(294));
                        throw t;
                    } finally{}
                    h.length <= this.suspenseDepth && h.push("");
                    h[this.suspenseDepth] += x;
                }
            }
            return h[0];
        } finally{
            $022bcdb8507c1d1a$var$Ra.current = c, $022bcdb8507c1d1a$var$X = b;
        }
    };
    b.render = function(a, b, f) {
        if ("string" === typeof a || "number" === typeof a) {
            f = "" + a;
            if ("" === f) return "";
            if (this.makeStaticMarkup) return $022bcdb8507c1d1a$var$N(f);
            if (this.previousWasTextNode) return "<!-- -->" + $022bcdb8507c1d1a$var$N(f);
            this.previousWasTextNode = !0;
            return $022bcdb8507c1d1a$var$N(f);
        }
        b = $022bcdb8507c1d1a$var$$a(a, b, this.threadID);
        a = b.child;
        b = b.context;
        if (null === a || !1 === a) return "";
        if (!$022bcdb8507c1d1a$var$m.isValidElement(a)) {
            if (null != a && null != a.$$typeof) {
                f = a.$$typeof;
                if (f === $022bcdb8507c1d1a$var$ba) throw Error($022bcdb8507c1d1a$var$r(257));
                throw Error($022bcdb8507c1d1a$var$r(258, f.toString()));
            }
            a = $022bcdb8507c1d1a$var$Z(a);
            this.stack.push({
                type: null,
                domNamespace: f,
                children: a,
                childIndex: 0,
                context: b,
                footer: ""
            });
            return "";
        }
        var c = a.type;
        if ("string" === typeof c) return this.renderDOM(a, b, f);
        switch(c){
            case $022bcdb8507c1d1a$var$ca:
            case $022bcdb8507c1d1a$var$fa:
            case $022bcdb8507c1d1a$var$da:
            case $022bcdb8507c1d1a$var$ia:
            case $022bcdb8507c1d1a$var$v:
                return a = $022bcdb8507c1d1a$var$Z(a.props.children), this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
            case $022bcdb8507c1d1a$var$B:
                throw Error($022bcdb8507c1d1a$var$r(294));
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $022bcdb8507c1d1a$var$ha:
                $022bcdb8507c1d1a$var$O = {};
                var d = c.render(a.props, a.ref);
                d = $022bcdb8507c1d1a$var$Ea(c.render, a.props, d, a.ref);
                d = $022bcdb8507c1d1a$var$Z(d);
                this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: d,
                    childIndex: 0,
                    context: b,
                    footer: ""
                });
                return "";
            case $022bcdb8507c1d1a$var$ja:
                return a = [
                    $022bcdb8507c1d1a$var$m.createElement(c.type, $022bcdb8507c1d1a$var$k({
                        ref: a.ref
                    }, a.props))
                ], this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
            case $022bcdb8507c1d1a$var$w:
                return c = $022bcdb8507c1d1a$var$Z(a.props.children), f = {
                    type: a,
                    domNamespace: f,
                    children: c,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }, this.pushProvider(a), this.stack.push(f), "";
            case $022bcdb8507c1d1a$var$ea:
                c = a.type;
                d = a.props;
                var g = this.threadID;
                $022bcdb8507c1d1a$var$E(c, g);
                c = $022bcdb8507c1d1a$var$Z(d.children(c[g]));
                this.stack.push({
                    type: a,
                    domNamespace: f,
                    children: c,
                    childIndex: 0,
                    context: b,
                    footer: ""
                });
                return "";
            case $022bcdb8507c1d1a$var$ma:
                throw Error($022bcdb8507c1d1a$var$r(338));
            case $022bcdb8507c1d1a$var$ka:
                switch(c = a.type, $022bcdb8507c1d1a$var$oa(c), c._status){
                    case 1:
                        return a = [
                            $022bcdb8507c1d1a$var$m.createElement(c._result, $022bcdb8507c1d1a$var$k({
                                ref: a.ref
                            }, a.props))
                        ], this.stack.push({
                            type: null,
                            domNamespace: f,
                            children: a,
                            childIndex: 0,
                            context: b,
                            footer: ""
                        }), "";
                    case 2:
                        throw c._result;
                    default:
                        throw Error($022bcdb8507c1d1a$var$r(295));
                }
            case $022bcdb8507c1d1a$var$na:
                throw Error($022bcdb8507c1d1a$var$r(343));
        }
        throw Error($022bcdb8507c1d1a$var$r(130, null == c ? c : typeof c, ""));
    };
    b.renderDOM = function(a, b, f) {
        var c = a.type.toLowerCase();
        if (!$022bcdb8507c1d1a$var$Ua.hasOwnProperty(c)) {
            if (!$022bcdb8507c1d1a$var$Ta.test(c)) throw Error($022bcdb8507c1d1a$var$r(65, c));
            $022bcdb8507c1d1a$var$Ua[c] = !0;
        }
        var d = a.props;
        if ("input" === c) d = $022bcdb8507c1d1a$var$k({
            type: void 0
        }, d, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: null != d.value ? d.value : d.defaultValue,
            checked: null != d.checked ? d.checked : d.defaultChecked
        });
        else if ("textarea" === c) {
            var g = d.value;
            if (null == g) {
                g = d.defaultValue;
                var e = d.children;
                if (null != e) {
                    if (null != g) throw Error($022bcdb8507c1d1a$var$r(92));
                    if (Array.isArray(e)) {
                        if (!(1 >= e.length)) throw Error($022bcdb8507c1d1a$var$r(93));
                        e = e[0];
                    }
                    g = "" + e;
                }
                null == g && (g = "");
            }
            d = $022bcdb8507c1d1a$var$k({}, d, {
                value: void 0,
                children: "" + g
            });
        } else if ("select" === c) this.currentSelectValue = null != d.value ? d.value : d.defaultValue, d = $022bcdb8507c1d1a$var$k({}, d, {
            value: void 0
        });
        else if ("option" === c) {
            e = this.currentSelectValue;
            var I = $022bcdb8507c1d1a$var$Wa(d.children);
            if (null != e) {
                var G = null != d.value ? d.value + "" : I;
                g = !1;
                if (Array.isArray(e)) {
                    for(var n = 0; n < e.length; n++)if ("" + e[n] === G) {
                        g = !0;
                        break;
                    }
                } else g = "" + e === G;
                d = $022bcdb8507c1d1a$var$k({
                    selected: void 0,
                    children: void 0
                }, d, {
                    selected: g,
                    children: I
                });
            }
        }
        if (g = d) {
            if ($022bcdb8507c1d1a$var$Na[c] && (null != g.children || null != g.dangerouslySetInnerHTML)) throw Error($022bcdb8507c1d1a$var$r(137, c, ""));
            if (null != g.dangerouslySetInnerHTML) {
                if (null != g.children) throw Error($022bcdb8507c1d1a$var$r(60));
                if (!("object" === typeof g.dangerouslySetInnerHTML && "__html" in g.dangerouslySetInnerHTML)) throw Error($022bcdb8507c1d1a$var$r(61));
            }
            if (null != g.style && "object" !== typeof g.style) throw Error($022bcdb8507c1d1a$var$r(62, ""));
        }
        g = d;
        e = this.makeStaticMarkup;
        I = 1 === this.stack.length;
        G = "<" + a.type;
        for(z in g)if ($022bcdb8507c1d1a$var$Xa.call(g, z)) {
            var l = g[z];
            if (null != l) {
                if ("style" === z) {
                    n = void 0;
                    var x = "", t = "";
                    for(n in l)if (l.hasOwnProperty(n)) {
                        var y = 0 === n.indexOf("--"), q = l[n];
                        if (null != q) {
                            if (y) var A = n;
                            else if (A = n, $022bcdb8507c1d1a$var$Va.hasOwnProperty(A)) A = $022bcdb8507c1d1a$var$Va[A];
                            else {
                                var T = A.replace($022bcdb8507c1d1a$var$Pa, "-$1").toLowerCase().replace($022bcdb8507c1d1a$var$Qa, "-ms-");
                                A = $022bcdb8507c1d1a$var$Va[A] = T;
                            }
                            x += t + A + ":";
                            t = n;
                            y = null == q || "boolean" === typeof q || "" === q ? "" : y || "number" !== typeof q || 0 === q || $022bcdb8507c1d1a$var$Y.hasOwnProperty(t) && $022bcdb8507c1d1a$var$Y[t] ? ("" + q).trim() : q + "px";
                            x += y;
                            t = ";";
                        }
                    }
                    l = x || null;
                }
                n = null;
                b: if (y = c, q = g, -1 === y.indexOf("-")) y = "string" === typeof q.is;
                else switch(y){
                    case "annotation-xml":
                    case "color-profile":
                    case "font-face":
                    case "font-face-src":
                    case "font-face-uri":
                    case "font-face-format":
                    case "font-face-name":
                    case "missing-glyph":
                        y = !1;
                        break b;
                    default:
                        y = !0;
                }
                y ? $022bcdb8507c1d1a$var$Ya.hasOwnProperty(z) || (n = z, n = $022bcdb8507c1d1a$var$va(n) && null != l ? n + '="' + ($022bcdb8507c1d1a$var$N(l) + '"') : "") : n = $022bcdb8507c1d1a$var$za(z, l);
                n && (G += " " + n);
            }
        }
        e || I && (G += ' data-reactroot=""');
        var z = G;
        g = "";
        $022bcdb8507c1d1a$var$Ma.hasOwnProperty(c) ? z += "/>" : (z += ">", g = "</" + a.type + ">");
        a: {
            e = d.dangerouslySetInnerHTML;
            if (null != e) {
                if (null != e.__html) {
                    e = e.__html;
                    break a;
                }
            } else if (e = d.children, "string" === typeof e || "number" === typeof e) {
                e = $022bcdb8507c1d1a$var$N(e);
                break a;
            }
            e = null;
        }
        null != e ? (d = [], $022bcdb8507c1d1a$var$Sa.hasOwnProperty(c) && "\n" === e.charAt(0) && (z += "\n"), z += e) : d = $022bcdb8507c1d1a$var$Z(d.children);
        a = a.type;
        f = null == f || "http://www.w3.org/1999/xhtml" === f ? $022bcdb8507c1d1a$var$La(a) : "http://www.w3.org/2000/svg" === f && "foreignObject" === a ? "http://www.w3.org/1999/xhtml" : f;
        this.stack.push({
            domNamespace: f,
            type: c,
            children: d,
            childIndex: 0,
            context: b,
            footer: g
        });
        this.previousWasTextNode = !1;
        return z;
    };
    return a;
}();
function $022bcdb8507c1d1a$var$bb(a, b) {
    a.prototype = Object.create(b.prototype);
    a.prototype.constructor = a;
    a.__proto__ = b;
}
var $022bcdb8507c1d1a$var$cb = function(a) {
    function b(b, c) {
        var d = a.call(this, {}) || this;
        d.partialRenderer = new $022bcdb8507c1d1a$var$ab(b, c);
        return d;
    }
    $022bcdb8507c1d1a$var$bb(b, a);
    var c = b.prototype;
    c._destroy = function(a, b) {
        this.partialRenderer.destroy();
        b(a);
    };
    c._read = function(a) {
        try {
            this.push(this.partialRenderer.read(a));
        } catch (f) {
            this.destroy(f);
        }
    };
    return b;
}($022bcdb8507c1d1a$var$aa.Readable), $022bcdb8507c1d1a$var$db = {
    renderToString: function(a) {
        a = new $022bcdb8507c1d1a$var$ab(a, !1);
        try {
            return a.read(Infinity);
        } finally{
            a.destroy();
        }
    },
    renderToStaticMarkup: function(a) {
        a = new $022bcdb8507c1d1a$var$ab(a, !0);
        try {
            return a.read(Infinity);
        } finally{
            a.destroy();
        }
    },
    renderToNodeStream: function(a) {
        return new $022bcdb8507c1d1a$var$cb(a, !1);
    },
    renderToStaticNodeStream: function(a) {
        return new $022bcdb8507c1d1a$var$cb(a, !0);
    },
    version: "16.14.0"
};
var $022bcdb8507c1d1a$var$reactDomServer_node_production_min = $022bcdb8507c1d1a$var$db.default || $022bcdb8507c1d1a$var$db;
$022bcdb8507c1d1a$var$server_node.exports = $022bcdb8507c1d1a$var$reactDomServer_node_production_min;
var $022bcdb8507c1d1a$var$server = $022bcdb8507c1d1a$var$server_node.exports;
var $022bcdb8507c1d1a$var$_excluded = [
    "color",
    "size",
    "meaningful"
];
var $022bcdb8507c1d1a$var$sizeMatrix = {
    small: 12,
    medium: 16,
    large: 24,
    xlarge: 32,
    xxlarge: 48
};
/**
 * Creates a collecticons component by passing default props to attach the
 * SVG.
 *
 * @param {function} creatorFn Function to create the collecticon. An SVG
 * should be returned.
 */ function $022bcdb8507c1d1a$export$7209ba2b0568490(creatorFn) {
    var StyledCollecticon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).forwardRef(function(props, ref) {
        var color = props.color, size = props.size, meaningful = props.meaningful, rest = $022bcdb8507c1d1a$var$_objectWithoutProperties(props, $022bcdb8507c1d1a$var$_excluded);
        var s = (typeof size === "string" ? $022bcdb8507c1d1a$var$sizeMatrix[size] : size) || 16;
        var iconProps = $022bcdb8507c1d1a$var$_objectSpread2({
            width: s,
            height: s,
            fill: color || "currentColor",
            xmlns: "http://www.w3.org/2000/svg",
            role: "img",
            viewBox: "0 0 16 16",
            // By default icons are rendered decoratively (aria hidden true) Using
            // "meaningful" prop (together with a descriptive title) will enable the
            // icon to be understood by assistive technologies.
            "aria-hidden": !meaningful,
            ref: ref
        }, rest);
        return creatorFn(iconProps);
    });
    StyledCollecticon.displayName = "StyledCollecticon";
    StyledCollecticon.propTypes = {
        color: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
        size: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).oneOf([
                "small",
                "medium",
                "large",
                "xlarge",
                "xxlarge"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).number
        ]),
        meaningful: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).bool
    };
    return StyledCollecticon;
}
/**
 * Creates a data URI of the given icon for use as image src.
 *
 * @param Cmp Component of the icon to render
 * @param props Props for the component
 */ var $022bcdb8507c1d1a$export$60da06e7afb307b7 = function iconDataURI(Cmp) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var str = $022bcdb8507c1d1a$var$server.renderToStaticMarkup(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement(Cmp, props));
    return "data:image/svg+xml,".concat(encodeURIComponent(str));
};
var $022bcdb8507c1d1a$export$fb146e0ebe1880c9 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "area icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M4,12L4,13L12,13L12,12L13,12L13,4L12,4L12,3L4,3L4,4L3,4L3,12L4,12ZM7,7L9,7L9,9L7,9L7,7ZM16,12L16,16L12,16L12,15L4,15L4,16L0,16L0,12L1,12L1,4L0,4L0,0L4,0L4,1L12,1L12,0L16,0L16,4L15,4L15,12L16,12Z"
    }));
})).withConfig({
    displayName: "area__CollecticonArea",
    componentId: "sc-1hc4aeg-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$4d7881fd068b9554 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow down left icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M12,12L5.414,12L15.021,2.393L13.607,0.979L4,10.586L4,4L2,4L2,14L12,14L12,12Z"
    }));
})).withConfig({
    displayName: "arrow-down-left__CollecticonArrowDownLeft",
    componentId: "sc-1f22cfq-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$ff31736f1164b93d = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow down right icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M12,4L12,10.586L2.393,0.979L0.979,2.393L10.586,12L4,12L4,14L14,14L14,4L12,4Z"
    }));
})).withConfig({
    displayName: "arrow-down-right__CollecticonArrowDownRight",
    componentId: "sc-14aji5o-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$bab927fca1b80a3 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow down icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "13.586,7.586 9,12.172 9,0 7,0 7,12.172 2.414,7.586 1,9 8,16 15,9"
    }));
})).withConfig({
    displayName: "arrow-down__CollecticonArrowDown",
    componentId: "sc-1ou87kv-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$7c84e7446b64c8ba = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow left icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "8.414,13.586 3.828,9 16,9 16,7 3.828,7 8.414,2.414 7,1 0,8 7,15"
    }));
})).withConfig({
    displayName: "arrow-left__CollecticonArrowLeft",
    componentId: "sc-n1mnft-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$669f6b165f77f8e7 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow loop icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M6,4H3.528c0.075-0.081,0.15-0.162,0.228-0.244C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756 C13.375,4.891,14,6.397,14,8h2c0-4.419-3.581-8-8-8C5.609,0,3.466,1.047,2,2.709V0H0v6h6V4z M10,12h2.472 c-0.075,0.081-0.15,0.163-0.228,0.244C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8H0 c0,4.419,3.581,8,8,8c2.391,0,4.534-1.047,6-2.709V16h2v-6h-6V12z"
    }));
})).withConfig({
    displayName: "arrow-loop__CollecticonArrowLoop",
    componentId: "sc-1nzbdx-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$d4555cec95ec110c = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow move icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M7.5,1.924L5.773,3.651L5.061,2.939L8,0L10.939,2.939L10.227,3.651L8.5,1.924L8.5,7.5L14.076,7.5L12.349,5.773L13.061,5.061L16,8L13.061,10.939L12.349,10.227L14.076,8.5L8.5,8.5L8.5,14.076L10.227,12.349L10.939,13.061L8,16L5.061,13.061L5.773,12.349L7.5,14.076L7.5,8.5L1.924,8.5L3.651,10.227L2.939,10.939L0,8L2.939,5.061L3.651,5.773L1.924,7.5L7.5,7.5L7.5,1.924Z"
    }));
})).withConfig({
    displayName: "arrow-move__CollecticonArrowMove",
    componentId: "sc-1nwao1f-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$4337670c5d4a46ab = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow reply icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M16,11c-0,-2.209 -1.791,-4 -4,-4c-3.548,0 -8.172,0 -8.172,0l2.586,-2.586l-1.414,-1.414l-5,5l5,5l1.414,-1.414l-2.586,-2.586l8.172,0c0.53,-0 1.039,0.211 1.414,0.586c0.375,0.375 0.586,0.884 0.586,1.414c0,1.392 0,3 0,3l2,0l0,-3Z"
    }));
})).withConfig({
    displayName: "arrow-reply__CollecticonArrowReply",
    componentId: "sc-6s0wwi-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$404215554288eeeb = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow return icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14.238,5.762C13.102,4.626,11.597,4,10,4H3.828l2.586-2.586L5,0L0,5l5,5l1.414-1.414L3.828,6H10 c1.063,0,2.066,0.418,2.824,1.176C13.582,7.934,14,8.937,14,10s-0.418,2.066-1.176,2.824C12.066,13.582,11.063,14,10,14H6v2h4 c1.597,0,3.102-0.626,4.238-1.762S16,11.597,16,10S15.374,6.898,14.238,5.762z"
    }));
})).withConfig({
    displayName: "arrow-return__CollecticonArrowReturn",
    componentId: "sc-1aahqvf-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$45ced6d791f6eabf = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow revert icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,0l2,0l0,2.709c1.466,-1.662 3.609,-2.709 6,-2.709c4.419,0 8,3.581 8,8c0,4.419 -3.581,8 -8,8c-4.419,0 -8,-3.581 -8,-8l2,0c0,1.603 0.624,3.11 1.756,4.244c1.132,1.134 2.641,1.756 4.244,1.756c1.603,0 3.109,-0.625 4.244,-1.756c1.131,-1.135 1.756,-2.641 1.756,-4.244c0,-1.603 -0.625,-3.109 -1.756,-4.244c-1.135,-1.131 -2.641,-1.756 -4.244,-1.756c-1.603,0 -3.109,0.625 -4.244,1.756c-0.078,0.078 -0.156,0.16 -0.228,0.244l2.472,0l0,2l-6,0l0,-6Zm10.784,4.916l1.485,1.337l-5.169,5.747l-3.244,-3.206l1.406,-1.422l1.754,1.731l3.768,-4.187Z"
    }));
})).withConfig({
    displayName: "arrow-revert__CollecticonArrowRevert",
    componentId: "sc-19w5v2z-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$d30f3c1f95f9e187 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow right icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "7.586,2.414 12.172,7 0,7 0,9 12.172,9 7.586,13.586 9,15 16,8 9,1"
    }));
})).withConfig({
    displayName: "arrow-right__CollecticonArrowRight",
    componentId: "sc-1jnuo03-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$d33a98b6c97f9bcf = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow semi spin ccw icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,0l0,6h6V4H3.528C3.6,3.916,3.678,3.834,3.756,3.756C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756 C13.375,4.891,14,6.397,14,8s-0.625,3.109-1.756,4.244C11.109,13.375,9.603,14,8,14v2c4.419,0,8-3.581,8-8s-3.581-8-8-8 C5.609,0,3.466,1.047,2,2.709V0L0,0z"
    }));
})).withConfig({
    displayName: "arrow-semi-spin-ccw__CollecticonArrowSemiSpinCcw",
    componentId: "sc-14rjf09-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$65b63483548348e7 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow semi spin cw icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14,0v2.709C12.534,1.047,10.391,0,8,0C3.581,0,0,3.581,0,8s3.581,8,8,8v-2c-1.603,0-3.109-0.625-4.244-1.756 C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756 C12.322,3.834,12.4,3.916,12.472,4H10v2h6V0H14z"
    }));
})).withConfig({
    displayName: "arrow-semi-spin-cw__CollecticonArrowSemiSpinCw",
    componentId: "sc-1or7835-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$1e31cff672fc44e7 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow spin ccw icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,0l0,6h6V4H3.528C3.6,3.916,3.678,3.834,3.756,3.756C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756 C13.375,4.891,14,6.397,14,8s-0.625,3.109-1.756,4.244C11.109,13.375,9.603,14,8,14s-3.112-0.622-4.244-1.756S2,9.603,2,8H0 c0,4.419,3.581,8,8,8s8-3.581,8-8s-3.581-8-8-8C5.609,0,3.466,1.047,2,2.709V0L0,0z"
    }));
})).withConfig({
    displayName: "arrow-spin-ccw__CollecticonArrowSpinCcw",
    componentId: "sc-15g2usu-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$8b2c6a502c5588cb = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow spin cw icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14,0v2.709C12.534,1.047,10.391,0,8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8h-2c0,1.603-0.625,3.109-1.756,4.244 S9.603,14,8,14s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2 s3.109,0.625,4.244,1.756C12.322,3.834,12.4,3.916,12.472,4H10v2h6V0H14z"
    }));
})).withConfig({
    displayName: "arrow-spin-cw__CollecticonArrowSpinCw",
    componentId: "sc-got6vy-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$e18c7fe3ad046317 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow up left icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M4,12L4,5.414L13.607,15.021L15.021,13.607L5.414,4L12,4L12,2L2,2L2,12L4,12Z"
    }));
})).withConfig({
    displayName: "arrow-up-left__CollecticonArrowUpLeft",
    componentId: "sc-11tv0ac-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$c59521707fa9adf4 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow up right icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M4,4L10.586,4L0.979,13.607L2.393,15.021L12,5.414L12,12L14,12L14,2L4,2L4,4Z"
    }));
})).withConfig({
    displayName: "arrow-up-right__CollecticonArrowUpRight",
    componentId: "sc-1c0kio-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$44382674197c7e20 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "arrow up icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "2.414,8.414 7,3.828 7,16 9,16 9,3.828 13.586,8.414 15,7 8,0 1,7"
    }));
})).withConfig({
    displayName: "arrow-up__CollecticonArrowUp",
    componentId: "sc-ojud5m-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$6d44efda105760b1 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "bell icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M13,9V6.5c0-2.306-1.759-4.222-4-4.472V1.5c0-0.553-0.447-1-1-1s-1,0.447-1,1v0.528C4.759,2.278,3,4.194,3,6.5V9 c0,1.103-0.897,2-2,2v2h14v-2C13.897,11,13,10.103,13,9z M8,15.5c0.931,0,1.716-0.638,1.938-1.5H6.062 C6.284,14.862,7.069,15.5,8,15.5z"
    }));
})).withConfig({
    displayName: "bell__CollecticonBell",
    componentId: "sc-45f13-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$67ac5bddd7c814c4 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "blow icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,3c0-1.656-1.344-3-3-3S2,1.344,2,3h2c0-0.55,0.45-1,1-1s1,0.45,1,1S5.55,4,5,4H0v2h5C6.656,6,8,4.656,8,3z M12,1 C9.791,1,8,2.791,8,5v1h2V5c0-1.103,0.897-2,2-2s2,0.897,2,2s-0.897,2-2,2H1v2h11.5V8.969C14.472,8.722,16,7.041,16,5 C16,2.791,14.209,1,12,1z M9,10H2v2h7c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1H6c0,1.656,1.344,3,3,3s3-1.344,3-3S10.656,10,9,10z"
    }));
})).withConfig({
    displayName: "blow__CollecticonBlow",
    componentId: "sc-1jrq390-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$bd738f28ecacfb4c = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "bold icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "bold",
        d: "M9,1l-6,0l-0,14l6,0c2.208,0 4,-1.792 4,-4c0,-1.194 -0.524,-2.267 -1.355,-3c0.831,-0.733 1.355,-1.806 1.355,-3c-0,-2.208 -1.792,-4 -4,-4Zm-1,8c1.104,-0 2,0.896 2,2c0,1.104 -0.896,2 -2,2c-0,0 -2,0 -2,0l-0,-4l2,-0Zm0,-6c1.104,-0 2,0.896 2,2c0,1.104 -0.896,2 -2,2c-0,0 -2,0 -2,0l-0,-4l2,-0Z"
    }));
})).withConfig({
    displayName: "bold__CollecticonBold",
    componentId: "sc-19g96dt-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$32797ac8ba9dbc26 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "book bookmark icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M5,12h9V0H9v6L7,4L5,6V0H4C2.9,0,2,0.9,2,2v12c0,1.1,0.9,2,2,2h10v-2H5c-0.6,0-1-0.4-1-1S4.4,12,5,12z"
    }));
})).withConfig({
    displayName: "book-bookmark__CollecticonBookBookmark",
    componentId: "sc-1xmlnah-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$f27e10809e8ad7c = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "book icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M5,12h9V0H4C2.9,0,2,0.9,2,2v12c0,1.1,0.9,2,2,2h10v-2H5c-0.6,0-1-0.4-1-1S4.4,12,5,12z M5,2h7v2H5V2z"
    }));
})).withConfig({
    displayName: "book__CollecticonBook",
    componentId: "sc-12x3af2-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$a7cf23fc039bccca = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand collecticons icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M12.042,0h-8v2h8V0z M10.87,11.828C10.114,12.584,9.111,13,8.042,13s-2.072-0.416-2.828-1.172S4.042,10.069,4.042,9 s0.416-2.072,1.172-2.828S6.973,5,8.042,5s2.072,0.416,2.828,1.172C11.383,6.684,11.739,7.316,11.917,8h2.041 c-0.475-2.838-2.944-5-5.916-5c-3.312,0-6,2.688-6,6s2.688,6,6,6c2.972,0,5.441-2.163,5.916-5h-2.041 C11.742,10.684,11.383,11.316,10.87,11.828z"
    }));
})).withConfig({
    displayName: "brand-collecticons__CollecticonBrandCollecticons",
    componentId: "sc-egpnjr-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$3fd46276f478a1b0 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand development seed 2 icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M9.053,13.581c-0.003-0.322,0.084-0.6,0.219-0.891c-0.288,0.253-0.403,0.541-0.506,0.931c0.028-0.456,0.25-3.45,0.25-3.6 c0.766-2.188,0.425-8.722,1.4-9.534C9.291,0.691,8.913,1.841,8.55,2.753C8.194,1.681,8.475,1,7.294,0.625 c0.944,0.8,0.756,1.491,0.95,2.594c-0.566-0.734-0.391-1.65-1.041-2.4C7.019,0.628,6.406,0.162,6.406,0.162 c0,0.028,0.491,1.009,0.581,1.528c0.091,0.519,0.306,1.556,0.275,1.938C7.341,5.747,7.875,7.8,8.241,9.878 c0.059,0.353,0.244,1.391,0.244,1.391L8.525,11.7c-0.066-0.284-0.125-0.541-0.163-0.65c-0.106-0.312-0.366-1.103-0.428-1.431 C7.044,7.787,5.416,4.2,3.241,3.669C4.475,4.763,5.803,6.206,6.1,7.6C5.437,6.669,2.831,4.681,1.772,3.956 c1.997,2.072,3.6,4.219,5.337,6.522c0.503,0.653,1.131,1.978,1.178,2.278c0.034,0.222,0.075,1.05,0.1,1.559 c-0.972-2.344-1.506-3.534-3.297-4.587C4.784,9.566,3.834,9.237,3.834,9.237c0.431,0.475,0.959,0.5,1.353,1.166 C4.372,9.869,3.525,9.775,2.594,9.744c2.991,1.547,4.606,1.978,5.616,4.95C8.291,15.181,8.169,15.55,8.178,16h0.669 c-0.003-0.316,0.003-0.616,0-0.678c0.031-0.206,0.041-0.831,0.131-1.022c0.312-0.794,0.819-1.169,1.525-1.631 C9.862,12.875,9.541,12.797,9.053,13.581z M11.997,6.578c-0.247,0.234-0.978,1.162-0.978,1.162c0.044-1.312,0.372-2.719,1.209-3.7 c-1.163,0.762-1.822,2.644-2.125,3.794c-0.119,0.463-1.497,3.144-0.856,4.584c0.125-0.525,0.422-1.038,0.75-1.487 c0.153-0.203,0.794-1.228,1.438-2.688c0.566-1.469,1.491-2.328,2.8-3.056C13.25,5.338,12.687,5.906,11.997,6.578z"
    }));
})).withConfig({
    displayName: "brand-development-seed-2__CollecticonBrandDevelopmentSeed2",
    componentId: "sc-1963e18-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$dd983756265c5ba0 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand development seed icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M15,0H1C0.447,0,0,0.447,0,1v14c0,0.553,0.447,1,1,1h7.178c-0.009-0.45,0.113-0.819,0.031-1.306 c-1.009-2.972-2.625-3.403-5.616-4.95c0.931,0.031,1.778,0.125,2.594,0.659C4.794,9.738,4.266,9.713,3.834,9.238 c0,0,0.95,0.328,1.256,0.491c1.791,1.053,2.325,2.244,3.297,4.587c-0.025-0.509-0.066-1.337-0.1-1.559 c-0.047-0.3-0.675-1.625-1.178-2.278c-1.737-2.303-3.341-4.45-5.338-6.522C2.831,4.681,5.438,6.669,6.1,7.6 C5.803,6.206,4.475,4.763,3.241,3.669C5.416,4.2,7.044,7.788,7.934,9.619c0.062,0.328,0.322,1.119,0.428,1.431 c0.038,0.109,0.097,0.366,0.163,0.65l-0.041-0.431c0,0-0.184-1.038-0.244-1.391c-0.366-2.078-0.9-4.131-0.978-6.25 c0.031-0.381-0.184-1.419-0.275-1.938c-0.091-0.519-0.581-1.5-0.581-1.528l0,0c0,0,0.613,0.466,0.797,0.656 c0.65,0.75,0.475,1.666,1.041,2.4C8.05,2.116,8.238,1.425,7.294,0.625C8.475,1,8.194,1.681,8.55,2.753 c0.363-0.913,0.741-2.062,1.866-2.266c-0.975,0.812-0.634,7.347-1.4,9.534c0,0.15-0.222,3.144-0.25,3.6 c0.103-0.391,0.219-0.678,0.506-0.931c-0.134,0.291-0.222,0.569-0.219,0.891c0.488-0.784,0.809-0.706,1.45-0.913 c-0.706,0.462-1.212,0.837-1.525,1.631c-0.091,0.191-0.1,0.816-0.131,1.022c0.003,0.062-0.003,0.359,0,0.675H15c0.553,0,1-0.447,1-1 V1C16,0.447,15.553,0,15,0z M11.434,8.244c-0.644,1.459-1.284,2.484-1.438,2.688c-0.328,0.45-0.625,0.962-0.75,1.488 c-0.641-1.441,0.738-4.122,0.856-4.584c0.303-1.15,0.962-3.031,2.125-3.794l0,0l0,0l0,0c-0.837,0.981-1.166,2.387-1.209,3.7 c0,0,0.731-0.928,0.978-1.162c0.691-0.672,1.253-1.241,2.238-1.391C12.925,5.916,12,6.775,11.434,8.244z"
    }));
})).withConfig({
    displayName: "brand-development-seed__CollecticonBrandDevelopmentSeed",
    componentId: "sc-1d6uv5p-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$c9ea3985d0020928 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand dropbox icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8.011,3.76L4.005,6.317l4.005,2.557L4.005,11.43L0,8.852l4.005-2.557L0,3.76l4.005-2.557L8.011,3.76z M3.984,12.24 l4.005-2.557l4.005,2.557l-4.005,2.557L3.984,12.24z M8.011,8.852l4.005-2.557L8.011,3.76l3.984-2.557L16,3.76l-4.005,2.557 L16,8.874l-4.005,2.557L8.011,8.852z"
    }));
})).withConfig({
    displayName: "brand-dropbox__CollecticonBrandDropbox",
    componentId: "sc-1ahotra-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$834c92baa9723134 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand facebook icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M15.117,0H0.883C0.395,0,0,0.395,0,0.883v14.234C0,15.605,0.395,16,0.883,16h7.664V9.812H6.469V7.391h2.078V5.608 c0-2.067,1.262-3.192,3.106-3.192c0.883,0,1.642,0.066,1.863,0.095v2.16l-1.271,0.001c-1.003,0-1.197,0.477-1.197,1.176v1.543h2.398 l-0.312,2.422h-2.086V16h4.07C15.605,16,16,15.605,16,15.117V0.883C16,0.395,15.605,0,15.117,0z"
    }));
})).withConfig({
    displayName: "brand-facebook__CollecticonBrandFacebook",
    componentId: "sc-1vrmzn7-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$d8149c9a6ffff702 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand flickr icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,8c0,1.933,1.567,3.5,3.5,3.5S7,9.933,7,8S5.433,4.5,3.5,4.5S0,6.067,0,8z M9,8c0,1.933,1.567,3.5,3.5,3.5S16,9.933,16,8 s-1.567-3.5-3.5-3.5S9,6.067,9,8z"
    }));
})).withConfig({
    displayName: "brand-flickr__CollecticonBrandFlickr",
    componentId: "sc-2bpfaz-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$68cfb6157bb0630 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand github icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M7.999,0C3.582,0,0,3.582,0,8c0,3.534,2.292,6.533,5.471,7.591 c0.4,0.073,0.546-0.174,0.546-0.386c0-0.19-0.007-0.693-0.011-1.361c-2.225,0.483-2.695-1.072-2.695-1.072 c-0.364-0.924-0.888-1.17-0.888-1.17c-0.726-0.496,0.055-0.486,0.055-0.486c0.803,0.057,1.225,0.824,1.225,0.824 c0.714,1.223,1.872,0.87,2.328,0.665c0.073-0.517,0.279-0.87,0.508-1.069c-1.776-0.202-3.644-0.888-3.644-3.954 c0-0.873,0.312-1.587,0.823-2.147C3.637,5.233,3.362,4.419,3.798,3.318c0,0,0.672-0.215,2.2,0.82C6.636,3.961,7.32,3.872,8,3.869 c0.679,0.003,1.364,0.092,2.003,0.269c1.527-1.035,2.198-0.82,2.198-0.82c0.436,1.101,0.162,1.915,0.08,2.117 c0.513,0.559,0.822,1.273,0.822,2.147c0,3.073-1.87,3.75-3.653,3.948c0.287,0.247,0.543,0.735,0.543,1.481 c0,1.069-0.01,1.932-0.01,2.195c0,0.214,0.144,0.463,0.55,0.385C13.71,14.53,16,11.534,16,8C16,3.582,12.418,0,7.999,0z"
    }));
})).withConfig({
    displayName: "brand-github__CollecticonBrandGithub",
    componentId: "sc-1i7dd0q-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$eabd4486e49012ba = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand human rights icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M7.734,0c0.334,0.184,1.469,0.938,1.469,2.297c0,1.203-1.941,4.791-1.188,5.722l4.812-6c0,0,1.197,1.456,0.478,2.688 c-0.747,1.281-2.588,2.781-3.325,3.897C9.524,9.294,9.746,9.663,9.746,9.663l5.834-3.194c0,0,0.469,1.391-0.641,2.391 c-1.172,1.056-3.931,1.475-3.931,2.575h4.006c0,0-0.409,1.216-1.184,1.384c-0.684,0.15-2.144-0.247-2.831,0.372 C10.271,13.847,9.456,16,7.015,16c-1.641,0-2.912-1.184-3.703-2.738c-0.913-1.797-1.938-2.663-2.991-2.881 c0,0,0.575-1.359,2.088-1.359c2.081,0,2.972,3.409,4.544,3.409c0.453,0,0.934-0.234,0.934-0.903c0-0.725-1.044-1.325-1.334-1.525 C5.862,9.522,5.309,8.756,5.665,7.472L7.734,0"
    }));
})).withConfig({
    displayName: "brand-human-rights__CollecticonBrandHumanRights",
    componentId: "sc-1pwhpak-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$b32786cce09df9e0 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand id icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,14.462h2.518V4.963H0V14.462z M0,3.83h2.518V1.538H0V3.83z M15.756,5.599c-0.163-0.744-0.468-1.435-0.916-2.074 c-0.558-0.79-1.288-1.333-2.189-1.629c-0.529-0.174-1.192-0.267-1.988-0.279H5.124v12.845h5.538c1.942,0,3.378-0.799,4.308-2.396 C15.657,10.88,16,9.434,16,7.725C16,7.051,15.919,6.343,15.756,5.599z M12.862,10.357c-0.5,1.249-1.385,1.874-2.653,1.874H7.73 V3.847h2.479c1.222,0,2.038,0.35,2.448,1.05c0.41,0.7,0.615,1.704,0.615,3.011C13.272,8.856,13.135,9.672,12.862,10.357z"
    }));
})).withConfig({
    displayName: "brand-id__CollecticonBrandId",
    componentId: "sc-arpc4b-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$c85efb9e6a50791b = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand instagram icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,4C5.791,4,4,5.791,4,8s1.791,4,4,4s4-1.791,4-4S10.209,4,8,4z M8,10c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2 S9.103,10,8,10z M11,0H5C2.237,0,0,2.237,0,5v6c0,2.762,2.237,5,5,5h6c2.762,0,5-2.238,5-5V5C16,2.237,13.762,0,11,0z M14,11 c0,1.653-1.347,3-3,3H5c-1.653,0-3-1.347-3-3V5c0-1.653,1.347-3,3-3h6c1.653,0,3,1.347,3,3V11z M12,3c-0.553,0-1,0.447-1,1 s0.447,1,1,1s1-0.447,1-1S12.553,3,12,3z"
    }));
})).withConfig({
    displayName: "brand-instagram__CollecticonBrandInstagram",
    componentId: "sc-3ob4n4-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$4238e97612e0856e = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand lastfm icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M3.997,12.445c2.072,0,3.059-0.972,3.059-0.972L6.469,9.88c0,0-0.953,1.062-2.381,1.062c-1.266,0-2.162-1.1-2.162-2.859 c0-2.253,1.138-3.059,2.253-3.059c1.613,0,2.125,1.044,2.566,2.381l0.588,1.831c0.588,1.778,1.688,3.206,4.856,3.206 c2.272,0,3.812-0.697,3.812-2.528c0-1.484-0.844-2.253-2.419-2.622l-1.172-0.256c-0.806-0.184-1.044-0.512-1.044-1.062 c0-0.622,0.494-0.991,1.3-0.991c0.878,0,1.356,0.331,1.428,1.119l1.831-0.219c-0.147-1.65-1.284-2.328-3.153-2.328 c-1.65,0-3.262,0.622-3.262,2.622c0,1.247,0.606,2.034,2.125,2.4l1.247,0.294c0.934,0.219,1.247,0.606,1.247,1.137 c0,0.678-0.659,0.953-1.906,0.953c-1.85,0-2.622-0.972-3.059-2.309L8.556,6.82C7.791,4.436,6.562,3.558,4.125,3.558 C1.428,3.558,0,5.261,0,8.158C0,10.942,1.428,12.445,3.997,12.445z"
    }));
})).withConfig({
    displayName: "brand-lastfm__CollecticonBrandLastfm",
    componentId: "sc-1360vss-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$a2e102bc44d355e3 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand linkedin icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14.815,0H1.18C0.53,0,0,0.517,0,1.153v13.694C0,15.485,0.53,16,1.18,16h13.636C15.467,16,16,15.485,16,14.847V1.153 C16,0.517,15.467,0,14.815,0z M4.746,13.634H2.371V5.999h2.376V13.634z M3.559,4.955c-0.762,0-1.377-0.617-1.377-1.377 c0-0.759,0.615-1.376,1.377-1.376c0.759,0,1.376,0.617,1.376,1.376C4.935,4.339,4.319,4.955,3.559,4.955z M13.633,13.634h-2.371 V9.922c0-0.886-0.017-2.025-1.233-2.025c-1.235,0-1.423,0.964-1.423,1.96v3.778H6.235V5.999h2.274v1.043h0.033 c0.317-0.6,1.091-1.233,2.245-1.233c2.401,0,2.845,1.581,2.845,3.638V13.634z"
    }));
})).withConfig({
    displayName: "brand-linkedin__CollecticonBrandLinkedin",
    componentId: "sc-1tarsql-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$435e172f1afd8f3 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand medium icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,0v16h16V0H0z M13.292,3.791l-0.858,0.823c-0.074,0.056-0.111,0.149-0.095,0.241v6.045 c-0.015,0.092,0.021,0.184,0.095,0.241l0.838,0.823v0.181H9.057v-0.181l0.868-0.843c0.085-0.085,0.085-0.11,0.085-0.241V5.993 l-2.414,6.13H7.271l-2.81-6.13v4.109c-0.023,0.173,0.034,0.347,0.156,0.472l1.129,1.37v0.181H2.544v-0.181l1.129-1.37 c0.121-0.125,0.175-0.3,0.146-0.472V5.351C3.832,5.219,3.781,5.089,3.683,5L2.679,3.791V3.61h3.116l2.409,5.283l2.118-5.283h2.971 V3.791z"
    }));
})).withConfig({
    displayName: "brand-medium__CollecticonBrandMedium",
    componentId: "sc-1ct5yr7-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$b3ee3fb5dcd7cd96 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand satsummit icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M11,5L9,7V4L8,3L7,4v3L5,5H0v6h5l2-2v4h2V9l2,2h5V5H11z M2,10H1V6h1V10z M4,10H3V6h1V10z M13,10h-1V6h1V10z M15,10h-1V6h1 V10z"
    }));
})).withConfig({
    displayName: "brand-satsummit__CollecticonBrandSatsummit",
    componentId: "sc-1cwtnh8-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$f01132691dc82ba2 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand skype icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M15.239,9.03c0.044-0.325,0.069-0.655,0.069-0.992c0-4.036-3.29-7.309-7.347-7.309c-0.403,0-0.799,0.033-1.183,0.096 c-0.69-0.449-1.511-0.711-2.394-0.711C1.961,0.115,0,2.078,0,4.499c0,0.881,0.259,1.7,0.706,2.387 c-0.06,0.376-0.091,0.76-0.091,1.152c0,4.037,3.288,7.309,7.346,7.309c0.458,0,0.904-0.045,1.337-0.123 c0.673,0.418,1.467,0.661,2.317,0.661c2.422,0,4.384-1.963,4.384-4.385C16,10.585,15.72,9.734,15.239,9.03z M8.648,13.425 c-2.335,0.122-3.427-0.395-4.428-1.334c-1.118-1.049-0.669-2.245,0.242-2.306c0.91-0.061,1.456,1.032,1.942,1.335 c0.485,0.303,2.331,0.993,3.306-0.122c1.062-1.213-0.706-1.841-2.002-2.031c-1.85-0.274-4.186-1.275-4.004-3.247 C3.886,3.748,5.379,2.738,6.95,2.595c2.002-0.182,3.306,0.303,4.337,1.183c1.192,1.017,0.547,2.153-0.212,2.244 C10.318,6.114,9.468,4.351,7.8,4.324C6.08,4.297,4.918,6.114,7.041,6.63c2.124,0.516,4.398,0.728,5.218,2.669 C13.078,11.241,10.985,13.303,8.648,13.425z"
    }));
})).withConfig({
    displayName: "brand-skype__CollecticonBrandSkype",
    componentId: "sc-1q1785s-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$8b71514e84056695 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand slack icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,10.111c0,0.925,0.756,1.681,1.681,1.681c0.925,0,1.681-0.756,1.681-1.681V8.43H1.681C0.756,8.43,0,9.186,0,10.111z M16,5.889c0-0.925-0.756-1.681-1.681-1.681c-0.925,0-1.681,0.756-1.681,1.681V7.57h1.681C15.244,7.57,16,6.814,16,5.889z M10.111,7.57c0.925,0,1.681-0.756,1.681-1.681V1.681C11.792,0.756,11.036,0,10.111,0C9.186,0,8.43,0.756,8.43,1.681v4.208 C8.43,6.814,9.186,7.57,10.111,7.57z M5.889,8.43c-0.925,0-1.681,0.756-1.681,1.681v4.208C4.208,15.244,4.964,16,5.889,16 c0.925,0,1.681-0.756,1.681-1.681v-4.208C7.57,9.186,6.814,8.43,5.889,8.43z M5.889,4.208H1.681C0.756,4.208,0,4.964,0,5.889 C0,6.814,0.756,7.57,1.681,7.57h4.208c0.925,0,1.681-0.756,1.681-1.681C7.57,4.964,6.814,4.208,5.889,4.208z M5.889,0 C4.964,0,4.208,0.756,4.208,1.681c0,0.925,0.756,1.681,1.681,1.681H7.57V1.681C7.57,0.756,6.814,0,5.889,0z M14.319,8.43h-4.208 c-0.925,0-1.681,0.756-1.681,1.681c0,0.925,0.756,1.681,1.681,1.681h4.208c0.925,0,1.681-0.756,1.681-1.681 C16,9.186,15.244,8.43,14.319,8.43z M10.111,12.638H8.43v1.681C8.43,15.244,9.186,16,10.111,16c0.925,0,1.681-0.756,1.681-1.681 C11.792,13.394,11.036,12.638,10.111,12.638z"
    }));
})).withConfig({
    displayName: "brand-slack__CollecticonBrandSlack",
    componentId: "sc-1j15ji4-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$4eeeb34c908b13d0 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand soundcloud icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M2.035,7.791c-0.05,0-0.091,0.041-0.094,0.094L1.8,9.638l0.141,1.694c0.003,0.053,0.044,0.091,0.094,0.091 c0.05,0,0.091-0.041,0.094-0.091l0.159-1.694L2.129,7.884C2.125,7.828,2.085,7.791,2.035,7.791z M2.676,7.903 c-0.056,0-0.104,0.047-0.107,0.106L2.435,9.635l0.134,1.71c0.003,0.059,0.05,0.106,0.106,0.106c0.056,0,0.103-0.047,0.106-0.106 l0.15-1.71L2.782,8.009C2.779,7.95,2.732,7.903,2.676,7.903z M3.319,6.872c-0.066,0-0.119,0.053-0.122,0.119L3.072,9.635l0.125,1.71 c0.003,0.066,0.056,0.119,0.122,0.119c0.066,0,0.119-0.053,0.122-0.119l0.141-1.71L3.441,6.99C3.435,6.922,3.382,6.872,3.319,6.872z M1.4,7.85c-0.044,0-0.075,0.034-0.081,0.078l-0.15,1.707l0.15,1.644c0.003,0.047,0.038,0.078,0.081,0.078 c0.041,0,0.075-0.034,0.081-0.078L1.65,9.635L1.482,7.928C1.475,7.881,1.444,7.85,1.4,7.85z M0.181,8.681 c-0.034,0-0.059,0.025-0.066,0.063L0,9.635l0.116,0.875c0.003,0.038,0.031,0.063,0.066,0.063c0.031,0,0.059-0.025,0.063-0.063 l0.138-0.875L0.244,8.747C0.241,8.706,0.213,8.681,0.181,8.681z M0.772,8.131c-0.034,0-0.063,0.028-0.066,0.066L0.55,9.635 l0.156,1.407c0.003,0.038,0.031,0.066,0.066,0.066c0.034,0,0.063-0.025,0.066-0.066l0.178-1.407L0.838,8.197 C0.835,8.159,0.806,8.131,0.772,8.131z M3.957,6.262c-0.072,0-0.131,0.059-0.134,0.134L3.707,9.644l0.116,1.697 c0.003,0.075,0.063,0.134,0.134,0.134c0.072,0,0.131-0.059,0.134-0.134l0.131-1.697L4.091,6.397 C4.088,6.318,4.029,6.262,3.957,6.262z M7.405,5.403C7.373,5.381,7.333,5.368,7.292,5.368S7.214,5.381,7.183,5.402 c-0.056,0.038-0.094,0.1-0.094,0.169v0.038L7.014,9.635c0,0.003,0.078,1.635,0.078,1.635c0,0.003,0,0.003,0,0.006 c0.003,0.047,0.019,0.088,0.047,0.122c0.038,0.044,0.094,0.075,0.156,0.075c0.056,0,0.106-0.022,0.141-0.059 c0.038-0.038,0.059-0.088,0.063-0.144l0.009-0.163l0.078-1.469L7.501,5.571C7.492,5.5,7.458,5.44,7.405,5.403z M14.034,7.537 c-0.269,0-0.528,0.053-0.763,0.153c-0.156-1.775-1.644-3.166-3.46-3.166c-0.444,0-0.878,0.088-1.26,0.234 C8.402,4.815,8.364,4.874,8.361,4.99v6.248c0.003,0.122,0.094,0.216,0.213,0.225c0.006,0,5.457,0,5.457,0 c1.088,0,1.969-0.872,1.969-1.96C16.003,8.419,15.122,7.537,14.034,7.537z M6.617,6.031c-0.103,0-0.188,0.084-0.191,0.188 L6.342,9.635l0.084,1.644c0.003,0.103,0.084,0.188,0.191,0.188c0.103,0,0.188-0.081,0.191-0.188l0.094-1.644L6.808,6.218 C6.804,6.112,6.72,6.031,6.617,6.031z M8.073,5.018C8.042,4.999,8.005,4.987,7.964,4.987c-0.053,0-0.1,0.019-0.138,0.05 c-0.047,0.041-0.078,0.1-0.081,0.166v0.022L7.658,9.638l0.044,0.816l0.044,0.794c0,0.119,0.1,0.216,0.216,0.216 c0.119,0,0.216-0.097,0.216-0.216v0.003l0.097-1.61L8.177,5.206C8.18,5.124,8.136,5.056,8.073,5.018z M5.948,5.915 c-0.097,0-0.175,0.078-0.175,0.175L5.679,9.635l0.094,1.653c0.003,0.097,0.078,0.175,0.175,0.175s0.172-0.078,0.175-0.175 l0.103-1.653L6.123,6.087C6.12,5.99,6.042,5.915,5.948,5.915z M5.282,5.834c-0.088,0-0.159,0.072-0.163,0.163l-0.1,3.638l0.1,1.669 c0.003,0.091,0.075,0.159,0.163,0.159s0.159-0.072,0.163-0.159l0.113-1.669L5.445,5.996C5.442,5.906,5.37,5.834,5.282,5.834z M4.623,5.968c-0.081,0-0.147,0.066-0.15,0.147l-0.11,3.52l0.109,1.682c0.003,0.081,0.069,0.147,0.15,0.147s0.144-0.066,0.15-0.147 l0.122-1.682l-0.121-3.52C4.767,6.031,4.701,5.968,4.623,5.968z"
    }));
})).withConfig({
    displayName: "brand-soundcloud__CollecticonBrandSoundcloud",
    componentId: "sc-1sstkof-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$e582f877f685c307 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand tumblr icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M9.707,15.997c-3.396,0-4.687-2.503-4.687-4.274V6.496H3.412V4.43c2.418-0.875,3.009-3.062,3.14-4.312 C6.561,0.034,6.63,0,6.667,0h2.343v4.074h3.199v2.421H8.995v4.98c0.009,0.669,0.25,1.581,1.472,1.581h0.059 c0.422-0.012,0.99-0.137,1.29-0.278l0.772,2.284c-0.291,0.425-1.6,0.915-2.771,0.937H9.698C9.698,15.997,9.707,15.997,9.707,15.997z"
    }));
})).withConfig({
    displayName: "brand-tumblr__CollecticonBrandTumblr",
    componentId: "sc-2ls7o1-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$f26b4f060f08f8f9 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand twitter icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M16,3.038c-0.589,0.261-1.221,0.438-1.885,0.517c0.678-0.406,1.198-1.05,1.443-1.816c-0.634,0.376-1.337,0.649-2.085,0.797 c-0.599-0.638-1.452-1.037-2.396-1.037c-1.813,0-3.283,1.47-3.283,3.282c0,0.257,0.029,0.508,0.085,0.748 c-2.728-0.137-5.147-1.444-6.766-3.43C0.831,2.584,0.669,3.148,0.669,3.75c0,1.139,0.579,2.144,1.46,2.732 C1.592,6.465,1.086,6.317,0.643,6.071c0,0.014,0,0.027,0,0.041c0,1.59,1.132,2.917,2.633,3.219C3,9.406,2.71,9.447,2.411,9.447 c-0.212,0-0.417-0.021-0.618-0.059c0.418,1.304,1.63,2.253,3.066,2.28c-1.123,0.88-2.539,1.405-4.077,1.405 c-0.265,0-0.526-0.016-0.783-0.046c1.453,0.931,3.178,1.475,5.032,1.475c6.038,0,9.34-5.002,9.34-9.34 c0-0.142-0.003-0.284-0.01-0.425C15.003,4.274,15.56,3.696,16,3.038z"
    }));
})).withConfig({
    displayName: "brand-twitter__CollecticonBrandTwitter",
    componentId: "sc-1joz4pi-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$5e55219a763bfc51 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "brand youtube icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M6.364,10.379L6.364,5.621L10.545,8L6.364,10.379ZM15.666,4.124C15.482,3.431 14.939,2.885 14.251,2.7C13.003,2.364 8,2.364 8,2.364C8,2.364 2.997,2.364 1.749,2.7C1.061,2.885 0.518,3.431 0.334,4.124C0,5.38 0,8 0,8C0,8 0,10.62 0.334,11.876C0.518,12.569 1.061,13.115 1.749,13.3C2.997,13.636 8,13.636 8,13.636C8,13.636 13.003,13.636 14.251,13.3C14.939,13.115 15.482,12.569 15.666,11.876C16,10.62 16,8 16,8C16,8 16,5.38 15.666,4.124"
    }));
})).withConfig({
    displayName: "brand-youtube__CollecticonBrandYoutube",
    componentId: "sc-sr8y6n-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$3f241c3fc4d9dd7a = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "briefcase icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M6,2h4v1h2V2c0-1.1-0.9-2-2-2H6C4.9,0,4,0.9,4,2v1h2V2z M0,14c0,0.55,0.45,1,1,1h14c0.55,0,1-0.45,1-1V8H0V14z M7,9h2v1 c0,0.553-0.447,1-1,1s-1-0.447-1-1V9z M15,4H1C0.45,4,0,4.45,0,5v2h16V5C16,4.45,15.55,4,15,4z"
    }));
})).withConfig({
    displayName: "briefcase__CollecticonBriefcase",
    componentId: "sc-kf8guy-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$16c0cbaf2c55e7b6 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "calendar range icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "calendar-range",
        d: "M15,15L1,15C0.447,15 0,14.553 0,14L0,3C0,2.447 0.447,2 1,2L2,2L2,4L5,4L5,2L11,2L11,4L14,4L14,2L15,2C15.553,2 16,2.447 16,3L16,14C16,14.553 15.553,15 15,15ZM14,6L2,6L2,13L14,13L14,6ZM9,12L7,12L7,10L9,10L9,12ZM6,12L4,12L4,10L6,10L6,12ZM12,9L10,9L10,7L12,7L12,9ZM9,9L7,9L7,7L9,7L9,9ZM4,3L3,3L3,0.494C3,0.222 3.222,0 3.497,0L3.506,0C3.778,0 4,0.222 4,0.494L4,3ZM13,3L12,3L12,0.494C12,0.222 12.222,0 12.497,0L12.506,0C12.778,0 13,0.222 13,0.494L13,3Z"
    }));
})).withConfig({
    displayName: "calendar-range__CollecticonCalendarRange",
    componentId: "sc-d7veqq-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$edaa4810f882e615 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "calendar slot icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "calendar-day",
        d: "M6,7L4,7L4,9L6,9L6,7ZM15,2L14,2L14,4L11,4L11,2L5,2L5,4L2,4L2,2L1,2C0.447,2 0,2.447 0,3L0,14C0,14.553 0.447,15 1,15L15,15C15.553,15 16,14.553 16,14L16,3C16,2.447 15.553,2 15,2ZM14,13L2,13L2,6L14,6L14,13ZM4,0.494C4,0.222 3.778,0 3.506,0L3.497,0C3.222,0 3,0.222 3,0.494L3,3L4,3L4,0.494ZM13,0.494C13,0.222 12.778,0 12.506,0L12.497,0C12.222,0 12,0.222 12,0.494L12,3L13,3L13,0.494Z"
    }));
})).withConfig({
    displayName: "calendar-slot__CollecticonCalendarSlot",
    componentId: "sc-149d7hp-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$af3433002e85528f = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "calendar icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M6,7H4v2h2V7z M6,10H4v2h2V10z M9,7H7v2h2V7z M9,10H7v2h2V10z M12,7h-2v2h2V7z M12,10h-2v2h2V10z M15,2h-1v2h-3V2H5v2H2V2H1 C0.447,2,0,2.447,0,3v11c0,0.553,0.447,1,1,1h14c0.553,0,1-0.447,1-1V3C16,2.447,15.553,2,15,2z M14,13H2V6h12V13z M4,0.494 C4,0.222,3.778,0,3.506,0H3.497C3.222,0,3,0.222,3,0.494V3h1V0.494z M13,0.494C13,0.222,12.778,0,12.506,0h-0.009 C12.222,0,12,0.222,12,0.494V3h1V0.494z"
    }));
})).withConfig({
    displayName: "calendar__CollecticonCalendar",
    componentId: "sc-8vlmvg-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$ebaef9cfe20e1737 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "camera icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M6,8.5c0,1.103,0.897,2,2,2s2-0.897,2-2s-0.897-2-2-2S6,7.397,6,8.5z M15,3h-3.5C11.25,2,11,1,10,1H6C5,1,4.75,2,4.5,3H1 C0.45,3,0,3.45,0,4v9c0,0.55,0.45,1,1,1h14c0.55,0,1-0.45,1-1V4C16,3.45,15.55,3,15,3z M8,12.5c-2.209,0-4-1.791-4-4s1.791-4,4-4 s4,1.791,4,4S10.209,12.5,8,12.5z"
    }));
})).withConfig({
    displayName: "camera__CollecticonCamera",
    componentId: "sc-1o7mf61-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$e71f7b946c7cc127 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chart bars icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M16,14L16,16L0,16L0,14L16,14ZM11,5L11,13L9,13L9,5L11,5ZM15,1L15,13L13,13L13,1L15,1ZM3,9L3,13L1,13L1,9L3,9ZM7,3L7,13L5,13L5,3L7,3Z"
    }));
})).withConfig({
    displayName: "chart-bars__CollecticonChartBars",
    componentId: "sc-uuv0u5-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$51e1bcc8c9b70cf = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chart line icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M16,14L16,16L0,16L0,14L16,14ZM13.292,4.39C13.109,4.141 13,3.833 13,3.5C13,2.672 13.672,2 14.5,2C15.328,2 16,2.672 16,3.5C16,4.328 15.328,5 14.5,5C14.483,5 14.466,5 14.448,4.999L10.708,10.61C10.891,10.859 11,11.167 11,11.5C11,12.328 10.328,13 9.5,13C8.672,13 8,12.328 8,11.5C8,11.193 8.092,10.907 8.251,10.67L5.626,6.995C5.584,6.998 5.542,7 5.5,7C5.458,7 5.416,6.998 5.374,6.995L2.749,10.67C2.908,10.907 3,11.193 3,11.5C3,12.328 2.328,13 1.5,13C0.672,13 0,12.328 0,11.5C0,10.672 0.672,10 1.5,10C1.542,10 1.584,10.002 1.626,10.005L4.251,6.33C4.092,6.093 4,5.807 4,5.5C4,4.672 4.672,4 5.5,4C6.328,4 7,4.672 7,5.5C7,5.807 6.908,6.093 6.749,6.33L9.374,10.005C9.416,10.002 9.458,10 9.5,10C9.517,10 9.534,10 9.552,10.001L13.292,4.39Z"
    }));
})).withConfig({
    displayName: "chart-line__CollecticonChartLine",
    componentId: "sc-ct4my2-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$acdc8ffe67b5cfdc = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chart pie icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M7,9L14,9C13.95,12.913 10.833,16 7,16C3.137,16 0,12.863 0,9C0,5.137 3.137,2 7,2L7,9ZM16,7L9,7L9,0L10.41,0.142C13.576,0.793 15.962,3.577 16,7Z"
    }));
})).withConfig({
    displayName: "chart-pie__CollecticonChartPie",
    componentId: "sc-10flqng-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$c99fa69b6fe4cbfa = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chevron down small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "12.586,4.586 8,9.172 3.414,4.586 2,6 8,12 14,6"
    }));
})).withConfig({
    displayName: "chevron-down--small__CollecticonChevronDownSmall",
    componentId: "sc-j16u51-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$d24fe4633d517542 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chevron down trail small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("g", {
        id: "chevron-down-trail--small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "arrow-a100",
        d: "M12.586,6.586l-4.586,4.586l-4.586,-4.586l-1.414,1.414l6,6l6,-6l-1.414,-1.414Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "arrow-a32",
        d: "M12.586,1.586l-4.586,4.586l-4.586,-4.586l-1.414,1.414l6,6l6,-6l-1.414,-1.414Z",
        opacity: "0.32"
    })));
})).withConfig({
    displayName: "chevron-down-trail--small__CollecticonChevronDownTrailSmall",
    componentId: "sc-1ga8kui-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$6be9a9d30ce9b0ed = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chevron down icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "14.586,3.586 8,10.172 1.414,3.586 0,5 8,13 16,5"
    }));
})).withConfig({
    displayName: "chevron-down__CollecticonChevronDown",
    componentId: "sc-16oe913-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$5257c06aa807f52c = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chevron left small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "11.414,12.586 6.828,8 11.414,3.414 10,2 4,8 10,14"
    }));
})).withConfig({
    displayName: "chevron-left--small__CollecticonChevronLeftSmall",
    componentId: "sc-18vjqa1-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$bd98fc092ca567ad = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chevron left trail small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("g", {
        id: "chevron-left-trail--small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "arrow-a32",
        d: "M14.414,12.586l-4.586,-4.586l4.586,-4.586l-1.414,-1.414l-6,6l6,6l1.414,-1.414Z",
        opacity: "0.32"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "arrow-a100",
        d: "M9.414,12.586l-4.586,-4.586l4.586,-4.586l-1.414,-1.414l-6,6l6,6l1.414,-1.414Z"
    })));
})).withConfig({
    displayName: "chevron-left-trail--small__CollecticonChevronLeftTrailSmall",
    componentId: "sc-r4sk2v-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$87375f63e1783ecd = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chevron left icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "12.414,14.586 5.828,8 12.414,1.414 11,0 3,8 11,16 "
    }));
})).withConfig({
    displayName: "chevron-left__CollecticonChevronLeft",
    componentId: "sc-o6152v-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$1871f85e3a28ae2d = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chevron right small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "4.586,3.414 9.172,8 4.586,12.586 6,14 12,8 6,2"
    }));
})).withConfig({
    displayName: "chevron-right--small__CollecticonChevronRightSmall",
    componentId: "sc-1oue0hw-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$5bb5160993ff67f0 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chevron right trail small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("g", {
        id: "chevron-right-trail--small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "arrow-a100",
        d: "M6.586,3.414l4.586,4.586l-4.586,4.586l1.414,1.414l6,-6l-6,-6l-1.414,1.414Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "arrow-a32",
        d: "M1.586,3.414l4.586,4.586l-4.586,4.586l1.414,1.414l6,-6l-6,-6l-1.414,1.414Z",
        opacity: "0.32"
    })));
})).withConfig({
    displayName: "chevron-right-trail--small__CollecticonChevronRightTrailSmall",
    componentId: "sc-cr3ier-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$f98cf460e7941c2b = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chevron right icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "3.586,1.414 10.172,8 3.586,14.586 5,16 13,8 5,0"
    }));
})).withConfig({
    displayName: "chevron-right__CollecticonChevronRight",
    componentId: "sc-138s8d2-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$61133413a12a7ef4 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chevron step backward icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M2,15h2V1H2V15z M14.4,2.4L13,1L6,8l7,7l1.4-1.4L8.8,8L14.4,2.4z"
    }));
})).withConfig({
    displayName: "chevron-step-backward__CollecticonChevronStepBackward",
    componentId: "sc-1h8m6i3-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$e4779f93e989d6cc = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chevron step forward icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14,1h-2v14h2V1z M7.2,8l-5.6,5.6L3,15l7-7L3,1L1.6,2.4L7.2,8z"
    }));
})).withConfig({
    displayName: "chevron-step-forward__CollecticonChevronStepForward",
    componentId: "sc-ymfau8-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$66e62118032befb3 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chevron up small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "3.414,11.414 8,6.828 12.586,11.414 14,10 8,4 2,10"
    }));
})).withConfig({
    displayName: "chevron-up--small__CollecticonChevronUpSmall",
    componentId: "sc-1vuskgk-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$ef1b2d050d1d9596 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chevron up trail small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("g", {
        id: "chevron-up-trail--small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "arrow-a32",
        d: "M3.414,14.414l4.586,-4.586l4.586,4.586l1.414,-1.414l-6,-6l-6,6l1.414,1.414Z",
        opacity: "0.32"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "arrow-a100",
        d: "M3.414,9.414l4.586,-4.586l4.586,4.586l1.414,-1.414l-6,-6l-6,6l1.414,1.414Z"
    })));
})).withConfig({
    displayName: "chevron-up-trail--small__CollecticonChevronUpTrailSmall",
    componentId: "sc-1u82jsn-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$cd6ea45e6c6fa795 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "chevron up icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "1.414,12.414 8,5.828 14.586,12.414 16,11 8,3 0,11"
    }));
})).withConfig({
    displayName: "chevron-up__CollecticonChevronUp",
    componentId: "sc-ks5tuk-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$f72e08a2ef494448 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "circle exclamation icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M7,9h2V4H7V9z M9,11c0-0.553-0.447-1-1-1s-1,0.447-1,1s0.447,1,1,1S9,11.553,9,11z M16,8c0-4.419-3.581-8-8-8S0,3.581,0,8 s3.581,8,8,8S16,12.419,16,8z M14,8c0,1.603-0.625,3.109-1.756,4.244C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756 C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8z"
    }));
})).withConfig({
    displayName: "circle-exclamation__CollecticonCircleExclamation",
    componentId: "sc-1k0psd0-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$543083732c6741d9 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "circle forbidden icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,8c0,4.419,3.581,8,8,8s8-3.581,8-8s-3.581-8-8-8S0,3.581,0,8z M12.891,11.478L4.522,3.109C5.531,2.391,6.734,2,8,2 c1.603,0,3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8C14,9.266,13.609,10.469,12.891,11.478z M2,8 c0-1.266,0.391-2.469,1.109-3.478l8.369,8.369C10.469,13.609,9.266,14,8,14c-1.603,0-3.109-0.625-4.244-1.756 C2.625,11.109,2,9.603,2,8z"
    }));
})).withConfig({
    displayName: "circle-forbidden__CollecticonCircleForbidden",
    componentId: "sc-1o35ffe-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$5ec4aa1366cd882 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "circle information icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M7,12h2V7H7V12z M8,4C7.448,4,7,4.448,7,5s0.448,1,1,1c0.552,0,1-0.448,1-1S8.552,4,8,4z M8,0C3.582,0,0,3.582,0,8 c0,4.418,3.582,8,8,8s8-3.582,8-8C16,3.582,12.418,0,8,0z M12.243,12.243C11.109,13.376,9.603,14,8,14s-3.109-0.624-4.243-1.757 C2.624,11.109,2,9.603,2,8s0.624-3.109,1.757-4.243C4.891,2.624,6.397,2,8,2s3.109,0.624,4.243,1.757C13.376,4.891,14,6.397,14,8 C14,9.603,13.376,11.109,12.243,12.243z"
    }));
})).withConfig({
    displayName: "circle-information__CollecticonCircleInformation",
    componentId: "sc-17lqoff-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$e356a46c6dfa0cd = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "circle pause icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244C11.109,13.375,9.603,14,8,14 s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8c0-1.603,0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2 s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8C14,9.603,13.375,11.109,12.244,12.244z M5,11h2V5H5V11z M9,11h2V5H9V11z"
    }));
})).withConfig({
    displayName: "circle-pause__CollecticonCirclePause",
    componentId: "sc-kbggwr-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$f251922d9c0b7d86 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "circle play next icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M5,11l4-3L5,5V11z M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244 C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8c0-1.603,0.625-3.109,1.756-4.244 C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8C14,9.603,13.375,11.109,12.244,12.244z M9,8v3h2V5H9 V8z"
    }));
})).withConfig({
    displayName: "circle-play-next__CollecticonCirclePlayNext",
    componentId: "sc-ha7um8-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$b8c4b2c7e344e0c3 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "circle play icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M6,12l6-4L6,4V12z M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244 C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2 s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8S13.375,11.109,12.244,12.244z"
    }));
})).withConfig({
    displayName: "circle-play__CollecticonCirclePlay",
    componentId: "sc-15udb8c-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$94c33b488623435e = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "circle question icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,10.5c-0.552,0-1,0.448-1,1c0,0.552,0.448,1,1,1c0.552,0,1-0.448,1-1C9,10.948,8.552,10.5,8,10.5z M8,0 C3.582,0,0,3.582,0,8c0,4.418,3.582,8,8,8s8-3.582,8-8C16,3.582,12.418,0,8,0z M12.243,12.243C11.109,13.376,9.603,14,8,14 s-3.109-0.624-4.243-1.757C2.624,11.109,2,9.603,2,8s0.624-3.109,1.757-4.243C4.891,2.624,6.397,2,8,2s3.109,0.624,4.243,1.757 C13.376,4.891,14,6.397,14,8C14,9.603,13.376,11.109,12.243,12.243z M7.927,3.755c-2.248,0-2.76,1.695-2.802,2.906h1.571 c0.028-0.256,0.101-1.418,1.221-1.418c0.672,0,1.206,0.406,1.206,1.175c0,0.695-0.724,1.155-1.303,1.711 C7.241,8.685,7.168,9.325,7.168,9.824V10c0.146,0,1.615,0,1.615,0V9.824c0-1.256,1.967-1.594,1.967-3.541 C10.75,5.059,9.874,3.755,7.927,3.755z"
    }));
})).withConfig({
    displayName: "circle-question__CollecticonCircleQuestion",
    componentId: "sc-1tmmqtp-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$1d64b5b770b4b3ed = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "circle record icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "circle-record",
        d: "M8,0.035C12.406,0.035 15.983,3.612 15.983,8.017C15.983,12.423 12.406,16 8,16C3.594,16 0.017,12.423 0.017,8.017C0.017,3.612 3.594,0.035 8,0.035ZM8,2.035C4.698,2.035 2.017,4.716 2.017,8.017C2.017,11.319 4.698,14 8,14C11.302,14 13.983,11.319 13.983,8.017C13.983,4.716 11.302,2.035 8,2.035ZM7.989,5.017C9.636,5.017 10.972,6.354 10.972,8C10.972,9.646 9.636,10.983 7.989,10.983C6.343,10.983 5.007,9.646 5.007,8C5.007,6.354 6.343,5.017 7.989,5.017Z"
    }));
})).withConfig({
    displayName: "circle-record__CollecticonCircleRecord",
    componentId: "sc-dorv0a-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$5836eb8e2e3e864d = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "circle stop icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M5,11h6V5H5V11z M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244 C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2 s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8S13.375,11.109,12.244,12.244z"
    }));
})).withConfig({
    displayName: "circle-stop__CollecticonCircleStop",
    componentId: "sc-p4y1fg-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$c65898577f07616b = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "circle tick icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244C11.109,13.375,9.603,14,8,14 s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756 C13.375,4.891,14,6.397,14,8S13.375,11.109,12.244,12.244z M10.784,4.916L7.016,9.103L5.262,7.372L3.856,8.794L7.1,12l5.169-5.747 L10.784,4.916z"
    }));
})).withConfig({
    displayName: "circle-tick__CollecticonCircleTick",
    componentId: "sc-ucs8qm-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$6fb1bca6e16c2c94 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "circle xmark icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M10.294,4.294L8,6.584L5.706,4.291L4.291,5.706L6.584,8l-2.294,2.294l1.416,1.416L8,9.416l2.294,2.294l1.416-1.416L9.416,8 l2.294-2.294L10.294,4.294z M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244 C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756C2.625,11.109,2,9.603,2,8s0.625-3.109,1.756-4.244C4.891,2.625,6.397,2,8,2 s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8S13.375,11.109,12.244,12.244z"
    }));
})).withConfig({
    displayName: "circle-xmark__CollecticonCircleXmark",
    componentId: "sc-1rxb9gg-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$5a17af862a7576da = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "clipboard tick icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M11,2c0-0.6-0.4-1-1-1H9.4C9.2,0.4,8.7,0,8,0S6.8,0.4,6.6,1H6C5.4,1,5,1.4,5,2v2h6V2z M13,2h-1v2h1v10H3V4h1V2H3 C1.9,2,1,2.9,1,4v10c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V4C15,2.9,14.1,2,13,2z M7,9.7L5.2,8L3.8,9.4L7,12.6l5.2-5.7l-1.5-1.3L7,9.7 z"
    }));
})).withConfig({
    displayName: "clipboard-tick__CollecticonClipboardTick",
    componentId: "sc-1pdrcx1-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$b21a11de10d6bf76 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "clipboard icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M11,6H5v2h6V6z M11,2c0-0.6-0.4-1-1-1H9.4C9.2,0.4,8.7,0,8,0S6.8,0.4,6.6,1H6C5.4,1,5,1.4,5,2v2h6V2z M11,10H5v2h6V10z M13,2h-1v2h1v10H3V4h1V2H3C1.9,2,1,2.9,1,4v10c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V4C15,2.9,14.1,2,13,2z"
    }));
})).withConfig({
    displayName: "clipboard__CollecticonClipboard",
    componentId: "sc-a2zain-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$17345b07225e0aa = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "clock back icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,0C5.609,0,3.463,1.047,2,2.709V0H0v6h6V4H3.528C3.6,3.916,3.681,3.838,3.756,3.756 C4.891,2.625,6.397,2,8,2s3.109,0.625,4.244,1.756C13.375,4.891,14,6.397,14,8s-0.625,3.109-1.756,4.244 C11.109,13.375,9.603,14,8,14s-3.113-0.619-4.244-1.756S2,9.603,2,8H0c0,4.419,3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M7,4v4.416 l3.291,3.291l1.416-1.416L9,7.584V4H7z"
    }));
})).withConfig({
    displayName: "clock-back__CollecticonClockBack",
    componentId: "sc-rxii24-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$bbbb9b7c1aff7988 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "clock icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M9,4H7v4.416l3.294,3.291l1.413-1.416L9,7.584V4z M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M8,14 c-3.312,0-6-2.688-6-6s2.688-6,6-6s6,2.688,6,6S11.312,14,8,14z"
    }));
})).withConfig({
    displayName: "clock__CollecticonClock",
    componentId: "sc-183mh7f-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$1610bcb056ae58bb = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "code icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M12.294,3.294l-1.416,1.416L13.5,8l-2.622,3.294l1.416,1.416L16,8L12.294,3.294z M5.122,4.706L3.706,3.291L0,8l3.706,4.706 l1.416-1.416L2.5,8L5.122,4.706z M6,13h2l2-10H8L6,13z"
    }));
})).withConfig({
    displayName: "code__CollecticonCode",
    componentId: "sc-i0rakm-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$4073c4c5b5a233d4 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "cog icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M16,9V7l-2.259-0.753c-0.113-0.372-0.262-0.728-0.441-1.066l1.066-2.131L12.95,1.634L10.819,2.7 c-0.338-0.178-0.694-0.325-1.066-0.441L9,0H7L6.247,2.259C5.875,2.372,5.519,2.522,5.181,2.7L3.05,1.638L1.638,3.05l1.066,2.131 C2.522,5.519,2.375,5.875,2.259,6.247L0,7v2l2.259,0.753c0.112,0.372,0.263,0.728,0.441,1.066L1.634,12.95l1.416,1.416L5.181,13.3 c0.338,0.178,0.694,0.328,1.066,0.441L7,16h2l0.753-2.259c0.372-0.113,0.728-0.262,1.066-0.441l2.131,1.066l1.416-1.416L13.3,10.819 c0.178-0.337,0.328-0.694,0.441-1.066L16,9z M8,11c-1.656,0-3-1.344-3-3s1.344-3,3-3s3,1.344,3,3S9.656,11,8,11z"
    }));
})).withConfig({
    displayName: "cog__CollecticonCog",
    componentId: "sc-1sd7ai6-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$fa207a04e28a42cb = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "compass 2 icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "15,1 1,6 8,8 10,15"
    }));
})).withConfig({
    displayName: "compass-2__CollecticonCompass2",
    componentId: "sc-1tbgltj-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$6df11ed8ec8f8d62 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "compass icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M8,14c-3.312,0-6-2.688-6-6s2.688-6,6-6s6,2.688,6,6 S11.312,14,8,14z M6.5,6.5L4,11v1h1l4.5-2.5L12,5V4h-1L6.5,6.5z M8,9C7.447,9,7,8.553,7,8s0.447-1,1-1s1,0.447,1,1S8.553,9,8,9z"
    }));
})).withConfig({
    displayName: "compass__CollecticonCompass",
    componentId: "sc-1ka5acc-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$ec3499dc3f62d571 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "crosshair 2 icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244C11.35,13.137,10.225,13.716,9,13.919V11H7 v2.919c-1.222-0.203-2.35-0.781-3.244-1.675C2.862,11.35,2.287,10.222,2.081,9H5V7H2.081c0.203-1.222,0.781-2.35,1.675-3.244 S5.775,2.284,7,2.081V5h2V2.081c1.222,0.203,2.35,0.781,3.244,1.675C13.137,4.65,13.716,5.775,13.919,7H11v2h2.919 C13.712,10.222,13.137,11.35,12.244,12.244z"
    }));
})).withConfig({
    displayName: "crosshair-2__CollecticonCrosshair2",
    componentId: "sc-6nf0hc-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$daacca6cce9e30d3 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "crosshair icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M13.916,7C13.494,4.488,11.512,2.506,9,2.084V0H7v2.084C4.488,2.506,2.506,4.488,2.084,7H0v2h2.084 C2.506,11.512,4.488,13.494,7,13.916V16h2v-2.084c2.512-0.422,4.494-2.403,4.916-4.916H16V7H13.916z M10.828,10.828 C10.072,11.584,9.069,12,8,12s-2.072-0.416-2.828-1.172S4,9.069,4,8s0.416-2.072,1.172-2.828S6.931,4,8,4s2.072,0.416,2.828,1.172 S12,6.931,12,8S11.584,10.072,10.828,10.828z M8,6C6.897,6,6,6.897,6,8s0.897,2,2,2s2-0.897,2-2S9.103,6,8,6z"
    }));
})).withConfig({
    displayName: "crosshair__CollecticonCrosshair",
    componentId: "sc-1amsdvw-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$23ce67b3071ee16e = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "disc dollar icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12,6H6.181C5.909,6,5.688,6.222,5.688,6.494v0.009 c0,0.272,0.222,0.494,0.494,0.494H10c1.103,0,2,0.897,2,2v1c0,1.103-0.897,2-2,2H9v1H7v-1H4v-2h5.506C9.778,9.997,10,9.775,10,9.503 V9.494C10,9.222,9.778,9,9.506,9H6H5.981C4.887,9,4,8.112,4,7.019V6c0-1.103,0.897-2,2-2h1V3h2v1h3V6z"
    }));
})).withConfig({
    displayName: "disc-dollar__CollecticonDiscDollar",
    componentId: "sc-1dlkh66-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$65f71275cd169acd = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "disc xmark icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,0C3.582,0,0,3.582,0,8s3.582,8,8,8s8-3.582,8-8S12.418,0,8,0z M12.707,11.293l-1.414,1.414L8,9.414l-3.293,3.293 l-1.414-1.414L6.586,8L3.293,4.707l1.414-1.414L8,6.586l3.293-3.293l1.414,1.414L9.414,8L12.707,11.293z"
    }));
})).withConfig({
    displayName: "disc-xmark__CollecticonDiscXmark",
    componentId: "sc-1c7ctan-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$cb9a136b7e677418 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "download 2 icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M12.706,8.294l-1.416-1.416L9,9.172V0H7v9.172L4.706,6.878L3.291,8.294L8,13L12.706,8.294z M16,14H0v2h16V14z"
    }));
})).withConfig({
    displayName: "download-2__CollecticonDownload2",
    componentId: "sc-13uh0ce-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$70f26903e40c814d = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "download icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M12.706,8.294l-1.416-1.416L9,9.172V0H7v9.172L4.706,6.878L3.291,8.294L8,13L12.706,8.294z M14,4v10H2V4H0v12h16V4H14z"
    }));
})).withConfig({
    displayName: "download__CollecticonDownload",
    componentId: "sc-1wcnsuh-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$d5822d1e3e781a7c = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "drop icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,13c2,0,4.497-1.5,4-4C11,9,6,13,8,13z M8,0c0,0-7,5-7,10c0,4,3.688,6,7,6s7-2,7-6C15,5,8,0,8,0z M12.606,11.687 c-0.244,0.456-0.6,0.866-1.062,1.209c-0.466,0.35-1.019,0.622-1.641,0.816C9.294,13.9,8.637,14,8,14s-1.294-0.1-1.903-0.288 c-0.622-0.191-1.175-0.466-1.641-0.816c-0.463-0.347-0.819-0.753-1.062-1.209C3.131,11.194,3,10.625,3,10 c0-0.788,0.278-1.684,0.825-2.669c0.494-0.891,1.2-1.831,2.094-2.794C6.659,3.741,7.406,3.056,8,2.553 c0.594,0.503,1.341,1.184,2.084,1.984c0.894,0.966,1.6,1.906,2.094,2.794C12.722,8.316,13,9.212,13,10 C13,10.625,12.866,11.194,12.606,11.687z"
    }));
})).withConfig({
    displayName: "drop__CollecticonDrop",
    componentId: "sc-x9gde6-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$74e5b01e82a6f5df = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "ellipsis horizontal icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M4,8c0-1.103-0.897-2-2-2S0,6.897,0,8s0.897,2,2,2S4,9.103,4,8z M6,8c0,1.103,0.897,2,2,2s2-0.897,2-2S9.103,6,8,6 S6,6.897,6,8z M12,8c0,1.103,0.897,2,2,2s2-0.897,2-2s-0.897-2-2-2S12,6.897,12,8z"
    }));
})).withConfig({
    displayName: "ellipsis-horizontal__CollecticonEllipsisHorizontal",
    componentId: "sc-1qnc74s-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$b307b75901e71920 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "ellipsis vertical icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,4c1.103,0,2-0.897,2-2S9.103,0,8,0S6,0.897,6,2S6.897,4,8,4z M8,6C6.897,6,6,6.897,6,8s0.897,2,2,2s2-0.897,2-2 S9.103,6,8,6z M8,12c-1.103,0-2,0.897-2,2s0.897,2,2,2s2-0.897,2-2S9.103,12,8,12z"
    }));
})).withConfig({
    displayName: "ellipsis-vertical__CollecticonEllipsisVertical",
    componentId: "sc-179rm06-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$8f179830d10593db = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "envelope icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,6v8h16V6l-8,5L0,6z M0,2v2l8,5l8-5V2H0z"
    }));
})).withConfig({
    displayName: "envelope__CollecticonEnvelope",
    componentId: "sc-yidx52-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$5af68724e0a1bf3d = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "equal small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M2,11h12V9H2V11z M2,5v2h12V5H2z"
    }));
})).withConfig({
    displayName: "equal--small__CollecticonEqualSmall",
    componentId: "sc-wsga5u-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$35a394b139d2779b = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "equal icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M1,11h14V9H1V11z M1,5v2h14V5H1z"
    }));
})).withConfig({
    displayName: "equal__CollecticonEqual",
    componentId: "sc-1fa0j72-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$d37d6805b1edaaab = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "exclamation small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M9,11C9,10.447 8.553,10 8,10C7.447,10 7,10.447 7,11C7,11.553 7.447,12 8,12C8.553,12 9,11.553 9,11ZM9,4L9,9L7,9L7,4L9,4Z"
    }));
})).withConfig({
    displayName: "exclamation--small__CollecticonExclamationSmall",
    componentId: "sc-8rmq3h-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$5edd362dbec83f16 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "expand collapse icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "expand-collapse",
        d: "M4.414,15.414L8,11.828L11.586,15.414L13,14L8,9L3,14L4.414,15.414ZM11.586,0.586L8,4.172L4.414,0.586L3,2L8,7L13,2L11.586,0.586Z"
    }));
})).withConfig({
    displayName: "expand-collapse__CollecticonExpandCollapse",
    componentId: "sc-12n4ycf-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$2a5f2ff1590ba9f0 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "expand down left icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M13,11H9v2h6V1H3v6h2V3h8V11z M0,8v8h8v-2H3.412l6.294-6.294L8.294,6.294L2,12.587V8H0z"
    }));
})).withConfig({
    displayName: "expand-down-left__CollecticonExpandDownLeft",
    componentId: "sc-1rjpycs-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$e4d1c1f093ddfc94 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "expand down right icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M3,3h8v4h2V1H1v12h6v-2H3V3z M14,8v4.587L7.706,6.294L6.294,7.706L12.587,14H8v2h8V8H14z"
    }));
})).withConfig({
    displayName: "expand-down-right__CollecticonExpandDownRight",
    componentId: "sc-10e6gt6-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$b96e2b4e5f7775c1 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "expand from left icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "expand-from-left",
        d: "M16,16L0,16L0,0L16,0L16,16ZM4,2L4,14L14,14L14,2L4,2ZM5.586,5.414L8.172,8L5.586,10.586L7,12L11,8L7,4L5.586,5.414Z"
    }));
})).withConfig({
    displayName: "expand-from-left__CollecticonExpandFromLeft",
    componentId: "sc-xntp9m-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$bfc74f0b8ad1f2ce = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "expand from right icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "expand-from-right",
        d: "M0,0L16,0L16,16L0,16L0,0ZM12,14L12,2L2,2L2,14L12,14ZM10.414,10.586L7.828,8L10.414,5.414L9,4L5,8L9,12L10.414,10.586Z"
    }));
})).withConfig({
    displayName: "expand-from-right__CollecticonExpandFromRight",
    componentId: "sc-8rny95-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$c5cb8522150f3be8 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "expand top left icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M13,13H5V9H3v6h12V3H9v2h4V13z M2,8V3.413l6.294,6.294l1.413-1.413L3.412,2H8V0L0,0l0,8H2z"
    }));
})).withConfig({
    displayName: "expand-top-left__CollecticonExpandTopLeft",
    componentId: "sc-1bzl97p-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$10a0ddbd1861a097 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "expand top right icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M3,5h4V3H1v12h12V9h-2v4H3V5z M16,8V0L8,0v2h4.587L6.294,8.294l1.413,1.413L14,3.413V8H16z"
    }));
})).withConfig({
    displayName: "expand-top-right__CollecticonExpandTopRight",
    componentId: "sc-1bjhv94-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$c52792559dd5fde = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "eye disabled icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M11.685,2.886L11.686,2.886L14.586,-0.014L16,1.4L13.345,4.055C15.264,5.792 16,8 16,8C16,8 14,14 8,14C6.537,14 5.312,13.643 4.296,13.104L1.4,16L-0.014,14.586L2.64,11.932L2.64,11.932L4.055,10.516L4.055,10.516L5.472,9.1L5.472,9.1L11.685,2.886ZM5.806,11.594C6.444,11.846 7.173,12 8,12C11.479,12 13.214,9.267 13.832,8C13.519,7.356 12.917,6.338 11.949,5.49C11.97,5.658 12,5.825 12,6C12,8.209 10.209,10 8,10C7.81,10 7.622,9.987 7.439,9.961L5.806,11.594ZM1.669,10.902C0.478,9.435 0,8 0,8C0,8 2,2 8,2C8.828,2 9.579,2.114 10.26,2.311L4.549,8.023C4.2,7.429 4,6.738 4,6C4,5.826 4.03,5.66 4.051,5.491C3.082,6.34 2.481,7.358 2.168,8C2.361,8.396 2.661,8.932 3.088,9.484L1.669,10.902Z"
    }));
})).withConfig({
    displayName: "eye-disabled__CollecticonEyeDisabled",
    componentId: "sc-4xvufx-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$5b296b74fc93300b = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "eye icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,2C2,2 0,8 0,8C0,8 2,14 8,14C14,14 16,8 16,8C16,8 14,2 8,2ZM8,12C4.519,12 2.787,9.272 2.168,8C2.481,7.358 3.082,6.34 4.051,5.491C4.03,5.66 4,5.826 4,6C4,8.209 5.791,10 8,10C10.209,10 12,8.209 12,6C12,5.825 11.97,5.658 11.949,5.49C12.917,6.338 13.519,7.356 13.832,8C13.214,9.267 11.479,12 8,12Z"
    }));
})).withConfig({
    displayName: "eye__CollecticonEye",
    componentId: "sc-1wfb5gr-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$baa7a52704f72315 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "face happy icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M5,7C5.553,7 6,6.553 6,6C6,5.447 5.553,5 5,5C4.447,5 4,5.447 4,6C4,6.553 4.447,7 5,7ZM8,10C7.263,10 6.616,9.597 6.269,9L4.125,9C4.569,10.725 6.134,12 8,12C9.863,12 11.431,10.725 11.875,9L9.731,9C9.384,9.597 8.738,10 8,10ZM8,0C3.581,0 0,3.581 0,8C0,12.419 3.581,16 8,16C12.419,16 16,12.419 16,8C16,3.581 12.419,0 8,0ZM12.244,12.244C11.109,13.375 9.603,14 8,14C6.397,14 4.891,13.375 3.756,12.244C2.625,11.109 2,9.603 2,8C2,6.397 2.625,4.891 3.756,3.756C4.891,2.625 6.397,2 8,2C9.603,2 11.109,2.625 12.244,3.756C13.375,4.891 14,6.397 14,8C14,9.603 13.375,11.109 12.244,12.244ZM11,5C10.447,5 10,5.447 10,6C10,6.553 10.447,7 11,7C11.553,7 12,6.553 12,6C12,5.447 11.553,5 11,5Z"
    }));
})).withConfig({
    displayName: "face-happy__CollecticonFaceHappy",
    componentId: "sc-1h06tny-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$3ca36d1b1b6880d8 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "face sad icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,8C6.134,8 4.569,9.275 4.125,11L6.269,11C6.616,10.403 7.263,10 8,10C8.738,10 9.384,10.403 9.731,11L11.875,11C11.431,9.275 9.863,8 8,8ZM5,7C5.553,7 6,6.553 6,6C6,5.447 5.553,5 5,5C4.447,5 4,5.447 4,6C4,6.553 4.447,7 5,7ZM8,0C3.581,0 0,3.581 0,8C0,12.419 3.581,16 8,16C12.419,16 16,12.419 16,8C16,3.581 12.419,0 8,0ZM12.244,12.244C11.109,13.375 9.603,14 8,14C6.397,14 4.891,13.375 3.756,12.244C2.625,11.109 2,9.603 2,8C2,6.397 2.625,4.891 3.756,3.756C4.891,2.625 6.397,2 8,2C9.603,2 11.109,2.625 12.244,3.756C13.375,4.891 14,6.397 14,8C14,9.603 13.375,11.109 12.244,12.244ZM11,5C10.447,5 10,5.447 10,6C10,6.553 10.447,7 11,7C11.553,7 12,6.553 12,6C12,5.447 11.553,5 11,5Z"
    }));
})).withConfig({
    displayName: "face-sad__CollecticonFaceSad",
    componentId: "sc-wspec2-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$d05ae46b0b12cd6f = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "factory icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,16h3V0H0V16z M10,8V4L4,8v8h6v-4h2v4h4V4L10,8z"
    }));
})).withConfig({
    displayName: "factory__CollecticonFactory",
    componentId: "sc-1to3481-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$ccb23f910e5c3193 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "fence icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14,0l-2,2v2h-2V2L8,0L6,2v2H4V2L2,0L0,2v14h4v-2h2v2h4v-2h2v2h4V2L14,0z M4,12V6h2v6H4z M10,12V6h2v6H10z"
    }));
})).withConfig({
    displayName: "fence__CollecticonFence",
    componentId: "sc-ndm71b-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$f153bd1599ddd890 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "filter icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M7,16L7,10L0,2L0,0L16,0L16,2L9,10L9,14L7,16Z"
    }));
})).withConfig({
    displayName: "filter__CollecticonFilter",
    componentId: "sc-eblqxv-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$9fcd2875a6bf0e38 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "flag pole icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M2.009,0H1.991C1.444,0,1,0.444,1,0.991V16h2V0.991C3,0.444,2.556,0,2.009,0z M16,1H4v8h12l-4-4L16,1z"
    }));
})).withConfig({
    displayName: "flag-pole__CollecticonFlagPole",
    componentId: "sc-13b70b-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$964c15ec9e30ae83 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "flame icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M9.65,4.05C9.8,4.2,9.95,4.35,10.1,4.5c0.9,0.95,1.6,1.9,2.1,2.8c0.55,1,0.85,1.9,0.85,2.65c0,0.6-0.15,1.2-0.4,1.7 c-0.25,0.45-0.6,0.85-1.05,1.2c-0.45,0.35-1,0.6-1.65,0.8C9.3,13.9,8.65,14,8,14s-1.3-0.1-1.9-0.3s-1.15-0.45-1.65-0.8 C4,12.55,3.65,12.15,3.4,11.7C3.15,11.2,3,10.65,3,10c0-0.6,0.2-1.3,0.65-2.1C3.75,7.7,3.85,7.5,4,7.3c0.8,0.65,1.55,0.8,2.05,0.8 C6.9,8.1,7.7,7.7,8.35,7c0.4-0.5,0.75-1.1,1-1.85C9.45,4.8,9.55,4.45,9.65,4.05 M8,0c0,3.9-0.85,6.1-1.95,6.1C5.45,6.1,4.7,5.45,4,4 c-1.65,1.85-3,4-3,6c0,4,3.7,6,7,6l0,0c3.3,0,7-2,7-6C15,5,8,0,8,0L8,0z"
    }));
})).withConfig({
    displayName: "flame__CollecticonFlame",
    componentId: "sc-fx7lds-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$22e733acfe1431e6 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "folder icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M7,1l2,2h7v11H0V1H7z"
    }));
})).withConfig({
    displayName: "folder__CollecticonFolder",
    componentId: "sc-1s4zkne-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$6c64be5e42deae66 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "gauge icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M8,14c-3.312,0-6-2.688-6-6s2.688-6,6-6s6,2.688,6,6 S11.312,14,8,14z M8.225,8.016L6.172,5.387l0.575,3.287C6.591,8.912,6.5,9.194,6.5,9.5C6.5,10.328,7.172,11,8,11s1.5-0.672,1.5-1.5 C9.5,8.75,8.947,8.125,8.225,8.016z M8,3C5.581,3,3.562,4.719,3.1,7h1.141C4.412,6.344,4.756,5.744,5.25,5.25 C5.984,4.516,6.963,4.113,8,4.113s2.016,0.403,2.75,1.137c0.494,0.494,0.837,1.094,1.009,1.75H12.9C12.438,4.719,10.419,3,8,3z"
    }));
})).withConfig({
    displayName: "gauge__CollecticonGauge",
    componentId: "sc-5yj9ve-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$476bfa1ddc2dfe7a = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "git fork icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M13,9v2h-2.488c-0.047-0.006-0.131-0.044-0.169-0.069L7.416,8l2.931-2.931C10.384,5.041,10.469,5.006,10.516,5H13v2l3-3 l-3-3v2h-2.5C9.962,3,9.319,3.266,8.941,3.647L6.584,6H0v4h6.584l2.353,2.353C9.319,12.734,9.959,13,10.497,13h2.5v2l3-3L13,9z"
    }));
})).withConfig({
    displayName: "git-fork__CollecticonGitFork",
    componentId: "sc-kkuh2n-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$922c85641f9f6751 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "globe icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,0C3.581,0,0,3.581,0,8s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M3.756,12.244C2.625,11.109,2,9.603,2,8 c0-0.569,0.078-1.122,0.231-1.653l0.506,1.334l2.819,2.225l0.469,0.106l-0.691,1.106l1.022,2.653 C5.384,13.497,4.494,12.978,3.756,12.244z M12.822,11.575c-0.175,0.234-0.369,0.459-0.578,0.669 c-1.084,1.084-2.512,1.703-4.041,1.753l1.678-1.325l0.216-1.131L5.856,9.569L5.594,9.112L5.25,8.875L5.072,8.091L4.491,8.328 l0.194-0.762l0.694-0.091l0.619,0.688L6.2,6.975l0.759-1.05l0.809-0.287L7.85,5.091L7.675,4.903l0.766-0.125l0.087-0.6L7.834,3.462 L7.241,3.541L6.506,3.175l-0.4,1.253L5.222,3.891l1.284-1.344L4.862,2.881c0.831-0.509,1.772-0.809,2.759-0.869L9.484,3.65 l0.684,0.184l0.144-0.528l0.703-0.491c0.441,0.256,0.85,0.572,1.219,0.941c0.184,0.184,0.356,0.381,0.516,0.584l-0.544,0.941 l-0.534,0.106l0.656,4.137l0.731,0.766L12.822,11.575z M12.859,6.191l0.247-0.331L13.387,6.2L12.859,6.191z"
    }));
})).withConfig({
    displayName: "globe__CollecticonGlobe",
    componentId: "sc-10oai70-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$384500bdee9cfb28 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "grip horizontal icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "grip-horizontal",
        d: "M3,7l-0,-2l-2,0l-0,2l2,0Zm-0,4l-0,-2l-2,0l-0,2l2,0Zm4,-4l-0,-2l-2,0l-0,2l2,0Zm-0,4l-0,-2l-2,0l-0,2l2,0Zm4,-4l-0,-2l-2,0l-0,2l2,0Zm0,4l0,-2l-2,0l0,2l2,0Zm4,-4l-0,-2l-2,0l-0,2l2,0Zm-0,4l-0,-2l-2,0l0,2l2,0Z"
    }));
})).withConfig({
    displayName: "grip-horizontal__CollecticonGripHorizontal",
    componentId: "sc-16u2dmc-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$686e909ad6dbb500 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "grip vertical icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "grip-vertical",
        d: "M7,13L5,13L5,15L7,15L7,13ZM11,13L9,13L9,15L11,15L11,13ZM7,9L5,9L5,11L7,11L7,9ZM11,9L9,9L9,11L11,11L11,9ZM7,5L5,5L5,7L7,7L7,5ZM11,5L9,5L9,7L11,7L11,5ZM7,1L5,1L5,3L7,3L7,1ZM11,1L9,1L9,3L11,3L11,1Z"
    }));
})).withConfig({
    displayName: "grip-vertical__CollecticonGripVertical",
    componentId: "sc-maqm4u-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$77134c21538c4a4c = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "hamburger menu icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M1,9h14V7H1V9z M1,14h14v-2H1V14z M1,2v2h14V2H1z"
    }));
})).withConfig({
    displayName: "hamburger-menu__CollecticonHamburgerMenu",
    componentId: "sc-179stu8-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$89331070f6fc9967 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "hand pan icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "hand-pan",
        d: "M8,8L8,1C8,0.448 8.448,0 9,0C9.552,0 10,0.448 10,1L10,8L11,8L11,2C11,1.448 11.448,1 12,1C12.552,1 13,1.448 13,2L13,8L14,8L14,5C14,4.448 14.448,4 15,4C15.552,4 16,4.448 16,5L16,9L16,9.001L16,14C16,14.53 15.789,15.039 15.414,15.414C15.039,15.789 14.53,16 14,16C11.883,16 8.628,16 7,16C6.37,16 5.778,15.704 5.4,15.2C3.88,13.174 0,8 0,8C0,8 0,8 0,8C0.574,7.426 1.482,7.362 2.131,7.848L5,10L5,3C5,2.448 5.448,2 6,2C6.552,2 7,2.448 7,3L7,8L8,8Z"
    }));
})).withConfig({
    displayName: "hand-pan__CollecticonHandPan",
    componentId: "sc-1o21t5t-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$90416b71b616b91 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "hand swipe horizontal icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "hand-swipe-horizontal",
        d: "M5,11L5,4.5C5,3.672 5.672,3 6.5,3C7.328,3 8,3.672 8,4.5L8,8L9.528,8C9.838,8 10.145,8.072 10.422,8.211C11.005,8.502 12.076,9.038 12.894,9.447C13.572,9.786 14,10.479 14,11.236C14,12.022 14,13.063 14,14C14,14.53 13.789,15.039 13.414,15.414C13.039,15.789 12.53,16 12,16L6.702,16C6.247,16 5.807,15.845 5.452,15.562C4.154,14.523 1,12 1,12C1,11.448 1.448,11 2,11L5,11ZM2,4.5C2,2.016 4.016,-0 6.5,-0C8.984,-0 11,2.016 11,4.5C11,4.5 9,4.5 9,4.5C9,3.12 7.88,2 6.5,2C5.12,2 4,3.12 4,4.5C4,4.5 2,4.5 2,4.5Z"
    }));
})).withConfig({
    displayName: "hand-swipe-horizontal__CollecticonHandSwipeHorizontal",
    componentId: "sc-15beqjt-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$84d82bc35f21d6b6 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "hand thumbs down icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M3,10L3,1L0,1L0,10L3,10ZM15,11C15.265,11 15.52,10.895 15.707,10.707C15.895,10.52 16,10.265 16,10C16,8.833 16,6.975 16,6.277C16,6.096 15.951,5.918 15.857,5.762C15.455,5.092 14.295,3.158 13.583,1.971C13.221,1.369 12.57,1 11.868,1C10.397,1 7.805,1 6,1C5.47,1 4.961,1.211 4.586,1.586C4.211,1.961 4,2.47 4,3C4,5.255 4,8.803 4,10.298C4,10.753 4.155,11.193 4.438,11.548C5.477,12.846 8,16 8,16C8,16 8,16 8,16C8.552,16 9,15.552 9,15L9,11L15,11Z"
    }));
})).withConfig({
    displayName: "hand-thumbs-down__CollecticonHandThumbsDown",
    componentId: "sc-1kyach0-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$ffd6616d7f2ec8c7 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "hand thumbs up icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M3,6L3,15L0,15L0,6L3,6ZM15,5C15.265,5 15.52,5.105 15.707,5.293C15.895,5.48 16,5.735 16,6C16,7.167 16,9.025 16,9.723C16,9.904 15.951,10.082 15.857,10.238C15.455,10.908 14.295,12.842 13.583,14.029C13.221,14.631 12.57,15 11.868,15C10.397,15 7.805,15 6,15C5.47,15 4.961,14.789 4.586,14.414C4.211,14.039 4,13.53 4,13C4,10.745 4,7.197 4,5.702C4,5.247 4.155,4.807 4.438,4.452C5.477,3.154 8,0 8,0C8,0 8,0 8,0C8.552,0 9,0.448 9,1L9,5L15,5Z"
    }));
})).withConfig({
    displayName: "hand-thumbs-up__CollecticonHandThumbsUp",
    componentId: "sc-ywkjmo-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$9551e39be92a9bc5 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "heading icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "heading",
        d: "M11,8l-6,0l0,-7l-2,0l0,14l2,0l0,-5l6,0l0,5l2,0l0,-14l-2,0l0,7Z"
    }));
})).withConfig({
    displayName: "heading__CollecticonHeading",
    componentId: "sc-1rw8j61-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$3094a1b9f32c68d5 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "heart icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M11.75,1C10.126,1,8.716,1.911,8,3.249C7.284,1.911,5.874,1,4.25,1C1.903,1,0,2.903,0,5.25C0,11,8,15,8,15s8-4,8-9.75 C16,2.903,14.097,1,11.75,1z"
    }));
})).withConfig({
    displayName: "heart__CollecticonHeart",
    componentId: "sc-18uyj45-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$62a58013efdd2c1a = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "house icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "0,6 0,16 6,16 6,10 10,10 10,16 16,16 16,6 8,0"
    }));
})).withConfig({
    displayName: "house__CollecticonHouse",
    componentId: "sc-1fgnmhh-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$72fd52d03f766e5d = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "houses icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,8v7h3v-4h3v4h6V8L6,3L0,8z M10,1L7.6,3L13,7.5V13h3V6L10,1z"
    }));
})).withConfig({
    displayName: "houses__CollecticonHouses",
    componentId: "sc-39h0d0-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$b7a766f44e29e48c = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "iso stack icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,9L0,5l8-4l8,4L8,9z M14.397,7.2L16,8l-8,4L0,8l1.603-0.8L8,10.397L14.397,7.2z M14.397,10.2L16,11l-8,4l-8-4l1.603-0.8 L8,13.397L14.397,10.2z"
    }));
})).withConfig({
    displayName: "iso-stack__CollecticonIsoStack",
    componentId: "sc-187l9aa-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$f6547b3d6e6e28f2 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "italic icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "italic",
        d: "M9.439,3l-5,10l-3.439,0l-0,2l9,0l0,-2l-3.439,0l5,-10l3.439,0l0,-2l-9,0l0,2l3.439,0Z"
    }));
})).withConfig({
    displayName: "italic__CollecticonItalic",
    componentId: "sc-ra4udc-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$bf1e1a02918ee573 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "keyboard icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M16,4c-0,-1.105 -0.895,-2 -2,-2c-3.074,0 -8.926,0 -12,0c-1.105,0 -2,0.895 -2,2c0,2.22 0,5.78 0,8c0,1.105 0.895,2 2,2c3.074,0 8.926,0 12,0c1.105,-0 2,-0.895 2,-2c0,-2.22 0,-5.78 0,-8Zm-4,6l0,2l-8,0l0,-2l8,0Zm-8,-3l0,2l-2,0l0,-2l2,0Zm3,0l0,2l-2,0l0,-2l2,0Zm3,0l0,2l-2,0l0,-2l2,0Zm4,0l0,2l-3,0l0,-2l3,0Zm-10,-3l0,2l-2,0l0,-2l2,0Zm3,0l0,2l-2,0l0,-2l2,0Zm3,0l0,2l-2,0l0,-2l2,0Zm4,0l0,2l-3,0l0,-2l3,0Z"
    }));
})).withConfig({
    displayName: "keyboard__CollecticonKeyboard",
    componentId: "sc-kehk32-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$658302eb55688f = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "layout column 2x icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,16L7,16L7,0L0,0L0,16ZM15,16L15,0L8,0L8,16L15,16Z"
    }));
})).withConfig({
    displayName: "layout-column-2x__CollecticonLayoutColumn2x",
    componentId: "sc-11ojdwa-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$f8afa6b34668155e = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "layout grid 2x2 icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M7,9L7,16L0,16L0,9L7,9ZM15,9L15,16L8,16L8,9L15,9ZM7,1L7,8L0,8L0,1L7,1ZM15,1L15,8L8,8L8,1L15,1Z"
    }));
})).withConfig({
    displayName: "layout-grid-2x2__CollecticonLayoutGrid2x2",
    componentId: "sc-14yggc1-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$9da84757d72aaa95 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "layout grid 3x3 icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M1,1h4v4H1V1z M6,1h4v4H6V1z M11,1h4v4h-4V1z M1,6h4v4H1V6z M6,6h4v4H6V6z M11,6h4v4h-4V6z M1,11h4v4H1V11z M6,11h4v4H6V11z M11,11h4v4h-4V11z"
    }));
})).withConfig({
    displayName: "layout-grid-3x3__CollecticonLayoutGrid3x3",
    componentId: "sc-1j22hjj-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$c41918702c92a94 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "layout row 2x icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,0L0,7L16,7L16,0L0,0ZM0,15L16,15L16,8L0,8L0,15Z"
    }));
})).withConfig({
    displayName: "layout-row-2x__CollecticonLayoutRow2x",
    componentId: "sc-uoth1p-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$b64d86384c92f1e0 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "leaf icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,0C4.134,0,1,3.134,1,7v9h2v-4c0-3.866,3.134-7,7-7h2c-3.866,0-7,3.134-7,7v2h3c3.866,0,7-3.134,7-7V0H8z"
    }));
})).withConfig({
    displayName: "leaf__CollecticonLeaf",
    componentId: "sc-1mdo8m2-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$c1c6fe15475bbb7e = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "link icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M6.794,12.794C6.316,13.269,5.681,13.531,5,13.531s-1.316-0.262-1.794-0.738c-0.987-0.988-0.987-2.597,0-3.584L5.5,6.916 L4.084,5.5L1.791,7.794c-1.766,1.769-1.766,4.644,0.003,6.413C2.647,15.062,3.784,15.531,5,15.531s2.353-0.469,3.206-1.325 l2.294-2.294L9.084,10.5L6.794,12.794z M14.206,1.794C13.353,0.938,12.216,0.469,11,0.469S8.647,0.938,7.794,1.794L5.5,4.084 L6.916,5.5l2.294-2.294C9.684,2.731,10.319,2.469,11,2.469s1.316,0.263,1.794,0.737c0.988,0.987,0.988,2.597,0,3.584L10.5,9.084 l1.416,1.416l2.294-2.294C15.975,6.438,15.975,3.562,14.206,1.794z M11.706,5.706l-1.416-1.416l-6,6l1.416,1.416L11.706,5.706z"
    }));
})).withConfig({
    displayName: "link__CollecticonLink",
    componentId: "sc-w4hhqn-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$8eec6b150ddf7426 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "list numbered icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "list-numbered",
        d: "M0,10l0,-1l2,0c0.552,0 1,0.448 1,1l0,1c-0,0.552 -0.448,1 -1,1l-0.75,0c-0.066,-0 -0.13,0.026 -0.177,0.073c-0.047,0.047 -0.073,0.111 -0.073,0.177c0,0.153 0,0.347 0,0.5c-0,0.066 0.026,0.13 0.073,0.177c0.047,0.047 0.111,0.073 0.177,0.073l1.75,0l0,1l-2,0c-0.552,-0 -1,-0.448 -1,-1l0,-1c0,-0.552 0.448,-1 1,-1l0.75,-0c0.066,0 0.13,-0.026 0.177,-0.073c0.047,-0.047 0.073,-0.111 0.073,-0.177c0,-0.153 0,-0.347 0,-0.5c0,-0.066 -0.026,-0.13 -0.073,-0.177c-0.047,-0.047 -0.111,-0.073 -0.177,-0.073l-1.75,0Zm4,1l12,0l0,2l-12,0l0,-2Zm0,-4l12,0l0,2l-12,0l0,-2Zm-3,-3.75c0,-0.066 -0.026,-0.13 -0.073,-0.177c-0.047,-0.047 -0.111,-0.073 -0.177,-0.073l-0.75,0l0,-1l1,0c0.552,0 1,0.448 1,1c-0,1.185 0,4 0,4l-1,0l0,-3.75Zm3,-0.25l12,0l0,2l-12,0l0,-2Z"
    }));
})).withConfig({
    displayName: "list-numbered__CollecticonListNumbered",
    componentId: "sc-1y4r290-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$8e6bd23949fc26d0 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "list icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M4,3v2h12V3H4z M0,5h2V3H0V5z M4,9h12V7H4V9z M0,9h2V7H0V9z M4,13h12v-2H4V13z M0,13h2v-2H0V13z"
    }));
})).withConfig({
    displayName: "list__CollecticonList",
    componentId: "sc-33nw9x-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$70cca5edf1a67180 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "lock 2 open icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M12.25,7H12V4c0-1.653-1.347-3-3-3H7C5.347,1,4,2.347,4,4v1h2V4c0-0.55,0.45-1,1-1h2c0.55,0,1,0.45,1,1v3H3.75 C3.338,7,3,7.338,3,7.75v6.5C3,14.662,3.338,15,3.75,15h8.5c0.412,0,0.75-0.338,0.75-0.75v-6.5C13,7.338,12.662,7,12.25,7z"
    }));
})).withConfig({
    displayName: "lock-2-open__CollecticonLock2Open",
    componentId: "sc-zzwhkx-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$d5b6665210f0a539 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "lock 2 icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M12.25,7H12V4c0-1.653-1.347-3-3-3H7C5.347,1,4,2.347,4,4v3H3.75C3.338,7,3,7.338,3,7.75v6.5C3,14.663,3.338,15,3.75,15h8.5 c0.413,0,0.75-0.337,0.75-0.75v-6.5C13,7.338,12.663,7,12.25,7z M6,4c0-0.55,0.45-1,1-1h2c0.55,0,1,0.45,1,1v3H6V4z"
    }));
})).withConfig({
    displayName: "lock-2__CollecticonLock2",
    componentId: "sc-1pa8bjy-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$247536f07b7c3b83 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "lock open icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14,7h-1V4c0-2.206-1.794-4-4-4H7C4.794,0,3,1.794,3,4h2c0-1.103,0.897-2,2-2h2c1.103,0,2,0.897,2,2v3H8H2 C1.45,7,1,7.45,1,8v7c0,0.55,0.45,1,1,1h12c0.55,0,1-0.45,1-1V8C15,7.45,14.55,7,14,7z M9,12.731V13.5c0,0.55-0.45,1-1,1 s-1-0.45-1-1v-0.769C6.403,12.384,6,11.741,6,11c0-1.103,0.897-2,2-2s2,0.897,2,2C10,11.741,9.597,12.384,9,12.731z"
    }));
})).withConfig({
    displayName: "lock-open__CollecticonLockOpen",
    componentId: "sc-xf9pgz-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$5c8bd75215c9ed1f = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "lock icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14,7h-1V4c0-2.206-1.794-4-4-4H7C4.794,0,3,1.794,3,4v3H2C1.45,7,1,7.45,1,8v7c0,0.55,0.45,1,1,1h12c0.55,0,1-0.45,1-1V8 C15,7.45,14.55,7,14,7z M9,12.731V13.5c0,0.55-0.45,1-1,1s-1-0.45-1-1v-0.769C6.403,12.384,6,11.741,6,11c0-1.103,0.897-2,2-2 s2,0.897,2,2C10,11.741,9.597,12.384,9,12.731z M5,7V4c0-1.103,0.897-2,2-2h2c1.103,0,2,0.897,2,2v3H5z"
    }));
})).withConfig({
    displayName: "lock__CollecticonLock",
    componentId: "sc-o95j22-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$1692611780ac32d = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "login icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14,14l0,-12l-6,0l0,-2l8,0l0,16l-8,0l0,-2l6,0Zm-6.998,-0.998l4.998,-5.002l-5,-5l-1.416,1.416l2.588,2.584l-8.172,0l0,2l8.172,0l-2.586,2.586l1.416,1.416Z"
    }));
})).withConfig({
    displayName: "login__CollecticonLogin",
    componentId: "sc-1y1wjb9-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$2d4c748bd12d78e0 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "logout icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14,14l0,-12l-6,0l0,-2l8,0l0,16l-8,0l0,-2l6,0Zm-9.002,-0.998l-4.998,-5.002l5,-5l1.416,1.416l-2.588,2.584l8.172,0l0,2l-8.172,0l2.586,2.586l-1.416,1.416Z"
    }));
})).withConfig({
    displayName: "logout__CollecticonLogout",
    componentId: "sc-1iqecrb-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$b2a4ca5137e627ff = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "magnifier left icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M15.708,13.587l-3.675-3.675C12.646,8.92,13,7.751,13,6.5C13,2.91,10.09,0,6.5,0S0,2.91,0,6.5S2.91,13,6.5,13 c1.251,0,2.42-0.354,3.412-0.967l3.675,3.675c0.389,0.389,1.025,0.389,1.414,0l0.707-0.707 C16.097,14.612,16.097,13.976,15.708,13.587z M3.318,9.682C2.468,8.832,2,7.702,2,6.5s0.468-2.332,1.318-3.182S5.298,2,6.5,2 s2.332,0.468,3.182,1.318C10.532,4.168,11,5.298,11,6.5s-0.468,2.332-1.318,3.182C8.832,10.532,7.702,11,6.5,11 S4.168,10.532,3.318,9.682z"
    }));
})).withConfig({
    displayName: "magnifier-left__CollecticonMagnifierLeft",
    componentId: "sc-16fyszn-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$89ad07d969809ef0 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "magnifier right icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0.292,15.001l0.707,0.707c0.389,0.389,1.025,0.389,1.414,0l3.675-3.675C7.08,12.646,8.249,13,9.5,13 c3.59,0,6.5-2.91,6.5-6.5S13.09,0,9.5,0S3,2.91,3,6.5c0,1.251,0.354,2.42,0.967,3.412l-3.675,3.675 C-0.097,13.976-0.097,14.612,0.292,15.001z M9.5,11c-1.202,0-2.332-0.468-3.182-1.318C5.468,8.832,5,7.702,5,6.5 s0.468-2.332,1.318-3.182S8.298,2,9.5,2s2.332,0.468,3.182,1.318C13.532,4.168,14,5.298,14,6.5s-0.468,2.332-1.318,3.182 C11.832,10.532,10.702,11,9.5,11z"
    }));
})).withConfig({
    displayName: "magnifier-right__CollecticonMagnifierRight",
    componentId: "sc-mpkmvd-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$a85a53f46ea5d4e1 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "map icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,3l5-2v12l-5,2V3z M11,3v12l-5-1.667v-12L11,3z M16,1v12l-4,1.6v-12L16,1z"
    }));
})).withConfig({
    displayName: "map__CollecticonMap",
    componentId: "sc-zq8trt-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$ddb0bcf29e4fc4bb = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "marker icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z"
    }));
})).withConfig({
    displayName: "marker__CollecticonMarker",
    componentId: "sc-9444h2-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$448b293f3d913b8a = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "minus small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "14,7 2,7 2,9 14,9"
    }));
})).withConfig({
    displayName: "minus--small__CollecticonMinusSmall",
    componentId: "sc-idjajx-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$8b95d566fbd56482 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "minus icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "15,7 1,7 1,9 15,9"
    }));
})).withConfig({
    displayName: "minus__CollecticonMinus",
    componentId: "sc-1dxv3e5-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$40baeeb0bb7c9f71 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "mobile phone icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M11.5,0h-7C3.675,0,3,0.675,3,1.5v13C3,15.325,3.675,16,4.5,16h7c0.825,0,1.5-0.675,1.5-1.5v-13C13,0.675,12.325,0,11.5,0z M8,15c-0.553,0-1-0.447-1-1s0.447-1,1-1s1,0.447,1,1S8.553,15,8,15z M12,12H4V2h8V12z"
    }));
})).withConfig({
    displayName: "mobile-phone__CollecticonMobilePhone",
    componentId: "sc-lfadc0-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$d7458318da00be20 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "options tick icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M16,5l-11.012,0l0,9l11.012,0l0,1.988l-13,0l0,-12.976l13,0l0,1.988Zm-16,-4.988l14,0l0,1.988l-12.012,0l0,12l-1.988,0l0,-12l0,-1.988Zm8.2,8.36l-1.406,1.422l3.243,3.206l5.169,-5.747l-1.484,-1.338l-3.769,4.187l-1.753,-1.73Z"
    }));
})).withConfig({
    displayName: "options-tick__CollecticonOptionsTick",
    componentId: "sc-1rof8rz-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$c5e5312dcf5a204f = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "page cog icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14.706,4.206l-3.912-3.912C10.606,0.106,10.353,0,10.088,0H1v7h2V2h7v3h3v9H9v2h6V4.916C15,4.65,14.894,4.394,14.706,4.206 z M7.592,12.385L9,12.15v-1.288l-1.408-0.231c-0.069-0.25-0.166-0.482-0.288-0.697L8.137,8.77l-0.91-0.91L6.066,8.692 C5.847,8.573,5.618,8.473,5.377,8.407L5.146,7H3.857L3.626,8.407C3.382,8.473,3.15,8.573,2.934,8.692L1.771,7.86L0.86,8.77 l0.832,1.163c-0.119,0.219-0.219,0.447-0.285,0.691L0,10.856v1.288l1.408,0.231c0.066,0.244,0.166,0.475,0.285,0.691L0.86,14.23 l0.91,0.91l1.164-0.832c0.219,0.119,0.447,0.219,0.691,0.285L3.857,16h1.289l0.231-1.407c0.244-0.066,0.476-0.166,0.688-0.285 l1.164,0.832l0.91-0.91l-0.829-1.154C7.426,12.857,7.527,12.629,7.592,12.385z M4.492,12.788c-0.71,0-1.289-0.579-1.289-1.288 s0.579-1.288,1.289-1.288c0.71,0,1.289,0.575,1.289,1.288S5.202,12.788,4.492,12.788z"
    }));
})).withConfig({
    displayName: "page-cog__CollecticonPageCog",
    componentId: "sc-ne538-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$4de7d3a780aa7d4b = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "page label icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14.706,4.206l-3.912-3.912C10.606,0.106,10.353,0,10.088,0H1v8H0v4h10V8H3V2h7v3h3v9H3v-1H1v3h14V4.916 C15,4.65,14.894,4.394,14.706,4.206z"
    }));
})).withConfig({
    displayName: "page-label__CollecticonPageLabel",
    componentId: "sc-ihkl7a-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$37ce21e1ba043044 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "page lock open icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14.706,4.206l-3.913-3.913C10.606,0.106,10.353,0,10.087,0H1v9h2V2h7v3h3v9H9v2h6V4.916C15,4.65,14.894,4.394,14.706,4.206 z M9,10h2V9c0-1.653-1.347-3-3-3S5,7.347,5,9v1H0.991C0.447,10,0,10.447,0,10.991v4.019C0,15.553,0.447,16,0.991,16h6.019 C7.553,16,8,15.553,8,15.009v-4.019C8,10.447,7.553,10,7.009,10H7V9c0-0.55,0.45-1,1-1s1,0.45,1,1V10z M4,14c-0.553,0-1-0.447-1-1 s0.447-1,1-1s1,0.447,1,1S4.553,14,4,14z"
    }));
})).withConfig({
    displayName: "page-lock-open__CollecticonPageLockOpen",
    componentId: "sc-9vft70-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$4a8a225852a3176 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "page tick icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14.706,4.206l-3.913-3.913C10.606,0.106,10.353,0,10.087,0H1v16h14V4.916C15,4.65,14.894,4.394,14.706,4.206z M13,14H3V2h7 v3h3V14z M5.2,8.372L3.794,9.794L7.037,13l5.169-5.747l-1.484-1.338l-3.769,4.187L5.2,8.372z"
    }));
})).withConfig({
    displayName: "page-tick__CollecticonPageTick",
    componentId: "sc-19po8ir-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$63c83462b6ec5fb6 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "page up icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14.706,4.206c0.188,0.188 0.294,0.444 0.294,0.71l0,11.084l-14,0l0,-16l9.087,0c0.266,0 0.519,0.106 0.706,0.293l3.913,3.913Zm-1.706,9.794l0,-9l-3,0l0,-3l-7,0l0,12l10,0Zm-7.586,-3.586l-1.414,-1.414l4,-4l4,4l-1.414,1.414l-1.586,-1.586l0,4.172l-2,0l0,-4.172l-1.586,1.586Z"
    }));
})).withConfig({
    displayName: "page-up__CollecticonPageUp",
    componentId: "sc-gbkx4m-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$c04e66d9f370f139 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "page icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14.706,4.206l-3.913-3.913C10.606,0.106,10.353,0,10.087,0H1v16h14V4.916C15,4.65,14.894,4.394,14.706,4.206z M13,14H3V2h7 v3h3V14z"
    }));
})).withConfig({
    displayName: "page__CollecticonPage",
    componentId: "sc-k2xb9e-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$509fad11b885abb0 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "pages icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M3,3H1v13h11v-2H3V3z M12,0H4v13h11V3L12,0z M13,11H6V2h5v2h2V11z"
    }));
})).withConfig({
    displayName: "pages__CollecticonPages",
    componentId: "sc-1td2367-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$b8f31e9a5cf17074 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "pencil icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M1,11v4h4l7-7L8,4L1,11z M11,1L9,3l4,4l2-2L11,1z"
    }));
})).withConfig({
    displayName: "pencil__CollecticonPencil",
    componentId: "sc-1kh2dl6-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$20df3a4d38f4449c = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "pi icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "pi",
        d: "M4,4L6,4L6,14L4,14L4,4ZM14,14L12,14C11.47,14 10.961,13.789 10.586,13.414C10.211,13.039 10,12.53 10,12C10,9.082 10,4 10,4L12,4C12,4 12,9.749 12,11.5C12,11.633 12.053,11.76 12.146,11.854C12.24,11.947 12.367,12 12.5,12C13.092,12 14,12 14,12L14,14ZM2,2L14,2L14,4L2,4L2,2Z"
    }));
})).withConfig({
    displayName: "pi__CollecticonPi",
    componentId: "sc-wten9m-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$c273953023f3b0d9 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "picture icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M11.5,7C12.328,7,13,6.328,13,5.5S12.328,4,11.5,4S10,4.672,10,5.5S10.672,7,11.5,7z M13,8l-4,2L6,5l-3,6v1h10V8z M0,1v14 h16V1H0z M14,13H2V3h12V13z"
    }));
})).withConfig({
    displayName: "picture__CollecticonPicture",
    componentId: "sc-23cpjo-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$1f35cd9a970948ef = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "pilcrow icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,14L6,14L6,10C3.792,10 2,8.208 2,6C2,3.823 3.742,2.051 6,2L14,2L14,4L12,4L12,14L10,14L10,4L8,4L8,14Z"
    }));
})).withConfig({
    displayName: "pilcrow__CollecticonPilcrow",
    componentId: "sc-1b83p3i-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$3a9f56a1d1f9a714 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "plus small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "14,7 9,7 9,2 7,2 7,7 2,7 2,9 7,9 7,14 9,14 9,9 14,9"
    }));
})).withConfig({
    displayName: "plus--small__CollecticonPlusSmall",
    componentId: "sc-1fqmt3p-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$889d6f1a30ea74d6 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "plus icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "15,7 9,7 9,1 7,1 7,7 1,7 1,9 7,9 7,15 9,15 9,9 15,9"
    }));
})).withConfig({
    displayName: "plus__CollecticonPlus",
    componentId: "sc-1fkp87s-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$37ff0821c075ffdb = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "pop down icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M2,14h10V5H2V14z M4,7h6v5H4V7z M5,2v2h8v7h2V2H5z"
    }));
})).withConfig({
    displayName: "pop-down__CollecticonPopDown",
    componentId: "sc-1unqzj7-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$f4bc043c492a6c31 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "pop up icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M4,2v9h10V2H4z M12,9H6V4h6V9z M3,5H1v9h10v-2H3V5z"
    }));
})).withConfig({
    displayName: "pop-up__CollecticonPopUp",
    componentId: "sc-1l36dux-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$cabb19bc45ece1c2 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "printer icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M13,1H3v2h10V1z M15,4H1C0.45,4,0,4.45,0,5v5c0,0.55,0.45,1,1,1h2v4h10v-4h2c0.55,0,1-0.45,1-1V5C16,4.45,15.55,4,15,4z M11,13H5V9h6V13z M14,7c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S14.552,7,14,7z"
    }));
})).withConfig({
    displayName: "printer__CollecticonPrinter",
    componentId: "sc-1t5531d-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$cc12b47c9c533761 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "quote left icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M16,3V1c-4.188,0-7,2.812-7,7v7h7V8h-5C11,4.916,12.916,3,16,3z M0,8v7h7V8H2c0-3.084,1.916-5,5-5V1C2.812,1,0,3.812,0,8z"
    }));
})).withConfig({
    displayName: "quote-left__CollecticonQuoteLeft",
    componentId: "sc-4aykvt-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$31a206cffc6bcef8 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "quote right icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,8h5c0,3.084-1.916,5-5,5v2c4.188,0,7-2.812,7-7V1H0V8z M9,1v7h5c0,3.084-1.916,5-5,5v2c4.188,0,7-2.812,7-7V1H9z"
    }));
})).withConfig({
    displayName: "quote-right__CollecticonQuoteRight",
    componentId: "sc-16q59gl-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$8aa06688994ea65a = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "resize center horizontal icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M6.999,16h2.002V0H6.999V16z M5.414,5.414L4,4L0,8l4,4l1.414-1.414L3.828,9H6V7H3.828L5.414,5.414z M12,4l-1.414,1.414 L12.172,7H10v2h2.172l-1.586,1.586L12,12l4-4L12,4z"
    }));
})).withConfig({
    displayName: "resize-center-horizontal__CollecticonResizeCenterHorizontal",
    componentId: "sc-1uhrfmw-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$ce07c1505fc240fa = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "resize center vertical icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,6.999v2.002h16V6.999H0z M7,3.828V6h2V3.828l1.586,1.586L12,4L8,0L4,4l1.414,1.414L7,3.828z M9,12.172V10H7v2.172 l-1.586-1.586L4,12l4,4l4-4l-1.414-1.414L9,12.172z"
    }));
})).withConfig({
    displayName: "resize-center-vertical__CollecticonResizeCenterVertical",
    componentId: "sc-17ttas-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$4ec862b3067b2249 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "resize in icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M2,8L8,8L8,14L6,14L6,11.4L1.4,16L-0.014,14.586L4.572,10L2,10L2,8ZM8,2L10,2L10,4.6L14.6,0L16.014,1.414L11.428,6L14,6L14,8L8,8L8,2Z"
    }));
})).withConfig({
    displayName: "resize-in__CollecticonResizeIn",
    componentId: "sc-yqh48y-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$3c2cb1e70bb7ddf8 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "resize out icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M1.986,12.6L6.586,8L8,9.414L3.414,14L5.986,14L5.986,16L1.986,16L-0.014,16L-0.014,10L1.986,10L1.986,12.6ZM12.586,2L10.014,2L10.014,0L16.014,0L16.014,6L14.014,6L14.014,3.4L9.414,8L8,6.586L12.586,2Z"
    }));
})).withConfig({
    displayName: "resize-out__CollecticonResizeOut",
    componentId: "sc-14snpdr-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$62497cdf6d0d1934 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "road icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M16,16L13,0H9v1H7V0H3L0,16h7v-4h2v4H16z M7,3h2v2H7V3z M7,10V7h2v3H7z"
    }));
})).withConfig({
    displayName: "road__CollecticonRoad",
    componentId: "sc-kxef51-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$a7789793f3c2c8cc = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "rock icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M6.516,2.612L9.325,3.55l0.734,2.934l0.188,0.75l0.644,0.428l2.238,1.494L13.734,14H2.441l0.331-1.65l1.125-0.562 l0.875-0.438l0.191-0.959L6.516,2.612 M5,0L3,10l-2,1l-1,5h16l-1-8l-3-2l-1-4L5,0L5,0z"
    }));
})).withConfig({
    displayName: "rock__CollecticonRock",
    componentId: "sc-1m4dfhv-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$67a54af4fd4d9a2e = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "rss feed icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M1,5v2c1.081,0,2.128,0.211,3.113,0.628c0.952,0.403,1.808,0.98,2.543,1.715s1.312,1.591,1.715,2.543 C8.789,12.872,9,13.919,9,15h2C11,9.477,6.523,5,1,5z M4,10c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S5.105,10,4,10z M1,1v2 c1.621,0,3.192,0.317,4.67,0.942c1.429,0.604,2.712,1.47,3.815,2.573c1.103,1.103,1.968,2.386,2.573,3.815 C12.683,11.808,13,13.379,13,15h2C15,7.268,8.732,1,1,1z"
    }));
})).withConfig({
    displayName: "rss-feed__CollecticonRssFeed",
    componentId: "sc-krf4ws-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$611ca684c7a93fe1 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "share 2 icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M13.5,11c-0.609,0-1.169,0.219-1.603,0.581l-6.9-3.45C5,8.088,5,8.044,5,8c0-0.044,0-0.088-0.003-0.131l6.9-3.45 C12.331,4.781,12.891,5,13.5,5C14.881,5,16,3.881,16,2.5S14.881,0,13.5,0S11,1.119,11,2.5c0,0.044,0,0.088,0.003,0.131l-6.9,3.45 C3.669,5.719,3.109,5.5,2.5,5.5C1.119,5.5,0,6.619,0,8s1.119,2.5,2.5,2.5c0.609,0,1.169-0.219,1.603-0.581l6.9,3.45 C11,13.412,11,13.456,11,13.5c0,1.381,1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5S14.881,11,13.5,11z"
    }));
})).withConfig({
    displayName: "share-2__CollecticonShare2",
    componentId: "sc-2o6k8j-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$7cffb2c8835f2a25 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "share icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M10,6v2h3v6H3V8h3V6H1v10h14V6H10z M7,3.328V11h2V3.328l1.834,1.834L12,4L8,0L4,4l1.166,1.166L7,3.328z"
    }));
})).withConfig({
    displayName: "share__CollecticonShare",
    componentId: "sc-ob5ay5-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$72c7f3691d5e45db = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "shrink to left icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "shrink-to-left",
        d: "M16,16L0,16L0,0L16,0L16,16ZM4,2L4,14L14,14L14,2L4,2ZM10.414,10.586L7.828,8L10.414,5.414L9,4L5,8L9,12L10.414,10.586Z"
    }));
})).withConfig({
    displayName: "shrink-to-left__CollecticonShrinkToLeft",
    componentId: "sc-tcmzh2-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$d11c632cbde2be34 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "shrink to right icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "shrink-to-right",
        d: "M0,0L16,0L16,16L0,16L0,0ZM12,14L12,2L2,2L2,14L12,14ZM5.586,5.414L8.172,8L5.586,10.586L7,12L11,8L7,4L5.586,5.414Z"
    }));
})).withConfig({
    displayName: "shrink-to-right__CollecticonShrinkToRight",
    componentId: "sc-1fxnoaq-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$3b59d4afb984fe49 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "sign danger icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M15.006,12.262L8.994,1.737c-0.547-0.956-1.438-0.956-1.984,0L0.994,12.262C0.447,13.219,0.9,14,2,14h12 C15.1,14,15.553,13.219,15.006,12.262z M8,13c-0.691,0-1.25-0.559-1.25-1.25c0-0.691,0.559-1.25,1.25-1.25 c0.691,0,1.25,0.559,1.25,1.25C9.25,12.441,8.691,13,8,13z M9,10H7V5h2V10z"
    }));
})).withConfig({
    displayName: "sign-danger__CollecticonSignDanger",
    componentId: "sc-1ecz7b4-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$1ff70e20de9defba = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "sliders horizontal icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M4,12H0v2h4v1h3v-4H4V12z M9,10h3V6H9v1H0v2h9V10z M3,5h3V1H3v1H0v2h3V5z M8,14h8v-2H8V14z M7,2v2h9V2H7z M13,9h3V7h-3V9z"
    }));
})).withConfig({
    displayName: "sliders-horizontal__CollecticonSlidersHorizontal",
    componentId: "sc-11z3834-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$5363c08acc839f14 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "sliders vertical icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M12,12v4h2v-4h1V9h-4v3H12z M10,7V4H6v3h1v9h2V7H10z M5,13v-3H1v3h1v3h2v-3H5z M14,8V0h-2v8H14z M2,9h2V0H2V9z M9,3V0H7v3H9z"
    }));
})).withConfig({
    displayName: "sliders-vertical__CollecticonSlidersVertical",
    componentId: "sc-12f45x9-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$7306271c30123976 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "sort asc icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("g", {
        id: "sort-asc"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "arrow-down",
        d: "M8.002,11.5l-3.294,-2.622l-1.416,1.416l4.71,3.706l4.706,-3.706l-1.416,-1.416l-3.29,2.622Z",
        opacity: "0.32"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "arrow-up",
        d: "M7.998,4.5l3.294,2.622l1.416,-1.416l-4.71,-3.706l-4.706,3.706l1.416,1.416l3.29,-2.622Z"
    })));
})).withConfig({
    displayName: "sort-asc__CollecticonSortAsc",
    componentId: "sc-1swvzh4-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$d51a5d41a86d4b55 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "sort desc icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("g", {
        id: "sort-desc"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "arrow-down",
        d: "M8.002,11.5l-3.294,-2.622l-1.416,1.416l4.71,3.706l4.706,-3.706l-1.416,-1.416l-3.29,2.622Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "arrow-up",
        d: "M7.998,4.5l3.294,2.622l1.416,-1.416l-4.71,-3.706l-4.706,3.706l1.416,1.416l3.29,-2.622Z",
        opacity: "0.32"
    })));
})).withConfig({
    displayName: "sort-desc__CollecticonSortDesc",
    componentId: "sc-1g5jihn-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$24bdafc250bc28ef = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "sort none icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        opacity: "0.32",
        d: "M8,11.5L4.706,8.878l-1.416,1.416L8,14l4.706-3.706l-1.416-1.416L8,11.5z M8,4.5l3.294,2.622l1.416-1.416L8,2L3.294,5.706 l1.416,1.416L8,4.5z"
    }));
})).withConfig({
    displayName: "sort-none__CollecticonSortNone",
    componentId: "sc-u7zsfg-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$ee66e65f9bacd0b7 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "sort icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,11.5L4.706,8.878l-1.416,1.416L8,14l4.706-3.706l-1.416-1.416L8,11.5z M8,4.5l3.294,2.622l1.416-1.416L8,2L3.294,5.706 l1.416,1.416L8,4.5z"
    }));
})).withConfig({
    displayName: "sort__CollecticonSort",
    componentId: "sc-dgizvs-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$f0833711cb9f68ce = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "spark icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M10,1L3,9h4.5L6,15l7-8H8.5L10,1z"
    }));
})).withConfig({
    displayName: "spark__CollecticonSpark",
    componentId: "sc-bhnjlj-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$154cb3948df3efa1 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "speech balloon icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M4,13L2,13C1.47,13 0.961,12.789 0.586,12.414C0.211,12.039 0,11.53 0,11C0,9.257 0,6.743 0,5C0,4.47 0.211,3.961 0.586,3.586C0.961,3.211 1.47,3 2,3C5.074,3 10.926,3 14,3C14.53,3 15.039,3.211 15.414,3.586C15.789,3.961 16,4.47 16,5C16,6.743 16,9.257 16,11C16,11.53 15.789,12.039 15.414,12.414C15.039,12.789 14.53,13 14,13L8,13L4,16L4,13Z"
    }));
})).withConfig({
    displayName: "speech-balloon__CollecticonSpeechBalloon",
    componentId: "sc-13d2rgy-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$b347ffcee0e953cc = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "square small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("rect", {
        x: "4",
        y: "4",
        width: "8",
        height: "8"
    }));
})).withConfig({
    displayName: "square--small__CollecticonSquareSmall",
    componentId: "sc-tacoml-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$ade582b79af72d78 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "square icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("rect", {
        x: "2",
        y: "2",
        width: "12",
        height: "12"
    }));
})).withConfig({
    displayName: "square__CollecticonSquare",
    componentId: "sc-f9q5rr-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$75f6b5de4cbd2386 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "star icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M16,6.204l-5.528-0.803L8,0.392L5.528,5.401L0,6.204l4,3.899l-0.944,5.505L8,13.009l4.944,2.599L12,10.103L16,6.204z"
    }));
})).withConfig({
    displayName: "star__CollecticonStar",
    componentId: "sc-1y1tcee-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$2bdb2cf27f0a265 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "steam icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M7,16h2v-6H7V16z M12.603,3.044C11.844,1.256,10.069,0,8,0C5.238,0,3,2.237,3,5C1.344,5,0,6.344,0,8s1.344,3,3,3h0.284L4,15 h2L5,9H3C2.45,9,2,8.55,2,8s0.45-1,1-1h2V5c0-1.653,1.347-3,3-3c1.206,0,2.291,0.719,2.762,1.828L11.2,4.856l1.103,0.166 c0.466,0.072,0.897,0.306,1.209,0.669C13.734,5.947,14,6.381,14,7c0,1.103-0.897,2-2,2h-1l-1,6h2l0.725-4.066 C14.587,10.594,16,8.962,16,7C16,4.997,14.525,3.338,12.603,3.044z"
    }));
})).withConfig({
    displayName: "steam__CollecticonSteam",
    componentId: "sc-1yiviod-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$2eb1b0b2d752ea4b = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "subscript 2 icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "subscript",
        d: "M13,12l0,-1l2,0c0.552,0 1,0.448 1,1l0,1c-0,0.552 -0.448,1 -1,1l-0.75,0c-0.066,-0 -0.13,0.026 -0.177,0.073c-0.047,0.047 -0.073,0.111 -0.073,0.177c0,0.153 0,0.347 0,0.5c-0,0.066 0.026,0.13 0.073,0.177c0.047,0.047 0.111,0.073 0.177,0.073l1.75,0l0,1l-2,0c-0.552,-0 -1,-0.448 -1,-1l0,-1c0,-0.552 0.448,-1 1,-1l0.75,-0c0.066,0 0.13,-0.026 0.177,-0.073c0.047,-0.047 0.073,-0.111 0.073,-0.177c0,-0.153 0,-0.347 0,-0.5c0,-0.066 -0.026,-0.13 -0.073,-0.177c-0.047,-0.047 -0.111,-0.073 -0.177,-0.073l-1.75,0Zm-1,3l-2,0l0,-5l-6,0l0,5l-2,0l0,-9c0,-2.76 2.24,-5 5,-5c2.76,0 5,2.24 5,5l0,9Zm-2,-7l0,-2c0,-1.656 -1.344,-3 -3,-3c-1.656,0 -3,1.344 -3,3l0,2l6,0Z"
    }));
})).withConfig({
    displayName: "subscript-2__CollecticonSubscript2",
    componentId: "sc-c9wj65-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$b147170bf0ac6406 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "subscript icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M13,12l0,-1l2,0c0.552,0 1,0.448 1,1l0,1c-0,0.552 -0.448,1 -1,1l-0.75,0c-0.066,-0 -0.13,0.026 -0.177,0.073c-0.047,0.047 -0.073,0.111 -0.073,0.177c0,0.153 0,0.347 0,0.5c-0,0.066 0.026,0.13 0.073,0.177c0.047,0.047 0.111,0.073 0.177,0.073l1.75,0l0,1l-2,0c-0.552,-0 -1,-0.448 -1,-1l0,-1c0,-0.552 0.448,-1 1,-1l0.75,-0c0.066,0 0.13,-0.026 0.177,-0.073c0.047,-0.047 0.073,-0.111 0.073,-0.177c0,-0.153 0,-0.347 0,-0.5c0,-0.066 -0.026,-0.13 -0.073,-0.177c-0.047,-0.047 -0.111,-0.073 -0.177,-0.073l-1.75,0Zm-4.586,-4l4,4l-2.828,0l-2.586,-2.586l-2.586,2.586l-2.828,0l4,-4l-4,-4l2.828,0l2.586,2.586l2.586,-2.586l2.828,0l-4,4Z"
    }));
})).withConfig({
    displayName: "subscript__CollecticonSubscript",
    componentId: "sc-10v17n7-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$831d605561b8cca5 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "superscript 2 icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "superscript",
        d: "M12,15l-2,0l0,-5l-6,0l0,5l-2,0l0,-9c0,-2.76 2.24,-5 5,-5c2.76,0 5,2.24 5,5l0,9Zm-2,-7l0,-2c0,-1.656 -1.344,-3 -3,-3c-1.656,0 -3,1.344 -3,3l0,2l6,0Zm3,-7l0,-1l2,0c0.552,0 1,0.448 1,1l0,1c-0,0.552 -0.448,1 -1,1l-0.75,0c-0.066,-0 -0.13,0.026 -0.177,0.073c-0.047,0.047 -0.073,0.111 -0.073,0.177c0,0.153 0,0.347 0,0.5c-0,0.066 0.026,0.13 0.073,0.177c0.047,0.047 0.111,0.073 0.177,0.073l1.75,0l0,1l-2,0c-0.552,-0 -1,-0.448 -1,-1l0,-1c0,-0.552 0.448,-1 1,-1l0.75,-0c0.066,0 0.13,-0.026 0.177,-0.073c0.047,-0.047 0.073,-0.111 0.073,-0.177c0,-0.153 0,-0.347 0,-0.5c0,-0.066 -0.026,-0.13 -0.073,-0.177c-0.047,-0.047 -0.111,-0.073 -0.177,-0.073l-1.75,0Z"
    }));
})).withConfig({
    displayName: "superscript-2__CollecticonSuperscript2",
    componentId: "sc-1p3lqd0-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$3a4c80bfe15d601a = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "superscript icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "superscript",
        d: "M8.414,8l4,4l-2.828,0l-2.586,-2.586l-2.586,2.586l-2.828,0l4,-4l-4,-4l2.828,0l2.586,2.586l2.586,-2.586l2.828,0l-4,4Zm4.586,-7l0,-1l2,0c0.552,0 1,0.448 1,1l0,1c-0,0.552 -0.448,1 -1,1l-0.75,0c-0.066,-0 -0.13,0.026 -0.177,0.073c-0.047,0.047 -0.073,0.111 -0.073,0.177c0,0.153 0,0.347 0,0.5c-0,0.066 0.026,0.13 0.073,0.177c0.047,0.047 0.111,0.073 0.177,0.073l1.75,0l0,1l-2,0c-0.552,-0 -1,-0.448 -1,-1l0,-1c0,-0.552 0.448,-1 1,-1l0.75,-0c0.066,0 0.13,-0.026 0.177,-0.073c0.047,-0.047 0.073,-0.111 0.073,-0.177c0,-0.153 0,-0.347 0,-0.5c0,-0.066 -0.026,-0.13 -0.073,-0.177c-0.047,-0.047 -0.111,-0.073 -0.177,-0.073l-1.75,0Z"
    }));
})).withConfig({
    displayName: "superscript__CollecticonSuperscript",
    componentId: "sc-1wli6ww-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$8702548ed1d7ac29 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "swap horizontal icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,11h11.2l-2.6,2.6L10,15l6-6H0V11z M4.8,5l2.6-2.6L6,1L0,7h16V5H4.8z"
    }));
})).withConfig({
    displayName: "swap-horizontal__CollecticonSwapHorizontal",
    componentId: "sc-11czhsy-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$4a3cdaf8654d6ecf = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "swap vertical icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M5,16L5,4.8L2.4,7.4L1,6L7,0L7,16L5,16ZM11,11.2L13.6,8.6L15,10L9,16L9,0L11,0L11,11.2Z"
    }));
})).withConfig({
    displayName: "swap-vertical__CollecticonSwapVertical",
    componentId: "sc-1b5kgbc-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$7f7b28202d8c7331 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "table add column icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "table-add-column",
        d: "M12,11l-0,2l2,0l-0,-2l2,0l-0,-2l-2,0l-0,-2l-2,0l-0,2l-2,0l-0,2l2,0Zm2,-5l-0,-5c0,-0.265 -0.105,-0.52 -0.293,-0.707c-0.187,-0.188 -0.442,-0.293 -0.707,-0.293l-10,-0c-0.552,-0 -1,0.448 -1,1c-0,2.577 -0,11.423 0,14c0,0.552 0.448,1 1,1c1.916,0 8.084,0 10,0c0.552,-0 1,-0.448 1,-1l-0,-1l-5,0l-0,-12l3,0l-0,4l2,0Zm-10,-4l3,0l-0,12l-3,0l-0,-12Z"
    }));
})).withConfig({
    displayName: "table-add-column__CollecticonTableAddColumn",
    componentId: "sc-1v902ed-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$ca16e8c9b654c9e9 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "table add row icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "table-add-row",
        d: "M11,12l2,0l0,2l-2,0l0,2l-2,0l0,-2l-2,0l0,-2l2,0l0,-2l2,0l0,2Zm-5,2l-5,-0c-0.265,0 -0.52,-0.105 -0.707,-0.293c-0.188,-0.187 -0.293,-0.442 -0.293,-0.707l-0,-10c-0,-0.552 0.448,-1 1,-1c2.577,0 11.423,-0 14,0c0.552,0 1,0.448 1,1c-0,1.916 0,8.084 -0,10c-0,0.552 -0.448,1 -1,1l-1,-0l0,-5l-12,-0l0,3l4,0l0,2Zm-4,-10l0,3l12,0l0,-3l-12,0Z"
    }));
})).withConfig({
    displayName: "table-add-row__CollecticonTableAddRow",
    componentId: "sc-633nv5-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$5784f2a304a439e3 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "table subtract column icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "table-subtract-column",
        d: "M11.414,13l1.586,-1.586l1.586,1.586l1.414,-1.414l-1.586,-1.586l1.586,-1.586l-1.414,-1.414l-1.586,1.586l-1.586,-1.586l-1.414,1.414l1.586,1.586l-1.586,1.586l1.414,1.414Zm2.586,-7l-0,-5c0,-0.265 -0.105,-0.52 -0.293,-0.707c-0.187,-0.188 -0.442,-0.293 -0.707,-0.293l-10,-0c-0.552,-0 -1,0.448 -1,1c-0,2.577 -0,11.423 0,14c0,0.552 0.448,1 1,1c1.916,0 8.084,0 10,0c0.552,-0 1,-0.448 1,-1l-0,-1l-5,0l-0,-12l3,0l-0,4l2,0Zm-10,-4l3,0l-0,12l-3,0l-0,-12Z"
    }));
})).withConfig({
    displayName: "table-subtract-column__CollecticonTableSubtractColumn",
    componentId: "sc-1fyh4v8-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$51fa6d51058f66a4 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "table subtract row icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        id: "table-subtract-row",
        d: "M13,11.414l-1.586,1.586l1.586,1.586l-1.414,1.414l-1.586,-1.586l-1.586,1.586l-1.414,-1.414l1.586,-1.586l-1.586,-1.586l1.414,-1.414l1.586,1.586l1.586,-1.586l1.414,1.414Zm-7,2.586l-5,-0c-0.265,0 -0.52,-0.105 -0.707,-0.293c-0.188,-0.187 -0.293,-0.442 -0.293,-0.707l-0,-10c-0,-0.552 0.448,-1 1,-1c2.577,0 11.423,-0 14,0c0.552,0 1,0.448 1,1c-0,1.916 0,8.084 -0,10c-0,0.552 -0.448,1 -1,1l-1,-0l0,-5l-12,-0l0,3l4,0l0,2Zm-4,-10l0,3l12,0l0,-3l-12,0Z"
    }));
})).withConfig({
    displayName: "table-subtract-row__CollecticonTableSubtractRow",
    componentId: "sc-m6hsld-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$c69ace2e6416b89c = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "table icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M1,16C0.448,16 0,15.552 0,15C0,12.127 0,3.873 0,1C0,0.448 0.448,0 1,0C3.873,0 12.127,0 15,0C15.552,0 16,0.448 16,1C16,3.873 16,12.127 16,15C16,15.552 15.552,16 15,16C12.127,16 3.873,16 1,16ZM2,7L2,14L4,14L4,7L2,7ZM6,7L6,14L10,14L10,7L6,7ZM12,7L12,14L14,14L14,7L12,7ZM2,2L2,5L14,5L14,2L2,2Z"
    }));
})).withConfig({
    displayName: "table__CollecticonTable",
    componentId: "sc-1ck2wmp-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$7b73804de18dac8e = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "tag icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14.497,0H9.988C9.162,0,8.007,0.478,7.423,1.063L0.438,8.047c-0.585,0.585-0.585,1.541,0,2.125l5.389,5.389 c0.584,0.585,1.541,0.585,2.125,0l6.984-6.984C15.522,7.993,16,6.838,16,6.012V1.503C16,0.676,15.324,0,14.497,0z M12.5,5 C11.672,5,11,4.328,11,3.5S11.672,2,12.5,2S14,2.672,14,3.5S13.328,5,12.5,5z"
    }));
})).withConfig({
    displayName: "tag__CollecticonTag",
    componentId: "sc-kmqdpo-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$40d1ddcefe169242 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "target icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,4C5.791,4,4,5.791,4,8s1.791,4,4,4s4-1.791,4-4S10.209,4,8,4z M8,10.5c-1.378,0-2.5-1.122-2.5-2.5S6.622,5.5,8,5.5 s2.5,1.122,2.5,2.5S9.378,10.5,8,10.5z M8,7C7.447,7,7,7.447,7,8s0.447,1,1,1s1-0.447,1-1S8.553,7,8,7z M8,0C3.581,0,0,3.581,0,8 s3.581,8,8,8s8-3.581,8-8S12.419,0,8,0z M12.244,12.244C11.109,13.375,9.603,14,8,14s-3.109-0.625-4.244-1.756 C2.622,11.112,2,9.603,2,8s0.625-3.109,1.756-4.244C4.888,2.622,6.397,2,8,2s3.109,0.625,4.244,1.756C13.378,4.888,14,6.397,14,8 S13.375,11.109,12.244,12.244z"
    }));
})).withConfig({
    displayName: "target__CollecticonTarget",
    componentId: "sc-o9hlvz-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$3b8ef319a6c5f131 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "text block icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,10h16V8H0V10z M0,0v2h16V0H0z M0,14h8v-2H0V14z M0,6h16V4H0V6z"
    }));
})).withConfig({
    displayName: "text-block__CollecticonTextBlock",
    componentId: "sc-xb76he-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$7679025d661a5f99 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "tick small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M2,9.014L3.414,7.6L6.004,10.189L12.593,3.6L14.007,5.014L6.003,13.017L2,9.014Z"
    }));
})).withConfig({
    displayName: "tick--small__CollecticonTickSmall",
    componentId: "sc-1gw1pv0-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$6a564a3c64a0c770 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "tick icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M0,9.014L1.414,7.6L5.004,11.189L14.593,1.6L16.007,3.014L5.003,14.017L0,9.014Z"
    }));
})).withConfig({
    displayName: "tick__CollecticonTick",
    componentId: "sc-kz2lfw-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$5918e8962b6636e9 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "trash bin icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M11,5h2v8.5c0,0.825-0.675,1.5-1.5,1.5h-7C3.675,15,3,14.325,3,13.5V5h2v8h2V5h2v8h2V5z M2,2h12v2H2V2z M6,0h4v1H6V0z"
    }));
})).withConfig({
    displayName: "trash-bin__CollecticonTrashBin",
    componentId: "sc-1md69fn-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$f7790cfaf03c8a87 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "triangle down small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "8,11 3,6 13,6"
    }));
})).withConfig({
    displayName: "triangle-down--small__CollecticonTriangleDownSmall",
    componentId: "sc-1mvvmvk-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$d0e1eaac53e25db1 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "triangle down icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "8,13 0,5 16,5"
    }));
})).withConfig({
    displayName: "triangle-down__CollecticonTriangleDown",
    componentId: "sc-yiau6v-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$668e2789cbc708d7 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "triangle left small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "5,8 10,3 10,13"
    }));
})).withConfig({
    displayName: "triangle-left--small__CollecticonTriangleLeftSmall",
    componentId: "sc-1wii1zs-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$1974c1a52230d9bf = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "triangle left icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "3,8 11,0 11,16"
    }));
})).withConfig({
    displayName: "triangle-left__CollecticonTriangleLeft",
    componentId: "sc-15tp8d3-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$501ada128b32fc9e = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "triangle right small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "11,8 6,13 6,3"
    }));
})).withConfig({
    displayName: "triangle-right--small__CollecticonTriangleRightSmall",
    componentId: "sc-f8t04i-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$79a26f2c80e33f90 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "triangle right icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "13,8 5,16 5,0"
    }));
})).withConfig({
    displayName: "triangle-right__CollecticonTriangleRight",
    componentId: "sc-nu28g8-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$18dba1b5898bbfb1 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "triangle up small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "8,5 13,10 3,10"
    }));
})).withConfig({
    displayName: "triangle-up--small__CollecticonTriangleUpSmall",
    componentId: "sc-19tjeu7-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$9bef3663bbeb4db3 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "triangle up icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "8,3 16,11 0,11"
    }));
})).withConfig({
    displayName: "triangle-up__CollecticonTriangleUp",
    componentId: "sc-iwnypi-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$3c99c824037eed46 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "tumblr reblog icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M2,5h10.672l-1.837,1.834L12,8l4-4l-4-4l-1.166,1.166L12.672,3H0v7l2-2V5z M14,11H3.328l1.838-1.834L4,8l-4,4l4,4 l1.166-1.166L3.328,13H16V6l-2,2V11z"
    }));
})).withConfig({
    displayName: "tumblr-reblog__CollecticonTumblrReblog",
    componentId: "sc-53971o-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$bf9bd1a6e1a39cb5 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "ufo icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M6,13L3,15L3.889,12.333L0,10L16,10L12.111,12.333L13,15L10,13L6,13ZM16,9L0,9L0,8L3,6C3,3.24 5.24,1 8,1C10.76,1 13,3.24 13,6L16,8L16,9Z"
    }));
})).withConfig({
    displayName: "ufo__CollecticonUfo",
    componentId: "sc-19wp69f-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$193ca764ca13a0c5 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "underline icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M3,13l10,0l0,2l-10,0l0,-2Zm8,-12l2,0l0,6c0,2.76 -2.24,5 -5,5c-2.76,0 -5,-2.24 -5,-5l0,-6l2,0l-0,6c-0,1.656 1.344,3 3,3c1.656,0 3,-1.344 3,-3l0,-6Z"
    }));
})).withConfig({
    displayName: "underline__CollecticonUnderline",
    componentId: "sc-1rup4pw-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$6ec63552fd597a0c = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "upload 2 icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M3.294,7.706l1.416,1.416L7,6.828V16h2V6.828l2.294,2.294l1.416-1.416L8,3L3.294,7.706z M0,2h16V0H0V2z"
    }));
})).withConfig({
    displayName: "upload-2__CollecticonUpload2",
    componentId: "sc-p2a7et-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$65f5fd8d1a192873 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "upload icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M3.294,7.706l1.416,1.416L7,6.828V16h2V6.828l2.294,2.294l1.416-1.416L8,3L3.294,7.706z M2,12V2h12v10h2V0H0v12H2z"
    }));
})).withConfig({
    displayName: "upload__CollecticonUpload",
    componentId: "sc-1ww7u5j-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$de7094d8f3d0eff8 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "user group icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M14,12.5C14,11.837 13.737,11.201 13.268,10.732C12.799,10.263 12.163,10 11.5,10C9.447,10 6.553,10 4.5,10C3.837,10 3.201,10.263 2.732,10.732C2.263,11.201 2,11.837 2,12.5C2,14.147 2,15 2,15L14,15C14,15 14,14.147 14,12.5ZM12,6L14,6C14.53,6 15.039,6.211 15.414,6.586C15.789,6.961 16,7.47 16,8L16,11L14.663,11C14.101,9.818 12.896,9 11.5,9L10.645,9C11.476,8.267 12,7.194 12,6ZM1.337,11L0,11C0,11 0,9.392 0,8C0,7.47 0.211,6.961 0.586,6.586C0.961,6.211 1.47,6 2,6L4,6C4,7.194 4.524,8.267 5.355,9L4.5,9C3.104,9 1.899,9.817 1.337,11ZM8,3C9.656,3 11,4.344 11,6C11,7.656 9.656,9 8,9C6.344,9 5,7.656 5,6C5,4.344 6.344,3 8,3ZM4.127,4.996C4.085,4.999 4.043,5 4,5C2.896,5 2,4.104 2,3C2,1.896 2.896,1 4,1C4.954,1 5.753,1.67 5.952,2.564C5.061,3.097 4.394,3.966 4.127,4.996ZM10.048,2.564C10.247,1.67 11.046,1 12,1C13.104,1 14,1.896 14,3C14,4.104 13.104,5 12,5C11.957,5 11.915,4.999 11.873,4.996C11.606,3.966 10.939,3.097 10.048,2.564Z"
    }));
})).withConfig({
    displayName: "user-group__CollecticonUserGroup",
    componentId: "sc-1o3ubat-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$24f630ce129477b6 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "user icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M8,8c2.209,0,4-1.791,4-4s-1.791-4-4-4S4,1.791,4,4S5.791,8,8,8z M12,10H4c-2.209,0-4,1.791-4,4v2h16v-2 C16,11.791,14.209,10,12,10z"
    }));
})).withConfig({
    displayName: "user__CollecticonUser",
    componentId: "sc-jgwre8-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$7c42224f1c8d83b0 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "users icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M16,12.5C16,11.837 15.737,11.201 15.268,10.732C14.799,10.263 14.163,10 13.5,10C11.447,10 8.553,10 6.5,10C5.837,10 5.201,10.263 4.732,10.732C4.263,11.201 4,11.837 4,12.5C4,14.147 4,15 4,15L16,15C16,15 16,14.147 16,12.5ZM3,13L0,13C0,13 0,12.147 0,10.5C0,9.837 0.263,9.201 0.732,8.732C1.201,8.263 1.837,8 2.5,8L6.536,8C6.754,8.376 7.031,8.714 7.355,9L6.5,9C4.567,9 3,10.567 3,12.5L3,13ZM10,3C11.656,3 13,4.344 13,6C13,7.656 11.656,9 10,9C8.344,9 7,7.656 7,6C7,4.344 8.344,3 10,3ZM6.126,6.997C6.084,6.999 6.042,7 6,7C4.344,7 3,5.656 3,4C3,2.344 4.344,1 6,1C7.026,1 7.932,1.516 8.473,2.302C7.022,2.903 6,4.333 6,6C6,6.344 6.044,6.679 6.126,6.997Z"
    }));
})).withConfig({
    displayName: "users__CollecticonUsers",
    componentId: "sc-1543no2-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$25372d620e7a1b0b = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "way icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M15,3L15,4.268C15.598,4.614 16,5.26 16,6C16,7.104 15.104,8 14,8C12.896,8 12,7.104 12,6C12,5.26 12.402,4.614 13,4.268L13,3.5C13,2.672 12.328,2 11.5,2C10.672,2 10,2.672 10,3.5L10,12L10,12.013C9.993,14.215 8.203,16 6,16C3.792,16 2,14.208 2,12L2,11.829C0.835,11.417 0,10.305 0,9C0,7.344 1.344,6 3,6C4.656,6 6,7.344 6,9C6,10.305 5.165,11.417 4,11.829L4,12.006C4,12.108 4.008,12.21 4.024,12.311C4.049,12.471 4.094,12.629 4.157,12.778C4.254,13.008 4.395,13.219 4.569,13.397C4.736,13.568 4.933,13.709 5.15,13.81C5.336,13.898 5.535,13.957 5.739,13.983C5.958,14.012 6.181,14.004 6.397,13.961C6.583,13.923 6.764,13.859 6.932,13.77C7.13,13.665 7.311,13.527 7.464,13.362C7.615,13.2 7.738,13.014 7.828,12.812C7.898,12.654 7.948,12.487 7.975,12.317C7.992,12.212 8,12.106 8,12L8,3.5C8,1.568 9.568,0 11.5,0C13.262,0 14.721,1.305 14.964,3L15,3ZM3,8C2.448,8 2,8.448 2,9C2,9.552 2.448,10 3,10C3.552,10 4,9.552 4,9C4,8.448 3.552,8 3,8Z"
    }));
})).withConfig({
    displayName: "way__CollecticonWay",
    componentId: "sc-1ws2bod-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$db99d8e121938012 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "wrench icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("path", {
        d: "M15.379,12.379L8.79,5.79C8.913,5.379,9,4.951,9,4.5C9,2.015,6.985,0,4.5,0C4.049,0,3.621,0.087,3.21,0.21l2.291,2.291 c0.828,0.828,0.828,2.17,0,2.998L5.499,5.501c-0.828,0.828-2.17,0.828-2.998,0L0.21,3.21C0.087,3.621,0,4.049,0,4.5 C0,6.985,2.015,9,4.5,9c0.451,0,0.879-0.087,1.29-0.21l6.589,6.589c0.828,0.828,2.17,0.828,2.998,0l0.002-0.002 C16.207,14.549,16.207,13.207,15.379,12.379z M13.75,14.75c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1S14.302,14.75,13.75,14.75z"
    }));
})).withConfig({
    displayName: "wrench__CollecticonWrench",
    componentId: "sc-13hjr0s-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$4cca98ab4f54f41d = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "xmark small icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "13.707,3.707 12.293,2.293 8,6.586 3.707,2.293 2.293,3.707 6.586,8 2.293,12.293 3.707,13.707 8,9.414  12.293,13.707 13.707,12.293 9.414,8"
    }));
})).withConfig({
    displayName: "xmark--small__CollecticonXmarkSmall",
    componentId: "sc-194sjhs-0"
})([
    ""
]);
var $022bcdb8507c1d1a$export$eeb267586df04918 = /*#__PURE__*/ (0, $6fhRl.default)($022bcdb8507c1d1a$export$7209ba2b0568490(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("svg", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("title", null, props.title || "xmark icon"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("polygon", {
        points: "14.707,2.707 13.293,1.293 8,6.586 2.707,1.293 1.293,2.707 6.586,8 1.293,13.293 2.707,14.707 8,9.414 13.293,14.707 14.707,13.293 9.414,8"
    }));
})).withConfig({
    displayName: "xmark__CollecticonXmark",
    componentId: "sc-pn541c-0"
})([
    ""
]);

});
parcelRegister("lGXdi", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $fcab73c957478daa$var$Stream;

var $fHNw8 = parcelRequire("fHNw8");
var $fcab73c957478daa$require$EE = $fHNw8.EventEmitter;

var $gmyMj = parcelRequire("gmyMj");
$gmyMj($fcab73c957478daa$var$Stream, $fcab73c957478daa$require$EE);

$fcab73c957478daa$var$Stream.Readable = (parcelRequire("6Vpap"));

$fcab73c957478daa$var$Stream.Writable = (parcelRequire("hmkR8"));

$fcab73c957478daa$var$Stream.Duplex = (parcelRequire("ku3t4"));

$fcab73c957478daa$var$Stream.Transform = (parcelRequire("iN6gi"));

$fcab73c957478daa$var$Stream.PassThrough = (parcelRequire("7pFip"));

$fcab73c957478daa$var$Stream.finished = (parcelRequire("4kxK8"));

$fcab73c957478daa$var$Stream.pipeline = (parcelRequire("01yI0"));
// Backwards-compat with node 0.4.x
$fcab73c957478daa$var$Stream.Stream = $fcab73c957478daa$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $fcab73c957478daa$var$Stream() {
    $fcab73c957478daa$require$EE.call(this);
}
$fcab73c957478daa$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($fcab73c957478daa$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("fHNw8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $b6f14845af049f52$var$R = typeof Reflect === "object" ? Reflect : null;
var $b6f14845af049f52$var$ReflectApply = $b6f14845af049f52$var$R && typeof $b6f14845af049f52$var$R.apply === "function" ? $b6f14845af049f52$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $b6f14845af049f52$var$ReflectOwnKeys;
if ($b6f14845af049f52$var$R && typeof $b6f14845af049f52$var$R.ownKeys === "function") $b6f14845af049f52$var$ReflectOwnKeys = $b6f14845af049f52$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $b6f14845af049f52$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $b6f14845af049f52$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $b6f14845af049f52$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $b6f14845af049f52$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $b6f14845af049f52$var$EventEmitter() {
    $b6f14845af049f52$var$EventEmitter.init.call(this);
}
module.exports = $b6f14845af049f52$var$EventEmitter;
module.exports.once = $b6f14845af049f52$var$once;
// Backwards-compat with node 0.10.x
$b6f14845af049f52$var$EventEmitter.EventEmitter = $b6f14845af049f52$var$EventEmitter;
$b6f14845af049f52$var$EventEmitter.prototype._events = undefined;
$b6f14845af049f52$var$EventEmitter.prototype._eventsCount = 0;
$b6f14845af049f52$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $b6f14845af049f52$var$defaultMaxListeners = 10;
function $b6f14845af049f52$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($b6f14845af049f52$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $b6f14845af049f52$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $b6f14845af049f52$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $b6f14845af049f52$var$defaultMaxListeners = arg;
    }
});
$b6f14845af049f52$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$b6f14845af049f52$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $b6f14845af049f52$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $b6f14845af049f52$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $b6f14845af049f52$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$b6f14845af049f52$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $b6f14845af049f52$var$_getMaxListeners(this);
};
$b6f14845af049f52$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $b6f14845af049f52$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $b6f14845af049f52$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$b6f14845af049f52$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $b6f14845af049f52$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $b6f14845af049f52$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $b6f14845af049f52$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $b6f14845af049f52$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$b6f14845af049f52$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $b6f14845af049f52$var$_addListener(this, type, listener, false);
};
$b6f14845af049f52$var$EventEmitter.prototype.on = $b6f14845af049f52$var$EventEmitter.prototype.addListener;
$b6f14845af049f52$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $b6f14845af049f52$var$_addListener(this, type, listener, true);
};
function $b6f14845af049f52$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $b6f14845af049f52$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $b6f14845af049f52$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$b6f14845af049f52$var$EventEmitter.prototype.once = function once(type, listener) {
    $b6f14845af049f52$var$checkListener(listener);
    this.on(type, $b6f14845af049f52$var$_onceWrap(this, type, listener));
    return this;
};
$b6f14845af049f52$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $b6f14845af049f52$var$checkListener(listener);
    this.prependListener(type, $b6f14845af049f52$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$b6f14845af049f52$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $b6f14845af049f52$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $b6f14845af049f52$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$b6f14845af049f52$var$EventEmitter.prototype.off = $b6f14845af049f52$var$EventEmitter.prototype.removeListener;
$b6f14845af049f52$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $b6f14845af049f52$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $b6f14845af049f52$var$unwrapListeners(evlistener) : $b6f14845af049f52$var$arrayClone(evlistener, evlistener.length);
}
$b6f14845af049f52$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $b6f14845af049f52$var$_listeners(this, type, true);
};
$b6f14845af049f52$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $b6f14845af049f52$var$_listeners(this, type, false);
};
$b6f14845af049f52$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $b6f14845af049f52$var$listenerCount.call(emitter, type);
};
$b6f14845af049f52$var$EventEmitter.prototype.listenerCount = $b6f14845af049f52$var$listenerCount;
function $b6f14845af049f52$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$b6f14845af049f52$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $b6f14845af049f52$var$ReflectOwnKeys(this._events) : [];
};
function $b6f14845af049f52$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $b6f14845af049f52$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $b6f14845af049f52$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $b6f14845af049f52$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $b6f14845af049f52$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $b6f14845af049f52$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $b6f14845af049f52$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $b6f14845af049f52$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $b6f14845af049f52$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("gmyMj", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("6Vpap", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $dpptK = parcelRequire("dpptK");
"use strict";
module.exports = $50ab96973f1d600a$var$Readable;
/*<replacement>*/ var $50ab96973f1d600a$var$Duplex;
/*</replacement>*/ $50ab96973f1d600a$var$Readable.ReadableState = $50ab96973f1d600a$var$ReadableState;

var $fHNw8 = parcelRequire("fHNw8");
var $50ab96973f1d600a$require$EE = $fHNw8.EventEmitter;
var $50ab96973f1d600a$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $1zBkE = parcelRequire("1zBkE");

var $gybZ1 = parcelRequire("gybZ1");
var $50ab96973f1d600a$require$Buffer = $gybZ1.Buffer;
var $50ab96973f1d600a$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $50ab96973f1d600a$var$_uint8ArrayToBuffer(chunk) {
    return $50ab96973f1d600a$require$Buffer.from(chunk);
}
function $50ab96973f1d600a$var$_isUint8Array(obj) {
    return $50ab96973f1d600a$require$Buffer.isBuffer(obj) || obj instanceof $50ab96973f1d600a$var$OurUint8Array;
}

var $3U7jb = parcelRequire("3U7jb");
var $50ab96973f1d600a$var$debug;
if ($3U7jb && $3U7jb.debuglog) $50ab96973f1d600a$var$debug = $3U7jb.debuglog("stream");
else $50ab96973f1d600a$var$debug = function debug() {};

var $bGgJU = parcelRequire("bGgJU");

var $cSIRM = parcelRequire("cSIRM");

var $9GDZh = parcelRequire("9GDZh");
var $50ab96973f1d600a$var$getHighWaterMark = $9GDZh.getHighWaterMark;

var $aiAV0 = parcelRequire("aiAV0");
var $50ab96973f1d600a$require$_require$codes = $aiAV0.codes;
var $50ab96973f1d600a$var$ERR_INVALID_ARG_TYPE = $50ab96973f1d600a$require$_require$codes.ERR_INVALID_ARG_TYPE, $50ab96973f1d600a$var$ERR_STREAM_PUSH_AFTER_EOF = $50ab96973f1d600a$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $50ab96973f1d600a$var$ERR_METHOD_NOT_IMPLEMENTED = $50ab96973f1d600a$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $50ab96973f1d600a$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $50ab96973f1d600a$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
var $50ab96973f1d600a$var$StringDecoder;
var $50ab96973f1d600a$var$createReadableStreamAsyncIterator;
var $50ab96973f1d600a$var$from;

(parcelRequire("gmyMj"))($50ab96973f1d600a$var$Readable, $1zBkE);
var $50ab96973f1d600a$var$errorOrDestroy = $cSIRM.errorOrDestroy;
var $50ab96973f1d600a$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $50ab96973f1d600a$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $50ab96973f1d600a$var$ReadableState(options, stream, isDuplex) {
    $50ab96973f1d600a$var$Duplex = $50ab96973f1d600a$var$Duplex || (parcelRequire("ku3t4"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $50ab96973f1d600a$var$Duplex; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $50ab96973f1d600a$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex); // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bGgJU();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy; // has it been destroyed
    this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$50ab96973f1d600a$var$StringDecoder) $50ab96973f1d600a$var$StringDecoder = (parcelRequire("g9yY1")).StringDecoder;
        this.decoder = new $50ab96973f1d600a$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $50ab96973f1d600a$var$Readable(options) {
    $50ab96973f1d600a$var$Duplex = $50ab96973f1d600a$var$Duplex || (parcelRequire("ku3t4"));
    if (!(this instanceof $50ab96973f1d600a$var$Readable)) return new $50ab96973f1d600a$var$Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $50ab96973f1d600a$var$Duplex;
    this._readableState = new $50ab96973f1d600a$var$ReadableState(options, this, isDuplex); // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $1zBkE.call(this);
}
Object.defineProperty($50ab96973f1d600a$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$50ab96973f1d600a$var$Readable.prototype.destroy = $cSIRM.destroy;
$50ab96973f1d600a$var$Readable.prototype._undestroy = $cSIRM.undestroy;
$50ab96973f1d600a$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$50ab96973f1d600a$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $50ab96973f1d600a$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $50ab96973f1d600a$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()
$50ab96973f1d600a$var$Readable.prototype.unshift = function(chunk) {
    return $50ab96973f1d600a$var$readableAddChunk(this, chunk, null, true, false);
};
function $50ab96973f1d600a$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $50ab96973f1d600a$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $50ab96973f1d600a$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $50ab96973f1d600a$var$chunkInvalid(state, chunk);
        if (er) $50ab96973f1d600a$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $50ab96973f1d600a$require$Buffer.prototype) chunk = $50ab96973f1d600a$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $50ab96973f1d600a$var$errorOrDestroy(stream, new $50ab96973f1d600a$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $50ab96973f1d600a$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $50ab96973f1d600a$var$errorOrDestroy(stream, new $50ab96973f1d600a$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $50ab96973f1d600a$var$addChunk(stream, state, chunk, false);
                    else $50ab96973f1d600a$var$maybeReadMore(stream, state);
                } else $50ab96973f1d600a$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $50ab96973f1d600a$var$maybeReadMore(stream, state);
        }
    } // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $50ab96973f1d600a$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $50ab96973f1d600a$var$emitReadable(stream);
    }
    $50ab96973f1d600a$var$maybeReadMore(stream, state);
}
function $50ab96973f1d600a$var$chunkInvalid(state, chunk) {
    var er;
    if (!$50ab96973f1d600a$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $50ab96973f1d600a$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$50ab96973f1d600a$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
}; // backwards compatibility.

$50ab96973f1d600a$var$Readable.prototype.setEncoding = function(enc) {
    if (!$50ab96973f1d600a$var$StringDecoder) $50ab96973f1d600a$var$StringDecoder = (parcelRequire("g9yY1")).StringDecoder;
    var decoder = new $50ab96973f1d600a$var$StringDecoder(enc);
    this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
}; // Don't raise the hwm > 1GB
var $50ab96973f1d600a$var$MAX_HWM = 0x40000000;
function $50ab96973f1d600a$var$computeNewHighWaterMark(n) {
    if (n >= $50ab96973f1d600a$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $50ab96973f1d600a$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $50ab96973f1d600a$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $50ab96973f1d600a$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n; // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
} // you can override either this method, or the async _read(n) below.
$50ab96973f1d600a$var$Readable.prototype.read = function(n) {
    $50ab96973f1d600a$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $50ab96973f1d600a$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $50ab96973f1d600a$var$endReadable(this);
        else $50ab96973f1d600a$var$emitReadable(this);
        return null;
    }
    n = $50ab96973f1d600a$var$howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $50ab96973f1d600a$var$endReadable(this);
        return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $50ab96973f1d600a$var$debug("need readable", doRead); // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $50ab96973f1d600a$var$debug("length less than watermark", doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $50ab96973f1d600a$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $50ab96973f1d600a$var$debug("do read");
        state.reading = true;
        state.sync = true; // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true; // call internal read method
        this._read(state.highWaterMark);
        state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $50ab96973f1d600a$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $50ab96973f1d600a$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $50ab96973f1d600a$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $50ab96973f1d600a$var$onEofChunk(stream, state) {
    $50ab96973f1d600a$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $50ab96973f1d600a$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $50ab96973f1d600a$var$emitReadable_(stream);
        }
    }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $50ab96973f1d600a$var$emitReadable(stream) {
    var state = stream._readableState;
    $50ab96973f1d600a$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $50ab96973f1d600a$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $dpptK.nextTick($50ab96973f1d600a$var$emitReadable_, stream);
    }
}
function $50ab96973f1d600a$var$emitReadable_(stream) {
    var state = stream._readableState;
    $50ab96973f1d600a$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    } // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $50ab96973f1d600a$var$flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $50ab96973f1d600a$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $dpptK.nextTick($50ab96973f1d600a$var$maybeReadMore_, stream, state);
    }
}
function $50ab96973f1d600a$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $50ab96973f1d600a$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$50ab96973f1d600a$var$Readable.prototype._read = function(n) {
    $50ab96973f1d600a$var$errorOrDestroy(this, new $50ab96973f1d600a$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$50ab96973f1d600a$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $50ab96973f1d600a$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $dpptK.stdout && dest !== $dpptK.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $dpptK.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $50ab96973f1d600a$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $50ab96973f1d600a$var$debug("onend");
        dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $50ab96973f1d600a$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $50ab96973f1d600a$var$debug("cleanup"); // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true; // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $50ab96973f1d600a$var$debug("ondata");
        var ret = dest.write(chunk);
        $50ab96973f1d600a$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $50ab96973f1d600a$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $50ab96973f1d600a$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $50ab96973f1d600a$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($50ab96973f1d600a$var$EElistenerCount(dest, "error") === 0) $50ab96973f1d600a$var$errorOrDestroy(dest, er);
    } // Make sure our error handler is attached before userland ones.
    $50ab96973f1d600a$var$prependListener(dest, "error", onerror); // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $50ab96973f1d600a$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $50ab96973f1d600a$var$debug("unpipe");
        src.unpipe(dest);
    } // tell the dest that it's being piped to
    dest.emit("pipe", src); // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $50ab96973f1d600a$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $50ab96973f1d600a$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $50ab96973f1d600a$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $50ab96973f1d600a$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $50ab96973f1d600a$var$flow(src);
        }
    };
}
$50ab96973f1d600a$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    }; // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this; // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes; // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    } // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    } // try to find the right one.
    var index = $50ab96973f1d600a$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something
$50ab96973f1d600a$var$Readable.prototype.on = function(ev, fn) {
    var res = $1zBkE.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0; // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $50ab96973f1d600a$var$debug("on readable", state.length, state.reading);
            if (state.length) $50ab96973f1d600a$var$emitReadable(this);
            else if (!state.reading) $dpptK.nextTick($50ab96973f1d600a$var$nReadingNextTick, this);
        }
    }
    return res;
};
$50ab96973f1d600a$var$Readable.prototype.addListener = $50ab96973f1d600a$var$Readable.prototype.on;
$50ab96973f1d600a$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $1zBkE.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $dpptK.nextTick($50ab96973f1d600a$var$updateReadableListening, this);
    return res;
};
$50ab96973f1d600a$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $1zBkE.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $dpptK.nextTick($50ab96973f1d600a$var$updateReadableListening, this);
    return res;
};
function $50ab96973f1d600a$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
    else if (self.listenerCount("data") > 0) self.resume();
}
function $50ab96973f1d600a$var$nReadingNextTick(self) {
    $50ab96973f1d600a$var$debug("readable nexttick read 0");
    self.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$50ab96973f1d600a$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $50ab96973f1d600a$var$debug("resume"); // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $50ab96973f1d600a$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $50ab96973f1d600a$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $dpptK.nextTick($50ab96973f1d600a$var$resume_, stream, state);
    }
}
function $50ab96973f1d600a$var$resume_(stream, state) {
    $50ab96973f1d600a$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $50ab96973f1d600a$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$50ab96973f1d600a$var$Readable.prototype.pause = function() {
    $50ab96973f1d600a$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $50ab96973f1d600a$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $50ab96973f1d600a$var$flow(stream) {
    var state = stream._readableState;
    $50ab96973f1d600a$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$50ab96973f1d600a$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $50ab96973f1d600a$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $50ab96973f1d600a$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
     // proxy certain important events.
    for(var n = 0; n < $50ab96973f1d600a$var$kProxyEvents.length; n++)stream.on($50ab96973f1d600a$var$kProxyEvents[n], this.emit.bind(this, $50ab96973f1d600a$var$kProxyEvents[n]));
     // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $50ab96973f1d600a$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $50ab96973f1d600a$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($50ab96973f1d600a$var$createReadableStreamAsyncIterator === undefined) $50ab96973f1d600a$var$createReadableStreamAsyncIterator = (parcelRequire("aWjrY"));
    return $50ab96973f1d600a$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($50ab96973f1d600a$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($50ab96973f1d600a$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($50ab96973f1d600a$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
}); // exposed for testing purposes only.
$50ab96973f1d600a$var$Readable._fromList = $50ab96973f1d600a$var$fromList;
Object.defineProperty($50ab96973f1d600a$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $50ab96973f1d600a$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $50ab96973f1d600a$var$endReadable(stream) {
    var state = stream._readableState;
    $50ab96973f1d600a$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $dpptK.nextTick($50ab96973f1d600a$var$endReadableNT, state, stream);
    }
}
function $50ab96973f1d600a$var$endReadableNT(state, stream) {
    $50ab96973f1d600a$var$debug("endReadableNT", state.endEmitted, state.length); // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $50ab96973f1d600a$var$Readable.from = function(iterable, opts) {
    if ($50ab96973f1d600a$var$from === undefined) $50ab96973f1d600a$var$from = (parcelRequire("8iNn4"));
    return $50ab96973f1d600a$var$from($50ab96973f1d600a$var$Readable, iterable, opts);
};
function $50ab96973f1d600a$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("1zBkE", function(module, exports) {

module.exports = (parcelRequire("fHNw8")).EventEmitter;

});

parcelRegister("gybZ1", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $c0c91deafda60d52$export$a143d493d941bafc; }, function (v) { return $c0c91deafda60d52$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $c0c91deafda60d52$export$e4cf37d7f6fb9e0a; }, function (v) { return $c0c91deafda60d52$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $c0c91deafda60d52$export$f99ded8fe4b79145; }, function (v) { return $c0c91deafda60d52$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $c0c91deafda60d52$export$599f31c3813fae4d; }, function (v) { return $c0c91deafda60d52$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c0c91deafda60d52$export$a143d493d941bafc;
var $c0c91deafda60d52$export$e4cf37d7f6fb9e0a;
var $c0c91deafda60d52$export$f99ded8fe4b79145;
var $c0c91deafda60d52$export$599f31c3813fae4d;
"use strict";

var $fw7rd = parcelRequire("fw7rd");

var $33ED1 = parcelRequire("33ED1");
const $c0c91deafda60d52$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$c0c91deafda60d52$export$a143d493d941bafc = $c0c91deafda60d52$var$Buffer;
$c0c91deafda60d52$export$e4cf37d7f6fb9e0a = $c0c91deafda60d52$var$SlowBuffer;
$c0c91deafda60d52$export$f99ded8fe4b79145 = 50;
const $c0c91deafda60d52$var$K_MAX_LENGTH = 0x7fffffff;
$c0c91deafda60d52$export$599f31c3813fae4d = $c0c91deafda60d52$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c0c91deafda60d52$var$Buffer.TYPED_ARRAY_SUPPORT = $c0c91deafda60d52$var$typedArraySupport();
if (!$c0c91deafda60d52$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c0c91deafda60d52$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c0c91deafda60d52$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$c0c91deafda60d52$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c0c91deafda60d52$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$c0c91deafda60d52$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c0c91deafda60d52$var$createBuffer(length) {
    if (length > $c0c91deafda60d52$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c0c91deafda60d52$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c0c91deafda60d52$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c0c91deafda60d52$var$allocUnsafe(arg);
    }
    return $c0c91deafda60d52$var$from(arg, encodingOrOffset, length);
}
$c0c91deafda60d52$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c0c91deafda60d52$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $c0c91deafda60d52$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c0c91deafda60d52$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c0c91deafda60d52$var$isInstance(value, ArrayBuffer) || value && $c0c91deafda60d52$var$isInstance(value.buffer, ArrayBuffer)) return $c0c91deafda60d52$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($c0c91deafda60d52$var$isInstance(value, SharedArrayBuffer) || value && $c0c91deafda60d52$var$isInstance(value.buffer, SharedArrayBuffer))) return $c0c91deafda60d52$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c0c91deafda60d52$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $c0c91deafda60d52$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $c0c91deafda60d52$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c0c91deafda60d52$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c0c91deafda60d52$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c0c91deafda60d52$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c0c91deafda60d52$var$Buffer, Uint8Array);
function $c0c91deafda60d52$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c0c91deafda60d52$var$alloc(size, fill, encoding) {
    $c0c91deafda60d52$var$assertSize(size);
    if (size <= 0) return $c0c91deafda60d52$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $c0c91deafda60d52$var$createBuffer(size).fill(fill, encoding) : $c0c91deafda60d52$var$createBuffer(size).fill(fill);
    return $c0c91deafda60d52$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c0c91deafda60d52$var$Buffer.alloc = function(size, fill, encoding) {
    return $c0c91deafda60d52$var$alloc(size, fill, encoding);
};
function $c0c91deafda60d52$var$allocUnsafe(size) {
    $c0c91deafda60d52$var$assertSize(size);
    return $c0c91deafda60d52$var$createBuffer(size < 0 ? 0 : $c0c91deafda60d52$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c0c91deafda60d52$var$Buffer.allocUnsafe = function(size) {
    return $c0c91deafda60d52$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c0c91deafda60d52$var$Buffer.allocUnsafeSlow = function(size) {
    return $c0c91deafda60d52$var$allocUnsafe(size);
};
function $c0c91deafda60d52$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$c0c91deafda60d52$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $c0c91deafda60d52$var$byteLength(string, encoding) | 0;
    let buf = $c0c91deafda60d52$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c0c91deafda60d52$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $c0c91deafda60d52$var$checked(array.length) | 0;
    const buf = $c0c91deafda60d52$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c0c91deafda60d52$var$fromArrayView(arrayView) {
    if ($c0c91deafda60d52$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $c0c91deafda60d52$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c0c91deafda60d52$var$fromArrayLike(arrayView);
}
function $c0c91deafda60d52$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c0c91deafda60d52$var$Buffer.prototype);
    return buf;
}
function $c0c91deafda60d52$var$fromObject(obj) {
    if ($c0c91deafda60d52$var$Buffer.isBuffer(obj)) {
        const len = $c0c91deafda60d52$var$checked(obj.length) | 0;
        const buf = $c0c91deafda60d52$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $c0c91deafda60d52$var$numberIsNaN(obj.length)) return $c0c91deafda60d52$var$createBuffer(0);
        return $c0c91deafda60d52$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $c0c91deafda60d52$var$fromArrayLike(obj.data);
}
function $c0c91deafda60d52$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c0c91deafda60d52$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c0c91deafda60d52$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $c0c91deafda60d52$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c0c91deafda60d52$var$Buffer.alloc(+length);
}
$c0c91deafda60d52$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c0c91deafda60d52$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c0c91deafda60d52$var$Buffer.compare = function compare(a, b) {
    if ($c0c91deafda60d52$var$isInstance(a, Uint8Array)) a = $c0c91deafda60d52$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c0c91deafda60d52$var$isInstance(b, Uint8Array)) b = $c0c91deafda60d52$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c0c91deafda60d52$var$Buffer.isBuffer(a) || !$c0c91deafda60d52$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c0c91deafda60d52$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$c0c91deafda60d52$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c0c91deafda60d52$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $c0c91deafda60d52$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($c0c91deafda60d52$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c0c91deafda60d52$var$Buffer.isBuffer(buf)) buf = $c0c91deafda60d52$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c0c91deafda60d52$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c0c91deafda60d52$var$byteLength(string, encoding) {
    if ($c0c91deafda60d52$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c0c91deafda60d52$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $c0c91deafda60d52$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $c0c91deafda60d52$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c0c91deafda60d52$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c0c91deafda60d52$var$Buffer.byteLength = $c0c91deafda60d52$var$byteLength;
function $c0c91deafda60d52$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $c0c91deafda60d52$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $c0c91deafda60d52$var$utf8Slice(this, start, end);
        case "ascii":
            return $c0c91deafda60d52$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $c0c91deafda60d52$var$latin1Slice(this, start, end);
        case "base64":
            return $c0c91deafda60d52$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c0c91deafda60d52$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c0c91deafda60d52$var$Buffer.prototype._isBuffer = true;
function $c0c91deafda60d52$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c0c91deafda60d52$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$c0c91deafda60d52$var$swap(this, i, i + 1);
    return this;
};
$c0c91deafda60d52$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $c0c91deafda60d52$var$swap(this, i, i + 3);
        $c0c91deafda60d52$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c0c91deafda60d52$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $c0c91deafda60d52$var$swap(this, i, i + 7);
        $c0c91deafda60d52$var$swap(this, i + 1, i + 6);
        $c0c91deafda60d52$var$swap(this, i + 2, i + 5);
        $c0c91deafda60d52$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c0c91deafda60d52$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $c0c91deafda60d52$var$utf8Slice(this, 0, length);
    return $c0c91deafda60d52$var$slowToString.apply(this, arguments);
};
$c0c91deafda60d52$var$Buffer.prototype.toLocaleString = $c0c91deafda60d52$var$Buffer.prototype.toString;
$c0c91deafda60d52$var$Buffer.prototype.equals = function equals(b) {
    if (!$c0c91deafda60d52$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $c0c91deafda60d52$var$Buffer.compare(this, b) === 0;
};
$c0c91deafda60d52$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $c0c91deafda60d52$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($c0c91deafda60d52$var$customInspectSymbol) $c0c91deafda60d52$var$Buffer.prototype[$c0c91deafda60d52$var$customInspectSymbol] = $c0c91deafda60d52$var$Buffer.prototype.inspect;
$c0c91deafda60d52$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c0c91deafda60d52$var$isInstance(target, Uint8Array)) target = $c0c91deafda60d52$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c0c91deafda60d52$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c0c91deafda60d52$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c0c91deafda60d52$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $c0c91deafda60d52$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c0c91deafda60d52$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c0c91deafda60d52$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c0c91deafda60d52$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $c0c91deafda60d52$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c0c91deafda60d52$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c0c91deafda60d52$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c0c91deafda60d52$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c0c91deafda60d52$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c0c91deafda60d52$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c0c91deafda60d52$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c0c91deafda60d52$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c0c91deafda60d52$var$utf8Write(buf, string, offset, length) {
    return $c0c91deafda60d52$var$blitBuffer($c0c91deafda60d52$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c0c91deafda60d52$var$asciiWrite(buf, string, offset, length) {
    return $c0c91deafda60d52$var$blitBuffer($c0c91deafda60d52$var$asciiToBytes(string), buf, offset, length);
}
function $c0c91deafda60d52$var$base64Write(buf, string, offset, length) {
    return $c0c91deafda60d52$var$blitBuffer($c0c91deafda60d52$var$base64ToBytes(string), buf, offset, length);
}
function $c0c91deafda60d52$var$ucs2Write(buf, string, offset, length) {
    return $c0c91deafda60d52$var$blitBuffer($c0c91deafda60d52$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c0c91deafda60d52$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $c0c91deafda60d52$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $c0c91deafda60d52$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $c0c91deafda60d52$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $c0c91deafda60d52$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c0c91deafda60d52$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c0c91deafda60d52$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c0c91deafda60d52$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $fw7rd.fromByteArray(buf);
    else return $fw7rd.fromByteArray(buf.slice(start, end));
}
function $c0c91deafda60d52$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c0c91deafda60d52$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $c0c91deafda60d52$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c0c91deafda60d52$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $c0c91deafda60d52$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c0c91deafda60d52$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c0c91deafda60d52$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c0c91deafda60d52$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c0c91deafda60d52$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $c0c91deafda60d52$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c0c91deafda60d52$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c0c91deafda60d52$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c0c91deafda60d52$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c0c91deafda60d52$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$c0c91deafda60d52$var$Buffer.prototype.readUintLE = $c0c91deafda60d52$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c0c91deafda60d52$var$Buffer.prototype.readUintBE = $c0c91deafda60d52$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c0c91deafda60d52$var$Buffer.prototype.readUint8 = $c0c91deafda60d52$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c0c91deafda60d52$var$Buffer.prototype.readUint16LE = $c0c91deafda60d52$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c0c91deafda60d52$var$Buffer.prototype.readUint16BE = $c0c91deafda60d52$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c0c91deafda60d52$var$Buffer.prototype.readUint32LE = $c0c91deafda60d52$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c0c91deafda60d52$var$Buffer.prototype.readUint32BE = $c0c91deafda60d52$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c0c91deafda60d52$var$Buffer.prototype.readBigUInt64LE = $c0c91deafda60d52$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c0c91deafda60d52$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c0c91deafda60d52$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c0c91deafda60d52$var$Buffer.prototype.readBigUInt64BE = $c0c91deafda60d52$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c0c91deafda60d52$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c0c91deafda60d52$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c0c91deafda60d52$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c0c91deafda60d52$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c0c91deafda60d52$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c0c91deafda60d52$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c0c91deafda60d52$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c0c91deafda60d52$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c0c91deafda60d52$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c0c91deafda60d52$var$Buffer.prototype.readBigInt64LE = $c0c91deafda60d52$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c0c91deafda60d52$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c0c91deafda60d52$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$c0c91deafda60d52$var$Buffer.prototype.readBigInt64BE = $c0c91deafda60d52$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c0c91deafda60d52$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c0c91deafda60d52$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$c0c91deafda60d52$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, 4, this.length);
    return $33ED1.read(this, offset, true, 23, 4);
};
$c0c91deafda60d52$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, 4, this.length);
    return $33ED1.read(this, offset, false, 23, 4);
};
$c0c91deafda60d52$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, 8, this.length);
    return $33ED1.read(this, offset, true, 52, 8);
};
$c0c91deafda60d52$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkOffset(offset, 8, this.length);
    return $33ED1.read(this, offset, false, 52, 8);
};
function $c0c91deafda60d52$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c0c91deafda60d52$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$c0c91deafda60d52$var$Buffer.prototype.writeUintLE = $c0c91deafda60d52$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c0c91deafda60d52$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c0c91deafda60d52$var$Buffer.prototype.writeUintBE = $c0c91deafda60d52$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c0c91deafda60d52$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c0c91deafda60d52$var$Buffer.prototype.writeUint8 = $c0c91deafda60d52$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c0c91deafda60d52$var$Buffer.prototype.writeUint16LE = $c0c91deafda60d52$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c0c91deafda60d52$var$Buffer.prototype.writeUint16BE = $c0c91deafda60d52$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c0c91deafda60d52$var$Buffer.prototype.writeUint32LE = $c0c91deafda60d52$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c0c91deafda60d52$var$Buffer.prototype.writeUint32BE = $c0c91deafda60d52$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c0c91deafda60d52$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c0c91deafda60d52$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c0c91deafda60d52$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c0c91deafda60d52$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c0c91deafda60d52$var$Buffer.prototype.writeBigUInt64LE = $c0c91deafda60d52$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $c0c91deafda60d52$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c0c91deafda60d52$var$Buffer.prototype.writeBigUInt64BE = $c0c91deafda60d52$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $c0c91deafda60d52$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c0c91deafda60d52$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c0c91deafda60d52$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c0c91deafda60d52$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c0c91deafda60d52$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c0c91deafda60d52$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c0c91deafda60d52$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c0c91deafda60d52$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c0c91deafda60d52$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c0c91deafda60d52$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c0c91deafda60d52$var$Buffer.prototype.writeBigInt64LE = $c0c91deafda60d52$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $c0c91deafda60d52$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$c0c91deafda60d52$var$Buffer.prototype.writeBigInt64BE = $c0c91deafda60d52$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $c0c91deafda60d52$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $c0c91deafda60d52$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $c0c91deafda60d52$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $33ED1.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c0c91deafda60d52$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c0c91deafda60d52$var$writeFloat(this, value, offset, true, noAssert);
};
$c0c91deafda60d52$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c0c91deafda60d52$var$writeFloat(this, value, offset, false, noAssert);
};
function $c0c91deafda60d52$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0c91deafda60d52$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $33ED1.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c0c91deafda60d52$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c0c91deafda60d52$var$writeDouble(this, value, offset, true, noAssert);
};
$c0c91deafda60d52$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c0c91deafda60d52$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c0c91deafda60d52$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c0c91deafda60d52$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c0c91deafda60d52$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$c0c91deafda60d52$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $c0c91deafda60d52$var$Buffer.isBuffer(val) ? val : $c0c91deafda60d52$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $c0c91deafda60d52$var$errors = {};
function $c0c91deafda60d52$var$E(sym, getMessage, Base) {
    $c0c91deafda60d52$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$c0c91deafda60d52$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$c0c91deafda60d52$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$c0c91deafda60d52$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c0c91deafda60d52$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $c0c91deafda60d52$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $c0c91deafda60d52$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $c0c91deafda60d52$var$checkBounds(buf, offset, byteLength) {
    $c0c91deafda60d52$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c0c91deafda60d52$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c0c91deafda60d52$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $c0c91deafda60d52$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $c0c91deafda60d52$var$checkBounds(buf, offset, byteLength);
}
function $c0c91deafda60d52$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $c0c91deafda60d52$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $c0c91deafda60d52$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c0c91deafda60d52$var$validateNumber(value, type);
        throw new $c0c91deafda60d52$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $c0c91deafda60d52$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c0c91deafda60d52$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $c0c91deafda60d52$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c0c91deafda60d52$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c0c91deafda60d52$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $c0c91deafda60d52$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $c0c91deafda60d52$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c0c91deafda60d52$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c0c91deafda60d52$var$base64ToBytes(str) {
    return $fw7rd.toByteArray($c0c91deafda60d52$var$base64clean(str));
}
function $c0c91deafda60d52$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c0c91deafda60d52$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c0c91deafda60d52$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $c0c91deafda60d52$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c0c91deafda60d52$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $c0c91deafda60d52$var$BufferBigIntNotDefined : fn;
}
function $c0c91deafda60d52$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("fw7rd", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $b4bf9d2c8f39e965$export$d622b2ad8d90c771; }, function (v) { return $b4bf9d2c8f39e965$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $b4bf9d2c8f39e965$export$6100ba28696e12de; }, function (v) { return $b4bf9d2c8f39e965$export$6100ba28696e12de = v; });
var $b4bf9d2c8f39e965$export$a48f0734ac7c2329;
var $b4bf9d2c8f39e965$export$d622b2ad8d90c771;
var $b4bf9d2c8f39e965$export$6100ba28696e12de;
"use strict";
$b4bf9d2c8f39e965$export$a48f0734ac7c2329 = $b4bf9d2c8f39e965$var$byteLength;
$b4bf9d2c8f39e965$export$d622b2ad8d90c771 = $b4bf9d2c8f39e965$var$toByteArray;
$b4bf9d2c8f39e965$export$6100ba28696e12de = $b4bf9d2c8f39e965$var$fromByteArray;
var $b4bf9d2c8f39e965$var$lookup = [];
var $b4bf9d2c8f39e965$var$revLookup = [];
var $b4bf9d2c8f39e965$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $b4bf9d2c8f39e965$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $b4bf9d2c8f39e965$var$i = 0, $b4bf9d2c8f39e965$var$len = $b4bf9d2c8f39e965$var$code.length; $b4bf9d2c8f39e965$var$i < $b4bf9d2c8f39e965$var$len; ++$b4bf9d2c8f39e965$var$i){
    $b4bf9d2c8f39e965$var$lookup[$b4bf9d2c8f39e965$var$i] = $b4bf9d2c8f39e965$var$code[$b4bf9d2c8f39e965$var$i];
    $b4bf9d2c8f39e965$var$revLookup[$b4bf9d2c8f39e965$var$code.charCodeAt($b4bf9d2c8f39e965$var$i)] = $b4bf9d2c8f39e965$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$b4bf9d2c8f39e965$var$revLookup["-".charCodeAt(0)] = 62;
$b4bf9d2c8f39e965$var$revLookup["_".charCodeAt(0)] = 63;
function $b4bf9d2c8f39e965$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $b4bf9d2c8f39e965$var$byteLength(b64) {
    var lens = $b4bf9d2c8f39e965$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $b4bf9d2c8f39e965$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $b4bf9d2c8f39e965$var$toByteArray(b64) {
    var tmp;
    var lens = $b4bf9d2c8f39e965$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $b4bf9d2c8f39e965$var$Arr($b4bf9d2c8f39e965$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $b4bf9d2c8f39e965$var$revLookup[b64.charCodeAt(i)] << 18 | $b4bf9d2c8f39e965$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $b4bf9d2c8f39e965$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $b4bf9d2c8f39e965$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $b4bf9d2c8f39e965$var$revLookup[b64.charCodeAt(i)] << 2 | $b4bf9d2c8f39e965$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $b4bf9d2c8f39e965$var$revLookup[b64.charCodeAt(i)] << 10 | $b4bf9d2c8f39e965$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $b4bf9d2c8f39e965$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $b4bf9d2c8f39e965$var$tripletToBase64(num) {
    return $b4bf9d2c8f39e965$var$lookup[num >> 18 & 0x3F] + $b4bf9d2c8f39e965$var$lookup[num >> 12 & 0x3F] + $b4bf9d2c8f39e965$var$lookup[num >> 6 & 0x3F] + $b4bf9d2c8f39e965$var$lookup[num & 0x3F];
}
function $b4bf9d2c8f39e965$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($b4bf9d2c8f39e965$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $b4bf9d2c8f39e965$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($b4bf9d2c8f39e965$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($b4bf9d2c8f39e965$var$lookup[tmp >> 2] + $b4bf9d2c8f39e965$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($b4bf9d2c8f39e965$var$lookup[tmp >> 10] + $b4bf9d2c8f39e965$var$lookup[tmp >> 4 & 0x3F] + $b4bf9d2c8f39e965$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("33ED1", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $23a12ae2b39cd622$export$aafa59e2e03f2942; }, function (v) { return $23a12ae2b39cd622$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $23a12ae2b39cd622$export$68d8715fc104d294; }, function (v) { return $23a12ae2b39cd622$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $23a12ae2b39cd622$export$aafa59e2e03f2942;
var $23a12ae2b39cd622$export$68d8715fc104d294;
$23a12ae2b39cd622$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$23a12ae2b39cd622$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("3U7jb", function(module, exports) {
"use strict";

});

parcelRegister("bGgJU", function(module, exports) {
"use strict";
function $88109a0fe4ae2765$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $88109a0fe4ae2765$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $88109a0fe4ae2765$var$ownKeys(Object(source), true).forEach(function(key) {
            $88109a0fe4ae2765$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $88109a0fe4ae2765$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $88109a0fe4ae2765$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $88109a0fe4ae2765$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $88109a0fe4ae2765$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $88109a0fe4ae2765$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $88109a0fe4ae2765$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $88109a0fe4ae2765$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

var $gybZ1 = parcelRequire("gybZ1");
var $88109a0fe4ae2765$var$Buffer = $gybZ1.Buffer;

var $3U7jb = parcelRequire("3U7jb");
var $88109a0fe4ae2765$var$inspect = $3U7jb.inspect;
var $88109a0fe4ae2765$var$custom = $88109a0fe4ae2765$var$inspect && $88109a0fe4ae2765$var$inspect.custom || "inspect";
function $88109a0fe4ae2765$var$copyBuffer(src, target, offset) {
    $88109a0fe4ae2765$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $88109a0fe4ae2765$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $88109a0fe4ae2765$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $88109a0fe4ae2765$var$Buffer.alloc(0);
                var ret = $88109a0fe4ae2765$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $88109a0fe4ae2765$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            } // Consumes a specified amount of bytes or characters from the buffered data.
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            } // Consumes a specified amount of characters from the buffered data.
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Consumes a specified amount of bytes from the buffered data.
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $88109a0fe4ae2765$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Make sure the linked list only shows the minimal necessary information.
        },
        {
            key: $88109a0fe4ae2765$var$custom,
            value: function value(_, options) {
                return $88109a0fe4ae2765$var$inspect(this, $88109a0fe4ae2765$var$_objectSpread({}, options, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("cSIRM", function(module, exports) {

var $dpptK = parcelRequire("dpptK");
"use strict"; // undocumented cb() API, needed for core, not for public API
function $960d54b34a4396c8$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $dpptK.nextTick($960d54b34a4396c8$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $dpptK.nextTick($960d54b34a4396c8$var$emitErrorNT, this, err);
            }
        }
        return this;
    } // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
     // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $dpptK.nextTick($960d54b34a4396c8$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $dpptK.nextTick($960d54b34a4396c8$var$emitErrorAndCloseNT, _this, err);
            } else $dpptK.nextTick($960d54b34a4396c8$var$emitCloseNT, _this);
        } else if (cb) {
            $dpptK.nextTick($960d54b34a4396c8$var$emitCloseNT, _this);
            cb(err);
        } else $dpptK.nextTick($960d54b34a4396c8$var$emitCloseNT, _this);
    });
    return this;
}
function $960d54b34a4396c8$var$emitErrorAndCloseNT(self, err) {
    $960d54b34a4396c8$var$emitErrorNT(self, err);
    $960d54b34a4396c8$var$emitCloseNT(self);
}
function $960d54b34a4396c8$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $960d54b34a4396c8$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $960d54b34a4396c8$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $960d54b34a4396c8$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $960d54b34a4396c8$var$destroy,
    undestroy: $960d54b34a4396c8$var$undestroy,
    errorOrDestroy: $960d54b34a4396c8$var$errorOrDestroy
};

});

parcelRegister("9GDZh", function(module, exports) {
"use strict";

var $70d70df7d56f0e03$var$ERR_INVALID_OPT_VALUE = (parcelRequire("aiAV0")).codes.ERR_INVALID_OPT_VALUE;
function $70d70df7d56f0e03$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $70d70df7d56f0e03$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $70d70df7d56f0e03$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $70d70df7d56f0e03$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    } // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $70d70df7d56f0e03$var$getHighWaterMark
};

});
parcelRegister("aiAV0", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $77f839144798542e$export$e45cb6485273080e; }, function (v) { return $77f839144798542e$export$e45cb6485273080e = v; });
var $77f839144798542e$export$e45cb6485273080e;
"use strict";
function $77f839144798542e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $77f839144798542e$var$codes = {};
function $77f839144798542e$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $77f839144798542e$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $77f839144798542e$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $77f839144798542e$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $77f839144798542e$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $77f839144798542e$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $77f839144798542e$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$77f839144798542e$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$77f839144798542e$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $77f839144798542e$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($77f839144798542e$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($77f839144798542e$var$oneOf(expected, "type"));
    else {
        var type = $77f839144798542e$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($77f839144798542e$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$77f839144798542e$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$77f839144798542e$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$77f839144798542e$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$77f839144798542e$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$77f839144798542e$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$77f839144798542e$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$77f839144798542e$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$77f839144798542e$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$77f839144798542e$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$77f839144798542e$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$77f839144798542e$export$e45cb6485273080e = $77f839144798542e$var$codes;

});


parcelRegister("ku3t4", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $dpptK = parcelRequire("dpptK");
"use strict";
/*<replacement>*/ var $ee994c9e6721fe4a$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $ee994c9e6721fe4a$var$Duplex;

var $6Vpap = parcelRequire("6Vpap");

var $hmkR8 = parcelRequire("hmkR8");

(parcelRequire("gmyMj"))($ee994c9e6721fe4a$var$Duplex, $6Vpap);
// Allow the keys array to be GC'ed.
var $ee994c9e6721fe4a$var$keys = $ee994c9e6721fe4a$var$objectKeys($hmkR8.prototype);
for(var $ee994c9e6721fe4a$var$v = 0; $ee994c9e6721fe4a$var$v < $ee994c9e6721fe4a$var$keys.length; $ee994c9e6721fe4a$var$v++){
    var $ee994c9e6721fe4a$var$method = $ee994c9e6721fe4a$var$keys[$ee994c9e6721fe4a$var$v];
    if (!$ee994c9e6721fe4a$var$Duplex.prototype[$ee994c9e6721fe4a$var$method]) $ee994c9e6721fe4a$var$Duplex.prototype[$ee994c9e6721fe4a$var$method] = $hmkR8.prototype[$ee994c9e6721fe4a$var$method];
}
function $ee994c9e6721fe4a$var$Duplex(options) {
    if (!(this instanceof $ee994c9e6721fe4a$var$Duplex)) return new $ee994c9e6721fe4a$var$Duplex(options);
    $6Vpap.call(this, options);
    $hmkR8.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $ee994c9e6721fe4a$var$onend);
        }
    }
}
Object.defineProperty($ee994c9e6721fe4a$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($ee994c9e6721fe4a$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($ee994c9e6721fe4a$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
}); // the no-half-open enforcer
function $ee994c9e6721fe4a$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.
    $dpptK.nextTick($ee994c9e6721fe4a$var$onEndNT, this);
}
function $ee994c9e6721fe4a$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($ee994c9e6721fe4a$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("hmkR8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $dpptK = parcelRequire("dpptK");
"use strict";
module.exports = $ca34ab527aaf587a$var$Writable;
/* <replacement> */ function $ca34ab527aaf587a$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream
function $ca34ab527aaf587a$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $ca34ab527aaf587a$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $ca34ab527aaf587a$var$Duplex;
/*</replacement>*/ $ca34ab527aaf587a$var$Writable.WritableState = $ca34ab527aaf587a$var$WritableState;

/*<replacement>*/ var $ca34ab527aaf587a$var$internalUtil = {
    deprecate: (parcelRequire("49ajz"))
};

var $1zBkE = parcelRequire("1zBkE");

var $gybZ1 = parcelRequire("gybZ1");
var $ca34ab527aaf587a$require$Buffer = $gybZ1.Buffer;
var $ca34ab527aaf587a$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $ca34ab527aaf587a$var$_uint8ArrayToBuffer(chunk) {
    return $ca34ab527aaf587a$require$Buffer.from(chunk);
}
function $ca34ab527aaf587a$var$_isUint8Array(obj) {
    return $ca34ab527aaf587a$require$Buffer.isBuffer(obj) || obj instanceof $ca34ab527aaf587a$var$OurUint8Array;
}

var $cSIRM = parcelRequire("cSIRM");

var $9GDZh = parcelRequire("9GDZh");
var $ca34ab527aaf587a$var$getHighWaterMark = $9GDZh.getHighWaterMark;

var $aiAV0 = parcelRequire("aiAV0");
var $ca34ab527aaf587a$require$_require$codes = $aiAV0.codes;
var $ca34ab527aaf587a$var$ERR_INVALID_ARG_TYPE = $ca34ab527aaf587a$require$_require$codes.ERR_INVALID_ARG_TYPE, $ca34ab527aaf587a$var$ERR_METHOD_NOT_IMPLEMENTED = $ca34ab527aaf587a$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $ca34ab527aaf587a$var$ERR_MULTIPLE_CALLBACK = $ca34ab527aaf587a$require$_require$codes.ERR_MULTIPLE_CALLBACK, $ca34ab527aaf587a$var$ERR_STREAM_CANNOT_PIPE = $ca34ab527aaf587a$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $ca34ab527aaf587a$var$ERR_STREAM_DESTROYED = $ca34ab527aaf587a$require$_require$codes.ERR_STREAM_DESTROYED, $ca34ab527aaf587a$var$ERR_STREAM_NULL_VALUES = $ca34ab527aaf587a$require$_require$codes.ERR_STREAM_NULL_VALUES, $ca34ab527aaf587a$var$ERR_STREAM_WRITE_AFTER_END = $ca34ab527aaf587a$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $ca34ab527aaf587a$var$ERR_UNKNOWN_ENCODING = $ca34ab527aaf587a$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $ca34ab527aaf587a$var$errorOrDestroy = $cSIRM.errorOrDestroy;

(parcelRequire("gmyMj"))($ca34ab527aaf587a$var$Writable, $1zBkE);
function $ca34ab527aaf587a$var$nop() {}

function $ca34ab527aaf587a$var$WritableState(options, stream, isDuplex) {
    $ca34ab527aaf587a$var$Duplex = $ca34ab527aaf587a$var$Duplex || (parcelRequire("ku3t4"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $ca34ab527aaf587a$var$Duplex; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $ca34ab527aaf587a$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex); // if _final has been called
    this.finalCalled = false; // drain event flag.
    this.needDrain = false; // at the start of calling end()
    this.ending = false; // when end() has been called, and returned
    this.ended = false; // when 'finish' is emitted
    this.finished = false; // has it been destroyed
    this.destroyed = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0; // a flag to see when we're in the middle of a write.
    this.writing = false; // when true all writes will be buffered until .uncork() call
    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $ca34ab527aaf587a$var$onwrite(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null; // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false; // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy; // count buffered requests
    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $ca34ab527aaf587a$var$CorkedRequest(this);
}
$ca34ab527aaf587a$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($ca34ab527aaf587a$var$WritableState.prototype, "buffer", {
            get: $ca34ab527aaf587a$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $ca34ab527aaf587a$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $ca34ab527aaf587a$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($ca34ab527aaf587a$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($ca34ab527aaf587a$var$realHasInstance.call(this, object)) return true;
            if (this !== $ca34ab527aaf587a$var$Writable) return false;
            return object && object._writableState instanceof $ca34ab527aaf587a$var$WritableState;
        }
    });
} else $ca34ab527aaf587a$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $ca34ab527aaf587a$var$Writable(options) {
    $ca34ab527aaf587a$var$Duplex = $ca34ab527aaf587a$var$Duplex || (parcelRequire("ku3t4")); // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $ca34ab527aaf587a$var$Duplex;
    if (!isDuplex && !$ca34ab527aaf587a$var$realHasInstance.call($ca34ab527aaf587a$var$Writable, this)) return new $ca34ab527aaf587a$var$Writable(options);
    this._writableState = new $ca34ab527aaf587a$var$WritableState(options, this, isDuplex); // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $1zBkE.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.
$ca34ab527aaf587a$var$Writable.prototype.pipe = function() {
    $ca34ab527aaf587a$var$errorOrDestroy(this, new $ca34ab527aaf587a$var$ERR_STREAM_CANNOT_PIPE());
};
function $ca34ab527aaf587a$var$writeAfterEnd(stream, cb) {
    var er = new $ca34ab527aaf587a$var$ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
    $ca34ab527aaf587a$var$errorOrDestroy(stream, er);
    $dpptK.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $ca34ab527aaf587a$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $ca34ab527aaf587a$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $ca34ab527aaf587a$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $ca34ab527aaf587a$var$errorOrDestroy(stream, er);
        $dpptK.nextTick(cb, er);
        return false;
    }
    return true;
}
$ca34ab527aaf587a$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $ca34ab527aaf587a$var$_isUint8Array(chunk);
    if (isBuf && !$ca34ab527aaf587a$require$Buffer.isBuffer(chunk)) chunk = $ca34ab527aaf587a$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $ca34ab527aaf587a$var$nop;
    if (state.ending) $ca34ab527aaf587a$var$writeAfterEnd(this, cb);
    else if (isBuf || $ca34ab527aaf587a$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $ca34ab527aaf587a$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$ca34ab527aaf587a$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$ca34ab527aaf587a$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $ca34ab527aaf587a$var$clearBuffer(this, state);
    }
};
$ca34ab527aaf587a$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $ca34ab527aaf587a$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($ca34ab527aaf587a$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $ca34ab527aaf587a$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $ca34ab527aaf587a$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($ca34ab527aaf587a$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $ca34ab527aaf587a$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $ca34ab527aaf587a$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $ca34ab527aaf587a$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $ca34ab527aaf587a$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $ca34ab527aaf587a$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $ca34ab527aaf587a$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $dpptK.nextTick(cb, er); // this can emit finish, and it will always happen
        // after error
        $dpptK.nextTick($ca34ab527aaf587a$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $ca34ab527aaf587a$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $ca34ab527aaf587a$var$errorOrDestroy(stream, er); // this can emit finish, but finish must
        // always follow error
        $ca34ab527aaf587a$var$finishMaybe(stream, state);
    }
}
function $ca34ab527aaf587a$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $ca34ab527aaf587a$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $ca34ab527aaf587a$var$ERR_MULTIPLE_CALLBACK();
    $ca34ab527aaf587a$var$onwriteStateUpdate(state);
    if (er) $ca34ab527aaf587a$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $ca34ab527aaf587a$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $ca34ab527aaf587a$var$clearBuffer(stream, state);
        if (sync) $dpptK.nextTick($ca34ab527aaf587a$var$afterWrite, stream, state, finished, cb);
        else $ca34ab527aaf587a$var$afterWrite(stream, state, finished, cb);
    }
}
function $ca34ab527aaf587a$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $ca34ab527aaf587a$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $ca34ab527aaf587a$var$finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $ca34ab527aaf587a$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
} // if there's something in the buffer waiting, then process it
function $ca34ab527aaf587a$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $ca34ab527aaf587a$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish); // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $ca34ab527aaf587a$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $ca34ab527aaf587a$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$ca34ab527aaf587a$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $ca34ab527aaf587a$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$ca34ab527aaf587a$var$Writable.prototype._writev = null;
$ca34ab527aaf587a$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    } // ignore unnecessary end() calls.
    if (!state.ending) $ca34ab527aaf587a$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($ca34ab527aaf587a$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $ca34ab527aaf587a$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $ca34ab527aaf587a$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $ca34ab527aaf587a$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $ca34ab527aaf587a$var$finishMaybe(stream, state);
    });
}
function $ca34ab527aaf587a$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $dpptK.nextTick($ca34ab527aaf587a$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $ca34ab527aaf587a$var$finishMaybe(stream, state) {
    var need = $ca34ab527aaf587a$var$needFinish(state);
    if (need) {
        $ca34ab527aaf587a$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $ca34ab527aaf587a$var$endWritable(stream, state, cb) {
    state.ending = true;
    $ca34ab527aaf587a$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $dpptK.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $ca34ab527aaf587a$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    } // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($ca34ab527aaf587a$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$ca34ab527aaf587a$var$Writable.prototype.destroy = $cSIRM.destroy;
$ca34ab527aaf587a$var$Writable.prototype._undestroy = $cSIRM.undestroy;
$ca34ab527aaf587a$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("49ajz", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $305000f01c3cfe53$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $305000f01c3cfe53$var$deprecate(fn, msg) {
    if ($305000f01c3cfe53$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($305000f01c3cfe53$var$config("throwDeprecation")) throw new Error(msg);
            else if ($305000f01c3cfe53$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $305000f01c3cfe53$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("g9yY1", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $bc289c55a11cd6c8$export$63a7aa211a91ed69; }, function (v) { return $bc289c55a11cd6c8$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $bc289c55a11cd6c8$export$63a7aa211a91ed69;
"use strict";

var $9vKT6 = parcelRequire("9vKT6");
var $bc289c55a11cd6c8$require$Buffer = $9vKT6.Buffer;
/*</replacement>*/ var $bc289c55a11cd6c8$var$isEncoding = $bc289c55a11cd6c8$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $bc289c55a11cd6c8$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $bc289c55a11cd6c8$var$normalizeEncoding(enc) {
    var nenc = $bc289c55a11cd6c8$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($bc289c55a11cd6c8$require$Buffer.isEncoding === $bc289c55a11cd6c8$var$isEncoding || !$bc289c55a11cd6c8$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$bc289c55a11cd6c8$export$63a7aa211a91ed69 = $bc289c55a11cd6c8$var$StringDecoder;
function $bc289c55a11cd6c8$var$StringDecoder(encoding) {
    this.encoding = $bc289c55a11cd6c8$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $bc289c55a11cd6c8$var$utf16Text;
            this.end = $bc289c55a11cd6c8$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $bc289c55a11cd6c8$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $bc289c55a11cd6c8$var$base64Text;
            this.end = $bc289c55a11cd6c8$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $bc289c55a11cd6c8$var$simpleWrite;
            this.end = $bc289c55a11cd6c8$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $bc289c55a11cd6c8$require$Buffer.allocUnsafe(nb);
}
$bc289c55a11cd6c8$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$bc289c55a11cd6c8$var$StringDecoder.prototype.end = $bc289c55a11cd6c8$var$utf8End;
// Returns only complete characters in a Buffer
$bc289c55a11cd6c8$var$StringDecoder.prototype.text = $bc289c55a11cd6c8$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$bc289c55a11cd6c8$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $bc289c55a11cd6c8$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $bc289c55a11cd6c8$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $bc289c55a11cd6c8$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $bc289c55a11cd6c8$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $bc289c55a11cd6c8$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $bc289c55a11cd6c8$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $bc289c55a11cd6c8$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $bc289c55a11cd6c8$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $bc289c55a11cd6c8$var$utf8Text(buf, i) {
    var total = $bc289c55a11cd6c8$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $bc289c55a11cd6c8$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $bc289c55a11cd6c8$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $bc289c55a11cd6c8$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $bc289c55a11cd6c8$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $bc289c55a11cd6c8$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $bc289c55a11cd6c8$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $bc289c55a11cd6c8$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("9vKT6", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $gybZ1 = parcelRequire("gybZ1");
var $6ecb613cd7c4e68e$var$Buffer = $gybZ1.Buffer;
// alternative to using Object.keys for old browsers
function $6ecb613cd7c4e68e$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($6ecb613cd7c4e68e$var$Buffer.from && $6ecb613cd7c4e68e$var$Buffer.alloc && $6ecb613cd7c4e68e$var$Buffer.allocUnsafe && $6ecb613cd7c4e68e$var$Buffer.allocUnsafeSlow) module.exports = $gybZ1;
else {
    // Copy properties from require('buffer')
    $6ecb613cd7c4e68e$var$copyProps($gybZ1, module.exports);
    module.exports.Buffer = $6ecb613cd7c4e68e$var$SafeBuffer;
}
function $6ecb613cd7c4e68e$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $6ecb613cd7c4e68e$var$Buffer(arg, encodingOrOffset, length);
}
$6ecb613cd7c4e68e$var$SafeBuffer.prototype = Object.create($6ecb613cd7c4e68e$var$Buffer.prototype);
// Copy static methods from Buffer
$6ecb613cd7c4e68e$var$copyProps($6ecb613cd7c4e68e$var$Buffer, $6ecb613cd7c4e68e$var$SafeBuffer);
$6ecb613cd7c4e68e$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $6ecb613cd7c4e68e$var$Buffer(arg, encodingOrOffset, length);
};
$6ecb613cd7c4e68e$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $6ecb613cd7c4e68e$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$6ecb613cd7c4e68e$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ecb613cd7c4e68e$var$Buffer(size);
};
$6ecb613cd7c4e68e$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $gybZ1.SlowBuffer(size);
};

});


parcelRegister("aWjrY", function(module, exports) {

var $dpptK = parcelRequire("dpptK");
"use strict";
var $7f6e6890537ee71f$var$_Object$setPrototypeO;
function $7f6e6890537ee71f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $4kxK8 = parcelRequire("4kxK8");
var $7f6e6890537ee71f$var$kLastResolve = Symbol("lastResolve");
var $7f6e6890537ee71f$var$kLastReject = Symbol("lastReject");
var $7f6e6890537ee71f$var$kError = Symbol("error");
var $7f6e6890537ee71f$var$kEnded = Symbol("ended");
var $7f6e6890537ee71f$var$kLastPromise = Symbol("lastPromise");
var $7f6e6890537ee71f$var$kHandlePromise = Symbol("handlePromise");
var $7f6e6890537ee71f$var$kStream = Symbol("stream");
function $7f6e6890537ee71f$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $7f6e6890537ee71f$var$readAndResolve(iter) {
    var resolve = iter[$7f6e6890537ee71f$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$7f6e6890537ee71f$var$kStream].read(); // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$7f6e6890537ee71f$var$kLastPromise] = null;
            iter[$7f6e6890537ee71f$var$kLastResolve] = null;
            iter[$7f6e6890537ee71f$var$kLastReject] = null;
            resolve($7f6e6890537ee71f$var$createIterResult(data, false));
        }
    }
}
function $7f6e6890537ee71f$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $dpptK.nextTick($7f6e6890537ee71f$var$readAndResolve, iter);
}
function $7f6e6890537ee71f$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$7f6e6890537ee71f$var$kEnded]) {
                resolve($7f6e6890537ee71f$var$createIterResult(undefined, true));
                return;
            }
            iter[$7f6e6890537ee71f$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $7f6e6890537ee71f$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $7f6e6890537ee71f$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($7f6e6890537ee71f$var$_Object$setPrototypeO = {
    get stream () {
        return this[$7f6e6890537ee71f$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$7f6e6890537ee71f$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$7f6e6890537ee71f$var$kEnded]) return Promise.resolve($7f6e6890537ee71f$var$createIterResult(undefined, true));
        if (this[$7f6e6890537ee71f$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $dpptK.nextTick(function() {
                if (_this[$7f6e6890537ee71f$var$kError]) reject(_this[$7f6e6890537ee71f$var$kError]);
                else resolve($7f6e6890537ee71f$var$createIterResult(undefined, true));
            });
        });
         // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$7f6e6890537ee71f$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($7f6e6890537ee71f$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$7f6e6890537ee71f$var$kStream].read();
            if (data !== null) return Promise.resolve($7f6e6890537ee71f$var$createIterResult(data, false));
            promise = new Promise(this[$7f6e6890537ee71f$var$kHandlePromise]);
        }
        this[$7f6e6890537ee71f$var$kLastPromise] = promise;
        return promise;
    }
}, $7f6e6890537ee71f$var$_defineProperty($7f6e6890537ee71f$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $7f6e6890537ee71f$var$_defineProperty($7f6e6890537ee71f$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$7f6e6890537ee71f$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($7f6e6890537ee71f$var$createIterResult(undefined, true));
        });
    });
}), $7f6e6890537ee71f$var$_Object$setPrototypeO), $7f6e6890537ee71f$var$AsyncIteratorPrototype);
var $7f6e6890537ee71f$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($7f6e6890537ee71f$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $7f6e6890537ee71f$var$_defineProperty(_Object$create, $7f6e6890537ee71f$var$kStream, {
        value: stream,
        writable: true
    }), $7f6e6890537ee71f$var$_defineProperty(_Object$create, $7f6e6890537ee71f$var$kLastResolve, {
        value: null,
        writable: true
    }), $7f6e6890537ee71f$var$_defineProperty(_Object$create, $7f6e6890537ee71f$var$kLastReject, {
        value: null,
        writable: true
    }), $7f6e6890537ee71f$var$_defineProperty(_Object$create, $7f6e6890537ee71f$var$kError, {
        value: null,
        writable: true
    }), $7f6e6890537ee71f$var$_defineProperty(_Object$create, $7f6e6890537ee71f$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $7f6e6890537ee71f$var$_defineProperty(_Object$create, $7f6e6890537ee71f$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$7f6e6890537ee71f$var$kStream].read();
            if (data) {
                iterator[$7f6e6890537ee71f$var$kLastPromise] = null;
                iterator[$7f6e6890537ee71f$var$kLastResolve] = null;
                iterator[$7f6e6890537ee71f$var$kLastReject] = null;
                resolve($7f6e6890537ee71f$var$createIterResult(data, false));
            } else {
                iterator[$7f6e6890537ee71f$var$kLastResolve] = resolve;
                iterator[$7f6e6890537ee71f$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$7f6e6890537ee71f$var$kLastPromise] = null;
    $4kxK8(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$7f6e6890537ee71f$var$kLastReject]; // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$7f6e6890537ee71f$var$kLastPromise] = null;
                iterator[$7f6e6890537ee71f$var$kLastResolve] = null;
                iterator[$7f6e6890537ee71f$var$kLastReject] = null;
                reject(err);
            }
            iterator[$7f6e6890537ee71f$var$kError] = err;
            return;
        }
        var resolve = iterator[$7f6e6890537ee71f$var$kLastResolve];
        if (resolve !== null) {
            iterator[$7f6e6890537ee71f$var$kLastPromise] = null;
            iterator[$7f6e6890537ee71f$var$kLastResolve] = null;
            iterator[$7f6e6890537ee71f$var$kLastReject] = null;
            resolve($7f6e6890537ee71f$var$createIterResult(undefined, true));
        }
        iterator[$7f6e6890537ee71f$var$kEnded] = true;
    });
    stream.on("readable", $7f6e6890537ee71f$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $7f6e6890537ee71f$var$createReadableStreamAsyncIterator;

});
parcelRegister("4kxK8", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $3273345b69dc2dd9$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("aiAV0")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $3273345b69dc2dd9$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $3273345b69dc2dd9$var$noop() {}
function $3273345b69dc2dd9$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $3273345b69dc2dd9$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $3273345b69dc2dd9$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $3273345b69dc2dd9$var$once(callback || $3273345b69dc2dd9$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $3273345b69dc2dd9$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $3273345b69dc2dd9$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($3273345b69dc2dd9$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $3273345b69dc2dd9$var$eos;

});


parcelRegister("8iNn4", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("iN6gi", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $dae1a916f73231e8$var$Transform;

var $aiAV0 = parcelRequire("aiAV0");
var $dae1a916f73231e8$require$_require$codes = $aiAV0.codes;
var $dae1a916f73231e8$var$ERR_METHOD_NOT_IMPLEMENTED = $dae1a916f73231e8$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $dae1a916f73231e8$var$ERR_MULTIPLE_CALLBACK = $dae1a916f73231e8$require$_require$codes.ERR_MULTIPLE_CALLBACK, $dae1a916f73231e8$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $dae1a916f73231e8$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $dae1a916f73231e8$var$ERR_TRANSFORM_WITH_LENGTH_0 = $dae1a916f73231e8$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $ku3t4 = parcelRequire("ku3t4");

(parcelRequire("gmyMj"))($dae1a916f73231e8$var$Transform, $ku3t4);
function $dae1a916f73231e8$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $dae1a916f73231e8$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $dae1a916f73231e8$var$Transform(options) {
    if (!(this instanceof $dae1a916f73231e8$var$Transform)) return new $dae1a916f73231e8$var$Transform(options);
    $ku3t4.call(this, options);
    this._transformState = {
        afterTransform: $dae1a916f73231e8$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    }; // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    } // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $dae1a916f73231e8$var$prefinish);
}
function $dae1a916f73231e8$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $dae1a916f73231e8$var$done(_this, er, data);
    });
    else $dae1a916f73231e8$var$done(this, null, null);
}
$dae1a916f73231e8$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $ku3t4.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$dae1a916f73231e8$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $dae1a916f73231e8$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$dae1a916f73231e8$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$dae1a916f73231e8$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$dae1a916f73231e8$var$Transform.prototype._destroy = function(err, cb) {
    $ku3t4.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $dae1a916f73231e8$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $dae1a916f73231e8$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $dae1a916f73231e8$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("7pFip", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $565ae6b69bdc4a21$var$PassThrough;

var $iN6gi = parcelRequire("iN6gi");

(parcelRequire("gmyMj"))($565ae6b69bdc4a21$var$PassThrough, $iN6gi);
function $565ae6b69bdc4a21$var$PassThrough(options) {
    if (!(this instanceof $565ae6b69bdc4a21$var$PassThrough)) return new $565ae6b69bdc4a21$var$PassThrough(options);
    $iN6gi.call(this, options);
}
$565ae6b69bdc4a21$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("01yI0", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $004b048ad1d01604$var$eos;
function $004b048ad1d01604$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $aiAV0 = parcelRequire("aiAV0");
var $004b048ad1d01604$require$_require$codes = $aiAV0.codes;
var $004b048ad1d01604$var$ERR_MISSING_ARGS = $004b048ad1d01604$require$_require$codes.ERR_MISSING_ARGS, $004b048ad1d01604$var$ERR_STREAM_DESTROYED = $004b048ad1d01604$require$_require$codes.ERR_STREAM_DESTROYED;
function $004b048ad1d01604$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $004b048ad1d01604$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $004b048ad1d01604$var$destroyer(stream, reading, writing, callback) {
    callback = $004b048ad1d01604$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($004b048ad1d01604$var$eos === undefined) $004b048ad1d01604$var$eos = (parcelRequire("4kxK8"));
    $004b048ad1d01604$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true; // request.destroy just do .end - .abort is what we want
        if ($004b048ad1d01604$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $004b048ad1d01604$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $004b048ad1d01604$var$call(fn) {
    fn();
}
function $004b048ad1d01604$var$pipe(from, to) {
    return from.pipe(to);
}
function $004b048ad1d01604$var$popCallback(streams) {
    if (!streams.length) return $004b048ad1d01604$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $004b048ad1d01604$var$noop;
    return streams.pop();
}
function $004b048ad1d01604$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $004b048ad1d01604$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $004b048ad1d01604$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $004b048ad1d01604$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($004b048ad1d01604$var$call);
            if (reading) return;
            destroys.forEach($004b048ad1d01604$var$call);
            callback(error);
        });
    });
    return streams.reduce($004b048ad1d01604$var$pipe);
}
module.exports = $004b048ad1d01604$var$pipeline;

});



parcelRegister("egbTY", function(module, exports) {

$parcel$export(module.exports, "createOverlineStyles", function () { return $a61bcabfd7b0f0fe$export$44fa246b1b246e12; });
$parcel$export(module.exports, "createSubtitleStyles", function () { return $a61bcabfd7b0f0fe$export$c02b221f8c5c2fc8; });
$parcel$export(module.exports, "Heading", function () { return $a61bcabfd7b0f0fe$export$a8a3e93435678ff9; });
$parcel$export(module.exports, "Overline", function () { return $a61bcabfd7b0f0fe$export$6fb32aa36db1667d; });
$parcel$export(module.exports, "Lead", function () { return $a61bcabfd7b0f0fe$export$ba4d7ae5fb67789e; });
$parcel$export(module.exports, "Subtitle", function () { return $a61bcabfd7b0f0fe$export$cf345ef34cd72655; });
$parcel$export(module.exports, "Prose", function () { return $a61bcabfd7b0f0fe$export$9599cd3a25da89a5; });
$parcel$export(module.exports, "Table", function () { return $a61bcabfd7b0f0fe$export$54ec01a60f47d33d; });

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");
function $a61bcabfd7b0f0fe$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a61bcabfd7b0f0fe$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a61bcabfd7b0f0fe$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a61bcabfd7b0f0fe$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a61bcabfd7b0f0fe$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a61bcabfd7b0f0fe$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a61bcabfd7b0f0fe$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var $a61bcabfd7b0f0fe$var$_templateObject$2, $a61bcabfd7b0f0fe$var$_templateObject2$1, $a61bcabfd7b0f0fe$var$_templateObject3, $a61bcabfd7b0f0fe$var$_templateObject4, $a61bcabfd7b0f0fe$var$_templateObject5, $a61bcabfd7b0f0fe$var$_templateObject6;
var $a61bcabfd7b0f0fe$var$renderHeadingVariation = function renderHeadingVariation() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var variation = props.variation;
    if (!variation) return (0, $6fhRl.css)($a61bcabfd7b0f0fe$var$_templateObject$2 || ($a61bcabfd7b0f0fe$var$_templateObject$2 = $a61bcabfd7b0f0fe$var$_taggedTemplateLiteral([
        "\n      color: inherit;\n    "
    ])));
    else return (0, $6fhRl.css)($a61bcabfd7b0f0fe$var$_templateObject2$1 || ($a61bcabfd7b0f0fe$var$_templateObject2$1 = $a61bcabfd7b0f0fe$var$_taggedTemplateLiteral([
        "\n      color: ",
        ";\n    "
    ])), (0, $atWKR.themeVal)([
        "color",
        variation
    ]));
};
var $a61bcabfd7b0f0fe$var$sizeMapping = {
    xxsmall: "0.75rem",
    xsmall: "1rem",
    small: "1.25rem",
    medium: "1.5rem",
    large: "1.75rem",
    xlarge: "2rem",
    xxlarge: "2.25rem",
    jumbo: "3rem"
};
var $a61bcabfd7b0f0fe$export$634a6ab7e77e3062 = function renderHeadingSize() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size;
    return (0, $6fhRl.css)($a61bcabfd7b0f0fe$var$_templateObject3 || ($a61bcabfd7b0f0fe$var$_templateObject3 = $a61bcabfd7b0f0fe$var$_taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n    ",
        "\n  "
    ])), $a61bcabfd7b0f0fe$var$sizeMapping[size], size === "xxsmall" && "line-height: 1rem;");
};
var $a61bcabfd7b0f0fe$export$90953dc85ce65d2a = function createHeadingStyles(props) {
    return (0, $6fhRl.css)($a61bcabfd7b0f0fe$var$_templateObject4 || ($a61bcabfd7b0f0fe$var$_templateObject4 = $a61bcabfd7b0f0fe$var$_taggedTemplateLiteral([
        "\n  font-family: ",
        ";\n  text-transform: ",
        ";\n  font-weight: ",
        ";\n  font-style: ",
        ";\n  font-variation-settings: ",
        ";\n\n  /* Variation */\n  ",
        "\n\n  /* Size */\n  ",
        "\n"
    ])), (0, $atWKR.themeVal)("type.heading.family"), (0, $atWKR.themeVal)("type.heading.case"), (0, $atWKR.themeVal)("type.heading.weight"), (0, $atWKR.themeVal)("type.heading.style"), (0, $atWKR.themeVal)("type.heading.settings"), $a61bcabfd7b0f0fe$var$renderHeadingVariation(props), $a61bcabfd7b0f0fe$export$634a6ab7e77e3062(props));
};
var $a61bcabfd7b0f0fe$export$44fa246b1b246e12 = function createOverlineStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, $6fhRl.css)($a61bcabfd7b0f0fe$var$_templateObject5 || ($a61bcabfd7b0f0fe$var$_templateObject5 = $a61bcabfd7b0f0fe$var$_taggedTemplateLiteral([
        "\n  font-size: 0.75rem;\n  line-height: 1rem;\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  text-transform: ",
        ";\n  font-feature-settings: ",
        ";\n\n  /* Variation */\n  ",
        "\n"
    ])), (0, $atWKR.themeVal)("type.overline.family"), (0, $atWKR.themeVal)("type.overline.regular"), (0, $atWKR.themeVal)("type.overline.textTransform"), (0, $atWKR.themeVal)("type.overline.settings"), $a61bcabfd7b0f0fe$var$renderHeadingVariation($a61bcabfd7b0f0fe$var$_objectSpread2($a61bcabfd7b0f0fe$var$_objectSpread2({}, props), {}, {
        variation: props.variation || "base-400"
    })));
};
var $a61bcabfd7b0f0fe$export$c02b221f8c5c2fc8 = function createSubtitleStyles() {
    return (0, $6fhRl.css)($a61bcabfd7b0f0fe$var$_templateObject6 || ($a61bcabfd7b0f0fe$var$_templateObject6 = $a61bcabfd7b0f0fe$var$_taggedTemplateLiteral([
        "\n  font-size: 0.75rem;\n  line-height: 1rem;\n  color: ",
        ";\n"
    ])), (0, $atWKR.themeVal)("color.base-400"));
};
var $a61bcabfd7b0f0fe$export$a8a3e93435678ff9 = /*#__PURE__*/ (0, $6fhRl.default).h1.withConfig({
    displayName: "Heading",
    componentId: "sc-17hljlf-0"
})([
    "",
    ""
], $a61bcabfd7b0f0fe$export$90953dc85ce65d2a);
var $a61bcabfd7b0f0fe$export$6fb32aa36db1667d = /*#__PURE__*/ (0, $6fhRl.default).p.withConfig({
    displayName: "Heading__Overline",
    componentId: "sc-17hljlf-1"
})([
    "",
    ""
], $a61bcabfd7b0f0fe$export$44fa246b1b246e12);
var $a61bcabfd7b0f0fe$export$ba4d7ae5fb67789e = /*#__PURE__*/ (0, $6fhRl.default).p.withConfig({
    displayName: "Heading__Lead",
    componentId: "sc-17hljlf-2"
})([
    "font-size:",
    ";color:",
    ";"
], (0, $atWKR.themeVal)("type.base.leadSize"), (0, $atWKR.themeVal)("color.base-400"));
var $a61bcabfd7b0f0fe$export$cf345ef34cd72655 = /*#__PURE__*/ (0, $6fhRl.default).p.withConfig({
    displayName: "Heading__Subtitle",
    componentId: "sc-17hljlf-3"
})([
    "",
    ""
], $a61bcabfd7b0f0fe$export$c02b221f8c5c2fc8);
var $a61bcabfd7b0f0fe$var$_templateObject$1;
var $a61bcabfd7b0f0fe$var$proseSpacing = 1.5;
var $a61bcabfd7b0f0fe$export$53917277ddc56be = function createProseStyles() {
    return (0, $6fhRl.css)($a61bcabfd7b0f0fe$var$_templateObject$1 || ($a61bcabfd7b0f0fe$var$_templateObject$1 = $a61bcabfd7b0f0fe$var$_taggedTemplateLiteral([
        "\n  sup,\n  sub {\n    font-size: 0.75em;\n  }\n\n  sup {\n    vertical-align: top;\n  }\n\n  sub {\n    vertical-align: bottom;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    ",
        "\n    margin-bottom: ",
        ";\n\n    &:not(:first-child) {\n      margin-top: ",
        ";\n    }\n  }\n\n  h1 {\n    ",
        "\n  }\n\n  h2 {\n    ",
        "\n  }\n\n  h3 {\n    ",
        "\n  }\n\n  h4 {\n    ",
        "\n  }\n\n  h5 {\n    ",
        "\n  }\n\n  h6 {\n    ",
        "\n  }\n\n  dl {\n    padding: 0;\n  }\n\n  ol ol,\n  ol ul,\n  ul ol,\n  ul ul {\n    margin-bottom: 0;\n  }\n\n  dt {\n    font-weight: ",
        ";\n  }\n\n  figure > figcaption {\n    ",
        "\n    padding: ",
        ";\n    text-align: center;\n    width: 100%;\n    max-width: 52rem;\n    margin: 0 auto;\n  }\n\n  figure img {\n    display: block;\n    margin: 0 auto;\n  }\n\n  > * {\n    margin-bottom: ",
        ";\n  }\n\n  > *:last-child {\n    margin-bottom: 0;\n  }\n\n  table {\n    ",
        "\n\n    &.table-zebra {\n      ",
        "\n    }\n  }\n"
    ])), $a61bcabfd7b0f0fe$export$90953dc85ce65d2a, (0, $atWKR.glsp)(), (0, $atWKR.glsp)($a61bcabfd7b0f0fe$var$proseSpacing * 2), $a61bcabfd7b0f0fe$export$634a6ab7e77e3062({
        size: "xxlarge"
    }), $a61bcabfd7b0f0fe$export$634a6ab7e77e3062({
        size: "xlarge"
    }), $a61bcabfd7b0f0fe$export$634a6ab7e77e3062({
        size: "large"
    }), $a61bcabfd7b0f0fe$export$634a6ab7e77e3062({
        size: "medium"
    }), $a61bcabfd7b0f0fe$export$634a6ab7e77e3062({
        size: "small"
    }), $a61bcabfd7b0f0fe$export$634a6ab7e77e3062({
        size: "xsmall"
    }), (0, $atWKR.themeVal)("type.base.bold"), $a61bcabfd7b0f0fe$export$c02b221f8c5c2fc8, (0, $atWKR.glsp)(), (0, $atWKR.rem)($a61bcabfd7b0f0fe$var$proseSpacing), $a61bcabfd7b0f0fe$export$aff06e213e8ef556, $a61bcabfd7b0f0fe$export$dc91e21443ea6226({
        zebra: true
    }));
};
var $a61bcabfd7b0f0fe$export$9599cd3a25da89a5 = /*#__PURE__*/ (0, $6fhRl.default).div.withConfig({
    displayName: "Prose",
    componentId: "sc-1p4enbu-0"
})([
    "",
    ""
], $a61bcabfd7b0f0fe$export$53917277ddc56be);
var $a61bcabfd7b0f0fe$var$_templateObject, $a61bcabfd7b0f0fe$var$_templateObject2;
var $a61bcabfd7b0f0fe$export$dc91e21443ea6226 = function renderTableZebra() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, zebra = _ref.zebra;
    return zebra && (0, $6fhRl.css)($a61bcabfd7b0f0fe$var$_templateObject || ($a61bcabfd7b0f0fe$var$_templateObject = $a61bcabfd7b0f0fe$var$_taggedTemplateLiteral([
        "\n    tbody tr:nth-of-type(odd) {\n      background: ",
        ";\n    }\n  "
    ])), (0, $atWKR.themeVal)("color.base-50a"));
};
var $a61bcabfd7b0f0fe$export$aff06e213e8ef556 = function createTableStyles(props) {
    return (0, $6fhRl.css)($a61bcabfd7b0f0fe$var$_templateObject2 || ($a61bcabfd7b0f0fe$var$_templateObject2 = $a61bcabfd7b0f0fe$var$_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 100%;\n  border-color: ",
        ";\n  border-collapse: collapse;\n\n  tbody,\n  td,\n  tfoot,\n  th,\n  thead,\n  tr {\n    border-color: inherit;\n    border-bottom-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-bottom-width: 0px;\n  }\n\n  & > *:not(caption) > * > * {\n    border-bottom-width: ",
        ";\n  }\n\n  & > :not(:last-child) > :last-child > * {\n    border-bottom-width: ",
        ";\n  }\n\n  th {\n    ",
        "\n  }\n\n  td,\n  th {\n    padding: ",
        ";\n    vertical-align: top;\n    text-align: left;\n  }\n\n  th:first-child,\n  td:first-child {\n    padding-left: ",
        ";\n  }\n\n  th:last-child,\n  td:last-child {\n    padding-right: ",
        ";\n  }\n\n  /* Table zebra */\n  ",
        "\n\n  caption {\n    ",
        "\n    caption-side: bottom;\n    padding: ",
        ";\n    text-align: center;\n  }\n"
    ])), (0, $atWKR.themeVal)("color.base-200a"), (0, $atWKR.themeVal)("layout.border"), (0, $atWKR.multiply)((0, $atWKR.themeVal)("layout.border"), 2), $a61bcabfd7b0f0fe$export$90953dc85ce65d2a({
        size: "xsmall"
    }), (0, $atWKR.glsp)(1 / 4), (0, $atWKR.glsp)(), (0, $atWKR.glsp)(), $a61bcabfd7b0f0fe$export$dc91e21443ea6226(props), $a61bcabfd7b0f0fe$export$c02b221f8c5c2fc8, (0, $atWKR.glsp)());
};
var $a61bcabfd7b0f0fe$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $6fhRl.default).table.withConfig({
    displayName: "Table",
    componentId: "sc-1f22pod-0"
})([
    "",
    ""
], $a61bcabfd7b0f0fe$export$aff06e213e8ef556);

});

parcelRegister("9mbTf", function(module, exports) {

$parcel$export(module.exports, "VerticalDivider", function () { return $6cff6440b48f328d$export$8da326e5389a0196; });
$parcel$export(module.exports, "Toolbar", function () { return $6cff6440b48f328d$export$4c260019440d418f; });
$parcel$export(module.exports, "ToolbarGroup", function () { return $6cff6440b48f328d$export$86603917d61f5a16; });
$parcel$export(module.exports, "ToolbarLabel", function () { return $6cff6440b48f328d$export$700073176d859d9c; });
$parcel$export(module.exports, "ToolbarIconButton", function () { return $6cff6440b48f328d$export$ed3f3d46251616ca; });

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $3RyIS = parcelRequire("3RyIS");

var $ifjYT = parcelRequire("ifjYT");

var $egbTY = parcelRequire("egbTY");

var $9HCvT = parcelRequire("9HCvT");
function $6cff6440b48f328d$var$_extends() {
    $6cff6440b48f328d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6cff6440b48f328d$var$_extends.apply(this, arguments);
}
function $6cff6440b48f328d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6cff6440b48f328d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6cff6440b48f328d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6cff6440b48f328d$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var $6cff6440b48f328d$var$_templateObject$1, $6cff6440b48f328d$var$_templateObject2$1;
var $6cff6440b48f328d$var$renderDividerVariation = function renderDividerVariation(_ref) {
    var variation = _ref.variation;
    if (variation === "light") return (0, $6fhRl.css)($6cff6440b48f328d$var$_templateObject$1 || ($6cff6440b48f328d$var$_templateObject$1 = $6cff6440b48f328d$var$_taggedTemplateLiteral([
        "\n      background: transparent\n        linear-gradient(\n          90deg,\n          ",
        ",\n          ",
        "\n        )\n        50% / ",
        " auto no-repeat;\n    "
    ])), (0, $atWKR.themeVal)("color.surface-100a"), (0, $atWKR.themeVal)("color.surface-100a"), (0, $atWKR.themeVal)("layout.border"));
     // Default: variation === 'dark'
    return (0, $6fhRl.css)($6cff6440b48f328d$var$_templateObject2$1 || ($6cff6440b48f328d$var$_templateObject2$1 = $6cff6440b48f328d$var$_taggedTemplateLiteral([
        "\n    background: transparent\n      linear-gradient(\n        90deg,\n        ",
        ",\n        ",
        "\n      )\n      50% / ",
        " auto no-repeat;\n  "
    ])), (0, $atWKR.themeVal)("color.base-200a"), (0, $atWKR.themeVal)("color.base-200a"), (0, $atWKR.themeVal)("layout.border"));
};
var $6cff6440b48f328d$export$8da326e5389a0196 = /*#__PURE__*/ (0, $6fhRl.default).hr.withConfig({
    displayName: "vertical-divider__VerticalDivider",
    componentId: "sc-aok8iv-0"
})([
    "display:inline-flex;border:0;width:",
    ";height:",
    ";margin:0;",
    ""
], (0, $atWKR.glsp)(0.5), (0, $atWKR.glsp)(), $6cff6440b48f328d$var$renderDividerVariation);
// global toolbar props, like the size.
// Context
var $6cff6440b48f328d$var$ToolbarContext = /*#__PURE__*/ (0, $3RyIS.createContext)({
    inToolbar: false
}); // Context provider
var $6cff6440b48f328d$var$ToolbarProvider = function ToolbarProvider(props) {
    var children = props.children, size = props.size;
    var contextValue = (0, $3RyIS.useMemo)(function() {
        return {
            inToolbar: true,
            size: size
        };
    }, [
        size
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($6cff6440b48f328d$var$ToolbarContext.Provider, {
        value: contextValue
    }, children);
};
$6cff6440b48f328d$var$ToolbarProvider.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).node,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).oneOf([
        "small",
        "medium",
        "large"
    ])
}; // Context consumer
var $6cff6440b48f328d$var$useToolbar = function useToolbar() {
    // It should be possible to use the hook outside the toolbar to allow
    // component reusability.
    return (0, $3RyIS.useContext)($6cff6440b48f328d$var$ToolbarContext);
};
var $6cff6440b48f328d$var$ToolbarContextButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).forwardRef(function(props, ref) {
    var _useToolbar = $6cff6440b48f328d$var$useToolbar(), size = _useToolbar.size;
    /* eslint-disable-next-line react/prop-types */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement((0, $9HCvT.Button), $6cff6440b48f328d$var$_extends({}, props, {
        size: size || props.size,
        ref: ref
    }));
});
$6cff6440b48f328d$var$ToolbarContextButton.displayName = "ToolbarContextButton";
var $6cff6440b48f328d$var$_templateObject, $6cff6440b48f328d$var$_templateObject2, $6cff6440b48f328d$var$_templateObject3, $6cff6440b48f328d$var$_templateObject4;
var $6cff6440b48f328d$var$_excluded = [
    "className",
    "children",
    "size"
];
function $6cff6440b48f328d$var$ToolbarComponent(_ref) {
    var className = _ref.className, children = _ref.children, size = _ref.size, rest = $6cff6440b48f328d$var$_objectWithoutProperties(_ref, $6cff6440b48f328d$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($6cff6440b48f328d$var$ToolbarProvider, {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("div", $6cff6440b48f328d$var$_extends({
        className: className,
        role: "toolbar"
    }, rest), children));
}
$6cff6440b48f328d$var$ToolbarComponent.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).node,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string
};
var $6cff6440b48f328d$var$setSpacingVariable = function setSpacingVariable(_ref2) {
    var size = _ref2.size;
    switch(size){
        case "small":
            return (0, $6fhRl.css)($6cff6440b48f328d$var$_templateObject || ($6cff6440b48f328d$var$_templateObject = $6cff6440b48f328d$var$_taggedTemplateLiteral([
                "\n        --toolbar-spacing: ",
                ";\n      "
            ])), (0, $atWKR.glsp)(0.125));
        case "large":
            return (0, $6fhRl.css)($6cff6440b48f328d$var$_templateObject2 || ($6cff6440b48f328d$var$_templateObject2 = $6cff6440b48f328d$var$_taggedTemplateLiteral([
                "\n        --toolbar-spacing: ",
                ";\n      "
            ])), (0, $atWKR.glsp)(0.5));
        case "xlarge":
            return (0, $6fhRl.css)($6cff6440b48f328d$var$_templateObject3 || ($6cff6440b48f328d$var$_templateObject3 = $6cff6440b48f328d$var$_taggedTemplateLiteral([
                "\n        --toolbar-spacing: ",
                ";\n      "
            ])), (0, $atWKR.glsp)());
        // medium
        default:
            return (0, $6fhRl.css)($6cff6440b48f328d$var$_templateObject4 || ($6cff6440b48f328d$var$_templateObject4 = $6cff6440b48f328d$var$_taggedTemplateLiteral([
                "\n        --toolbar-spacing: ",
                ";\n      "
            ])), (0, $atWKR.glsp)(0.25));
    }
};
var $6cff6440b48f328d$export$4c260019440d418f = /*#__PURE__*/ (0, $6fhRl.default)($6cff6440b48f328d$var$ToolbarComponent).withConfig({
    displayName: "toolbar__Toolbar",
    componentId: "sc-1dvjpky-0"
})([
    "display:flex;flex-flow:row nowrap;align-items:center;",
    " gap:var(--toolbar-spacing);"
], $6cff6440b48f328d$var$setSpacingVariable);
var $6cff6440b48f328d$export$86603917d61f5a16 = /*#__PURE__*/ (0, $6fhRl.default).div.attrs(function(props) {
    return {
        role: props.role || "group"
    };
}).withConfig({
    displayName: "toolbar__ToolbarGroup",
    componentId: "sc-1dvjpky-1"
})([
    "all:inherit;& + &{margin-left:calc(var(--toolbar-spacing) * 4);}"
]);
var $6cff6440b48f328d$export$700073176d859d9c = /*#__PURE__*/ (0, $6fhRl.default).span.withConfig({
    displayName: "toolbar__ToolbarLabel",
    componentId: "sc-1dvjpky-2"
})([
    "",
    " ",
    " color:",
    ";"
], (0, $egbTY.createOverlineStyles)(), (0, $atWKR.truncated)(), function(_ref3) {
    var variation = _ref3.variation;
    return variation === "light" ? (0, $atWKR.themeVal)("color.surface") : (0, $atWKR.themeVal)("color.base-400");
});
var $6cff6440b48f328d$export$e5c1a33878e86e9e = /*#__PURE__*/ (0, $6fhRl.default)($6cff6440b48f328d$var$ToolbarContextButton).withConfig({
    displayName: "toolbar__ToolbarButton",
    componentId: "sc-1dvjpky-3"
})([
    ""
]);
var $6cff6440b48f328d$export$ed3f3d46251616ca = /*#__PURE__*/ (0, $6fhRl.default)($6cff6440b48f328d$export$e5c1a33878e86e9e).attrs({
    fitting: "skinny"
}).withConfig({
    displayName: "toolbar__ToolbarIconButton",
    componentId: "sc-1dvjpky-4"
})([
    ""
]);

});



parcelRegister("1wE4d", function(module, exports) {

$parcel$export(module.exports, "useDisplay", function () { return $31d67bf247f443d0$export$8406b7efc286d284; });

var $3RyIS = parcelRequire("3RyIS");
function $31d67bf247f443d0$export$8406b7efc286d284() {
    const [display, setDisplay] = (0, $3RyIS.useState)(false);
    return {
        isRevealed: display,
        show: (0, $3RyIS.useCallback)(()=>setDisplay(true), [
            setDisplay
        ]),
        hide: (0, $3RyIS.useCallback)(()=>setDisplay(false), [
            setDisplay
        ])
    };
}

});



parcelRegister("3pC4o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4cd6075e70cc436$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");
parcelRequire("hiK0Y");
var $3xK2A = parcelRequire("3xK2A");
function $f4cd6075e70cc436$export$2e2bcd8739ae039() {
    const [clicked, setClicked] = (0, $3RyIS.useState)(false);
    //implementing useEffect for nextjs implementation
    (0, $3RyIS.useEffect)(()=>{
        const firstFocusableElement = document.querySelector("button");
        if (firstFocusableElement && clicked) {
            firstFocusableElement.focus();
            setClicked(false);
        }
    }, [
        clicked
    ]);
    const onClick = ()=>{
        if (typeof window !== "undefined") {
            setClicked(true);
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    };
    return /*#__PURE__*/ (0, $21sFD.jsx)("div", {
        className: "margin-left-auto margin-right-auto return-to-top-container",
        children: /*#__PURE__*/ (0, $21sFD.jsx)((0, $3xK2A.USWDSButton), {
            onClick: onClick,
            unstyled: true,
            children: "Return to top"
        })
    });
}

});


parcelRegister("jFp0l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b22762e05912853c$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $6fhRl = parcelRequire("6fhRl");

var $7i4Xz = parcelRequire("7i4Xz");

var $atWKR = parcelRequire("atWKR");

var $8KsRR = parcelRequire("8KsRR");

var $9HCvT = parcelRequire("9HCvT");

var $2JIVh = parcelRequire("2JIVh");

var $egbTY = parcelRequire("egbTY");

var $04Xx0 = parcelRequire("04Xx0");

var $johEW = parcelRequire("johEW");

var $gOQ9k = parcelRequire("gOQ9k");

var $71lnM = parcelRequire("71lnM");

var $lBJBu = parcelRequire("lBJBu");
/**
 * Legacy page footer component for VEDA applications.
 *
 * @deprecated This component is deprecated and will be removed in version 7.
 *             See {@link https://github.com/NASA-IMPACT/veda-ui/issues/1889} for details.
 *
 * Provides contact info, GitHub link, NASA branding, and version info.
 * Hidden when `ENABLE_USWDS_PAGE_FOOTER` is enabled in favor of modern USWDS footer.
 *
 * @param hideFooter - Boolean flag to hide the footer completely
 */ const $b22762e05912853c$var$PageFooterSelf = (0, $6fhRl.default).footer`
  padding: ${(0, $04Xx0.variableGlsp)(0.75, 1)};
  background: ${(0, $atWKR.themeVal)("color.base-50")};
  animation: ${(0, $8KsRR.reveal)} 0.32s ease 0s 1;
  display: flex;
  flex-flow: column nowrap;

  ${({ isHidden: isHidden })=>isHidden && (0, $atWKR.visuallyHidden)()}

  ${(0, $atWKR.media).smallUp`
    flex-flow: row nowrap;
  `}

  a {
    &,
    &:visited {
      color: inherit;
    }
  }
`;
const $b22762e05912853c$var$FooterCredits = (0, $6fhRl.default).address`
  font-size: 0.875rem;
  line-height: 1.5rem;
  font-style: normal;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-end;

  a span {
    ${(0, $atWKR.visuallyHidden)()}
  }

  h3 {
    ${(0, $atWKR.visuallyHidden)()}
  }

  small {
    font-size: inherit;
    display: block;
    opacity: 0.64;
  }
`;
const $b22762e05912853c$var$InfoList = (0, $6fhRl.default).dl`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-flow: column;
  gap: ${(0, $atWKR.glsp)(0, 1)};
  align-items: start;
  margin-bottom: ${(0, $04Xx0.variableGlsp)()};

  ${(0, $atWKR.media).smallUp`
    gap: ${(0, $atWKR.glsp)(0, 2)};
    margin: 0 0 0 auto;
    order: 2;
  `}

  ${(0, $atWKR.media).mediumUp`
    grid-template-columns: repeat(4, auto);
    grid-auto-flow: auto;
    grid-gap: ${(0, $04Xx0.variableGlsp)(0, 0.5)};
    align-items: center;
  `}

  dt {
    ${(0, $egbTY.createSubtitleStyles)()}
    text-transform: uppercase;
    font-size: 0.75rem;
    line-height: 1rem;
    grid-row: 1;

    ${(0, $atWKR.media).mediumUp`
      margin-left: ${(0, $04Xx0.variableGlsp)()};
    `}
  }

  dd {
    grid-row: 2;

    ${(0, $atWKR.media).mediumUp`
      grid-row: 1;
    `}
  }
`;
function $b22762e05912853c$var$PageFooterLegacy(props) {
    (0, $lBJBu.useDeprecationWarning)({
        name: "PageFooterLegacy",
        removalVersion: "7.0.0",
        issueUrl: "https://github.com/NASA-IMPACT/veda-ui/issues/1889",
        alternative: "Use the modern USWDS footer component instead"
    });
    const nowDate = new Date();
    return /*#__PURE__*/ (0, $21sFD.jsx)($b22762e05912853c$var$PageFooterSelf, {
        isHidden: props.hideFooter,
        children: /*#__PURE__*/ (0, $21sFD.jsxs)((0, $gOQ9k.ComponentOverride), {
            with: "pageFooter",
            appVersion: "3.1.25",
            appUiVersion: "6.21.0",
            appBuildTime: "1787776487434",
            children: [
                /*#__PURE__*/ (0, $21sFD.jsxs)($b22762e05912853c$var$InfoList, {
                    children: [
                        /*#__PURE__*/ (0, $21sFD.jsx)("dt", {
                            children: "NASA official"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("dd", {
                            children: /*#__PURE__*/ (0, $21sFD.jsxs)((0, $9HCvT.Button), {
                                forwardedAs: "a",
                                href: "mailto:manil.maskey@nasa.gov",
                                variation: "base-text",
                                size: "small",
                                fitting: "skinny",
                                children: [
                                    /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Icon).Mail, {
                                        "aria-hidden": "true"
                                    }),
                                    "Manil Maskey"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("dt", {
                            children: "Open source code"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("dd", {
                            children: /*#__PURE__*/ (0, $21sFD.jsxs)((0, $9HCvT.Button), {
                                forwardedAs: "a",
                                href: "https://github.com/NASA-IMPACT/veda-config",
                                variation: "base-text",
                                size: "small",
                                fitting: "skinny",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: [
                                    /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Icon).Github, {
                                        "aria-hidden": "true"
                                    }),
                                    "GitHub"
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $21sFD.jsx)($b22762e05912853c$var$FooterCredits, {
                    children: /*#__PURE__*/ (0, $21sFD.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $21sFD.jsxs)((0, $71lnM.default), {
                                to: "https://earthdata.nasa.gov/",
                                children: [
                                    /*#__PURE__*/ (0, $21sFD.jsx)("span", {
                                        children: "By"
                                    }),
                                    " NASA ",
                                    /*#__PURE__*/ (0, $21sFD.jsx)("strong", {
                                        children: "Earthdata"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $21sFD.jsx)("span", {
                                        children: "on"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $21sFD.jsx)("time", {
                                        dateTime: nowDate.getFullYear().toString(),
                                        children: nowDate.getFullYear()
                                    })
                                ]
                            }),
                            " \u2022 ",
                            /*#__PURE__*/ (0, $21sFD.jsx)((0, $johEW.Tip), {
                                content: `Released on ${(0, $7i4Xz.default)(new Date(1787776487434), "PPPP")} (veda-ui v${"3.1.25"}))`,
                                children: /*#__PURE__*/ (0, $21sFD.jsxs)("span", {
                                    children: [
                                        "v",
                                        "3.1.25"
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $b22762e05912853c$export$2e2bcd8739ae039 = $b22762e05912853c$var$PageFooterLegacy;

});
parcelRegister("7i4Xz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54ee0fbd4ba95311$export$2e2bcd8739ae039; });

var $8Njuw = parcelRequire("8Njuw");

var $kehF5 = parcelRequire("kehF5");

var $96sPX = parcelRequire("96sPX");

var $bWBSz = parcelRequire("bWBSz");

var $4tUk5 = parcelRequire("4tUk5");

var $28N94 = parcelRequire("28N94");

var $3nBpF = parcelRequire("3nBpF");

var $eR5Kk = parcelRequire("eR5Kk");

var $aTOKl = parcelRequire("aTOKl");

var $zVBZd = parcelRequire("zVBZd");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $54ee0fbd4ba95311$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $54ee0fbd4ba95311$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $54ee0fbd4ba95311$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $54ee0fbd4ba95311$var$doubleQuoteRegExp = /''/g;
var $54ee0fbd4ba95311$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $54ee0fbd4ba95311$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $zVBZd.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || (0, $kehF5.default);
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $aTOKl.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $aTOKl.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $aTOKl.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $aTOKl.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $bWBSz.default)(dirtyDate);
    if (!(0, $8Njuw.default)(originalDate)) throw new RangeError("Invalid time value");
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $3nBpF.default)(originalDate);
    var utcDate = (0, $96sPX.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($54ee0fbd4ba95311$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $28N94.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join("").match($54ee0fbd4ba95311$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $54ee0fbd4ba95311$var$cleanEscapedString(substring);
        var formatter = (0, $4tUk5.default)[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $eR5Kk.isProtectedWeekYearToken)(substring)) (0, $eR5Kk.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $eR5Kk.isProtectedDayOfYearToken)(substring)) (0, $eR5Kk.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($54ee0fbd4ba95311$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $54ee0fbd4ba95311$var$cleanEscapedString(input) {
    return input.match($54ee0fbd4ba95311$var$escapedStringRegExp)[1].replace($54ee0fbd4ba95311$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("8Njuw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $667204e86ebb5a07$export$2e2bcd8739ae039; });

var $1PALi = parcelRequire("1PALi");

var $bWBSz = parcelRequire("bWBSz");

var $zVBZd = parcelRequire("zVBZd");
function $667204e86ebb5a07$export$2e2bcd8739ae039(dirtyDate) {
    (0, $zVBZd.default)(1, arguments);
    if (!(0, $1PALi.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $bWBSz.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("1PALi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $155711f9b5c2b7cf$export$2e2bcd8739ae039; });

var $zVBZd = parcelRequire("zVBZd");
function $155711f9b5c2b7cf$export$2e2bcd8739ae039(value) {
    (0, $zVBZd.default)(1, arguments);
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});
parcelRegister("zVBZd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06bff57abe49ccc6$export$2e2bcd8739ae039; });
function $06bff57abe49ccc6$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});


parcelRegister("bWBSz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b227e7f0881f0d7$export$2e2bcd8739ae039; });

var $zVBZd = parcelRequire("zVBZd");
function $8b227e7f0881f0d7$export$2e2bcd8739ae039(argument) {
    (0, $zVBZd.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});


parcelRegister("kehF5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eba2d0b821e819c7$export$2e2bcd8739ae039; });

var $d9jYw = parcelRequire("d9jYw");

var $hRyUd = parcelRequire("hRyUd");

var $6yOQi = parcelRequire("6yOQi");

var $6f5Ze = parcelRequire("6f5Ze");

var $bV6Ei = parcelRequire("bV6Ei");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $eba2d0b821e819c7$var$locale = {
    code: "en-US",
    formatDistance: (0, $d9jYw.default),
    formatLong: (0, $hRyUd.default),
    formatRelative: (0, $6yOQi.default),
    localize: (0, $6f5Ze.default),
    match: (0, $bV6Ei.default),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $eba2d0b821e819c7$export$2e2bcd8739ae039 = $eba2d0b821e819c7$var$locale;

});
parcelRegister("d9jYw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $992b9c49d018b192$export$2e2bcd8739ae039; });
var $992b9c49d018b192$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $992b9c49d018b192$var$formatDistance = function(token, count, options) {
    var result;
    var tokenValue = $992b9c49d018b192$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $992b9c49d018b192$export$2e2bcd8739ae039 = $992b9c49d018b192$var$formatDistance;

});

parcelRegister("hRyUd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d012766ea34f610d$export$2e2bcd8739ae039; });

var $hFKrF = parcelRequire("hFKrF");
var $d012766ea34f610d$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $d012766ea34f610d$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $d012766ea34f610d$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $d012766ea34f610d$var$formatLong = {
    date: (0, $hFKrF.default)({
        formats: $d012766ea34f610d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $hFKrF.default)({
        formats: $d012766ea34f610d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $hFKrF.default)({
        formats: $d012766ea34f610d$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $d012766ea34f610d$export$2e2bcd8739ae039 = $d012766ea34f610d$var$formatLong;

});
parcelRegister("hFKrF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdda4b16217a829f$export$2e2bcd8739ae039; });
function $cdda4b16217a829f$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("6yOQi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c6d5b4aa8604542$export$2e2bcd8739ae039; });
var $4c6d5b4aa8604542$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $4c6d5b4aa8604542$var$formatRelative = function(token, _date, _baseDate, _options) {
    return $4c6d5b4aa8604542$var$formatRelativeLocale[token];
};
var $4c6d5b4aa8604542$export$2e2bcd8739ae039 = $4c6d5b4aa8604542$var$formatRelative;

});

parcelRegister("6f5Ze", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48b8c997ec9fefba$export$2e2bcd8739ae039; });

var $12xwd = parcelRequire("12xwd");
var $48b8c997ec9fefba$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $48b8c997ec9fefba$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $48b8c997ec9fefba$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $48b8c997ec9fefba$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $48b8c997ec9fefba$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $48b8c997ec9fefba$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $48b8c997ec9fefba$var$ordinalNumber = function(dirtyNumber, _options) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $48b8c997ec9fefba$var$localize = {
    ordinalNumber: $48b8c997ec9fefba$var$ordinalNumber,
    era: (0, $12xwd.default)({
        values: $48b8c997ec9fefba$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $12xwd.default)({
        values: $48b8c997ec9fefba$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $12xwd.default)({
        values: $48b8c997ec9fefba$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $12xwd.default)({
        values: $48b8c997ec9fefba$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $12xwd.default)({
        values: $48b8c997ec9fefba$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $48b8c997ec9fefba$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $48b8c997ec9fefba$export$2e2bcd8739ae039 = $48b8c997ec9fefba$var$localize;

});
parcelRegister("12xwd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c1ffa6dab0f675c$export$2e2bcd8739ae039; });
function $0c1ffa6dab0f675c$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("bV6Ei", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $023d534e21b69310$export$2e2bcd8739ae039; });

var $3hc8g = parcelRequire("3hc8g");

var $3FM1R = parcelRequire("3FM1R");
var $023d534e21b69310$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $023d534e21b69310$var$parseOrdinalNumberPattern = /\d+/i;
var $023d534e21b69310$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $023d534e21b69310$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $023d534e21b69310$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $023d534e21b69310$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $023d534e21b69310$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $023d534e21b69310$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $023d534e21b69310$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $023d534e21b69310$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $023d534e21b69310$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $023d534e21b69310$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $023d534e21b69310$var$match = {
    ordinalNumber: (0, $3FM1R.default)({
        matchPattern: $023d534e21b69310$var$matchOrdinalNumberPattern,
        parsePattern: $023d534e21b69310$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $3hc8g.default)({
        matchPatterns: $023d534e21b69310$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $023d534e21b69310$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $3hc8g.default)({
        matchPatterns: $023d534e21b69310$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $023d534e21b69310$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $3hc8g.default)({
        matchPatterns: $023d534e21b69310$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $023d534e21b69310$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $3hc8g.default)({
        matchPatterns: $023d534e21b69310$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $023d534e21b69310$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $3hc8g.default)({
        matchPatterns: $023d534e21b69310$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $023d534e21b69310$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $023d534e21b69310$export$2e2bcd8739ae039 = $023d534e21b69310$var$match;

});
parcelRegister("3hc8g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $262c5edcc952c0a8$export$2e2bcd8739ae039; });
function $262c5edcc952c0a8$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $262c5edcc952c0a8$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $262c5edcc952c0a8$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $262c5edcc952c0a8$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $262c5edcc952c0a8$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("3FM1R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2aca7500094daeea$export$2e2bcd8739ae039; });
function $2aca7500094daeea$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("96sPX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01b5db0451cb42bb$export$2e2bcd8739ae039; });

var $aTOKl = parcelRequire("aTOKl");

var $bBNJq = parcelRequire("bBNJq");

var $zVBZd = parcelRequire("zVBZd");
function $01b5db0451cb42bb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $zVBZd.default)(2, arguments);
    var amount = (0, $aTOKl.default)(dirtyAmount);
    return (0, $bBNJq.default)(dirtyDate, -amount);
}

});
parcelRegister("aTOKl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ef6679cdbb7815f$export$2e2bcd8739ae039; });
function $7ef6679cdbb7815f$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("bBNJq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8739ba146be764eb$export$2e2bcd8739ae039; });

var $aTOKl = parcelRequire("aTOKl");

var $bWBSz = parcelRequire("bWBSz");

var $zVBZd = parcelRequire("zVBZd");
function $8739ba146be764eb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $zVBZd.default)(2, arguments);
    var timestamp = (0, $bWBSz.default)(dirtyDate).getTime();
    var amount = (0, $aTOKl.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});


parcelRegister("4tUk5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34358f71f4788d41$export$2e2bcd8739ae039; });

var $jGiyH = parcelRequire("jGiyH");

var $cExZK = parcelRequire("cExZK");

var $gcRQ9 = parcelRequire("gcRQ9");

var $daxBO = parcelRequire("daxBO");

var $cli1Q = parcelRequire("cli1Q");

var $16ucO = parcelRequire("16ucO");

var $12HES = parcelRequire("12HES");
var $34358f71f4788d41$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $34358f71f4788d41$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $12HES.default).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $cli1Q.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $16ucO.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
         // Padding
        return (0, $16ucO.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $gcRQ9.default)(date); // Padding
        return (0, $16ucO.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $16ucO.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $16ucO.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $16ucO.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $12HES.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $16ucO.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $daxBO.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $16ucO.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $cExZK.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $16ucO.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $12HES.default).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $jGiyH.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $16ucO.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $16ucO.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $16ucO.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $16ucO.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $34358f71f4788d41$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $34358f71f4788d41$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $34358f71f4788d41$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $34358f71f4788d41$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $34358f71f4788d41$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $34358f71f4788d41$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $12HES.default).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $12HES.default).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $16ucO.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $16ucO.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $12HES.default).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $12HES.default).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $12HES.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $34358f71f4788d41$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $34358f71f4788d41$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $34358f71f4788d41$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $34358f71f4788d41$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $34358f71f4788d41$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $34358f71f4788d41$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $34358f71f4788d41$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $34358f71f4788d41$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $34358f71f4788d41$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $34358f71f4788d41$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $16ucO.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $16ucO.default)(timestamp, token.length);
    }
};
function $34358f71f4788d41$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $16ucO.default)(minutes, 2);
}
function $34358f71f4788d41$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $16ucO.default)(Math.abs(offset) / 60, 2);
    }
    return $34358f71f4788d41$var$formatTimezone(offset, dirtyDelimiter);
}
function $34358f71f4788d41$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $16ucO.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $16ucO.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $34358f71f4788d41$export$2e2bcd8739ae039 = $34358f71f4788d41$var$formatters;

});
parcelRegister("jGiyH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e54055e8c40cd353$export$2e2bcd8739ae039; });

var $bWBSz = parcelRequire("bWBSz");

var $zVBZd = parcelRequire("zVBZd");
var $e54055e8c40cd353$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
function $e54055e8c40cd353$export$2e2bcd8739ae039(dirtyDate) {
    (0, $zVBZd.default)(1, arguments);
    var date = (0, $bWBSz.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $e54055e8c40cd353$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("cExZK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $936397280ad4a9c5$export$2e2bcd8739ae039; });

var $bWBSz = parcelRequire("bWBSz");

var $iOk2F = parcelRequire("iOk2F");

var $k0Sax = parcelRequire("k0Sax");

var $zVBZd = parcelRequire("zVBZd");
var $936397280ad4a9c5$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
function $936397280ad4a9c5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $zVBZd.default)(1, arguments);
    var date = (0, $bWBSz.default)(dirtyDate);
    var diff = (0, $iOk2F.default)(date).getTime() - (0, $k0Sax.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $936397280ad4a9c5$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("iOk2F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db1c716a19e3690a$export$2e2bcd8739ae039; });

var $bWBSz = parcelRequire("bWBSz");

var $zVBZd = parcelRequire("zVBZd");
function $db1c716a19e3690a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $zVBZd.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $bWBSz.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("k0Sax", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e91dd391bdd737f7$export$2e2bcd8739ae039; });

var $gcRQ9 = parcelRequire("gcRQ9");

var $iOk2F = parcelRequire("iOk2F");

var $zVBZd = parcelRequire("zVBZd");
function $e91dd391bdd737f7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $zVBZd.default)(1, arguments);
    var year = (0, $gcRQ9.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $iOk2F.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("gcRQ9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcc787d738cc7571$export$2e2bcd8739ae039; });

var $bWBSz = parcelRequire("bWBSz");

var $zVBZd = parcelRequire("zVBZd");

var $iOk2F = parcelRequire("iOk2F");
function $bcc787d738cc7571$export$2e2bcd8739ae039(dirtyDate) {
    (0, $zVBZd.default)(1, arguments);
    var date = (0, $bWBSz.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $iOk2F.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $iOk2F.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("daxBO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9966478d89386698$export$2e2bcd8739ae039; });

var $bWBSz = parcelRequire("bWBSz");

var $aBnDh = parcelRequire("aBnDh");

var $emWsp = parcelRequire("emWsp");

var $zVBZd = parcelRequire("zVBZd");
var $9966478d89386698$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
function $9966478d89386698$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $zVBZd.default)(1, arguments);
    var date = (0, $bWBSz.default)(dirtyDate);
    var diff = (0, $aBnDh.default)(date, options).getTime() - (0, $emWsp.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $9966478d89386698$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("aBnDh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b7fb0fe9c28222b$export$2e2bcd8739ae039; });

var $bWBSz = parcelRequire("bWBSz");

var $zVBZd = parcelRequire("zVBZd");

var $aTOKl = parcelRequire("aTOKl");
function $7b7fb0fe9c28222b$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $zVBZd.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $aTOKl.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $aTOKl.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $bWBSz.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("emWsp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7607724121d815c$export$2e2bcd8739ae039; });

var $cli1Q = parcelRequire("cli1Q");

var $zVBZd = parcelRequire("zVBZd");

var $aBnDh = parcelRequire("aBnDh");

var $aTOKl = parcelRequire("aTOKl");
function $a7607724121d815c$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $zVBZd.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $aTOKl.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $aTOKl.default)(options.firstWeekContainsDate);
    var year = (0, $cli1Q.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $aBnDh.default)(firstWeek, dirtyOptions);
    return date;
}

});
parcelRegister("cli1Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fc56e576a100f84$export$2e2bcd8739ae039; });

var $bWBSz = parcelRequire("bWBSz");

var $zVBZd = parcelRequire("zVBZd");

var $aBnDh = parcelRequire("aBnDh");

var $aTOKl = parcelRequire("aTOKl");
function $8fc56e576a100f84$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $zVBZd.default)(1, arguments);
    var date = (0, $bWBSz.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $aTOKl.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $aTOKl.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $aBnDh.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $aBnDh.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("16ucO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cddc83748417c61$export$2e2bcd8739ae039; });
function $0cddc83748417c61$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

});

parcelRegister("12HES", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c27d7f9fca7dc97$export$2e2bcd8739ae039; });

var $16ucO = parcelRequire("16ucO");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $0c27d7f9fca7dc97$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $16ucO.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $16ucO.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $16ucO.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $16ucO.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $16ucO.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $16ucO.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $16ucO.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $16ucO.default)(fractionalSeconds, token.length);
    }
};
var $0c27d7f9fca7dc97$export$2e2bcd8739ae039 = $0c27d7f9fca7dc97$var$formatters;

});


parcelRegister("28N94", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18f27360d4a7f18a$export$2e2bcd8739ae039; });
function $18f27360d4a7f18a$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
}
function $18f27360d4a7f18a$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
}
function $18f27360d4a7f18a$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $18f27360d4a7f18a$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $18f27360d4a7f18a$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $18f27360d4a7f18a$var$timeLongFormatter(timePattern, formatLong));
}
var $18f27360d4a7f18a$var$longFormatters = {
    p: $18f27360d4a7f18a$var$timeLongFormatter,
    P: $18f27360d4a7f18a$var$dateTimeLongFormatter
};
var $18f27360d4a7f18a$export$2e2bcd8739ae039 = $18f27360d4a7f18a$var$longFormatters;

});

parcelRegister("3nBpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27608a860e279aa0$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $27608a860e279aa0$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("eR5Kk", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $ad0a78ffcc051edb$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $ad0a78ffcc051edb$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $ad0a78ffcc051edb$export$8073c1ae88f0e727; });
var $ad0a78ffcc051edb$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $ad0a78ffcc051edb$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $ad0a78ffcc051edb$export$c6cc36aa33304772(token) {
    return $ad0a78ffcc051edb$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $ad0a78ffcc051edb$export$c6b49d6dceb604a1(token) {
    return $ad0a78ffcc051edb$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $ad0a78ffcc051edb$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("04Xx0", function(module, exports) {

$parcel$export(module.exports, "variableBaseType", function () { return $97daa52b02fdbe0b$export$13258753b704e79f; });
$parcel$export(module.exports, "variableProseVSpace", function () { return $97daa52b02fdbe0b$export$43981dacff470a11; });
$parcel$export(module.exports, "variableGlsp", function () { return $97daa52b02fdbe0b$export$ade793d24924ca57; });

var $atWKR = parcelRequire("atWKR");

var $6fhRl = parcelRequire("6fhRl");
const $97daa52b02fdbe0b$var$variableType = (base, variable)=>{
    return (0, $6fhRl.css)`calc(${base} + var(${variable}, 0rem))`;
};
const $97daa52b02fdbe0b$export$13258753b704e79f = (base)=>$97daa52b02fdbe0b$var$variableType(base, "--base-text-increment");
const $97daa52b02fdbe0b$export$43981dacff470a11 = ()=>{
    return (0, $6fhRl.css)`calc(
    ${$97daa52b02fdbe0b$export$13258753b704e79f((0, $atWKR.themeVal)("type.base.size"))} + 0.5rem
  )`;
};
const $97daa52b02fdbe0b$export$ade793d24924ca57 = (...args)=>{
    args = args.length ? args : [
        1
    ];
    const fns = args.map((m)=>(0, $6fhRl.css)`calc(${(0, $atWKR.themeVal)("layout.space")} * var(--base-space-multiplier, 1) * ${m})`);
    const spaces = Array(args.length - 1).fill(" ");
    return (0, $6fhRl.css)([
        "",
        ...spaces,
        ""
    ], ...fns);
};

});

parcelRegister("gOQ9k", function(module, exports) {

$parcel$export(module.exports, "ComponentOverride", function () { return $7fceeb492fe0752f$export$82a3e89e956de8ba; });
$parcel$export(module.exports, "ContentOverride", function () { return $7fceeb492fe0752f$export$72d1ada09c8a89ed; });

var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");

var $fqfrI = parcelRequire("fqfrI");

var $l7Vlc = parcelRequire("l7Vlc");

var $1QyWY = parcelRequire("1QyWY");

var $bGpZO = parcelRequire("bGpZO");

const $7fceeb492fe0752f$var$MdxContent = /*#__PURE__*/ (0, $3RyIS.lazy)(()=>(parcelRequire("hutkf")));
function $7fceeb492fe0752f$export$82a3e89e956de8ba(props) {
    const { with: _with, children: children, ...rest } = props;
    const loader = (0, $l7Vlc.getOverride)(_with)?.content;
    const pageMdx = (0, $1QyWY.useMdxPageLoader)(loader);
    if (!loader) return /*#__PURE__*/ (0, $21sFD.jsx)((0, $21sFD.Fragment), {
        children: children
    });
    if (pageMdx.status === (0, $bGpZO.S_SUCCEEDED)) return /*#__PURE__*/ (0, $21sFD.jsx)((0, $fqfrI.MDXProvider), {
        children: /*#__PURE__*/ (0, $21sFD.jsx)(pageMdx.MdxContent, {
            ...rest
        })
    });
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $21sFD.Fragment), {
        children: false
    });
}
function $7fceeb492fe0752f$export$72d1ada09c8a89ed(props) {
    const { with: _with, children: children, ...rest } = props;
    const loader = (0, $l7Vlc.getOverride)(_with)?.content;
    return loader ? /*#__PURE__*/ (0, $21sFD.jsx)($7fceeb492fe0752f$var$MdxContent, {
        loader: loader,
        throughProps: rest
    }) : /*#__PURE__*/ (0, $21sFD.jsx)((0, $21sFD.Fragment), {
        children: children
    });
}

});
parcelRegister("fqfrI", function(module, exports) {

$parcel$export(module.exports, "useMDXComponents", function () { return $b3a543ff2aadd072$export$ba49c9ffd2310961; });
$parcel$export(module.exports, "MDXProvider", function () { return $b3a543ff2aadd072$export$1cf78dad7550a52b; });
/**
 * @typedef {import('mdx/types.js').MDXComponents} MDXComponents
 * @typedef {import('react').Component<{}, {}, unknown>} Component
 * @typedef {import('react').ReactNode} ReactNode
 */ /**
 * @callback MergeComponents
 *   Custom merge function.
 * @param {Readonly<MDXComponents>} currentComponents
 *   Current components from the context.
 * @returns {MDXComponents}
 *   Additional components.
 *
 * @typedef Props
 *   Configuration for `MDXProvider`.
 * @property {ReactNode | null | undefined} [children]
 *   Children (optional).
 * @property {Readonly<MDXComponents> | MergeComponents | null | undefined} [components]
 *   Additional components to use or a function that creates them (optional).
 * @property {boolean | null | undefined} [disableParentContext=false]
 *   Turn off outer component context (default: `false`).
 */ 
var $3RyIS = parcelRequire("3RyIS");
/** @type {Readonly<MDXComponents>} */ const $b3a543ff2aadd072$var$emptyComponents = {};
const $b3a543ff2aadd072$var$MDXContext = (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createContext($b3a543ff2aadd072$var$emptyComponents);
function $b3a543ff2aadd072$export$ba49c9ffd2310961(components) {
    const contextComponents = (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).useContext($b3a543ff2aadd072$var$MDXContext);
    // Memoize to avoid unnecessary top-level context changes
    return (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).useMemo(function() {
        // Custom merge via a function prop
        if (typeof components === "function") return components(contextComponents);
        return {
            ...contextComponents,
            ...components
        };
    }, [
        contextComponents,
        components
    ]);
}
function $b3a543ff2aadd072$export$1cf78dad7550a52b(properties) {
    /** @type {Readonly<MDXComponents>} */ let allComponents;
    if (properties.disableParentContext) allComponents = typeof properties.components === "function" ? properties.components($b3a543ff2aadd072$var$emptyComponents) : properties.components || $b3a543ff2aadd072$var$emptyComponents;
    else allComponents = $b3a543ff2aadd072$export$ba49c9ffd2310961(properties.components);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($b3a543ff2aadd072$var$MDXContext.Provider, {
        value: allComponents
    }, properties.children);
}

});

parcelRegister("1QyWY", function(module, exports) {

$parcel$export(module.exports, "useMdxPageLoader", function () { return $ddb02a64cc577dc6$export$35be397a9d49deea; });

var $3RyIS = parcelRequire("3RyIS");

var $bGpZO = parcelRequire("bGpZO");
function $ddb02a64cc577dc6$export$35be397a9d49deea(loader) {
    const [pageMdx, setPageMdx] = (0, $3RyIS.useState)({
        status: (0, $bGpZO.S_IDLE),
        MdxContent: null
    });
    (0, $3RyIS.useEffect)(()=>{
        if (!loader) return;
        const load = async ()=>{
            setPageMdx({
                status: (0, $bGpZO.S_LOADING),
                MdxContent: null
            });
            const content = await loader();
            setPageMdx({
                status: (0, $bGpZO.S_SUCCEEDED),
                MdxContent: content.default
            });
        };
        load();
    }, [
        loader
    ]);
    return pageMdx;
}

});
parcelRegister("bGpZO", function(module, exports) {

$parcel$export(module.exports, "S_IDLE", function () { return $6b8e3da619bb8c1b$export$4173a1cafc17f10c; });
$parcel$export(module.exports, "S_LOADING", function () { return $6b8e3da619bb8c1b$export$c328c4e9193d023b; });
$parcel$export(module.exports, "S_SUCCEEDED", function () { return $6b8e3da619bb8c1b$export$5a7aba0f257f66; });
$parcel$export(module.exports, "S_FAILED", function () { return $6b8e3da619bb8c1b$export$4733fe50ccd1b736; });
const $6b8e3da619bb8c1b$export$4173a1cafc17f10c = "idle";
const $6b8e3da619bb8c1b$export$c328c4e9193d023b = "loading";
const $6b8e3da619bb8c1b$export$5a7aba0f257f66 = "success";
const $6b8e3da619bb8c1b$export$4733fe50ccd1b736 = "error";

});


parcelRegister("hutkf", function(module, exports) {

var $9viiU = parcelRequire("9viiU");








module.exports = Promise.all([
    $9viiU("2yFTg"),
    $9viiU("bnCbN"),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("gBFRY")),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("eAUxD")),
    $9viiU("9azGc"),
    $9viiU("kuTXU"),
    $9viiU("2hQAJ"),
    $9viiU("6AxUY"),
    $9viiU("aeqcH"),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("aPjrX")),
    $9viiU("rWbfN"),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("3sa5j")),
    $9viiU("avPeM"),
    $9viiU("aDh7I"),
    $9viiU("15JZc"),
    $9viiU("2l5tY"),
    $9viiU("j5fXg")
]).then(()=>parcelRequire("b7QfG"));

});


parcelRegister("71lnM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $830683e3b0ffde1b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "CustomLink", function () { return $830683e3b0ffde1b$export$de47df264fea00a4; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $idnjL = parcelRequire("idnjL");

var $bJNua = parcelRequire("bJNua");
function $830683e3b0ffde1b$export$2e2bcd8739ae039(props) {
    const { to: to, children: children, ...rest } = props;
    const isExternalLink = /^https?:\/\//.test(to);
    const linkProps = (0, $bJNua.getLinkProps)(to);
    return isExternalLink ? /*#__PURE__*/ (0, $21sFD.jsxs)("a", {
        ...linkProps,
        ...rest,
        children: [
            " ",
            children,
            " "
        ]
    }) : /*#__PURE__*/ (0, $21sFD.jsxs)((0, $idnjL.Link), {
        ...linkProps,
        ...rest,
        children: [
            " ",
            children,
            " "
        ]
    });
}
function $830683e3b0ffde1b$export$de47df264fea00a4(props) {
    const { href: href, ...rest } = props;
    const isExternalLink = /^(https?:\/\/|mailto:)/i.test(href);
    const linkProps = (0, $bJNua.getLinkProps)(href);
    return isExternalLink ? // @ts-expect-error linkProps returned from getLinkProps are not being recognized suddenly
    /*#__PURE__*/ (0, $21sFD.jsx)("a", {
        ...linkProps,
        ...rest
    }) : /*#__PURE__*/ (0, $21sFD.jsx)((0, $idnjL.Link), {
        ...linkProps,
        ...rest
    });
}

});
parcelRegister("bJNua", function(module, exports) {

$parcel$export(module.exports, "getLinkProps", function () { return $72c1d5af7b52eca8$export$60113ebe1cf0ecf; });
const $72c1d5af7b52eca8$export$60113ebe1cf0ecf = (linkTo, as)=>{
    // Open the link in a new tab when link is external
    const isExternalLink = /^(https?:\/\/|mailto:)/i.test(linkTo);
    return isExternalLink ? {
        href: linkTo,
        to: linkTo,
        target: "_blank",
        rel: "noopener noreferrer"
    } : {
        ...as ? {
            as: as
        } : {},
        to: linkTo
    };
};

});


parcelRegister("lBJBu", function(module, exports) {

$parcel$export(module.exports, "useDeprecationWarning", function () { return $dc48d0fc58f955eb$export$406e4c8585b97b03; });

var $3RyIS = parcelRequire("3RyIS");
function $dc48d0fc58f955eb$export$fd85fde5373f97ba(options) {
    const { name: name, removalVersion: removalVersion, issueUrl: issueUrl, alternative: alternative } = options;
    let message = `\u{26A0}\u{FE0F} ${name} is deprecated and will be removed in version ${removalVersion}.`;
    if (alternative) message += ` ${alternative}.`;
    if (issueUrl) message += ` See ${issueUrl} for details.`;
    // eslint-disable-next-line no-console
    console.warn(message);
}
function $dc48d0fc58f955eb$export$406e4c8585b97b03({ name: name, removalVersion: removalVersion, issueUrl: issueUrl, alternative: alternative }) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).useEffect(()=>{
        $dc48d0fc58f955eb$export$fd85fde5373f97ba({
            name: name,
            removalVersion: removalVersion,
            issueUrl: issueUrl,
            alternative: alternative
        });
    }, [
        name,
        removalVersion,
        issueUrl,
        alternative
    ]);
}

});


parcelRegister("akyNT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7856c4ea03629091$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");
function $7856c4ea03629091$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $21sFD.jsx)("svg", {
        role: "img",
        "aria-label": "NASA Logo",
        width: "44",
        height: "44",
        viewBox: "0 0 44 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $21sFD.jsxs)("g", {
            id: "NASA_logo",
            children: [
                /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                    id: "Vector",
                    d: "M20.3614 39.939C30.26 39.939 38.2843 31.9146 38.2843 22.016C38.2843 12.1174 30.26 4.09303 20.3614 4.09303C10.4628 4.09303 2.43839 12.1174 2.43839 22.016C2.43839 31.9146 10.4628 39.939 20.3614 39.939Z",
                    fill: "#0C448C"
                }),
                /*#__PURE__*/ (0, $21sFD.jsxs)("g", {
                    id: "Group",
                    children: [
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_2",
                            d: "M19.3031 7.73658C19.4141 7.73658 19.5041 7.64662 19.5041 7.53565C19.5041 7.42468 19.4141 7.33472 19.3031 7.33472C19.1922 7.33472 19.1022 7.42468 19.1022 7.53565C19.1022 7.64662 19.1922 7.73658 19.3031 7.73658Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_3",
                            d: "M21.366 8.00449C21.477 8.00449 21.567 7.91453 21.567 7.80356C21.567 7.69259 21.477 7.60263 21.366 7.60263C21.2551 7.60263 21.1651 7.69259 21.1651 7.80356C21.1651 7.91453 21.2551 8.00449 21.366 8.00449Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_4",
                            d: "M24.0719 11.648C24.1829 11.648 24.2728 11.5581 24.2728 11.4471C24.2728 11.3361 24.1829 11.2462 24.0719 11.2462C23.9609 11.2462 23.871 11.3361 23.871 11.4471C23.871 11.5581 23.9609 11.648 24.0719 11.648Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_5",
                            d: "M9.22985 30.4015C9.34082 30.4015 9.43078 30.3116 9.43078 30.2006C9.43078 30.0896 9.34082 29.9997 9.22985 29.9997C9.11888 29.9997 9.02892 30.0896 9.02892 30.2006C9.02892 30.3116 9.11888 30.4015 9.22985 30.4015Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_6",
                            d: "M9.75226 32.009C9.86323 32.009 9.95319 31.919 9.95319 31.808C9.95319 31.6971 9.86323 31.6071 9.75226 31.6071C9.64129 31.6071 9.55133 31.6971 9.55133 31.808C9.55133 31.919 9.64129 32.009 9.75226 32.009Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_7",
                            d: "M7.26072 30.5922C7.34383 30.5922 7.4112 30.5248 7.4112 30.4417C7.4112 30.3586 7.34383 30.2912 7.26072 30.2912C7.17762 30.2912 7.11025 30.3586 7.11025 30.4417C7.11025 30.5248 7.17762 30.5922 7.26072 30.5922Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_8",
                            d: "M15.4319 33.7504C15.5152 33.7504 15.5828 33.6828 15.5828 33.5995C15.5828 33.5161 15.5152 33.4485 15.4319 33.4485C15.3485 33.4485 15.281 33.5161 15.281 33.5995C15.281 33.6828 15.3485 33.7504 15.4319 33.7504Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_9",
                            d: "M28.2477 31.0878C28.3308 31.0878 28.3981 31.0204 28.3981 30.9373C28.3981 30.8542 28.3308 30.7869 28.2477 30.7869C28.1645 30.7869 28.0972 30.8542 28.0972 30.9373C28.0972 31.0204 28.1645 31.0878 28.2477 31.0878Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_10",
                            d: "M31.972 27.0429C32.0554 27.0429 32.1229 26.9753 32.1229 26.8919C32.1229 26.8086 32.0554 26.741 31.972 26.741C31.8887 26.741 31.8211 26.8086 31.8211 26.8919C31.8211 26.9753 31.8887 27.0429 31.972 27.0429Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_11",
                            d: "M13.7173 12.7728C13.8004 12.7728 13.8678 12.7054 13.8678 12.6223C13.8678 12.5392 13.8004 12.4718 13.7173 12.4718C13.6342 12.4718 13.5668 12.5392 13.5668 12.6223C13.5668 12.7054 13.6342 12.7728 13.7173 12.7728Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_12",
                            d: "M17.8163 9.76241C17.8994 9.76241 17.9667 9.69504 17.9667 9.61193C17.9667 9.52883 17.8994 9.46146 17.8163 9.46146C17.7332 9.46146 17.6658 9.52883 17.6658 9.61193C17.6658 9.69504 17.7332 9.76241 17.8163 9.76241Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_13",
                            d: "M17.3711 9.46771C17.4542 9.46771 17.5216 9.40034 17.5216 9.31723C17.5216 9.23413 17.4542 9.16676 17.3711 9.16676C17.288 9.16676 17.2206 9.23413 17.2206 9.31723C17.2206 9.40034 17.288 9.46771 17.3711 9.46771Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_14",
                            d: "M16.9692 9.17301C17.0523 9.17301 17.1197 9.10564 17.1197 9.02254C17.1197 8.93943 17.0523 8.87206 16.9692 8.87206C16.8861 8.87206 16.8187 8.93943 16.8187 9.02254C16.8187 9.10564 16.8861 9.17301 16.9692 9.17301Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_15",
                            d: "M14.3603 13.5502C14.4434 13.5502 14.5107 13.4828 14.5107 13.3997C14.5107 13.3166 14.4434 13.2492 14.3603 13.2492C14.2772 13.2492 14.2098 13.3166 14.2098 13.3997C14.2098 13.4828 14.2772 13.5502 14.3603 13.5502Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_16",
                            d: "M20.398 5.71701C20.4811 5.71701 20.5485 5.64964 20.5485 5.56654C20.5485 5.48343 20.4811 5.41606 20.398 5.41606C20.3149 5.41606 20.2475 5.48343 20.2475 5.56654C20.2475 5.64964 20.3149 5.71701 20.398 5.71701Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_17",
                            d: "M21.3897 10.0571C21.4728 10.0571 21.5402 9.98973 21.5402 9.90663C21.5402 9.82352 21.4728 9.75615 21.3897 9.75615C21.3066 9.75615 21.2392 9.82352 21.2392 9.90663C21.2392 9.98973 21.3066 10.0571 21.3897 10.0571Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_18",
                            d: "M19.8256 9.20962C19.9087 9.20962 19.976 9.14225 19.976 9.05915C19.976 8.97604 19.9087 8.90867 19.8256 8.90867C19.7425 8.90867 19.6751 8.97604 19.6751 9.05915C19.6751 9.14225 19.7425 9.20962 19.8256 9.20962Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_19",
                            d: "M17.1465 10.3621C17.2296 10.3621 17.297 10.2947 17.297 10.2116C17.297 10.1285 17.2296 10.0611 17.1465 10.0611C17.0634 10.0611 16.996 10.1285 16.996 10.2116C16.996 10.2947 17.0634 10.3621 17.1465 10.3621Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_20",
                            d: "M28.9612 35.0631C29.0443 35.0631 29.1116 34.9957 29.1116 34.9126C29.1116 34.8295 29.0443 34.7622 28.9612 34.7622C28.8781 34.7622 28.8107 34.8295 28.8107 34.9126C28.8107 34.9957 28.8781 35.0631 28.9612 35.0631Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_21",
                            d: "M8.97534 31.3696C9.05869 31.3696 9.12626 31.302 9.12626 31.2186C9.12626 31.1353 9.05869 31.0677 8.97534 31.0677C8.89199 31.0677 8.82442 31.1353 8.82442 31.2186C8.82442 31.302 8.89199 31.3696 8.97534 31.3696Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_22",
                            d: "M19.4505 33.3119C19.5338 33.3119 19.6014 33.2443 19.6014 33.161C19.6014 33.0776 19.5338 33.01 19.4505 33.01C19.3671 33.01 19.2996 33.0776 19.2996 33.161C19.2996 33.2443 19.3671 33.3119 19.4505 33.3119Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_23",
                            d: "M12.0929 31.249C12.1762 31.249 12.2438 31.1814 12.2438 31.0981C12.2438 31.0147 12.1762 30.9472 12.0929 30.9472C12.0095 30.9472 11.942 31.0147 11.942 31.0981C11.942 31.1814 12.0095 31.249 12.0929 31.249Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_24",
                            d: "M13.3958 33.3757C13.4792 33.3757 13.5467 33.3082 13.5467 33.2248C13.5467 33.1415 13.4792 33.0739 13.3958 33.0739C13.3124 33.0739 13.2449 33.1415 13.2449 33.2248C13.2449 33.3082 13.3124 33.3757 13.3958 33.3757Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_25",
                            d: "M22.9869 32.0357C23.07 32.0357 23.1373 31.9684 23.1373 31.8853C23.1373 31.8022 23.07 31.7348 22.9869 31.7348C22.9037 31.7348 22.8364 31.8022 22.8364 31.8853C22.8364 31.9684 22.9037 32.0357 22.9869 32.0357Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_26",
                            d: "M28.2744 29.0517C28.3575 29.0517 28.4249 28.9844 28.4249 28.9013C28.4249 28.8181 28.3575 28.7508 28.2744 28.7508C28.1913 28.7508 28.124 28.8181 28.124 28.9013C28.124 28.9844 28.1913 29.0517 28.2744 29.0517Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_27",
                            d: "M32.2833 30.8833C32.3664 30.8833 32.4337 30.816 32.4337 30.7329C32.4337 30.6498 32.3664 30.5824 32.2833 30.5824C32.2002 30.5824 32.1328 30.6498 32.1328 30.7329C32.1328 30.816 32.2002 30.8833 32.2833 30.8833Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_28",
                            d: "M33.6495 31.7576C33.7326 31.7576 33.8 31.6902 33.8 31.6071C33.8 31.524 33.7326 31.4566 33.6495 31.4566C33.5664 31.4566 33.4991 31.524 33.4991 31.6071C33.4991 31.6902 33.5664 31.7576 33.6495 31.7576Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_29",
                            d: "M33.8742 29.3732C33.9573 29.3732 34.0246 29.3058 34.0246 29.2227C34.0246 29.1396 33.9573 29.0723 33.8742 29.0723C33.7911 29.0723 33.7237 29.1396 33.7237 29.2227C33.7237 29.3058 33.7911 29.3732 33.8742 29.3732Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_30",
                            d: "M13.9414 25.9976C14.0245 25.9976 14.0919 25.9302 14.0919 25.8471C14.0919 25.764 14.0245 25.6966 13.9414 25.6966C13.8583 25.6966 13.791 25.764 13.791 25.8471C13.791 25.9302 13.8583 25.9976 13.9414 25.9976Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_31",
                            d: "M13.9986 29.504C14.1096 29.504 14.1995 29.4141 14.1995 29.3031C14.1995 29.1921 14.1096 29.1022 13.9986 29.1022C13.8876 29.1022 13.7977 29.1921 13.7977 29.3031C13.7977 29.4141 13.8876 29.504 13.9986 29.504Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_32",
                            d: "M15.2042 32.0491C15.3151 32.0491 15.4051 31.9592 15.4051 31.8482C15.4051 31.7372 15.3151 31.6473 15.2042 31.6473C15.0932 31.6473 15.0032 31.7372 15.0032 31.8482C15.0032 31.9592 15.0932 32.0491 15.2042 32.0491Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_33",
                            d: "M29.6443 29.3969C29.7553 29.3969 29.8453 29.3069 29.8453 29.1959C29.8453 29.085 29.7553 28.995 29.6443 28.995C29.5334 28.995 29.4434 29.085 29.4434 29.1959C29.4434 29.3069 29.5334 29.3969 29.6443 29.3969Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_34",
                            d: "M34.8418 29.1022C34.9527 29.1022 35.0427 29.0122 35.0427 28.9012C35.0427 28.7903 34.9527 28.7003 34.8418 28.7003C34.7308 28.7003 34.6408 28.7903 34.6408 28.9012C34.6408 29.0122 34.7308 29.1022 34.8418 29.1022Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_35",
                            d: "M32.2698 28.0037C32.3808 28.0037 32.4708 27.9138 32.4708 27.8028C32.4708 27.6918 32.3808 27.6019 32.2698 27.6019C32.1589 27.6019 32.0689 27.6918 32.0689 27.8028C32.0689 27.9138 32.1589 28.0037 32.2698 28.0037Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_36",
                            d: "M29.6443 28.1109C29.7553 28.1109 29.8453 28.0209 29.8453 27.91C29.8453 27.799 29.7553 27.709 29.6443 27.709C29.5334 27.709 29.4434 27.799 29.4434 27.91C29.4434 28.0209 29.5334 28.1109 29.6443 28.1109Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_37",
                            d: "M24.2286 7.40973L24.7282 7.36196L24.2295 7.33383C24.2139 7.23738 24.1366 7.16192 24.0393 7.14942L23.9915 6.652L23.9629 7.15344C23.8727 7.17353 23.8035 7.24899 23.7924 7.34276L23.2815 7.38919L23.7959 7.41688C23.8147 7.50306 23.8843 7.57048 23.9719 7.58655L24.0183 8.09915L24.0455 7.58745C24.138 7.57182 24.2112 7.50082 24.2286 7.40973Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_38",
                            d: "M15.7958 12.9724L16.2954 12.9246L15.7967 12.8965C15.7815 12.8 15.7038 12.7246 15.6065 12.7121L15.5587 12.2147L15.5306 12.7161C15.4399 12.7362 15.3707 12.8116 15.3595 12.9054L14.8487 12.9518L15.3631 12.9795C15.3819 13.0657 15.4515 13.1331 15.539 13.1492L15.5855 13.6618L15.6132 13.1501C15.7056 13.1349 15.7788 13.0635 15.7958 12.9724Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_39",
                            d: "M34.4756 27.6796L34.9753 27.6318L34.4765 27.6037C34.4613 27.5072 34.3836 27.4318 34.2863 27.4193L34.2385 26.9219L34.2104 27.4233C34.1202 27.4434 34.051 27.5188 34.0398 27.6126L33.529 27.6591L34.0434 27.6867C34.0621 27.7729 34.1318 27.8403 34.2193 27.8564L34.2658 28.369L34.2934 27.8573C34.385 27.8421 34.4582 27.7711 34.4756 27.6796Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_40",
                            d: "M14.108 35.3694L14.6076 35.3216L14.1089 35.2935C14.0933 35.197 14.016 35.1216 13.9187 35.1091L13.8709 34.6121L13.8428 35.1131C13.7521 35.1332 13.6829 35.2086 13.6717 35.3024L13.1609 35.3489L13.6753 35.3765C13.6941 35.4627 13.7637 35.5306 13.8512 35.5462L13.8977 36.0588L13.9254 35.5471C14.0173 35.5319 14.091 35.4605 14.108 35.3694Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_41",
                            d: "M32.8883 31.6187L33.3879 31.571L32.8892 31.5428C32.874 31.4464 32.7963 31.3709 32.699 31.3584L32.6512 30.861L32.623 31.362C32.5329 31.3821 32.4636 31.4575 32.4525 31.5513L31.9417 31.5978L32.4561 31.6254C32.4748 31.7116 32.5445 31.779 32.632 31.7951L32.6784 32.3077L32.7061 31.796C32.7976 31.7813 32.8713 31.7098 32.8883 31.6187Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_42",
                            d: "M24.6117 17.7228C22.5278 18.5328 20.4953 19.2557 18.7803 19.7924C15.2953 20.8837 5.76 23.8378 0 27.5617L0.482232 27.7492C3.99181 25.7667 6.27304 25.1438 8.46586 24.454C10.8502 23.7038 18.5584 21.8999 22.0487 20.9176C23.228 20.5859 24.609 20.1514 26.0718 19.6227C25.7316 19.1481 25.3726 18.6721 24.9948 18.197C24.8685 18.0367 24.7403 17.8787 24.6117 17.7228ZM27.1577 21.232C26.6532 21.5726 26.2303 21.8446 25.9343 22.016C24.2197 23.0073 15.8605 28.7137 13.9588 30.0265C12.0571 31.3392 6.77894 36.3223 5.22508 37.769L5.1715 38.3579C10.1814 33.8571 11.7531 32.7471 13.7445 31.232C16.2093 29.3567 21.308 25.8873 23.0409 24.7755C24.6974 23.7128 26.1915 22.7354 27.5323 21.841C27.5105 21.8044 27.4886 21.7678 27.4667 21.7307C27.3658 21.5651 27.2627 21.399 27.1577 21.232ZM34.9891 12.9608C32.5485 14.3914 28.7018 16.1181 24.9698 17.5831C25.0591 17.6925 25.148 17.8027 25.2364 17.9139C25.6534 18.439 26.0468 18.9677 26.417 19.4968C29.3505 18.4163 32.5694 16.966 35.1235 15.2107C33.9067 16.3636 29.8841 19.37 27.4314 21.0458C27.5578 21.2516 27.6801 21.4574 27.7985 21.6624C31.5143 19.1758 34.0148 17.3455 35.4718 16.1216C37.4811 14.4338 42.0623 10.6563 43.8037 5.59288C40.7491 9.47798 37.1377 11.7012 34.9891 12.9608Z",
                            fill: "#E54D2F"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_43",
                            d: "M18.0551 26.4539C17.66 25.9565 17.1134 25.2903 16.7031 24.7737C16.1543 24.0829 15.6467 23.385 15.1814 22.688C15.0296 22.726 14.8782 22.7639 14.7268 22.8019C15.2886 23.6784 15.9123 24.5536 16.5919 25.4091C17.0884 26.0342 17.5399 26.5374 17.7712 26.8504C17.818 26.9138 17.9109 27.054 18.0364 27.2407C18.1811 27.1424 18.3271 27.0433 18.4744 26.9433C18.332 26.7884 18.1913 26.6254 18.0551 26.4539ZM20.9396 29.0723C20.615 28.7651 19.8278 28.252 19.0084 27.4822C18.8276 27.6064 18.645 27.7323 18.4619 27.8591C18.991 28.6048 19.7117 29.5206 20.2761 29.7876C21.1262 30.1903 21.3553 29.4661 20.9396 29.0723ZM25.2364 17.9139C20.5516 12.0173 14.8286 8.77785 12.3612 10.7385C10.4448 12.2611 11.2315 16.711 13.8731 21.3856C14.0097 21.3387 14.145 21.2927 14.279 21.2471C11.6129 16.6927 10.8833 12.4602 12.6907 11.0238C14.9621 9.219 20.4467 12.4709 24.9957 18.1966C25.9374 19.3816 26.7652 20.5711 27.4663 21.7307C30.1507 26.1735 30.9745 30.1912 29.1197 31.8313C28.5522 32.3331 26.8179 32.5301 24.5461 31.5075C24.5144 31.5473 24.5653 31.6549 24.605 31.6812C26.5661 32.4698 28.4446 32.7703 29.393 32.017C31.6719 30.206 29.9212 23.8106 25.2364 17.9139Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_44",
                            d: "M5.14426 18.6136H8.14482L10.6631 22.8867C10.6631 22.8867 10.6631 19.7924 10.6631 19.5513C10.6631 19.1762 10.1876 18.6873 10.0202 18.6136C10.2211 18.6136 11.9759 18.6136 12.0964 18.6136C11.9692 18.6471 11.5606 19.1427 11.5606 19.5513C11.5606 19.7522 11.5606 24.2397 11.5606 24.454C11.5606 24.7554 11.996 25.1706 12.2036 25.3314H9.31021L6.7517 21.0382C6.7517 21.0382 6.7517 24.2397 6.7517 24.4138C6.7517 24.7487 7.07989 25.0702 7.42147 25.3448H5.21124C5.52603 25.2108 5.82742 24.7889 5.85421 24.454C5.881 24.1191 5.85421 19.7991 5.85421 19.6116C5.85421 19.203 5.45905 18.8681 5.14426 18.6136Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_45",
                            d: "M32.5913 25.3314H36.5831C36.3621 25.2778 36.1143 25.0166 35.9804 24.6683C35.8464 24.32 33.7299 18.6136 33.7299 18.6136H32.2122C31.7818 18.9235 31.3206 19.2503 30.8281 19.5946C30.8267 19.6071 30.8254 19.6196 30.8231 19.6317C30.7571 20.0335 29.5693 24.3352 29.497 24.5478C29.3965 24.8425 28.8808 25.1706 28.6732 25.3448H30.8231C30.6088 25.1037 30.4347 24.8692 30.4749 24.6013C30.515 24.3334 30.6356 23.7976 30.6356 23.7976H32.8592C32.9597 24.0655 33.0347 24.3062 33.0736 24.5344C33.1204 24.809 32.8391 25.1171 32.5913 25.3314ZM30.8365 22.9403L31.5867 20.489L32.5779 22.9403H30.8365ZM30.4985 18.8583C30.6088 18.777 30.7196 18.6953 30.8298 18.6136H30.2471C30.3052 18.6672 30.4012 18.7516 30.4985 18.8583Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_46",
                            d: "M15.231 24.6013C15.2711 24.3334 15.3917 23.7976 15.3917 23.7976H17.6153C17.7158 24.0655 17.7908 24.3062 17.8297 24.5344C17.8765 24.809 17.5952 25.1171 17.3474 25.3314H20.8619C20.9351 25.2823 21.0079 25.2332 21.0807 25.1845C20.9445 25.0639 20.819 24.8831 20.7364 24.6683C20.6025 24.32 18.486 18.6136 18.486 18.6136H15.0032C15.1707 18.7677 15.6529 19.1829 15.5792 19.6317C15.5136 20.0335 14.3254 24.3352 14.2531 24.5478C14.1526 24.8425 13.6369 25.1706 13.4293 25.3448H15.5792C15.3649 25.1037 15.1908 24.8692 15.231 24.6013ZM16.3428 20.489L17.334 22.9403H15.5926L16.3428 20.489Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                            id: "Vector_47",
                            d: "M27.3712 21.9482C26.7157 22.3848 26.024 22.8407 25.2953 23.3167C25.6222 23.4752 25.8825 23.6744 25.9075 23.9316C25.9539 24.4147 24.9832 24.6482 24.1058 24.5477C23.9303 24.5276 23.758 24.4817 23.5937 24.42C23.4115 24.5375 23.2275 24.6558 23.0409 24.7755C22.8511 24.8974 22.6207 25.0474 22.3577 25.2206V25.9141C22.5319 25.5725 22.9127 25.2666 23.2083 25.251C23.3356 25.2443 23.7776 25.6529 25.5994 25.5524C26.4835 25.5037 28.1914 24.5611 28.1646 23.4761C28.1485 22.8349 27.8136 22.3348 27.3712 21.9482ZM22.3573 23.6235V24.3298C22.5185 24.2222 22.6774 24.1164 22.8333 24.0133C22.5881 23.8427 22.4144 23.6833 22.3573 23.6235ZM26.7483 21.5048C26.5786 21.4043 26.4067 21.3163 26.2419 21.2386C25.3846 20.8368 24.4871 20.7631 24.2996 20.2206C24.1674 19.8379 24.5407 19.4839 25.4516 19.4972C26.3625 19.5106 27.2064 20.0532 27.4341 20.2474V18.5194C27.3671 18.5864 27.0733 18.9235 26.8045 18.8677C26.2888 18.7605 25.4114 18.6207 24.4068 18.6265C23.2548 18.6332 22.2635 19.5236 22.23 20.6492C22.1831 22.2232 23.4423 22.6519 24.1523 22.8997C24.2255 22.9251 24.309 22.9524 24.3996 22.9814C25.0805 22.5384 25.619 22.1973 25.9343 22.0156C26.1459 21.8937 26.4232 21.7186 26.7483 21.5048Z",
                            fill: "white"
                        })
                    ]
                })
            ]
        })
    });
}

});

parcelRegister("iCOkj", function(module, exports) {

$parcel$export(module.exports, "LayoutRootContext", function () { return $49f5069387b4a1ef$export$9f21f7ede1976202; });
$parcel$export(module.exports, "LayoutRootContextProvider", function () { return $49f5069387b4a1ef$export$80b18b0852738b00; });

var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");

var $6IPSj = parcelRequire("6IPSj");

var $kPcTz = parcelRequire("kPcTz");
const $49f5069387b4a1ef$export$9f21f7ede1976202 = /*#__PURE__*/ (0, $3RyIS.createContext)({});
function $49f5069387b4a1ef$export$80b18b0852738b00({ children: children }) {
    const [layoutProps, setLayoutProps] = (0, $3RyIS.useState)({});
    const [feedbackModalRevealed, setFeedbackModalRevealed] = (0, $3RyIS.useState)(false);
    // Put the header size and visibility status in the context so that children
    // elements can access them for positioning purposes.
    const location = (0, $6IPSj.useLocation)().pathname;
    const hideNav = layoutProps.hideNav;
    const { isHeaderHidden: isHeaderHidden, headerHeight: headerHeight, wrapperHeight: wrapperHeight } = (0, $kPcTz.useSlidingStickyHeader)(location, hideNav);
    const ctx = {
        ...layoutProps,
        setLayoutProps: setLayoutProps,
        isHeaderHidden: isHeaderHidden,
        headerHeight: headerHeight,
        wrapperHeight: wrapperHeight,
        feedbackModalRevealed: feedbackModalRevealed,
        setFeedbackModalRevealed: setFeedbackModalRevealed
    };
    return /*#__PURE__*/ (0, $21sFD.jsx)($49f5069387b4a1ef$export$9f21f7ede1976202.Provider, {
        value: ctx,
        children: children
    });
}

});
parcelRegister("kPcTz", function(module, exports) {

$parcel$export(module.exports, "HEADER_ID", function () { return $2d45f6b930165f7d$export$b9c335479effb691; });
$parcel$export(module.exports, "HEADER_WRAPPER_ID", function () { return $2d45f6b930165f7d$export$4eb51c692ca09c42; });
$parcel$export(module.exports, "HEADER_TRANSITION_DURATION", function () { return $2d45f6b930165f7d$export$1d27eb55ded4794e; });
$parcel$export(module.exports, "useSlidingStickyHeader", function () { return $2d45f6b930165f7d$export$eced29d7b59956a2; });

var $3RyIS = parcelRequire("3RyIS");

var $4FYyx = parcelRequire("4FYyx");
const $2d45f6b930165f7d$export$b9c335479effb691 = "page-header";
const $2d45f6b930165f7d$export$4eb51c692ca09c42 = "header-wrapper";
const $2d45f6b930165f7d$export$1d27eb55ded4794e = 320;
function $2d45f6b930165f7d$export$eced29d7b59956a2(pathname, disabled = false) {
    const [isHidden, setHidden] = (0, $3RyIS.useState)(false);
    const [headerHeight, setHeaderHeight] = (0, $3RyIS.useState)(0);
    const [wrapperHeight, setWrapperHeight] = (0, $3RyIS.useState)(0);
    const navWrapperElement = document.querySelector(`#${$2d45f6b930165f7d$export$4eb51c692ca09c42}`);
    const prevPathname = (0, $4FYyx.usePreviousValue)(pathname);
    (0, $3RyIS.useEffect)(()=>{
        if (disabled) return;
        const pageChanged = prevPathname !== pathname;
        if (pageChanged) {
            setHidden(false);
            setHeaderHeight(0);
            setWrapperHeight(0);
        }
    }, [
        pathname,
        prevPathname,
        disabled
    ]);
    (0, $3RyIS.useEffect)(()=>{
        if (disabled || !navWrapperElement) return;
        let ticking = false;
        let prevY = window.scrollY;
        let scrollUpDelta = 0;
        // navWrapperElement should be mounted before the hook
        // When the element mounts the <Suspense> element is still in the DOM and
        // the page has display: none. The result is that any measurement of the
        // header would be 0. By using an IntersectionObserver we are able to get
        // the correct height once the element becomes visible.
        const observer = new IntersectionObserver(([e])=>{
            if (e.isIntersecting) {
                observer.unobserve(navWrapperElement);
                // Initial height.
                // Get the height of the header and the wrapper. Both are needed because in
                // some pages the wrapper contains the local nav as well.
                const headerHeightQueried = document.querySelector(`#${$2d45f6b930165f7d$export$b9c335479effb691}`)?.offsetHeight || 0;
                setHeaderHeight(headerHeightQueried);
                setWrapperHeight(navWrapperElement.offsetHeight);
                // The header is hidden if the page is loaded and the user is scrolled
                // mid-way.
                setHidden(window.scrollY > headerHeightQueried);
            }
        });
        observer.observe(navWrapperElement);
        function tick(currY) {
            const wrapperEl = document.querySelector(`#${$2d45f6b930165f7d$export$4eb51c692ca09c42}`);
            if (!wrapperEl) throw new Error(`Header element with ID ${$2d45f6b930165f7d$export$4eb51c692ca09c42} not found.`);
            setWrapperHeight(wrapperEl.offsetHeight);
            const el = document.querySelector(`#${$2d45f6b930165f7d$export$b9c335479effb691}`);
            const headerHeightQueried = el?.offsetHeight ?? 0;
            setHeaderHeight(headerHeightQueried);
            // When the document is scrolled quickly to the bottom of the page, the
            // shrinking header causes the scroll event to be fired again, and since
            // the page is shrinking, the scrollY is decreasing leading to the page
            // header being shown as it is being considered a scroll up.
            // By checking if we are at the bottom, we can prevent this.
            const atTheBottom = window.innerHeight + Math.ceil(window.pageYOffset) >= document.body.offsetHeight;
            if (currY <= headerHeightQueried) {
                // When the header gets hidden the css transitions the element out of
                // the viewport by applying a negative translate. (See NavWrapper). If
                // the user scrolls to the top of the page quickly and the header
                // still has to animate to be shown it looks like a glitch because a
                // white area will be seen. In this situation we remove the
                // translation so that it looks like the header is already there.
                // Additionally this has to be done by accessing the DOM node directly
                // instead of using a state because the styled component does not
                // update fast enough.
                wrapperEl.style.transition = "none";
                // Visible if within its height.
                setHidden(false);
                scrollUpDelta = 0;
            } else if (currY < prevY && !atTheBottom) {
                // Scrolling up.
                scrollUpDelta += prevY - currY;
                // When scrolling up we want some travel before showing the header
                // again.
                if (scrollUpDelta > 64) {
                    wrapperEl.style.transition = "";
                    setHidden(false);
                }
            } else if (currY > prevY) {
                wrapperEl.style.transition = "";
                // Scrolling down.
                setHidden(true);
                scrollUpDelta = 0;
            }
            prevY = currY;
        }
        function onViewportPositionChange() {
            if (!ticking) {
                // instead of setting a specific number of ms to wait (throttling),
                // pass it to the browser to be processed on the next frame, whenever that may be.
                window.requestAnimationFrame(()=>{
                    tick(window.scrollY);
                    ticking = false;
                });
                ticking = true;
            }
        }
        window.addEventListener("scroll", onViewportPositionChange);
        window.addEventListener("resize", onViewportPositionChange);
        return ()=>{
            window.removeEventListener("scroll", onViewportPositionChange);
            window.removeEventListener("resize", onViewportPositionChange);
        };
    }, [
        navWrapperElement,
        disabled
    ]);
    return {
        isHeaderHidden: isHidden,
        headerHeight: headerHeight,
        wrapperHeight: wrapperHeight
    };
}

});
parcelRegister("4FYyx", function(module, exports) {

$parcel$export(module.exports, "useEffectPrevious", function () { return $11ed540c923fa77b$export$a1374b051b334514; });
$parcel$export(module.exports, "useLayoutEffectPrevious", function () { return $11ed540c923fa77b$export$de77312506f02988; });
$parcel$export(module.exports, "usePreviousValue", function () { return $11ed540c923fa77b$export$54b70074ca60d2e1; });

var $3RyIS = parcelRequire("3RyIS");
function $11ed540c923fa77b$var$makePreviousHook(effectHook) {
    return (cb, deps)=>{
        const prev = (0, $3RyIS.useRef)([]);
        const mounted = (0, $3RyIS.useRef)(false);
        const unchangingCb = (0, $3RyIS.useRef)(cb);
        unchangingCb.current = cb;
        effectHook(()=>{
            const r = unchangingCb.current(prev.current, mounted.current);
            prev.current = deps;
            if (!mounted.current) mounted.current = true;
            return r;
        /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, deps);
    };
}
const $11ed540c923fa77b$export$a1374b051b334514 = $11ed540c923fa77b$var$makePreviousHook((0, $3RyIS.useEffect));
const $11ed540c923fa77b$export$de77312506f02988 = $11ed540c923fa77b$var$makePreviousHook((0, $3RyIS.useLayoutEffect));
const $11ed540c923fa77b$export$54b70074ca60d2e1 = (value, isEqualFunc = (a, b)=>a === b)=>{
    const ref = (0, $3RyIS.useRef)(undefined);
    const current = ref.current;
    if (!isEqualFunc(current, value)) ref.current = value;
    return current;
};

});



parcelRegister("lhcdM", function(module, exports) {

$parcel$export(module.exports, "setGoogleTagManager", function () { return $d07ed5b3cfe34d76$export$22817efb0158eaec; });

var $iTuet = parcelRequire("iTuet");
const $d07ed5b3cfe34d76$var$gtMCode = undefined;
const $d07ed5b3cfe34d76$var$gtmAuth = undefined;
const $d07ed5b3cfe34d76$var$gtmPreviewEnv = undefined;
// This variables should be saved in env.local or CI
const $d07ed5b3cfe34d76$var$tagManagerArgs = {
    gtmId: $d07ed5b3cfe34d76$var$gtMCode,
    auth: $d07ed5b3cfe34d76$var$gtmAuth,
    preview: $d07ed5b3cfe34d76$var$gtmPreviewEnv,
    cookies_win: "x"
};
function $d07ed5b3cfe34d76$export$22817efb0158eaec() {
    if ($d07ed5b3cfe34d76$var$gtMCode) (0, (/*@__PURE__*/$parcel$interopDefault($iTuet))).initialize($d07ed5b3cfe34d76$var$tagManagerArgs);
}

});
parcelRegister("iTuet", function(module, exports) {
"use strict";

var $bPYck = parcelRequire("bPYck");
var $dc14d099fa278213$var$_TagManager2 = $dc14d099fa278213$var$_interopRequireDefault($bPYck);
function $dc14d099fa278213$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = $dc14d099fa278213$var$_TagManager2.default;

});
parcelRegister("bPYck", function(module, exports) {
"use strict";

var $hACRx = parcelRequire("hACRx");
var $89e3272e20a02e03$var$_Snippets2 = $89e3272e20a02e03$var$_interopRequireDefault($hACRx);
function $89e3272e20a02e03$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $89e3272e20a02e03$var$TagManager = {
    dataScript: function dataScript(dataLayer) {
        var script = document.createElement("script");
        script.innerHTML = dataLayer;
        return script;
    },
    gtm: function gtm(args) {
        var snippets = $89e3272e20a02e03$var$_Snippets2.default.tags(args);
        var noScript = function noScript() {
            var noscript = document.createElement("noscript");
            noscript.innerHTML = snippets.iframe;
            return noscript;
        };
        var script = function script() {
            var script = document.createElement("script");
            script.innerHTML = snippets.script;
            return script;
        };
        var dataScript = this.dataScript(snippets.dataLayerVar);
        return {
            noScript: noScript,
            script: script,
            dataScript: dataScript
        };
    },
    initialize: function initialize(_ref) {
        var gtmId = _ref.gtmId, _ref$events = _ref.events, events = _ref$events === undefined ? {} : _ref$events, dataLayer = _ref.dataLayer, _ref$dataLayerName = _ref.dataLayerName, dataLayerName = _ref$dataLayerName === undefined ? "dataLayer" : _ref$dataLayerName, _ref$auth = _ref.auth, auth = _ref$auth === undefined ? "" : _ref$auth, _ref$preview = _ref.preview, preview = _ref$preview === undefined ? "" : _ref$preview;
        var gtm = this.gtm({
            id: gtmId,
            events: events,
            dataLayer: dataLayer || undefined,
            dataLayerName: dataLayerName,
            auth: auth,
            preview: preview
        });
        if (dataLayer) document.head.appendChild(gtm.dataScript);
        document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
        document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
    },
    dataLayer: function dataLayer(_ref2) {
        var _dataLayer = _ref2.dataLayer, _ref2$dataLayerName = _ref2.dataLayerName, dataLayerName = _ref2$dataLayerName === undefined ? "dataLayer" : _ref2$dataLayerName;
        if (window[dataLayerName]) return window[dataLayerName].push(_dataLayer);
        var snippets = $89e3272e20a02e03$var$_Snippets2.default.dataLayer(_dataLayer, dataLayerName);
        var dataScript = this.dataScript(snippets);
        document.head.insertBefore(dataScript, document.head.childNodes[0]);
    }
};
module.exports = $89e3272e20a02e03$var$TagManager;

});
parcelRegister("hACRx", function(module, exports) {
"use strict";

var $4g0Zx = parcelRequire("4g0Zx");
var $cce3f1bf2ddc87c1$var$_warn2 = $cce3f1bf2ddc87c1$var$_interopRequireDefault($4g0Zx);
function $cce3f1bf2ddc87c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// https://developers.google.com/tag-manager/quickstart
var $cce3f1bf2ddc87c1$var$Snippets = {
    tags: function tags(_ref) {
        var id = _ref.id, events = _ref.events, dataLayer = _ref.dataLayer, dataLayerName = _ref.dataLayerName, preview = _ref.preview, auth = _ref.auth;
        var gtm_auth = "&gtm_auth=" + auth;
        var gtm_preview = "&gtm_preview=" + preview;
        if (!id) (0, $cce3f1bf2ddc87c1$var$_warn2.default)("GTM Id is required");
        var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';
        var script = "\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js', " + JSON.stringify(events).slice(1, -1) + "});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';\n        j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'" + gtm_auth + gtm_preview + "&gtm_cookies_win=x';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,'script','" + dataLayerName + "','" + id + "');";
        var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);
        return {
            iframe: iframe,
            script: script,
            dataLayerVar: dataLayerVar
        };
    },
    dataLayer: function dataLayer(_dataLayer, dataLayerName) {
        return "\n      window." + dataLayerName + " = window." + dataLayerName + " || [];\n      window." + dataLayerName + ".push(" + JSON.stringify(_dataLayer) + ")";
    }
};
module.exports = $cce3f1bf2ddc87c1$var$Snippets;

});
parcelRegister("4g0Zx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $31996cf5da2733cc$var$warn = function warn(s) {
    console.warn("[react-gtm]", s);
};
module.exports.default = $31996cf5da2733cc$var$warn;

});





parcelRegister("5l1xF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e301c24112c75dc$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $idnjL = parcelRequire("idnjL");

var $jGOns = parcelRequire("jGOns");

var $9Puxc = parcelRequire("9Puxc");

var $e7LLc = parcelRequire("e7LLc");

var $akyNT = parcelRequire("akyNT");

var $kPcTz = parcelRequire("kPcTz");

var $39y1u = parcelRequire("39y1u");
const $3e301c24112c75dc$var$NavWrapperContainer = (0, $6fhRl.default).div`
  position: sticky;
  top: 0;
  width: 100%;
  z-index: ${(0, $atWKR.themeVal)("zIndices.sticky")};

  transition: top ${(0, $kPcTz.HEADER_TRANSITION_DURATION)}ms ease-out;
  ${({ shouldSlideHeader: shouldSlideHeader, headerHeight: headerHeight })=>// Hide the header by translating the nav by the header's height. The
    // translate is in the NavWrapper and not the header because in this way the
    // localNav (also inside the NavWrapper) will stick to the top.
    shouldSlideHeader && (0, $6fhRl.css)`
      top: -${headerHeight}px;
    `}
`;
// Hiding configurable map for now until Instances are ready to adapt it
const $3e301c24112c75dc$var$isUSWDSEnabled = (0, $39y1u.checkEnvFlag)(undefined);
const $3e301c24112c75dc$var$appTitle = $3e301c24112c75dc$var$isUSWDSEnabled ? "Earthdata VEDA Dashboard" : "U.S. Greenhouse Gas Center";
function $3e301c24112c75dc$var$NavWrapper(props) {
    const { isHeaderHidden: isHeaderHidden, headerHeight: headerHeight } = (0, $e7LLc.useSlidingStickyHeaderProps)();
    return $3e301c24112c75dc$var$isUSWDSEnabled ? /*#__PURE__*/ (0, $21sFD.jsx)((0, $9Puxc.default), {
        ...props,
        logoSvg: /*#__PURE__*/ (0, $21sFD.jsx)((0, $akyNT.default), {}),
        title: $3e301c24112c75dc$var$appTitle
    }) : /*#__PURE__*/ (0, $21sFD.jsx)($3e301c24112c75dc$var$NavWrapperContainer, {
        id: (0, $kPcTz.HEADER_WRAPPER_ID),
        shouldSlideHeader: isHeaderHidden,
        headerHeight: headerHeight,
        children: /*#__PURE__*/ (0, $21sFD.jsx)((0, $jGOns.default), {
            ...props,
            linkProperties: {
                LinkElement: (0, $idnjL.NavLink),
                pathAttributeKeyName: "to"
            }
        })
    });
}
var $3e301c24112c75dc$export$2e2bcd8739ae039 = $3e301c24112c75dc$var$NavWrapper;

});
parcelRegister("jGOns", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fa9c4eba08958a5$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $8KsRR = parcelRequire("8KsRR");

var $egbTY = parcelRequire("egbTY");

var $9HCvT = parcelRequire("9HCvT");

var $2JIVh = parcelRequire("2JIVh");

var $h7JSo = parcelRequire("h7JSo");

var $dMk3s = parcelRequire("dMk3s");

var $04Xx0 = parcelRequire("04Xx0");

var $hNqhF = parcelRequire("hNqhF");

var $6vRkW = parcelRequire("6vRkW");

var $kPcTz = parcelRequire("kPcTz");
// @DEPRECATED: This component is deprecated and will be removed in the future.
const $2fa9c4eba08958a5$var$PageHeaderSelf = (0, $6fhRl.default).header`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  gap: ${(0, $04Xx0.variableGlsp)()};
  padding: ${(0, $04Xx0.variableGlsp)(0.75, 1)};
  background: ${(0, $atWKR.themeVal)("color.primary")};
  animation: ${(0, $8KsRR.reveal)} 0.32s ease 0s 1;

  &,
  &:visited {
    color: ${(0, $atWKR.themeVal)("color.surface")};
  }
`;
const $2fa9c4eba08958a5$var$GlobalNav = (0, $6fhRl.default).nav`
  position: fixed;
  inset: 0 0 0 auto;
  z-index: 900;
  display: flex;
  flex-flow: column nowrap;
  width: 20rem;
  margin-right: -20rem;
  transition: margin 0.24s ease 0s;

  ${({ revealed: revealed })=>revealed && (0, $6fhRl.css)`
      & {
        margin-right: 0;
      }
    `}

  ${(0, $atWKR.media).largeUp`
    position: static;
    flex: 1;
    margin: 0;
  }

    &:before {
      content: '';
    }
  `}

  /* Show page nav backdrop on small screens */

  &::after {
    content: '';
    position: absolute;
    inset: 0 0 0 auto;
    z-index: -1;
    background: transparent;
    width: 0;
    transition: background 0.64s ease 0s;

    ${({ revealed: revealed })=>revealed && (0, $6fhRl.css)`
        ${(0, $atWKR.media).mediumDown`
          background: ${(0, $atWKR.themeVal)("color.base-400a")};
          width: 200vw;
        `}
      `}
  }
`;
const $2fa9c4eba08958a5$var$GlobalNavInner = (0, $6fhRl.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${(0, $atWKR.themeVal)("color.primary")};

  ${(0, $atWKR.media).mediumDown`
    box-shadow: ${(0, $atWKR.themeVal)("boxShadow.elevationD")};
  `}
`;
const $2fa9c4eba08958a5$var$GlobalNavHeader = (0, $6fhRl.default).div`
  padding: ${(0, $04Xx0.variableGlsp)(1)};
  box-shadow: inset 0 -1px 0 0 ${(0, $atWKR.themeVal)("color.surface-200a")};
  ${(0, $atWKR.media).largeUp`
    display: none;
  `}
`;
const $2fa9c4eba08958a5$var$GlobalNavTitle = (0, $6fhRl.default)((0, $egbTY.Heading)).attrs({
    as: "span",
    size: "small"
})`
  /* styled-component */
`;
const $2fa9c4eba08958a5$export$9dcb6ed886c28a2f = (0, $6fhRl.default).div`
  align-self: start;
  ${(0, $atWKR.media).largeUp`
    display: none;
  `}
`;
const $2fa9c4eba08958a5$export$64eb44db16fa7ade = (0, $6fhRl.default)((0, $9HCvT.Button))`
  z-index: 2000;
`;
const $2fa9c4eba08958a5$var$GlobalNavBody = (0, $6fhRl.default).div`
  display: flex;
  flex: 1;

  .shadow-top {
    background: linear-gradient(
      to top,
      ${(0, $atWKR.themeVal)("color.primary-600")}00 0%,
      ${(0, $atWKR.themeVal)("color.primary-600")} 100%
    );
  }

  .shadow-bottom {
    background: linear-gradient(
      to bottom,
      ${(0, $atWKR.themeVal)("color.primary-600")}00 0%,
      ${(0, $atWKR.themeVal)("color.primary-600")} 100%
    );
  }
`;
const $2fa9c4eba08958a5$var$GlobalNavBodyInner = (0, $6fhRl.default).div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${(0, $04Xx0.variableGlsp)()};
  padding: ${(0, $04Xx0.variableGlsp)(1, 0)};

  ${(0, $atWKR.media).largeUp`
    flex-direction: row;
    justify-content: space-between;
    padding: 0;
  `}
`;
const $2fa9c4eba08958a5$var$NavBlock = (0, $6fhRl.default).div`
  display: flex;
  flex-flow: column nowrap;
  gap: ${(0, $atWKR.glsp)(0.25)};

  ${(0, $atWKR.media).largeUp`
    flex-direction: row;
    align-items: center;
    gap: ${(0, $atWKR.glsp)(1.5)};
  `}
`;
const $2fa9c4eba08958a5$var$SROnly = (0, $6fhRl.default).a`
  height: 1px;
  left: -10000px;
  overflow: hidden;
  position: absolute;
  top: auto;
  width: 1px;
  color: ${(0, $atWKR.themeVal)("color.link")};
  &:focus {
    top: 0;
    left: 0;
    background-color: ${(0, $atWKR.themeVal)("color.surface")};
    padding: ${(0, $atWKR.glsp)(0.25)};
    height: auto;
    width: auto;
  }
`;
const $2fa9c4eba08958a5$var$SectionsNavBlock = (0, $6fhRl.default)($2fa9c4eba08958a5$var$NavBlock)`
  /* styled-component */
`;
const $2fa9c4eba08958a5$var$GlobalNavBlockTitle = (0, $6fhRl.default)((0, $egbTY.Overline)).attrs({
    as: "span"
})`
  ${(0, $atWKR.visuallyHidden)}
  display: block;
  padding: ${(0, $04Xx0.variableGlsp)(1, 1, 0.25, 1)};
  color: currentColor;
  opacity: 0.64;

  ${(0, $atWKR.media).largeUp`
    padding: 0;
  `}
`;
const $2fa9c4eba08958a5$var$GlobalMenu = (0, $6fhRl.default).ul`
  ${(0, $atWKR.listReset)()}
  display: flex;
  flex-flow: column nowrap;
  gap: ${(0, $atWKR.glsp)(0.5)};

  ${(0, $atWKR.media).largeUp`
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: ${(0, $atWKR.glsp)(1.5)};
  `}
`;
function $2fa9c4eba08958a5$var$PageHeaderLegacy(props) {
    const { mainNavItems: mainNavItems, subNavItems: subNavItems, logo: logo, linkProperties: linkProperties } = props;
    const { isMediumDown: isMediumDown } = (0, $6vRkW.useMediaQuery)();
    const [globalNavRevealed, setGlobalNavRevealed] = (0, $3RyIS.useState)(false);
    const globalNavBodyRef = (0, $3RyIS.useRef)(null);
    // Click listener for the whole global nav body so we can close it when clicking
    // the overlay on medium down media query.
    const onGlobalNavClick = (0, $3RyIS.useCallback)((e)=>{
        if (!globalNavBodyRef.current?.contains(e.target)) setGlobalNavRevealed(false);
    }, []);
    (0, $3RyIS.useEffect)(()=>{
        // Close global nav when media query changes.
        // NOTE: isMediumDown is returning document.body's width, not the whole window width
        // which conflicts with how mediaquery decides the width.
        // JSX element susing isMediumDown is also protected with css logic because of this.
        // ex. Look at GlobalNavActions
        if (!isMediumDown) setGlobalNavRevealed(false);
    }, [
        isMediumDown
    ]);
    const closeNavOnClick = (0, $3RyIS.useCallback)(()=>{
        setGlobalNavRevealed(false);
    }, []);
    function skipNav(e) {
        // a tag won't appear for keyboard focus without href
        // so we are preventing the default behaviour of a link here
        e.preventDefault();
        // Then find a next focusable element in pagebody,focus it.
        const pageBody = document.getElementById((0, $hNqhF.PAGE_BODY_ID));
        if (pageBody) pageBody.focus();
    }
    return /*#__PURE__*/ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
        children: [
            /*#__PURE__*/ (0, $21sFD.jsx)($2fa9c4eba08958a5$var$SROnly, {
                href: "#",
                onClick: skipNav,
                children: "Skip to main content"
            }),
            /*#__PURE__*/ (0, $21sFD.jsxs)($2fa9c4eba08958a5$var$PageHeaderSelf, {
                id: (0, $kPcTz.HEADER_ID),
                children: [
                    globalNavRevealed && isMediumDown && /*#__PURE__*/ (0, $21sFD.jsx)((0, $h7JSo.default), {}),
                    logo,
                    isMediumDown && /*#__PURE__*/ (0, $21sFD.jsx)($2fa9c4eba08958a5$export$9dcb6ed886c28a2f, {
                        children: /*#__PURE__*/ (0, $21sFD.jsx)($2fa9c4eba08958a5$export$64eb44db16fa7ade, {
                            "aria-label": globalNavRevealed ? "Close Global Navigation" : "Open Global Navigation",
                            // @ts-expect-error UI lib error. achromic-text does exit
                            variation: "achromic-text",
                            fitting: "skinny",
                            onClick: ()=>setGlobalNavRevealed((v)=>!v),
                            active: globalNavRevealed,
                            children: /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Icon).Menu, {
                                size: 3
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)($2fa9c4eba08958a5$var$GlobalNav, {
                        "aria-label": "Global Navigation",
                        role: "navigation",
                        revealed: globalNavRevealed,
                        onClick: onGlobalNavClick,
                        children: /*#__PURE__*/ (0, $21sFD.jsxs)($2fa9c4eba08958a5$var$GlobalNavInner, {
                            ref: globalNavBodyRef,
                            children: [
                                isMediumDown && /*#__PURE__*/ (0, $21sFD.jsx)((0, $21sFD.Fragment), {
                                    children: /*#__PURE__*/ (0, $21sFD.jsx)($2fa9c4eba08958a5$var$GlobalNavHeader, {
                                        children: /*#__PURE__*/ (0, $21sFD.jsx)($2fa9c4eba08958a5$var$GlobalNavTitle, {
                                            "aria-hidden": "true",
                                            children: "Browse"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $21sFD.jsx)($2fa9c4eba08958a5$var$GlobalNavBody, {
                                    as: isMediumDown ? undefined : "div",
                                    children: /*#__PURE__*/ (0, $21sFD.jsxs)($2fa9c4eba08958a5$var$GlobalNavBodyInner, {
                                        children: [
                                            /*#__PURE__*/ (0, $21sFD.jsxs)($2fa9c4eba08958a5$var$SectionsNavBlock, {
                                                children: [
                                                    /*#__PURE__*/ (0, $21sFD.jsx)($2fa9c4eba08958a5$var$GlobalNavBlockTitle, {
                                                        children: "Global"
                                                    }),
                                                    /*#__PURE__*/ (0, $21sFD.jsx)($2fa9c4eba08958a5$var$GlobalMenu, {
                                                        children: mainNavItems.map((item)=>{
                                                            return /*#__PURE__*/ (0, $21sFD.jsx)((0, $dMk3s.default), {
                                                                linkProperties: linkProperties,
                                                                item: item,
                                                                alignment: "left",
                                                                onClick: closeNavOnClick
                                                            }, `${item.title}-nav-item`);
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $21sFD.jsxs)($2fa9c4eba08958a5$var$SectionsNavBlock, {
                                                children: [
                                                    /*#__PURE__*/ (0, $21sFD.jsx)($2fa9c4eba08958a5$var$GlobalNavBlockTitle, {
                                                        children: "Meta"
                                                    }),
                                                    /*#__PURE__*/ (0, $21sFD.jsx)($2fa9c4eba08958a5$var$GlobalMenu, {
                                                        children: subNavItems.map((item)=>{
                                                            return /*#__PURE__*/ (0, $21sFD.jsx)((0, $dMk3s.default), {
                                                                linkProperties: linkProperties,
                                                                item: item,
                                                                alignment: "right",
                                                                onClick: closeNavOnClick
                                                            }, `${item.title}-nav-item`);
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $2fa9c4eba08958a5$export$2e2bcd8739ae039 = $2fa9c4eba08958a5$var$PageHeaderLegacy;

});
parcelRegister("h7JSo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52b0d299cfe43377$export$2e2bcd8739ae039; });

var $3RyIS = parcelRequire("3RyIS");
function $52b0d299cfe43377$var$UnscrollableBody() {
    (0, $3RyIS.useEffect)(()=>{
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = "";
        };
    }, []);
    return null;
}
var $52b0d299cfe43377$export$2e2bcd8739ae039 = $52b0d299cfe43377$var$UnscrollableBody;

});

parcelRegister("dMk3s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9efebea8a35ad5a9$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $9HCvT = parcelRequire("9HCvT");

var $2JIVh = parcelRequire("2JIVh");

var $hGSMG = parcelRequire("hGSMG");

var $dLz2s = parcelRequire("dLz2s");

var $fH1nS = parcelRequire("fH1nS");

var $aUAzJ = parcelRequire("aUAzJ");

var $hNqhF = parcelRequire("hNqhF");

var $cGQ3Q = parcelRequire("cGQ3Q");

var $6vRkW = parcelRequire("6vRkW");
// @DEPRECATED: This component is deprecated and will be removed in the future.
const $9efebea8a35ad5a9$var$rgbaFixed = (0, $atWKR.rgba);
const $9efebea8a35ad5a9$export$9dcb6ed886c28a2f = (0, $6fhRl.default).div`
  align-self: start;
  ${(0, $atWKR.media).largeUp`
    display: none;
  `}
`;
const $9efebea8a35ad5a9$var$GlobalMenuItem = (0, $6fhRl.default).span`
  ${(0, $cGQ3Q.default)}
  cursor: default;
  &:hover {
    opacity: 1;
  }
`;
const $9efebea8a35ad5a9$export$64eb44db16fa7ade = (0, $6fhRl.default)((0, $9HCvT.Button))`
  z-index: 2000;
`;
const $9efebea8a35ad5a9$var$GlobalMenuLink = (0, $6fhRl.default).a`
  ${(0, $cGQ3Q.default)}
`;
const $9efebea8a35ad5a9$var$GlobalMenuButton = (0, $6fhRl.default)((0, $9HCvT.Button))`
  ${(0, $cGQ3Q.default)}
`;
const $9efebea8a35ad5a9$var$DropMenuNavItem = (0, $6fhRl.default)((0, $hGSMG.DropMenuItem))`
  &.active {
    background-color: ${$9efebea8a35ad5a9$var$rgbaFixed((0, $atWKR.themeVal)("color.link"), 0.08)};
  }
  ${(0, $atWKR.media).largeDown`
    padding-left ${(0, $atWKR.glsp)(2)};
    &:hover {
      color: inherit;
      opacity: 0.64;
    }
  `}
`;
const $9efebea8a35ad5a9$var$LOG = true;
function $9efebea8a35ad5a9$var$LinkDropMenuNavItem({ child: child, onClick: onClick, linkProperties: linkProperties }) {
    const { title: title, type: type, ...rest } = child;
    const linkProps = {
        as: linkProperties.LinkElement,
        [linkProperties.pathAttributeKeyName]: rest.to
    };
    if (type === (0, $aUAzJ.NavItemType).INTERNAL_LINK) return /*#__PURE__*/ (0, $21sFD.jsx)("li", {
        children: /*#__PURE__*/ (0, $21sFD.jsx)($9efebea8a35ad5a9$var$DropMenuNavItem, {
            ...linkProps,
            onClick: onClick,
            "data-dropdown": "click.close",
            children: title
        })
    });
    else if (type === (0, $aUAzJ.NavItemType).EXTERNAL_LINK) return /*#__PURE__*/ (0, $21sFD.jsx)("li", {
        children: /*#__PURE__*/ (0, $21sFD.jsx)($9efebea8a35ad5a9$var$DropMenuNavItem, {
            as: "a",
            target: "blank",
            rel: "noopener",
            href: rest.href,
            onClick: onClick,
            "data-dropdown": "click.close",
            children: title
        })
    }, `${title}-dropdown-menu`);
    else {
        $9efebea8a35ad5a9$var$LOG && /* eslint-disable-next-line no-console */ console.error(`Invalid child Nav Item type, type "${type}" is not of `, (0, $aUAzJ.NavItemType));
        return null;
    }
}
// Global menu link style
const $9efebea8a35ad5a9$var$ButtonAsNavLink = (0, $6fhRl.default)((0, $9HCvT.Button))`
  ${(0, $atWKR.media).mediumUp`
    background-color: ${(0, $atWKR.themeVal)("color.primary-700")};
    &:hover {
      background-color: ${(0, $atWKR.themeVal)("color.primary-800")};
    }
    /* Print & when prop is passed */
    ${({ active: active })=>active && "&,"}
    &:active,
    &.active {
      background-color: ${(0, $atWKR.themeVal)("color.primary-900")};
    }
    &:focus-visible {
      background-color: ${(0, $atWKR.themeVal)("color.primary-200a")};
    }
  `}
  ${(0, $atWKR.media).mediumDown`
    ${(0, $cGQ3Q.default)}
  `}
`;
function $9efebea8a35ad5a9$export$2e2bcd8739ae039({ item: item, alignment: alignment, onClick: onClick, linkProperties: linkProperties }) {
    const { isMediumDown: isMediumDown } = (0, $6vRkW.useMediaQuery)();
    const { isRevealed: isRevealed, show: show, hide: hide } = (0, $hNqhF.useFeedbackModal)();
    const { title: title, type: type, ...rest } = item;
    if (type === (0, $aUAzJ.NavItemType).INTERNAL_LINK) {
        const linkProps = {
            as: linkProperties.LinkElement,
            [linkProperties.pathAttributeKeyName]: rest.to
        };
        return /*#__PURE__*/ (0, $21sFD.jsx)("li", {
            children: /*#__PURE__*/ (0, $21sFD.jsx)($9efebea8a35ad5a9$var$GlobalMenuLink, {
                ...linkProps,
                onClick: onClick,
                children: title
            })
        }, `${title}-nav-item`);
    } else if (item.type === (0, $aUAzJ.NavItemType).EXTERNAL_LINK) return /*#__PURE__*/ (0, $21sFD.jsx)("li", {
        children: /*#__PURE__*/ (0, $21sFD.jsx)($9efebea8a35ad5a9$var$GlobalMenuLink, {
            as: "a",
            target: "_blank",
            rel: "noopener",
            onClick: onClick,
            href: rest.href,
            children: title
        })
    }, `${title}-nav-item`);
    else if (item.type === (0, $aUAzJ.NavItemType).ACTION) return /*#__PURE__*/ (0, $21sFD.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $21sFD.jsx)($9efebea8a35ad5a9$var$ButtonAsNavLink, {
                type: "button",
                size: "large",
                onClick: show,
                style: {
                    color: "white"
                },
                children: title
            }),
            /*#__PURE__*/ (0, $21sFD.jsx)((0, $fH1nS.default), {
                src: "https://docs.google.com/forms/d/e/1FAIpQLSeVWCrnca08Gt_qoWYjTo6gnj1BEGL4NCUC9VEiQnXA02gzVQ/viewform",
                isRevealed: isRevealed,
                hide: hide
            })
        ]
    });
    else if (type === (0, $aUAzJ.NavItemType).DROPDOWN) {
        const { title: title } = item;
        // Mobile view
        if (isMediumDown) return /*#__PURE__*/ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
            children: [
                /*#__PURE__*/ (0, $21sFD.jsx)("li", {
                    children: /*#__PURE__*/ (0, $21sFD.jsxs)($9efebea8a35ad5a9$var$GlobalMenuItem, {
                        children: [
                            title,
                            " "
                        ]
                    })
                }),
                item.children.map((child)=>{
                    return /*#__PURE__*/ (0, $21sFD.jsx)($9efebea8a35ad5a9$var$LinkDropMenuNavItem, {
                        child: child,
                        onClick: onClick,
                        linkProperties: linkProperties
                    }, `${child.id}-dropdown-menu`);
                })
            ]
        });
        else return /*#__PURE__*/ (0, $21sFD.jsx)("li", {
            children: /*#__PURE__*/ (0, $21sFD.jsx)((0, $dLz2s.default), {
                alignment: alignment ?? "left",
                triggerElement: (props)=>/*#__PURE__*/ (0, $21sFD.jsxs)($9efebea8a35ad5a9$var$GlobalMenuButton, {
                        ...props,
                        // @ts-expect-error achromic text exists
                        variation: "achromic-text",
                        fitting: "skinny",
                        children: [
                            title,
                            " ",
                            /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Icon).ExpandMore, {
                                size: 3
                            })
                        ]
                    }),
                children: /*#__PURE__*/ (0, $21sFD.jsx)((0, $hGSMG.DropMenu), {
                    children: item.children.map((child)=>{
                        return /*#__PURE__*/ (0, $21sFD.jsx)($9efebea8a35ad5a9$var$LinkDropMenuNavItem, {
                            child: child,
                            linkProperties: linkProperties
                        }, `${title}-dropdown-menu`);
                    })
                })
            })
        });
    } else {
        $9efebea8a35ad5a9$var$LOG && /* eslint-disable-next-line no-console */ console.error(`Invalid type for Nav Items, type "${type}" is not of `, (0, $aUAzJ.NavItemType));
        return null;
    }
}

});
parcelRegister("hGSMG", function(module, exports) {

$parcel$export(module.exports, "DropTitle", function () { return $ce10daea3dd4da28$export$70e2c86b2c1a0692; });
$parcel$export(module.exports, "DropMenu", function () { return $ce10daea3dd4da28$export$7e7cfe33f7203052; });
$parcel$export(module.exports, "DropMenuItem", function () { return $ce10daea3dd4da28$export$1d16dd19bd2e4d57; });
$parcel$export(module.exports, "Dropdown", function () { return $ce10daea3dd4da28$export$931cbfb6bfb85fc; });

var $3RyIS = parcelRequire("3RyIS");

var $ifjYT = parcelRequire("ifjYT");

var $3qHRY = parcelRequire("3qHRY");

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $egbTY = parcelRequire("egbTY");
function $ce10daea3dd4da28$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ce10daea3dd4da28$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ce10daea3dd4da28$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ce10daea3dd4da28$var$_defineProperty$1(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ce10daea3dd4da28$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ce10daea3dd4da28$var$_defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ce10daea3dd4da28$var$_extends$1() {
    $ce10daea3dd4da28$var$_extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ce10daea3dd4da28$var$_extends$1.apply(this, arguments);
}
function $ce10daea3dd4da28$var$_objectWithoutPropertiesLoose$2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ce10daea3dd4da28$var$_objectWithoutProperties$1(source, excluded) {
    if (source == null) return {};
    var target = $ce10daea3dd4da28$var$_objectWithoutPropertiesLoose$2(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ce10daea3dd4da28$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function $ce10daea3dd4da28$var$_slicedToArray(arr, i) {
    return $ce10daea3dd4da28$var$_arrayWithHoles(arr) || $ce10daea3dd4da28$var$_iterableToArrayLimit(arr, i) || $ce10daea3dd4da28$var$_unsupportedIterableToArray(arr, i) || $ce10daea3dd4da28$var$_nonIterableRest();
}
function $ce10daea3dd4da28$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ce10daea3dd4da28$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ce10daea3dd4da28$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ce10daea3dd4da28$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ce10daea3dd4da28$var$_arrayLikeToArray(o, minLen);
}
function $ce10daea3dd4da28$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ce10daea3dd4da28$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $ce10daea3dd4da28$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $ce10daea3dd4da28$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $ce10daea3dd4da28$var$reactTether = {};
var $ce10daea3dd4da28$var$TetherComponent$2 = {};
var $ce10daea3dd4da28$var$tether = {
    exports: {}
};
/*! tether 1.4.7 */ (function(module, exports) {
    (function(root, factory) {
        module.exports = factory();
    })($ce10daea3dd4da28$var$commonjsGlobal, function() {
        var _createClass = function() {
            function defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
            };
        }();
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        var TetherBase = undefined;
        if (typeof TetherBase === "undefined") TetherBase = {
            modules: []
        };
        var zeroElement = null;
        // Same as native getBoundingClientRect, except it takes into account parent <frame> offsets
        // if the element lies within a nested document (<frame> or <iframe>-like).
        function getActualBoundingClientRect(node) {
            var boundingRect = node.getBoundingClientRect();
            // The original object returned by getBoundingClientRect is immutable, so we clone it
            // We can't use extend because the properties are not considered part of the object by hasOwnProperty in IE9
            var rect = {};
            for(var k in boundingRect)rect[k] = boundingRect[k];
            try {
                if (node.ownerDocument !== document) {
                    var _frameElement = node.ownerDocument.defaultView.frameElement;
                    if (_frameElement) {
                        var frameRect = getActualBoundingClientRect(_frameElement);
                        rect.top += frameRect.top;
                        rect.bottom += frameRect.top;
                        rect.left += frameRect.left;
                        rect.right += frameRect.left;
                    }
                }
            } catch (err) {
            // Ignore "Access is denied" in IE11/Edge
            }
            return rect;
        }
        function getScrollParents(el) {
            // In firefox if the el is inside an iframe with display: none; window.getComputedStyle() will return null;
            // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
            var computedStyle = getComputedStyle(el) || {};
            var position = computedStyle.position;
            var parents = [];
            if (position === "fixed") return [
                el
            ];
            var parent = el;
            while((parent = parent.parentNode) && parent && parent.nodeType === 1){
                var style = undefined;
                try {
                    style = getComputedStyle(parent);
                } catch (err) {}
                if (typeof style === "undefined" || style === null) {
                    parents.push(parent);
                    return parents;
                }
                var _style = style;
                var overflow = _style.overflow;
                var overflowX = _style.overflowX;
                var overflowY = _style.overflowY;
                if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
                    if (position !== "absolute" || [
                        "relative",
                        "absolute",
                        "fixed"
                    ].indexOf(style.position) >= 0) parents.push(parent);
                }
            }
            parents.push(el.ownerDocument.body);
            // If the node is within a frame, account for the parent window scroll
            if (el.ownerDocument !== document) parents.push(el.ownerDocument.defaultView);
            return parents;
        }
        var uniqueId = function() {
            var id = 0;
            return function() {
                return ++id;
            };
        }();
        var zeroPosCache = {};
        var getOrigin = function getOrigin() {
            // getBoundingClientRect is unfortunately too accurate.  It introduces a pixel or two of
            // jitter as the user scrolls that messes with our ability to detect if two positions
            // are equivilant or not.  We place an element at the top left of the page that will
            // get the same jitter, so we can cancel the two out.
            var node = zeroElement;
            if (!node || !document.body.contains(node)) {
                node = document.createElement("div");
                node.setAttribute("data-tether-id", uniqueId());
                extend(node.style, {
                    top: 0,
                    left: 0,
                    position: "absolute"
                });
                document.body.appendChild(node);
                zeroElement = node;
            }
            var id = node.getAttribute("data-tether-id");
            if (typeof zeroPosCache[id] === "undefined") {
                zeroPosCache[id] = getActualBoundingClientRect(node);
                // Clear the cache when this position call is done
                defer(function() {
                    delete zeroPosCache[id];
                });
            }
            return zeroPosCache[id];
        };
        function removeUtilElements() {
            if (zeroElement) document.body.removeChild(zeroElement);
            zeroElement = null;
        }
        function getBounds(el) {
            var doc = undefined;
            if (el === document) {
                doc = document;
                el = document.documentElement;
            } else doc = el.ownerDocument;
            var docEl = doc.documentElement;
            var box = getActualBoundingClientRect(el);
            var origin = getOrigin();
            box.top -= origin.top;
            box.left -= origin.left;
            if (typeof box.width === "undefined") box.width = document.body.scrollWidth - box.left - box.right;
            if (typeof box.height === "undefined") box.height = document.body.scrollHeight - box.top - box.bottom;
            box.top = box.top - docEl.clientTop;
            box.left = box.left - docEl.clientLeft;
            box.right = doc.body.clientWidth - box.width - box.left;
            box.bottom = doc.body.clientHeight - box.height - box.top;
            return box;
        }
        function getOffsetParent(el) {
            return el.offsetParent || document.documentElement;
        }
        var _scrollBarSize = null;
        function getScrollBarSize() {
            if (_scrollBarSize) return _scrollBarSize;
            var inner = document.createElement("div");
            inner.style.width = "100%";
            inner.style.height = "200px";
            var outer = document.createElement("div");
            extend(outer.style, {
                position: "absolute",
                top: 0,
                left: 0,
                pointerEvents: "none",
                visibility: "hidden",
                width: "200px",
                height: "150px",
                overflow: "hidden"
            });
            outer.appendChild(inner);
            document.body.appendChild(outer);
            var widthContained = inner.offsetWidth;
            outer.style.overflow = "scroll";
            var widthScroll = inner.offsetWidth;
            if (widthContained === widthScroll) widthScroll = outer.clientWidth;
            document.body.removeChild(outer);
            var width = widthContained - widthScroll;
            _scrollBarSize = {
                width: width,
                height: width
            };
            return _scrollBarSize;
        }
        function extend() {
            var out = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
            var args = [];
            Array.prototype.push.apply(args, arguments);
            args.slice(1).forEach(function(obj) {
                if (obj) {
                    for(var key in obj)if (({}).hasOwnProperty.call(obj, key)) out[key] = obj[key];
                }
            });
            return out;
        }
        function removeClass(el, name) {
            if (typeof el.classList !== "undefined") name.split(" ").forEach(function(cls) {
                if (cls.trim()) el.classList.remove(cls);
            });
            else {
                var regex = new RegExp("(^| )" + name.split(" ").join("|") + "( |$)", "gi");
                var className = getClassName(el).replace(regex, " ");
                setClassName(el, className);
            }
        }
        function addClass(el, name) {
            if (typeof el.classList !== "undefined") name.split(" ").forEach(function(cls) {
                if (cls.trim()) el.classList.add(cls);
            });
            else {
                removeClass(el, name);
                var cls = getClassName(el) + (" " + name);
                setClassName(el, cls);
            }
        }
        function hasClass(el, name) {
            if (typeof el.classList !== "undefined") return el.classList.contains(name);
            var className = getClassName(el);
            return new RegExp("(^| )" + name + "( |$)", "gi").test(className);
        }
        function getClassName(el) {
            // Can't use just SVGAnimatedString here since nodes within a Frame in IE have
            // completely separately SVGAnimatedString base classes
            if (el.className instanceof el.ownerDocument.defaultView.SVGAnimatedString) return el.className.baseVal;
            return el.className;
        }
        function setClassName(el, className) {
            el.setAttribute("class", className);
        }
        function updateClasses(el, add, all) {
            // Of the set of 'all' classes, we need the 'add' classes, and only the
            // 'add' classes to be set.
            all.forEach(function(cls) {
                if (add.indexOf(cls) === -1 && hasClass(el, cls)) removeClass(el, cls);
            });
            add.forEach(function(cls) {
                if (!hasClass(el, cls)) addClass(el, cls);
            });
        }
        var deferred = [];
        var defer = function defer(fn) {
            deferred.push(fn);
        };
        var flush = function flush() {
            var fn = undefined;
            while(fn = deferred.pop())fn();
        };
        var Evented = function() {
            function Evented() {
                _classCallCheck(this, Evented);
            }
            _createClass(Evented, [
                {
                    key: "on",
                    value: function on(event, handler, ctx) {
                        var once = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
                        if (typeof this.bindings === "undefined") this.bindings = {};
                        if (typeof this.bindings[event] === "undefined") this.bindings[event] = [];
                        this.bindings[event].push({
                            handler: handler,
                            ctx: ctx,
                            once: once
                        });
                    }
                },
                {
                    key: "once",
                    value: function once(event, handler, ctx) {
                        this.on(event, handler, ctx, true);
                    }
                },
                {
                    key: "off",
                    value: function off(event, handler) {
                        if (typeof this.bindings === "undefined" || typeof this.bindings[event] === "undefined") return;
                        if (typeof handler === "undefined") delete this.bindings[event];
                        else {
                            var i = 0;
                            while(i < this.bindings[event].length)if (this.bindings[event][i].handler === handler) this.bindings[event].splice(i, 1);
                            else ++i;
                        }
                    }
                },
                {
                    key: "trigger",
                    value: function trigger(event) {
                        if (typeof this.bindings !== "undefined" && this.bindings[event]) {
                            var i = 0;
                            for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                            while(i < this.bindings[event].length){
                                var _bindings$event$i = this.bindings[event][i];
                                var handler = _bindings$event$i.handler;
                                var ctx = _bindings$event$i.ctx;
                                var once = _bindings$event$i.once;
                                var context = ctx;
                                if (typeof context === "undefined") context = this;
                                handler.apply(context, args);
                                if (once) this.bindings[event].splice(i, 1);
                                else ++i;
                            }
                        }
                    }
                }
            ]);
            return Evented;
        }();
        TetherBase.Utils = {
            getActualBoundingClientRect: getActualBoundingClientRect,
            getScrollParents: getScrollParents,
            getBounds: getBounds,
            getOffsetParent: getOffsetParent,
            extend: extend,
            addClass: addClass,
            removeClass: removeClass,
            hasClass: hasClass,
            updateClasses: updateClasses,
            defer: defer,
            flush: flush,
            uniqueId: uniqueId,
            Evented: Evented,
            getScrollBarSize: getScrollBarSize,
            removeUtilElements: removeUtilElements
        };
        var _slicedToArray = function() {
            function sliceIterator(arr, i) {
                var _arr = [];
                var _n = true;
                var _d = false;
                var _e = undefined;
                try {
                    for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                        _arr.push(_s.value);
                        if (i && _arr.length === i) break;
                    }
                } catch (err) {
                    _d = true;
                    _e = err;
                } finally{
                    try {
                        if (!_n && _i["return"]) _i["return"]();
                    } finally{
                        if (_d) throw _e;
                    }
                }
                return _arr;
            }
            return function(arr, i) {
                if (Array.isArray(arr)) return arr;
                else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                else throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
        }();
        var _createClass = function() {
            function defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
            };
        }();
        var _get = function get(_x6, _x7, _x8) {
            var _again = true;
            _function: while(_again){
                var object = _x6, property = _x7, receiver = _x8;
                _again = false;
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else {
                        _x6 = parent;
                        _x7 = property;
                        _x8 = receiver;
                        _again = true;
                        desc = parent = undefined;
                        continue _function;
                    }
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            }
        };
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        if (typeof TetherBase === "undefined") throw new Error("You must include the utils.js file before tether.js");
        var _TetherBase$Utils = TetherBase.Utils;
        var getScrollParents = _TetherBase$Utils.getScrollParents;
        var getBounds = _TetherBase$Utils.getBounds;
        var getOffsetParent = _TetherBase$Utils.getOffsetParent;
        var extend = _TetherBase$Utils.extend;
        var addClass = _TetherBase$Utils.addClass;
        var removeClass = _TetherBase$Utils.removeClass;
        var updateClasses = _TetherBase$Utils.updateClasses;
        var defer = _TetherBase$Utils.defer;
        var flush = _TetherBase$Utils.flush;
        var getScrollBarSize = _TetherBase$Utils.getScrollBarSize;
        var removeUtilElements = _TetherBase$Utils.removeUtilElements;
        function within(a, b) {
            var diff = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];
            return a + diff >= b && b >= a - diff;
        }
        var transformKey = function() {
            if (typeof document === "undefined") return "";
            var el = document.createElement("div");
            var transforms = [
                "transform",
                "WebkitTransform",
                "OTransform",
                "MozTransform",
                "msTransform"
            ];
            for(var i = 0; i < transforms.length; ++i){
                var key = transforms[i];
                if (el.style[key] !== undefined) return key;
            }
        }();
        var tethers = [];
        var position = function position() {
            tethers.forEach(function(tether) {
                tether.position(false);
            });
            flush();
        };
        function now() {
            if (typeof performance === "object" && typeof performance.now === "function") return performance.now();
            return +new Date();
        }
        (function() {
            var lastCall = null;
            var lastDuration = null;
            var pendingTimeout = null;
            var tick = function tick() {
                if (typeof lastDuration !== "undefined" && lastDuration > 16) {
                    // We voluntarily throttle ourselves if we can't manage 60fps
                    lastDuration = Math.min(lastDuration - 16, 250);
                    // Just in case this is the last event, remember to position just once more
                    pendingTimeout = setTimeout(tick, 250);
                    return;
                }
                if (typeof lastCall !== "undefined" && now() - lastCall < 10) // Some browsers call events a little too frequently, refuse to run more than is reasonable
                return;
                if (pendingTimeout != null) {
                    clearTimeout(pendingTimeout);
                    pendingTimeout = null;
                }
                lastCall = now();
                position();
                lastDuration = now() - lastCall;
            };
            if (typeof window !== "undefined" && typeof window.addEventListener !== "undefined") [
                "resize",
                "scroll",
                "touchmove"
            ].forEach(function(event) {
                window.addEventListener(event, tick);
            });
        })();
        var MIRROR_LR = {
            center: "center",
            left: "right",
            right: "left"
        };
        var MIRROR_TB = {
            middle: "middle",
            top: "bottom",
            bottom: "top"
        };
        var OFFSET_MAP = {
            top: 0,
            left: 0,
            middle: "50%",
            center: "50%",
            bottom: "100%",
            right: "100%"
        };
        var autoToFixedAttachment = function autoToFixedAttachment(attachment, relativeToAttachment) {
            var left = attachment.left;
            var top = attachment.top;
            if (left === "auto") left = MIRROR_LR[relativeToAttachment.left];
            if (top === "auto") top = MIRROR_TB[relativeToAttachment.top];
            return {
                left: left,
                top: top
            };
        };
        var attachmentToOffset = function attachmentToOffset(attachment) {
            var left = attachment.left;
            var top = attachment.top;
            if (typeof OFFSET_MAP[attachment.left] !== "undefined") left = OFFSET_MAP[attachment.left];
            if (typeof OFFSET_MAP[attachment.top] !== "undefined") top = OFFSET_MAP[attachment.top];
            return {
                left: left,
                top: top
            };
        };
        function addOffset() {
            var out = {
                top: 0,
                left: 0
            };
            for(var _len = arguments.length, offsets = Array(_len), _key = 0; _key < _len; _key++)offsets[_key] = arguments[_key];
            offsets.forEach(function(_ref) {
                var top = _ref.top;
                var left = _ref.left;
                if (typeof top === "string") top = parseFloat(top, 10);
                if (typeof left === "string") left = parseFloat(left, 10);
                out.top += top;
                out.left += left;
            });
            return out;
        }
        function offsetToPx(offset, size) {
            if (typeof offset.left === "string" && offset.left.indexOf("%") !== -1) offset.left = parseFloat(offset.left, 10) / 100 * size.width;
            if (typeof offset.top === "string" && offset.top.indexOf("%") !== -1) offset.top = parseFloat(offset.top, 10) / 100 * size.height;
            return offset;
        }
        var parseOffset = function parseOffset(value) {
            var _value$split = value.split(" ");
            var _value$split2 = _slicedToArray(_value$split, 2);
            var top = _value$split2[0];
            var left = _value$split2[1];
            return {
                top: top,
                left: left
            };
        };
        var parseAttachment = parseOffset;
        var TetherClass = function(_Evented) {
            _inherits(TetherClass, _Evented);
            function TetherClass(options) {
                var _this = this;
                _classCallCheck(this, TetherClass);
                _get(Object.getPrototypeOf(TetherClass.prototype), "constructor", this).call(this);
                this.position = this.position.bind(this);
                tethers.push(this);
                this.history = [];
                this.setOptions(options, false);
                TetherBase.modules.forEach(function(module) {
                    if (typeof module.initialize !== "undefined") module.initialize.call(_this);
                });
                this.position();
            }
            _createClass(TetherClass, [
                {
                    key: "getClass",
                    value: function getClass() {
                        var key = arguments.length <= 0 || arguments[0] === undefined ? "" : arguments[0];
                        var classes = this.options.classes;
                        if (typeof classes !== "undefined" && classes[key]) return this.options.classes[key];
                        else if (this.options.classPrefix) return this.options.classPrefix + "-" + key;
                        else return key;
                    }
                },
                {
                    key: "setOptions",
                    value: function setOptions(options) {
                        var _this2 = this;
                        var pos = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
                        var defaults = {
                            offset: "0 0",
                            targetOffset: "0 0",
                            targetAttachment: "auto auto",
                            classPrefix: "tether"
                        };
                        this.options = extend(defaults, options);
                        var _options = this.options;
                        var element = _options.element;
                        var target = _options.target;
                        var targetModifier = _options.targetModifier;
                        this.element = element;
                        this.target = target;
                        this.targetModifier = targetModifier;
                        if (this.target === "viewport") {
                            this.target = document.body;
                            this.targetModifier = "visible";
                        } else if (this.target === "scroll-handle") {
                            this.target = document.body;
                            this.targetModifier = "scroll-handle";
                        }
                        [
                            "element",
                            "target"
                        ].forEach(function(key) {
                            if (typeof _this2[key] === "undefined") throw new Error("Tether Error: Both element and target must be defined");
                            if (typeof _this2[key].jquery !== "undefined") _this2[key] = _this2[key][0];
                            else if (typeof _this2[key] === "string") _this2[key] = document.querySelector(_this2[key]);
                        });
                        addClass(this.element, this.getClass("element"));
                        if (!(this.options.addTargetClasses === false)) addClass(this.target, this.getClass("target"));
                        if (!this.options.attachment) throw new Error("Tether Error: You must provide an attachment");
                        this.targetAttachment = parseAttachment(this.options.targetAttachment);
                        this.attachment = parseAttachment(this.options.attachment);
                        this.offset = parseOffset(this.options.offset);
                        this.targetOffset = parseOffset(this.options.targetOffset);
                        if (typeof this.scrollParents !== "undefined") this.disable();
                        if (this.targetModifier === "scroll-handle") this.scrollParents = [
                            this.target
                        ];
                        else this.scrollParents = getScrollParents(this.target);
                        if (!(this.options.enabled === false)) this.enable(pos);
                    }
                },
                {
                    key: "getTargetBounds",
                    value: function getTargetBounds() {
                        if (typeof this.targetModifier !== "undefined") {
                            if (this.targetModifier === "visible") {
                                if (this.target === document.body) return {
                                    top: pageYOffset,
                                    left: pageXOffset,
                                    height: innerHeight,
                                    width: innerWidth
                                };
                                else {
                                    var bounds = getBounds(this.target);
                                    var out = {
                                        height: bounds.height,
                                        width: bounds.width,
                                        top: bounds.top,
                                        left: bounds.left
                                    };
                                    out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
                                    out.height = Math.min(out.height, bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)));
                                    out.height = Math.min(innerHeight, out.height);
                                    out.height -= 2;
                                    out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
                                    out.width = Math.min(out.width, bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)));
                                    out.width = Math.min(innerWidth, out.width);
                                    out.width -= 2;
                                    if (out.top < pageYOffset) out.top = pageYOffset;
                                    if (out.left < pageXOffset) out.left = pageXOffset;
                                    return out;
                                }
                            } else if (this.targetModifier === "scroll-handle") {
                                var bounds = undefined;
                                var target = this.target;
                                if (target === document.body) {
                                    target = document.documentElement;
                                    bounds = {
                                        left: pageXOffset,
                                        top: pageYOffset,
                                        height: innerHeight,
                                        width: innerWidth
                                    };
                                } else bounds = getBounds(target);
                                var style = getComputedStyle(target);
                                var hasBottomScroll = target.scrollWidth > target.clientWidth || [
                                    style.overflow,
                                    style.overflowX
                                ].indexOf("scroll") >= 0 || this.target !== document.body;
                                var scrollBottom = 0;
                                if (hasBottomScroll) scrollBottom = 15;
                                var height = bounds.height - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth) - scrollBottom;
                                var out = {
                                    width: 15,
                                    height: height * 0.975 * (height / target.scrollHeight),
                                    left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15
                                };
                                var fitAdj = 0;
                                if (height < 408 && this.target === document.body) fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
                                if (this.target !== document.body) out.height = Math.max(out.height, 24);
                                var scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
                                out.top = scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);
                                if (this.target === document.body) out.height = Math.max(out.height, 24);
                                return out;
                            }
                        } else return getBounds(this.target);
                    }
                },
                {
                    key: "clearCache",
                    value: function clearCache() {
                        this._cache = {};
                    }
                },
                {
                    key: "cache",
                    value: function cache(k, getter) {
                        // More than one module will often need the same DOM info, so
                        // we keep a cache which is cleared on each position call
                        if (typeof this._cache === "undefined") this._cache = {};
                        if (typeof this._cache[k] === "undefined") this._cache[k] = getter.call(this);
                        return this._cache[k];
                    }
                },
                {
                    key: "enable",
                    value: function enable() {
                        var _this3 = this;
                        var pos = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
                        if (!(this.options.addTargetClasses === false)) addClass(this.target, this.getClass("enabled"));
                        addClass(this.element, this.getClass("enabled"));
                        this.enabled = true;
                        this.scrollParents.forEach(function(parent) {
                            if (parent !== _this3.target.ownerDocument) parent.addEventListener("scroll", _this3.position);
                        });
                        if (pos) this.position();
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        var _this4 = this;
                        removeClass(this.target, this.getClass("enabled"));
                        removeClass(this.element, this.getClass("enabled"));
                        this.enabled = false;
                        if (typeof this.scrollParents !== "undefined") this.scrollParents.forEach(function(parent) {
                            parent.removeEventListener("scroll", _this4.position);
                        });
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        var _this5 = this;
                        this.disable();
                        tethers.forEach(function(tether, i) {
                            if (tether === _this5) tethers.splice(i, 1);
                        });
                        // Remove any elements we were using for convenience from the DOM
                        if (tethers.length === 0) removeUtilElements();
                    }
                },
                {
                    key: "updateAttachClasses",
                    value: function updateAttachClasses(elementAttach, targetAttach) {
                        var _this6 = this;
                        elementAttach = elementAttach || this.attachment;
                        targetAttach = targetAttach || this.targetAttachment;
                        var sides = [
                            "left",
                            "top",
                            "bottom",
                            "right",
                            "middle",
                            "center"
                        ];
                        if (typeof this._addAttachClasses !== "undefined" && this._addAttachClasses.length) // updateAttachClasses can be called more than once in a position call, so
                        // we need to clean up after ourselves such that when the last defer gets
                        // ran it doesn't add any extra classes from previous calls.
                        this._addAttachClasses.splice(0, this._addAttachClasses.length);
                        if (typeof this._addAttachClasses === "undefined") this._addAttachClasses = [];
                        var add = this._addAttachClasses;
                        if (elementAttach.top) add.push(this.getClass("element-attached") + "-" + elementAttach.top);
                        if (elementAttach.left) add.push(this.getClass("element-attached") + "-" + elementAttach.left);
                        if (targetAttach.top) add.push(this.getClass("target-attached") + "-" + targetAttach.top);
                        if (targetAttach.left) add.push(this.getClass("target-attached") + "-" + targetAttach.left);
                        var all = [];
                        sides.forEach(function(side) {
                            all.push(_this6.getClass("element-attached") + "-" + side);
                            all.push(_this6.getClass("target-attached") + "-" + side);
                        });
                        defer(function() {
                            if (!(typeof _this6._addAttachClasses !== "undefined")) return;
                            updateClasses(_this6.element, _this6._addAttachClasses, all);
                            if (!(_this6.options.addTargetClasses === false)) updateClasses(_this6.target, _this6._addAttachClasses, all);
                            delete _this6._addAttachClasses;
                        });
                    }
                },
                {
                    key: "position",
                    value: function position() {
                        var _this7 = this;
                        var flushChanges = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
                        // flushChanges commits the changes immediately, leave true unless you are positioning multiple
                        // tethers (in which case call Tether.Utils.flush yourself when you're done)
                        if (!this.enabled) return;
                        this.clearCache();
                        // Turn 'auto' attachments into the appropriate corner or edge
                        var targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);
                        this.updateAttachClasses(this.attachment, targetAttachment);
                        var elementPos = this.cache("element-bounds", function() {
                            return getBounds(_this7.element);
                        });
                        var width = elementPos.width;
                        var height = elementPos.height;
                        if (width === 0 && height === 0 && typeof this.lastSize !== "undefined") {
                            var _lastSize = this.lastSize;
                            // We cache the height and width to make it possible to position elements that are
                            // getting hidden.
                            width = _lastSize.width;
                            height = _lastSize.height;
                        } else this.lastSize = {
                            width: width,
                            height: height
                        };
                        var targetPos = this.cache("target-bounds", function() {
                            return _this7.getTargetBounds();
                        });
                        var targetSize = targetPos;
                        // Get an actual px offset from the attachment
                        var offset = offsetToPx(attachmentToOffset(this.attachment), {
                            width: width,
                            height: height
                        });
                        var targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);
                        var manualOffset = offsetToPx(this.offset, {
                            width: width,
                            height: height
                        });
                        var manualTargetOffset = offsetToPx(this.targetOffset, targetSize);
                        // Add the manually provided offset
                        offset = addOffset(offset, manualOffset);
                        targetOffset = addOffset(targetOffset, manualTargetOffset);
                        // It's now our goal to make (element position + offset) == (target position + target offset)
                        var left = targetPos.left + targetOffset.left - offset.left;
                        var top = targetPos.top + targetOffset.top - offset.top;
                        for(var i = 0; i < TetherBase.modules.length; ++i){
                            var _module2 = TetherBase.modules[i];
                            var ret = _module2.position.call(this, {
                                left: left,
                                top: top,
                                targetAttachment: targetAttachment,
                                targetPos: targetPos,
                                elementPos: elementPos,
                                offset: offset,
                                targetOffset: targetOffset,
                                manualOffset: manualOffset,
                                manualTargetOffset: manualTargetOffset,
                                scrollbarSize: scrollbarSize,
                                attachment: this.attachment
                            });
                            if (ret === false) return false;
                            else if (typeof ret === "undefined" || typeof ret !== "object") continue;
                            else {
                                top = ret.top;
                                left = ret.left;
                            }
                        }
                        // We describe the position three different ways to give the optimizer
                        // a chance to decide the best possible way to position the element
                        // with the fewest repaints.
                        var next = {
                            // It's position relative to the page (absolute positioning when
                            // the element is a child of the body)
                            page: {
                                top: top,
                                left: left
                            },
                            // It's position relative to the viewport (fixed positioning)
                            viewport: {
                                top: top - pageYOffset,
                                bottom: pageYOffset - top - height + innerHeight,
                                left: left - pageXOffset,
                                right: pageXOffset - left - width + innerWidth
                            }
                        };
                        var doc = this.target.ownerDocument;
                        var win = doc.defaultView;
                        var scrollbarSize = undefined;
                        if (win.innerHeight > doc.documentElement.clientHeight) {
                            scrollbarSize = this.cache("scrollbar-size", getScrollBarSize);
                            next.viewport.bottom -= scrollbarSize.height;
                        }
                        if (win.innerWidth > doc.documentElement.clientWidth) {
                            scrollbarSize = this.cache("scrollbar-size", getScrollBarSize);
                            next.viewport.right -= scrollbarSize.width;
                        }
                        if ([
                            "",
                            "static"
                        ].indexOf(doc.body.style.position) === -1 || [
                            "",
                            "static"
                        ].indexOf(doc.body.parentElement.style.position) === -1) {
                            // Absolute positioning in the body will be relative to the page, not the 'initial containing block'
                            next.page.bottom = doc.body.scrollHeight - top - height;
                            next.page.right = doc.body.scrollWidth - left - width;
                        }
                        if (typeof this.options.optimizations !== "undefined" && this.options.optimizations.moveElement !== false && !(typeof this.targetModifier !== "undefined")) (function() {
                            var offsetParent = _this7.cache("target-offsetparent", function() {
                                return getOffsetParent(_this7.target);
                            });
                            var offsetPosition = _this7.cache("target-offsetparent-bounds", function() {
                                return getBounds(offsetParent);
                            });
                            var offsetParentStyle = getComputedStyle(offsetParent);
                            var offsetParentSize = offsetPosition;
                            var offsetBorder = {};
                            [
                                "Top",
                                "Left",
                                "Bottom",
                                "Right"
                            ].forEach(function(side) {
                                offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle["border" + side + "Width"]);
                            });
                            offsetPosition.right = doc.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
                            offsetPosition.bottom = doc.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;
                            if (next.page.top >= offsetPosition.top + offsetBorder.top && next.page.bottom >= offsetPosition.bottom) {
                                if (next.page.left >= offsetPosition.left + offsetBorder.left && next.page.right >= offsetPosition.right) {
                                    // We're within the visible part of the target's scroll parent
                                    var scrollTop = offsetParent.scrollTop;
                                    var scrollLeft = offsetParent.scrollLeft;
                                    // It's position relative to the target's offset parent (absolute positioning when
                                    // the element is moved to be a child of the target's offset parent).
                                    next.offset = {
                                        top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
                                        left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left
                                    };
                                }
                            }
                        })();
                        // We could also travel up the DOM and try each containing context, rather than only
                        // looking at the body, but we're gonna get diminishing returns.
                        this.move(next);
                        this.history.unshift(next);
                        if (this.history.length > 3) this.history.pop();
                        if (flushChanges) flush();
                        return true;
                    }
                },
                {
                    key: "move",
                    value: function move(pos) {
                        var _this8 = this;
                        if (!(typeof this.element.parentNode !== "undefined")) return;
                        var same = {};
                        for(var type in pos){
                            same[type] = {};
                            for(var key in pos[type]){
                                var found = false;
                                for(var i = 0; i < this.history.length; ++i){
                                    var point = this.history[i];
                                    if (typeof point[type] !== "undefined" && !within(point[type][key], pos[type][key])) {
                                        found = true;
                                        break;
                                    }
                                }
                                if (!found) same[type][key] = true;
                            }
                        }
                        var css = {
                            top: "",
                            left: "",
                            right: "",
                            bottom: ""
                        };
                        var transcribe = function transcribe(_same, _pos) {
                            var hasOptimizations = typeof _this8.options.optimizations !== "undefined";
                            var gpu = hasOptimizations ? _this8.options.optimizations.gpu : null;
                            if (gpu !== false) {
                                var yPos = undefined, xPos = undefined;
                                if (_same.top) {
                                    css.top = 0;
                                    yPos = _pos.top;
                                } else {
                                    css.bottom = 0;
                                    yPos = -_pos.bottom;
                                }
                                if (_same.left) {
                                    css.left = 0;
                                    xPos = _pos.left;
                                } else {
                                    css.right = 0;
                                    xPos = -_pos.right;
                                }
                                if (typeof window.devicePixelRatio === "number" && devicePixelRatio % 1 === 0) {
                                    xPos = Math.round(xPos * devicePixelRatio) / devicePixelRatio;
                                    yPos = Math.round(yPos * devicePixelRatio) / devicePixelRatio;
                                }
                                css[transformKey] = "translateX(" + xPos + "px) translateY(" + yPos + "px)";
                                if (transformKey !== "msTransform") // The Z transform will keep this in the GPU (faster, and prevents artifacts),
                                // but IE9 doesn't support 3d transforms and will choke.
                                css[transformKey] += " translateZ(0)";
                            } else {
                                if (_same.top) css.top = _pos.top + "px";
                                else css.bottom = _pos.bottom + "px";
                                if (_same.left) css.left = _pos.left + "px";
                                else css.right = _pos.right + "px";
                            }
                        };
                        var moved = false;
                        if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
                            css.position = "absolute";
                            transcribe(same.page, pos.page);
                        } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
                            css.position = "fixed";
                            transcribe(same.viewport, pos.viewport);
                        } else if (typeof same.offset !== "undefined" && same.offset.top && same.offset.left) (function() {
                            css.position = "absolute";
                            var offsetParent = _this8.cache("target-offsetparent", function() {
                                return getOffsetParent(_this8.target);
                            });
                            if (getOffsetParent(_this8.element) !== offsetParent) defer(function() {
                                _this8.element.parentNode.removeChild(_this8.element);
                                offsetParent.appendChild(_this8.element);
                            });
                            transcribe(same.offset, pos.offset);
                            moved = true;
                        })();
                        else {
                            css.position = "absolute";
                            transcribe({
                                top: true,
                                left: true
                            }, pos.page);
                        }
                        if (!moved) {
                            if (this.options.bodyElement) {
                                if (this.element.parentNode !== this.options.bodyElement) this.options.bodyElement.appendChild(this.element);
                            } else {
                                var isFullscreenElement = function isFullscreenElement(e) {
                                    var d = e.ownerDocument;
                                    var fe = d.fullscreenElement || d.webkitFullscreenElement || d.mozFullScreenElement || d.msFullscreenElement;
                                    return fe === e;
                                };
                                var offsetParentIsBody = true;
                                var currentNode = this.element.parentNode;
                                while(currentNode && currentNode.nodeType === 1 && currentNode.tagName !== "BODY" && !isFullscreenElement(currentNode)){
                                    if (getComputedStyle(currentNode).position !== "static") {
                                        offsetParentIsBody = false;
                                        break;
                                    }
                                    currentNode = currentNode.parentNode;
                                }
                                if (!offsetParentIsBody) {
                                    this.element.parentNode.removeChild(this.element);
                                    this.element.ownerDocument.body.appendChild(this.element);
                                }
                            }
                        }
                        // Any css change will trigger a repaint, so let's avoid one if nothing changed
                        var writeCSS = {};
                        var write = false;
                        for(var key in css){
                            var val = css[key];
                            var elVal = this.element.style[key];
                            if (elVal !== val) {
                                write = true;
                                writeCSS[key] = val;
                            }
                        }
                        if (write) defer(function() {
                            extend(_this8.element.style, writeCSS);
                            _this8.trigger("repositioned");
                        });
                    }
                }
            ]);
            return TetherClass;
        }(Evented);
        TetherClass.modules = [];
        TetherBase.position = position;
        var Tether = extend(TetherClass, TetherBase);
        var _slicedToArray = function() {
            function sliceIterator(arr, i) {
                var _arr = [];
                var _n = true;
                var _d = false;
                var _e = undefined;
                try {
                    for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                        _arr.push(_s.value);
                        if (i && _arr.length === i) break;
                    }
                } catch (err) {
                    _d = true;
                    _e = err;
                } finally{
                    try {
                        if (!_n && _i["return"]) _i["return"]();
                    } finally{
                        if (_d) throw _e;
                    }
                }
                return _arr;
            }
            return function(arr, i) {
                if (Array.isArray(arr)) return arr;
                else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                else throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
        }();
        var _TetherBase$Utils = TetherBase.Utils;
        var getBounds = _TetherBase$Utils.getBounds;
        var extend = _TetherBase$Utils.extend;
        var updateClasses = _TetherBase$Utils.updateClasses;
        var defer = _TetherBase$Utils.defer;
        var BOUNDS_FORMAT = [
            "left",
            "top",
            "right",
            "bottom"
        ];
        function getBoundingRect(tether, to) {
            if (to === "scrollParent") to = tether.scrollParents[0];
            else if (to === "window") to = [
                pageXOffset,
                pageYOffset,
                innerWidth + pageXOffset,
                innerHeight + pageYOffset
            ];
            if (to === document) to = to.documentElement;
            if (typeof to.nodeType !== "undefined") (function() {
                var node = to;
                var size = getBounds(to);
                var pos = size;
                var style = getComputedStyle(to);
                to = [
                    pos.left,
                    pos.top,
                    size.width + pos.left,
                    size.height + pos.top
                ];
                // Account any parent Frames scroll offset
                if (node.ownerDocument !== document) {
                    var win = node.ownerDocument.defaultView;
                    to[0] += win.pageXOffset;
                    to[1] += win.pageYOffset;
                    to[2] += win.pageXOffset;
                    to[3] += win.pageYOffset;
                }
                BOUNDS_FORMAT.forEach(function(side, i) {
                    side = side[0].toUpperCase() + side.substr(1);
                    if (side === "Top" || side === "Left") to[i] += parseFloat(style["border" + side + "Width"]);
                    else to[i] -= parseFloat(style["border" + side + "Width"]);
                });
            })();
            return to;
        }
        TetherBase.modules.push({
            position: function position(_ref) {
                var _this = this;
                var top = _ref.top;
                var left = _ref.left;
                var targetAttachment = _ref.targetAttachment;
                if (!this.options.constraints) return true;
                var _cache = this.cache("element-bounds", function() {
                    return getBounds(_this.element);
                });
                var height = _cache.height;
                var width = _cache.width;
                if (width === 0 && height === 0 && typeof this.lastSize !== "undefined") {
                    var _lastSize = this.lastSize;
                    // Handle the item getting hidden as a result of our positioning without glitching
                    // the classes in and out
                    width = _lastSize.width;
                    height = _lastSize.height;
                }
                var targetSize = this.cache("target-bounds", function() {
                    return _this.getTargetBounds();
                });
                var targetHeight = targetSize.height;
                var targetWidth = targetSize.width;
                var allClasses = [
                    this.getClass("pinned"),
                    this.getClass("out-of-bounds")
                ];
                this.options.constraints.forEach(function(constraint) {
                    var outOfBoundsClass = constraint.outOfBoundsClass;
                    var pinnedClass = constraint.pinnedClass;
                    if (outOfBoundsClass) allClasses.push(outOfBoundsClass);
                    if (pinnedClass) allClasses.push(pinnedClass);
                });
                allClasses.forEach(function(cls) {
                    [
                        "left",
                        "top",
                        "right",
                        "bottom"
                    ].forEach(function(side) {
                        allClasses.push(cls + "-" + side);
                    });
                });
                var addClasses = [];
                var tAttachment = extend({}, targetAttachment);
                var eAttachment = extend({}, this.attachment);
                this.options.constraints.forEach(function(constraint) {
                    var to = constraint.to;
                    var attachment = constraint.attachment;
                    var pin = constraint.pin;
                    if (typeof attachment === "undefined") attachment = "";
                    var changeAttachX = undefined, changeAttachY = undefined;
                    if (attachment.indexOf(" ") >= 0) {
                        var _attachment$split = attachment.split(" ");
                        var _attachment$split2 = _slicedToArray(_attachment$split, 2);
                        changeAttachY = _attachment$split2[0];
                        changeAttachX = _attachment$split2[1];
                    } else changeAttachX = changeAttachY = attachment;
                    var bounds = getBoundingRect(_this, to);
                    if (changeAttachY === "target" || changeAttachY === "both") {
                        if (top < bounds[1] && tAttachment.top === "top") {
                            top += targetHeight;
                            tAttachment.top = "bottom";
                        }
                        if (top + height > bounds[3] && tAttachment.top === "bottom") {
                            top -= targetHeight;
                            tAttachment.top = "top";
                        }
                    }
                    if (changeAttachY === "together") {
                        if (tAttachment.top === "top") {
                            if (eAttachment.top === "bottom" && top < bounds[1]) {
                                top += targetHeight;
                                tAttachment.top = "bottom";
                                top += height;
                                eAttachment.top = "top";
                            } else if (eAttachment.top === "top" && top + height > bounds[3] && top - (height - targetHeight) >= bounds[1]) {
                                top -= height - targetHeight;
                                tAttachment.top = "bottom";
                                eAttachment.top = "bottom";
                            }
                        }
                        if (tAttachment.top === "bottom") {
                            if (eAttachment.top === "top" && top + height > bounds[3]) {
                                top -= targetHeight;
                                tAttachment.top = "top";
                                top -= height;
                                eAttachment.top = "bottom";
                            } else if (eAttachment.top === "bottom" && top < bounds[1] && top + (height * 2 - targetHeight) <= bounds[3]) {
                                top += height - targetHeight;
                                tAttachment.top = "top";
                                eAttachment.top = "top";
                            }
                        }
                        if (tAttachment.top === "middle") {
                            if (top + height > bounds[3] && eAttachment.top === "top") {
                                top -= height;
                                eAttachment.top = "bottom";
                            } else if (top < bounds[1] && eAttachment.top === "bottom") {
                                top += height;
                                eAttachment.top = "top";
                            }
                        }
                    }
                    if (changeAttachX === "target" || changeAttachX === "both") {
                        if (left < bounds[0] && tAttachment.left === "left") {
                            left += targetWidth;
                            tAttachment.left = "right";
                        }
                        if (left + width > bounds[2] && tAttachment.left === "right") {
                            left -= targetWidth;
                            tAttachment.left = "left";
                        }
                    }
                    if (changeAttachX === "together") {
                        if (left < bounds[0] && tAttachment.left === "left") {
                            if (eAttachment.left === "right") {
                                left += targetWidth;
                                tAttachment.left = "right";
                                left += width;
                                eAttachment.left = "left";
                            } else if (eAttachment.left === "left") {
                                left += targetWidth;
                                tAttachment.left = "right";
                                left -= width;
                                eAttachment.left = "right";
                            }
                        } else if (left + width > bounds[2] && tAttachment.left === "right") {
                            if (eAttachment.left === "left") {
                                left -= targetWidth;
                                tAttachment.left = "left";
                                left -= width;
                                eAttachment.left = "right";
                            } else if (eAttachment.left === "right") {
                                left -= targetWidth;
                                tAttachment.left = "left";
                                left += width;
                                eAttachment.left = "left";
                            }
                        } else if (tAttachment.left === "center") {
                            if (left + width > bounds[2] && eAttachment.left === "left") {
                                left -= width;
                                eAttachment.left = "right";
                            } else if (left < bounds[0] && eAttachment.left === "right") {
                                left += width;
                                eAttachment.left = "left";
                            }
                        }
                    }
                    if (changeAttachY === "element" || changeAttachY === "both") {
                        if (top < bounds[1] && eAttachment.top === "bottom") {
                            top += height;
                            eAttachment.top = "top";
                        }
                        if (top + height > bounds[3] && eAttachment.top === "top") {
                            top -= height;
                            eAttachment.top = "bottom";
                        }
                    }
                    if (changeAttachX === "element" || changeAttachX === "both") {
                        if (left < bounds[0]) {
                            if (eAttachment.left === "right") {
                                left += width;
                                eAttachment.left = "left";
                            } else if (eAttachment.left === "center") {
                                left += width / 2;
                                eAttachment.left = "left";
                            }
                        }
                        if (left + width > bounds[2]) {
                            if (eAttachment.left === "left") {
                                left -= width;
                                eAttachment.left = "right";
                            } else if (eAttachment.left === "center") {
                                left -= width / 2;
                                eAttachment.left = "right";
                            }
                        }
                    }
                    if (typeof pin === "string") pin = pin.split(",").map(function(p) {
                        return p.trim();
                    });
                    else if (pin === true) pin = [
                        "top",
                        "left",
                        "right",
                        "bottom"
                    ];
                    pin = pin || [];
                    var pinned = [];
                    var oob = [];
                    if (top < bounds[1]) {
                        if (pin.indexOf("top") >= 0) {
                            top = bounds[1];
                            pinned.push("top");
                        } else oob.push("top");
                    }
                    if (top + height > bounds[3]) {
                        if (pin.indexOf("bottom") >= 0) {
                            top = bounds[3] - height;
                            pinned.push("bottom");
                        } else oob.push("bottom");
                    }
                    if (left < bounds[0]) {
                        if (pin.indexOf("left") >= 0) {
                            left = bounds[0];
                            pinned.push("left");
                        } else oob.push("left");
                    }
                    if (left + width > bounds[2]) {
                        if (pin.indexOf("right") >= 0) {
                            left = bounds[2] - width;
                            pinned.push("right");
                        } else oob.push("right");
                    }
                    if (pinned.length) (function() {
                        var pinnedClass = undefined;
                        if (typeof _this.options.pinnedClass !== "undefined") pinnedClass = _this.options.pinnedClass;
                        else pinnedClass = _this.getClass("pinned");
                        addClasses.push(pinnedClass);
                        pinned.forEach(function(side) {
                            addClasses.push(pinnedClass + "-" + side);
                        });
                    })();
                    if (oob.length) (function() {
                        var oobClass = undefined;
                        if (typeof _this.options.outOfBoundsClass !== "undefined") oobClass = _this.options.outOfBoundsClass;
                        else oobClass = _this.getClass("out-of-bounds");
                        addClasses.push(oobClass);
                        oob.forEach(function(side) {
                            addClasses.push(oobClass + "-" + side);
                        });
                    })();
                    if (pinned.indexOf("left") >= 0 || pinned.indexOf("right") >= 0) eAttachment.left = tAttachment.left = false;
                    if (pinned.indexOf("top") >= 0 || pinned.indexOf("bottom") >= 0) eAttachment.top = tAttachment.top = false;
                    if (tAttachment.top !== targetAttachment.top || tAttachment.left !== targetAttachment.left || eAttachment.top !== _this.attachment.top || eAttachment.left !== _this.attachment.left) {
                        _this.updateAttachClasses(eAttachment, tAttachment);
                        _this.trigger("update", {
                            attachment: eAttachment,
                            targetAttachment: tAttachment
                        });
                    }
                });
                defer(function() {
                    if (!(_this.options.addTargetClasses === false)) updateClasses(_this.target, addClasses, allClasses);
                    updateClasses(_this.element, addClasses, allClasses);
                });
                return {
                    top: top,
                    left: left
                };
            }
        });
        var _TetherBase$Utils = TetherBase.Utils;
        var getBounds = _TetherBase$Utils.getBounds;
        var updateClasses = _TetherBase$Utils.updateClasses;
        var defer = _TetherBase$Utils.defer;
        TetherBase.modules.push({
            position: function position(_ref) {
                var _this = this;
                var top = _ref.top;
                var left = _ref.left;
                var _cache = this.cache("element-bounds", function() {
                    return getBounds(_this.element);
                });
                var height = _cache.height;
                var width = _cache.width;
                var targetPos = this.getTargetBounds();
                var bottom = top + height;
                var right = left + width;
                var abutted = [];
                if (top <= targetPos.bottom && bottom >= targetPos.top) [
                    "left",
                    "right"
                ].forEach(function(side) {
                    var targetPosSide = targetPos[side];
                    if (targetPosSide === left || targetPosSide === right) abutted.push(side);
                });
                if (left <= targetPos.right && right >= targetPos.left) [
                    "top",
                    "bottom"
                ].forEach(function(side) {
                    var targetPosSide = targetPos[side];
                    if (targetPosSide === top || targetPosSide === bottom) abutted.push(side);
                });
                var allClasses = [];
                var addClasses = [];
                var sides = [
                    "left",
                    "top",
                    "right",
                    "bottom"
                ];
                allClasses.push(this.getClass("abutted"));
                sides.forEach(function(side) {
                    allClasses.push(_this.getClass("abutted") + "-" + side);
                });
                if (abutted.length) addClasses.push(this.getClass("abutted"));
                abutted.forEach(function(side) {
                    addClasses.push(_this.getClass("abutted") + "-" + side);
                });
                defer(function() {
                    if (!(_this.options.addTargetClasses === false)) updateClasses(_this.target, addClasses, allClasses);
                    updateClasses(_this.element, addClasses, allClasses);
                });
                return true;
            }
        });
        var _slicedToArray = function() {
            function sliceIterator(arr, i) {
                var _arr = [];
                var _n = true;
                var _d = false;
                var _e = undefined;
                try {
                    for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                        _arr.push(_s.value);
                        if (i && _arr.length === i) break;
                    }
                } catch (err) {
                    _d = true;
                    _e = err;
                } finally{
                    try {
                        if (!_n && _i["return"]) _i["return"]();
                    } finally{
                        if (_d) throw _e;
                    }
                }
                return _arr;
            }
            return function(arr, i) {
                if (Array.isArray(arr)) return arr;
                else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                else throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
        }();
        TetherBase.modules.push({
            position: function position(_ref) {
                var top = _ref.top;
                var left = _ref.left;
                if (!this.options.shift) return;
                var shift = this.options.shift;
                if (typeof this.options.shift === "function") shift = this.options.shift.call(this, {
                    top: top,
                    left: left
                });
                var shiftTop = undefined, shiftLeft = undefined;
                if (typeof shift === "string") {
                    shift = shift.split(" ");
                    shift[1] = shift[1] || shift[0];
                    var _shift = shift;
                    var _shift2 = _slicedToArray(_shift, 2);
                    shiftTop = _shift2[0];
                    shiftLeft = _shift2[1];
                    shiftTop = parseFloat(shiftTop, 10);
                    shiftLeft = parseFloat(shiftLeft, 10);
                } else {
                    shiftTop = shift.top;
                    shiftLeft = shift.left;
                }
                top += shiftTop;
                left += shiftLeft;
                return {
                    top: top,
                    left: left
                };
            }
        });
        return Tether;
    });
})($ce10daea3dd4da28$var$tether);
Object.defineProperty($ce10daea3dd4da28$var$TetherComponent$2, "__esModule", {
    value: true
});
$ce10daea3dd4da28$var$TetherComponent$2.default = void 0;
var $ce10daea3dd4da28$var$_react = $ce10daea3dd4da28$var$_interopRequireWildcard((0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))));
var $ce10daea3dd4da28$var$_propTypes = $ce10daea3dd4da28$var$_interopRequireDefault((0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))));
var $ce10daea3dd4da28$var$_reactDom = $ce10daea3dd4da28$var$_interopRequireDefault((0, (/*@__PURE__*/$parcel$interopDefault($3qHRY))));
var $ce10daea3dd4da28$var$_tether = $ce10daea3dd4da28$var$_interopRequireDefault($ce10daea3dd4da28$var$tether.exports);
function $ce10daea3dd4da28$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ce10daea3dd4da28$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $ce10daea3dd4da28$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ce10daea3dd4da28$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ce10daea3dd4da28$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ce10daea3dd4da28$var$_typeof(obj);
}
function $ce10daea3dd4da28$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $ce10daea3dd4da28$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $ce10daea3dd4da28$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ce10daea3dd4da28$var$_objectWithoutPropertiesLoose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ce10daea3dd4da28$var$_objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ce10daea3dd4da28$var$_toConsumableArray(arr) {
    return $ce10daea3dd4da28$var$_arrayWithoutHoles(arr) || $ce10daea3dd4da28$var$_iterableToArray(arr) || $ce10daea3dd4da28$var$_nonIterableSpread();
}
function $ce10daea3dd4da28$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $ce10daea3dd4da28$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $ce10daea3dd4da28$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $ce10daea3dd4da28$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ce10daea3dd4da28$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ce10daea3dd4da28$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ce10daea3dd4da28$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ce10daea3dd4da28$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ce10daea3dd4da28$var$_possibleConstructorReturn(self1, call) {
    if (call && ($ce10daea3dd4da28$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ce10daea3dd4da28$var$_assertThisInitialized$1(self1);
}
function $ce10daea3dd4da28$var$_getPrototypeOf$1(o) {
    $ce10daea3dd4da28$var$_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ce10daea3dd4da28$var$_getPrototypeOf$1(o);
}
function $ce10daea3dd4da28$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ce10daea3dd4da28$var$_setPrototypeOf$1(subClass, superClass);
}
function $ce10daea3dd4da28$var$_setPrototypeOf$1(o, p) {
    $ce10daea3dd4da28$var$_setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ce10daea3dd4da28$var$_setPrototypeOf$1(o, p);
}
function $ce10daea3dd4da28$var$_assertThisInitialized$1(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $ce10daea3dd4da28$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
if (!$ce10daea3dd4da28$var$_tether.default) console.error("It looks like Tether has not been included. Please load this dependency first https://github.com/HubSpot/tether");
var $ce10daea3dd4da28$var$renderElementToPropTypes = [
    $ce10daea3dd4da28$var$_propTypes.default.string,
    $ce10daea3dd4da28$var$_propTypes.default.shape({
        appendChild: $ce10daea3dd4da28$var$_propTypes.default.func.isRequired
    })
];
var $ce10daea3dd4da28$var$childrenPropType = function childrenPropType(_ref, propName, componentName) {
    var children = _ref.children;
    var childCount = $ce10daea3dd4da28$var$_react.Children.count(children);
    if (childCount > 0) return new Error("".concat(componentName, " no longer uses children to render components. Please use renderTarget and renderElement instead."));
};
var $ce10daea3dd4da28$var$attachmentPositions = [
    "auto auto",
    "top left",
    "top center",
    "top right",
    "middle left",
    "middle center",
    "middle right",
    "bottom left",
    "bottom center",
    "bottom right"
];
var $ce10daea3dd4da28$var$TetherComponent$1 = /*#__PURE__*/ function(_Component) {
    $ce10daea3dd4da28$var$_inherits(TetherComponent, _Component);
    function TetherComponent() {
        var _getPrototypeOf2;
        var _this;
        $ce10daea3dd4da28$var$_classCallCheck(this, TetherComponent);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $ce10daea3dd4da28$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $ce10daea3dd4da28$var$_getPrototypeOf$1(TetherComponent)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $ce10daea3dd4da28$var$_defineProperty($ce10daea3dd4da28$var$_assertThisInitialized$1($ce10daea3dd4da28$var$_assertThisInitialized$1(_this)), "_targetNode", $ce10daea3dd4da28$var$_react.default.createRef());
        $ce10daea3dd4da28$var$_defineProperty($ce10daea3dd4da28$var$_assertThisInitialized$1($ce10daea3dd4da28$var$_assertThisInitialized$1(_this)), "_elementNode", $ce10daea3dd4da28$var$_react.default.createRef());
        $ce10daea3dd4da28$var$_defineProperty($ce10daea3dd4da28$var$_assertThisInitialized$1($ce10daea3dd4da28$var$_assertThisInitialized$1(_this)), "_elementParentNode", null);
        $ce10daea3dd4da28$var$_defineProperty($ce10daea3dd4da28$var$_assertThisInitialized$1($ce10daea3dd4da28$var$_assertThisInitialized$1(_this)), "_tetherInstance", null);
        return _this;
    }
    $ce10daea3dd4da28$var$_createClass(TetherComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._createContainer(); // The container is created after mounting
                // so we need to force an update to
                // enable tether
                // Cannot move _createContainer into the constructor
                // because of is a side effect: https://reactjs.org/docs/strict-mode.html#detecting-unexpected-side-effects
                this.forceUpdate();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                // If the container related props have changed, then update the container
                if (prevProps.renderElementTag !== this.props.renderElementTag || prevProps.renderElementTo !== this.props.renderElementTo) this._createContainer();
                 // Verify if className props have changed
                if (this._elementParentNode && prevProps.className !== this.props.className) {
                    var _this$_elementParentN, _this$_elementParentN2;
                    // Add a bunch of checks against weird classNames
                    var prevClasses = (prevProps.className || "").split(" ").filter(function(value) {
                        return value.length > 0;
                    });
                    var currClasses = (this.props.className || "").split(" ").filter(function(value) {
                        return value.length > 0;
                    });
                    (_this$_elementParentN = this._elementParentNode.classList).remove.apply(_this$_elementParentN, $ce10daea3dd4da28$var$_toConsumableArray(prevClasses));
                    (_this$_elementParentN2 = this._elementParentNode.classList).add.apply(_this$_elementParentN2, $ce10daea3dd4da28$var$_toConsumableArray(currClasses));
                }
                this._update();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._destroy();
            }
        },
        {
            key: "getTetherInstance",
            value: function getTetherInstance() {
                return this._tetherInstance;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this._tetherInstance.disable();
            }
        },
        {
            key: "enable",
            value: function enable() {
                this._tetherInstance.enable();
            }
        },
        {
            key: "on",
            value: function on(event, handler, ctx) {
                this._tetherInstance.on(event, handler, ctx);
            }
        },
        {
            key: "once",
            value: function once(event, handler, ctx) {
                this._tetherInstance.once(event, handler, ctx);
            }
        },
        {
            key: "off",
            value: function off(event, handler) {
                this._tetherInstance.off(event, handler);
            }
        },
        {
            key: "position",
            value: function position() {
                this._tetherInstance.position();
            }
        },
        {
            key: "_runRenders",
            value: function _runRenders() {
                // To obtain the components, we run the render functions and pass in the ref
                // Later, when the component is mounted, the ref functions will be called
                // and trigger a tether update
                var targetComponent = typeof this.props.renderTarget === "function" ? this.props.renderTarget(this._targetNode) : null;
                var elementComponent = typeof this.props.renderElement === "function" ? this.props.renderElement(this._elementNode) : null; // Check if what has been returned is a valid react element
                if (!(0, $ce10daea3dd4da28$var$_react.isValidElement)(targetComponent)) targetComponent = null;
                if (!(0, $ce10daea3dd4da28$var$_react.isValidElement)(elementComponent)) elementComponent = null;
                return {
                    targetComponent: targetComponent,
                    elementComponent: elementComponent
                };
            }
        },
        {
            key: "_createTetherInstance",
            value: function _createTetherInstance(tetherOptions) {
                if (this._tetherInstance) this._destroy();
                this._tetherInstance = new $ce10daea3dd4da28$var$_tether.default(tetherOptions);
                this._registerEventListeners();
            }
        },
        {
            key: "_destroyTetherInstance",
            value: function _destroyTetherInstance() {
                if (this._tetherInstance) {
                    this._tetherInstance.destroy();
                    this._tetherInstance = null;
                }
            }
        },
        {
            key: "_registerEventListeners",
            value: function _registerEventListeners() {
                var _this2 = this;
                this.on("update", function() {
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    return _this2.props.onUpdate && _this2.props.onUpdate.apply(_this2, args);
                });
                this.on("repositioned", function() {
                    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                    return _this2.props.onRepositioned && _this2.props.onRepositioned.apply(_this2, args);
                });
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this._destroyTetherInstance();
                this._removeContainer();
            }
        },
        {
            key: "_createContainer",
            value: function _createContainer() {
                // Create element node container if it hasn't been yet
                this._removeContainer();
                var _this$props = this.props, renderElementTag = _this$props.renderElementTag, className = _this$props.className; // Create a node that we can stick our content Component in
                this._elementParentNode = document.createElement(renderElementTag);
                this._elementParentNode.className = className || "";
            }
        },
        {
            key: "_addContainerToDOM",
            value: function _addContainerToDOM() {
                // Append node to the render node
                if (this._elementParentNode.parentNode !== this._renderNode) this._renderNode.appendChild(this._elementParentNode);
            }
        },
        {
            key: "_removeContainer",
            value: function _removeContainer() {
                if (this._elementParentNode && this._elementParentNode.parentNode) this._elementParentNode.parentNode.removeChild(this._elementParentNode);
            }
        },
        {
            key: "_update",
            value: function _update() {
                // If no element component provided, bail out
                var shouldDestroy = !this._elementNode.current || !this._targetNode.current;
                if (shouldDestroy) {
                    // Destroy Tether element if it has been created
                    this._destroy();
                    return;
                }
                this._updateTether();
            }
        },
        {
            key: "_updateTether",
            value: function _updateTether() {
                var _this$props2 = this.props;
                _this$props2.children;
                _this$props2.renderElementTag;
                _this$props2.renderElementTo;
                var id = _this$props2.id;
                _this$props2.className;
                var style = _this$props2.style;
                _this$props2.renderTarget;
                _this$props2.renderElement;
                var options = $ce10daea3dd4da28$var$_objectWithoutProperties(_this$props2, [
                    "children",
                    "renderElementTag",
                    "renderElementTo",
                    "id",
                    "className",
                    "style",
                    "renderTarget",
                    "renderElement"
                ]);
                var tetherOptions = $ce10daea3dd4da28$var$_objectSpread({
                    target: this._targetNode.current,
                    element: this._elementParentNode
                }, options);
                var idStr = id || "";
                if (this._elementParentNode.id !== idStr) this._elementParentNode.id = idStr;
                if (style) {
                    var elementStyle = this._elementParentNode.style;
                    Object.keys(style).forEach(function(key) {
                        if (elementStyle[key] !== style[key]) elementStyle[key] = style[key];
                    });
                }
                this._addContainerToDOM();
                if (this._tetherInstance) this._tetherInstance.setOptions(tetherOptions);
                else this._createTetherInstance(tetherOptions);
                this._tetherInstance.position();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$_runRenders = this._runRenders(), targetComponent = _this$_runRenders.targetComponent, elementComponent = _this$_runRenders.elementComponent;
                if (!targetComponent) return null;
                return $ce10daea3dd4da28$var$_react.default.createElement($ce10daea3dd4da28$var$_react.default.Fragment, null, targetComponent, elementComponent && this._elementParentNode && $ce10daea3dd4da28$var$_reactDom.default.createPortal(elementComponent, this._elementParentNode));
            }
        },
        {
            key: "_renderNode",
            get: function get() {
                var renderElementTo = this.props.renderElementTo;
                if (typeof renderElementTo === "string") return document.querySelector(renderElementTo);
                return renderElementTo || document.body;
            }
        }
    ]);
    return TetherComponent;
}($ce10daea3dd4da28$var$_react.Component);
$ce10daea3dd4da28$var$_defineProperty($ce10daea3dd4da28$var$TetherComponent$1, "propTypes", {
    renderElementTag: $ce10daea3dd4da28$var$_propTypes.default.string,
    renderElementTo: $ce10daea3dd4da28$var$_propTypes.default.oneOfType($ce10daea3dd4da28$var$renderElementToPropTypes),
    attachment: $ce10daea3dd4da28$var$_propTypes.default.oneOf($ce10daea3dd4da28$var$attachmentPositions).isRequired,
    targetAttachment: $ce10daea3dd4da28$var$_propTypes.default.oneOf($ce10daea3dd4da28$var$attachmentPositions),
    offset: $ce10daea3dd4da28$var$_propTypes.default.string,
    targetOffset: $ce10daea3dd4da28$var$_propTypes.default.string,
    targetModifier: $ce10daea3dd4da28$var$_propTypes.default.string,
    enabled: $ce10daea3dd4da28$var$_propTypes.default.bool,
    classes: $ce10daea3dd4da28$var$_propTypes.default.object,
    classPrefix: $ce10daea3dd4da28$var$_propTypes.default.string,
    optimizations: $ce10daea3dd4da28$var$_propTypes.default.object,
    constraints: $ce10daea3dd4da28$var$_propTypes.default.array,
    id: $ce10daea3dd4da28$var$_propTypes.default.string,
    className: $ce10daea3dd4da28$var$_propTypes.default.string,
    style: $ce10daea3dd4da28$var$_propTypes.default.object,
    onUpdate: $ce10daea3dd4da28$var$_propTypes.default.func,
    onRepositioned: $ce10daea3dd4da28$var$_propTypes.default.func,
    renderTarget: $ce10daea3dd4da28$var$_propTypes.default.func,
    renderElement: $ce10daea3dd4da28$var$_propTypes.default.func,
    children: $ce10daea3dd4da28$var$childrenPropType
});
$ce10daea3dd4da28$var$_defineProperty($ce10daea3dd4da28$var$TetherComponent$1, "defaultProps", {
    renderElementTag: "div",
    renderElementTo: null
});
var $ce10daea3dd4da28$var$_default = $ce10daea3dd4da28$var$TetherComponent$1;
$ce10daea3dd4da28$var$TetherComponent$2.default = $ce10daea3dd4da28$var$_default;
(function(exports) {
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    Object.defineProperty(exports, "default", {
        enumerable: true,
        get: function get() {
            return _TetherComponent.default;
        }
    });
    var _TetherComponent = _interopRequireDefault($ce10daea3dd4da28$var$TetherComponent$2);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
})($ce10daea3dd4da28$var$reactTether);
var $ce10daea3dd4da28$var$TetherComponent = /*@__PURE__*/ $ce10daea3dd4da28$var$getDefaultExportFromCjs($ce10daea3dd4da28$var$reactTether);
function $ce10daea3dd4da28$var$_extends() {
    $ce10daea3dd4da28$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ce10daea3dd4da28$var$_extends.apply(this, arguments);
}
function $ce10daea3dd4da28$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ce10daea3dd4da28$var$_setPrototypeOf(o, p) {
    $ce10daea3dd4da28$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ce10daea3dd4da28$var$_setPrototypeOf(o, p);
}
function $ce10daea3dd4da28$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $ce10daea3dd4da28$var$_setPrototypeOf(subClass, superClass);
}
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $ce10daea3dd4da28$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $ce10daea3dd4da28$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!$ce10daea3dd4da28$var$hasClass(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}
function $ce10daea3dd4da28$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $ce10daea3dd4da28$var$removeClass$1(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $ce10daea3dd4da28$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $ce10daea3dd4da28$var$replaceClassName(element.className && element.className.baseVal || "", className));
}
var $ce10daea3dd4da28$var$config = {
    disabled: false
};
var $ce10daea3dd4da28$var$TransitionGroupContext = (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createContext(null);
var $ce10daea3dd4da28$var$UNMOUNTED = "unmounted";
var $ce10daea3dd4da28$var$EXITED = "exited";
var $ce10daea3dd4da28$var$ENTERING = "entering";
var $ce10daea3dd4da28$var$ENTERED = "entered";
var $ce10daea3dd4da28$var$EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $ce10daea3dd4da28$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $ce10daea3dd4da28$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $ce10daea3dd4da28$var$EXITED;
                _this.appearStatus = $ce10daea3dd4da28$var$ENTERING;
            } else initialStatus = $ce10daea3dd4da28$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $ce10daea3dd4da28$var$UNMOUNTED;
        else initialStatus = $ce10daea3dd4da28$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $ce10daea3dd4da28$var$UNMOUNTED) return {
            status: $ce10daea3dd4da28$var$EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $ce10daea3dd4da28$var$ENTERING && status !== $ce10daea3dd4da28$var$ENTERED) nextStatus = $ce10daea3dd4da28$var$ENTERING;
            } else if (status === $ce10daea3dd4da28$var$ENTERING || status === $ce10daea3dd4da28$var$ENTERED) nextStatus = $ce10daea3dd4da28$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $ce10daea3dd4da28$var$ENTERING) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $ce10daea3dd4da28$var$EXITED) this.setState({
            status: $ce10daea3dd4da28$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($3qHRY))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || $ce10daea3dd4da28$var$config.disabled) {
            this.safeSetState({
                status: $ce10daea3dd4da28$var$ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $ce10daea3dd4da28$var$ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $ce10daea3dd4da28$var$ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($3qHRY))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || $ce10daea3dd4da28$var$config.disabled) {
            this.safeSetState({
                status: $ce10daea3dd4da28$var$EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $ce10daea3dd4da28$var$EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $ce10daea3dd4da28$var$EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($3qHRY))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $ce10daea3dd4da28$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = $ce10daea3dd4da28$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($ce10daea3dd4da28$var$TransitionGroupContext.Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).Component);
$ce10daea3dd4da28$var$Transition.contextType = $ce10daea3dd4da28$var$TransitionGroupContext;
$ce10daea3dd4da28$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $ce10daea3dd4da28$var$noop() {}
$ce10daea3dd4da28$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $ce10daea3dd4da28$var$noop,
    onEntering: $ce10daea3dd4da28$var$noop,
    onEntered: $ce10daea3dd4da28$var$noop,
    onExit: $ce10daea3dd4da28$var$noop,
    onExiting: $ce10daea3dd4da28$var$noop,
    onExited: $ce10daea3dd4da28$var$noop
};
$ce10daea3dd4da28$var$Transition.UNMOUNTED = $ce10daea3dd4da28$var$UNMOUNTED;
$ce10daea3dd4da28$var$Transition.EXITED = $ce10daea3dd4da28$var$EXITED;
$ce10daea3dd4da28$var$Transition.ENTERING = $ce10daea3dd4da28$var$ENTERING;
$ce10daea3dd4da28$var$Transition.ENTERED = $ce10daea3dd4da28$var$ENTERED;
$ce10daea3dd4da28$var$Transition.EXITING = $ce10daea3dd4da28$var$EXITING;
var $ce10daea3dd4da28$var$Transition$1 = $ce10daea3dd4da28$var$Transition;
var $ce10daea3dd4da28$var$_addClass = function addClass$1(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return $ce10daea3dd4da28$var$addClass(node, c);
    });
};
var $ce10daea3dd4da28$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return $ce10daea3dd4da28$var$removeClass$1(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $ce10daea3dd4da28$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    $ce10daea3dd4da28$var$_inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") /* eslint-disable no-unused-expressions */ node && node.scrollTop;
        if (className) {
            this.appliedClasses[type][phase] = className;
            $ce10daea3dd4da28$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $ce10daea3dd4da28$var$removeClass(node, baseClassName);
        if (activeClassName) $ce10daea3dd4da28$var$removeClass(node, activeClassName);
        if (doneClassName) $ce10daea3dd4da28$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props;
        _this$props.classNames;
        var props = $ce10daea3dd4da28$var$_objectWithoutPropertiesLoose(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($ce10daea3dd4da28$var$Transition$1, $ce10daea3dd4da28$var$_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).Component);
$ce10daea3dd4da28$var$CSSTransition.defaultProps = {
    classNames: ""
};
$ce10daea3dd4da28$var$CSSTransition.propTypes = {};
var $ce10daea3dd4da28$var$CSSTransition$1 = $ce10daea3dd4da28$var$CSSTransition;
function $ce10daea3dd4da28$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $ce10daea3dd4da28$var$_getPrototypeOf(o) {
    $ce10daea3dd4da28$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ce10daea3dd4da28$var$_getPrototypeOf(o);
}
function $ce10daea3dd4da28$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $ce10daea3dd4da28$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ce10daea3dd4da28$var$_construct(Parent, args, Class) {
    if ($ce10daea3dd4da28$var$_isNativeReflectConstruct()) $ce10daea3dd4da28$var$_construct = Reflect.construct;
    else $ce10daea3dd4da28$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $ce10daea3dd4da28$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $ce10daea3dd4da28$var$_construct.apply(null, arguments);
}
function $ce10daea3dd4da28$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $ce10daea3dd4da28$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$ce10daea3dd4da28$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $ce10daea3dd4da28$var$_construct(Class, arguments, $ce10daea3dd4da28$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $ce10daea3dd4da28$var$_setPrototypeOf(Wrapper, Class);
    };
    return $ce10daea3dd4da28$var$_wrapNativeSuper(Class);
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */ var $ce10daea3dd4da28$var$PolishedError = /*#__PURE__*/ function(_Error) {
    $ce10daea3dd4da28$var$_inheritsLoose(PolishedError, _Error);
    function PolishedError(code) {
        var _this;
        _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
        return $ce10daea3dd4da28$var$_assertThisInitialized(_this);
    }
    return PolishedError;
}(/*#__PURE__*/ $ce10daea3dd4da28$var$_wrapNativeSuper(Error));
function $ce10daea3dd4da28$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $ce10daea3dd4da28$var$convertToInt(red, green, blue) {
    return $ce10daea3dd4da28$var$colorToInt(red) + "," + $ce10daea3dd4da28$var$colorToInt(green) + "," + $ce10daea3dd4da28$var$colorToInt(blue);
}
function $ce10daea3dd4da28$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $ce10daea3dd4da28$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
     // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = (hue % 360 + 360) % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $ce10daea3dd4da28$var$namedColorMap = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "00ffff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "0000ff",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "00ffff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "ff00ff",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "639",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */ function $ce10daea3dd4da28$var$nameToHex(color) {
    if (typeof color !== "string") return color;
    var normalizedColorName = color.toLowerCase();
    return $ce10daea3dd4da28$var$namedColorMap[normalizedColorName] ? "#" + $ce10daea3dd4da28$var$namedColorMap[normalizedColorName] : color;
}
var $ce10daea3dd4da28$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $ce10daea3dd4da28$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $ce10daea3dd4da28$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $ce10daea3dd4da28$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $ce10daea3dd4da28$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
var $ce10daea3dd4da28$var$rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
var $ce10daea3dd4da28$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var $ce10daea3dd4da28$var$hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $ce10daea3dd4da28$var$parseToRgb(color) {
    if (typeof color !== "string") throw new $ce10daea3dd4da28$var$PolishedError(3);
    var normalizedColor = $ce10daea3dd4da28$var$nameToHex(color);
    if (normalizedColor.match($ce10daea3dd4da28$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($ce10daea3dd4da28$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($ce10daea3dd4da28$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($ce10daea3dd4da28$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $ce10daea3dd4da28$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $ce10daea3dd4da28$var$rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $ce10daea3dd4da28$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $ce10daea3dd4da28$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $ce10daea3dd4da28$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new $ce10daea3dd4da28$var$PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $ce10daea3dd4da28$var$hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $ce10daea3dd4da28$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $ce10daea3dd4da28$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new $ce10daea3dd4da28$var$PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4])
        };
    }
    throw new $ce10daea3dd4da28$var$PolishedError(5);
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $ce10daea3dd4da28$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
function $ce10daea3dd4da28$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $ce10daea3dd4da28$var$rgb(value, green, blue) {
    if (typeof value === "number" && typeof green === "number" && typeof blue === "number") return $ce10daea3dd4da28$var$reduceHexValue("#" + $ce10daea3dd4da28$var$numberToHex(value) + $ce10daea3dd4da28$var$numberToHex(green) + $ce10daea3dd4da28$var$numberToHex(blue));
    else if (typeof value === "object" && green === undefined && blue === undefined) return $ce10daea3dd4da28$var$reduceHexValue("#" + $ce10daea3dd4da28$var$numberToHex(value.red) + $ce10daea3dd4da28$var$numberToHex(value.green) + $ce10daea3dd4da28$var$numberToHex(value.blue));
    throw new $ce10daea3dd4da28$var$PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $ce10daea3dd4da28$var$rgba(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === "string" && typeof secondValue === "number") {
        var rgbValue = $ce10daea3dd4da28$var$parseToRgb(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === "number" && typeof secondValue === "number" && typeof thirdValue === "number" && typeof fourthValue === "number") return fourthValue >= 1 ? $ce10daea3dd4da28$var$rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === "object" && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $ce10daea3dd4da28$var$rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new $ce10daea3dd4da28$var$PolishedError(7);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $ce10daea3dd4da28$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $ce10daea3dd4da28$var$curried(f, length, combined);
    };
} // eslint-disable-next-line no-redeclare
function $ce10daea3dd4da28$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $ce10daea3dd4da28$var$curried(f, f.length, []);
}
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $ce10daea3dd4da28$var$mix(weight, color, otherColor) {
    if (color === "transparent") return otherColor;
    if (otherColor === "transparent") return color;
    if (weight === 0) return otherColor;
    var parsedColor1 = $ce10daea3dd4da28$var$parseToRgb(color);
    var color1 = $ce10daea3dd4da28$var$_extends({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === "number" ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $ce10daea3dd4da28$var$parseToRgb(otherColor);
    var color2 = $ce10daea3dd4da28$var$_extends({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === "number" ? parsedColor2.alpha : 1
    }); // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha * (parseFloat(weight) / 1.0) + color2.alpha * (1 - parseFloat(weight) / 1.0)
    };
    return $ce10daea3dd4da28$var$rgba(mixedColor);
} // prettier-ignore
var $ce10daea3dd4da28$var$curriedMix = /*#__PURE__*/ $ce10daea3dd4da28$var$curry($ce10daea3dd4da28$var$mix);
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $ce10daea3dd4da28$var$tint(percentage, color) {
    if (color === "transparent") return color;
    return $ce10daea3dd4da28$var$curriedMix(parseFloat(percentage), "rgb(255, 255, 255)", color);
} // prettier-ignore
var $ce10daea3dd4da28$var$curriedTint = /*#__PURE__*/ $ce10daea3dd4da28$var$curry($ce10daea3dd4da28$var$tint);
var $ce10daea3dd4da28$var$_templateObject, $ce10daea3dd4da28$var$_templateObject2, $ce10daea3dd4da28$var$_templateObject3, $ce10daea3dd4da28$var$_templateObject4, $ce10daea3dd4da28$var$_templateObject5, $ce10daea3dd4da28$var$_templateObject6, $ce10daea3dd4da28$var$_templateObject7, $ce10daea3dd4da28$var$_templateObject8, $ce10daea3dd4da28$var$_templateObject9, $ce10daea3dd4da28$var$_templateObject10;
var $ce10daea3dd4da28$var$_tint = (0, $atWKR.stylizeFunction)($ce10daea3dd4da28$var$curriedTint);
var $ce10daea3dd4da28$var$transitions = {
    up: {
        start: function start() {
            return (0, $6fhRl.css)($ce10daea3dd4da28$var$_templateObject || ($ce10daea3dd4da28$var$_templateObject = $ce10daea3dd4da28$var$_taggedTemplateLiteral([
                "\n      opacity: 0;\n      transform: translate(0, ",
                ");\n    "
            ])), (0, $atWKR.glsp)());
        },
        end: function end() {
            return (0, $6fhRl.css)($ce10daea3dd4da28$var$_templateObject2 || ($ce10daea3dd4da28$var$_templateObject2 = $ce10daea3dd4da28$var$_taggedTemplateLiteral([
                "\n      opacity: 1;\n      transform: translate(0, ",
                ");\n    "
            ])), (0, $atWKR.glsp)(-1));
        }
    },
    down: {
        start: function start() {
            return (0, $6fhRl.css)($ce10daea3dd4da28$var$_templateObject3 || ($ce10daea3dd4da28$var$_templateObject3 = $ce10daea3dd4da28$var$_taggedTemplateLiteral([
                "\n      opacity: 0;\n      transform: translate(0, ",
                ");\n    "
            ])), (0, $atWKR.glsp)(-1));
        },
        end: function end() {
            return (0, $6fhRl.css)($ce10daea3dd4da28$var$_templateObject4 || ($ce10daea3dd4da28$var$_templateObject4 = $ce10daea3dd4da28$var$_taggedTemplateLiteral([
                "\n      opacity: 1;\n      transform: translate(0, ",
                ");\n    "
            ])), (0, $atWKR.glsp)());
        }
    },
    left: {
        start: function start() {
            return (0, $6fhRl.css)($ce10daea3dd4da28$var$_templateObject5 || ($ce10daea3dd4da28$var$_templateObject5 = $ce10daea3dd4da28$var$_taggedTemplateLiteral([
                "\n      opacity: 0;\n      transform: translate(",
                ", 0);\n    "
            ])), (0, $atWKR.glsp)());
        },
        end: function end() {
            return (0, $6fhRl.css)($ce10daea3dd4da28$var$_templateObject6 || ($ce10daea3dd4da28$var$_templateObject6 = $ce10daea3dd4da28$var$_taggedTemplateLiteral([
                "\n      opacity: 1;\n      transform: translate(",
                ", 0);\n    "
            ])), (0, $atWKR.glsp)(-1));
        }
    },
    right: {
        start: function start() {
            return (0, $6fhRl.css)($ce10daea3dd4da28$var$_templateObject7 || ($ce10daea3dd4da28$var$_templateObject7 = $ce10daea3dd4da28$var$_taggedTemplateLiteral([
                "\n      opacity: 0;\n      transform: translate(",
                ", 0);\n    "
            ])), (0, $atWKR.glsp)(-1));
        },
        end: function end() {
            return (0, $6fhRl.css)($ce10daea3dd4da28$var$_templateObject8 || ($ce10daea3dd4da28$var$_templateObject8 = $ce10daea3dd4da28$var$_taggedTemplateLiteral([
                "\n      opacity: 1;\n      transform: translate(",
                ", 0);\n    "
            ])), (0, $atWKR.glsp)());
        }
    }
};
var $ce10daea3dd4da28$var$DropContent = /*#__PURE__*/ (0, $6fhRl.default).div.withConfig({
    displayName: "styled__DropContent",
    componentId: "sc-cioebn-0"
})([
    "background:",
    ";border-radius:",
    ";box-shadow:0 0 0 1px ",
    ",",
    ";position:relative;z-index:1000;width:100vw;max-width:14rem;padding:",
    ";text-align:left;color:",
    ";transition:opacity 0.16s ease,transform 0.16s ease;.tether-target-attached-top.tether-element-attached-bottom &{",
    " &.drop-trans-exit{",
    "}&.drop-trans-exit-active{",
    "}}.tether-target-attached-bottom.tether-element-attached-top &{",
    " &.drop-trans-exit{",
    "}&.drop-trans-exit-active{",
    "}}.tether-target-attached-right.tether-element-attached-left &{",
    " &.drop-trans-exit{",
    "}&.drop-trans-exit-active{",
    "}}.tether-target-attached-left.tether-element-attached-right &{",
    " &.drop-trans-exit{",
    "}&.drop-trans-exit-active{",
    "}}&&.drop-trans-appear,&&.drop-trans-enter{",
    "}&&.drop-trans-enter-active,&&.drop-trans-appear-active{",
    "}&&.drop-trans-exit{",
    "}&&.drop-trans-exit-active{",
    "}"
], (0, $atWKR.themeVal)("color.surface"), (0, $atWKR.themeVal)("shape.rounded"), (0, $atWKR.themeVal)("color.base-100a"), (0, $atWKR.themeVal)("boxShadow.elevationD"), (0, $atWKR.glsp)(), (0, $atWKR.themeVal)("type.base.color"), $ce10daea3dd4da28$var$transitions.up.end, $ce10daea3dd4da28$var$transitions.up.end, $ce10daea3dd4da28$var$transitions.up.start, $ce10daea3dd4da28$var$transitions.down.end, $ce10daea3dd4da28$var$transitions.down.end, $ce10daea3dd4da28$var$transitions.down.start, $ce10daea3dd4da28$var$transitions.right.end, $ce10daea3dd4da28$var$transitions.right.end, $ce10daea3dd4da28$var$transitions.right.start, $ce10daea3dd4da28$var$transitions.left.end, $ce10daea3dd4da28$var$transitions.left.end, $ce10daea3dd4da28$var$transitions.left.start, function(_ref) {
    var direction = _ref.direction;
    return $ce10daea3dd4da28$var$transitions[direction].start;
}, function(_ref2) {
    var direction = _ref2.direction;
    return $ce10daea3dd4da28$var$transitions[direction].end;
}, function(_ref3) {
    var direction = _ref3.direction;
    return $ce10daea3dd4da28$var$transitions[direction].end;
}, function(_ref4) {
    var direction = _ref4.direction;
    return $ce10daea3dd4da28$var$transitions[direction].start;
}); // Drop content elements.
var $ce10daea3dd4da28$var$dropTitleAttrs = function dropTitleAttrs(props) {
    return {
        as: props.as || "h6"
    };
};
var $ce10daea3dd4da28$export$70e2c86b2c1a0692 = /*#__PURE__*/ (0, $6fhRl.default)((0, $egbTY.Overline)).attrs($ce10daea3dd4da28$var$dropTitleAttrs).withConfig({
    displayName: "styled__DropTitle",
    componentId: "sc-cioebn-1"
})([
    "margin:",
    ";"
], (0, $atWKR.glsp)(0, 0, 1, 0));
var $ce10daea3dd4da28$export$7e7cfe33f7203052 = /*#__PURE__*/ (0, $6fhRl.default).ul.withConfig({
    displayName: "styled__DropMenu",
    componentId: "sc-cioebn-2"
})([
    "list-style:none;margin:",
    ";box-shadow:0 ",
    " 0 0 ",
    ";padding:",
    ";min-width:12rem;font-family:",
    ";font-weight:",
    ";&:last-child{margin-bottom:",
    ";box-shadow:none;}"
], (0, $atWKR.glsp)(-1, -1, 1, -1), (0, $atWKR.themeVal)("layout.border"), (0, $atWKR.themeVal)("color.base-100a"), (0, $atWKR.glsp)(0.5, 0), (0, $atWKR.themeVal)("type.base.family"), (0, $atWKR.themeVal)("type.base.bold"), (0, $atWKR.glsp)(-1));
var $ce10daea3dd4da28$export$1d16dd19bd2e4d57 = /*#__PURE__*/ (0, $6fhRl.default).a.withConfig({
    displayName: "styled__DropMenuItem",
    componentId: "sc-cioebn-3"
})([
    "position:relative;display:flex;gap:",
    ";align-items:center;padding:",
    ";color:",
    ";text-decoration:none;transition:all 0.16s ease 0s;&:visited{color:inherit;}&:hover,&:focus{color:",
    ";background-color:",
    ";opacity:1;}",
    " ",
    ""
], (0, $atWKR.glsp)(0.5), (0, $atWKR.glsp)(0.25, 1), (0, $atWKR.themeVal)("type.base.color"), (0, $atWKR.themeVal)("color.link"), (0, $atWKR.rgba)((0, $atWKR.themeVal)("color.link"), 0.12), function(_ref5) {
    var active = _ref5.active;
    return active && (0, $6fhRl.css)($ce10daea3dd4da28$var$_templateObject9 || ($ce10daea3dd4da28$var$_templateObject9 = $ce10daea3dd4da28$var$_taggedTemplateLiteral([
        "\n      &,\n      &:visited {\n        background-color: ",
        ";\n        color: ",
        ";\n      }\n\n      &::before {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 0.25rem;\n        height: 100%;\n        background: ",
        ";\n        content: '';\n        pointer-events: none;\n      }\n    "
    ])), (0, $atWKR.rgba)((0, $atWKR.themeVal)("color.link"), 0.08), (0, $atWKR.themeVal)("color.link"), (0, $atWKR.themeVal)("color.link"));
}, function(_ref6) {
    var d = _ref6.disabled;
    return d && (0, $6fhRl.css)($ce10daea3dd4da28$var$_templateObject10 || ($ce10daea3dd4da28$var$_templateObject10 = $ce10daea3dd4da28$var$_taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ])), (0, $atWKR.disabled)());
});
var $ce10daea3dd4da28$export$c9bb0d8234e7b028 = /*#__PURE__*/ (0, $6fhRl.default).div.withConfig({
    displayName: "styled__DropInset",
    componentId: "sc-cioebn-4"
})([
    "background:",
    ";color:",
    ";box-shadow:inset 0 ",
    " 0 0 ",
    ",inset 0 -",
    " 0 0 ",
    ";margin:",
    ";padding:",
    ";&:first-child{box-shadow:inset 0 -",
    " 0 0 ",
    ";}&:last-child{margin-bottom:",
    ";box-shadow:inset 0 ",
    " 0 0 ",
    ";border-radius:0 0 ",
    " ",
    ";}&:only-child{box-shadow:none;}> *:first-child{margin-top:0;}> *:last-child{margin-bottom:0;}"
], (0, $atWKR.themeVal)("color.base-50"), $ce10daea3dd4da28$var$_tint(0.32, (0, $atWKR.themeVal)("type.base.color")), (0, $atWKR.themeVal)("layout.border"), (0, $atWKR.themeVal)("color.base-100a"), (0, $atWKR.themeVal)("layout.border"), (0, $atWKR.themeVal)("color.base-100a"), (0, $atWKR.glsp)(-1, -1, 1, -1), (0, $atWKR.glsp)(), (0, $atWKR.themeVal)("layout.border"), (0, $atWKR.themeVal)("color.base-100a"), (0, $atWKR.glsp)(-1), (0, $atWKR.themeVal)("layout.border"), (0, $atWKR.themeVal)("color.base-100a"), (0, $atWKR.themeVal)("shape.rounded"), (0, $atWKR.themeVal)("shape.rounded"));
var $ce10daea3dd4da28$var$_excluded = [
    "direction",
    "alignment",
    "id",
    "className",
    "onChange",
    "triggerElement",
    "children"
], $ce10daea3dd4da28$var$_excluded2 = [
    "onChange"
];
/**
 * Calculates the values for tether based on the desired alignment and direction.
 *
 * @throws Error if values are not compatible with one another.
 *
 * @param {string} direction Direction of the drop.
 * @param {string} alignment Alignment of the drop.
 */ var $ce10daea3dd4da28$export$8beb6953ff5a24c0 = function getTetherAttachments(direction, alignment) {
    var allowed;
    if (direction === "up" || direction === "down") allowed = [
        "left",
        "center",
        "right"
    ];
    else if (direction === "left" || direction === "right") allowed = [
        "top",
        "middle",
        "bottom"
    ];
    else throw new Error('Dropdown: direction "'.concat(direction, '" is not supported. Use one of: up, down, left, right'));
    if (allowed.indexOf(alignment) === -1) throw new Error('Dropdown: alignment "'.concat(alignment, '" is not supported when direction is ').concat(direction, ". Use one of: ").concat(allowed.join(", ")));
     // The attachments are returned as an array:
    // [tetherAttachment, tetherTargetAttachment]
    switch(direction){
        case "up":
            return [
                "bottom ".concat(alignment),
                "top ".concat(alignment)
            ];
        case "down":
            return [
                "top ".concat(alignment),
                "bottom ".concat(alignment)
            ];
        case "right":
            return [
                "".concat(alignment, " left"),
                "".concat(alignment, " right")
            ];
        case "left":
            return [
                "".concat(alignment, " right"),
                "".concat(alignment, " left")
            ];
    }
}; // Global variable to hold a reference to each dropdown. Needed for the close
// all function.
var $ce10daea3dd4da28$var$activeDropdowns = [];
/**
 * Returns the closes instance up the DOM tree that matches the provided
 * conditions.
 * @param {HTMLElement} el The element from which to start
 * @param {function} cb Callback to validate the element. Returning true will
 *                      indicate the element was found.
 */ var $ce10daea3dd4da28$var$getClosest = function getClosest(el, cb) {
    do {
        // If the click is released outside the view port, the el will be
        // HTMLDocument and won't have hasAttribute method.
        if (el && el.hasAttribute && cb(el)) return el;
        el = el.parentNode; // eslint-disable-line
    }while (el && el.tagName !== "BODY" && el.tagName !== "HTML");
    return null;
};
/**
 * Returns the closes element with the [data-drop-instance] attribute.
 * @param {HTMLElement} el The element from which to start
 */ var $ce10daea3dd4da28$var$getClosestInstance = function getClosestInstance(el) {
    return $ce10daea3dd4da28$var$getClosest(el, function(element) {
        return element.hasAttribute("data-drop-instance");
    });
};
/**
 * Returns the closes element inside the dropdown that is capable of closing it
 * by having the [data-dropdown="click.close"] attribute.
 * @param {HTMLElement} el The element from which to start
 */ var $ce10daea3dd4da28$var$getClosestDropCloser = function getClosestDropCloser(el) {
    return $ce10daea3dd4da28$var$getClosest(el, function(element) {
        var v = element.getAttribute("data-dropdown");
        return v === "click.close";
    });
};
var $ce10daea3dd4da28$var$useBodyListenerEffect = function useBodyListenerEffect(uuid, setOpen) {
    (0, $3RyIS.useEffect)(function() {
        // Abort in case of SSR.
        if (typeof window === "undefined") return;
        var listener = function listener(e) {
            var target = e.target; // Closer as in an element that can close the dropdown.
            var closerElement = $ce10daea3dd4da28$var$getClosestDropCloser(target);
            if (target.tagName === "BODY" || target.tagName === "HTML" || closerElement) // If we are at the top of the DOM tree or clicked an element capable of
            // closing the dropdown.
            return setOpen(false);
             // The closest instance is the closest parent element with a
            // [data-drop-instance] attribute. This attribute will have the uuid of the
            // dropdown. This element will also have a [data-drop-el] attribute which
            // will have a value of either "trigger" or "content" depending on which it
            // refers to.
            var closestInstance = $ce10daea3dd4da28$var$getClosestInstance(target);
            if (!closestInstance) return setOpen(false);
            var closestUuid = closestInstance.getAttribute("data-drop-instance");
            if (closestInstance.getAttribute("data-drop-el") === "trigger" && closestUuid === uuid) // If we're dealing with the trigger for this instance don't do anything.
            // There are other listeners in place.
            return;
            if (closestInstance.getAttribute("data-drop-el") === "content" && closestUuid === uuid) // If we're dealing with the content for this instance don't do anything.
            // The content elements can use data-dropdown='click.close' if they need to
            // close the dropdown, otherwise a trigger click is needed.
            return;
             // In all other cases close the dropdown.
            setOpen(false);
        };
        $ce10daea3dd4da28$var$activeDropdowns.push({
            uuid: uuid,
            setOpen: setOpen
        });
        window.addEventListener("click", listener, true);
        return function() {
            $ce10daea3dd4da28$var$activeDropdowns = $ce10daea3dd4da28$var$activeDropdowns.filter(function(d) {
                return d.uuid !== uuid;
            });
            window.removeEventListener("click", listener, true);
        }; // setOpen is a hook and won't change.
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        uuid
    ]);
};
var $ce10daea3dd4da28$export$931cbfb6bfb85fc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).forwardRef(function(props, ref) {
    var direction = props.direction, alignment = props.alignment, id = props.id, className = props.className, onChange = props.onChange, triggerElement = props.triggerElement, children = props.children, rest = $ce10daea3dd4da28$var$_objectWithoutProperties$1(props, $ce10daea3dd4da28$var$_excluded);
    var uuid = (0, $3RyIS.useRef)($ce10daea3dd4da28$export$931cbfb6bfb85fc.generateUUID());
    var tetherRef = (0, $3RyIS.useRef)(null);
    var _useState = (0, $3RyIS.useState)(false), _useState2 = $ce10daea3dd4da28$var$_slicedToArray(_useState, 2), isOpen = _useState2[0], setOpen = _useState2[1];
    $ce10daea3dd4da28$var$useBodyListenerEffect(uuid.current, setOpen);
    (0, $3RyIS.useImperativeHandle)(ref, function() {
        return {
            reposition: function reposition() {
                return tetherRef.current.position();
            },
            open: function open() {
                return setOpen(true);
            },
            close: function close() {
                return setOpen(false);
            }
        };
    });
    var _getTetherAttachments = $ce10daea3dd4da28$export$8beb6953ff5a24c0(direction, alignment), _getTetherAttachments2 = $ce10daea3dd4da28$var$_slicedToArray(_getTetherAttachments, 2), tetherAttachment = _getTetherAttachments2[0], tetherTargetAttachment = _getTetherAttachments2[1];
    var toggleDropdown = function toggleDropdown(e) {
        e && e.preventDefault();
        setOpen(!isOpen);
    }; // Base and additional classes for the trigger and the content.
    var klasses = [
        className,
        "drop__content",
        "drop-trans",
        "drop-trans--".concat(direction)
    ].filter(Boolean).join(" ");
    /* eslint-disable-next-line prefer-const */ var dropdownContentProps = $ce10daea3dd4da28$var$_objectSpread2({
        id: id || undefined,
        className: klasses,
        "data-drop-instance": uuid.current,
        "data-drop-el": "content",
        direction: direction,
        onChange: onChange,
        children: children
    }, rest);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($ce10daea3dd4da28$var$TetherComponent, {
        ref: tetherRef // attachment is the content.
        ,
        attachment: tetherAttachment // targetAttachment is the trigger
        ,
        targetAttachment: tetherTargetAttachment,
        constraints: [
            {
                to: "window",
                attachment: "both",
                pin: true
            }
        ],
        renderTarget: function renderTarget(ref) {
            return triggerElement({
                ref: ref,
                // Ref from thether. Must be attached.
                onClick: toggleDropdown,
                active: isOpen,
                className: isOpen ? "active" : "",
                "data-drop-el": "trigger",
                "data-drop-instance": uuid.current
            });
        },
        renderElement: function renderElement(ref) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($ce10daea3dd4da28$var$CSSTransition$1, {
                ref: ref,
                in: isOpen,
                unmountOnExit: true,
                appear: true,
                classNames: "drop-trans",
                timeout: {
                    appear: 300,
                    enter: 300,
                    exit: 300
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($ce10daea3dd4da28$var$TransitionItem, dropdownContentProps));
        }
    });
});
$ce10daea3dd4da28$export$931cbfb6bfb85fc.displayName = "Dropdown"; // Use a static method to generate a uuid so it can be mocked during tests.
$ce10daea3dd4da28$export$931cbfb6bfb85fc.generateUUID = function() {
    return Math.random().toString(36).substr(2, 5);
};
$ce10daea3dd4da28$export$931cbfb6bfb85fc.closeAll = function() {
    return $ce10daea3dd4da28$var$activeDropdowns.forEach(function(d) {
        return d.setOpen(false);
    });
};
$ce10daea3dd4da28$export$931cbfb6bfb85fc.defaultProps = {
    /* eslint-disable-next-line react/display-name */ triggerElement: function triggerElement(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement("button", $ce10daea3dd4da28$var$_extends$1({
            type: "button"
        }, props), "Dropdown");
    },
    direction: "down",
    alignment: "center"
};
$ce10daea3dd4da28$export$931cbfb6bfb85fc.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).func,
    triggerElement: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).func,
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).oneOf([
        "up",
        "down",
        "left",
        "right"
    ]),
    alignment: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).oneOf([
        "left",
        "center",
        "right",
        "top",
        "middle",
        "bottom"
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).node
}; // The TransitionItem is only used to trigger the change event on mount/unmount.
function $ce10daea3dd4da28$var$TransitionItem(props) {
    var onChange = props.onChange, rest = $ce10daea3dd4da28$var$_objectWithoutProperties$1(props, $ce10daea3dd4da28$var$_excluded2);
    (0, $3RyIS.useEffect)(function() {
        onChange && onChange(true);
        return function() {
            onChange && onChange(false);
        }; // onChange will not change in between mounts because the whole purpose of
    // TransitionItem is to be mounted/unmounted for animation.
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3RyIS))).createElement($ce10daea3dd4da28$var$DropContent, rest);
}
$ce10daea3dd4da28$var$TransitionItem.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).func,
    props: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).shape({
        direction: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string
    }),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).node
};

});

parcelRegister("dLz2s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68f4582a2f11772a$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $hGSMG = parcelRequire("hGSMG");
/**
 * Override Dropdown styles to play well with the shadow scrollbar.
 */ const $68f4582a2f11772a$var$DropdownWithScroll = (0, $6fhRl.default)((0, $hGSMG.Dropdown))`
  padding: 0;
  overflow: hidden;
  max-height: 320px;
  overscroll-behavior: none;
  overflow-y: scroll;

  ${(0, $hGSMG.DropTitle)} {
    margin: 0;
    padding: ${(0, $atWKR.glsp)(1, 1, 0, 1)};
  }

  ${(0, $hGSMG.DropMenu)} {
    margin: 0;
  }
`;
var $68f4582a2f11772a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $3RyIS.forwardRef)(function DropdownScrollable(props, ref) {
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $21sFD.jsx)($68f4582a2f11772a$var$DropdownWithScroll, {
        ref: ref,
        ...rest,
        children: children
    });
});

});

parcelRegister("cGQ3Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93d1ca7ef9af1134$export$2e2bcd8739ae039; });

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $04Xx0 = parcelRequire("04Xx0");
const $93d1ca7ef9af1134$var$GlobalMenuLinkCSS = (0, $6fhRl.css)`
  appearance: none;
  position: relative;
  display: flex;
  gap: ${(0, $atWKR.glsp)(0.25)};
  align-items: center;
  border: 0;
  background: none;
  cursor: pointer;
  color: currentColor;
  text-decoration: none;
  text-align: left;
  padding: ${(0, $04Xx0.variableGlsp)(0, 1)};
  transition: all 0.32s ease 0s;
  text-transform: ${(0, $atWKR.themeVal)("button.type.case")};
  font-weight: ${(0, $atWKR.themeVal)("button.type.weight")};

  ${(0, $atWKR.media).largeUp`
    padding: ${(0, $atWKR.glsp)(0.5, 0)};
  `}

  &:hover {
    opacity: 0.64;
  }

  > * {
    flex-shrink: 0;
  }

  /* Menu link line decoration */

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0.125rem;
    height: 0;
    background: currentColor;

    ${(0, $atWKR.media).largeUp`
      width: 0;
      height: 0.125rem;
    `}
  }

  &.active::after {
    ${(0, $atWKR.media).mediumDown`
      height: 100%;
    `}

    ${(0, $atWKR.media).largeUp`
      width: 100%;
    `}
  }
`;
var $93d1ca7ef9af1134$export$2e2bcd8739ae039 = $93d1ca7ef9af1134$var$GlobalMenuLinkCSS;

});

parcelRegister("6vRkW", function(module, exports) {

$parcel$export(module.exports, "useMediaQuery", function () { return $2c65e663b68a2c05$export$32d5543ab307c01; });

var $3RyIS = parcelRequire("3RyIS");

var $6fhRl = parcelRequire("6fhRl");

var $9p4xI = parcelRequire("9p4xI");

var $1VhEK = parcelRequire("1VhEK");
function $2c65e663b68a2c05$export$32d5543ab307c01() {
    const theme = (0, $6fhRl.useTheme)();
    if (!theme.mediaRanges) throw new Error("There are no media ranges defined in the theme");
    const ranges = Object.entries(theme.mediaRanges);
    // Create breakpoints from media ranges.
    const breakpoints = (0, $3RyIS.useMemo)(()=>ranges.reduce((acc, [breakpoint, [lowerBound]])=>({
                ...acc,
                [breakpoint]: lowerBound ?? 0
            }), {}), [
        ranges
    ]);
    const { observe: observe, currentBreakpoint: currentBreakpoint, width: calculatedWidth } = (0, $9p4xI.default)({
        breakpoints: breakpoints,
        updateOnBreakpointChange: true
    });
    (0, $3RyIS.useEffect)(()=>{
        observe(document.body);
    }, [
        observe
    ]);
    // Account for the scrollbar width because the css media queries will.
    const scrollbarWidth = (0, $1VhEK.getScrollbarWidth)();
    // On first mount react-cool-dimension will return a width of 0, which breaks
    // the media queries styles because there's a mismatch between the css media
    // queries and the js.
    const width = calculatedWidth + scrollbarWidth || (typeof window !== "undefined" ? window.innerWidth + scrollbarWidth : 0);
    const rangeBooleans = (0, $3RyIS.useMemo)(()=>ranges.reduce((acc, [rangeKey, bounds])=>{
            const upper = `${rangeKey.charAt(0).toUpperCase()}${rangeKey.slice(1)}`;
            const makeKey = (b)=>`is${upper}${b}`;
            let [lBound, uBound] = bounds;
            lBound = lBound ?? -Infinity;
            uBound = uBound ?? Infinity;
            return {
                ...acc,
                [makeKey("Up")]: width >= lBound,
                [makeKey("Only")]: width >= lBound && width <= uBound,
                [makeKey("Down")]: width <= uBound
            };
        }, {}), [
        ranges,
        width
    ]);
    return (0, $3RyIS.useMemo)(()=>({
            current: currentBreakpoint,
            ...rangeBooleans
        }), [
        currentBreakpoint,
        rangeBooleans
    ]);
}

});
parcelRegister("9p4xI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d89f8f9d4330a6e$export$2e2bcd8739ae039; });

var $3RyIS = parcelRequire("3RyIS");
function $6d89f8f9d4330a6e$var$_extends() {
    $6d89f8f9d4330a6e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6d89f8f9d4330a6e$var$_extends.apply(this, arguments);
}
var $6d89f8f9d4330a6e$var$useLatest = function(val) {
    var ref = (0, $3RyIS.useRef)(val);
    ref.current = val;
    return ref;
};
var $6d89f8f9d4330a6e$export$c62515649e5f5409 = "\uD83D\uDCA1 react-cool-dimensions: the browser doesn't support Resize Observer, please use polyfill: https://github.com/wellyshen/react-cool-dimensions#resizeobserver-polyfill";
var $6d89f8f9d4330a6e$export$ec85bcb9e60e4d6a = "\uD83D\uDCA1 react-cool-dimensions: the browser doesn't support border-box size, fallback to content-box size. Please see: https://github.com/wellyshen/react-cool-dimensions#border-box-size-measurement";
var $6d89f8f9d4330a6e$var$getCurrentBreakpoint = function getCurrentBreakpoint(bps, w) {
    var curBp = "";
    var max = -1;
    Object.keys(bps).forEach(function(key) {
        var val = bps[key];
        if (w >= val && val > max) {
            curBp = key;
            max = val;
        }
    });
    return curBp;
};
var $6d89f8f9d4330a6e$var$useDimensions = function useDimensions(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, useBorderBoxSize = _ref.useBorderBoxSize, breakpoints = _ref.breakpoints, updateOnBreakpointChange = _ref.updateOnBreakpointChange, shouldUpdate = _ref.shouldUpdate, onResize = _ref.onResize, polyfill = _ref.polyfill;
    var _useState = (0, $3RyIS.useState)({
        currentBreakpoint: "",
        width: 0,
        height: 0
    }), state = _useState[0], setState = _useState[1];
    var prevSizeRef = (0, $3RyIS.useRef)({});
    var prevBreakpointRef = (0, $3RyIS.useRef)();
    var observerRef = (0, $3RyIS.useRef)();
    var warnedRef = (0, $3RyIS.useRef)(false);
    var ref = (0, $3RyIS.useRef)();
    var onResizeRef = $6d89f8f9d4330a6e$var$useLatest(onResize);
    var shouldUpdateRef = $6d89f8f9d4330a6e$var$useLatest(shouldUpdate);
    var unobserve = (0, $3RyIS.useCallback)(function() {
        if (observerRef.current) observerRef.current.disconnect();
    }, []);
    var observe = (0, $3RyIS.useCallback)(function(element) {
        if (element && element !== ref.current) {
            unobserve();
            ref.current = element;
        }
        if (observerRef.current && ref.current) observerRef.current.observe(ref.current);
    }, [
        unobserve
    ]);
    (0, $3RyIS.useEffect)(function() {
        if ((!("ResizeObserver" in window) || !("ResizeObserverEntry" in window)) && !polyfill) {
            console.error($6d89f8f9d4330a6e$export$c62515649e5f5409);
            return function() {
                return null;
            };
        }
        var raf = null; // eslint-disable-next-line compat/compat
        observerRef.current = new (polyfill || ResizeObserver)(function(_ref2) {
            var entry = _ref2[0];
            raf = requestAnimationFrame(function() {
                var contentBoxSize = entry.contentBoxSize, borderBoxSize = entry.borderBoxSize, contentRect = entry.contentRect;
                var boxSize = contentBoxSize;
                if (useBorderBoxSize) {
                    if (borderBoxSize) boxSize = borderBoxSize;
                    else if (!warnedRef.current) {
                        console.warn($6d89f8f9d4330a6e$export$ec85bcb9e60e4d6a);
                        warnedRef.current = true;
                    } // @juggle/resize-observer polyfill has different data structure
                }
                boxSize = Array.isArray(boxSize) ? boxSize[0] : boxSize;
                var width = boxSize ? boxSize.inlineSize : contentRect.width;
                var height = boxSize ? boxSize.blockSize : contentRect.height;
                if (width === prevSizeRef.current.width && height === prevSizeRef.current.height) return;
                prevSizeRef.current = {
                    width: width,
                    height: height
                };
                var e = {
                    currentBreakpoint: "",
                    width: width,
                    height: height,
                    entry: entry,
                    observe: observe,
                    unobserve: unobserve
                };
                if (breakpoints) {
                    e.currentBreakpoint = $6d89f8f9d4330a6e$var$getCurrentBreakpoint(breakpoints, width);
                    if (e.currentBreakpoint !== prevBreakpointRef.current) {
                        if (onResizeRef.current) onResizeRef.current(e);
                        prevBreakpointRef.current = e.currentBreakpoint;
                    }
                } else if (onResizeRef.current) onResizeRef.current(e);
                var next = {
                    currentBreakpoint: e.currentBreakpoint,
                    width: width,
                    height: height,
                    entry: entry
                };
                if (shouldUpdateRef.current && !shouldUpdateRef.current(next)) return;
                if (!shouldUpdateRef.current && breakpoints && updateOnBreakpointChange) {
                    setState(function(prev) {
                        return prev.currentBreakpoint !== next.currentBreakpoint ? next : prev;
                    });
                    return;
                }
                setState(next);
            });
        });
        observe();
        return function() {
            unobserve();
            if (raf) cancelAnimationFrame(raf);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(breakpoints),
        useBorderBoxSize,
        observe,
        unobserve,
        updateOnBreakpointChange
    ]);
    return $6d89f8f9d4330a6e$var$_extends({}, state, {
        observe: observe,
        unobserve: unobserve
    });
};
var $6d89f8f9d4330a6e$export$2e2bcd8739ae039 = $6d89f8f9d4330a6e$var$useDimensions;

});

parcelRegister("1VhEK", function(module, exports) {

$parcel$export(module.exports, "getScrollbarWidth", function () { return $781eeb6952bab9de$export$ace028f8da1a6300; });
$parcel$export(module.exports, "useScrollbarWidthAsCssVar", function () { return $781eeb6952bab9de$export$b9a207ff02cf03ea; });

var $3RyIS = parcelRequire("3RyIS");
let $781eeb6952bab9de$var$scrollbarWidthCache;
function $781eeb6952bab9de$export$ace028f8da1a6300() {
    if ($781eeb6952bab9de$var$scrollbarWidthCache !== undefined) return $781eeb6952bab9de$var$scrollbarWidthCache;
    const el = document.createElement("div");
    el.style.cssText = "overflow:scroll; visibility:hidden; position:absolute;";
    document.body.appendChild(el);
    const width = el.offsetWidth - el.clientWidth;
    el.remove();
    $781eeb6952bab9de$var$scrollbarWidthCache = width;
    return width;
}
function $781eeb6952bab9de$export$b9a207ff02cf03ea(varName = "--scrollbar-width") {
    (0, $3RyIS.useEffect)(()=>{
        const width = $781eeb6952bab9de$export$ace028f8da1a6300();
        document.documentElement.style.setProperty(varName, width + "px");
        return ()=>{
            document.documentElement.style.removeProperty(varName);
        };
    }, [
        varName
    ]);
}

});




parcelRegister("9Puxc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b871342b60c89757$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");

var $rmfBT = parcelRequire("rmfBT");

var $46TJE = parcelRequire("46TJE");

var $fQhPJ = parcelRequire("fQhPJ");
parcelRequire("hiK0Y");
var $cpaZD = parcelRequire("cpaZD");
var $4KRzF = parcelRequire("4KRzF");
var $jgkOA = parcelRequire("jgkOA");
function $b871342b60c89757$export$2e2bcd8739ae039({ mainNavItems: mainNavItems, subNavItems: subNavItems, logoSvg: Logo, title: title, version: version, accessibilityHomeShortCutText: accessibilityHomeShortCutText }) {
    const [expanded, setExpanded] = (0, $3RyIS.useState)(false);
    (0, $46TJE.default)(expanded, setExpanded);
    const [isOpen, setIsOpen] = (0, $3RyIS.useState)(mainNavItems.map(()=>false));
    const toggleExpansion = (0, $3RyIS.useCallback)(()=>{
        setExpanded((prvExpanded)=>{
            return !prvExpanded;
        });
    }, []);
    const primaryItems = (0, $3RyIS.useMemo)(()=>(0, $fQhPJ.createDynamicNavMenuList)({
            navItems: mainNavItems,
            dropdownIsOpen: isOpen,
            dropdownSetIsOpen: setIsOpen
        }), [
        mainNavItems,
        isOpen
    ]);
    const secondaryItems = (0, $3RyIS.useMemo)(()=>(0, $fQhPJ.createDynamicNavMenuList)({
            navItems: subNavItems
        }), [
        subNavItems
    ]);
    const skipNav = (e)=>{
        e.preventDefault();
        const pageBody = document.getElementById("pagebody");
        if (pageBody) pageBody.focus();
    };
    return /*#__PURE__*/ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
        children: [
            /*#__PURE__*/ (0, $21sFD.jsx)("button", {
                type: "button",
                className: "usa-skipnav",
                onClick: skipNav,
                children: accessibilityHomeShortCutText || "Skip to main content"
            }),
            /*#__PURE__*/ (0, $21sFD.jsxs)((0, $4KRzF.USWDSHeader), {
                extended: true,
                showMobileOverlay: expanded,
                children: [
                    /*#__PURE__*/ (0, $21sFD.jsxs)("div", {
                        className: "usa-navbar",
                        children: [
                            /*#__PURE__*/ (0, $21sFD.jsx)((0, $4KRzF.USWDSHeaderTitle), {
                                children: /*#__PURE__*/ (0, $21sFD.jsx)((0, $rmfBT.default), {
                                    LogoSvg: Logo,
                                    title: title,
                                    version: version,
                                    className: "mobile-lg:display-block display-none"
                                })
                            }),
                            /*#__PURE__*/ (0, $21sFD.jsx)((0, $jgkOA.USWDSNavMenuButton), {
                                onClick: toggleExpansion,
                                label: "Menu"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)((0, $cpaZD.USWDSExtendedNav), {
                        primaryItems: primaryItems,
                        secondaryItems: secondaryItems,
                        mobileExpanded: expanded,
                        onToggleMobileNav: toggleExpansion
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("rmfBT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b87728f05589c702$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $johEW = parcelRequire("johEW");


var $6SviU = parcelRequire("6SviU");
function $b87728f05589c702$export$2e2bcd8739ae039({ LogoSvg: LogoSvg, title: title, version: version, className: className }) {
    const { navigation: { LinkComponent: LinkComponent, linkProps: linkProps } } = (0, $6SviU.useVedaUI)();
    return /*#__PURE__*/ (0, $21sFD.jsxs)("div", {
        id: "logo-container",
        children: [
            /*#__PURE__*/ (0, $21sFD.jsxs)(LinkComponent, {
                id: "logo-container-link",
                [linkProps.pathAttributeKeyName]: "/",
                children: [
                    /*#__PURE__*/ (0, $21sFD.jsx)("span", {
                        className: className,
                        children: LogoSvg
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("span", {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $21sFD.jsx)((0, $johEW.Tip), {
                content: version ? `v${version}` : "beta version",
                children: /*#__PURE__*/ (0, $21sFD.jsx)("div", {
                    id: "logo-container-beta-tag",
                    className: "display-none mobile-lg:display-block",
                    as: LinkComponent,
                    [linkProps.pathAttributeKeyName]: "/development",
                    children: version || "BETA"
                })
            })
        ]
    });
}

});

parcelRegister("46TJE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $378f57ecaaee0d46$export$2e2bcd8739ae039; });

var $3RyIS = parcelRequire("3RyIS");
/**
 * Would be better to have this fixed on the react-uswds side!
 *
 * Subscribe to https://github.com/trussworks/react-uswds/issues/2586
 * for updates
 * */ const $378f57ecaaee0d46$var$USWDS_DESKTOP_BREAKPOINT = 1024;
// no magic numbers! Use value from theme?
function $378f57ecaaee0d46$var$useMobileMenuFix(expanded, setExpanded) {
    const handleClickOutside = (event)=>{
        // When the mobile nav is active, clicking outside of the nav should close it
        if (event.target instanceof Element && event.target.closest(".usa-overlay")) setExpanded(false);
    };
    const handleResize = ()=>{
        if (window.innerWidth > $378f57ecaaee0d46$var$USWDS_DESKTOP_BREAKPOINT && expanded) setExpanded(false);
    };
    (0, $3RyIS.useEffect)(()=>{
        document.addEventListener("click", handleClickOutside);
        window.addEventListener("resize", handleResize);
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
            window.removeEventListener("resize", handleResize);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expanded
    ]); // We want to register the event listeners only once, when the component mounts, and when the expanded state changes
}
var $378f57ecaaee0d46$export$2e2bcd8739ae039 = $378f57ecaaee0d46$var$useMobileMenuFix;

});


parcelRegister("e7LLc", function(module, exports) {

$parcel$export(module.exports, "useSlidingStickyHeaderProps", function () { return $58812bd2787f552d$export$49f3e3e2ff0262a4; });

var $3RyIS = parcelRequire("3RyIS");

var $iCOkj = parcelRequire("iCOkj");
function $58812bd2787f552d$export$49f3e3e2ff0262a4() {
    const { isHeaderHidden: isHeaderHidden, headerHeight: headerHeight, wrapperHeight: wrapperHeight } = (0, $3RyIS.useContext)((0, $iCOkj.LayoutRootContext));
    return {
        isHeaderHidden: isHeaderHidden,
        headerHeight: headerHeight,
        wrapperHeight: wrapperHeight
    };
}

});


parcelRegister("6fOze", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9772e3712e4a7d97$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $9o9iM = parcelRequire("9o9iM");

var $johEW = parcelRequire("johEW");

var $gOQ9k = parcelRequire("gOQ9k");
// @DEPRECATED: This component is deprecated and will be removed in the future.
const $9772e3712e4a7d97$var$appTitle = "U.S. Greenhouse Gas Center";
const $9772e3712e4a7d97$var$appVersion = "3.1.25";
const $9772e3712e4a7d97$export$75d5b518c51e7fd6 = (0, $6fhRl.default).div`
  display: flex;
  flex-shrink: 0;

  a {
    display: grid;
    align-items: center;
    gap: ${(0, $atWKR.glsp)(0, 0.5)};

    &,
    &:visited {
      color: inherit;
      text-decoration: none;
    }

    #nasa-logo-neg-mono {
      opacity: 1;
      transition: all 0.32s ease 0s;
    }

    #nasa-logo-pos {
      opacity: 0;
      transform: translate(0, -100%);
      transition: all 0.32s ease 0s;
    }

    &:hover {
      opacity: 1;

      #nasa-logo-neg-mono {
        opacity: 0;
      }

      #nasa-logo-pos {
        opacity: 1;
      }
    }

    svg {
      grid-row: 1 / span 2;
      height: 2.5rem;
      width: auto;

      ${(0, $atWKR.media).largeUp`
        transform: scale(1.125);
      `}
    }

    span:first-of-type {
      font-size: 0.875rem;
      line-height: 1rem;
      font-weight: ${(0, $atWKR.themeVal)("type.base.extrabold")};
      text-transform: uppercase;
    }

    span:last-of-type {
      grid-row: 2;
      font-size: 1.25rem;
      line-height: 1.5rem;
      font-weight: ${(0, $atWKR.themeVal)("type.base.regular")};
      letter-spacing: -0.025em;
    }
  }
`;
const $9772e3712e4a7d97$export$5692ae4df5f5c3d9 = (0, $6fhRl.default).a`
  align-self: end;
  font-size: 0.75rem;
  font-weight: ${(0, $atWKR.themeVal)("type.base.bold")};
  line-height: 1rem;
  text-transform: uppercase;
  background: ${(0, $atWKR.themeVal)("color.surface")};
  padding: ${(0, $atWKR.glsp)(0, 0.25)};
  border-radius: ${(0, $atWKR.themeVal)("shape.rounded")};
  margin: ${(0, $atWKR.glsp)(0.125, 0.5)};

  &&,
  &&:visited {
    color: ${(0, $atWKR.themeVal)("color.primary")};
  }

  ${(0, $atWKR.media).largeUp`
    margin: ${(0, $atWKR.glsp)(0, 0.5)};
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding: 0 ${(0, $atWKR.glsp)(0.5)};
  `}
`;
function $9772e3712e4a7d97$export$2e2bcd8739ae039({ linkProperties: linkProperties }) {
    const LinkElement = linkProperties.LinkElement;
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $gOQ9k.ComponentOverride), {
        with: "headerBrand",
        children: /*#__PURE__*/ (0, $21sFD.jsxs)($9772e3712e4a7d97$export$75d5b518c51e7fd6, {
            children: [
                /*#__PURE__*/ (0, $21sFD.jsxs)(LinkElement, {
                    [linkProperties.pathAttributeKeyName]: "/",
                    children: [
                        /*#__PURE__*/ (0, $21sFD.jsx)((0, $9o9iM.default), {}),
                        /*#__PURE__*/ (0, $21sFD.jsx)("span", {
                            children: "Earthdata"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $21sFD.jsx)("span", {
                            children: $9772e3712e4a7d97$var$appTitle
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $21sFD.jsx)((0, $johEW.Tip), {
                    content: `v${$9772e3712e4a7d97$var$appVersion}`,
                    children: /*#__PURE__*/ (0, $21sFD.jsx)($9772e3712e4a7d97$export$5692ae4df5f5c3d9, {
                        as: linkProperties.LinkElement,
                        [linkProperties.pathAttributeKeyName]: "/development",
                        children: "Beta"
                    })
                })
            ]
        })
    });
}

});
parcelRegister("9o9iM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d5d921913153053$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");
function $6d5d921913153053$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $21sFD.jsxs)("svg", {
        width: 312,
        height: 258,
        viewBox: "0 0 312 258",
        style: {
            fillRule: "evenodd",
            clipRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: 2
        },
        children: [
            /*#__PURE__*/ (0, $21sFD.jsx)("title", {
                children: "NASA"
            }),
            /*#__PURE__*/ (0, $21sFD.jsxs)("g", {
                id: "nasa-logo-pos",
                children: [
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M273.427,387C273.427,457.761 215.188,516 144.427,516C73.665,516 15.427,457.761 15.427,387C15.427,316.239 73.665,258 144.427,258C215.188,258 273.427,316.239 273.427,387Z",
                        style: {
                            fill: "rgb(0,102,179)",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M146.205,269.721C146.205,270.297 145.731,270.771 145.154,270.771C144.578,270.771 144.104,270.297 144.104,269.721C144.104,269.145 144.578,268.67 145.154,268.67C145.731,268.67 146.205,269.145 146.205,269.721Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M153.48,285.643C153.48,286.353 152.896,286.936 152.187,286.936C151.477,286.936 150.893,286.353 150.893,285.643C150.893,284.934 151.477,284.35 152.187,284.35C152.896,284.35 153.48,284.934 153.48,285.643Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M172.393,311.67C172.393,312.379 171.81,312.963 171.1,312.963C170.39,312.963 169.807,312.379 169.807,311.67C169.807,310.959 170.39,310.376 171.1,310.376C171.81,310.376 172.393,310.959 172.393,311.67Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M142.002,294.615C142.002,295.191 141.528,295.666 140.951,295.666C140.375,295.666 139.901,295.191 139.901,294.615C139.901,294.039 140.375,293.564 140.951,293.564C141.528,293.564 142.002,294.039 142.002,294.615Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M153.318,300.596C153.318,301.172 152.843,301.647 152.267,301.647C151.691,301.647 151.217,301.172 151.217,300.596C151.217,300.02 151.691,299.545 152.267,299.545C152.843,299.545 153.318,300.02 153.318,300.596Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M138.607,283.865C138.607,284.574 138.023,285.158 137.314,285.158C136.604,285.158 136.021,284.574 136.021,283.865C136.021,283.156 136.604,282.572 137.314,282.572C138.023,282.572 138.607,283.156 138.607,283.865Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M121.472,294.292C121.472,294.869 120.998,295.343 120.422,295.343C119.845,295.343 119.371,294.869 119.371,294.292C119.371,293.716 119.845,293.241 120.422,293.241C120.998,293.241 121.472,293.716 121.472,294.292Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M124.544,296.394C124.544,296.97 124.069,297.444 123.493,297.444C122.917,297.444 122.442,296.97 122.442,296.394C122.442,295.817 122.917,295.343 123.493,295.343C124.069,295.343 124.544,295.817 124.544,296.394Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M127.615,298.495C127.615,299.071 127.14,299.545 126.564,299.545C125.987,299.545 125.513,299.071 125.513,298.495C125.513,297.918 125.987,297.444 126.564,297.444C127.14,297.444 127.615,297.918 127.615,298.495Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M122.927,302.536C122.927,303.112 122.453,303.587 121.877,303.587C121.3,303.587 120.826,303.112 120.826,302.536C120.826,301.959 121.3,301.485 121.877,301.485C122.453,301.485 122.927,301.959 122.927,302.536Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M98.517,319.671C98.517,320.248 98.043,320.722 97.466,320.722C96.89,320.722 96.415,320.248 96.415,319.671C96.415,319.095 96.89,318.621 97.466,318.621C98.043,318.621 98.517,319.095 98.517,319.671Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M103.044,325.168C103.044,325.744 102.569,326.218 101.993,326.218C101.417,326.218 100.942,325.744 100.942,325.168C100.942,324.591 101.417,324.117 101.993,324.117C102.569,324.117 103.044,324.591 103.044,325.168Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M99.487,413.915C99.487,414.491 99.012,414.966 98.436,414.966C97.86,414.966 97.385,414.491 97.385,413.915C97.385,413.339 97.86,412.864 98.436,412.864C99.012,412.864 99.487,413.339 99.487,413.915Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M100.134,438.404C100.134,439.115 99.549,439.699 98.84,439.699C98.131,439.699 97.547,439.115 97.547,438.404C97.547,437.696 98.131,437.113 98.84,437.113C99.549,437.113 100.134,437.696 100.134,438.404Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M86.231,450.935C86.231,451.511 85.756,451.986 85.18,451.986C84.604,451.986 84.13,451.511 84.13,450.935C84.13,450.357 84.604,449.884 85.18,449.884C85.756,449.884 86.231,450.357 86.231,450.935Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M69.58,456.027C69.58,456.736 68.996,457.32 68.287,457.32C67.578,457.32 66.994,456.736 66.994,456.027C66.994,455.316 67.578,454.732 68.287,454.732C68.996,454.732 69.58,455.316 69.58,456.027Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M66.186,444.71C66.186,445.419 65.602,446.003 64.893,446.003C64.183,446.003 63.599,445.419 63.599,444.71C63.599,444.001 64.183,443.417 64.893,443.417C65.602,443.417 66.186,444.001 66.186,444.71Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M64.246,451.904C64.246,452.48 63.772,452.954 63.195,452.954C62.619,452.954 62.145,452.48 62.145,451.904C62.145,451.327 62.619,450.853 63.195,450.853C63.772,450.853 64.246,451.327 64.246,451.904Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M51.798,445.923C51.798,446.499 51.324,446.974 50.747,446.974C50.171,446.974 49.697,446.499 49.697,445.923C49.697,445.347 50.171,444.872 50.747,444.872C51.324,444.872 51.798,445.347 51.798,445.923Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M95.283,466.129C95.283,466.705 94.809,467.18 94.233,467.18C93.656,467.18 93.182,466.705 93.182,466.129C93.182,465.553 93.656,465.078 94.233,465.078C94.809,465.078 95.283,465.553 95.283,466.129Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M108.378,456.511C108.378,457.22 107.794,457.804 107.085,457.804C106.376,457.804 105.792,457.22 105.792,456.511C105.792,455.802 106.376,455.218 107.085,455.218C107.794,455.218 108.378,455.802 108.378,456.511Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M109.833,468.877C109.833,469.453 109.359,469.928 108.782,469.928C108.206,469.928 107.731,469.453 107.731,468.877C107.731,468.301 108.206,467.828 108.782,467.828C109.359,467.828 109.833,468.301 109.833,468.877Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M163.664,457.077C163.664,457.654 163.19,458.128 162.613,458.128C162.037,458.128 161.563,457.654 161.563,457.077C161.563,456.499 162.037,456.027 162.613,456.027C163.19,456.027 163.664,456.499 163.664,457.077Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M138.607,465.967C138.607,466.545 138.132,467.018 137.556,467.018C136.98,467.018 136.506,466.545 136.506,465.967C136.506,465.391 136.98,464.918 137.556,464.918C138.132,464.918 138.607,465.391 138.607,465.967Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M206.017,478.739C206.017,479.315 205.543,479.789 204.966,479.789C204.39,479.789 203.915,479.315 203.915,478.739C203.915,478.162 204.39,477.688 204.966,477.688C205.543,477.688 206.017,478.162 206.017,478.739Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M211.513,429.029C211.513,429.738 210.929,430.322 210.22,430.322C209.511,430.322 208.927,429.738 208.927,429.029C208.927,428.321 209.511,427.737 210.22,427.737C210.929,427.737 211.513,428.321 211.513,429.029Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M201.167,436.061C201.167,436.639 200.693,437.113 200.116,437.113C199.54,437.113 199.066,436.639 199.066,436.061C199.066,435.487 199.54,435.012 200.116,435.012C200.693,435.012 201.167,435.487 201.167,436.061Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M211.352,438.082C211.352,438.791 210.768,439.375 210.059,439.375C209.35,439.375 208.766,438.791 208.766,438.082C208.766,437.373 209.35,436.789 210.059,436.789C210.768,436.789 211.352,437.373 211.352,438.082Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M201.167,450.611C201.167,451.187 200.693,451.661 200.116,451.661C199.54,451.661 199.066,451.187 199.066,450.611C199.066,450.034 199.54,449.56 200.116,449.56C200.693,449.56 201.167,450.034 201.167,450.611Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M227.517,421.998C227.517,422.574 227.043,423.049 226.467,423.049C225.889,423.049 225.414,422.574 225.414,421.998C225.414,421.422 225.889,420.947 226.467,420.947C227.043,420.947 227.517,421.422 227.517,421.998Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M230.104,428.383C230.104,429.094 229.52,429.676 228.811,429.676C228.101,429.676 227.517,429.094 227.517,428.383C227.517,427.674 228.101,427.09 228.811,427.09C229.52,427.09 230.104,427.674 230.104,428.383Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M248.209,435.981C248.209,436.69 247.625,437.274 246.915,437.274C246.205,437.274 245.621,436.69 245.621,435.981C245.621,435.272 246.205,434.688 246.915,434.688C247.625,434.688 248.209,435.272 248.209,435.981Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M229.781,449.48C229.781,450.056 229.306,450.53 228.73,450.53C228.154,450.53 227.679,450.056 227.679,449.48C227.679,448.904 228.154,448.429 228.73,448.429C229.306,448.429 229.781,448.904 229.781,449.48Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M241.419,438.487C241.419,439.063 240.945,439.537 240.368,439.537C239.792,439.537 239.318,439.063 239.318,438.487C239.318,437.91 239.792,437.436 240.368,437.436C240.945,437.436 241.419,437.91 241.419,438.487Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M239.318,455.46C239.318,456.036 238.843,456.511 238.267,456.511C237.691,456.511 237.216,456.036 237.216,455.46C237.216,454.884 237.691,454.409 238.267,454.409C238.843,454.409 239.318,454.884 239.318,455.46Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M168.848,282.647C169.026,281.99 169.558,281.478 170.227,281.329L170.594,278.562L171.137,281.355C171.785,281.54 172.287,282.07 172.434,282.733L175.235,283.13L172.408,283.628C172.23,284.267 171.717,284.765 171.07,284.923L170.594,287.77L170.114,284.902C169.485,284.72 168.993,284.21 168.837,283.569L166.135,283.13L168.848,282.647Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M96.37,480.946C96.548,480.289 97.081,479.776 97.749,479.627L98.117,476.862L98.661,479.655C99.308,479.838 99.811,480.367 99.956,481.031L102.758,481.428L99.931,481.926C99.753,482.565 99.239,483.063 98.592,483.221L98.117,486.07L97.637,483.201C97.007,483.018 96.516,482.508 96.359,481.867L93.657,481.428L96.37,480.946Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M229.659,455.38C229.837,454.722 230.368,454.21 231.037,454.062L231.405,451.294L231.949,454.087C232.596,454.271 233.099,454.802 233.244,455.466L236.045,455.863L233.219,456.361C233.04,456.999 232.528,457.497 231.88,457.655L231.405,460.503L230.925,457.634C230.295,457.452 229.805,456.941 229.648,456.302L226.947,455.863L229.659,455.38Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M240.211,426.869C240.388,426.211 240.92,425.699 241.588,425.551L241.956,422.783L242.5,425.576C243.148,425.762 243.651,426.291 243.796,426.955L246.597,427.352L243.771,427.85C243.592,428.488 243.079,428.987 242.433,429.145L241.956,431.992L241.477,429.123C240.847,428.942 240.357,428.432 240.2,427.791L237.497,427.352L240.211,426.869Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M109.303,321.556C109.481,320.898 110.013,320.387 110.681,320.237L111.049,317.471L111.593,320.264C112.241,320.448 112.743,320.978 112.889,321.642L115.69,322.039L112.863,322.536C112.685,323.175 112.172,323.674 111.525,323.832L111.049,326.679L110.569,323.811C109.94,323.628 109.449,323.118 109.293,322.478L106.59,322.039L109.303,321.556Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M100.756,381.578C110.286,398.228 121.393,410.411 130.341,421.988C138.283,432.264 153.757,437.408 148.307,442.286C142.164,447.782 127.292,423.533 127.292,423.533C117.408,411.614 107.949,398.97 98.299,382.433L100.756,381.578Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M0,425.268C46.046,395.026 126.409,375.502 192.597,349.225C242.884,329.26 287.601,304.198 311.639,269.689C250.721,393.777 81.066,379.089 3.312,426.424L0,425.268Z",
                        style: {
                            fill: "rgb(237,28,36)",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M107.05,363.738L130.11,363.738L146.644,405.374L152.155,410.905L122.134,410.905L127.645,405.374L125.687,400.294L109.117,400.294L107.413,406.103L111.365,410.905L95.701,410.905L101.213,405.374L111.837,368.554L107.05,363.738ZM122.751,393.004L116.078,376.098L111.184,393.004L122.751,393.004Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M214.184,363.738L238.118,363.738L254.653,405.374L260.164,410.905L230.143,410.905L235.654,405.374L233.696,400.294L217.125,400.294L215.421,406.103L219.373,410.905L203.71,410.905L209.222,405.374L219.845,368.554L214.184,363.738ZM230.759,393.004L224.087,376.098L219.192,393.004L230.759,393.004Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M75.758,393.113L75.758,368.554L70.972,363.738L86.925,363.738L82.14,368.554L82.14,405.374L87.651,410.905L66.693,410.905L48.637,380.361L48.637,405.374L53.277,410.905L36.6,410.905L42.111,405.374L42.111,368.554L37.325,363.738L58.21,363.738L75.758,393.113Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M196.553,375.835L196.063,361.15L191.12,364.562C184.156,362.127 176.051,362.219 170.364,364.91C165.071,367.415 159.36,372.704 160.055,380.22C160.752,387.736 166.577,390.645 171.826,393.024C178.582,396.086 185.936,397.121 185.827,401.167C185.757,403.741 181.485,405.587 178.165,405.482C175.135,405.386 165.28,404.646 160.125,398.523L161.101,413.97L166.604,409.935C173.289,412.3 181.392,413.292 188.889,410.847C196.341,408.419 204.174,402.183 199.827,391.285C197.956,386.596 192.804,383.705 189.731,382.447C186.917,381.295 178.333,377.92 175.936,376.671C173.136,375.212 173.448,370.582 180.185,369.642C186.288,368.791 194.742,373.678 196.553,375.835Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M35.658,497.677C128.131,403.298 265.971,359.693 311.639,269.689C284.138,357.193 136.85,405.454 35.408,502.115L35.658,497.677Z",
                        style: {
                            fill: "rgb(237,28,36)",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M98.299,382.433C97.216,380.577 96.131,378.672 95.042,376.714C70.388,332.361 73.944,287.098 118.563,306.82C156.431,323.559 192.6,370.511 207.146,403.857C213.887,419.307 231.96,479.946 173.764,455.374L173.65,455.019C228.613,477.651 219.111,420.301 189.691,376.331C173.042,351.45 151.331,330.725 137.637,320.722C92.05,287.421 64.246,307.79 96.253,373.097C97.702,376.053 99.208,378.875 100.756,381.578L98.299,382.433Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $21sFD.jsxs)("g", {
                id: "nasa-logo-neg-mono",
                children: [
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M273.427,129.05C273.427,199.811 215.188,258.05 144.427,258.05C73.665,258.05 15.427,199.811 15.427,129.05C15.427,58.289 73.665,0.05 144.427,0.05C215.188,0.05 273.427,58.289 273.427,129.05ZM263.427,129.05C263.427,194.326 209.703,248.05 144.427,248.05C79.151,248.05 25.427,194.326 25.427,129.05C25.427,63.774 79.151,10.05 144.427,10.05C209.703,10.05 263.427,63.774 263.427,129.05Z",
                        style: {
                            fill: "white"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M146.205,11.771C146.205,12.347 145.731,12.821 145.154,12.821C144.578,12.821 144.104,12.347 144.104,11.771C144.104,11.195 144.578,10.719 145.154,10.719C145.731,10.719 146.205,11.195 146.205,11.771Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M153.48,27.693C153.48,28.403 152.896,28.986 152.187,28.986C151.477,28.986 150.893,28.403 150.893,27.693C150.893,26.984 151.477,26.4 152.187,26.4C152.896,26.4 153.48,26.984 153.48,27.693Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M172.393,53.719C172.393,54.429 171.81,55.013 171.1,55.013C170.39,55.013 169.807,54.429 169.807,53.719C169.807,53.009 170.39,52.426 171.1,52.426C171.81,52.426 172.393,53.009 172.393,53.719Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M142.002,36.665C142.002,37.241 141.528,37.716 140.951,37.716C140.375,37.716 139.901,37.241 139.901,36.665C139.901,36.089 140.375,35.614 140.951,35.614C141.528,35.614 142.002,36.089 142.002,36.665Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M153.318,42.646C153.318,43.222 152.843,43.697 152.267,43.697C151.691,43.697 151.217,43.222 151.217,42.646C151.217,42.07 151.691,41.595 152.267,41.595C152.843,41.595 153.318,42.07 153.318,42.646Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M138.607,25.915C138.607,26.624 138.023,27.208 137.314,27.208C136.604,27.208 136.021,26.624 136.021,25.915C136.021,25.206 136.604,24.622 137.314,24.622C138.023,24.622 138.607,25.206 138.607,25.915Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M121.472,36.342C121.472,36.919 120.998,37.393 120.422,37.393C119.845,37.393 119.371,36.919 119.371,36.342C119.371,35.766 119.845,35.291 120.422,35.291C120.998,35.291 121.472,35.766 121.472,36.342Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M124.544,38.444C124.544,39.02 124.069,39.494 123.493,39.494C122.917,39.494 122.442,39.02 122.442,38.444C122.442,37.867 122.917,37.393 123.493,37.393C124.069,37.393 124.544,37.867 124.544,38.444Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M127.615,40.545C127.615,41.121 127.14,41.595 126.564,41.595C125.987,41.595 125.513,41.121 125.513,40.545C125.513,39.968 125.987,39.494 126.564,39.494C127.14,39.494 127.615,39.968 127.615,40.545Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M122.927,44.586C122.927,45.162 122.453,45.637 121.877,45.637C121.3,45.637 120.826,45.162 120.826,44.586C120.826,44.009 121.3,43.535 121.877,43.535C122.453,43.535 122.927,44.009 122.927,44.586Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M98.517,61.721C98.517,62.298 98.043,62.772 97.466,62.772C96.89,62.772 96.415,62.298 96.415,61.721C96.415,61.145 96.89,60.671 97.466,60.671C98.043,60.671 98.517,61.145 98.517,61.721Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M103.044,67.218C103.044,67.794 102.569,68.268 101.993,68.268C101.417,68.268 100.942,67.794 100.942,67.218C100.942,66.641 101.417,66.167 101.993,66.167C102.569,66.167 103.044,66.641 103.044,67.218Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M99.487,155.965C99.487,156.541 99.012,157.016 98.436,157.016C97.86,157.016 97.385,156.541 97.385,155.965C97.385,155.389 97.86,154.914 98.436,154.914C99.012,154.914 99.487,155.389 99.487,155.965Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M100.134,180.454C100.134,181.165 99.549,181.749 98.84,181.749C98.131,181.749 97.547,181.165 97.547,180.454C97.547,179.746 98.131,179.163 98.84,179.163C99.549,179.163 100.134,179.746 100.134,180.454Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M86.231,192.985C86.231,193.561 85.756,194.036 85.18,194.036C84.604,194.036 84.13,193.561 84.13,192.985C84.13,192.407 84.604,191.934 85.18,191.934C85.756,191.934 86.231,192.407 86.231,192.985Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M69.58,198.077C69.58,198.786 68.996,199.37 68.287,199.37C67.578,199.37 66.994,198.786 66.994,198.077C66.994,197.366 67.578,196.782 68.287,196.782C68.996,196.782 69.58,197.366 69.58,198.077Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M66.186,186.76C66.186,187.469 65.602,188.053 64.893,188.053C64.183,188.053 63.599,187.469 63.599,186.76C63.599,186.051 64.183,185.467 64.893,185.467C65.602,185.467 66.186,186.051 66.186,186.76Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M64.246,193.954C64.246,194.53 63.772,195.004 63.195,195.004C62.619,195.004 62.145,194.53 62.145,193.954C62.145,193.377 62.619,192.903 63.195,192.903C63.772,192.903 64.246,193.377 64.246,193.954Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M51.798,187.973C51.798,188.549 51.324,189.024 50.747,189.024C50.171,189.024 49.697,188.549 49.697,187.973C49.697,187.397 50.171,186.922 50.747,186.922C51.324,186.922 51.798,187.397 51.798,187.973Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M95.283,208.179C95.283,208.755 94.809,209.23 94.233,209.23C93.656,209.23 93.182,208.755 93.182,208.179C93.182,207.603 93.656,207.128 94.233,207.128C94.809,207.128 95.283,207.603 95.283,208.179Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M108.378,198.561C108.378,199.27 107.794,199.854 107.085,199.854C106.376,199.854 105.792,199.27 105.792,198.561C105.792,197.852 106.376,197.268 107.085,197.268C107.794,197.268 108.378,197.852 108.378,198.561Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M109.833,210.927C109.833,211.503 109.359,211.978 108.782,211.978C108.206,211.978 107.731,211.503 107.731,210.927C107.731,210.351 108.206,209.878 108.782,209.878C109.359,209.878 109.833,210.351 109.833,210.927Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M163.664,199.127C163.664,199.704 163.19,200.178 162.613,200.178C162.037,200.178 161.563,199.704 161.563,199.127C161.563,198.549 162.037,198.077 162.613,198.077C163.19,198.077 163.664,198.549 163.664,199.127Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M138.607,208.017C138.607,208.595 138.132,209.068 137.556,209.068C136.98,209.068 136.506,208.595 136.506,208.017C136.506,207.441 136.98,206.968 137.556,206.968C138.132,206.968 138.607,207.441 138.607,208.017Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M206.017,220.789C206.017,221.365 205.543,221.839 204.966,221.839C204.39,221.839 203.915,221.365 203.915,220.789C203.915,220.212 204.39,219.738 204.966,219.738C205.543,219.738 206.017,220.212 206.017,220.789Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M211.513,171.079C211.513,171.788 210.929,172.372 210.22,172.372C209.511,172.372 208.927,171.788 208.927,171.079C208.927,170.371 209.511,169.787 210.22,169.787C210.929,169.787 211.513,170.371 211.513,171.079Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M201.167,178.111C201.167,178.689 200.693,179.163 200.116,179.163C199.54,179.163 199.066,178.689 199.066,178.111C199.066,177.537 199.54,177.062 200.116,177.062C200.693,177.062 201.167,177.537 201.167,178.111Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M211.352,180.132C211.352,180.841 210.768,181.425 210.059,181.425C209.35,181.425 208.766,180.841 208.766,180.132C208.766,179.423 209.35,178.839 210.059,178.839C210.768,178.839 211.352,179.423 211.352,180.132Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M201.167,192.661C201.167,193.237 200.693,193.711 200.116,193.711C199.54,193.711 199.066,193.237 199.066,192.661C199.066,192.084 199.54,191.61 200.116,191.61C200.693,191.61 201.167,192.084 201.167,192.661Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M227.517,164.048C227.517,164.624 227.043,165.099 226.467,165.099C225.889,165.099 225.414,164.624 225.414,164.048C225.414,163.472 225.889,162.997 226.467,162.997C227.043,162.997 227.517,163.472 227.517,164.048Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M230.104,170.433C230.104,171.144 229.52,171.726 228.811,171.726C228.101,171.726 227.517,171.144 227.517,170.433C227.517,169.724 228.101,169.14 228.811,169.14C229.52,169.14 230.104,169.724 230.104,170.433Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M248.209,178.031C248.209,178.74 247.625,179.324 246.915,179.324C246.205,179.324 245.621,178.74 245.621,178.031C245.621,177.322 246.205,176.738 246.915,176.738C247.625,176.738 248.209,177.322 248.209,178.031Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M229.781,191.53C229.781,192.106 229.306,192.58 228.73,192.58C228.154,192.58 227.679,192.106 227.679,191.53C227.679,190.954 228.154,190.479 228.73,190.479C229.306,190.479 229.781,190.954 229.781,191.53Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M241.419,180.537C241.419,181.113 240.945,181.587 240.368,181.587C239.792,181.587 239.318,181.113 239.318,180.537C239.318,179.96 239.792,179.486 240.368,179.486C240.945,179.486 241.419,179.96 241.419,180.537Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M239.318,197.51C239.318,198.086 238.843,198.561 238.267,198.561C237.691,198.561 237.216,198.086 237.216,197.51C237.216,196.934 237.691,196.459 238.267,196.459C238.843,196.459 239.318,196.934 239.318,197.51Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M168.848,24.697C169.026,24.04 169.558,23.528 170.227,23.379L170.594,20.612L171.137,23.405C171.785,23.59 172.287,24.12 172.434,24.783L175.235,25.18L172.408,25.678C172.23,26.317 171.717,26.815 171.07,26.973L170.594,29.82L170.114,26.952C169.485,26.77 168.993,26.26 168.837,25.619L166.135,25.18L168.848,24.697Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M96.37,222.996C96.548,222.339 97.081,221.826 97.749,221.677L98.117,218.912L98.661,221.705C99.308,221.888 99.811,222.417 99.956,223.081L102.758,223.478L99.931,223.976C99.753,224.615 99.239,225.113 98.592,225.271L98.117,228.12L97.637,225.251C97.007,225.068 96.516,224.558 96.359,223.917L93.657,223.478L96.37,222.996Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M229.659,197.43C229.837,196.772 230.368,196.26 231.037,196.112L231.405,193.344L231.949,196.137C232.596,196.321 233.099,196.852 233.244,197.516L236.045,197.913L233.219,198.411C233.04,199.049 232.528,199.547 231.88,199.705L231.405,202.553L230.925,199.684C230.295,199.502 229.805,198.991 229.648,198.352L226.947,197.913L229.659,197.43Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M240.211,168.919C240.388,168.261 240.92,167.749 241.588,167.601L241.956,164.833L242.5,167.626C243.148,167.812 243.651,168.341 243.796,169.005L246.597,169.402L243.771,169.9C243.592,170.538 243.079,171.037 242.433,171.195L241.956,174.042L241.477,171.173C240.847,170.992 240.357,170.482 240.2,169.841L237.497,169.402L240.211,168.919Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M109.303,63.606C109.481,62.948 110.013,62.437 110.681,62.287L111.049,59.521L111.593,62.314C112.241,62.498 112.743,63.028 112.889,63.692L115.69,64.089L112.863,64.586C112.685,65.225 112.172,65.724 111.525,65.882L111.049,68.729L110.569,65.861C109.94,65.678 109.449,65.168 109.293,64.528L106.59,64.089L109.303,63.606Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M100.756,123.628C110.286,140.277 121.393,152.461 130.341,164.038C138.283,174.314 153.757,179.458 148.307,184.336C142.164,189.832 127.292,165.583 127.292,165.583C117.408,153.664 107.949,141.02 98.299,124.483L100.756,123.628Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M0,167.318C46.046,137.076 126.409,117.552 192.597,91.275C242.884,71.31 287.601,46.248 311.639,11.739C250.721,135.827 81.066,121.139 3.312,168.474L0,167.318Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M107.05,105.788L130.11,105.788L146.644,147.424L152.155,152.955L122.134,152.955L127.645,147.424L125.687,142.344L109.117,142.344L107.413,148.153L111.365,152.955L95.701,152.955L101.213,147.424L111.837,110.604L107.05,105.788ZM122.751,135.054L116.078,118.147L111.184,135.054L122.751,135.054Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M214.184,105.788L238.118,105.788L254.653,147.424L260.164,152.955L230.143,152.955L235.654,147.424L233.696,142.344L217.125,142.344L215.421,148.153L219.373,152.955L203.71,152.955L209.222,147.424L219.845,110.604L214.184,105.788ZM230.759,135.054L224.087,118.147L219.192,135.054L230.759,135.054Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M75.758,135.163L75.758,110.604L70.972,105.788L86.925,105.788L82.14,110.604L82.14,147.424L87.651,152.955L66.693,152.955L48.637,122.411L48.637,147.424L53.277,152.955L36.6,152.955L42.111,147.424L42.111,110.604L37.325,105.788L58.21,105.788L75.758,135.163Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M196.553,117.885L196.063,103.2L191.12,106.612C184.156,104.177 176.051,104.269 170.364,106.96C165.071,109.465 159.36,114.754 160.055,122.27C160.752,129.786 166.577,132.695 171.826,135.074C178.582,138.136 185.936,139.171 185.827,143.217C185.757,145.791 181.485,147.637 178.165,147.532C175.135,147.436 165.28,146.696 160.125,140.573L161.101,156.02L166.604,151.985C173.289,154.35 181.392,155.342 188.889,152.897C196.341,150.469 204.174,144.233 199.827,133.335C197.956,128.646 192.804,125.755 189.731,124.497C186.917,123.345 178.333,119.97 175.936,118.72C173.136,117.262 173.448,112.632 180.185,111.692C186.288,110.841 194.742,115.728 196.553,117.885Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M35.658,239.727C128.131,145.348 265.971,101.743 311.639,11.739C284.138,99.243 136.85,147.504 35.408,244.165L35.658,239.727Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("path", {
                        d: "M98.299,124.483C97.216,122.627 96.131,120.722 95.042,118.763C70.388,74.411 73.944,29.148 118.563,48.87C156.431,65.609 192.6,112.561 207.146,145.907C213.887,161.356 231.96,221.996 173.764,197.424L173.65,197.069C228.613,219.701 219.111,162.351 189.691,118.38C173.042,93.5 151.331,72.775 137.637,62.772C92.05,29.471 64.246,49.84 96.253,115.147C97.702,118.102 99.208,120.925 100.756,123.628L98.299,124.483Z",
                        style: {
                            fill: "white",
                            fillRule: "nonzero"
                        }
                    })
                ]
            })
        ]
    });
}

});


parcelRegister("2V0YG", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("lKu24").then(()=>parcelRequire("98U0N"));

});

parcelRegister("92mPg", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("ggpsw").then(()=>parcelRequire("1DKeQ"));

});

parcelRegister("2hNh9", function(module, exports) {

var $9viiU = parcelRequire("9viiU");


module.exports = Promise.all([
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("5GG8I")),
    $9viiU("bjcj2"),
    $9viiU("iJNpj")
]).then(()=>parcelRequire("jPIv0"));

});


parcelRegister("2NGmK", function(module, exports) {

$parcel$export(module.exports, "pulsingAnimation", function () { return $c63803904e946c1f$export$84a97ed1b33c6a8d; });
$parcel$export(module.exports, "LoadingSkeleton", function () { return $c63803904e946c1f$export$44c18d210d5de37b; });
$parcel$export(module.exports, "ContentLoading", function () { return $c63803904e946c1f$export$199be3e6e7e83c08; });
$parcel$export(module.exports, "PageLoading", function () { return $c63803904e946c1f$export$a89b8b542bf88e85; });
$parcel$export(module.exports, "MapLoading", function () { return $c63803904e946c1f$export$3db9e2b8f2eba706; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $6fhRl = parcelRequire("6fhRl");

var $2JIVh = parcelRequire("2JIVh");

var $atWKR = parcelRequire("atWKR");

var $04Xx0 = parcelRequire("04Xx0");
const $c63803904e946c1f$var$pulse = (0, $6fhRl.keyframes)`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;
const $c63803904e946c1f$export$84a97ed1b33c6a8d = (0, $6fhRl.css)`
  animation: ${$c63803904e946c1f$var$pulse} 0.8s ease 0s infinite alternate;
`;
const $c63803904e946c1f$export$44c18d210d5de37b = (0, $6fhRl.default).span`
  display: ${({ inline: inline })=>inline ? "inline-block" : "block"};
  background: ${(0, $atWKR.themeVal)("color.base-100")};
  height: ${({ height: height })=>height ? height : "1rem"};
  width: ${({ width: width })=>(width || 1) * 100}%;
  ${$c63803904e946c1f$export$84a97ed1b33c6a8d}

  /* Size modifier */
  ${({ size: size })=>size === "large" && "height: 2.25rem;"}

  /* Color modifier */
  ${({ variation: variation })=>variation === "light" && "background: rgba(#fff, 0.48);"}

  /* type modifier */
  ${({ type: type, variation: variation })=>type === "heading" && (0, $6fhRl.css)`
      background: ${(0, $atWKR.themeVal)("color.base-200")};
      ${variation === "light" && "background: rgba(#fff, 0.80);"}
    `}
`;
const $c63803904e946c1f$export$9a0a40bbe698a200 = (0, $6fhRl.default).div`
  display: flex;
  flex-flow: column;
  gap: ${(0, $atWKR.glsp)(0.5)};
`;
const $c63803904e946c1f$var$MapLoadingWrapper = (0, $6fhRl.default).div`
  position: absolute;
  z-index: 1;
  display: grid;
  top: 50%;
  transform: translate(-50%, -50%);
  grid-template-columns: repeat(1fr, 3);
  grid-template-rows: repeat(1fr, 3);
  width: 8rem;
  aspect-ratio: 1;
  gap: ${(0, $atWKR.glsp)(0.5)};

  ${({ position: position })=>{
    if (position === "left") return "left: 25%;";
    if (position === "right") return "left: 75%;";
    return "left: 50%;";
}}

  > * {
    height: auto;
  }

  > *:nth-child(1) {
    grid-column: 1 / span 2;
    grid-row: 1 / span 2;
  }

  > *:nth-child(2) {
    grid-column: 3 / span 1;
    grid-row: 2 / span 1;
  }

  > *:nth-child(3) {
    grid-column: 2 / span 1;
    grid-row: 3 / span 1;
  }
`;
const $c63803904e946c1f$var$ContentLoadingSelf = (0, $6fhRl.default).div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 24vh);
  gap: ${(0, $04Xx0.variableGlsp)()};
  padding: ${(0, $04Xx0.variableGlsp)()};
  background: ${(0, $atWKR.themeVal)("color.surface")};

  > div {
    background: ${(0, $atWKR.themeVal)("color.base-100")};
    ${$c63803904e946c1f$export$84a97ed1b33c6a8d}
  }

  > div:nth-child(1) {
    grid-column: 1 / span 1;
  }

  > div:nth-child(2) {
    grid-column: 2 / span 3;
  }

  > div:nth-child(3) {
    grid-column: 1 / span 3;
    grid-row: 2;
  }

  > div:nth-child(4) {
    grid-column: 4 / span 1;
    grid-row: 2;
  }

  p {
    ${(0, $atWKR.visuallyHidden)()}
  }
`;
const $c63803904e946c1f$var$ChartLoadingWrapper = (0, $6fhRl.default).div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  text-align: center;
  padding: ${(0, $04Xx0.variableGlsp)()};
  gap: ${(0, $atWKR.glsp)()};
  aspect-ratio: 16/9;
  color: ${(0, $atWKR.themeVal)("color.base-400")};

  &::before {
    position: absolute;
    inset: 0;
    display: flex;
    content: '';
    z-index: -1;
    padding: ${(0, $04Xx0.variableGlsp)()};
    background: ${(0, $atWKR.themeVal)("color.base-100")};
    ${$c63803904e946c1f$export$84a97ed1b33c6a8d}
  }
`;
function $c63803904e946c1f$export$199be3e6e7e83c08() {
    return /*#__PURE__*/ (0, $21sFD.jsxs)($c63803904e946c1f$var$ContentLoadingSelf, {
        children: [
            /*#__PURE__*/ (0, $21sFD.jsx)("div", {}),
            /*#__PURE__*/ (0, $21sFD.jsx)("div", {}),
            /*#__PURE__*/ (0, $21sFD.jsx)("div", {}),
            /*#__PURE__*/ (0, $21sFD.jsx)("div", {}),
            /*#__PURE__*/ (0, $21sFD.jsx)("p", {
                children: "Loading contents..."
            })
        ]
    });
}
const $c63803904e946c1f$var$PageLoadingSelf = (0, $6fhRl.default).div`
  display: flex;
  flex-flow: column nowrap;
  gap: ${(0, $04Xx0.variableGlsp)()};
  height: 100vh;
  padding: ${(0, $04Xx0.variableGlsp)()};
  background: ${(0, $atWKR.themeVal)("color.surface")};

  > div {
    background: ${(0, $atWKR.themeVal)("color.base-100")};
    ${$c63803904e946c1f$export$84a97ed1b33c6a8d}
  }

  > div:nth-child(1) {
    height: 10%;
  }

  > div:nth-child(2) {
    height: 25%;
  }

  > div:nth-child(3) {
    flex-grow: 1;
  }

  p {
    ${(0, $atWKR.visuallyHidden)()}
  }
`;
function $c63803904e946c1f$export$a89b8b542bf88e85() {
    return /*#__PURE__*/ (0, $21sFD.jsxs)($c63803904e946c1f$var$PageLoadingSelf, {
        children: [
            /*#__PURE__*/ (0, $21sFD.jsx)("div", {}),
            /*#__PURE__*/ (0, $21sFD.jsx)("div", {}),
            /*#__PURE__*/ (0, $21sFD.jsx)("div", {}),
            /*#__PURE__*/ (0, $21sFD.jsx)("p", {
                children: "Loading page..."
            })
        ]
    });
}
const $c63803904e946c1f$export$3db9e2b8f2eba706 = (props)=>{
    return /*#__PURE__*/ (0, $21sFD.jsxs)($c63803904e946c1f$var$MapLoadingWrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $21sFD.jsx)($c63803904e946c1f$export$44c18d210d5de37b, {}),
            /*#__PURE__*/ (0, $21sFD.jsx)($c63803904e946c1f$export$44c18d210d5de37b, {}),
            /*#__PURE__*/ (0, $21sFD.jsx)($c63803904e946c1f$export$44c18d210d5de37b, {})
        ]
    });
};
const $c63803904e946c1f$export$54cd1f09c6562ed4 = (props)=>{
    return /*#__PURE__*/ (0, $21sFD.jsxs)($c63803904e946c1f$var$ChartLoadingWrapper, {
        children: [
            /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Icon).Assessment, {
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $21sFD.jsx)("p", {
                children: props.message
            })
        ]
    });
};

});

parcelRegister("dC4My", function(module, exports) {

$parcel$export(module.exports, "resourceNotFound", function () { return $9e9288962ef61e7a$export$2a1c2f802ade203e; });
$parcel$export(module.exports, "default", function () { return $9e9288962ef61e7a$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $fohMe = parcelRequire("fohMe");

var $l5jsC = parcelRequire("l5jsC");

var $hNqhF = parcelRequire("hNqhF");

var $dm1LE = parcelRequire("dm1LE");
const $9e9288962ef61e7a$export$2a1c2f802ade203e = ()=>{
    const e = new Error("Resource not found");
    e.resNotFound = true;
    return e;
};
function $9e9288962ef61e7a$var$UhOh() {
    return /*#__PURE__*/ (0, $21sFD.jsxs)((0, $21sFD.Fragment), {
        children: [
            /*#__PURE__*/ (0, $21sFD.jsx)((0, $hNqhF.LayoutProps), {
                title: "Not found"
            }),
            /*#__PURE__*/ (0, $21sFD.jsxs)((0, $dm1LE.PageMainContent), {
                children: [
                    /*#__PURE__*/ (0, $21sFD.jsx)((0, $l5jsC.default), {
                        title: "Page not found",
                        description: `That's a 404 error.`
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsxs)((0, $fohMe.FoldProse), {
                        children: [
                            /*#__PURE__*/ (0, $21sFD.jsx)("p", {
                                children: "We were not able to find the page you are looking for. It may have been archived or removed."
                            }),
                            /*#__PURE__*/ (0, $21sFD.jsxs)("p", {
                                children: [
                                    "If you think this page should be here let us know via",
                                    " ",
                                    /*#__PURE__*/ (0, $21sFD.jsx)("a", {
                                        href: `mailto:${"support@ghg.center"}`,
                                        title: "Send us an email",
                                        children: "support@ghg.center"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $9e9288962ef61e7a$export$2e2bcd8739ae039 = $9e9288962ef61e7a$var$UhOh;

});
parcelRegister("fohMe", function(module, exports) {

$parcel$export(module.exports, "FoldGrid", function () { return $f7331de60fcde257$export$346abda115f190d2; });
$parcel$export(module.exports, "FoldHeader", function () { return $f7331de60fcde257$export$20dbefdb0820cc7e; });
$parcel$export(module.exports, "FoldHeadline", function () { return $f7331de60fcde257$export$d198f4e612bfff3f; });
$parcel$export(module.exports, "FoldTitle", function () { return $f7331de60fcde257$export$112c405e29c5130c; });
$parcel$export(module.exports, "FoldLead", function () { return $f7331de60fcde257$export$f2b68822595bc04e; });
$parcel$export(module.exports, "FoldBody", function () { return $f7331de60fcde257$export$71143095dc9523f1; });
$parcel$export(module.exports, "Fold", function () { return $f7331de60fcde257$export$71b56ab8b1d5480d; });
$parcel$export(module.exports, "FoldProse", function () { return $f7331de60fcde257$export$3acc350f02190877; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $04Xx0 = parcelRequire("04Xx0");

var $c2gSG = parcelRequire("c2gSG");

var $4hr52 = parcelRequire("4hr52");

var $hHhKF = parcelRequire("hHhKF");
const $f7331de60fcde257$export$e513643ad18ce599 = (0, $6fhRl.default).div`
  padding-top: ${(0, $04Xx0.variableGlsp)(2)};
  padding-bottom: ${(0, $04Xx0.variableGlsp)(2)};

  & + & {
    padding-top: 0;
  }
`;
const $f7331de60fcde257$export$346abda115f190d2 = (0, $6fhRl.default)((0, $hHhKF.default))`
  padding-top: ${(0, $04Xx0.variableGlsp)(2)};
  padding-bottom: ${(0, $04Xx0.variableGlsp)(2)};

  & + &,
  & + ${$f7331de60fcde257$export$e513643ad18ce599} {
    padding-top: 0;
  }
`;
const $f7331de60fcde257$var$FoldInner = (0, $6fhRl.default)((0, $4hr52.default))`
  /* styled-component */
`;
const $f7331de60fcde257$export$20dbefdb0820cc7e = (0, $6fhRl.default).div`
  grid-column: 1 / -1;
  display: flex;
  flex-flow: column nowrap;
  gap: ${(0, $04Xx0.variableGlsp)()};

  ${(0, $atWKR.media).largeUp`
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: flex-end;
  `}

  > a {
    flex-shrink: 0;
  }
`;
const $f7331de60fcde257$export$d198f4e612bfff3f = (0, $6fhRl.default).div`
  p {
    margin: 1rem 0 0 0;
  }
`;
const $f7331de60fcde257$export$ca5026cdd6359846 = (0, $6fhRl.default).div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: ${(0, $04Xx0.variableGlsp)(0.5)};
`;
const $f7331de60fcde257$export$d5162af383626d28 = (0, $6fhRl.default).div`
  gap: ${(0, $04Xx0.variableGlsp)(0.125)};
`;
const $f7331de60fcde257$export$112c405e29c5130c = (0, $6fhRl.default)((0, $c2gSG.VarHeading)).attrs({
    as: "h2",
    size: "xlarge"
})`
  column-span: all;
  max-width: 52rem;
  display: flex;
  flex-direction: column;
  gap: calc(${(0, $atWKR.glsp)()} - ${(0, $atWKR.glsp)(0.25)});

  &::before {
    content: '';
    width: ${(0, $atWKR.glsp)(2)};
    height: ${(0, $atWKR.glsp)(0.25)};
    border-radius: ${(0, $atWKR.themeVal)("shape.rounded")};
    background: ${(0, $atWKR.themeVal)("color.primary")};
  }
`;
const $f7331de60fcde257$export$f2b68822595bc04e = (0, $6fhRl.default)((0, $c2gSG.VarLead))`
  color: inherit;
`;
const $f7331de60fcde257$export$71143095dc9523f1 = (0, $6fhRl.default).div`
  grid-column: 1 / -1;
  display: flex;
  flex-flow: column nowrap;
  gap: ${(0, $04Xx0.variableGlsp)()};
`;
const $f7331de60fcde257$var$Content = (0, $6fhRl.default)((0, $c2gSG.VarProse))`
  grid-column: 1 / span 4;

  ${(0, $atWKR.media).mediumUp`
    grid-column: 2 / span 6;
  `}

  ${(0, $atWKR.media).largeUp`
    grid-column: 3 / span 8;
  `}
`;
function $f7331de60fcde257$var$FoldComponent(props) {
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $21sFD.jsx)($f7331de60fcde257$export$e513643ad18ce599, {
        ...rest,
        children: /*#__PURE__*/ (0, $21sFD.jsx)($f7331de60fcde257$var$FoldInner, {
            children: children
        })
    });
}
const $f7331de60fcde257$export$71b56ab8b1d5480d = (0, $6fhRl.default)($f7331de60fcde257$var$FoldComponent)`
  /* Convert to styled-component: https://styled-components.com/docs/advanced#caveat */
`;
function $f7331de60fcde257$export$3acc350f02190877(props) {
    const { children: children } = props;
    return /*#__PURE__*/ (0, $21sFD.jsx)($f7331de60fcde257$export$e513643ad18ce599, {
        children: /*#__PURE__*/ (0, $21sFD.jsx)($f7331de60fcde257$var$FoldInner, {
            children: /*#__PURE__*/ (0, $21sFD.jsx)($f7331de60fcde257$var$Content, {
                children: children
            })
        })
    });
}

});
parcelRegister("c2gSG", function(module, exports) {

$parcel$export(module.exports, "VarHeading", function () { return $2038b4a2465bb0d6$export$ba54789bf8e7668f; });
$parcel$export(module.exports, "VarLead", function () { return $2038b4a2465bb0d6$export$17646834d55fad90; });
$parcel$export(module.exports, "VarProse", function () { return $2038b4a2465bb0d6$export$b0a152e86c019ad8; });

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $egbTY = parcelRequire("egbTY");

var $04Xx0 = parcelRequire("04Xx0");
//
// Heading
//
const $2038b4a2465bb0d6$var$sizeMapping = {
    xxsmall: "0.75rem",
    xsmall: "1rem",
    small: "1.25rem",
    medium: "1.5rem",
    large: "1.75rem",
    xlarge: "2rem",
    xxlarge: "2.25rem",
    jumbo: "3rem"
};
const $2038b4a2465bb0d6$var$renderHeadingSize = (props = {})=>{
    const { size: size = "medium" } = props;
    return (0, $6fhRl.css)`
    font-size: calc(${$2038b4a2465bb0d6$var$sizeMapping[size]} + var(--base-text-increment, 0rem));
    ${size === "xxsmall" && "line-height: 1rem;"}
  `;
};
const $2038b4a2465bb0d6$export$ba54789bf8e7668f = (0, $6fhRl.default)((0, $egbTY.Heading))`
  /* Size */
  ${$2038b4a2465bb0d6$var$renderHeadingSize}
`;
const $2038b4a2465bb0d6$export$17646834d55fad90 = (0, $6fhRl.default)((0, $egbTY.Lead))`
  font-size: ${(0, $04Xx0.variableBaseType)((0, $atWKR.themeVal)("type.base.leadSize"))};
`;
const $2038b4a2465bb0d6$export$b0a152e86c019ad8 = (0, $6fhRl.default)((0, $egbTY.Prose))`
  font-size: ${(0, $04Xx0.variableBaseType)((0, $atWKR.themeVal)("type.base.size"))};

  h1 {
    ${$2038b4a2465bb0d6$var$renderHeadingSize({
    size: "xxlarge"
})}
  }

  h2 {
    ${$2038b4a2465bb0d6$var$renderHeadingSize({
    size: "xlarge"
})}
  }

  h3 {
    ${$2038b4a2465bb0d6$var$renderHeadingSize({
    size: "large"
})}
  }

  h4 {
    ${$2038b4a2465bb0d6$var$renderHeadingSize({
    size: "medium"
})}
  }

  h5 {
    ${$2038b4a2465bb0d6$var$renderHeadingSize({
    size: "small"
})}
  }

  h6 {
    ${$2038b4a2465bb0d6$var$renderHeadingSize({
    size: "xsmall"
})}
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: calc(${(0, $04Xx0.variableProseVSpace)()} / 2);

    &:not(:first-child) {
      margin-top: calc(${(0, $04Xx0.variableProseVSpace)()} * 2);
    }
  }

  > * {
    margin-bottom: ${(0, $04Xx0.variableProseVSpace)()};
  }

  > *:last-child {
    margin-bottom: 0;
  }

  /* avoid long a tags breaking small screen layout */
  ${(0, $atWKR.media).mediumDown`
    a {
      word-break: break-word;
    }
  `}
`;

});

parcelRegister("4hr52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b451da212f22afd$export$2e2bcd8739ae039; });

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $04Xx0 = parcelRequire("04Xx0");
const $6b451da212f22afd$var$Constrainer = (0, $6fhRl.default).div`
  display: grid;
  gap: ${(0, $04Xx0.variableGlsp)()};
  grid-template-columns: repeat(4, 1fr);
  width: 100%;
  max-width: ${(0, $atWKR.themeVal)("layout.max")};
  margin: 0 auto;
  padding-left: ${(0, $04Xx0.variableGlsp)()};
  padding-right: ${(0, $04Xx0.variableGlsp)()};

  ${(0, $atWKR.media).mediumUp`
    grid-template-columns: repeat(8, 1fr);
  `}

  ${(0, $atWKR.media).largeUp`
    grid-template-columns: repeat(12, 1fr);
  `}
`;
var $6b451da212f22afd$export$2e2bcd8739ae039 = $6b451da212f22afd$var$Constrainer;

});

parcelRegister("hHhKF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f32be2d6e38db366$export$2e2bcd8739ae039; });
/* eslint-disable prettier/prettier */ 
var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $04Xx0 = parcelRequire("04Xx0");
// 🤗 Human Universal Gridder
//
// Grid:
//   start    1    2    3    4    5    6    7    8    9   10   11   12     end
// |      |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|      |
// |      |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|      |
// |      |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|      |
// |      |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|      |
// |      |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|  |*|      |
//
// The start and end take up 1 fraction and its size is fluid, depending on
// window size.
// Each column takes up a 12th of the max content width (defined in the theme).
// Grid gaps are marked with an asterisk.
// Each instance of Human Universal Gridder, nested inside another Human
// Universal Gridder must define its grid for the different media queries,
// through a grid prop.
// If the grid for a given media query is not defined the previous one will be
// used (<media query>Up pattern).
// The value for each media query breakpoint is an array with a start and an end
// column. It works much like the `grid-column` property of css.
//    <Hug>
//      <Hug
//        grid={{
//          smallUp: ['full-start', 'full-end'],
//          mediumUp: ['content-2', 'content-4'],
//          largeUp: ['content-2', 'content-5'],
//        }}
//      >
//        Subgrid 1
//      </Hug>
//      <Hug
//        grid={{
//          smallUp: ['full-start', 'full-end'],
//          // mediumUp is not defined, so smallUp will be used until largeUp.
//          largeUp: ['content-6', 'full-end'],
//        }}
//      >
//        Subgrid 2
//      </Hug>
//    </Hug>
//
// The Human Universal Gridder will define a grid whose line names are always
// the same regardless of how many nested grids there are. Therefore an element
// placed on `content-5` will be aligned with the top most `content-5`.
// Line names to be used on the grid.
// In a css grid, the lines are named, not the columns.
const $f32be2d6e38db366$var$gridLineNames = [
    "full-start",
    "content-start",
    // content-2 to content-12
    // content-1 does not exist as it is named content-start
    "content-2",
    "content-3",
    "content-4",
    "content-5",
    "content-6",
    "content-7",
    "content-8",
    "content-9",
    "content-10",
    "content-11",
    "content-12",
    "content-end",
    "full-end"
];
// List of media queries from the smallest to the largest.
const $f32be2d6e38db366$var$mdQueryOrdered = [
    "xsmall",
    "small",
    "medium",
    "large",
    "xlarge"
];
/**
 * Check that the provided range is in the expected format which is an array
 * with the start and end grid lines.
 * For example: ['full-start', 'full-end']
 *
 * @throws Error if the value is not in correct format or names are invalid.
 *
 * @param {any} cols The grid range to validate
 */ const $f32be2d6e38db366$var$validateGridLineNames = (cols)=>{
    let error = "";
    if (!Array.isArray(cols) || cols.length !== 2) error = `The grid definition format is not valid. Please use an array defining the start and end range. Example:
  ['full-start', 'full-end']`;
    if (cols.some((v)=>!$f32be2d6e38db366$var$gridLineNames.includes(v))) error = `The grid line names not valid. Please provide a valid name for the grid definition`;
    // There was an error. Show the user info for debugging.
    if (error) throw new Error(`\u{1F917} Human Universal Gridder

    ${JSON.stringify(cols)}

${error}`);
};
/**
 * Creates the universal grid for this component.
 *
 * @param {number} columns Number of columns for the grid.
 * @param {string} mdQuery Media query at which this grid is shown
 * @returns css
 */ function $f32be2d6e38db366$var$makeGrid(columns, mdQuery) {
    return ({ grid: grid })=>{
        const gridGap = (0, $04Xx0.variableGlsp)();
        const layoutMax = (0, $atWKR.themeVal)("layout.max");
        // Discard the base padding to ensure that gridded folds have the same size as
        // the constrainers.
        const layoutMaxNoPadding = (0, $6fhRl.css)`calc(${layoutMax} - ${gridGap})`;
        // Calculate how much of the content block (with is the layoutMaxNoPadding)
        // each column takes up.
        const fullColumn = (0, $6fhRl.css)`calc(${layoutMaxNoPadding} / ${columns})`;
        // To get the usable size of each column we need to account for the gap.
        const contentColWidth = (0, $6fhRl.css)`calc(${fullColumn} - ${gridGap})`;
        // Create the columns as:
        // [content-<num>] minmax(0, <size>)
        // Content columns start at index 2.
        const contentColumns = Array(columns - 1).fill(0).map((_, i)=>({
                name: `content-${i + 2}`,
                value: (0, $6fhRl.css)`
          [content-${i + 2}] minmax(0, ${contentColWidth})
          `
            }));
        // Create an array with all the columns definitions. It will be used to
        // filter out the ones that are not needed when taking the user's grid
        // definition into account.
        const columnTemplate = [
            {
                name: "full-start",
                value: (0, $6fhRl.css)`[full-start] minmax(0, 1fr)`
            },
            {
                name: "content-start",
                value: (0, $6fhRl.css)`[content-start] minmax(0, ${contentColWidth})`
            },
            ...contentColumns,
            {
                name: "content-end",
                value: (0, $6fhRl.css)`[content-end] minmax(0, 1fr)`
            },
            {
                name: "full-end",
                value: "[full-end]"
            }
        ];
        let gridTemplateColumns;
        let gridColumn;
        // If the user defined a grid property compute the subgrid.
        // This does two things:
        // - Set the start and end columns to what the user defined.
        // - Set the template-columns of this element to a subset of the parent (columnTemplate list)
        if (grid) {
            const [start, end] = $f32be2d6e38db366$var$getGridProp(grid, mdQuery);
            gridColumn = (0, $6fhRl.css)`
        grid-column: ${start} / ${end};
      `;
            const startIdx = columnTemplate.findIndex((col)=>col.name === start);
            const endIdx = columnTemplate.findIndex((col)=>col.name === end);
            if (startIdx === -1 || endIdx === -1) {
                const line = startIdx === -1 ? start : end;
                throw new Error(`\u{1F917} Human Universal Gridder

The grid line \`${line}\` does not exist in the ${mdQuery} media query which has ${columns} columns.
Grid lines for ${mdQuery}: ${columnTemplate.map((c)=>c.name).join(" | ")}`);
            }
            const lastColumn = columnTemplate[endIdx];
            gridTemplateColumns = [
                ...columnTemplate.slice(startIdx, endIdx),
                // Add the name of the last column without a size so we can use it for
                // naming purposes.
                {
                    name: lastColumn.name,
                    value: `[${lastColumn.name}]`
                }
            ];
        } else // If we're not using a subset, just use all the columns.
        gridTemplateColumns = columnTemplate;
        // The grid-template-columns will be a subset of this, depending on the grid
        // defined by the user.
        // grid-template-columns:
        //   [full-start] minmax(0, 1fr)
        //   [content-start] minmax(0, 000px)
        //   [content-2] minmax(0, 000px)
        //   [content-3] minmax(0, 000px)
        //   [content-4] minmax(0, 000px)
        //   ...
        //   [content-end] minmax(0, 1fr)
        //   [full-end];
        return (0, $6fhRl.css)`
      ${gridColumn}
      grid-gap: ${gridGap};
      grid-template-columns: ${gridTemplateColumns.map((col)=>col.value)};
    `;
    };
}
/**
 * Get the correct grid range for the given media query. If the grid for a given
 * media query is not defined the previous one will be used (<media query>Up
 * pattern).
 *
 * @param {number} columns Number of columns for the grid.
 * @param {string} mdQuery Media query at which this grid is shown
 *
 * @returns array
 */ const $f32be2d6e38db366$var$getGridProp = (grid, mdQuery)=>{
    // If the user provided an array, assume it is the same on all media queries.
    if (Array.isArray(grid)) {
        $f32be2d6e38db366$var$validateGridLineNames(grid);
        return grid;
    }
    // From the current media query go back until we find one defined by the user
    // or reach the default. The replicates the behavior of <mediaQuery>Up
    const mdIndex = $f32be2d6e38db366$var$mdQueryOrdered.findIndex((v)=>v === mdQuery);
    for(let i = mdIndex; i >= 0; i--){
        const m = $f32be2d6e38db366$var$mdQueryOrdered[i];
        const key = `${m}Up`;
        // Did the user provide an override for this media query?
        if (grid[key]) {
            $f32be2d6e38db366$var$validateGridLineNames(grid[key]);
            return grid[key];
        }
    // No override. Check previous media range.
    }
    // content-start to content-end
    return [
        $f32be2d6e38db366$var$gridLineNames[1],
        $f32be2d6e38db366$var$gridLineNames[$f32be2d6e38db366$var$gridLineNames.length - 2]
    ];
};
// Redeclare the media function to fix the types defined in the UI library.
const $f32be2d6e38db366$var$_media = (0, $atWKR.media);
const $f32be2d6e38db366$var$Hug = (0, $6fhRl.default).div`
  display: grid;
  ${$f32be2d6e38db366$var$makeGrid(4, $f32be2d6e38db366$var$mdQueryOrdered[0])}

  ${$f32be2d6e38db366$var$_media.smallUp`
    ${$f32be2d6e38db366$var$makeGrid(4, $f32be2d6e38db366$var$mdQueryOrdered[1])}
  `}

  ${$f32be2d6e38db366$var$_media.mediumUp`
    ${$f32be2d6e38db366$var$makeGrid(8, $f32be2d6e38db366$var$mdQueryOrdered[2])}
  `}

  ${$f32be2d6e38db366$var$_media.largeUp`
    ${$f32be2d6e38db366$var$makeGrid(12, $f32be2d6e38db366$var$mdQueryOrdered[3])}
  `}

  ${$f32be2d6e38db366$var$_media.xlargeUp`
    ${$f32be2d6e38db366$var$makeGrid(12, $f32be2d6e38db366$var$mdQueryOrdered[4])}
  `}
`;
var $f32be2d6e38db366$export$2e2bcd8739ae039 = $f32be2d6e38db366$var$Hug;

});


parcelRegister("l5jsC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efb53c99346ed337$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $7i4Xz = parcelRequire("7i4Xz");

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $8KsRR = parcelRequire("8KsRR");

var $ijBVb = parcelRequire("ijBVb");

var $amNu9 = parcelRequire("amNu9");

var $dm1LE = parcelRequire("dm1LE");

var $4hr52 = parcelRequire("4hr52");

var $04Xx0 = parcelRequire("04Xx0");
const $efb53c99346ed337$var$PageHeroSelf = (0, $6fhRl.default).div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-flow: column nowrap;
  gap: ${(0, $atWKR.glsp)()};
  justify-content: flex-end;
  background: ${(0, $atWKR.themeVal)("color.primary")};
  color: ${(0, $atWKR.themeVal)("color.surface")};
  min-height: 12rem;
  animation: ${(0, $8KsRR.reveal)} 0.32s ease 0s 1;

  ${({ isCover: isCover })=>isCover && (0, $6fhRl.css)`
      min-height: 16rem;

      ${(0, $atWKR.media).mediumUp`
        min-height: 20rem;
      `}

      ${(0, $atWKR.media).largeUp`
        min-height: 24rem;
      `}

      ${(0, $atWKR.media).xlargeUp`
        min-height: 28rem;
      `}

      &::before {
        position: absolute;
        z-index: 2;
        inset: 0 0 auto 0;
        height: ${(0, $atWKR.themeVal)("layout.border")};
        background: ${(0, $atWKR.themeVal)("color.base-300a")};
        content: '';
      }
    `}

  ${({ isHidden: isHidden })=>isHidden && (0, $atWKR.visuallyHidden)()}

  ${(0, $ijBVb.FigureAttribution)} {
    top: ${(0, $04Xx0.variableGlsp)()};
    right: ${(0, $04Xx0.variableGlsp)()};
  }
`;
const $efb53c99346ed337$var$PageHeroInner = (0, $6fhRl.default)((0, $4hr52.default))`
  padding-top: ${(0, $04Xx0.variableGlsp)(4)};
  padding-bottom: ${(0, $04Xx0.variableGlsp)(2)};
  align-items: end;

  /** The constrainer's padding was going over the imagine attribution icon
  * causing it not to work. We remove the pointer events from it and add them
  * again to the descendants. */
  pointer-events: none;
  * {
    pointer-events: auto;
  }
`;
const $efb53c99346ed337$export$c9d6a41b9c6b79ff = (0, $6fhRl.default).div`
  display: flex;
  flex-flow: column;
  gap: ${(0, $04Xx0.variableGlsp)(0.125)};
`;
const $efb53c99346ed337$var$PageHeroCover = (0, $6fhRl.default)((0, $ijBVb.Figure))`
  position: absolute;
  inset: 0;
  z-index: -1;
  background: ${(0, $atWKR.themeVal)("color.base-400")};

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    mix-blend-mode: multiply;
  }
`;
const $efb53c99346ed337$var$PageHeroBlockAlpha = (0, $6fhRl.default).div`
  display: flex;
  flex-direction: column;
  gap: ${(0, $04Xx0.variableGlsp)()};

  grid-column: 1 / span 4;

  ${(0, $atWKR.media).mediumUp`
    grid-column: 1 / span 6;
  `}

  ${(0, $atWKR.media).largeUp`
    grid-column: 1 / span 6;
  `}
`;
const $efb53c99346ed337$var$PageHeroBlockBeta = (0, $6fhRl.default).div`
  grid-column: 1 / span 4;
  grid-row: 2;
  display: flex;
  flex-direction: column;
  gap: ${(0, $04Xx0.variableGlsp)()};

  ${(0, $atWKR.media).mediumUp`
    grid-column: 1 / span 6;
    grid-row: 2;
  `}

  ${(0, $atWKR.media).largeUp`
    grid-column: 7 / span 6;
    grid-row: 1;
  `}
`;
function $efb53c99346ed337$export$4b2976b57d220ac6(props) {
    const { title: title, description: description, renderAlphaBlock: renderAlphaBlock, renderBetaBlock: renderBetaBlock, renderDetailsBlock: renderDetailsBlock, publishedDate: publishedDate, coverSrc: coverSrc, coverAlt: coverAlt, attributionAuthor: attributionAuthor, attributionUrl: attributionUrl, isHidden: isHidden, ...rest } = props;
    const hasImage = !!(coverSrc && coverAlt);
    const date = publishedDate ? typeof publishedDate === "string" ? new Date(publishedDate) : publishedDate : undefined;
    return /*#__PURE__*/ (0, $21sFD.jsx)($efb53c99346ed337$var$PageHeroSelf, {
        isCover: hasImage,
        isHidden: !!isHidden,
        ...rest,
        children: /*#__PURE__*/ (0, $21sFD.jsxs)($efb53c99346ed337$var$PageHeroInner, {
            children: [
                /*#__PURE__*/ (0, $21sFD.jsxs)((0, $amNu9.default), {
                    fn: renderAlphaBlock,
                    wrapWith: $efb53c99346ed337$var$PageHeroBlockAlpha,
                    children: [
                        /*#__PURE__*/ (0, $21sFD.jsxs)($efb53c99346ed337$export$c9d6a41b9c6b79ff, {
                            children: [
                                /*#__PURE__*/ (0, $21sFD.jsx)((0, $dm1LE.PageMainTitle), {
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $21sFD.jsx)($efb53c99346ed337$export$17027468d3335f31, {
                                    date: date
                                })
                            ]
                        }),
                        description && /*#__PURE__*/ (0, $21sFD.jsx)((0, $dm1LE.PageLead), {
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $21sFD.jsx)((0, $amNu9.default), {
                    fn: renderBetaBlock,
                    wrapWith: $efb53c99346ed337$var$PageHeroBlockBeta
                }),
                typeof renderDetailsBlock === "function" && renderDetailsBlock(),
                hasImage && /*#__PURE__*/ (0, $21sFD.jsxs)($efb53c99346ed337$var$PageHeroCover, {
                    children: [
                        /*#__PURE__*/ (0, $21sFD.jsx)("img", {
                            src: coverSrc,
                            alt: coverAlt
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsx)((0, $ijBVb.Figcaption), {
                            children: /*#__PURE__*/ (0, $21sFD.jsx)((0, $ijBVb.FigureAttribution), {
                                author: attributionAuthor,
                                url: attributionUrl
                            })
                        })
                    ]
                })
            ]
        })
    });
}
var $efb53c99346ed337$export$2e2bcd8739ae039 = (0, $6fhRl.default)($efb53c99346ed337$export$4b2976b57d220ac6)`
  /* Convert to styled-component: https://styled-components.com/docs/advanced#caveat */
`;
function $efb53c99346ed337$export$17027468d3335f31(props) {
    const { date: date } = props;
    if (!date) return null;
    return /*#__PURE__*/ (0, $21sFD.jsxs)((0, $dm1LE.PageOverline), {
        children: [
            "Published on",
            " ",
            /*#__PURE__*/ (0, $21sFD.jsx)("time", {
                dateTime: (0, $7i4Xz.default)(date, "yyyy-MM-dd"),
                children: (0, $7i4Xz.default)(date, "MMM d, yyyy")
            })
        ]
    });
}

});
parcelRegister("ijBVb", function(module, exports) {

$parcel$export(module.exports, "Figure", function () { return $3bf54c95803da46d$export$820c702ddd5a7343; });
$parcel$export(module.exports, "Figcaption", function () { return $3bf54c95803da46d$export$d98f36ee5a5a6a9b; });
$parcel$export(module.exports, "FigcaptionInner", function () { return $3bf54c95803da46d$export$e7803c8e09bf93da; });
$parcel$export(module.exports, "FigureAttributionSelf", function () { return $3bf54c95803da46d$export$cdfaaca76cdea965; });
$parcel$export(module.exports, "FigureAttribution", function () { return $3bf54c95803da46d$export$4884627e33af2296; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $ifjYT = parcelRequire("ifjYT");

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");

var $egbTY = parcelRequire("egbTY");

var $2JIVh = parcelRequire("2JIVh");

var $04Xx0 = parcelRequire("04Xx0");
const $3bf54c95803da46d$export$820c702ddd5a7343 = (0, $6fhRl.default).figure`
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 100%;

  > a {
    display: block;
  }
`;
const $3bf54c95803da46d$export$d98f36ee5a5a6a9b = (0, $6fhRl.default).figcaption`
  clear: both;
  display: flex;
  flex-flow: row nowrap;
`;
const $3bf54c95803da46d$export$e7803c8e09bf93da = (0, $6fhRl.default)((0, $egbTY.Subtitle)).attrs({
    as: "span"
})`
  padding: ${(0, $04Xx0.variableGlsp)(0.5, 0, 0, 0)};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: start;
  font-size: ${(0, $04Xx0.variableBaseType)("0.75rem")};
  text-align: left;
  max-width: 52rem;

  &::after {
    content: '';
    width: ${(0, $atWKR.glsp)(2)};
    height: ${(0, $atWKR.themeVal)("layout.border")};
    margin-top: calc(${(0, $04Xx0.variableGlsp)(0.5)} - ${(0, $atWKR.themeVal)("layout.border")});
    background: ${(0, $atWKR.themeVal)("color.base-100a")};
  }
`;
function $3bf54c95803da46d$var$renderAttributionPosition(props) {
    const { position: position } = props;
    switch(position){
        case "top-left":
            return (0, $6fhRl.css)`
        top: ${(0, $04Xx0.variableGlsp)()};
        left: ${(0, $04Xx0.variableGlsp)()};
      `;
        case "bottom-left":
            return (0, $6fhRl.css)`
        bottom: ${(0, $04Xx0.variableGlsp)()};
        left: ${(0, $04Xx0.variableGlsp)()};
      `;
        case "bottom-right":
            return (0, $6fhRl.css)`
        bottom: ${(0, $04Xx0.variableGlsp)()};
        right: ${(0, $04Xx0.variableGlsp)()};
      `;
        // top-right
        default:
            return (0, $6fhRl.css)`
        top: ${(0, $04Xx0.variableGlsp)()};
        right: ${(0, $04Xx0.variableGlsp)()};
      `;
    }
}
const $3bf54c95803da46d$export$cdfaaca76cdea965 = (0, $6fhRl.default).p`
  position: absolute;
  z-index: 40;
  max-width: calc(100% - ${(0, $atWKR.glsp)(2)}); /* stylelint-disable-line */
  height: 1.5rem;
  display: inline-flex;
  color: ${(0, $atWKR.themeVal)("color.surface")};
  border-radius: ${(0, $atWKR.themeVal)("shape.ellipsoid")};
  padding: ${(0, $atWKR.glsp)(0, 0.25)};
  font-size: 0.75rem;
  background: ${(0, $atWKR.themeVal)("color.base-400a")};
  overflow: hidden;

  ${$3bf54c95803da46d$var$renderAttributionPosition}

  a,
  a:visited {
    color: inherit;
    text-decoration: none;
  }
`;
const $3bf54c95803da46d$var$FigureAttributionInner = (0, $6fhRl.default).span`
  display: flex;
  flex-flow: nowrap;
  align-items: center;

  svg {
    flex-shrink: 0;
  }

  strong {
    display: block;
    width: 100%;
    max-width: 0;
    overflow: hidden;
    font-weight: normal;
    white-space: nowrap;
    padding: ${(0, $atWKR.glsp)(0)};
    opacity: 0;
    transition: all 0.24s ease-in-out 0s;
  }

  &:hover {
    strong {
      ${(0, $atWKR.truncated)()}
      max-width: 64vw;
      padding: ${(0, $atWKR.glsp)(0, 0.5, 0, 0.25)};
      opacity: 1;
    }
  }
`;
function $3bf54c95803da46d$var$FigureAttributionCmp(props) {
    const { author: author, url: url, position: position, ...rest } = props;
    if (!author) return null;
    const innerProps = url ? {
        as: "a",
        href: url,
        target: "_blank",
        rel: "noreferrer noopener"
    } : {};
    return /*#__PURE__*/ (0, $21sFD.jsx)($3bf54c95803da46d$export$cdfaaca76cdea965, {
        position: position,
        ...rest,
        children: /*#__PURE__*/ (0, $21sFD.jsxs)($3bf54c95803da46d$var$FigureAttributionInner, {
            ...innerProps,
            children: [
                /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Icon).Info, {
                    size: 3
                }),
                /*#__PURE__*/ (0, $21sFD.jsxs)("strong", {
                    children: [
                        "Figure by ",
                        author
                    ]
                })
            ]
        })
    });
}
const $3bf54c95803da46d$export$4884627e33af2296 = (0, $6fhRl.default)($3bf54c95803da46d$var$FigureAttributionCmp)`
  /* Convert to styled-component: https://styled-components.com/docs/advanced#caveat */
`;
$3bf54c95803da46d$var$FigureAttributionCmp.propTypes = {
    author: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    url: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).string,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).oneOf([
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right"
    ])
};

});

parcelRegister("amNu9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78c25833c9b34c77$export$2e2bcd8739ae039; });
/* eslint-disable react/prop-types */ 
var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");
function $78c25833c9b34c77$export$2e2bcd8739ae039(props) {
    const { fn: F, wrapWith: W, children: children, ...rest } = props;
    let value = children;
    // Styled-components fail with isValidElement, so checking directly.
    if (/*#__PURE__*/ (0, $3RyIS.isValidElement)(F) || F?.styledComponentId) value = /*#__PURE__*/ (0, $21sFD.jsx)(F, {
        ...props
    });
    else if (typeof F === "function") value = F(rest);
    if (/*#__PURE__*/ (0, $3RyIS.isValidElement)(W) || W?.styledComponentId) return value ? /*#__PURE__*/ (0, $21sFD.jsx)(W, {
        children: value
    }) : null;
    return value || null;
}

});

parcelRegister("dm1LE", function(module, exports) {

$parcel$export(module.exports, "PageMainContent", function () { return $9b8eb3718ca1a927$export$3693a9144d0fe949; });
$parcel$export(module.exports, "PageMainTitle", function () { return $9b8eb3718ca1a927$export$dd135e2c09f5fcf9; });
$parcel$export(module.exports, "PageOverline", function () { return $9b8eb3718ca1a927$export$cb51112b5e26a365; });
$parcel$export(module.exports, "PageLead", function () { return $9b8eb3718ca1a927$export$120152ecd0b7c4bd; });
$parcel$export(module.exports, "PageActions", function () { return $9b8eb3718ca1a927$export$a9e583a1195b23df; });

var $6fhRl = parcelRequire("6fhRl");

var $egbTY = parcelRequire("egbTY");

var $atWKR = parcelRequire("atWKR");

var $c2gSG = parcelRequire("c2gSG");

var $04Xx0 = parcelRequire("04Xx0");

var $hAJzY = parcelRequire("hAJzY");
const $9b8eb3718ca1a927$export$3693a9144d0fe949 = (0, $6fhRl.default).main`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  * {
    ${(0, $hAJzY.legacyGlobalStyleCSSBlock)};
  }
`;
const $9b8eb3718ca1a927$export$dd135e2c09f5fcf9 = (0, $6fhRl.default)((0, $c2gSG.VarHeading)).attrs((props)=>({
        as: props.as || "h1",
        size: props.size || "xxlarge"
    }))`
  /* styled-component */
`;
const $9b8eb3718ca1a927$export$cb51112b5e26a365 = (0, $6fhRl.default)((0, $egbTY.Overline))`
  order: -1;
  color: inherit;
  font-size: ${(0, $04Xx0.variableBaseType)("0.75rem")};
  line-height: ${(0, $04Xx0.variableBaseType)("1rem")};
  opacity: 0.64;

  > * {
    line-height: inherit;
  }
`;
const $9b8eb3718ca1a927$export$120152ecd0b7c4bd = (0, $6fhRl.default)((0, $c2gSG.VarLead))`
  color: inherit;
`;
const $9b8eb3718ca1a927$export$a9e583a1195b23df = (0, $6fhRl.default).div`
  display: flex;
  flex-direction: row nowrap;
  gap: ${(0, $04Xx0.variableGlsp)(0.5)};

  ${(0, $atWKR.media).largeUp`
    justify-content: end;
  `}
`;

});



parcelRegister("925SL", function(module, exports) {

$parcel$export(module.exports, "HintedError", function () { return $62d8ee203a33b8fa$export$5e2fc0291e57f772; });
$parcel$export(module.exports, "HintedErrorDisplay", function () { return $62d8ee203a33b8fa$export$295970e1d7fe83c4; });
$parcel$export(module.exports, "docsMessage", function () { return $62d8ee203a33b8fa$export$ee7e8e40289d22e; });

var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");

var $6fhRl = parcelRequire("6fhRl");

var $atWKR = parcelRequire("atWKR");
class $62d8ee203a33b8fa$export$5e2fc0291e57f772 extends Error {
    constructor(message, hints = []){
        super(message);
        this.hints = hints;
    }
}
const $62d8ee203a33b8fa$export$5f71c1e53eaf1d93 = (0, $6fhRl.default).div`
  margin: ${(0, $atWKR.glsp)(1, 0)};
  padding: ${(0, $atWKR.glsp)(0, 1)};
`;
const $62d8ee203a33b8fa$export$8a35684520b35731 = (0, $6fhRl.default).div`
  width: 100%;
  color: ${(0, $atWKR.themeVal)("color.danger")};
  border: 3px solid ${(0, $atWKR.themeVal)("color.danger")};
  padding: ${(0, $atWKR.glsp)(3)};

  > div {
    max-width: 48rem;
    margin: 0 auto;

    > * {
      display: block;
    }
  }
`;
const $62d8ee203a33b8fa$export$3beebeb686a5eb38 = (0, $6fhRl.default).div`
  margin-top: ${(0, $atWKR.glsp)()};
  color: ${(0, $atWKR.themeVal)("color.base")};

  pre {
    font-size: 0.875rem;
  }
`;
const $62d8ee203a33b8fa$var$ErrorSubtitle = (0, $6fhRl.default).div`
  color: ${(0, $atWKR.themeVal)("color.base")};
  font-size: 0.875rem;
`;
function $62d8ee203a33b8fa$export$295970e1d7fe83c4(props) {
    const { className: className, hints: hints, message: message, title: title, subtitle: subtitle } = props;
    return /*#__PURE__*/ (0, $21sFD.jsx)($62d8ee203a33b8fa$export$5f71c1e53eaf1d93, {
        className: className,
        children: /*#__PURE__*/ (0, $21sFD.jsx)($62d8ee203a33b8fa$export$8a35684520b35731, {
            children: /*#__PURE__*/ (0, $21sFD.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $21sFD.jsx)("small", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $21sFD.jsx)("strong", {
                        children: message
                    }),
                    subtitle && /*#__PURE__*/ (0, $21sFD.jsx)($62d8ee203a33b8fa$var$ErrorSubtitle, {
                        children: subtitle
                    }),
                    !!hints?.length && /*#__PURE__*/ (0, $21sFD.jsxs)($62d8ee203a33b8fa$export$3beebeb686a5eb38, {
                        children: [
                            /*#__PURE__*/ (0, $21sFD.jsx)("p", {
                                children: /*#__PURE__*/ (0, $21sFD.jsx)("strong", {
                                    children: "Hints:"
                                })
                            }),
                            hints.map((e, i)=>typeof e === "string" ? /* eslint-disable-next-line react/no-array-index-key */ /*#__PURE__*/ (0, $21sFD.jsx)("p", {
                                    children: e
                                }, i) : /* eslint-disable-next-line react/no-array-index-key */ /*#__PURE__*/ (0, $21sFD.jsx)((0, $3RyIS.Fragment), {
                                    children: e
                                }, i))
                        ]
                    })
                ]
            })
        })
    });
}
const $62d8ee203a33b8fa$export$ee7e8e40289d22e = /*#__PURE__*/ (0, $21sFD.jsxs)("p", {
    children: [
        "\uD83D\uDCDC Find all documentation in our",
        " ",
        /*#__PURE__*/ (0, $21sFD.jsx)("a", {
            href: "https://github.com/NASA-IMPACT/veda-config/blob/main/docs/MDX_BLOCKS.md",
            target: "_blank",
            rel: "noreferrer nofollow",
            children: /*#__PURE__*/ (0, $21sFD.jsx)("strong", {
                children: "Github repo"
            })
        }),
        "."
    ]
});

});

parcelRegister("8aa28", function(module, exports) {

var $9viiU = parcelRequire("9viiU");


module.exports = Promise.all([
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("gBFRY")),
    $9viiU("9azGc"),
    $9viiU("b7kVF")
]).then(()=>parcelRequire("7bG57"));

});

parcelRegister("hn4w8", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("7S921").then(()=>parcelRequire("4pcsL"));

});

parcelRegister("7yOpZ", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("4FUVc").then(()=>parcelRequire("c090F"));

});

parcelRegister("3YwAc", function(module, exports) {

var $9viiU = parcelRequire("9viiU");


module.exports = Promise.all([
    $9viiU("9MCwV"),
    $9viiU("2yFTg"),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("gBFRY")),
    $9viiU("9azGc"),
    $9viiU("kuTXU"),
    $9viiU("6AxUY"),
    $9viiU("2hQAJ"),
    $9viiU("618XJ")
]).then(()=>parcelRequire("fRh0j"));

});

parcelRegister("3fFSB", function(module, exports) {

var $9viiU = parcelRequire("9viiU");


module.exports = Promise.all([
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("gBFRY")),
    $9viiU("9azGc"),
    $9viiU("aDh7I"),
    $9viiU("1d4iR")
]).then(()=>parcelRequire("1udLW"));

});

parcelRegister("17f0k", function(module, exports) {

var $9viiU = parcelRequire("9viiU");


module.exports = Promise.all([
    $9viiU("9MCwV"),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("gBFRY")),
    $9viiU("9azGc"),
    $9viiU("kuTXU"),
    $9viiU("2hQAJ"),
    $9viiU("gdbFM")
]).then(()=>parcelRequire("5GDdy"));

});

parcelRegister("d5V9Q", function(module, exports) {

var $9viiU = parcelRequire("9viiU");


module.exports = Promise.all([
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("gBFRY")),
    $9viiU("9azGc"),
    $9viiU("2hQAJ"),
    $9viiU("aDh7I"),
    $9viiU("hzcDy")
]).then(()=>parcelRequire("c4jOS"));

});

parcelRegister("3FXAc", function(module, exports) {

var $9viiU = parcelRequire("9viiU");






module.exports = Promise.all([
    $9viiU("bjcj2"),
    $9viiU("bnCbN"),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("gBFRY")),
    $9viiU("9azGc"),
    $9viiU("kuTXU"),
    $9viiU("2hQAJ"),
    $9viiU("6AxUY"),
    $9viiU("aeqcH"),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("aPjrX")),
    $9viiU("rWbfN"),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("3sa5j")),
    $9viiU("avPeM"),
    $9viiU("aDh7I"),
    $9viiU("1Cn2x")
]).then(()=>parcelRequire("6mKPS"));

});

parcelRegister("3G8v0", function(module, exports) {

var $9viiU = parcelRequire("9viiU");






module.exports = Promise.all([
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("9sU5r")),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("gBFRY")),
    $9viiU("9azGc"),
    $9viiU("kuTXU"),
    $9viiU("2hQAJ"),
    $9viiU("6AxUY"),
    $9viiU("aeqcH"),
    (parcelRequire("5BfFi"))((parcelRequire("6FL5Y")).resolve("3sa5j")),
    $9viiU("avPeM"),
    $9viiU("aDh7I"),
    $9viiU("15JZc"),
    $9viiU("2l5tY"),
    $9viiU("bP0sG")
]).then(()=>parcelRequire("aKuYa"));

});

parcelRegister("g1Y4y", function(module, exports) {

var $9viiU = parcelRequire("9viiU");
module.exports = $9viiU("4dWGr").then(()=>parcelRequire("kgkTm"));

});

parcelRegister("7R3KQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c486530b51678956$export$2e2bcd8739ae039; });

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $51dfG = parcelRequire("51dfG");
var $hqNkG = parcelRequire("hqNkG");

var $fNzfd = parcelRequire("fNzfd");
// Create a client
const $c486530b51678956$var$queryClient = new (0, $51dfG.QueryClient)();
function $c486530b51678956$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $21sFD.jsxs)((0, $hqNkG.QueryClientProvider), {
        client: $c486530b51678956$var$queryClient,
        children: [
            children,
            /*#__PURE__*/ (0, $21sFD.jsx)((0, $fNzfd.ReactQueryDevtools), {
                initialIsOpen: false
            })
        ]
    });
}

});
parcelRegister("51dfG", function(module, exports) {

$parcel$export(module.exports, "QueryClient", function () { return $3a7753529045efa2$export$405d0624ed55a03f; });

var $7S1FP = parcelRequire("7S1FP");

var $7LcT0 = parcelRequire("7LcT0");

var $9WLMV = parcelRequire("9WLMV");

var $ahV8W = parcelRequire("ahV8W");

var $9HeJk = parcelRequire("9HeJk");

var $9F2KI = parcelRequire("9F2KI");

var $9re2n = parcelRequire("9re2n");

var $1VZZ0 = parcelRequire("1VZZ0");
// CLASS
class $3a7753529045efa2$export$405d0624ed55a03f {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $7LcT0.QueryCache)();
        this.mutationCache = config.mutationCache || new (0, $9WLMV.MutationCache)();
        this.logger = config.logger || (0, $1VZZ0.defaultLogger);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    mount() {
        this.unsubscribeFocus = (0, $ahV8W.focusManager).subscribe(()=>{
            if ((0, $ahV8W.focusManager).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $9HeJk.onlineManager).subscribe(()=>{
            if ((0, $9HeJk.onlineManager).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $7S1FP.parseFilterArgs)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $7S1FP.functionalUpdate)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, $7S1FP.parseQueryArgs)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $9F2KI.notifyManager).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $7S1FP.parseFilterArgs)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $9F2KI.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $7S1FP.parseFilterArgs)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $9F2KI.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $7S1FP.parseFilterArgs)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, $9F2KI.notifyManager).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $7S1FP.noop)).catch((0, $7S1FP.noop));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $7S1FP.parseFilterArgs)(arg1, arg2, arg3);
        return (0, $9F2KI.notifyManager).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $7S1FP.parseFilterArgs)(arg1, arg2, arg3);
        const promises = (0, $9F2KI.notifyManager).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $7S1FP.noop));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $7S1FP.noop));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $7S1FP.parseQueryArgs)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $7S1FP.noop)).catch((0, $7S1FP.noop));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $7S1FP.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $9re2n.infiniteQueryBehavior)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $7S1FP.noop)).catch((0, $7S1FP.noop));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $7S1FP.hashQueryKey)(queryKey) === (0, $7S1FP.hashQueryKey)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $7S1FP.partialMatchKey)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        {
            // Retrieve all matching defaults for the given key
            const matchingDefaults = this.queryDefaults.filter((x)=>(0, $7S1FP.partialMatchKey)(queryKey, x.queryKey)); // It is ok not having defaults, but it is error prone to have more than 1 default for a given key
            if (matchingDefaults.length > 1) this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(queryKey) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults.");
        }
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $7S1FP.hashQueryKey)(mutationKey) === (0, $7S1FP.hashQueryKey)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $7S1FP.partialMatchKey)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        {
            // Retrieve all matching defaults for the given key
            const matchingDefaults = this.mutationDefaults.filter((x)=>(0, $7S1FP.partialMatchKey)(mutationKey, x.mutationKey)); // It is ok not having defaults, but it is error prone to have more than 1 default for a given key
            if (matchingDefaults.length > 1) this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(mutationKey) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults.");
        }
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $7S1FP.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}

});
parcelRegister("7S1FP", function(module, exports) {

$parcel$export(module.exports, "isServer", function () { return $5baedfecd679543a$export$6acf61af03e62db; });
$parcel$export(module.exports, "noop", function () { return $5baedfecd679543a$export$8793edee2d425525; });
$parcel$export(module.exports, "functionalUpdate", function () { return $5baedfecd679543a$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "isValidTimeout", function () { return $5baedfecd679543a$export$e539f754e934e270; });
$parcel$export(module.exports, "difference", function () { return $5baedfecd679543a$export$acaf96a27438246b; });
$parcel$export(module.exports, "replaceAt", function () { return $5baedfecd679543a$export$224e3b7078227b8a; });
$parcel$export(module.exports, "timeUntilStale", function () { return $5baedfecd679543a$export$811b83d62bcf47f0; });
$parcel$export(module.exports, "parseQueryArgs", function () { return $5baedfecd679543a$export$8a11fbc2c8ea08fd; });
$parcel$export(module.exports, "parseFilterArgs", function () { return $5baedfecd679543a$export$18e8f4b987e6c111; });
$parcel$export(module.exports, "matchQuery", function () { return $5baedfecd679543a$export$c5d1efe363797780; });
$parcel$export(module.exports, "hashQueryKeyByOptions", function () { return $5baedfecd679543a$export$cc90ca97bc0d73fd; });
$parcel$export(module.exports, "partialMatchKey", function () { return $5baedfecd679543a$export$2f07189bb9fa26a7; });
$parcel$export(module.exports, "matchMutation", function () { return $5baedfecd679543a$export$a1ea5fb559f63ae3; });
$parcel$export(module.exports, "hashQueryKey", function () { return $5baedfecd679543a$export$5fcb678681417b54; });
$parcel$export(module.exports, "shallowEqualObjects", function () { return $5baedfecd679543a$export$3e67810a3f0e9f1c; });
$parcel$export(module.exports, "sleep", function () { return $5baedfecd679543a$export$e772c8ff12451969; });
$parcel$export(module.exports, "scheduleMicrotask", function () { return $5baedfecd679543a$export$4304cb76768ca134; });
$parcel$export(module.exports, "getAbortController", function () { return $5baedfecd679543a$export$382ca5d13a8f252c; });
$parcel$export(module.exports, "replaceData", function () { return $5baedfecd679543a$export$17619bac5b909b23; });
// TYPES
// UTILS
const $5baedfecd679543a$export$6acf61af03e62db = typeof window === "undefined";
function $5baedfecd679543a$export$8793edee2d425525() {
    return undefined;
}
function $5baedfecd679543a$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $5baedfecd679543a$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $5baedfecd679543a$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>array2.indexOf(x) === -1);
}
function $5baedfecd679543a$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $5baedfecd679543a$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $5baedfecd679543a$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$5baedfecd679543a$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $5baedfecd679543a$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($5baedfecd679543a$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $5baedfecd679543a$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $5baedfecd679543a$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $5baedfecd679543a$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $5baedfecd679543a$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $5baedfecd679543a$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($5baedfecd679543a$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $5baedfecd679543a$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$5baedfecd679543a$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $5baedfecd679543a$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($5baedfecd679543a$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($5baedfecd679543a$export$5fcb678681417b54(mutation.options.mutationKey) !== $5baedfecd679543a$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$5baedfecd679543a$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $5baedfecd679543a$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $5baedfecd679543a$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $5baedfecd679543a$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$5baedfecd679543a$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $5baedfecd679543a$export$2f07189bb9fa26a7(a, b) {
    return $5baedfecd679543a$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $5baedfecd679543a$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$5baedfecd679543a$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $5baedfecd679543a$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $5baedfecd679543a$export$7a8558113332b71e(a) && $5baedfecd679543a$export$7a8558113332b71e(b);
    if (array || $5baedfecd679543a$export$53b83ca8eaab0383(a) && $5baedfecd679543a$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $5baedfecd679543a$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $5baedfecd679543a$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $5baedfecd679543a$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $5baedfecd679543a$export$53b83ca8eaab0383(o) {
    if (!$5baedfecd679543a$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$5baedfecd679543a$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $5baedfecd679543a$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $5baedfecd679543a$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $5baedfecd679543a$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $5baedfecd679543a$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $5baedfecd679543a$export$4304cb76768ca134(callback) {
    $5baedfecd679543a$export$e772c8ff12451969(0).then(callback);
}
function $5baedfecd679543a$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
}
function $5baedfecd679543a$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $5baedfecd679543a$export$77a71fc411098696(prevData, data);
    return data;
}

});

parcelRegister("7LcT0", function(module, exports) {

$parcel$export(module.exports, "QueryCache", function () { return $5a66eb199d7f9769$export$5dde0cd941da8468; });

var $7S1FP = parcelRequire("7S1FP");

var $7OVce = parcelRequire("7OVce");

var $9F2KI = parcelRequire("9F2KI");

var $4L4n1 = parcelRequire("4L4n1");
// CLASS
class $5a66eb199d7f9769$export$5dde0cd941da8468 extends (0, $4L4n1.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $7S1FP.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $7OVce.Query)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $9F2KI.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $7S1FP.parseFilterArgs)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, $7S1FP.matchQuery)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $7S1FP.parseFilterArgs)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $7S1FP.matchQuery)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $9F2KI.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $9F2KI.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $9F2KI.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}

});
parcelRegister("7OVce", function(module, exports) {

$parcel$export(module.exports, "Query", function () { return $5b1991e5dc69dc21$export$62297b13309008b2; });

var $7S1FP = parcelRequire("7S1FP");

var $1VZZ0 = parcelRequire("1VZZ0");

var $9F2KI = parcelRequire("9F2KI");

var $dPHi4 = parcelRequire("dPHi4");

var $dlR4y = parcelRequire("dlR4y");
// CLASS
class $5b1991e5dc69dc21$export$62297b13309008b2 extends (0, $dlR4y.Removable) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $1VZZ0.defaultLogger);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $5b1991e5dc69dc21$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.meta = options == null ? void 0 : options.meta;
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $7S1FP.replaceData)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $7S1FP.noop)).catch((0, $7S1FP.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $7S1FP.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        if (!Array.isArray(this.options.queryKey)) this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
        const abortController = (0, $7S1FP.getAbortController)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $dPHi4.isCancelledError)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, $dPHi4.isCancelledError)(error)) {
                var _this$cache$config$on, _this$cache$config;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                this.logger.error(error);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $dPHi4.createRetryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on2, _this$cache$config2;
                if (typeof data === "undefined") {
                    onError(new Error("Query data cannot be undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSuccess) == null || _this$cache$config$on2.call(_this$cache$config2, data, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: ()=>{
                this.dispatch({
                    type: "failed"
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: state.fetchFailureCount + 1
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $dPHi4.canFetch)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $dPHi4.isCancelledError)(error) && error.revert && this.revertState) return {
                        ...this.revertState
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $9F2KI.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $5b1991e5dc69dc21$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasInitialData = typeof options.initialData !== "undefined";
    const initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    const hasData = typeof data !== "undefined";
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}

});
parcelRegister("1VZZ0", function(module, exports) {

$parcel$export(module.exports, "defaultLogger", function () { return $168b31d4ba6f4123$export$1cf3d545f2d4635c; });
const $168b31d4ba6f4123$export$1cf3d545f2d4635c = console;

});

parcelRegister("9F2KI", function(module, exports) {

$parcel$export(module.exports, "notifyManager", function () { return $708a13fdfea5cbe3$export$520687f44db6e1ab; });

var $7S1FP = parcelRequire("7S1FP");
function $708a13fdfea5cbe3$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $7S1FP.scheduleMicrotask)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $7S1FP.scheduleMicrotask)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $708a13fdfea5cbe3$export$520687f44db6e1ab = $708a13fdfea5cbe3$export$316a8efd03cd1458();

});

parcelRegister("dPHi4", function(module, exports) {

$parcel$export(module.exports, "canFetch", function () { return $a1219e6152113cc0$export$61b92f63f30245cf; });
$parcel$export(module.exports, "isCancelledError", function () { return $a1219e6152113cc0$export$986cc6445c1d323; });
$parcel$export(module.exports, "createRetryer", function () { return $a1219e6152113cc0$export$2cbd00fe8a2c8d85; });

var $ahV8W = parcelRequire("ahV8W");

var $9HeJk = parcelRequire("9HeJk");

var $7S1FP = parcelRequire("7S1FP");
function $a1219e6152113cc0$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $a1219e6152113cc0$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, $9HeJk.onlineManager).isOnline() : true;
}
class $a1219e6152113cc0$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $a1219e6152113cc0$export$986cc6445c1d323(value) {
    return value instanceof $a1219e6152113cc0$export$a8430ed4188f35a9;
}
function $a1219e6152113cc0$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $a1219e6152113cc0$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $ahV8W.focusManager).isFocused() || config.networkMode !== "always" && !(0, $9HeJk.onlineManager).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved || !shouldPause()) return continueResolve(value);
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $a1219e6152113cc0$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $7S1FP.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($a1219e6152113cc0$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}

});
parcelRegister("ahV8W", function(module, exports) {

$parcel$export(module.exports, "focusManager", function () { return $77d7d162c84e9838$export$6bf54661be5b02cf; });

var $4L4n1 = parcelRequire("4L4n1");

var $7S1FP = parcelRequire("7S1FP");
class $77d7d162c84e9838$export$86f1af424b2ca4de extends (0, $4L4n1.Subscribable) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $7S1FP.isServer) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    }
    onFocus() {
        this.listeners.forEach((listener)=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
}
const $77d7d162c84e9838$export$6bf54661be5b02cf = new $77d7d162c84e9838$export$86f1af424b2ca4de();

});
parcelRegister("4L4n1", function(module, exports) {

$parcel$export(module.exports, "Subscribable", function () { return $376ef117328cbe22$export$d26086b469ecdbcc; });
class $376ef117328cbe22$export$d26086b469ecdbcc {
    constructor(){
        this.listeners = [];
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.push(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners = this.listeners.filter((x)=>x !== listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.length > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}

});


parcelRegister("9HeJk", function(module, exports) {

$parcel$export(module.exports, "onlineManager", function () { return $70f38e52b5f423e7$export$b113e788b2dd3fdc; });

var $4L4n1 = parcelRequire("4L4n1");

var $7S1FP = parcelRequire("7S1FP");
class $70f38e52b5f423e7$export$58774fb55d5ff7fc extends (0, $4L4n1.Subscribable) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $7S1FP.isServer) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                window.addEventListener("online", listener, false);
                window.addEventListener("offline", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("online", listener);
                    window.removeEventListener("offline", listener);
                };
            }
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    }
    onOnline() {
        this.listeners.forEach((listener)=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
}
const $70f38e52b5f423e7$export$b113e788b2dd3fdc = new $70f38e52b5f423e7$export$58774fb55d5ff7fc();

});


parcelRegister("dlR4y", function(module, exports) {

$parcel$export(module.exports, "Removable", function () { return $9b86679c569746ca$export$e09608847fcc8c59; });

var $7S1FP = parcelRequire("7S1FP");
class $9b86679c569746ca$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $7S1FP.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $7S1FP.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}

});



parcelRegister("9WLMV", function(module, exports) {

$parcel$export(module.exports, "MutationCache", function () { return $73de9989db8bb85d$export$1fcfd9a244434844; });

var $9F2KI = parcelRequire("9F2KI");

var $2GBKa = parcelRequire("2GBKa");

var $7S1FP = parcelRequire("7S1FP");

var $4L4n1 = parcelRequire("4L4n1");
// CLASS
class $73de9989db8bb85d$export$1fcfd9a244434844 extends (0, $4L4n1.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, $2GBKa.Mutation)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $9F2KI.notifyManager).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, $7S1FP.matchMutation)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $7S1FP.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $9F2KI.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
        return (0, $9F2KI.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $7S1FP.noop))), Promise.resolve()));
    }
}

});
parcelRegister("2GBKa", function(module, exports) {

$parcel$export(module.exports, "Mutation", function () { return $1f4cc820759443ff$export$17b8b19c814bcf56; });

var $1VZZ0 = parcelRequire("1VZZ0");

var $9F2KI = parcelRequire("9F2KI");

var $dlR4y = parcelRequire("dlR4y");

var $dPHi4 = parcelRequire("dPHi4");
// CLASS
class $1f4cc820759443ff$export$17b8b19c814bcf56 extends (0, $dlR4y.Removable) {
    constructor(config){
        super();
        this.options = {
            ...config.defaultOptions,
            ...config.options
        };
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $1VZZ0.defaultLogger);
        this.observers = [];
        this.state = config.state || $1f4cc820759443ff$export$a1659b54bac3252a();
        this.meta = config.meta;
        this.updateCacheTime(this.options.cacheTime);
        this.scheduleGc();
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    }
    addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $dPHi4.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: ()=>{
                    this.dispatch({
                        type: "failed"
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                (_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null || _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this);
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            (_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null || _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this);
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onError, _this$options4, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                (_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onError) == null || _this$mutationCache$c5.call(_this$mutationCache$c6, error, this.state.variables, this.state.context, this);
                this.logger.error(error);
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: state.failureCount + 1
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        error: null,
                        isPaused: !(0, $dPHi4.canFetch)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $9F2KI.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $1f4cc820759443ff$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}

});


parcelRegister("9re2n", function(module, exports) {

$parcel$export(module.exports, "infiniteQueryBehavior", function () { return $01c5f5c70086ac87$export$84470d1367601e8d; });
function $01c5f5c70086ac87$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $01c5f5c70086ac87$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $01c5f5c70086ac87$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $01c5f5c70086ac87$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $01c5f5c70086ac87$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $01c5f5c70086ac87$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $01c5f5c70086ac87$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $01c5f5c70086ac87$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $01c5f5c70086ac87$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $01c5f5c70086ac87$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
}

});


parcelRegister("hqNkG", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", function () { return $cb0b21cc8547b017$export$22e77b9572c4fded; });
$parcel$export(module.exports, "QueryClientProvider", function () { return $cb0b21cc8547b017$export$45604f0cc8ae667b; });

var $3RyIS = parcelRequire("3RyIS");
const $cb0b21cc8547b017$export$2fba198b5b2e37fa = /*#__PURE__*/ $3RyIS.createContext(undefined);
const $cb0b21cc8547b017$var$QueryClientSharingContext = /*#__PURE__*/ $3RyIS.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $cb0b21cc8547b017$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $cb0b21cc8547b017$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $cb0b21cc8547b017$export$2fba198b5b2e37fa;
}
const $cb0b21cc8547b017$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $3RyIS.useContext($cb0b21cc8547b017$var$getQueryClientContext(context, $3RyIS.useContext($cb0b21cc8547b017$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const $cb0b21cc8547b017$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $3RyIS.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $cb0b21cc8547b017$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $3RyIS.createElement($cb0b21cc8547b017$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $3RyIS.createElement(Context.Provider, {
        value: client
    }, children));
};

});

parcelRegister("fNzfd", function(module, exports) {

$parcel$export(module.exports, "ReactQueryDevtools", function () { return $b806c56da7959faa$export$fd1469cb3147d866; });

const $b806c56da7959faa$export$fd1469cb3147d866 = function() {
    return null;
};
const $b806c56da7959faa$export$6d64409a8b475869 = function() {
    return null;
};

});



var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");
var $80b93b58b431c144$export$882461b6382ed46c;
var $80b93b58b431c144$export$757ceba2d55c277e;
"use strict";

var $3qHRY = parcelRequire("3qHRY");
var $80b93b58b431c144$var$i = $3qHRY.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$80b93b58b431c144$export$882461b6382ed46c = function(c, o) {
    $80b93b58b431c144$var$i.usingClientEntryPoint = true;
    try {
        return $3qHRY.createRoot(c, o);
    } finally{
        $80b93b58b431c144$var$i.usingClientEntryPoint = false;
    }
};
$80b93b58b431c144$export$757ceba2d55c277e = function(c, h, o) {
    $80b93b58b431c144$var$i.usingClientEntryPoint = true;
    try {
        return $3qHRY.hydrateRoot(c, h, o);
    } finally{
        $80b93b58b431c144$var$i.usingClientEntryPoint = false;
    }
};



var $ifjYT = parcelRequire("ifjYT");

var $idnjL = parcelRequire("idnjL");
var $6IPSj = parcelRequire("6IPSj");
var $6IPSj = parcelRequire("6IPSj");



var $l7Vlc = parcelRequire("l7Vlc");

var $gcFVa = parcelRequire("gcFVa");

var $21sFD = parcelRequire("21sFD");
parcelRequire("3RyIS");

var $6IPSj = parcelRequire("6IPSj");

var $bvGDc = parcelRequire("bvGDc");
function $c0356b0faf7879aa$var$DiscoveryRedirect() {
    const { discoveryId: discoveryId } = (0, $6IPSj.useParams)();
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Navigate), {
        replace: true,
        to: `${(0, $bvGDc.STORIES_PATH)}/${discoveryId}`
    });
}
function $c0356b0faf7879aa$var$ThematicDatasetRedirect({ explore: explore = false }) {
    const { datasetId: datasetId } = (0, $6IPSj.useParams)();
    let url = `/data-catalog/${datasetId}`;
    if (explore) url += "/explore";
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Navigate), {
        replace: true,
        to: url
    });
}
const $c0356b0faf7879aa$export$522a10032a0e989e = /*#__PURE__*/ (0, $21sFD.jsxs)((0, $6IPSj.Route), {
    path: ":thematicId",
    children: [
        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
            index: true,
            element: /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Navigate), {
                replace: true,
                to: "/data-catalog"
            })
        }),
        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
            path: "discoveries",
            element: /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Navigate), {
                replace: true,
                to: (0, $bvGDc.STORIES_PATH)
            })
        }),
        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
            path: "discoveries/:discoveryId",
            element: /*#__PURE__*/ (0, $21sFD.jsx)($c0356b0faf7879aa$var$DiscoveryRedirect, {})
        }),
        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
            path: "datasets",
            element: /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Navigate), {
                replace: true,
                to: "/data-catalog"
            })
        }),
        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
            path: "datasets/:datasetId",
            element: /*#__PURE__*/ (0, $21sFD.jsx)($c0356b0faf7879aa$var$ThematicDatasetRedirect, {})
        }),
        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
            path: "datasets/:datasetId/explore",
            element: /*#__PURE__*/ (0, $21sFD.jsx)($c0356b0faf7879aa$var$ThematicDatasetRedirect, {
                explore: true
            })
        }),
        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
            path: "analysis",
            element: /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Navigate), {
                replace: true,
                to: "/analysis"
            })
        }),
        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
            path: "analysis/results",
            element: /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Navigate), {
                replace: true,
                to: "/analysis/results"
            })
        }),
        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
            path: "*",
            element: /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Navigate), {
                replace: true,
                to: "/"
            })
        })
    ]
});
const $c0356b0faf7879aa$export$6982b16efdf19591 = /*#__PURE__*/ (0, $21sFD.jsxs)((0, $6IPSj.Route), {
    path: "/",
    children: [
        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
            path: "discoveries",
            element: /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Navigate), {
                replace: true,
                to: (0, $bvGDc.STORIES_PATH)
            })
        }),
        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
            path: "discoveries/:discoveryId",
            element: /*#__PURE__*/ (0, $21sFD.jsx)($c0356b0faf7879aa$var$DiscoveryRedirect, {})
        })
    ]
});



var $atWKR = parcelRequire("atWKR");

var $5lvjo = parcelRequire("5lvjo");

var $l7Vlc = parcelRequire("l7Vlc");
const $35239b72fdfb52c3$export$b368ceb201e689ad = {
    zIndices: {
        hide: -1,
        docked: 10,
        sticky: 900,
        dropdown: 1550,
        overlay: 1300,
        modal: 1400,
        popover: 1500,
        skipLink: 1600,
        toast: 1700,
        tooltip: 1800
    },
    color: {
        base: "#2c3e50",
        primary: "#2276ac",
        danger: "#FC3D21",
        infographicA: "#83868A",
        infographicB: "#6138BE",
        infographicC: "#83868A",
        infographicD: "#F2F2F2",
        infographicE: "#3094E3",
        infographicF: "#1D5C5D" // Sum
    },
    type: {
        base: {
            family: '"Public Sans",sans-serif',
            leadSize: "1.25rem",
            extrabold: "800",
            line: "inherit",
            // Increments to the type.base.size for each media breakpoint.
            sizeIncrement: {
                small: "0rem",
                medium: "0rem",
                large: "0.25rem",
                xlarge: "0.25rem"
            }
        },
        heading: {
            settings: '"wdth" 100, "wght" 700'
        }
    },
    layout: {
        min: "384px",
        max: "1440px",
        glspMultiplier: {
            xsmall: 1,
            small: 1,
            medium: 1.5,
            large: 2,
            xlarge: 2
        }
    }
};
function $35239b72fdfb52c3$export$2e2bcd8739ae039() {
    if (0, $l7Vlc.theme) return (0, $atWKR.createUITheme)((0, $5lvjo.defaultsDeep)({}, (0, $l7Vlc.theme), $35239b72fdfb52c3$export$b368ceb201e689ad));
    else return (0, $atWKR.createUITheme)($35239b72fdfb52c3$export$b368ceb201e689ad);
}



var $hAJzY = parcelRequire("hAJzY");
const $b9b810fe5342768a$var$publicUrl = undefined ?? "";
const $b9b810fe5342768a$export$3055426b36032d00 = ()=>{
    const { protocol: protocol, host: host } = window.location;
    const baseUrl = $b9b810fe5342768a$var$publicUrl.match(/https?:\/\//) ? $b9b810fe5342768a$var$publicUrl : `${protocol}//${host}/${$b9b810fe5342768a$var$publicUrl}`;
    // Remove trailing url if exists.
    const url = new URL(baseUrl.replace(/\/$/, ""));
    return url;
};
const $b9b810fe5342768a$export$7bef2761b33c0ea = (resource = "")=>`${$b9b810fe5342768a$export$3055426b36032d00().href.replace(/\/$/, "")}${resource}`;



var $hNqhF = parcelRequire("hNqhF");

var $iCOkj = parcelRequire("iCOkj");

var $1VhEK = parcelRequire("1VhEK");

var $2NGmK = parcelRequire("2NGmK");

var $dC4My = parcelRequire("dC4My");

var $21sFD = parcelRequire("21sFD");

var $3RyIS = parcelRequire("3RyIS");

var $ifjYT = parcelRequire("ifjYT");
parcelRequire("idnjL");
var $6IPSj = parcelRequire("6IPSj");
var $4bbcd2a557e69b8c$exports = {};
"use strict";

var $21sFD = parcelRequire("21sFD");
var $4bbcd2a557e69b8c$var$_jsx = $21sFD.jsx;
var $4bbcd2a557e69b8c$var$newlineRegex = /(\r\n|\r|\n)/g;
$4bbcd2a557e69b8c$exports = function(str) {
    if (typeof str !== "string") return str;
    return str.split($4bbcd2a557e69b8c$var$newlineRegex).map(function(line, index) {
        if (line.match($4bbcd2a557e69b8c$var$newlineRegex)) return $4bbcd2a557e69b8c$var$_jsx("br", {
            key: index
        });
        return line;
    });
};



var $2JIVh = parcelRequire("2JIVh");

var $dC4My = parcelRequire("dC4My");

var $hNqhF = parcelRequire("hNqhF");

var $iCOkj = parcelRequire("iCOkj");

var $l5jsC = parcelRequire("l5jsC");

var $fohMe = parcelRequire("fohMe");

var $dm1LE = parcelRequire("dm1LE");


var $4FYyx = parcelRequire("4FYyx");

var $925SL = parcelRequire("925SL");
class $6465cc921f73c6c7$export$2e2bcd8739ae039 extends (0, $3RyIS.Component) {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
        this.clearError = this.clearError.bind(this);
    }
    clearError() {
        this.setState({
            error: null
        });
    }
    render() {
        return /*#__PURE__*/ (0, $21sFD.jsx)($6465cc921f73c6c7$var$Child, {
            error: this.state.error,
            clearError: this.clearError,
            ...this.props
        });
    }
}
// Child component only needed to use hooks.
function $6465cc921f73c6c7$var$Child(props) {
    const { children: children, error: error, clearError: clearError } = props;
    const { pathname: pathname } = (0, $6IPSj.useLocation)();
    // If the pathname changed (because the user navigated) clear the error so the
    // page renders again.
    (0, $4FYyx.useEffectPrevious)((_, mounted)=>{
        if (mounted) clearError();
    }, [
        pathname
    ]);
    // eslint-disable-next-line react/prop-types
    if (!error) return children;
    // Note (this is a chicken and egg problem)
    // The error boundary wraps all the contexts (via Composer in main.js) to be
    // able to capture errors that happen in them. When an error occurs those
    // contexts are not rendered and so here we have to add the contexts needed by
    // the elements.
    if (error.resNotFound) return /*#__PURE__*/ (0, $21sFD.jsx)((0, $iCOkj.LayoutRootContextProvider), {
        children: /*#__PURE__*/ (0, $21sFD.jsx)((0, $hNqhF.default), {
            children: /*#__PURE__*/ (0, $21sFD.jsx)((0, $dC4My.default), {})
        })
    });
    return /*#__PURE__*/ (0, $21sFD.jsx)((0, $iCOkj.LayoutRootContextProvider), {
        children: /*#__PURE__*/ (0, $21sFD.jsxs)((0, $hNqhF.default), {
            children: [
                /*#__PURE__*/ (0, $21sFD.jsx)((0, $hNqhF.LayoutProps), {
                    title: "Something went wrong"
                }),
                /*#__PURE__*/ (0, $21sFD.jsxs)((0, $dm1LE.PageMainContent), {
                    children: [
                        /*#__PURE__*/ (0, $21sFD.jsx)((0, $l5jsC.default), {
                            title: "Something went wrong",
                            description: `We couldn't to load your content.`
                        }),
                        /*#__PURE__*/ (0, $21sFD.jsxs)((0, $fohMe.FoldProse), {
                            children: [
                                /*#__PURE__*/ (0, $21sFD.jsxs)("p", {
                                    children: [
                                        "This is on our side and we will fix it! In the meantime you can try again by refreshing the page or visit the",
                                        " ",
                                        /*#__PURE__*/ (0, $21sFD.jsx)("a", {
                                            href: (0, $b9b810fe5342768a$export$7bef2761b33c0ea)("/"),
                                            title: "Visit homepage",
                                            children: "homepage"
                                        }),
                                        "."
                                    ]
                                }),
                                error instanceof (0, $925SL.HintedError) ? /*#__PURE__*/ (0, $21sFD.jsx)((0, $925SL.HintedErrorDisplay), {
                                    title: "Error details",
                                    message: error.message,
                                    hints: error.hints
                                }) : /*#__PURE__*/ (0, $21sFD.jsxs)("details", {
                                    children: [
                                        /*#__PURE__*/ (0, $21sFD.jsx)("summary", {
                                            children: "Error details"
                                        }),
                                        /*#__PURE__*/ (0, $21sFD.jsx)("strong", {
                                            children: error.message
                                        }),
                                        /*#__PURE__*/ (0, $21sFD.jsx)("p", {
                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($4bbcd2a557e69b8c$exports)))(error.stack)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $21sFD.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $21sFD.jsx)("strong", {
                                        children: /*#__PURE__*/ (0, $21sFD.jsxs)("a", {
                                            href: (0, $b9b810fe5342768a$export$7bef2761b33c0ea)("/"),
                                            title: "Go back to homepage",
                                            children: [
                                                /*#__PURE__*/ (0, $21sFD.jsx)((0, $2JIVh.Icon).ArrowForward, {}),
                                                /*#__PURE__*/ (0, $21sFD.jsx)("span", {
                                                    children: "\xa0Go back to homepage"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
$6465cc921f73c6c7$var$Child.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).node,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).object,
    clearError: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).func
};


// Extend Array interface to include the last property



var $7R3KQ = parcelRequire("7R3KQ");

var $bvGDc = parcelRequire("bvGDc");

var $6SviU = parcelRequire("6SviU");


const $8fee5636e280e00f$var$Home = /*#__PURE__*/ (0, $3RyIS.lazy)(()=>(parcelRequire("8aa28")));

const $8fee5636e280e00f$var$About = /*#__PURE__*/ (0, $3RyIS.lazy)(()=>(parcelRequire("hn4w8")));

const $8fee5636e280e00f$var$Development = /*#__PURE__*/ (0, $3RyIS.lazy)(()=>(parcelRequire("7yOpZ")));

const $8fee5636e280e00f$var$StoriesHub = /*#__PURE__*/ (0, $3RyIS.lazy)(()=>(parcelRequire("3YwAc")));

const $8fee5636e280e00f$var$StoriesSingle = /*#__PURE__*/ (0, $3RyIS.lazy)(()=>(parcelRequire("3fFSB")));

const $8fee5636e280e00f$var$DataCatalog = /*#__PURE__*/ (0, $3RyIS.lazy)(()=>(parcelRequire("17f0k")));

const $8fee5636e280e00f$var$DatasetsOverview = /*#__PURE__*/ (0, $3RyIS.lazy)(()=>(parcelRequire("d5V9Q")));

const $8fee5636e280e00f$var$ExplorationAndAnalysis = /*#__PURE__*/ (0, $3RyIS.lazy)(()=>(parcelRequire("3FXAc")));

const $8fee5636e280e00f$var$Sandbox = /*#__PURE__*/ (0, $3RyIS.lazy)(()=>(parcelRequire("3G8v0")));

const $8fee5636e280e00f$var$UserPagesComponent = /*#__PURE__*/ (0, $3RyIS.lazy)(()=>(parcelRequire("g1Y4y")));
const $8fee5636e280e00f$var$composingComponents = [
    // Add contexts here.
    (0, $6465cc921f73c6c7$export$2e2bcd8739ae039),
    (0, $7R3KQ.default),
    (0, $iCOkj.LayoutRootContextProvider),
    ({ children: children })=>/*#__PURE__*/ (0, $21sFD.jsx)((0, $6SviU.VedaUIProvider), {
            config: {
                envMapboxToken: "pk.eyJ1IjoiY292aWQtbmFzYSIsImEiOiJjbDR6emc1cmMwNGJ5M2pvdnRoc2JiaTl1In0.IPkoabxAsf4ygRUD0EzFig" ?? "",
                envApiStacEndpoint: "https://earth.gov/ghgcenter/api/stac" ?? "",
                envApiRasterEndpoint: "https://earth.gov/ghgcenter/api/raster" ?? "",
                envApiCMREndpoint: undefined ?? "",
                envUrlShortenerEndpoint: undefined ?? "",
                geoDataPath: `${undefined ?? ""}/public/geo-data`,
                navigation: {
                    LinkComponent: (0, $idnjL.Link),
                    linkProps: {
                        pathAttributeKeyName: "to"
                    }
                }
            },
            children: children
        })
];
function $8fee5636e280e00f$var$ScrollTop() {
    const { pathname: pathname } = (0, $6IPSj.useLocation)();
    (0, $3RyIS.useEffect)(()=>{
        window.scrollTo({
            top: 0
        });
    }, [
        pathname
    ]);
    return null;
}
// Root component.
function $8fee5636e280e00f$var$Root() {
    (0, $1VhEK.useScrollbarWidthAsCssVar)();
    (0, $3RyIS.useEffect)(()=>{
        // Hide the welcome banner.
        const banner = document.querySelector("#welcome-banner");
        banner?.classList.add("dismissed");
        setTimeout(()=>banner?.remove(), 500);
    }, []);
    return /*#__PURE__*/ (0, $21sFD.jsxs)((0, $idnjL.BrowserRouter), {
        basename: (0, $b9b810fe5342768a$export$3055426b36032d00)().pathname,
        children: [
            /*#__PURE__*/ (0, $21sFD.jsx)($8fee5636e280e00f$var$ScrollTop, {}),
            /*#__PURE__*/ (0, $21sFD.jsxs)((0, $gcFVa.default), {
                theme: (0, $35239b72fdfb52c3$export$2e2bcd8739ae039),
                children: [
                    /*#__PURE__*/ (0, $21sFD.jsx)((0, $hAJzY.GlobalStyles), {}),
                    /*#__PURE__*/ (0, $21sFD.jsx)($8fee5636e280e00f$var$Composer, {
                        components: $8fee5636e280e00f$var$composingComponents,
                        children: /*#__PURE__*/ (0, $21sFD.jsx)((0, $3RyIS.Suspense), {
                            fallback: /*#__PURE__*/ (0, $21sFD.jsx)((0, $2NGmK.PageLoading), {}),
                            children: /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Routes), {
                                children: /*#__PURE__*/ (0, $21sFD.jsxs)((0, $6IPSj.Route), {
                                    path: "/",
                                    element: /*#__PURE__*/ (0, $21sFD.jsx)((0, $hNqhF.default), {}),
                                    children: [
                                        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
                                            index: true,
                                            element: /*#__PURE__*/ (0, $21sFD.jsx)($8fee5636e280e00f$var$Home, {})
                                        }),
                                        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
                                            path: (0, $bvGDc.ABOUT_PATH),
                                            element: /*#__PURE__*/ (0, $21sFD.jsx)($8fee5636e280e00f$var$About, {})
                                        }),
                                        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
                                            path: (0, $bvGDc.DATASETS_PATH),
                                            element: /*#__PURE__*/ (0, $21sFD.jsx)($8fee5636e280e00f$var$DataCatalog, {})
                                        }),
                                        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
                                            path: `${(0, $bvGDc.DATASETS_PATH)}/:datasetId`,
                                            element: /*#__PURE__*/ (0, $21sFD.jsx)($8fee5636e280e00f$var$DatasetsOverview, {})
                                        }),
                                        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
                                            path: (0, $bvGDc.STORIES_PATH),
                                            element: /*#__PURE__*/ (0, $21sFD.jsx)($8fee5636e280e00f$var$StoriesHub, {})
                                        }),
                                        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
                                            path: `${(0, $bvGDc.STORIES_PATH)}/:storyId`,
                                            element: /*#__PURE__*/ (0, $21sFD.jsx)($8fee5636e280e00f$var$StoriesSingle, {})
                                        }),
                                        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
                                            path: "development",
                                            element: /*#__PURE__*/ (0, $21sFD.jsx)($8fee5636e280e00f$var$Development, {})
                                        }),
                                        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
                                            path: (0, $bvGDc.EXPLORATION_PATH),
                                            element: /*#__PURE__*/ (0, $21sFD.jsx)($8fee5636e280e00f$var$ExplorationAndAnalysis, {})
                                        }),
                                        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
                                            path: "/sandbox/*",
                                            element: /*#__PURE__*/ (0, $21sFD.jsx)($8fee5636e280e00f$var$Sandbox, {})
                                        }),
                                        (0, $c0356b0faf7879aa$export$6982b16efdf19591),
                                        (0, $l7Vlc.userPages).map((p)=>/*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
                                                path: p,
                                                element: /*#__PURE__*/ (0, $21sFD.jsx)($8fee5636e280e00f$var$UserPagesComponent, {
                                                    id: p
                                                })
                                            }, p)),
                                        /*#__PURE__*/ (0, $21sFD.jsx)((0, $6IPSj.Route), {
                                            path: "*",
                                            element: /*#__PURE__*/ (0, $21sFD.jsx)((0, $dC4My.default), {})
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}
const $8fee5636e280e00f$var$container = document.getElementById("app-container");
const $8fee5636e280e00f$var$root = (0, $80b93b58b431c144$export$882461b6382ed46c)($8fee5636e280e00f$var$container); // createRoot(container!) if you use TypeScript
$8fee5636e280e00f$var$root.render(/*#__PURE__*/ (0, $21sFD.jsx)($8fee5636e280e00f$var$Root, {}));
/**
 * Composes components to to avoid deep nesting trees. Useful for contexts.
 *
 * @param {node} children Component children
 * @param {array} components The components to compose.
 */ function $8fee5636e280e00f$var$Composer(props) {
    const { children: children, components: components } = props;
    /* eslint-disable-next-line fp/no-mutating-methods */ const itemToCompose = [
        ...components
    ].reverse();
    return itemToCompose.reduce((acc, Component)=>/*#__PURE__*/ (0, $21sFD.jsx)(Component, {
            children: acc
        }), children);
}
$8fee5636e280e00f$var$Composer.propTypes = {
    components: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).array,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ifjYT))).node
};
// Adding .last property to array
/* eslint-disable-next-line fp/no-mutating-methods */ Object.defineProperty(Array.prototype, "last", {
    enumerable: false,
    configurable: true,
    get: function() {
        return this[this.length - 1];
    },
    set: undefined
});


//# sourceMappingURL=index.7bd6d27c.js.map
